export const config = [
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'address',
        name: 'full_address',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'date',
        unit: '',
        location: 'valuation',
        name: 'date',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'date',
        unit: '',
        location: 'assessment',
        name: 'date',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'assessment',
        name: 'type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'valuation',
        name: 'type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['avm', 'dvm', 'ovm'],
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'request',
        name: 'references',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'request',
        name: 'valuation_request_ref',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'request',
        name: 'customer_ref',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'reconstruction_value',
        search_dict_name: '',
        icon: 'ic-reconstruction',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'address_location',
        search_dict_name: '',
        icon: 'ic-location',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'secondary_buildings',
        search_dict_name: '',
        icon: 'ic-cube',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'economic_activity',
        search_dict_name: '',
        icon: 'ic-economic',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'roof',
        search_dict_name: '',
        icon: 'ic-roof',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'transaction',
        search_dict_name: '',
        icon: 'ic-economic',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'general',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'report',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'application',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'dashboard',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'dispatcher',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'user-admin',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'apps',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'results',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'flood_regular',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'flood_insurance_exclusion',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'helpcenter',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'faq-search-results',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'warnings',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'request',
        name: 'bank',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'valuation',
        name: 'valuer',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'valuation',
        name: 'monitor',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'request',
        name: 'customer',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'request',
        name: 'purpose',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['new_loan', 'revaluation'],
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'request',
        name: 'package',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['classic', 'renovation_light', 'renovation_full', 'new_construction'],
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'renovation',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'features',
        name: 'renovation_cost',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general_info'],
    },
    {
        modules: [],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'features',
        name: 'energetic_renovation_cost',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general_info'],
    },
    {
        modules: [],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'features',
        name: 'energetic_renovation_added_value',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'features',
        name: 'construction_cost',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general_info'],
    },
    {
        modules: [],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'features',
        name: 'parcel_cost',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general_info'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'general_info',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'building_class',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['new_building', 'existing_building'],
        sections: [],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_building_type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['house', 'apartment', 'new_house', 'new_apartment', 'construction_plot'],
        sections: ['general_info', 'building', 'c_building'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_touching_sides',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['attached', 'detached', 'town_house', 'condominium'],
        sections: [],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_number_of_facades',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['attached', 'semi', 'detached'],
        sections: ['general_info', 'c_building'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_number_of_facades_or_type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'new_house', 'construction_plot'],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'features',
        name: 'f_parcel_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['parcels_and_buildings', 'parcels', 'c_parcels'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'parcels_and_buildings',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'c_parcels',
        search_dict_name: '',
        icon: 'ic-environment',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'c_building',
        search_dict_name: '',
        icon: 'ic-building',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'features',
        name: 'f_building_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['parcels_and_buildings', 'c_building'],
    },
    {
        modules: [],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'features',
        name: 'f_others',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_x_annexes',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['parcels_and_buildings', 'parcels', 'secondary_buildings'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'features',
        name: 'f_annexes_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['parcels_and_buildings', 'parcels', 'secondary_buildings'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'features',
        name: 'f_area_largest_annex',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['secondary_buildings'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'array_of_float',
        unit: 'm',
        location: 'features',
        name: 'distances_annexes',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['secondary_buildings'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'new_house', 'new_apartment', 'construction_plot'],
        functionality: 'feature',
        type: 'custom_parcel',
        unit: '',
        location: 'features',
        name: 'parcel_ids',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['parcels_and_buildings'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'float',
        unit: 'degree',
        location: 'features',
        name: 'f_lng',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['address_location'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'float',
        unit: 'degree',
        location: 'features',
        name: 'f_lat',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['address_location'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_number_of_addresses',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['address_location'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'building',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core', 'dvm', 'ovm', 'ers'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'features',
        name: 'f_living_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building', 'c_building', 'house_info'],
    },
    {
        modules: ['core'],
        building_type_scope: ['apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'features',
        name: 'f_approx_living_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['c_building'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'n_rooms',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['c_building'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'approx_n_rooms',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['c_building'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'features',
        name: 'transaction_value',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['transaction'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'date',
        unit: '',
        location: 'features',
        name: 'transaction_date',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['transaction'],
    },
    {
        modules: ['core'],
        building_type_scope: ['apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro/m2',
        location: 'features',
        name: 'approx_price_sqm',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['transaction'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'float',
        unit: 'kgco2/m2year',
        location: 'features',
        name: 'co2_sqm',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['energy'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'features',
        name: 'co2_label',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['energy'],
    },
    {
        modules: ['core'],
        building_type_scope: ['apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'kwh/m2year',
        location: 'features',
        name: 'f_approx_epc',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['energy'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'style_of_house',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['traditional', 'modern', 'contemporary', 'mediterranean', 'other'],
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm', 'ers'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_construction_year',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building', 'c_building', 'house_info'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'numeric',
        unit: 'kwh/m2year',
        location: 'features',
        name: 'f_epc',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['energy'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'features',
        name: 'f_epc_label',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['A++', 'A+', 'A', 'B', 'C', 'D', 'E', 'F', 'G'],
        sections: ['energy', 'house_info'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'numeric',
        unit: 'kwh/m2year',
        location: 'features',
        name: 'f_epc_numeric',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_bedrooms',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_floor',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['ground_floor', '1', '2', '3', '4', '>4'],
        sections: ['building'],
    },
    {
        modules: [],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_bottom_floor',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: [],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_top_floor',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'array_of_int',
        unit: '',
        location: 'features',
        name: 'f_floors',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'f_balcony_present',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'f_garage_present',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_n_closed_garage',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'new_house', 'apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'custom_garage',
        unit: '',
        location: 'ovm_features',
        name: 'garages',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['parcels'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'new_house', 'apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'custom_garage',
        unit: '',
        location: 'ovm_features',
        name: 'parkings',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['parcels'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'new_house'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'secondary_buildings2',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'new_house'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'ovm_features',
        name: 'pool_house',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['secondary_buildings2'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'new_house'],
        functionality: 'feature',
        type: 'int',
        unit: 'm2',
        location: 'ovm_features',
        name: 'pool_house_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['secondary_buildings2'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'new_house'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'ovm_features',
        name: 'barn',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['secondary_buildings2'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'new_house'],
        functionality: 'feature',
        type: 'int',
        unit: 'm2',
        location: 'ovm_features',
        name: 'barn_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['secondary_buildings2'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'new_house'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'ovm_features',
        name: 'stables',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['secondary_buildings2'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'new_house'],
        functionality: 'feature',
        type: 'int',
        unit: 'm2',
        location: 'ovm_features',
        name: 'stables_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['secondary_buildings2'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_n_parking_spot',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'f_cellar_attic',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_garden_access',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['none', '\nprivate', 'common', 'private+common'],
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'f_garden_common',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'f_garden_private',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'building_structure',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm3',
        location: 'features',
        name: 'f_volume',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure', 'c_building'],
    },
    {
        modules: [],
        building_type_scope: ['house'],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'features',
        name: 'exterior_wall_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['c_building'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'common_parts',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'ovm_features',
        name: 'common_parts_state',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['maintenance_required', 'good', 'very_good'],
        sections: ['common_parts'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['house', 'new_house', 'apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'ovm_features',
        name: 'interior_state',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['maintenance_required', 'good', 'very_good'],
        sections: ['interior'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'int',
        unit: 'percent',
        location: 'ovm_features',
        name: 'apartment_quotity',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['common_parts'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'ovm_features',
        name: 'reserve_savings',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['common_parts'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'exterior_state',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['maintenance_required', 'good', 'very_good'],
        sections: ['building_structure'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'multi_enum_open',
        unit: '',
        location: 'ovm_features',
        name: 'comfort',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'security',
            'water_softener',
            'air_con',
            'elevator',
            'domotics',
            'storage',
            'rain_water',
            'hot_tub',
        ],
        sections: ['interior'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'multi_enum_open',
        unit: '',
        location: 'ovm_features',
        name: 'common_comfort',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'security',
            'water_softener',
            'air_con',
            'elevator',
            'domotics',
            'storage',
            'rain_water',
            'hot_tub',
        ],
        sections: ['interior'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'multi_enum_open',
        unit: '',
        location: 'ovm_features',
        name: 'interior_positive',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['interior'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'multi_enum_open',
        unit: '',
        location: 'ovm_features',
        name: 'interior_negative',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['interior'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'multi_enum_open',
        unit: '',
        location: 'dvm_features',
        name: 'facade_material',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'cinder_blocks',
            'wood',
            'plaster',
            'natural_stone',
            'metal',
            'concrete',
            'brick',
        ],
        sections: ['building_structure'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'features',
        name: 'f_roof_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure', 'roof'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'degree',
        location: 'features',
        name: 'f_mean_tilt',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure', 'roof'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'percent',
        location: 'features',
        name: 'f_percent_of_roof_flat',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure', 'roof'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm',
        location: 'features',
        name: 'f_min_height',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure', 'roof'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm',
        location: 'features',
        name: 'f_max_height',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure', 'roof'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_n_parts',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure', 'c_building'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_n_roof_panes',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure', 'roof'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'multi_enum_open',
        unit: '',
        location: 'dvm_features',
        name: 'roof_material',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'tiles',
            'bitumen_roofing',
            'metal',
            'slate_shingles',
            'black_concrete_tiles',
            'thatched',
            'asbestos',
            'green_roof',
        ],
        sections: ['building_structure'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'dvm_features',
        name: 'n_roof_windows',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'dvm_features',
        name: 'n_roof_dormers',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure'],
    },
    {
        modules: ['AVM'],
        building_type_scope: ['House & Apartment'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'dvm_features',
        name: 'solar_panel',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'dvm_features',
        name: 'solar_panel_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_structure'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'building_purpose_classification',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'dvm_features',
        name: 'f_building_listed',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['building_purpose_classification'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'int',
        unit: '',
        location: 'features',
        name: 'f_x_matched_entities',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['economic_activity'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'c_economic_activity_class',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'home_liberal_profession_or_office',
            'home_other_professional_activity',
            'home',
        ],
        sections: ['economic_activity'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'c_economic_activity_level',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'no_economic_activity',
            'activity_unlikely',
            'activity_possible',
            'activity_likely',
            'activity_very_likely',
        ],
        sections: ['economic_activity'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'parcels',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'features',
        name: 'f_garden_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['parcels', 'c_parcels'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'garden_orientation',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw'],
        sections: ['parcels'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'garden_arrangement',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['limited', 'good', 'very_good'],
        sections: ['parcels'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['apartment', 'new_apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'garden_common_arrangement',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['limited', 'good', 'very_good'],
        sections: ['parcels'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'dvm_features',
        name: 'f_swimming_pool',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['parcels', 'c_parcels'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'dvm_features',
        name: 'f_swimming_pool_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['parcels', 'c_parcels'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'fixed',
        unit: '',
        location: 'fixed',
        name: 'parcels_and_building_shapes',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['details_previous_page'],
        sections: ['parcels'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['new_house', 'new_apartment', 'construction_plot'],
        functionality: 'feature',
        type: 'fixed',
        unit: '',
        location: 'fixed',
        name: 'parcels_shapes',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['details_previous_page'],
        sections: ['parcels'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'surroundings',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'mobility',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'interior',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'environment',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['below_average', 'average', 'above_average'],
        sections: ['surroundings'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'public_transport',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['below_average', 'average', 'above_average'],
        sections: ['mobility'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'education',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['below_average', 'average', 'above_average'],
        sections: ['mobility'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'recreation',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['below_average', 'average', 'above_average'],
        sections: ['mobility'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'shops',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['below_average', 'average', 'above_average'],
        sections: ['mobility'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'healthcare',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['below_average', 'average', 'above_average'],
        sections: ['mobility'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'float',
        unit: 'm',
        location: '',
        name: 'f_distance_to_street',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['surroundings'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'direct_traffic_level',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['low', 'medium', 'high'],
        sections: ['surroundings'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'indirect_traffic_level',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['low', 'medium', 'high'],
        sections: ['surroundings'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_flood_risk',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['high', 'medium', 'low', 'unknown', 'none'],
        sections: ['surroundings', 'flood', 'flood_simple', 'flood_regular'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm',
        location: 'features',
        name: 'f_dist_building_flood',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['surroundings', 'flood', 'flood_simple', 'flood_regular'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_parcel_flood_risk',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['high', 'medium', 'low', 'unknown', 'none'],
        sections: ['surroundings', 'flood', 'flood_simple', 'flood_regular'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm',
        location: 'features',
        name: 'f_dist_parcel_flood',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['surroundings', 'flood', 'flood_simple', 'flood_regular'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_flood_risk_insurance_exclusion',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['high', 'none'],
        sections: ['surroundings', 'flood', 'flood_insurance_exclusion'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm',
        location: 'features',
        name: 'f_dist_building_flood_insurance_exclusion',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['surroundings', 'flood', 'flood_insurance_exclusion'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_parcel_flood_risk_insurance_exclusion',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['high', 'none'],
        sections: ['surroundings', 'flood', 'flood_simple', 'flood_insurance_exclusion'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm',
        location: 'features',
        name: 'f_dist_parcel_flood_insurance_exclusion',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['surroundings', 'flood', 'flood_insurance_exclusion'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_flood_risk_composite',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['high', 'medium', 'low', 'none'],
        sections: ['surroundings', 'flood'],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'f_flood_risk_max_parcel',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['high', 'medium', 'low', 'none'],
        sections: ['surroundings', 'flood'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'dvm_features',
        name: 'surroundings',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['urban', 'rural', 'isolated'],
        sections: ['surroundings'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'multi_enum_open',
        unit: '',
        location: 'dvm_features',
        name: 'other_positive',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'classified_facade',
            'green_neighbourhood',
            'sea_view',
            'no_direct_traffic',
            'exceptional_view',
            'other',
        ],
        sections: ['surroundings'],
    },
    {
        modules: [],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'dvm_features',
        name: 'other_positive_details',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['surroundings'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'multi_enum_open',
        unit: '',
        location: 'dvm_features',
        name: 'other_negative',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['tram', 'train', 'metro', 'traffic', 'busy_area', 'other'],
        sections: ['surroundings'],
    },
    {
        modules: [],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'dvm_features',
        name: 'other_negative_details',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['surroundings'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'multiline-text',
        unit: '',
        location: 'dvm_features',
        name: 'remarks',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'multiline-text',
        unit: '',
        location: 'dvm_features',
        name: 'internal_remarks',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'epc_source',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['user_estimate', 'certificate'],
        sections: ['building'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'room',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'enum_open',
        unit: '',
        location: 'section_data',
        name: 'room.type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'bedroom',
            'bathroom',
            'toilet',
            'kitchen',
            'living_room',
            'laundry_room',
            'lounge',
            'cellar',
            'attic',
            'hallway',
            'patio',
            'entry_hall',
        ],
        sections: ['room'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'm2',
        location: 'section_data',
        name: 'room.living_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['room'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'section_data',
        name: 'room.comment',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['room'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: '',
        unit: '',
        location: '',
        name: '',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'valuations',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'valuation',
        name: 'market_value',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'valuation',
        name: 'market_value_post_renovation',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'valuation',
        name: 'construction_cost',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'valuation',
        name: 'market_value_pre_construction',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'valuation',
        name: 'forced_sale_value_pre_construction',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'valuation',
        name: 'forced_sale_value_post_renovation',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'valuation',
        name: 'forced_sale_value',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro/month',
        location: 'valuation',
        name: 'rental_value',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'valuation',
        name: 'reconstruction_value',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations', 'reconstruction_value'],
    },
    {
        modules: ['ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'float',
        unit: 'euro',
        location: 'valuation',
        name: 'cadastral_income',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'float',
        unit: '',
        location: 'valuation',
        name: 'index_value',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['valuations', 'reconstruction_value'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'valuation',
        name: 'index_type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['abex'],
        sections: ['valuations', 'reconstruction_value'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'features',
        name: 'level',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['reconstruction_value', 'flood_meta'],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'reference_properties_location',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'section',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'reference_properties_characteristics',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'section',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'flood',
        search_dict_name: '',
        icon: 'ic-flood',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'section',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'energy',
        search_dict_name: '',
        icon: 'ic-environment',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'section',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'flood_simple',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'feature',
        type: 'float',
        unit: 'm',
        location: 'features',
        name: 'f_ground_height_above_sea',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['flood', 'flood_simple'],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: [
            'house',
            'apartment',
            'new_house',
            'new_apartment',
            'construction_plot',
        ],
        functionality: 'section',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'faq',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['new_house', 'new_apartment'],
        functionality: 'feature',
        type: '',
        unit: '',
        location: 'features',
        name: 'no_building_picture',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['construction_plot'],
        functionality: 'feature',
        type: '',
        unit: '',
        location: 'features',
        name: 'no_parcel_picture',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['new_house'],
        functionality: 'feature',
        type: '',
        unit: '',
        location: 'features',
        name: 'no_garden_technical_drawing',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['new_house', 'new_apartment'],
        functionality: 'feature',
        type: '',
        unit: '',
        location: 'features',
        name: 'parcel_selection',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: ['new_house', 'new_apartment'],
        functionality: 'feature',
        type: '',
        unit: '',
        location: 'features',
        name: 'vat',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'section',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'questions_feedback',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['core', 'avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'section',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'contact_info',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['avm', 'dvm', 'ovm'],
        building_type_scope: ['house', 'apartment'],
        functionality: 'section',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'disclaimer',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-avm',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-dvm',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['dvm', 'ovm', 'borrower'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-ovm',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['borrower'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'why-ovm',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['dvm', 'ers', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-dashboard',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['dvm', 'ers', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-draft',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['ovm', 'borrower'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'when-report',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['borrower'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-download-report',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'market-price-incorrect',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'issue-parcels',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'old-picture-or-3d',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['dvm', 'ers', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'report-language',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'wrong-pictures',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['dvm', 'ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'sharing',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'remarks-language',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'ING-how-ovm-request',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'where-customer-ref',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'building-type-apartment-building',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ers', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'address-not-found',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ers', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'find-epc',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'epc-label-vs-number',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'find-living-area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'find-box-number',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ers', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'find-construction-year',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ers', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'construction-vs-renovation',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'over-two-days',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'carport',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'personal-use',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'is-request-submitted',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['dashboard'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'review',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['dashboard'],
    },
    {
        modules: ['dvm', 'ers', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'find-previous-request',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['dashboard'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'download-report',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['dashboard'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'language-impact',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['dashboard'],
    },
    {
        modules: ['dvm', 'ers', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'unsubmission-window',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['dashboard'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'after-sixty-minutes',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['dashboard'],
    },
    {
        modules: ['dvm', 'ovm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'review-billing',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['dashboard'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-ers',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-common-wall',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-protected-volume',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-living-area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'apartment-ers',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['ers '],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'no-3d-model-ers-quality',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['results'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-renovation-goal',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'missing-renovation-option',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'choosing-insulation-material',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'own-property-ers',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'estimated-epc-different-than-actual-epc',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['results'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-is-vat-computed',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['results'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'price-ers-includes',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['results'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'incorrect-region',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['results'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'interaction-between-renovations',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['results'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'ers-reliability',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'report-measurements-dont-match',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-create-val-req',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm', 'ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-access-app',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['general'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-use-dashboard',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'what-is-val-report',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['report'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-create-req-const',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-create-req-new-house',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-create-req-existing-house',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-create-req-new-qpqrtment',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-create-req-existing-apartment',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-confirm-address-existing-prop',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['dvm'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-confirm-address-prop-under-const',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-create-ers-req-3D',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-create-ers-req-2D',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-to-create-ers-req-building-not-found',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'faq',
        type: '',
        unit: '',
        location: 'faq',
        name: 'how-total-investment-cost-calculated',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['application'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'property_type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['house', 'appartment'],
        sections: ['property_type'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features_question',
        name: 'insulated_floors',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'insulated_floors',
        search_dict_name: 'floor_attributes.0.has_insulation',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features_question',
        name: 'insulated_roof',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'insulated_roof',
        search_dict_name: 'roof_attributes.0.has_insulation',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features_question',
        name: 'insulated_walls',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'insulated_walls',
        search_dict_name: 'wall_attributes.0.has_insulation',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: ['ers'],
        building_type_scope: ['house', 'apartment', 'new_house', 'new_apartment'],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'window_type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'single',
            'ordinary_double',
            'hr_double_before_2000',
            'hr_double_after_2000',
            'triple',
        ],
        sections: ['insulation', 'building_structure'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features_question',
        name: 'has_attic',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'has_attic',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'insulation_floors_when',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features',
        name: 'floors_insulation_years',
        search_dict_name: 'floor_attributes.0.insulation_year',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'insulation_roof_when',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features',
        name: 'roof_insulation_year',
        search_dict_name: 'roof_attributes.0.insulation_year',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'insulation_walls_when',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features',
        name: 'walls_insulation_year',
        search_dict_name: 'wall_attributes.0.insulation_year',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features_question',
        name: 'has_basement',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'has_basement',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features_question',
        name: 'is_attic_heated',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'is_attic_heated',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['insulation'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'address',
        name: 'streetname',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['address'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'address',
        name: 'streetnumber',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['address'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'address',
        name: 'boxnumber',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['address'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'address',
        name: 'postalcode',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['address'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'address',
        name: 'municipality',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['address'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'epc_known',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features',
        name: 'epc_score',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['house_info'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'heating',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'heating_fuel',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'gas',
            'oil',
            'wood',
            'pellets',
            'coal',
            'district_heating',
            'electricity',
        ],
        sections: ['consumption'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features_question',
        name: 'select_heating_fuel',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'condensing_boiler',
            'standard_boiler_open',
            'standard_boiler_closed',
            'heat_pump',
            'standard_boiler',
            'chp',
            'energy_efficient',
            'non_energy_efficient',
            'electric_heeater',
        ],
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'heating_type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: [
            'boiler:condensing',
            'boiler:standard',
            'heat_pump',
            'stove',
            'electric_heater',
            'district_heating',
        ],
        sections: ['consumption'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features',
        name: 'heating_installation_year',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['consumption'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'ventilation',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features',
        name: 'ventilation_type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['natural', 'mechanical'],
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features_question',
        name: 'ventilation_type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['natural', 'mechanical'],
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'enum',
        unit: '',
        location: 'features_question',
        name: 'ventilation_subtype',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['system_b', 'system_c', 'system_cplus', 'system_d'],
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'renewables',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: ['solar_boiler', 'solar_panels', 'battery', 'air_conditioner'],
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'solar_boiler',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['consumption'],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'solar_panels',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['consumption'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'battery',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['consumption'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'air_conditioner',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['consumption'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'additional_consumption',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'spa_room',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'swimming_pool',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'electric_vehicle',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'consumers',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features',
        name: 'n_residents',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['consumption'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features_question',
        name: 'protected_consumer',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features',
        name: 'protected_consumer',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'installation_year',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'heater',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'energy_consumption_info',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'house_info',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'consumption',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'property_type',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'address',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'insulation',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'text',
        type: 'string',
        unit: '',
        location: 'section',
        name: 'house_information',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'consumption_known',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'yearly_electricity_consumption',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'features_question',
        name: 'yearly_electricity_consumption_subtitle',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features',
        name: 'yearly_electricity_consumption',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: ['consumption'],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'yearly_fuel_consumption',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'yearly_heating_consumption',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'f_construction_year',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'f_living_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'string',
        unit: '',
        location: 'features_question',
        name: 'approx_living_area',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features_question',
        name: 'solar_panels',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features_question',
        name: 'insulated_windows',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features_question',
        name: 'insulated_single_renovated',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'feature',
        type: 'boolean',
        unit: '',
        location: 'features_question',
        name: 'insulated_plural_renovated',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: ['ers'],
        building_type_scope: [],
        functionality: 'feature',
        type: 'integer',
        unit: '',
        location: 'features',
        name: 'gas_consumption_approx',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'question',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q1.q',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q1.a1',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'correct_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q1.a2',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q1.a3',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'question',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q2.q',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q2.a1',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'correct_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q2.a2',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q2.a3',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q2.a4',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'question',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q3.q',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q3.a1',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q3.a2',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'correct_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q3.a3',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'question',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q4.q',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q4.a1',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q4.a2',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'correct_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q4.a3',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'question',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q5.q',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q5.a1',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'correct_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q5.a2',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q5.a3',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'question',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q6.q',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'correct_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q6.a1',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q6.a2',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
    {
        modules: [],
        building_type_scope: [],
        functionality: 'wrong_answer',
        type: 'string',
        unit: '',
        location: 'energy_quizz',
        name: 'q6.a3',
        search_dict_name: '',
        icon: '',
        fallback: '',
        values: null,
        sections: [],
    },
]
export const translations = {
    'fr-BE': {
        unit: {
            m: 'm',
            m_tooltip: '',
            m2: 'm\u00b2',
            m2_tooltip: '',
            m3: 'm\u00b3',
            m3_tooltip: '',
            'kwh/m2year': 'kWh/m\u00b2an',
            'kwh/m2year_tooltip': '',
            euro: '\u20ac',
            euro_tooltip: '',
            'euro/month': '\u20ac/mois',
            'euro/month_tooltip': '',
            'euro/year': '\u20ac/an',
            'euro/year_tooltip': '',
            'euro/m2': '\u20ac/m\u00b2',
            'euro/m2_tooltip': '',
            'kgco2/m2year': 'kgCO\u2082/m\u00b2an',
            'kgco2/m2year_tooltip': '',
            'kgco2/year': 'kgCO\u2082/an',
            'kgco2/year_tooltip': '',
            'kwh/year': 'kWh/an',
            'kwh/year_tooltip': '',
            'l/year': 'l/an',
            'l/year_tooltip': '',
            'kg/year': 'kg/an',
            'kg/year_tooltip': '',
            'm3/year': 'm\u00b3/an',
            'm3/year_tooltip': '',
            percent: '%',
            percent_tooltip: '',
            month: '/mois',
            month_tooltip: '',
            kWh: 'kWh',
            kWh_tooltip: '',
            l: 'l',
            l_tooltip: '',
            kg: 'kg',
            kg_tooltip: '',
            'kWh/m2/yr': 'kWh/m\u00b2/an',
            'kWh/m2/yr_tooltip': '',
            'kWh/yr': 'kWh/an',
            'kWh/yr_tooltip': '',
            'l/yr': 'l/an',
            'l/yr_tooltip': '',
            'm3/yr': 'm\u00b3/an',
            'm3/yr_tooltip': '',
            'kg/co2/yr': 'kg/co2/an',
            'kg/co2/yr_tooltip': '',
            'kg/yr': 'kg/an',
            'kg/yr_tooltip': '',
        },
        address: {
            full_address: 'Adresse',
            full_address_tooltip:
                "S\u00e9lectionnez l'adresse du bien financ\u00e9. Merci de ne pas confondre ceci avec l'adresse d'autres biens \u00e9ventuels qui peuvent servir comme garantie.",
            streetname: 'Rue',
            streetname_tooltip: '',
            streetnumber: 'Num\u00e9ro',
            streetnumber_tooltip: '',
            boxnumber: 'Bo\u00eete',
            boxnumber_tooltip: '',
            postalcode: 'Code postal',
            postalcode_tooltip: '',
            municipality: 'Commune',
            municipality_tooltip: '',
        },
        valuation: {
            date: 'Date de la valorisation',
            date_tooltip: '',
            type: 'Type de valorisation',
            type_tooltip: '',
            performed_for: 'R\u00e9alis\u00e9 pour',
            performed_for_tooltip: '',
            valuer: 'R\u00e9alis\u00e9 par',
            valuer_tooltip: '',
            monitor: 'Contr\u00f4l\u00e9 par',
            monitor_tooltip: '',
            market_value: 'Valeur de march\u00e9',
            market_value_tooltip: '',
            market_value_post_renovation:
                'Valeur de march\u00e9 pr\u00e9vue apr\u00e8s r\u00e9novation',
            market_value_post_renovation_tooltip: '',
            construction_cost: 'Co\u00fbt de construction',
            construction_cost_tooltip: '',
            market_value_pre_construction: 'Valeur de march\u00e9 avant construction',
            market_value_pre_construction_tooltip: '',
            forced_sale_value_pre_construction:
                'Valeur de vente forc\u00e9e avant construction',
            forced_sale_value_pre_construction_tooltip: '',
            forced_sale_value_post_renovation:
                'Valeur de vente forc\u00e9e pr\u00e9vue apr\u00e8s r\u00e9novation',
            forced_sale_value_post_renovation_tooltip: '',
            forced_sale_value: 'Valeur de vente forc\u00e9e',
            forced_sale_value_tooltip: '',
            rental_value: 'Valeur locative mensuelle',
            rental_value_tooltip: '',
            reconstruction_value: 'Valeur de reconstruction',
            reconstruction_value_tooltip: '',
            cadastral_income: 'Revenu cadastral',
            cadastral_income_tooltip: '',
            index_value: 'Index',
            index_value_tooltip: '',
            index_type: "Type d'index",
            index_type_tooltip: '',
            explanation_1:
                "La valorisation de ce bien repose en partie sur un mod\u00e8le statistique fond\u00e9 sur des donn\u00e9es. Son r\u00e9sultat a \u00e9t\u00e9 revu et affin\u00e9 par un expert immobilier. Il s'agit d'un processus en deux \u00e9tapes :",
            explanation_1_tooltip: '',
            explanation_2: '\u00c9tape 1 : Estimation par mod\u00e8le de valorisation',
            explanation_2_tooltip: '',
            explanation_3:
                'Une premi\u00e8re estimation de la valeur de march\u00e9 de la propri\u00e9t\u00e9 est calcul\u00e9e par le mod\u00e8le sur la base de toutes les informations fournies par le client et de certains param\u00e8tres automatiques (cf. page 2). Cette valorsiation repr\u00e9sente la valeurde march\u00e9 moyenne pour une propri\u00e9t\u00e9 ayant cette localisation et ces caract\u00e9ristiques.(*)',
            explanation_3_tooltip: '',
            construction_plot_explanation_3:
                'Une premi\u00e8re estimation de la valeur de march\u00e9 de la propri\u00e9t\u00e9 est calcul\u00e9e sur base de la surface totale de la parcelle et sur le prix historique par m\u00e8tre carr\u00e9 des propri\u00e9t\u00e9s vendue dans le voisinage.',
            construction_plot_explanation_3_tooltip: '',
            explanation_4:
                '\u00c9tape 2 : Evaluation et mise au point par un expert immobilier',
            explanation_4_tooltip: '',
            explanation_5:
                "L'expert immobilier \u00e9value la valorisation du mod\u00e8le utilis\u00e9e en \u00c9tape 1 et prend ensuite en compte les autres param\u00e8tres entr\u00e9s automatiquement, ainsi que les param\u00e8tres entr\u00e9s par l'expert. Il en r\u00e9sulte une valeur de march\u00e9 du bien (ligne rouge dans le graphique). En fonction des corrections appliqu\u00e9es par l'expert immobilier, la valeur de march\u00e9 peut \u00eatre inf\u00e9rieure ou sup\u00e9rieure \u00e0 l'estimation initiale du mod\u00e8le de valorisation.\n\nLe graphique ci-dessous illustre comment la valeur de march\u00e9 de cette propri\u00e9t\u00e9 se compare \u00e0 d'autres propri\u00e9t\u00e9s dans le voisinage. Il permet toujours de contextualiser la valorisation r\u00e9alis\u00e9e par l'expert.",
            explanation_5_tooltip: '',
            construction_plot_explanation_5:
                "L'expert immobilier \u00e9value la valorisation du mod\u00e8le utilis\u00e9e en \u00c9tape 1 et prend ensuite en compte les autres param\u00e8tres, entr\u00e9s automatiquement ou par l'expert.",
            construction_plot_explanation_5_tooltip: '',
            explanation_6:
                "La valeur de march\u00e9 indiqu\u00e9e dans ce rapport est bas\u00e9e sur une valorisation \u00e0 distance r\u00e9alis\u00e9e par un expert. Elle vise \u00e0 donner la meilleure vue possible sur la valeur actuelle du bien. Cependant, elle reste une estimation o\u00f9 les \u00e9l\u00e9ments suivants doivent \u00eatre pris en compte :\n- Valorisation \u00e0 distance: l'expert a \u00e9valu\u00e9 le bien \u00e0 distance et n'a pas r\u00e9ellement visit\u00e9 le bien.\n- Pr\u00e9cision du mod\u00e8le: la valorisation repose, en partie, sur un mod\u00e8le statistique avec une certaine marge d'erreur.\n- Degr\u00e9 de subjectivit\u00e9: m\u00eame la meilleure valorisation par un expert est quelque peu biais\u00e9e par une forme de subjectivit\u00e9.",
            explanation_6_tooltip: '',
            onsite_explanation_6:
                "La valeur marchande indiqu\u00e9e dans ce rapport est bas\u00e9e sur une \u00e9valuation sur place examin\u00e9e par un expert et tente de donner le meilleur aper\u00e7u possible de la valeur actuelle du bien. Toutefois, il s'agit d'une estimation pour laquelle les \u00e9l\u00e9ments suivants doivent \u00eatre pris en compte :\n- Pr\u00e9cision du mod\u00e8le : l'\u00e9valuation repose, au moins partiellement, sur un mod\u00e8le statistique qui pr\u00e9sente une certaine marge d'erreur.\n- Niveau de subjectivit\u00e9 : m\u00eame la meilleure \u00e9valuation d'expert est quelque peu biais\u00e9e par un certain niveau de subjectivit\u00e9",
            onsite_explanation_6_tooltip: '',
            shared: {
                apartment: 'Appartement',
                assessed: 'Assessed',
                destructive_safeguard: {
                    confirm: 'Confirmer',
                    content:
                        '\u00cates-vous s\u00fbr de vouloir proc\u00e9der \u00e0 ce changement ?',
                    title:
                        'Attention : ce changement va r\u00e9initialiser le reste de votre demande.',
                },
                distance: 'Distance',
                listing_date: 'Listing date',
                reference: 'Reference',
            },
            desktop: {
                avm_features_influence: 'D\u00e9viation des crit\u00e8res AVM',
            },
            sidesteps: {
                borrower_details: "Donn\u00e9es de l'emprunteur",
                chat: {
                    button: 'Chat',
                    title: 'Your conversation with the Valuation Specialist',
                },
                construction_plot: 'Terrain \u00e0 b\u00e2tir',
                extra_info: 'Informations compl\u00e9mentaires',
                feedback: 'Feedback',
            },
            floors: {
                close: 'Fermer',
            },
            enter: {
                conflict_modal: {
                    back: 'Retour',
                    content:
                        'Pour visualiser cette demande d\u00e9j\u00e0 formul\u00e9e, cliquez sur le bouton du tableau de bord ci-dessous:',
                    continue: 'Continuer',
                    cta: 'Voulez-vous poursuivre avec la r\u00e9f\u00e9rence en doublon?',
                    dashboard: 'Voir dans le tableau de bord',
                    title:
                        "Il existe d\u00e9j\u00e0 une demande d'\u00e9valuation avec cette r\u00e9f\u00e9rence interne.",
                },
                customer_ref_title:
                    'Quelle est la r\u00e9f\u00e9rence interne du pr\u00eat ?',
                tooltip_text:
                    "Ceci permet de relier la demande d'\u00e9valuation au pr\u00eat.",
            },
            extra_info: {
                construction_cost_minValue:
                    'Veuillez entrer un co\u00fbt de construction sup\u00e9rieur \u00e0 10000',
                documents: 'Documents',
                documents_modal: {
                    label: 'Ajouter des documents (.jpg, .jpeg, .png, .pdf)',
                    steps: {
                        online: 'Envoy\u00e9',
                        upload: 'Ajouter',
                        uploading: 'Chargement',
                    },
                    title: 'Envoyer des documents',
                    warning:
                        "Tout document partag\u00e9 qui contient des informations autres que le PEB ou des photos de l'ext\u00e9rieur du bien ne sera pas pris en compte et supprim\u00e9.",
                },
            },
            feedback: {
                customer_present: 'Avez-vous rempli ce formulaire avec le client?',
                more_questions:
                    'Vous pouvez suivre le progr\u00e8s de votre demande sur le dashboard.',
                question_one:
                    "Comment \u00e9valuez-vous l'exp\u00e9rience globale pour remplir cette demande?",
                question_three_blocked:
                    "Expliquez-nous ce qui s'est pass\u00e9 et pourquoi vous ne pouvez pas continuer.",
                question_three_sent: 'Autres remarques',
                question_two: 'De quels documents le client disposait-il?',
                question_two_1: 'Certificat PEB',
                question_two_1_text: 'R\u00e9f\u00e9rence',
                question_two_2: 'Annonce immobili\u00e8re',
                question_two_2_link: 'Lien / R\u00e9f\u00e9rence',
                question_two_2_text: 'Source',
                question_two_3: 'Offre sign\u00e9e',
                question_two_4: 'Compromis',
                question_two_5: 'Acte de vente',
                question_two_6: "Rapport d'expertise",
                rating_1: '1: Tr\u00e8s mauvais',
                rating_2: '2: Mauvais',
                rating_3: '3: Ok',
                rating_4: '4: Bon',
                rating_5: '5: Tr\u00e8s bon',
                send: 'Envoyer le feedback et recommencer',
                rating_description: '(1 = tr\u00e8s mauvais / 5 = tr\u00e8s bon)',
            },
            start: {
                dashboard: 'Dashboard',
                welcome_text_1:
                    "Bienvenue ! Cette application vous permet d'estimer un prix immobilier pour chaque maison ou appartement en Belgique.",
                welcome_text_2:
                    "Chaque demande commence avec l'entr\u00e9e des d\u00e9tails sur un bien.",
                welcome_text_3:
                    "Ceci est une d\u00e9mo de l'outil de valuation Rockestate. Il est configur\u00e9 pour vous donner une id\u00e9e sur les diff\u00e9rentes alternatives de valuation de Rockestate (automatique, \u00e0 distance et sur place). L'impl\u00e9mentation de cet outil dans un environment de production peut varier l\u00e9g\u00e8rement de cette version d\u00e9mo.",
                welcome_title: 'Calculez un prix immobilier',
            },
            avm: {
                no_bedroom: '0 chambre \u00e0 coucher!',
            },
            request: {
                start_button_text: 'Commencer',
                start_over: 'Recommencer sans donner de feedback',
                tab_title: 'Formulaire',
                text_too_long: 'Ce champ est trop long',
                textarea_placeholder: 'Entrez vos commentaires ici',
                title:
                    'Nous y sommes presque. Quelques derni\u00e8res questions pour conclure.',
                which_type: 'Quel est le type de bien financ\u00e9 ?',
                which_address: "Quelle est l'adresse du bien financ\u00e9 ?",
                title_blocked:
                    'Nous sommes d\u00e9sol\u00e9s que vous soyez bloqu\u00e9.',
                title_sent: 'Votre demande a \u00e9t\u00e9 envoy\u00e9e !',
            },
            building_type: {
                tooltip_text:
                    'Est-que le client finance une maison unifamiliale ou un appartement?',
            },
            address: {
                tooltip_text:
                    "S\u00e9lectionnez l'adresse du bien financ\u00e9. Merci de ne pas confondre ceci avec l'adresse d'autres bien \u00e9ventuels qui peuvent servir comme s\u00fbret\u00e9.",
            },
            map: {
                'tooltip-for-confirm-main-building':
                    "Si ce n'est pas le bon b\u00e2timent, vous pouvez cliquer sur le lien ci-dessous pour pouvoir en s\u00e9lectionner un autre",
                'tooltip-for-confirm-main-parcel':
                    'La parcelle principale est celle o\u00f9 une maison serait construite',
                'tooltip-for-select-extra-parcels':
                    'Cliquez avec la souris sur les autres parcelles associ\u00e9es \u00e0 la propri\u00e9t\u00e9',
                'tooltip-for-select-main-building':
                    'Cliquez sur le b\u00e2timent principal',
                'tooltip-for-select-main-parcel':
                    'La parcelle principale est celle o\u00f9 une maison serait construite',
                'tooltip-for-select-parcels':
                    'Cliquer sur la/les parcelle(s) concernc\u00e9es par le bien',
                'tooltip-for-select-secondary-buildings': '',
                'tooltip-for-view-building-parcels':
                    'Si vous d\u00e9sirez changer ces informations, vous devez annuler cette demande et en cr\u00e9er une nouvelle',
                use_as_reference: 'Use as reference',
            },
            '': {
                upload_documents_tooltip: 'document(s) envoy\u00e9(s)',
            },
        },
        assessment: {
            date_tooltip: '',
            type_tooltip: '',
        },
        value: {
            avm: 'Valorisation automatique',
            avm_tooltip: '',
            dvm: 'Valorisation \u00e0 distance',
            dvm_tooltip: '',
            ovm: 'Valorisation sur place',
            ovm_tooltip: '',
            flood_assessment_tooltip: '',
            ers: 'Simulation de r\u00e9novations \u00e9nerg\u00e9tiques',
            ers_tooltip: '',
            short: {
                avm: 'Valorisation automatique',
                avm_tooltip: '',
                dvm: 'Valorisation \u00e0 distance',
                dvm_tooltip: '',
                ovm: 'Valorisation sur place',
                ovm_tooltip: '',
                ers: 'R\u00e9novation \u00e9nerg\u00e9tique',
                ers_tooltip: '',
            },
            '-': ' ',
            '-_tooltip': '',
            new_loan: 'Demande de pr\u00eat immobilier',
            new_loan_tooltip: '',
            revaluation: 'Revalorisation',
            revaluation_tooltip: '',
            classic_tooltip: '',
            renovation_light_tooltip: '',
            renovation_full_tooltip: '',
            new_building: 'Bien en construction',
            new_building_tooltip: 'sous r\u00e9gime TVA',
            existing_building: 'Bien d\u00e9j\u00e0 b\u00e2ti',
            existing_building_tooltip: "sujet aux frais d'enregistrement ",
            house: 'Maison',
            house_tooltip: 'B\u00e2timent comptant une seule entit\u00e9',
            apartment: 'Appartement',
            apartment_tooltip:
                "Une entit\u00e9 qui fait partie d'un b\u00e2timent plus large",
            annex: 'Annexe',
            annex_tooltip: '',
            new_construction: 'Nouvelle construction',
            new_construction_tooltip: '',
            new_house: 'Maison neuve',
            new_house_tooltip: 'B\u00e2timent comptant une seule entit\u00e9',
            new_apartment: 'Appartement neuf',
            new_apartment_tooltip:
                "Une entit\u00e9 qui fait partie d'un b\u00e2timent plus large",
            construction_plot: 'Terrain \u00e0 b\u00e2tir',
            construction_plot_tooltip: '',
            attached: '2 fa\u00e7ades',
            attached_tooltip: '',
            semi: '3 fa\u00e7ades',
            semi_tooltip: '',
            detached: '4 fa\u00e7ades',
            detached_tooltip: '',
            yes: 'Oui',
            yes_tooltip: '',
            no: 'Non',
            no_tooltip: '',
            traditional: 'Traditionnel',
            traditional_tooltip: '',
            modern: 'Moderne',
            modern_tooltip: '',
            contemporary: 'Contemporain',
            contemporary_tooltip: '',
            mediterranean: 'M\u00e9diterran\u00e9en',
            mediterranean_tooltip: '',
            other: 'Autre',
            other_tooltip: '',
            ground_floor: 'Rez-de-chauss\u00e9e',
            ground_floor_tooltip: '',
            1: '1',
            '1_tooltip': '',
            2: '2',
            '2_tooltip': '',
            3: '3',
            '3_tooltip': '',
            4: '4',
            '4_tooltip': '',
            '>4': '>4',
            '>4_tooltip': '',
            interior: 'Int\u00e9rieur',
            interior_tooltip: '',
            exterior: 'Ext\u00e9rieur',
            exterior_tooltip: '',
            private: 'Jardin priv\u00e9',
            private_tooltip: '',
            common: 'Jardin commun',
            common_tooltip: '',
            'private+common': 'Jardin priv\u00e9 et commun',
            'private+common_tooltip': '',
            maintenance_required: "Besoin d'entretien",
            maintenance_required_tooltip: '',
            good: 'Bon',
            good_tooltip: '',
            very_good: 'Tr\u00e8s bon',
            very_good_tooltip: '',
            security: 'Syst\u00e8me de s\u00e9curit\u00e9',
            security_tooltip: '',
            water_softener: "Adoucisseur d'eau",
            water_softener_tooltip: '',
            air_con: 'Air conditionn\u00e9',
            air_con_tooltip: '',
            elevator: 'Ascenseur',
            elevator_tooltip: '',
            domotics: 'Domotique',
            domotics_tooltip: '',
            storage: 'Local v\u00e9los',
            storage_tooltip: '',
            rain_water: "Puits d'eau de pluie",
            rain_water_tooltip: '',
            hot_tub: 'Jacuzzi',
            hot_tub_tooltip: '',
            cinder_blocks: 'Blocs de b\u00e9ton',
            cinder_blocks_tooltip: '',
            wood: 'Bois',
            wood_tooltip: '',
            plaster: 'Cr\u00e9pi',
            plaster_tooltip: '',
            natural_stone: 'Pierres naturelles',
            natural_stone_tooltip: '',
            metal: 'M\u00e9tal',
            metal_tooltip: '',
            concrete: 'B\u00e9ton',
            concrete_tooltip: '',
            brick: 'Briques',
            brick_tooltip: '',
            tiles: 'Tuiles',
            tiles_tooltip: '',
            bitumen_roofing: 'Roofing',
            bitumen_roofing_tooltip: '',
            slate_shingles: 'Ardoises',
            slate_shingles_tooltip: '',
            black_concrete_tiles: 'Tuiles noires en b\u00e9ton',
            black_concrete_tiles_tooltip: '',
            thatched: 'Chaume',
            thatched_tooltip: '',
            asbestos: 'Amiante',
            asbestos_tooltip: '',
            green_roof: 'Toit v\u00e9g\u00e9tal',
            green_roof_tooltip: '',
            home_liberal_profession_or_office:
                'Maison, profession lib\u00e9rale ou bureau',
            home_liberal_profession_or_office_tooltip: '',
            home_other_professional_activity: 'Autre activit\u00e9 professionelle',
            home_other_professional_activity_tooltip: '',
            home: 'Maison',
            home_tooltip: '',
            no_economic_activity: "Pas d'activit\u00e9 \u00e9conomique",
            no_economic_activity_tooltip: '',
            activity_unlikely: 'Activit\u00e9 improbable',
            activity_unlikely_tooltip: '',
            activity_possible: 'Activit\u00e9 possible',
            activity_possible_tooltip: '',
            activity_likely: 'Activit\u00e9 probable',
            activity_likely_tooltip: '',
            activity_very_likely: 'Activit\u00e9 tr\u00e8s probable',
            activity_very_likely_tooltip: '',
            n: 'N',
            n_tooltip: '',
            ne: 'NE',
            ne_tooltip: '',
            e: 'E',
            e_tooltip: '',
            se: 'SE',
            se_tooltip: '',
            s: 'S',
            s_tooltip: '',
            sw: 'SO',
            sw_tooltip: '',
            w: 'O',
            w_tooltip: '',
            nw: 'NO',
            nw_tooltip: '',
            limited: 'Limit\u00e9',
            limited_tooltip: '',
            details_previous_page: '(d\u00e9tails sur la page pr\u00e9c\u00e9dente)',
            details_previous_page_tooltip: '',
            below_average: 'Sous la moyenne',
            below_average_tooltip: '',
            average: 'Moyen',
            average_tooltip: '',
            above_average: 'Au dessus de la moyenne',
            above_average_tooltip: '',
            low: 'Faible',
            low_tooltip: '',
            medium: 'Mod\u00e9r\u00e9',
            medium_tooltip: '',
            high: 'Elev\u00e9',
            high_tooltip: '',
            unknown: 'Inconnu',
            unknown_tooltip: '',
            urban: 'Urbain',
            urban_tooltip: '',
            rural: 'Rural',
            rural_tooltip: '',
            isolated: 'Isol\u00e9',
            isolated_tooltip: '',
            city: 'Ville',
            city_tooltip: '',
            suburbs: 'Banlieue',
            suburbs_tooltip: '',
            village: 'Village',
            village_tooltip: '',
            none: 'Aucun',
            none_tooltip: '',
            classified_facade: 'Fa\u00e7ade class\u00e9e',
            classified_facade_tooltip: '',
            green_neighbourhood: 'Environnement vert',
            green_neighbourhood_tooltip: '',
            sea_view: 'Vue sur mer',
            sea_view_tooltip: '',
            no_direct_traffic: 'Pas de trafic direct',
            no_direct_traffic_tooltip: '',
            exceptional_view: 'Vue exceptionelle',
            exceptional_view_tooltip: '',
            tram: 'Tram',
            tram_tooltip: '',
            train: 'Train',
            train_tooltip: '',
            metro: 'M\u00e9tro',
            metro_tooltip: '',
            traffic: 'Trafic',
            traffic_tooltip: '',
            busy_area: 'Zone fr\u00e9quent\u00e9e',
            busy_area_tooltip: '',
            user_estimate: 'Estimation',
            user_estimate_tooltip: '',
            certificate: 'Certificat',
            certificate_tooltip: '',
            refinancing: 'Refinancement ou remise en vigueur',
            refinancing_tooltip: '',
            bedroom: 'Chambre',
            bedroom_tooltip: '',
            bathroom: 'Salle de bain',
            bathroom_tooltip: '',
            toilet: 'Toilette',
            toilet_tooltip: '',
            abex: 'ABEX',
            abex_tooltip: '',
            apartment_block_info:
                "Les parties communes de l'immeuble, partag\u00e9es avec des copropri\u00e9taires",
            apartment_block_info_tooltip: '',
            apartment_block: 'Immeuble',
            apartment_block_tooltip: '',
            other_type: 'Autre',
            other_type_tooltip: '',
            single: 'Simple',
            single_tooltip: '',
            ordinary_double: 'Double',
            ordinary_double_tooltip: '',
            hr_double_after_2000: 'Double haut rendement (apr\u00e8s 2000)',
            hr_double_after_2000_tooltip: '',
            hr_double_before_2000: 'Double haut rendement (avant 2000)',
            hr_double_before_2000_tooltip: '',
            triple: 'Triple',
            triple_tooltip: '',
            gas: 'Gaz',
            gas_tooltip: '',
            oil: 'Mazout',
            oil_tooltip: '',
            pellets: 'Pellets',
            pellets_tooltip: '',
            coal: 'Charbon',
            coal_tooltip: '',
            district_heating: 'Chauffage urbain/r\u00e9seau de chaleur',
            district_heating_tooltip: '',
            'boiler:condensing': 'Chaudi\u00e8re \u00e0 condensation',
            'boiler:condensing_tooltip': '',
            heat_pump: 'Pompe \u00e0 chaleur',
            heat_pump_tooltip: '',
            'boiler:standard': 'Chaudi\u00e8re standard',
            'boiler:standard_tooltip': '',
            chp: 'Cog\u00e9n\u00e9ration',
            chp_tooltip: '',
            stove: 'Po\u00eale',
            stove_tooltip: '',
            electricity: 'Electricit\u00e9',
            electricity_tooltip: '',
            electric_heater: 'Chauffage \u00e9lectrique',
            electric_heater_tooltip: '',
            no_ventilation: 'Pas de ventilation',
            no_ventilation_tooltip: '',
            natural: 'Naturelle',
            natural_tooltip:
                "Ventilation naturelle par les fen\u00eatres ou des grilles d'a\u00e9ration.",
            mechanical: 'M\u00e9canique',
            mechanical_tooltip: '',
            system_b: 'Syst\u00e8me B',
            system_b_tooltip:
                "Syst\u00e8me d'apport m\u00e9canique de l'air frais, \u00e9vacuation naturelle de l'air vici\u00e9.",
            system_c: 'Syst\u00e8me C',
            system_c_tooltip:
                "Syst\u00e8me d'apport m\u00e9canique de l'air frais, \u00e9vacuation naturelle de l'air vici\u00e9.",
            system_cplus: 'Syst\u00e8me C+',
            system_cplus_tooltip:
                "Syst\u00e8me d'apport et d'\u00e9vacuation d'air m\u00e9canique \u00e0 la demande, en fonction de la qualit\u00e9 de l'air. ",
            system_d: 'Syst\u00e8me D',
            system_d_tooltip:
                "Syst\u00e8me d'apport et \u00e9vacuation d'air m\u00e9canique automatis\u00e9, appel\u00e9 aussi 'ventilation \u00e9quilibr\u00e9e'. ",
            pur_pir: 'PUR/PIR',
            pur_pir_tooltip: '',
            mineral_wool: 'Laine min\u00e9rale',
            mineral_wool_tooltip: '',
            hr_double: 'Double haut rendement',
            hr_double_tooltip: '',
            air_water: 'Air-eau',
            air_water_tooltip: '',
            monocrystalline: 'Monocrystallin',
            monocrystalline_tooltip: '',
        },
        request: {
            references: 'R\u00e9f\u00e9rences',
            references_tooltip: '',
            valuation_request_ref: 'R\u00e9f\u00e9rence Rock.estate',
            valuation_request_ref_tooltip: '',
            customer_ref: 'R\u00e9f\u00e9rence interne',
            customer_ref_tooltip:
                "Ceci permet de relier la demande d'\u00e9valuation au pr\u00eat.",
            bank: 'Banque',
            bank_tooltip: '',
            customer: 'Client',
            customer_tooltip: '',
            purpose: 'Objectif de la valorisation',
            purpose_tooltip: '',
            package_tooltip: '',
            map_select: {
                'explanation-confirm-main-parcel':
                    "L'emplacement et la surface totale de la parcelle principale sont-elles correctes ?",
                'cannot-find-confirm-main-parcel':
                    "Non, l'emplacement ou la surface totale ne sont pas correctes.",
                'explanation-select-main-parcel':
                    "S\u00e9lectionnez la bonne parcelle principale si l'emplacement \u00e9tait incorrect.",
                'explanation-select-main-parcel-no-selection':
                    'S\u00e9lectionnez la parcelle principale.',
                'cannot-find-select-main-parcel':
                    "L'emplacement est correcte, mais la surface totale est plus petite (ex. lotissement).",
                'explanation-select-extra-parcels':
                    "S\u00e9lectionnez les parcelles suppl\u00e9mentaires incluses dans l'achat. V\u00e9rifiez si la surface totale de la parcelle est correcte.",
                'cannot-find-select-extra-parcels':
                    'Je souhaite corriger la surface totale de la parcelle.',
                'explanation-confirm-main-building': 'Est-ce bien le bon b\u00e2timent?',
                'cannot-find-confirm-main-building':
                    "Ceci n'est pas le bon b\u00e2timent",
                'explanation-select-main-building':
                    'S\u00e9lectionnez le b\u00e2timent principal',
                'cannot-find-select-main-building':
                    'Je ne trouve pas le b\u00e2timent principal',
                'explanation-select-secondary-buildings':
                    'S\u00e9lectionnez le(s) b\u00e2timent(s) secondaire(s)',
                'cannot-find-select-secondary-buildings':
                    'Je ne trouve pas certains b\u00e2timents secondaires',
                'explanation-select-parcels': 'S\u00e9lectionnez les parcelles',
                'cannot-find-select-parcels': 'Je ne trouve pas certaines parcelles',
                'tooltip-for-select-parcels':
                    'Cliquer sur la/les parcelle(s) concernc\u00e9es par le bien',
                'explanation-view-building-parcels':
                    'Ces b\u00e2timent et parcelles ont \u00e9t\u00e9 s\u00e9lectionn\u00e9s',
            },
        },
        footer: {
            text: 'Pour de plus amples informations, visitez {url.rockestate_main}',
            text_tooltip: '',
            data_version: 'Mise à jour des données : {data_version}',
        },
        url: {
            rockestate_main: 'https://www.rock.estate',
            rockestate_main_tooltip: '',
            dashboard: '/valuation/default/dashboard',
            dashboard_tooltip: '',
            rockestate_info: 'https://www.rock.estate/',
            rockestate_info_tooltip: '',
            valuation_app: '/valuation/default/',
            valuation_app_tooltip: '',
        },
        export: {
            by: 'Export\u00e9 par',
            by_tooltip: '',
            date: 'Date',
            date_tooltip: '',
            reference: 'R\u00e9f\u00e9rence',
            reference_tooltip: '',
        },
        section: {
            reconstruction_value: 'Reconstruction',
            reconstruction_value_tooltip: '',
            address_location: 'Adresse et localisation',
            address_location_tooltip: '',
            secondary_buildings: 'B\u00e2timents secondaires',
            secondary_buildings_tooltip: '',
            economic_activity: 'Activit\u00e9 \u00e9conomique',
            economic_activity_tooltip: '',
            roof: 'Toit',
            roof_tooltip: '',
            transaction: 'Transactions',
            transaction_tooltip: '',
            general: 'G\u00e9n\u00e9ral',
            general_tooltip: '',
            report: 'Rapport',
            report_tooltip: '',
            application: 'Application',
            application_tooltip: '',
            dashboard: 'Dashboard',
            dashboard_tooltip: '',
            dispatcher: 'Dispatcher',
            dispatcher_tooltip: '',
            'user-admin': 'Utilisateurs',
            'user-admin_tooltip': '',
            apps: 'Apps',
            apps_tooltip: '',
            results: 'R\u00e9sultats',
            results_tooltip: '',
            flood_regular_tooltip: '',
            flood_insurance_exclusion_tooltip: '',
            helpcenter: "Centre d'Aide",
            helpcenter_tooltip: '',
            'faq-search-results': 'R\u00e9sultats de la recherche',
            'faq-search-results_tooltip': '',
            warnings: 'Avertissements',
            warnings_tooltip: '',
            renovation: 'R\u00e9novation pr\u00e9vue',
            renovation_tooltip: '',
            general_info: 'Informations g\u00e9n\u00e9rales',
            general_info_tooltip: '',
            parcels_and_buildings: 'Parcelles et b\u00e2timents',
            parcels_and_buildings_tooltip: '',
            c_parcels: 'Terrain',
            c_parcels_tooltip: '',
            c_building: 'B\u00e2timent principal',
            c_building_tooltip: '',
            building: 'B\u00e2timent',
            building_tooltip: '',
            secondary_buildings2: 'B\u00e2timents secondaires',
            secondary_buildings2_tooltip: '',
            building_structure: 'Structure du b\u00e2timent',
            building_structure_tooltip: '',
            common_parts: 'Communs',
            common_parts_tooltip: '',
            building_purpose_classification:
                'Utilisation & classification du b\u00e2timent',
            building_purpose_classification_tooltip: '',
            parcels: 'Parcelle(s)',
            parcels_tooltip: '',
            surroundings: 'Environnement proche',
            surroundings_tooltip: '',
            mobility: 'Mobilit\u00e9',
            mobility_tooltip: '',
            interior: 'Int\u00e9rieur',
            interior_tooltip: '',
            room: 'Pi\u00e8ce',
            room_tooltip: '',
            valuations: 'Valorisations',
            valuations_tooltip: '',
            reference_properties_location: 'Biens de r\u00e9f\u00e9rences : emplacement',
            reference_properties_location_tooltip: '',
            reference_properties_characteristics:
                'Biens de r\u00e9f\u00e9rences : caract\u00e9ristiques',
            reference_properties_characteristics_tooltip: '',
            flood: 'Zones inondables',
            flood_tooltip: '',
            energy: 'Energie',
            energy_tooltip: '',
            flood_simple: 'Zones inondables',
            flood_simple_tooltip: '',
            faq: 'Foire aux questions',
            faq_tooltip: '',
            questions_feedback: 'Questions et commentaires',
            questions_feedback_tooltip: '',
            contact_info: 'Coordonn\u00e9es de contact',
            contact_info_tooltip: '',
            disclaimer: 'Mentions l\u00e9gales',
            disclaimer_tooltip: '',
            heating: 'Chauffage',
            heating_tooltip: '',
            ventilation: 'Ventilation',
            ventilation_tooltip: '',
            renewables: 'Energies renouvelables',
            renewables_tooltip: '',
            additional_consumption: 'n/a',
            additional_consumption_tooltip: '',
            consumers: 'Consommateurs',
            consumers_tooltip: '',
            energy_consumption_info_tooltip: '',
            house_info: "Donn\u00e9es relatives \u00e0 l'habitation",
            house_info_tooltip: '',
            consumption: 'Consommation',
            consumption_tooltip: '',
            property_type: 'Type de b\u00e2timent',
            property_type_tooltip: '',
            address: "Confirmation de l'adresse",
            address_tooltip: '',
            insulation: 'Isolation',
            insulation_tooltip: '',
            house_information: 'Donn\u00e9es relatives au bien',
            house_information_tooltip: '',
        },
        front: {
            title: 'Rapport de valorisation de la propri\u00e9t\u00e9',
            title_tooltip: '',
            core_title: 'Rapport de propri\u00e9t\u00e9',
            core_title_tooltip: '',
            flood_assessment: {
                title_tooltip: '',
            },
        },
        features: {
            renovation_cost: 'Co\u00fbt des r\u00e9novations (HTVA)',
            renovation_cost_tooltip: '',
            energetic_renovation_cost:
                'Co\u00fbt des r\u00e9novations \u00e9nerg\u00e9tiques (HTVA)',
            energetic_renovation_cost_tooltip: '',
            energetic_renovation_added_value:
                'Valeur ajout\u00e9e des r\u00e9novations \u00e9nergetiques',
            energetic_renovation_added_value_tooltip: '',
            construction_cost: 'Co\u00fbt de construction (HTVA)',
            construction_cost_tooltip:
                'Le co\u00fbt total pour construire la propri\u00e9t\u00e9, ceci inclut les co\u00fbts des mat\u00e9riaux ainsi que celui de la main d\u2019\u0153uvre.',
            parcel_cost: 'Co\u00fbt du terrain (hors taxes)',
            parcel_cost_tooltip:
                'Le co\u00fbt total du terrain sur lequel la propri\u00e9t\u00e9 va ou est en train d\u2019\u00eatre construite.',
            building_class: 'Type de propri\u00e9t\u00e9',
            building_class_tooltip:
                "Quel type de propri\u00e9t\u00e9 l'emprunteur finance-t-il?",
            f_building_type: 'Type de bien',
            f_building_type_tooltip:
                'Est-que le client finance une maison unifamiliale ou un appartement?',
            f_touching_sides: 'Murs mitoyens',
            f_touching_sides_tooltip: '',
            f_number_of_facades: 'Type de maison ',
            f_number_of_facades_tooltip: '',
            f_number_of_facades_or_type: 'Nombre de fa\u00e7ades',
            f_number_of_facades_or_type_tooltip:
                'Si la construction est cens\u00e9e avoir deux murs communs, s\u00e9lectionnez "2 fa\u00e7ades", si elle n\'a qu\'un seul mur commun, s\u00e9lectionnez "3 fa\u00e7ades". Enfin, s\u00e9lectionnez "4 fa\u00e7ades" si la construction n\'a pas de murs communs avec ses voisins.',
            f_parcel_area: 'Superficie totale de la parcelle',
            f_parcel_area_tooltip:
                'La superficie totale du/des terrain(s) s\u00e9lectionn\u00e9(s) comme enregistr\u00e9 dans le cadastre',
            f_building_area: 'Surface au sol du b\u00e2timent',
            f_building_area_tooltip: '',
            f_others: 'Autre',
            f_others_tooltip: '',
            f_x_annexes: 'B\u00e2timent(s) secondaire(s)',
            f_x_annexes_tooltip: '',
            f_annexes_area: 'Surface totale du(des) b\u00e2timent(s) secondaire(s)',
            f_annexes_area_tooltip: '',
            f_area_largest_annex: 'Plus grand b\u00e2timent secondaire',
            f_area_largest_annex_tooltip: '',
            distances_annexes: 'Distances par rapport au b\u00e2timent principal',
            distances_annexes_tooltip: '',
            parcel_ids: 'R\u00e9f\u00e9rence cadastrale',
            parcel_ids_tooltip: '',
            f_lng: 'Longitude',
            f_lng_tooltip: '',
            f_lat: 'Latitude',
            f_lat_tooltip: '',
            f_number_of_addresses: "Nombre d'adresses",
            f_number_of_addresses_tooltip: '',
            f_living_area: 'Surface habitable',
            f_living_area_tooltip:
                'La surface habitable totale du bien. Cette information se retrouve normalement dans le certificat PEB.',
            f_expected_living_area: 'Surface habitable (attendue)',
            f_expected_living_area_tooltip:
                'La surface habitable totale du bien. Cette information se retrouve normalement dans le cahier des charges ou sur les plans de la propri\u00e9t\u00e9.',
            f_approx_living_area: 'Surface habitable approximative',
            f_approx_living_area_tooltip: '',
            n_rooms: 'Nombre de pi\u00e8ces principales',
            n_rooms_tooltip: '',
            approx_n_rooms: 'Nombre de pi\u00e8ces approximatif',
            approx_n_rooms_tooltip: '',
            transaction_value: 'Valeur de transaction',
            transaction_value_tooltip: '',
            transaction_date: 'Date de transaction',
            transaction_date_tooltip: '',
            approx_price_sqm: 'Prix approximatif',
            approx_price_sqm_tooltip: '',
            co2_sqm: 'Emissions de gaz \u00e0 effet de serre',
            co2_sqm_tooltip: '',
            co2_label: "Label d'\u00e9mission de gaz \u00e0 effet de serre",
            co2_label_tooltip: '',
            f_approx_epc: "Consommation d'\u00e9nergie approximative",
            f_approx_epc_tooltip: '',
            f_construction_year: 'Ann\u00e9e de construction',
            f_construction_year_tooltip:
                "L'ann\u00e9e de construction officielle et originelle. Ceci ne tient pas compte des \u00e9ventuelles r\u00e9novations qui ont eu lieu \u00e0 un moment ult\u00e9rieur. Cette information se retrouve normalement dans l'annonce immobili\u00e8re.",
            f_expected_construction_year: 'Ann\u00e9e attendue de fin de travaux',
            f_expected_construction_year_tooltip:
                "Il s'agit de l'ann\u00e9e pr\u00e9vue o\u00f9 le bien est pr\u00eat pour \u00eatre occup\u00e9. Cette ann\u00e9e peut \u00eatre trouv\u00e9e sur le prospectus du promoteur ou dans le cahier des charges si l'achat se fait aupr\u00e8s d'un promoteur immobilier. Si le bien est construit par un ind\u00e9pendant, l'ann\u00e9e pr\u00e9vue pour l'ach\u00e8vement des travaux doit \u00eatre mentionn\u00e9e dans le permis de construire.",
            f_epc: 'PEB',
            f_epc_tooltip:
                "La consommation \u00e9nerg\u00e9tique du b\u00e2timent s'exprime en kWh/m\u00b2an. Cette information peut se trouver sur le certificat PEB du b\u00e2timent. ",
            f_epc_label: 'PEB',
            f_epc_label_tooltip: '',
            f_epc_numeric: 'PEB',
            f_epc_numeric_tooltip: '',
            f_expected_epc: 'PEB attendu au terme des travaux',
            f_expected_epc_tooltip:
                "La consommation \u00e9nerg\u00e9tique du b\u00e2timent s'exprime en kWh/m\u00b2an. Cette information peut se trouver sur le certificat PEB du b\u00e2timent.  Pour les nouvelles constructions, vous pouvez obtenir cette information \u00e0 partir du certificat EPB. Si celui-ci n'est pas donn\u00e9 par votre client au moment de la demande, nous utiliserons le score minimum l\u00e9gal autoris\u00e9 pour les nouvelles constructions dans la r\u00e9gion.",
            f_bedrooms: 'Nombre de chambres',
            f_bedrooms_tooltip:
                'Nombre de pi\u00e8ces pouvant servir comme chambre \u00e0 coucher. Cuisine, salles de bain et salon ne sont pas inclus.',
            f_floor: '\u00c9tage',
            f_floor_tooltip:
                "L'\u00e9tage auquel l'appartement se situe. S'il compte plusieurs \u00e9tages, s\u00e9lectionnez les tous. ",
            f_bottom_floor: "\u00c9tage le plus bas de l'immeuble",
            f_bottom_floor_tooltip:
                "L'\u00e9tage inf\u00e9rieur d'un b\u00e2timent est soit 0 soit un nombre n\u00e9gatif en fonction du nombre d'\u00e9tages souterrains. \nAttribuez la valeur 0 si le b\u00e2timent n'a pas de niveau souterrain. \nAttribuez une valeur n\u00e9gative si le b\u00e2timent poss\u00e8de un sous-sol/un garage souterrain/...",
            f_top_floor: "Dernier \u00e9tage de l'immeuble",
            f_top_floor_tooltip:
                "Le dernier \u00e9tage d'un b\u00e2timent est le dernier \u00e9tage habitable du b\u00e2timent. Parfois cela peut \u00eatre dans le grenier du b\u00e2timent.",
            f_floors: "\u00c9tage(s) de l'appartement",
            f_floors_tooltip:
                "S\u00e9lectionnez le ou les \u00e9tages o\u00f9 se trouve l'appartement dans la liste g\u00e9n\u00e9r\u00e9e.\nPar exemple : pour un duplex se trouvant aux 2\u00e8me et 3\u00e8me \u00e9tage, s\u00e9lectionnez les deux \u00e9tages en question.",
            f_balcony_present: 'Terrasse',
            f_balcony_present_tooltip:
                "Choisissez 'oui' si l'appartement a au moins un espace ext\u00e9rieur sur lequel vous pouvez tenir. Que ce soit une terrasse ou un balcon.",
            f_garage_present: 'Garage',
            f_garage_present_tooltip:
                "L'appartement peut disposer d'un ou plusieurs emplacements de parking. Il peut s'agir aussi bien d'un emplacement simple ou un box, \u00e0 l'interieur ou \u00e0 l'ext\u00e9rieur.",
            f_n_closed_garage: 'Nombre de garages ferm\u00e9s',
            f_n_closed_garage_tooltip:
                "Un garage ferm\u00e9 peut \u00eatre d'int\u00e9rieur ou d'ext\u00e9rieur. Indiquez le nombre de garages ferm\u00e9s appartenant \u00e0 l'appartement \u00e9valu\u00e9.",
            f_n_parking_spot: "Nombre d'emplacements de parking",
            f_n_parking_spot_tooltip:
                'Une place de stationnement est un emplacement ext\u00e9rieur ou int\u00e9rieur d\u00e9limit\u00e9 par des marques de signalisation et non par des murs (par opposition aux garages ferm\u00e9s).\nIndiquez le nombre de places de stationnement li\u00e9es \u00e0 la propri\u00e9t\u00e9.',
            f_cellar_attic: 'Cave et/ou grenier',
            f_cellar_attic_tooltip: '',
            f_garden_access: 'Jardin',
            f_garden_access_tooltip:
                "L'appartement peut donner acc\u00e8s \u00e0 un jardin privatif ou commun.",
            f_garden_common: 'Acc\u00e8s \u00e0 un jardin commun',
            f_garden_common_tooltip:
                "Un jardin commun n'est accessible qu'aux occupants de l'immeuble o\u00f9 le bien est \u00e9valu\u00e9. \nS'il existe un jardin commun, l'appartement \u00e9valu\u00e9 y donne-t-il acc\u00e8s ? Si oui, s\u00e9lectionnez oui.",
            f_garden_private: 'Acc\u00e8s \u00e0 un jardin priv\u00e9',
            f_garden_private_tooltip:
                "Un jardin priv\u00e9 est r\u00e9serv\u00e9 aux occupants de l'appartement \u00e9valu\u00e9 et est adjacent \u00e0 l'appartement. La diff\u00e9rence entre un jardin et une terrasse est qu'un jardin dispose de gazon.",
            f_volume: 'Volume du b\u00e2timent principal',
            f_volume_tooltip: '',
            exterior_wall_area: 'Surface des murs ext\u00e9rieurs',
            exterior_wall_area_tooltip: '',
            f_roof_area: 'Surface du toit',
            f_roof_area_tooltip: '',
            f_mean_tilt: 'Inclinaison moyenne du toit',
            f_mean_tilt_tooltip: '',
            f_percent_of_roof_flat: 'Proportion de toit plat',
            f_percent_of_roof_flat_tooltip: '',
            f_min_height: 'Hauteur minimale du toit',
            f_min_height_tooltip: '',
            f_max_height: 'Hauteur maximale du toit',
            f_max_height_tooltip: '',
            f_n_parts: 'Parties du b\u00e2timent principal',
            f_n_parts_tooltip: '',
            f_n_roof_panes: 'Pans de toit',
            f_n_roof_panes_tooltip: '',
            f_x_matched_entities: 'Entit\u00e9s connues \u00e0 cette adresse',
            f_x_matched_entities_tooltip: '',
            c_economic_activity_class: "Classe d'activit\u00e9 \u00e9conomique",
            c_economic_activity_class_tooltip: '',
            c_economic_activity_level: "Niveau d'activit\u00e9 \u00e9conomique",
            c_economic_activity_level_tooltip: '',
            f_garden_area: 'Surface du jardin',
            f_garden_area_tooltip: '',
            f_flood_risk: "Risque d'inondation",
            f_flood_risk_tooltip: '',
            f_dist_building_flood: 'Zone inondable la plus proche',
            f_dist_building_flood_tooltip: '',
            f_parcel_flood_risk: "Risque d'inondation des parcelles",
            f_parcel_flood_risk_tooltip: '',
            f_dist_parcel_flood: 'Zone inondable la plus proche des parcelles',
            f_dist_parcel_flood_tooltip: '',
            f_flood_risk_insurance_exclusion:
                "Risque d'inondation\n(zone d'exclusion d'assurance)",
            f_flood_risk_insurance_exclusion_tooltip: '',
            f_dist_building_flood_insurance_exclusion:
                "Zone inondable la plus proche\n(zone d'exclusion d'assurance)",
            f_dist_building_flood_insurance_exclusion_tooltip: '',
            f_parcel_flood_risk_insurance_exclusion:
                "Risque d'inondation des parcelles (zone d'exclusion d'assurance)",
            f_parcel_flood_risk_insurance_exclusion_tooltip: '',
            f_dist_parcel_flood_insurance_exclusion:
                "Zone inondable la plus proche des parcelles (zone d'exclusion d'assurance)",
            f_dist_parcel_flood_insurance_exclusion_tooltip: '',
            f_flood_risk_composite: "Risque d'inondation composite",
            f_flood_risk_composite_tooltip: '',
            f_flood_risk_max_parcel:
                "Risque maximal d'inondation de tous les b\u00e2timents de la parcelle",
            f_flood_risk_max_parcel_tooltip: '',
            epc_source: 'Origine du PEB',
            epc_source_tooltip: '',
            level: "Niveau d'information",
            level_tooltip: '',
            f_ground_height_above_sea: 'Altitude (au-dessus du niveau de la mer)',
            f_ground_height_above_sea_tooltip: '',
            no_building_picture: "Pas d'image graphique du b\u00e2timent",
            no_building_picture_tooltip: '',
            no_parcel_picture: "Pas d'image graphique de la parcelle",
            no_parcel_picture_tooltip: '',
            no_garden_technical_drawing: 'Pas de dessin technique du jardin',
            no_garden_technical_drawing_tooltip: '',
            parcel_selection: 'S\u00e9lection de(s) la(les) parcelle(s)',
            parcel_selection_tooltip: '',
            vat: 'TVA',
            vat_tooltip: '',
            property_type: 'Type de bien',
            property_type_tooltip: '',
            insulated_floors: 'Sols isol\u00e9s',
            insulated_floors_tooltip: '',
            insulated_roof: 'Toit isol\u00e9',
            insulated_roof_tooltip: '',
            insulated_walls: 'Murs isol\u00e9s',
            insulated_walls_tooltip: '',
            window_type: 'Vitrage',
            window_type_tooltip: '',
            has_attic: 'Grenier',
            has_attic_tooltip: '',
            floors_insulation_years: "Ann\u00e9e d'isolation des sols",
            floors_insulation_years_tooltip: '',
            roof_insulation_year: "Ann\u00e9e d'isolation du toit ",
            roof_insulation_year_tooltip: '',
            walls_insulation_year: "Ann\u00e9e d'isolation des murs",
            walls_insulation_year_tooltip: '',
            has_basement: 'Cave',
            has_basement_tooltip: '',
            is_attic_heated: 'Grenier chauff\u00e9',
            is_attic_heated_tooltip: '',
            epc_score: 'Score PEB',
            epc_score_tooltip: '',
            heating_fuel: 'Combustible de chauffage',
            heating_fuel_tooltip: '',
            heating_type: 'Type de chauffage',
            heating_type_tooltip: '',
            heating_installation_year: "Ann\u00e9e d'installation du chauffage",
            heating_installation_year_tooltip: '',
            ventilation_type: 'Type de ventilation',
            ventilation_type_tooltip: '',
            solar_boiler: 'Chauffe-eau solaire',
            solar_boiler_tooltip: '',
            solar_panels: 'Panneaux solaires',
            solar_panels_tooltip: '',
            battery: 'Batterie',
            battery_tooltip: '',
            air_conditioner: 'n/a',
            air_conditioner_tooltip: '',
            spa_room: 'n/a',
            spa_room_tooltip: '',
            swimming_pool: 'n/a',
            swimming_pool_tooltip: '',
            electric_vehicle: 'Voiture \u00e9lectrique',
            electric_vehicle_tooltip: '',
            n_residents: "Nombre d'occupants",
            n_residents_tooltip: '',
            protected_consumer: 'n/a',
            protected_consumer_tooltip: '',
            yearly_electricity_consumption:
                "Consommation d'\u00e9lectricit\u00e9 annuelle",
            yearly_electricity_consumption_tooltip: '',
            gas_consumption_approx: 'Consommation annuelle de gaz',
            gas_consumption_approx_tooltip: '',
            insulation_material: 'Materiau isolant',
            insulation_material_tooltip: '',
            heat_pump_type: 'Type de pompe \u00e0 chaleur',
            heat_pump_type_tooltip: '',
            pv_type: 'Type de panneau solaire',
            pv_type_tooltip: '',
        },
        disclaimer: {
            avm_tooltip: '',
            dvm:
                "Ce rapport de valorisation est le r\u00e9sultat d'une valorisation \u00e0 distance du bien par un expert immobilier. L'expert n'a pas visit\u00e9 le bien mais s'est appuy\u00e9 sur diverses sources de donn\u00e9es et un mod\u00e8le statistique pour effectuer une valorisation ind\u00e9pendante du bien. Pour plus d'informations concernant cette approche de valorisation, veuillez vous r\u00e9f\u00e9rer \u00e0 la derni\u00e8re page de ce rapport.",
            dvm_tooltip: '',
            ovm:
                "Ce rapport d'\u00e9valuation est le r\u00e9sultat d'une \u00e9valuation sur place du bien par un expert immobilier. La valorisation ind\u00e9pendante du bien, est bas\u00e9e sur la situation observ\u00e9e sur place par l'expert, et est soustenue par un mod\u00e8le statistique. Pour plus d'informations concernant cette approche d'\u00e9valuation, veuillez vous r\u00e9f\u00e9rer \u00e0 la derni\u00e8re page de ce rapport.",
            ovm_tooltip: '',
            epc_unavailable_1:
                "Je confirme qu'il n'y a pas de certificat PEB, et que cette estimation du PEB concerne ce bien",
            epc_unavailable_1_tooltip: '',
            epc_unavailable_2:
                "Je confirme que l'objectif de cette demande est un refinancement ou une r\u00e9mise en vigueur",
            epc_unavailable_2_tooltip: '',
            part_1:
                "Cette valorisation a \u00e9t\u00e9 r\u00e9alis\u00e9e dans le but exprim\u00e9 ici, aucune responsabilit\u00e9 n'est accept\u00e9e dans le cas o\u00f9 ce rapport serait utilis\u00e9 dans un autre but ou par une autre partie que celle \u00e0 laquelle il est adress\u00e9. Si une autre partie souhaite utiliser ou s'appuyer sur ce rapport \u00e0 quelque fin que ce soit, elle doit d'abord obtenir le consentement \u00e9crit de Rock.estate.\n",
            part_1_tooltip: '',
            part_2:
                "La publication de ce rapport, en tout ou en partie, est interdite sans l'accord \u00e9crit de Rock.estate. Les droits d'auteur de ce rapport restent \u00e0 tout moment la propri\u00e9t\u00e9 de Rock.estate. Ce rapport ne peut \u00eatre c\u00e9d\u00e9 \u00e0 un tiers sans le consentement expr\u00e8s du propri\u00e9taire du droit d'auteur.",
            part_2_tooltip: '',
            reconstruction_value_title: 'Calcul de la valeur de reconstruction',
            reconstruction_value_title_tooltip: '',
            reconstruction_value:
                "La valeur de reconstruction est le co\u00fbt total de reconstruction d'un b\u00e2timent \u00e0 neuf consid\u00e9rant les normes de construction actuelles. Ce calcul inclus la TVA et les frais d'architecte, ne d\u00e9pend pas de l'emplacement, et n'inclus pas les frais de d\u00e9molition ni les b\u00e2timents secondaires. Par cons\u00e9quent, il est possible que la valeur de reconstruction soit plus \u00e9lev\u00e9e que la valeur de march\u00e9. La valeur de reconstruction est bas\u00e9e sur l'indice {index_type} {index_value}{'.'}",
            reconstruction_value_tooltip: '',
            part_3:
                "En faisant ce rapport de valorisation, nous n'exprimons aucune opinion et n'acceptons aucune responsabilit\u00e9 quant \u00e0 la capacit\u00e9 et \u00e0 la volont\u00e9 du d\u00e9biteur hypoth\u00e9caire de respecter ses engagements dans le cadre du pr\u00eat propos\u00e9.",
            part_3_tooltip: '',
        },
        document: {
            purpose_tooltip: '',
            ers_report: 'Rapport ERS',
            ers_report_tooltip: '',
            epc_certificate: 'Certificat PEB | Certificats PEB',
            epc_certificate_tooltip: '',
            exterior_picture:
                "Photo de l'ext\u00e9rieur |\u00a0Photos de l'ext\u00e9rieur",
            exterior_picture_tooltip: '',
            building_blueprint: 'Plan du b\u00e2timent | Plans du b\u00e2timent',
            building_blueprint_tooltip: '',
            specifications: 'Cahier des charges | Cahiers des charges',
            specifications_tooltip: '',
            cadastral_plan: 'Plan cadastral |\u00a0Plans cadastraux',
            cadastral_plan_tooltip: '',
            sales_agreement: 'Compromis de vente',
            sales_agreement_tooltip: '',
            expected_epc: 'PEB attendu',
            expected_epc_tooltip: '',
        },
        common: {
            select_one: 'S\u00e9lectionnez',
            select_one_tooltip: '',
            floor: '\u00c9tage',
            floor_tooltip: '',
            cancel: 'Annuler',
            cancel_tooltip: '',
            new: 'Nouveau',
            new_tooltip: '',
            save: 'Enregistrer',
            save_tooltip: '',
            edit: 'Modifier',
            edit_tooltip: '',
            total: 'Total',
            total_tooltip: '',
            previous: 'Pr\u00e9c\u00e9dent',
            previous_tooltip: '',
            next: 'Suivant',
            next_tooltip: '',
            refresh: 'Rafra\u00eechir',
            refresh_tooltip: '',
            back: 'Retour',
            back_tooltip: '',
            price: 'Prix',
            price_tooltip: '',
            module: 'Module',
            module_tooltip: '',
            uploading: 'T\u00e9l\u00e9chargement',
            uploading_tooltip: '',
            go_to_consumption_next: 'Passer \u00e0 la consommation',
            go_to_consumption_next_tooltip: '',
            lets_get_started: 'Allons-y!',
            lets_get_started_tooltip: '',
            go_to_consumption:
                '<h2>Parfait!</h2> <p>Gr\u00e2ce \u00e0 ces informations, nous pouvons estimer le score EPC et recommander des r\u00e9novations adapt\u00e9es.</p>',
            go_to_consumption_tooltip: '',
            thank_you_so_far:
                "B\u00e2timent trouv\u00e9! Passons \u00e0 d'autres questions pour \u00e9valuer le score \u00e9nerg\u00e9tique.",
            thank_you_so_far_tooltip: '',
            yes: 'Oui',
            yes_tooltip: '',
            no: 'Non',
            no_tooltip: '',
            number_input: 'Indiquez le score \u00e9nerg\u00e9tique ici',
            number_input_tooltip: '',
            multiple_choice: 'S\u00e9lectionnez une des options',
            multiple_choice_tooltip: '',
            we_are_sorry: 'Nous sommes d\u00e9sol\u00e9s',
            we_are_sorry_tooltip: '',
            sorry: 'Oups\u00a0!',
            sorry_tooltip: '',
            enter_address: "Indiquez l'adresse ici ",
            enter_address_tooltip: '',
            back_to_ing: 'Retour au site web ING',
            back_to_ing_tooltip: '',
            maintenance:
                'Ce site web est momentan\u00e9ment en maintenance. Nous esp\u00e9rons vous revoir bient\u00f4t',
            maintenance_tooltip: '',
            send: 'Envoyer',
            send_tooltip: '',
            start_now: 'D\u00e9marrer',
            start_now_tooltip: '',
            i_dont_know: 'Je ne sais pas',
            i_dont_know_tooltip: '',
        },
        info: {
            data_from_customer: 'donn\u00e9es saisies par le client',
            data_from_customer_tooltip: '',
        },
        autocomplete: {
            enter_address: 'Entrez une adresse ici',
            enter_address_tooltip: '',
            address_not_found: "L'adresse n'est pas dans la liste",
            address_not_found_tooltip: '',
            enter_parcel: 'Entrez une r\u00e9f\u00e9rence cadastrale ici',
            enter_parcel_tooltip: '',
            parcel_not_found: "La r\u00e9f\u00e9rence cadastrale n'est pas dans la liste",
            parcel_not_found_tooltip: '',
            enter_dual: 'Entrer une adresse ou r\u00e9f\u00e9rence cadastrale ici',
            enter_dual_tooltip: '',
            dual_not_found:
                "L'adresse ou la r\u00e9f\u00e9rence cadastrale n'est pas dans la liste",
            dual_not_found_tooltip: '',
        },
        dvm_features: {
            style_of_house: 'Style de construction',
            style_of_house_tooltip: '',
            exterior_state: '\u00c9tat ext\u00e9rieur de la propri\u00e9t\u00e9',
            exterior_state_tooltip: '',
            facade_material: 'Mat\u00e9riau des fa\u00e7ades',
            facade_material_tooltip: '',
            roof_material: 'Mat\u00e9riau de toiture',
            roof_material_tooltip: '',
            n_roof_windows: 'Nombre de fen\u00eatres de toit',
            n_roof_windows_tooltip: '',
            n_roof_dormers: 'Nombre de chien-assis',
            n_roof_dormers_tooltip: '',
            solar_panel: 'Panneaux solaires',
            solar_panel_tooltip: '',
            solar_panel_area: 'Nombre de panneaux solaires/photovolta\u00efques.',
            solar_panel_area_tooltip: '',
            f_building_listed: 'Class\u00e9 \u00e0 des fins historiques',
            f_building_listed_tooltip: '',
            garden_orientation: 'Orientation du jardin',
            garden_orientation_tooltip: '',
            garden_arrangement: 'Am\u00e9nagement (possible) du jardin',
            garden_arrangement_tooltip: '',
            garden_common_arrangement: 'Am\u00e9nagement (possible) du jardin commun',
            garden_common_arrangement_tooltip: '',
            f_swimming_pool: 'Piscine ext\u00e9rieure enterr\u00e9e ',
            f_swimming_pool_tooltip: '',
            f_swimming_pool_area: 'Taille de la piscine ext\u00e9rieure',
            f_swimming_pool_area_tooltip: '',
            environment: 'Alentours',
            environment_tooltip: '',
            public_transport: 'Transport public',
            public_transport_tooltip: '',
            education: 'Enseignement',
            education_tooltip: '',
            recreation: 'Loisirs, sports, culture',
            recreation_tooltip: '',
            shops: 'Commerces & services',
            shops_tooltip: '',
            healthcare: 'Soins de sant\u00e9',
            healthcare_tooltip: '',
            direct_traffic_level: 'Niveau de trafic direct sur la voirie',
            direct_traffic_level_tooltip: '',
            indirect_traffic_level: 'Proximit\u00e9 du trafic indirect sur la voirie',
            indirect_traffic_level_tooltip: '',
            surroundings: 'Description des environs',
            surroundings_tooltip: '',
            other_positive: 'Autres \u00e9l\u00e9ments ayant un impact positif',
            other_positive_tooltip: '',
            other_positive_details: 'Commentaire additionnel ',
            other_positive_details_tooltip: '',
            other_negative: 'Autres \u00e9l\u00e9ments ayant un impact n\u00e9gatif',
            other_negative_tooltip: '',
            other_negative_details: 'Commentaire additionnel ',
            other_negative_details_tooltip: '',
            remarks: "Remarques de l'Expert Immobilier",
            remarks_tooltip: '',
            internal_remarks: 'Remarques internes',
            internal_remarks_tooltip: '',
        },
        ovm_features: {
            garages: 'Garages ferm\u00e9s',
            garages_tooltip: '',
            parkings: 'Emplacements de parking',
            parkings_tooltip: '',
            pool_house: 'Pool house',
            pool_house_tooltip: '',
            pool_house_area: 'Surface de la pool house ',
            pool_house_area_tooltip: '',
            barn: 'Grange',
            barn_tooltip: '',
            barn_area: 'Surface de la grange',
            barn_area_tooltip: '',
            stables: 'Ecuries',
            stables_tooltip: '',
            stables_area: 'Surface des \u00e9curies',
            stables_area_tooltip: '',
            common_parts_state: 'Etat g\u00e9n\u00e9ral des communs',
            common_parts_state_tooltip: '',
            interior_state: "Etat g\u00e9n\u00e9ral de l'int\u00e9rieur ",
            interior_state_tooltip: '',
            apartment_quotity: 'Quotit\u00e9s',
            apartment_quotity_tooltip: '',
            reserve_savings: 'Epargne dans le fonds de r\u00e9serve',
            reserve_savings_tooltip: '',
            comfort: 'Confort & \u00e9quipement',
            comfort_tooltip: '',
            common_comfort: 'Confort & \u00e9quipement',
            common_comfort_tooltip: '',
            interior_positive: 'Autres \u00e9l\u00e9ments ayant un impact positif',
            interior_positive_tooltip: '',
            interior_negative: 'Autres \u00e9l\u00e9ments ayant un impact n\u00e9gatif',
            interior_negative_tooltip: '',
        },
        fixed: {
            parcels_and_building_shapes:
                'Forme de la parcelles et du(des) b\u00e2timent(s)',
            parcels_and_building_shapes_tooltip: '',
            parcels_shapes: 'Forme de(s) la(les) parcelle(s)',
            parcels_shapes_tooltip: '',
        },
        '': {
            f_distance_to_street: 'Distance par rapport au milieu de la rue',
            f_distance_to_street_tooltip: '',
        },
        global: {
            comments: 'Commentaires',
            comments_tooltip: '',
            commons: {
                before: 'avant',
                between: 'entre {min} et {max}',
                after: 'apr\u00e8s',
            },
            map: {
                aerial_view: 'Vue a\u00e9rienne',
                cadastral_view: 'Vue cadastrale',
                flood_zone_low: 'Zone de crue r\u00e9guli\u00e8re basse',
                flood_zone_medium: 'Zone de crue r\u00e9guli\u00e8re moyenne',
                flood_zone_high: 'Zone de crue r\u00e9guli\u00e8re \u00e9lev\u00e9e',
                exclusion_flood_zone:
                    "Zones d'exclusion d'assurance contre les inondations",
                swimming_pools: 'Piscines',
                street_name: 'Nom de rue',
            },
            shared: {
                placeholder: {
                    streetname: 'Nom de la rue de votre domicile',
                    streetnumber: 'Num\u00e9ro de maison',
                    postalcode: 'Code postal \u00e0 4 chiffres',
                    municipality: 'Commune',
                    vat: 'Entrez le num\u00e9ro de TVA',
                    'company-name': "Nom de l'entreprise",
                    'contact-email': 'Entrez votre adresse e-mail',
                },
                resend_email: "Renvoyer l'e-mail",
                email_notification: 'E-mail envoy\u00e9 avec succ\u00e8s',
                edit_email: "Modifier l'e-mail",
                streetname: 'Nom de la rue',
                streetnumber: 'Num\u00e9ro de la maison',
                boxnumber: 'Num\u00e9ro de bo\u00eete',
                postalcode: 'Code postal',
                municipality: 'Municipalit\u00e9',
                vat: 'Num\u00e9ro de TVA',
                name: 'Nom',
                email: 'Email',
                company: 'Soci\u00e9t\u00e9 (le cas \u00e9ch\u00e9ant)',
                customer_ref_modal: {
                    title:
                        "Il existe d\u00e9j\u00e0 une demande d'\u00e9valuation avec cette r\u00e9f\u00e9rence interne.",
                    content:
                        'Pour visualiser cette demande d\u00e9j\u00e0 formul\u00e9e, cliquez sur le bouton du Dashboard ci-dessous:',
                    cta: 'Voulez-vous poursuivre avec la r\u00e9f\u00e9rence en doublon?',
                    dashboard: 'Voir dans le Dashboard',
                    continue: 'Continuer',
                },
                january: 'Janvier',
                february: 'Fevrier',
                march: 'Mars',
                april: 'Avril',
                may: 'May',
                june: 'Juin',
                july: 'Juillet',
                august: 'Ao\u00fbt',
                september: 'Septembre',
                october: 'Octobre',
                november: 'Novembre',
                december: 'D\u00e9cembre',
                flanders: 'Flandre',
                wallonia: 'Wallonie',
                brussels: 'Bruxelles',
            },
            action: {
                confirm: 'Je confirme',
            },
            helpcenter: {
                video_tutorials: 'Tutoriels vid\u00e9os',
                faq: 'FAQ',
                question: 'Vous ne trouvez pas ce que vous cherchez?',
                contact_cta: 'Contactez-nous',
                contact_form: {
                    title: "Demander de l'aide",
                    content:
                        'Si vous ne trouvez pas ce que vous cherchez dans la FAQ, nous serons heureux de vous aider. Dites-nous quel est le probl\u00e8me et nous vous r\u00e9pondrons dans les plus brefs d\u00e9lais.',
                    'subject_req-invoice': '',
                    subject_label: 'Sujet',
                    'subject_req-failing': 'Ma demande \u00e9choue constamment',
                    'subject_req-not-eval-yet':
                        "Ma demande n'a pas encore \u00e9t\u00e9 \u00e9valu\u00e9e",
                    'subject_req-back-to-draft':
                        'Ma demande est de retour sous le statut de "\u00c0 completer" mais toutes les informations sont correctes.',
                    'subject_cant-download-val-report':
                        'Je ne peux pas t\u00e9l\u00e9charger le rapport li\u00e9 \u00e0 ma demande.',
                    'subject_req-not-in-dashboard':
                        "Ma demande n'appara\u00eet pas dans mon Dashboard",
                    'subject_cancel-req': 'Je souhaite annuler ma demande',
                    subject_other: 'Autres',
                    other_label: 'Expliquez votre raison',
                    customer_ref: "R\u00e9f\u00e9rence interne de l'emprunt",
                    not_specific_req:
                        "Ce n'est pas au sujet d'une demande sp\u00e9cifique",
                    message: 'Votre question',
                    screenshot_label: "Ajouter des captures d'\u00e9cran",
                    screenshot_info:
                        'Due to security reasons, only files with the following formats can be shared with Rock.estate: .jpg, .jpeg, .png',
                    submit: 'Envoyer',
                    feedback_title: 'Merci de nous avoir contact\u00e9',
                    feedback_content:
                        'Nous vous contacterons sous peu pour trouver une solution \u00e0 votre probl\u00e8me ou r\u00e9pondre \u00e0 votre question.',
                    close: 'Fermer',
                    ing: 'LOP ID',
                },
            },
            errors: {
                no_valuers_in_region:
                    "Il n'y a pas d'\u00e9valuateurs disponibles dans votre r\u00e9gion. Veuillez nous contacter via support@rock.estate pour trouver une solution.",
            },
        },
        section_data: {
            room: {
                type: 'Type de pi\u00e8ce',
                type_tooltip: '',
                living_area: 'Superficie',
                living_area_tooltip: '',
                comment: 'Commentaires',
                comment_tooltip: '',
            },
        },
        footnote: {
            no_renovation_included:
                "Toutes les valeurs sont calcul\u00e9es pour l'\u00e9tat actuel du bien et ne tiennent pas compte des r\u00e9novations pr\u00e9vues.",
            no_renovation_included_tooltip: '',
            avm: 'Valorisation automatique',
            avm_tooltip: '',
            q25: '25\u00e8me percentile',
            q25_tooltip: '',
            q75: '75\u00e8me percentile',
            q75_tooltip: '',
        },
        reference_properties_location: {
            explanation_1:
                "La valorisation de cette propri\u00e9t\u00e9 repose sur {num_references} biens de r\u00e9f\u00e9rence qui ont \u00e9t\u00e9 s\u00e9lectionn\u00e9s dans le voisinage de la propri\u00e9t\u00e9 (dans un rayon de {reference}_radius km). Chaque bien de r\u00e9f\u00e9rence pr\u00e9sente un certain nombre de similitudes avec la propri\u00e9t\u00e9 \u00e9valu\u00e9e en termes d'emplacement, de taille et de plusieurs autres caract\u00e9ristiques. Le mod\u00e8le statistique sous-jacent de cette valorisation est bas\u00e9 sur une r\u00e9gression g\u00e9ographiquement pond\u00e9r\u00e9e (GWR) o\u00f9 les biens de r\u00e9f\u00e9rence situ\u00e9s \u00e0 proximit\u00e9 imm\u00e9diate de la propri\u00e9t\u00e9 re\u00e7oivent une pond\u00e9ration plus importante que les biens de r\u00e9f\u00e9rence situ\u00e9s dans un rayon plus \u00e9loign\u00e9.",
            explanation_1_tooltip: '',
            explanation_2:
                "La carte ci-dessous donne un aper\u00e7u de l'emplacement des biens de r\u00e9f\u00e9rence et de leur distance par rapport \u00e0 la propri\u00e9t\u00e9 \u00e9valu\u00e9e. La l\u00e9gende des couleurs sur la carte donne une indication de la valeur de march\u00e9 moyenne des biens immobiliers dans votre r\u00e9gion.",
            explanation_2_tooltip: '',
        },
        reference_properties_characteristics: {
            explanation_1:
                "Une propri\u00e9t\u00e9 poss\u00e8de diverses caract\u00e9ristiques objectives qui contribuent \u00e0 son prix, telles que l'emplacement, la taille et l'efficacit\u00e9 \u00e9nerg\u00e9tique. Les graphiques ci-dessous comparent certaines caract\u00e9ristiques de cette propri\u00e9t\u00e9 avec d\u2019autres biens plus ou moins proches.",
            explanation_1_tooltip: '',
            property_characteristics: 'Caract\u00e9ristiques de la propri\u00e9t\u00e9',
            property_characteristics_tooltip: '',
            properties_in_the_area: 'Propri\u00e9t\u00e9s dans votre r\u00e9gion',
            properties_in_the_area_tooltip: '',
        },
        flood: {
            explanation_1:
                "Aper\u00e7u des zones d'inondation officielles \u00e0 proximit\u00e9 de la propri\u00e9t\u00e9. Plusieurs cat\u00e9gories de risque d'inondation sont calcul\u00e9es en fonction de diff\u00e9rents sc\u00e9narios de risque d'inondation, allant de faible \u00e0 \u00e9lev\u00e9.",
            explanation_1_tooltip: '',
            check_ground_floor: {
                title: "L'appartement comprend-il le rez-de-chauss\u00e9e ?",
                yes_info: "Le rez-de-chauss\u00e9e fait partie de l'appartement",
                no_info: "Le rez-de-chauss\u00e9e ne fait pas partie de l'appartement",
                tooltip:
                    "Le rez-de-chauss\u00e9e d\u00e9signe l'\u00e9tage du b\u00e2timent situ\u00e9 au niveau de la rue",
            },
            flood_page: {
                title: "Analyse du risque d'inondation",
                download_report:
                    "T\u00e9l\u00e9charger le rapport de risque d'inondation",
                contextual_message_building_risk_high:
                    "Ce b\u00e2timent est expos\u00e9 \u00e0 un risque \u00e9lev\u00e9 d'inondation car il est situ\u00e9 \u00e0 {distance} m\u00e8tre d'une zone d'exclusion d'assurance. En raison du risque \u00e9lev\u00e9 d'inondation, il n'est pas souhaitable d'accorder un pr\u00eat pour ce bien.",
                contextual_message_parcel_risk_high:
                    "Cette parcelle est expos\u00e9e \u00e0 un risque \u00e9lev\u00e9 d'inondation car elle est situ\u00e9e \u00e0 {distance}  m\u00e8tre d'une zone d'exclusion d'assurance. En raison du risque \u00e9lev\u00e9 d'inondation, il n'est pas souhaitable d'accorder un pr\u00eat pour ce bien.",
                contextual_message_risk_none: "Le risque d'inondation est accept\u00e9",
                contextual_message_risk_high_not_ground_floor:
                    "Le risque d'inondation est accept\u00e9 dans la mesure o\u00f9 l'appartement ne comprend pas de rez-de-chauss\u00e9e.",
                open_map: "Ouvrir la carte d'inondation",
                more_information:
                    "Pour des informations plus d\u00e9taill\u00e9es sur les diff\u00e9rents risques ordinaire d'inondations, veuillez vous r\u00e9f\u00e9rer au rapport.",
                proceed_valuation: "Continuer vers l'\u00e9valuation",
            },
            confirm_decision_popup: {
                title: "Exclusion des assurances pour risque d'inondation",
                message:
                    'Le bien est situ\u00e9 dans une zone inondable exclue par les assurances. Il peut \u00eatre soumis \u00e0 des inondations fr\u00e9quentes et/ou graves. Un pr\u00eat pour ce bien peut \u00eatre refus\u00e9.',
                confirmation:
                    "Souhaitez-vous proc\u00e9der \u00e0 l'\u00e9valuation du bien ?",
                yes_proceed: 'Oui, continuer avec une \u00e9valuation',
            },
        },
        faq: {
            q_incorrect_valuation:
                "L'adresse du bien \u00e9valu\u00e9 est incorrecte, que dois-je faire?",
            q_incorrect_valuation_tooltip: '',
            a_incorrect_valuation:
                "Il semble que quelque chose ait d\u00fb mal se passer lors de la s\u00e9lection de l'adresse, du b\u00e2timent ou des parcelles li\u00e9es \u00e0 la propri\u00e9t\u00e9. Vous pouvez revoir les informations sur l'adresse donn\u00e9e via le lien suivant : {url}.dashboard{'.'}",
            a_incorrect_valuation_tooltip: '',
            q_incorrect_characteristics:
                "L'adresse du bien \u00e9valu\u00e9 est correcte, mais certaines des autres caract\u00e9ristiques de ce rapport sont incorrectes, que dois-je faire?",
            q_incorrect_characteristics_tooltip: '',
            a_incorrect_characteristics:
                'Si vous pensez que certaines informations dans ce rapport peuvent diff\u00e9rer substantiellement de la situation r\u00e9elle, ce qui pourrait avoir un impact important sur la valorisation de la propri\u00e9t\u00e9, suivez ce lien {url}.dashboard pour revoir et clarifier les informations incorrectes/manquantes.\u2028',
            a_incorrect_characteristics_tooltip: '',
            q_transaction_vs_market_value:
                "Pourquoi le prix de la transaction que j'ai pay\u00e9 est diff\u00e9rent de la valeur de march\u00e9 d\u00e9termin\u00e9e dans ce rapport?",
            q_transaction_vs_market_value_tooltip: '',
            a_transaction_vs_market_value_dvm:
                "Ce rapport de valorisation est le r\u00e9sultat de l'\u00e9valuation \u00e0 distance du bien en question par un expert immobilier, soutenue par un mod\u00e8le statistique. Le rapport devrait donner une indication pr\u00e9cise de la valeur de march\u00e9 attendue du bien, \u00e0 base des informations disponibles. \u00c9tant donn\u00e9 que l'expert n'a pas r\u00e9ellement visit\u00e9 la propri\u00e9t\u00e9, il peut arriver que l'impact de certaines caract\u00e9ristiques sp\u00e9cifiques \u00e0 ce bien ne soit pas enti\u00e8rement refl\u00e9t\u00e9 dans la valuer de march\u00e9 estim\u00e9e. Veuillez consulter notre page d'information via le lien suivant : {url}.rockestate_info{'.'}",
            a_transaction_vs_market_value_dvm_tooltip: '',
            a_transaction_vs_market_value_ovm:
                "Ce rapport d'\u00e9valuation est le r\u00e9sultat de l'\u00e9valuation \u00e0 distance d'un expert immobilier, soutenue par un mod\u00e8le statistique bas\u00e9 sur des donn\u00e9es. Le rapport doit donner une indication pr\u00e9cise de la valeur attendue du bien, sur la base des informations disponibles. \u00c9tant donn\u00e9 que l'\u00e9valuateur n'a pas r\u00e9ellement visit\u00e9 le bien, il peut arriver que l'impact de certaines caract\u00e9ristiques sp\u00e9cifiques \u00e0 ce bien ne soit pas enti\u00e8rement refl\u00e9t\u00e9 dans le prix de transaction estim\u00e9. Veuillez consulter notre page d'information via le lien suivant : {url}.rockestate_info{'.'}",
            a_transaction_vs_market_value_ovm_tooltip: '',
            q_loan_accepted:
                "Maintenant que j'ai re\u00e7u mon rapport de valorisation, cela signifie-t-il que ma demande de pr\u00eat a \u00e9t\u00e9 accept\u00e9e?",
            q_loan_accepted_tooltip: '',
            a_loan_accepted:
                "Nous avons partag\u00e9 ce rapport de valorisation avec vous et votre banque. Ce rapport de valorisation sera utilis\u00e9 par la banque comme l'un des \u00e9l\u00e9ments de son processus d'approbation du risque de cr\u00e9dit. La d\u00e9cision finale reste la leur. Rock.estate n'intervient en aucune fa\u00e7on dans cette d\u00e9cision.",
            a_loan_accepted_tooltip: '',
            'what-is-avm_tooltip': '',
            'what-is-avm_question': "Qu'est-ce qu'une \u00e9valuation automatique ?",
            'what-is-avm_answer':
                "Une M\u00e9thode d'\u00c9valuation Statistique est toute forme d'outil math\u00e9matique qui peut \u00eatre utilis\u00e9 pour estimer la valeur d'un bien immobilier par le biais de calculs d\u00e9terministes.\n\nRock.estate utilise une impl\u00e9mentation d'un mod\u00e8le d'\u00e9valuation automatis\u00e9 bas\u00e9 sur des comparables (CBAVM ou simplement AVM). Les CBAVM s\u00e9lectionnent des biens comparables r\u00e9cemment r\u00e9pertori\u00e9s pour construire un mod\u00e8le de r\u00e9gression et fournir une estimation pour le bien donn\u00e9. \n\nLes \u00e9valuations automatiques sont par conception automatiques : elles sont r\u00e9alis\u00e9es \u00e0 distance sans aucune intervention humaine.",
            'what-is-dvm_tooltip': '',
            'what-is-dvm_question': "Qu'est-ce qu'une \u00e9valuation \u00e0 distance ? ",
            'what-is-dvm_answer':
                " Une \u00e9valuation \u00e0 distance aussi appell\u00e9e \"Desktop Valuation (DVM)\" est r\u00e9alis\u00e9e par un Expert Immobillier, \u00e0 distance, sans visiter l'int\u00e9rieur du bien. L'Expert s'appuie sur diverses sources de donn\u00e9es, un mod\u00e8le statistique et d'\u00e9ventuelles informations fournies par l'emprunteur.\n\n\nUne \u00e9valuation \u00e0 distance (DVM) r\u00e9ussie combine un mod\u00e8le solide bas\u00e9 sur des donn\u00e9es, supervis\u00e9 par un Expert qui corrige et compl\u00e8te le mod\u00e8le. Il s'agit d'une alternative valable aux \u00e9valuations sur site (On-site Valuations) pour la majeure partie des biens immobiliers r\u00e9sidentiels.",
            'what-is-ovm_tooltip': '',
            'what-is-ovm_question': "Qu'est-ce qu'une \u00e9valuation sur place ?",
            'what-is-ovm_answer':
                "L'\u00e9valuation sur place (On-site) est l'\u00e9valuation traditionnelle au cours de laquelle un Expert visite une propri\u00e9t\u00e9 pour la d\u00e9crire enti\u00e8rement et en estimer la valeur. Cette m\u00e9thode offre la vision la plus compl\u00e8te de la valeur d'un bien. C'est \u00e9galement l'alternative d'\u00e9valuation qui n\u00e9cessite le plus de ressources.",
            'why-ovm_tooltip': '',
            'why-ovm_question':
                'Pourquoi la propri\u00e9t\u00e9 doit-elle \u00eatre \u00e9valu\u00e9e sur place et non \u00e0 distance ?',
            'why-ovm_answer':
                "L'\u00e9valuation \u00e0 distance n'est pas possible dans les cas suivants :\n\n- S'il est d\u00e9cid\u00e9 de ne pas proc\u00e9der \u00e0 une \u00e9valuation \u00e0 distance. Ce choix peut \u00eatre influenc\u00e9 par des facteurs tels que des caract\u00e9ristiques exceptionnelles du bien ou un manque de donn\u00e9es et d'informations ad\u00e9quates.\n\n- Lorsque le bien n'entre pas dans les param\u00e8tres d\u00e9finis par la banque pour les \u00e9valuations \u00e0 distance. Par exemple s'il est trop cher, s'il est class\u00e9 dans la cat\u00e9gorie des biens non r\u00e9sidentiels ou s'il n\u00e9cessite des r\u00e9novations importantes.",
            'what-is-dashboard_tooltip': '',
            'what-is-dashboard_question': "Qu'est-ce que le Dashboard ?",
            'what-is-dashboard_answer':
                "Le Dashboard (Dashboard) est la page de l'application Rock.estate o\u00f9 vous pouvez consulter toutes vos demandes et les m\u00e9ta-donn\u00e9es li\u00e9es telles que la date de cr\u00e9ation ou de modification, le statut actuel, etc. Les utilisateurs ayant le r\u00f4le de r\u00e9viseur peuvent \u00e9galement voir les demandes de leurs coll\u00e8gues. Ceci est utile si la propri\u00e9t\u00e9 d'une demande doit (temporairement) \u00eatre transf\u00e9r\u00e9e, par exemple pendant les vacances.\n\nLe Dashboard vous permet d'effectuer les actions suivantes :\n- Consulter et compl\u00e9ter des demandes imcompl\u00e8tes\n- Examiner les demandes soumises\n- T\u00e9l\u00e9charger des rapports sur les demandes trait\u00e9es (\u00e9valu\u00e9es)\n- S'approprier les demandes d'un coll\u00e8gue (le cas \u00e9ch\u00e9ant).",
            'what-is-draft_tooltip': '',
            'what-is-draft_question':
                'Que se passe-t-il lorsque ma demande a le statut de "\u00e0 compl\u00e9ter" ?',
            'what-is-draft_answer':
                'Deux sc\u00e9narios sont possibles pour une demande ayant le statut "A compl\u00e9ter" :\n\n1. Pour les Simulations de r\u00e9novations \u00e9nerg\u00e9tiques et pour les Demandes d\'\u00c9valuation : Vous attendez des informations manquantes de la part du client pour compl\u00e9ter la demande. Vous avez donc d\u00e9cid\u00e9 de ne pas finaliser la demande et de la sauvegarder sous le statut "A compl\u00e9ter". Lorsque vous disposerez de toutes les informations, vous pourrez compl\u00e9ter et soumettre la demande.\n2. Uniquement pour les Demandes d\'\u00c9valuation : Un Expert a trouv\u00e9 des informations incoh\u00e9rentes qu\'il souhaite mettre en \u00e9vidence. Veuillez v\u00e9rifier les informations et, si n\u00e9cessaire, corrigez les. Une fois que cela est fait, vous pouvez soumettre \u00e0 nouveau la demande.',
            'when-report_tooltip': '',
            'when-report_question':
                "Quand puis-je esp\u00e9rer recevoir le rapport d'\u00e9valuation ?",
            'when-report_answer':
                "Le rapport d'\u00e9valuation est g\u00e9n\u00e9ralement disponible dans les deux jours ouvrables qui suivent l'inspection sur place effectu\u00e9e par notre expert.",
            'how-download-report_tooltip': '',
            'how-download-report_question':
                "Comment puis-je t\u00e9l\u00e9charger le rapport d'\u00e9valuation ?",
            'how-download-report_answer':
                'Vous recevrez une notification par email apr\u00e8s la soumission du rapport par notre expert, cet email contiendra un lien pour t\u00e9l\u00e9charger le rapport.',
            'market-price-incorrect_tooltip': '',
            'market-price-incorrect_question':
                'Le prix du march\u00e9 indiqu\u00e9 dans le rapport est incorrect',
            'market-price-incorrect_answer':
                "Si la valeur de march\u00e9 donn\u00e9e par l'Expert Immobilier ne correspond pas au prix de transaction de la demande de pr\u00eat :\n- Assurez-vous que la propri\u00e9t\u00e9 \u00e9valu\u00e9e est la bonne ;\n- V\u00e9rifiez \u00e0 nouveau l'exactitude de toutes les donn\u00e9es ;\n- Si les donn\u00e9es sont correctes, demandez \u00e0 votre responsable de vous conseiller sur les \u00e9tapes suivantes.\n\nSi, apr\u00e8s examen, vous estimez toujours que l'\u00e9cart est trop important, veuillez nous contacter par le biais de notre formulaire de contact pour obtenir des informations compl\u00e9mentaires.",
            'issue-parcels_tooltip': '',
            'issue-parcels_question':
                'Les parcelles indiqu\u00e9es dans le rapport ne correspondent pas \u00e0 la propri\u00e9t\u00e9',
            'issue-parcels_answer':
                "Si la (les) parcelle(s) s\u00e9lectionn\u00e9e(s) pour l'\u00e9valuation n'est (ne sont) pas correcte(s), cela peut provenir d'une mauvaise s\u00e9lection au cours du processus de saisie des donn\u00e9es. \n\nCliquez sur \"Voir la demande\" \u00e0 c\u00f4t\u00e9 de la demande concern\u00e9e dans votre Dashboard et v\u00e9rifiez la saisie initiale.\n\nSi la saisie est correcte, veuillez nous en informer via notre formulaire de contact, car il s'agit d'une caract\u00e9ristique essentielle ayant un impact sur la valeur du bien.",
            'old-picture-or-3d_tooltip': '',
            'old-picture-or-3d_question':
                "Le bien a consid\u00e9rablement chang\u00e9 par rapport aux photos ou au mod\u00e8le 3D figurant dans le rapport d'\u00e9valuation",
            'old-picture-or-3d_answer':
                'Si les images du rapport ne correspondent pas \u00e0 la r\u00e9alit\u00e9, veuillez nous contacter via notre formulaire de contact.',
            'report-language_tooltip': '',
            'report-language_question':
                'Comment puis-je obtenir le rapport dans une autre langue ?',
            'report-language_answer':
                "Pour une demande d'\u00e9valuation, le rapport d'\u00e9valuation est g\u00e9n\u00e9r\u00e9 dans la langue de la demande. Par exemple, si lors de la cr\u00e9ation de la demande, la langue s\u00e9lectionn\u00e9e dans le coin sup\u00e9rieur droit \u00e9tait l'anglais, le rapport final sera \u00e9galement en anglais. Si vous souhaitez recevoir un rapport dans une autre langue, vous devez soumettre \u00e0 nouveau la demande originale dans la langue correspondante. Veuillez noter que les commentaires de notre Expert Immobilier ne sont pas traduits, car ils sont r\u00e9dig\u00e9s manuellement pendant l'\u00e9valuation.\n\nPour obtenir le rapport dans une autre langue pour une simulation de r\u00e9novations \u00e9nerg\u00e9tiques, s\u00e9lectionnez la langue souhait\u00e9e dans le coin sup\u00e9rieur droit de l'\u00e9cran sur la page du rapport. Vous pouvez maintenant t\u00e9l\u00e9charger le rapport dans la langue appropri\u00e9e.",
            'wrong-pictures_tooltip': '',
            'wrong-pictures_question':
                "La photo figurant sur le rapport d'\u00e9valuation ne correspond pas au b\u00e2timent \u00e9valu\u00e9",
            'wrong-pictures_answer':
                "La vue de la rue sur le rapport est s\u00e9lectionn\u00e9e par Google et parfois ne repr\u00e9sente pas la propri\u00e9t\u00e9 \u00e9valu\u00e9e. Cela ne signifie pas que l'\u00e9valuateur a \u00e9valu\u00e9 la mauvaise propri\u00e9t\u00e9. Si vous avez acc\u00e8s au rapport Web, l'image de la vue des rues est en fait interactive et vous pouvez vous d\u00e9placer dans la rue.",
            sharing_tooltip: '',
            sharing_question: 'Puis-je partager le rapport avec mon client ?',
            sharing_answer:
                'Cela d\u00e9pend du r\u00e8glement interne de votre entreprise. Nous vous recommandons d\'en discuter avec votre direction. Pour partager un rapport avec un client, t\u00e9l\u00e9chargez-le en cliquant sur le bouton vert "Rapport PDF" dans votre Dashboard, \u00e0 c\u00f4t\u00e9 de la demande.\n\nDans le cas des Simulations de r\u00e9novations \u00e9nerg\u00e9tiques, cliquez sur le bouton "Partager" sur la page de la simulation. Cela g\u00e9n\u00e8re un e-mail avec un lien vers les r\u00e9sultats. Vous pouvez envoyer ce lien \u00e0 votre client. Veuillez noter que votre client ne peut pas modifier le donn\u00e9es ni effectuer une autre simulation.',
            'remarks-language_tooltip': '',
            'remarks-language_question':
                "Pourquoi les remarques du rapport d'\u00e9valuation ne changent-elles pas en fonction de la langue du Dashboard si le reste du rapport le fait ?",
            'remarks-language_answer':
                "Lorsqu'un demande d'\u00e9valuation est entr\u00e9e dans une langue sp\u00e9cifique (par exemple, le fran\u00e7ais), la remarque sera r\u00e9dig\u00e9e soit dans la langue s\u00e9lectionn\u00e9e, soit en anglais. Si le demandeur change de langue apr\u00e8s avoir soumis sa demande, la langue des remarques ne sera pas modifi\u00e9e en cons\u00e9quence car ce n'est pas automatis\u00e9. ",
            'appeal-missing-feature_tooltip': '',
            'appeal-missing-feature_question':
                "L'expert immobilier n'a pas tenu compte d'un \u00e9l\u00e9ment (panneaux solaires, parcelle suppl\u00e9mentaire, piscine,...)",
            'appeal-missing-feature_answer':
                "Si l'expert immobilier n'a pas pris en compte un \u00e9l\u00e9ment qui pourrait potentiellement avoir un impact sur la valeur de la propri\u00e9t\u00e9, veuillez nous contacter via notre formulaire de contact pour nous le faire savoir.\nLes \u00e9l\u00e9ments consid\u00e9r\u00e9s comme potentiellement importants sont les suivants :\n- L'adresse\n- Surface du b\u00e2timent\n- Surface de la parcelle\n- Le score PEB\n- Surface habitable\n- Ann\u00e9e de construction\n- Nombre de chambres \u00e0 coucher\n- \u00c9tage(s) de l'appartement\n- Pr\u00e9sence d'un jardin priv\u00e9 ou commun\n- Terrasse\n- Piscine ext\u00e9rieure\n- Panneau(x) solaire(s)\n- Classement historique du bien (fa\u00e7ade ou b\u00e2timent complet)\n- Zones d'inondation\n- B\u00e2timents secondaires\n- Pr\u00e9sence d'un parking ou d'un garage ferm\u00e9\n\n",
            'ING-how-ovm-request_tooltip': '',
            'ING-how-ovm-request_question':
                'Comment puis-je demander une \u00e9valuation sur place ?',
            'ING-how-ovm-request_answer':
                "Actuellement, il n'est pas possible de soumettre directement une demande d'\u00e9valuation sur place. Nous n'effectuons des \u00e9valuations sur place que pour les biens qui peuvent faire l'objet d'une \u00e9valuation \u00e0 distance, mais pour lesquels notre expert d\u00e9cide qu'une \u00e9valuation \u00e0 distance n'est pas possible.\n\nDans ce cas, vous recevrez un email vous demandant les coordonn\u00e9es de l'emprunteur. Ces coordonn\u00e9es sont n\u00e9cessaires pour que nous puissions proc\u00e9der \u00e0 la prise de rendez-vous et au paiement",
            'where-customer-ref_tooltip': '',
            'where-customer-ref_question':
                'O\u00f9 puis-je trouver la r\u00e9f\u00e9rence interne du pr\u00eat ?',
            'where-customer-ref_answer':
                'Cette r\u00e9f\u00e9rence est interne \u00e0 la banque et nous vous sugg\u00e9rons de copier/coller cette r\u00e9f\u00e9rence depuis votre syst\u00e8me de cr\u00e9ation de pr\u00eats.',
            'building-type-apartment-building_tooltip': '',
            'building-type-apartment-building_question':
                'Comment puis-je demander une \u00e9valuation pour un immeuble de rapport ?',
            'building-type-apartment-building_answer':
                "Rock.estate n'\u00e9value pas les immeubles de rapport. Une demande de ce type entra\u00eenera une \u00e9valuation sur place et ne sera pas \u00e9valu\u00e9e.",
            'address-not-found_tooltip': '',
            'address-not-found_question':
                "L'application Rock.estate ne reconna\u00eet pas l'adresse du bien recherch\u00e9",
            'address-not-found_answer':
                " Si le b\u00e2timent s\u00e9lectionn\u00e9 automatiquement n'est pas correct, cliquez sur \"Ce n'est pas le bon b\u00e2timent\" pour s\u00e9lectionner manuellement un autre b\u00e2timent sur la carte. Si le remplissage automatique ne fonctionne pas et/ou l'application ne trouve pas l'adresse, s\u00e9lecionnez l'option \"Je ne trouve pas le b\u00e2timent\" et suivez les instructions.",
            'building-not-found_tooltip': '',
            'building-not-found_question':
                "Le building s\u00e9lectionn\u00e9 automatiquement n'est pas le bon. Que dois-je faire?",
            'building-not-found_answer':
                'Si vous ne trouvez pas le b\u00e2timent, vous pouvez suivre la proc\u00e9dure suivante :\n-Cliquez sur "Ceci pas le bon b\u00e2timent" et la plateforme vous permettra d\'en s\u00e9lectionner un autre.\n-Si vous ne pouvez toujours pas le s\u00e9lectionner/le trouver, cliquez sur "Je ne trouve pas le b\u00e2timent principal" et vous serez redirig\u00e9 vers une nouvelle page. Sur cette page, vous devrez fournir des informations suppl\u00e9mentaires telles que la taille de la parcelle, la taille du b\u00e2timent et le nombre de c\u00f4t\u00e9s qui se touchent. \n\n',
            'find-epc_tooltip': '',
            'find-epc_question':
                "O\u00f9 puis-je trouver le PEB d'une propri\u00e9t\u00e9 ?",
            'find-epc_answer':
                "Un certificat PEB valide est un document obligatoire lors de la vente d'un bien immobilier. Si le client ne dispose pas de cette information, vous pouvez consulter l'annonce de vente ou la base de donn\u00e9es en ligne en [Flandre](https://apps.energiesparen.be/zoek-een-epc) ou \u00e0 [Bruxelles](https://www.peb-epb.brussels/certificats-certificaten/). Notez qu'un score PEB n'est pas obligatoire pour faire une simulation de r\u00e9novations \u00e9nerg\u00e9tiques.",
            'epc-label-vs-number_tooltip': '',
            'epc-label-vs-number_question':
                "PEB : Est-il pr\u00e9f\u00e9rable de donner le label (lettre de A \u00e0 G) ou de donner l'exacte kWh/m\u00b2 ?",
            'epc-label-vs-number_answer':
                "L'\u00e9valuation d\u00e9pend fortement de l'emplacement, de la parcelle, de la surface habitable, de l'ann\u00e9e de construction et du score PEB. C'est pourquoi nous vous recommandons de saisir la demande avec le score PEB exact en kWh/m\u00b2/an. \nSi vous ne disposez que de la lettre du label de A \u00e0 G, nous \u00e9valuerons le bien en prenant le score moyen de chaque label, ce qui donnera une \u00e9valuation approximative de la valeur marchande du bien.",
            'find-living-area_tooltip': '',
            'find-living-area_question':
                "O\u00f9 puis-je trouver la surface habitable exacte d'une propri\u00e9t\u00e9 ?",
            'find-living-area_answer':
                "Vous pouvez trouver la surface habitable dans plusieurs documents li\u00e9s \u00e0 la propri\u00e9t\u00e9 comme, par exemple, le contrat de vente ou le certificat PEB. Veuillez noter que tout b\u00e2timent secondaire, sous-sol ou grenier non utilis\u00e9 n'est pas consid\u00e9r\u00e9 comme un espace habitable et donc comme une surface habitable. ",
            'find-box-number_tooltip': '',
            'find-box-number_question':
                "O\u00f9 puis-je trouver le num\u00e9ro de bo\u00eete aux lettres d'un appartement ?",
            'find-box-number_answer':
                "Le num\u00e9ro de bo\u00eete d'un appartement fait partie de l'adresse qui doit \u00eatre compl\u00e9t\u00e9e sur le contrat de vente ou le certificat PEB. Si vous n'\u00eates pas s\u00fbr de cette information, veuillez contacter l'emprunteur et compl\u00e9ter la demande une fois que vous aurez les informations. ",
            'find-construction-year_tooltip': '',
            'find-construction-year_question':
                "O\u00f9 puis-je trouver l'ann\u00e9e de construction ?",
            'find-construction-year_answer':
                "Vous trouverez g\u00e9n\u00e9ralement l'ann\u00e9e officielle de construction dans l'annonce de vente, le registre cadastral ou dans le certificat PEB. L'ann\u00e9e de construction se r\u00e9f\u00e8re \u00e0 l'ann\u00e9e de construction effective du b\u00e2timent et non \u00e0 l'ann\u00e9e des r\u00e9novations ult\u00e9rieures.",
            'construction-vs-renovation_tooltip': '',
            'construction-vs-renovation_question':
                "La propri\u00e9t\u00e9 a \u00e9t\u00e9 enti\u00e8rement r\u00e9nov\u00e9e: quelle doit \u00eatre l'ann\u00e9e de construction, est-ce l'ann\u00e9e d'origine ou la date de la r\u00e9novation ?",
            'construction-vs-renovation_answer':
                "Inscrivez comme ann\u00e9e de construction l'ann\u00e9e de la construction effective du b\u00e2timent, et non l'ann\u00e9e des r\u00e9novations ou des transformations. Nous prenons compte des r\u00e9novations en analysant le certificat PEB et d'autres informations.",
            'over-two-days_tooltip': '',
            'over-two-days_question':
                "Cela fait plus de 2 jours ouvrables et ma demande n'est toujours pas valoris\u00e9e, que dois-je faire ?",
            'over-two-days_answer':
                "Les jours ouvrables de Rock.estate vont du lundi au vendredi. \nIl se peut que vous ayez compt\u00e9 un samedi ou un jour f\u00e9ri\u00e9 dans les deux jours ouvrables auxquels vous faites r\u00e9f\u00e9rence. \n\nSi ce n'est pas le cas, contactez-nous via notre formulaire de contact en indiquant le num\u00e9ro de r\u00e9f\u00e9rence.",
            'right-info-flagged-incorrect_tooltip': '',
            'right-info-flagged-incorrect_question':
                "Que se passe-t-il si l'expert signale une information saisie dans la demande comme \"incorrecte\" alors que je sais qu'il s'agit de la bonne information ?",
            'incoherent-submitted-twice_tooltip': '',
            'incoherent-submitted-twice_question':
                'Que se passe-t-il lorsqu\'une \u00e9valuation est renvoy\u00e9e deux fois avec des informations dites "incorrectes" ?',
            'processing-time_tooltip': '',
            'processing-time_question':
                "Combien de temps faut-il pour qu'une demande soit trait\u00e9e ?",
            'multiple-addresses_tooltip': '',
            'multiple-addresses_question':
                "Est-il normal qu'il y ait plus d'une adresse pour un m\u00eame b\u00e2timent ?",
            'what-is-bedroom_tooltip': '',
            'what-is-bedroom_question': "Qu'est-ce qu'une chambre ?",
            'what-is-garden_tooltip': '',
            'what-is-garden_question': "Qu'est-ce qu'un jardin commun ?",
            'what-is-private-garden_tooltip': '',
            'what-is-private-garden_question':
                "Qu'est-ce qui est consid\u00e9r\u00e9 comme un jardin priv\u00e9 ?",
            'what-is-closed-garage_tooltip': '',
            'what-is-closed-garage_question': "Qu'est-ce qu'un garage ferm\u00e9 ?",
            'what-is-parking-spot_tooltip': '',
            'what-is-parking-spot_question': "Qu'est-ce qu'une place de parking ?",
            'what-is-cellar-basement_tooltip': '',
            'what-is-cellar-basement_question': "Qu'est-ce qu'une cave/sous-sol ?",
            carport_tooltip: '',
            carport_question:
                'Un carport d\u00e9signe-t-il une place de stationnement ou un garage ?',
            carport_answer:
                'Un carport d\u00e9signe une place de stationnement et non un garage ferm\u00e9. ',
            'personal-use_tooltip': '',
            'personal-use_question':
                'Puis-je demander une \u00e9valuation de mon propre bien ?',
            'personal-use_answer':
                "La plateforme d'\u00e9valuation Rock.estate ne peut \u00eatre utilis\u00e9e qu'\u00e0 des fins professionnelles.\nIl est de la responsabilit\u00e9 de chaque utilisateur autoris\u00e9 de s'y conformer. Par cons\u00e9quent, nous ne vous recommandons pas de demander une \u00e9valuation de votre propre propri\u00e9t\u00e9 ou de celle d'une personne que vous connaissez.",
            'is-request-submitted_tooltip': '',
            'is-request-submitted_question':
                "Comment puis-je savoir si j'ai soumis ma demande avec succ\u00e8s ?",
            'is-request-submitted_answer':
                "Une fois que vous avez soumis/envoy\u00e9 votre demande avec succ\u00e8s, le statut de la demande dans votre Dashboard devrait passer \u00e0 'Envoy\u00e9'. \nVous recevrez \u00e9galement un email vous informant que la demande a \u00e9t\u00e9 envoy\u00e9e et qu'un de nos sp\u00e9cialistes la traitera dans les deux jours ouvrables.",
            review_tooltip: '',
            review_question:
                'La demande que j\'ai soumise est revenue comme une demande "\u00e0 completer" en rouge, que dois-je faire ?',
            review_answer:
                'Si vous avez re\u00e7u une demande dont le statut est "\u00c0 compl\u00e9ter", cela signifie que l\'\u00e9valuateur a signal\u00e9 une ou plusieurs informations comme \u00e9tant "incorrectes". Si vous savez que cette ou ces informations sont effectivement correctes, vous pouvez soit d\u00e9cider de soumettre \u00e0 nouveau la demande telle quelle, soit nous contacter via notre formulaire de contact. ',
            'find-previous-request_tooltip': '',
            'find-previous-request_question':
                'Comment puis-je retrouver une demande ant\u00e9rieure ?',
            'find-previous-request_answer':
                "Pour retrouver une demande ant\u00e9rieure, allez dans votre Dashboard et utilisez la barre d'outils de recherche. Vous pouvez entrer une date, une r\u00e9f\u00e9rence, une r\u00e9f\u00e9rence interne, une adresse, ...",
            'download-report_tooltip': '',
            'download-report_question':
                'Comment puis-je t\u00e9l\u00e9charger le rapport ?',
            'download-report_answer':
                "Pour t\u00e9l\u00e9charger le rapport, vous pouvez cliquer sur la case verte situ\u00e9e \u00e0 c\u00f4t\u00e9 de votre demande et intitul\u00e9e 'Rapport PDF'.  \nIl ne sera disponible qu'une fois que votre demande aura \u00e9t\u00e9 \u00e9valu\u00e9e avec succ\u00e8s par l'\u00e9quipe d'\u00e9valuation de Rock.estate.",
            'language-impact_tooltip': '',
            'language-impact_question':
                "Le fait d'utiliser l'application d'\u00e9valuation Rock.estate dans une autre langue change-t-il quelque chose au processus ?",
            'language-impact_answer':
                "Si vous demandez une \u00e9valuation dans une langue, vous recevrez un rapport sur ce bien dans la m\u00eame langue. Vous pouvez changer la langue du rapport mais la remarque restera dans la langue d'origine.\nIl n'y aura aucun impact sur les donn\u00e9es ou la valeur marchande d'un bien.",
            'unsubmission-window_tooltip': '',
            'unsubmission-window_question':
                "Comment puis-je modifier une demande apr\u00e8s l'avoir soumise ?",
            'unsubmission-window_answer':
                'Pour modifier une demande apr\u00e8s l\'avoir soumise, acc\u00e9dez \u00e0 votre Dashboard et cliquez sur "Modifier". Pour les demandes d\'\u00e9valuation, vous disposez de 60 minutes pour les modifier ou les supprimer apr\u00e8s leur soumission. Pour les simulations de r\u00e9novations \u00e9nerg\u00e9tiques, cliquez sur "Modifier" en haut \u00e0 droite de la page de r\u00e9sultats. Une fois la modification effectu\u00e9e, n\'oubliez pas de cliquer sur "Soumettre" pour enregistrer vos modifications.',
            'after-sixty-minutes_tooltip': '',
            'after-sixty-minutes_question':
                'Comment puis-je modifier une demande soumise si les 60 minutes sont d\u00e9pass\u00e9es ?',
            'after-sixty-minutes_answer':
                "Si vous souhaitez modifier ou annuler une demande apr\u00e8s 60 minutes, faites-le nous savoir d\u00e8s que possible via notre formulaire de contact. Cette demande pourrait \u00eatre factur\u00e9e en fonction de la progression de l'\u00e9valuateur.",
            'review-billing_tooltip': '',
            'review-billing_question':
                'Ma demande est revenue sous forme de brouillon, cela signifie-t-il que la banque devra payer deux fois pour cette demande ?',
            'review-billing_answer':
                "Non, la banque ne sera factur\u00e9e qu'une seule fois apr\u00e8s que la demande ait \u00e9t\u00e9 \u00e9valu\u00e9e avec succ\u00e8s ou qu'une \u00e9valuation sur place ait \u00e9t\u00e9 recommand\u00e9e. \nSi, apr\u00e8s deux analyses de l'\u00e9quipe d'\u00e9valuation de Rock.estate, la demande ne peut \u00eatre \u00e9valu\u00e9e \u00e0 distance avec succ\u00e8s, une recommandation pour une \u00e9valuation sur place sera effectu\u00e9e.",
            'access-requests_tooltip': '',
            'access-requests_question':
                'Comment puis-je avoir acc\u00e8s aux demandes de mes coll\u00e8gues ?',
            substitution_tooltip: '',
            substitution_question:
                "Comment puis-je m'approprier une demande qui n'est pas la mienne ?",
            'what-is-ers_tooltip': '',
            'what-is-ers_question':
                "Qu'est ce qu'une simulation de r\u00e9novations \u00e9nerg\u00e9tiques?",
            'what-is-ers_answer':
                "Le Simulateur de r\u00e9novation \u00e9nerg\u00e9tique de Rock.estate est un outil puissant qui \u00e9value le score PEB d'une propri\u00e9t\u00e9 et propose des sc\u00e9narios de r\u00e9novation pertinents en fonction de ses caract\u00e9ristiques \u00e9nerg\u00e9tiques. En seulement quelques minutes, les utilisateurs peuvent explorer quelles r\u00e9novations correspondent le mieux \u00e0 leurs objectifs personnels et aux sp\u00e9cificit\u00e9s de leur maison.\n\nApr\u00e8s avoir rempli un simple questionnaire, le simulateur calcule quelles am\u00e9liorations \u00e9nerg\u00e9tiques contribueraient \u00e0 atteindre un score PEB cible, tout en optimisant le retour sur investissement. Cette estimation repose sur les r\u00e9ponses fournies par l'utilisateur, combin\u00e9es aux donn\u00e9es du b\u00e2timent et aux exigences techniques propre \u00e0 la Belgique. Un remplissage minutieux du questionnaire am\u00e9liore la pr\u00e9cision de l'estimation du score PEB.\n\nIl est important de noter que les r\u00e9sultats sont indicatifs. Ils ne remplacent pas un certificat PEB officiel, ni ne fournissent des recommandations de r\u00e9novation d\u00e9finitives. Consultez toujours un professionnel pour obtenir des conseils personnalis\u00e9s.",
            'what-is-common-wall_tooltip': '',
            'what-is-common-wall_question': "Qu'est-ce qu'un mur mitoyen ?",
            'what-is-common-wall_answer':
                "Un mur partag\u00e9, \u00e9galement appel\u00e9 mur mitoyen, se trouve entre deux propri\u00e9t\u00e9s voisines. Il agit comme une barri\u00e8re de s\u00e9paration appartenant aux deux propri\u00e9t\u00e9s qui s\u00e9pare et relie deux b\u00e2timents interconnect\u00e9s. Ces murs sont g\u00e9n\u00e9ralement isol\u00e9s et n'ont pas besoin d'isolation suppl\u00e9mentaire. \u00c0 l'int\u00e9rieur d'une maison, il peut y avoir plusieurs murs mitoyens, chacun \u00e9tant partag\u00e9 avec une ou plusieurs maisons voisines.",
            'what-is-protected-volume_tooltip': '',
            'what-is-protected-volume_question':
                "Qu'est-ce que le volume prot\u00e9g\u00e9 ?",
            'what-is-protected-volume_answer':
                "Un volume prot\u00e9g\u00e9 correspond \u00e0 l'espace int\u00e9rieur de votre maison que vous souhaitez prot\u00e9ger contre les pertes de chaleur. Cela inclut les pi\u00e8ces chauff\u00e9es ainsi que parfois les greniers et les sous-sols. L'objectif est de maintenir une temp\u00e9rature constante \u00e0 l'int\u00e9rieur.",
            'what-is-living-area_tooltip': '',
            'what-is-living-area_question':
                "Qu'est-ce que la surface habitable chauff\u00e9e ?",
            'what-is-living-area_answer':
                'La surface habitable chauff\u00e9e correspond \u00e0 la superficie totale du plancher qui fait partie du volume chauff\u00e9. En g\u00e9n\u00e9ral, le sous-sol est exclu de cette surface. Si la pi\u00e8ce du grenier est chauff\u00e9e, incluez \u00e9galement son espace dans le calcul. Vous pouvez retrouver la superficie utilisable sur le certificat PEB.',
            'apartment-ers_tooltip': '',
            'apartment-ers_question':
                'Comment puis-je demander une Simulation de r\u00e9novations \u00e9nerg\u00e9tiques pour un appartement ou un immeuble \u00e0 appartements ?',
            'apartment-ers_answer':
                "\u00c0 l'heure actuelle, le Simulateur de R\u00e9novation \u00c9nerg\u00e9tique n'est pas disponible pour les\nappartements r\u00e9sidentiels ou les immeubles d'appartements. Notre \u00e9quipe travaille activement \u00e0 \u00e9largir la port\u00e9e du simulateur pour inclure ces types de propri\u00e9t\u00e9s \u00e0 l'avenir. Nous vous remercions de votre compr\u00e9hension et de votre patience pendant que nous nous effor\u00e7ons d'am\u00e9liorer les fonctionnalit\u00e9s de notre service.",
            'no-3d-model-ers-quality_tooltip': '',
            'no-3d-model-ers-quality_question':
                "Le mod\u00e8le 3D n'a pas pu \u00eatre trouv\u00e9. Les r\u00e9sultats sont-ils pertinents?",
            'no-3d-model-ers-quality_answer':
                "Lorsque nous manquons de donn\u00e9es suffisantes pour un mod\u00e8le 3D, nous demandons des d\u00e9tails suppl\u00e9mentaires \u00e0 l'utilisateur pour estimer les dimensions du b\u00e2timent. Notre approche garantit une estimation pr\u00e9cise des caract\u00e9ristiques du monde r\u00e9el d'une maison construite de mani\u00e8re traditionnelle. Par cons\u00e9quent, la pr\u00e9cision de l'approximation est plus \u00e9lev\u00e9e pour les r\u00e9sidences conformes aux normes de construction conventionnelles, et lorsque les informations fournies par l'utilisateur sont correctes, notamment pour des \u00e9l\u00e9ments essentiels comme la superficie habitable chauff\u00e9e. \u00c0 l'inverse, une d\u00e9viation par rapport aux normes conventionnelles peut affecter la pr\u00e9cision des r\u00e9sultats.",
            'what-is-renovation-goal_tooltip': '',
            'what-is-renovation-goal_question':
                "Je dois s\u00e9lectionner un objectif de r\u00e9novation. Qu'est-ce que cela signifie?",
            'what-is-renovation-goal_answer':
                "Les propri\u00e9taires ont diverses motivations pour entreprendre des r\u00e9novations \u00e9nerg\u00e9tiques, telles que des pr\u00e9occupations environnementales, la r\u00e9duction des co\u00fbts \u00e9nerg\u00e9tiques, l'am\u00e9lioration du confort ou l'augmentation de la valeur de leur bien immobilier. Quel que soit le motif de la r\u00e9novation, il peut g\u00e9n\u00e9ralement se traduire en un objectif PEB, un budget ou une s\u00e9lection d'\u00e9l\u00e9ments de r\u00e9novation.\n\nEn fonction de l'objectif de r\u00e9novation du client, la plateforme propose le sc\u00e9nario de r\u00e9novation le plus efficace pour atteindre ses objectifs. Voici les diff\u00e9rentes options pr\u00e9sent\u00e9es par notre plateforme :\n\n- Objectif PEB : Si vous visez un score PEB particulier, cette option est id\u00e9ale. Elle vous propose le package de r\u00e9novation le plus rentable pour atteindre votre objectif de score PEB.\n- Budget : Indiquez-nous votre budget, et nous vous recommanderons le package offrant le score PEB le plus bas apr\u00e8s r\u00e9novation qui correspond \u00e0 votre capacit\u00e9 financi\u00e8re. Vous obtenez ainsi le meilleur rapport qualit\u00e9-prix.\n- Personnalisez : Si vous avez des contraintes sp\u00e9cifiques, cr\u00e9ez votre propre package en s\u00e9lectionnant les r\u00e9novations de votre choix. Avec Personnalisez, vous avez la flexibilit\u00e9 de cr\u00e9er un package de r\u00e9novation sur mesure.",
            'missing-renovation-option_tooltip': '',
            'missing-renovation-option_question':
                'Je ne trouve pas toutes les options de r\u00e9novation (ex: l\u2019isolation int\u00e9rieure des murs ou du plafond, etc.). Pourquoi est-ce le cas?',
            'missing-renovation-option_answer':
                "Certaines r\u00e9novations n\u00e9cessitent l\u2019intervention d\u2019un professionnel. Par exemple, pour l'isolation int\u00e9rieure des murs ou l'isolation du plafond, il existe un risque de ponts thermiques ou de condensation si ces travaux ne sont pas correctement \u00e9valu\u00e9s sur le plan technique. En revanche, l'isolation des planchers situ\u00e9s dans les niveaux interm\u00e9diaires n'est pas toujours le choix le plus rentable. Afin d'\u00e9viter dans la mesure du possible de fournir des conseils inexacts via notre simulateur, nous avons choisi de ne pas pr\u00e9senter aujourd'hui toutes les options de r\u00e9novation possibles. Si un professionnel recommande toujours certaines r\u00e9novations, le budget dans le simulateur pourrait \u00eatre surestim\u00e9. Nous s\u00e9lectionnons des r\u00e9novations qui conviennent \u00e0 la plupart des habitations et qui ont le plus grand impact positif sur une propri\u00e9t\u00e9. Si nous constatons une demande pour d'autres options, nous pourrons \u00e9largir le nombre d'options de r\u00e9novation propos\u00e9es.",
            'choosing-insulation-material_tooltip': '',
            'choosing-insulation-material_question':
                "Ai-je la possibilit\u00e9 de choisir le mat\u00e9riau d'isolation pour chaque r\u00e9novation?",
            'choosing-insulation-material_answer':
                "Actuellement, il n'est pas possible de s\u00e9lectionner des mat\u00e9riaux d'isolation sp\u00e9cifiques pour chaque r\u00e9novation. Cependant, il est essentiel de pr\u00e9ciser que nous choisissons avec soin des mat\u00e9riaux couramment utilis\u00e9s pour chaque type d'isolation. Nous envisageons d'ajouter cette fonctionnalit\u00e9 \u00e0 l'avenir, car nous comprenons l'importance de r\u00e9pondre \u00e0 des besoins uniques et nous souhaitons vous offrir la meilleure flexibilit\u00e9 possible.",
            'own-property-ers_tooltip': '',
            'own-property-ers_question':
                'Puis-je soumettre une Simulation de r\u00e9novations \u00e9nerg\u00e9tiques pour ma propre propri\u00e9t\u00e9?',
            'own-property-ers_answer':
                "La plateforme de Rock.estate est destin\u00e9e exclusivement \u00e0 un usage professionnel. Il incombe \u00e0 chaque utilisateur autoris\u00e9 de respecter cette restriction. Par cons\u00e9quent, nous vous recommandons de ne pas soumettre une simulation pour votre propre propri\u00e9t\u00e9 ou pour celle de quelqu'un que vous connaissez. Veuillez garder \u00e0 l'esprit qu'il est essentiel de respecter l'usage pr\u00e9vu du service.",
            'estimated-epc-different-than-actual-epc_tooltip': '',
            'estimated-epc-different-than-actual-epc_question':
                'Le score PEB estim\u00e9 diff\u00e8re du score PEB officiel.',
            'estimated-epc-different-than-actual-epc_answer':
                "Il existe plusieurs raisons pour lesquelles le score PEB estim\u00e9 peut varier :\n\n- Veuillez vous assurer que la propri\u00e9t\u00e9 \u00e9valu\u00e9e est la bonne et que les informations fournies sont exactes.\n- Un certificat PEB est valable pendant 10 ans. Certaines r\u00e9novations, comme l'ajout d'isolation de toit ou la mise \u00e0 niveau du syst\u00e8me de chauffage, peuvent avoir un impact sur l'efficacit\u00e9 \u00e9nerg\u00e9tique d'une maison et sur le score PEB. Si ces r\u00e9novations ont \u00e9t\u00e9 effectu\u00e9es apr\u00e8s la d\u00e9livrance du certificat, le document devient obsol\u00e8te.\n- Le simulateur PEB part du principe qu'il y a un seul syst\u00e8me de chauffage pour l'ensemble du volume prot\u00e9g\u00e9 et que les vitrages sont uniformes avec des fen\u00eatres standard. L'utilisation de plusieurs syst\u00e8mes de chauffage et les variations dans les valeurs d'isolation des vitrages peuvent influencer le score PEB r\u00e9el. De plus, le simulateur suppose que l'isolation est uniforme sur tous les murs ext\u00e9rieurs. Cependant, si certains murs sont isol\u00e9s et d'autres ne le sont pas, cela peut affecter le score PEB.\n- Lorsqu'un mod\u00e8le 3D n'est pas disponible, nous nous appuyons sur des questions suppl\u00e9mentaires pour estimer les dimensions avec pr\u00e9cision. Les variations dues \u00e0 la forme r\u00e9elle de la maison, comme la hauteur des plafonds et l'orientation du toit, peuvent influencer les surfaces et le volume. Cet effet est plus prononc\u00e9 lorsque les empreintes du b\u00e2timent sont absentes. Les mises \u00e0 jour du b\u00e2timent peuvent \u00e9galement avoir un impact sur les surfaces et le volume et rendre le mod\u00e8le 3D obsol\u00e8te, ce qui affecte le score PEB.\n- Si les mat\u00e9riaux d'isolation utilis\u00e9s pendant la construction ou la r\u00e9novation d\u00e9passaient les normes de l'industrie \u00e0 l'\u00e9poque de l'installation, le score PEB r\u00e9el pourrait d\u00e9passer le score estim\u00e9.",
            'how-is-vat-computed_tooltip': '',
            'how-is-vat-computed_question': 'Comment la TVA est-elle calcul\u00e9e?',
            'how-is-vat-computed_answer':
                "Conform\u00e9ment \u00e0 la l\u00e9gislation f\u00e9d\u00e9rale en mati\u00e8re de taxation, une TVA de 6 % s'applique aux r\u00e9novations \u00e9nerg\u00e9tiques pour les maisons de plus de 10 ans, sinon une TVA de 21 % s'applique. Pour avoir droit \u00e0 la TVA \u00e0 6 %, un entrepreneur doit effectuer les travaux. Pour les panneaux solaires et les pompes \u00e0 chaleur, les maisons de moins de 10 ans ont \u00e9galement droit \u00e0 une TVA de 6 % jusqu'\u00e0 la fin de 2023.",
            'price-ers-includes_tooltip': '',
            'price-ers-includes_question':
                "Qu'est-ce qui est inclus dans le prix d'une r\u00e9novation?",
            'price-ers-includes_answer':
                "Les prix comprennent la TVA, les mat\u00e9riaux d'isolation et les travaux.\n\nPlus pr\u00e9cis\u00e9ment,\n- L'isolation ext\u00e9rieure du toit comprend la d\u00e9molition de la couverture et de la structure du toit, la d\u00e9molition des goutti\u00e8res, l'installation de l'isolation et d'une barri\u00e8re anti-vapeur, la pose de la structure et de la couverture du toit, le travail autour des \u00e9vents du toit, la pose des goutti\u00e8res, le retrait et la r\u00e9installation des panneaux solaires s'ils sont d\u00e9j\u00e0 pr\u00e9sents, ainsi qu'une grue ou un treuil si n\u00e9cessaire.\n- L'isolation int\u00e9rieure du toit comprend le retrait de la couche d'isolation d\u00e9grad\u00e9e (y compris la barri\u00e8re anti-vapeur), l'installation d'une nouvelle couche d'isolation et d'une barri\u00e8re anti-vapeur, ainsi que des ajustements autour du plan du toit et des fen\u00eatres de lucarne.\n- L'isolation du plancher du grenier comprend l'installation d'isolation et d'une barri\u00e8re anti-vapeur, des modifications des tuyaux et de l'\u00e9clairage existants, ainsi qu'un ajustement de l'acc\u00e8s.\n- L'isolation ext\u00e9rieure des murs comprend la d\u00e9molition du drainage des eaux pluviales, la d\u00e9coupe des appuis de fen\u00eatre, l'installation de l'isolation, la pose de finitions (en cr\u00e9pi), la mise \u00e0 jour des ouvertures (y compris les appuis), la r\u00e9alisation d'\u00e9dits, l'agrandissement de la saillie du toit, le renouvellement du drainage des eaux pluviales, ainsi que l'\u00e9chafaudage.\n- L'isolation de la cavit\u00e9 murale comprend l'utilisation d'une plate-forme \u00e9l\u00e9vatrice, l'installation d'isolation en laine min\u00e9rale de 5 cm, y compris l'inspection, la pr\u00e9paration, le soufflage et la fermeture des ouvertures.\n- Les fen\u00eatres comprennent la d\u00e9molition et l'installation de vitres (avec suppl\u00e9ment pour le mat\u00e9riel de levage), la d\u00e9molition et l'installation du ch\u00e2ssis, la pose de RTO sur les vitres, ainsi que la d\u00e9molition et l'installation du vitrage.\n- La pompe \u00e0 chaleur comprend la d\u00e9molition du g\u00e9n\u00e9rateur existant, l'installation d'une pompe \u00e0 chaleur (avec forage pour l'eau souterraine), sa connexion au g\u00e9n\u00e9rateur existant et l'isolation des tuyaux non isol\u00e9s. Des co\u00fbts suppl\u00e9mentaires s'appliqueront pour le remplacement du syst\u00e8me de climatisation.\n- La chaudi\u00e8re \u00e0 gaz \u00e0 condensation comprend la suppression du g\u00e9n\u00e9rateur existant, l'installation d'une chaudi\u00e8re \u00e0 gaz \u00e0 condensation, des co\u00fbt lin\u00e9aires de la chaudi\u00e8re \u00e0 gaz en fonction de sa capacit\u00e9, la connexion au g\u00e9n\u00e9rateur existant, des co\u00fbts suppl\u00e9mentaires pour le remplacement du syst\u00e8me de distribution, ainsi que l'isolation des tuyaux non isol\u00e9s.\n- Les panneaux solaires comprennent l'installation de panneaux solaires avec tous les accessoires n\u00e9cessaires.\n",
            'incorrect-region_tooltip': '',
            'incorrect-region_question': 'La r\u00e9gion est incorrecte.',
            'incorrect-region_answer':
                "Nous comprenons l'importance de d\u00e9terminer avec pr\u00e9cision votre emplacement. Il est essentiel de noter que la m\u00eame adresse peut exister dans plusieurs villes.\n\nLorsque vous saisissez l'adresse de votre propri\u00e9t\u00e9, assurez-vous de s\u00e9lectionner la ville appropri\u00e9e parmi les options propos\u00e9es. Ensuite, passez en revue attentivement les d\u00e9tails de l'adresse que vous avez saisis pour \u00e9viter toute inexactitude.\n\nCertaines municipalit\u00e9s se trouvent \u00e0 la fronti\u00e8re de diff\u00e9rentes r\u00e9gions, ce qui peut cr\u00e9er des incoh\u00e9rences. Si vous en trouvez une, veuillez nous contacter via l'assistance.\n",
            'interaction-between-renovations_tooltip': '',
            'interaction-between-renovations_question':
                "Pourquoi l'ajout d'une r\u00e9novation d\u00e9s\u00e9lectionne-t-il parfois une autre que j'avais d\u00e9j\u00e0 choisie?",
            'interaction-between-renovations_answer':
                "Notre outil propose la meilleure combinaison de r\u00e9novations pour atteindre un objectif PEB \u00e0 un co\u00fbt minimal. Du point de vue financier, il n'est pas judicieux de combiner certains travaux de r\u00e9novation car ils ont des objectifs similaires ou peuvent se neutraliser mutuellement. La d\u00e9s\u00e9lection automatique des combinaisons de r\u00e9novation contreproductives garantit que votre investissement vous rapportera le meilleur retour sur investissement possible.\n\nPar exemple, si vous isolez le toit depuis l'int\u00e9rieur, il peut \u00eatre inutile de l'isoler \u00e9galement depuis l'ext\u00e9rieur.",
            'ers-reliability_tooltip': '',
            'ers-reliability_question':
                '\u00c0 quel point les chiffres indiqu\u00e9s dans le rapport sont-ils fiables?',
            'ers-reliability_answer':
                "Les chiffres fournis dans le rapport sont indicatifs et calcul\u00e9s en fonction des informations fournies par l'utilisateur et de diverses sources sur les prix du march\u00e9. Ils ne remplacent pas un certificat PEB officiel ni les conseils d'un professionnel. Les prix peuvent varier en fonction de l'\u00e9tat de la maison et des mat\u00e9riaux choisis pour la r\u00e9novation. Plus les informations fournies par l'utilisateur sont pr\u00e9cises, plus les r\u00e9sultats sont r\u00e9alistes. Il est important de noter que les estimations repr\u00e9sentent les conditions actuelles du march\u00e9 et peuvent \u00eatre sujettes \u00e0 des changements au fil du temps. Pour des chiffres exacts, il est recommand\u00e9 de consulter un professionnel, car ces calculs peuvent \u00eatre affect\u00e9s par divers facteurs.",
            'report-measurements-dont-match_tooltip': '',
            'report-measurements-dont-match_question':
                'Les mesures dans le rapport ne correspondent pas \u00e0 la propri\u00e9t\u00e9.',
            'report-measurements-dont-match_answer':
                "Il pourrait y avoir plusieurs raisons expliquant les incoh\u00e9rences que vous observez. Veuillez noter que vous avez la possibilit\u00e9 d'entrer manuellement les dimensions du b\u00e2timent en s\u00e9lectionnant \"Ce n'est pas le bon b\u00e2timent\" et en suivant les instructions.\n\n- Le mod\u00e8le 3D pourrait ne pas refl\u00e9ter l'\u00e9tat actuel de la maison (par exemple, des modifications ont r\u00e9cemment \u00e9t\u00e9 apport\u00e9es : ajout d'une pi\u00e8ce, etc.).\n- La maison du mod\u00e8le 3D choisie n'\u00e9tait pas votre maison.\n- La superficie habitable n'\u00e9tait pas correcte.\n- Le mod\u00e8le 3D pourrait ne pas avoir \u00e9t\u00e9 disponible. Nous avons utilis\u00e9 vos r\u00e9ponses \u00e0 des questions suppl\u00e9mentaires pour estimer les mesures, mais ces approximations pourraient ne pas correspondre parfaitement aux dimensions r\u00e9elles de la propri\u00e9t\u00e9.\n- Les surfaces des fen\u00eatres et du toit sont approxim\u00e9es en fonction des normes de construction, ce qui pourrait ne pas refl\u00e9ter avec pr\u00e9cision votre propri\u00e9t\u00e9.\n",
            'how-to-create-val-req_tooltip': '',
            'how-to-create-val-req_question':
                "Comment cr\u00e9er une demande d'\u00e9valuation",
            'how-to-create-val-req_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/e1e6ecce-a8b7-4425-9d2a-bd5d355a37f9" loading="lazy" title="Synthesia video player - How to start a Valuation request" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-access-app_tooltip': '',
            'how-to-access-app_question':
                'Comment acc\u00e9der aux applications de Rock.estate',
            'how-to-access-app_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/0b3b14d4-ae8f-4ab5-9bdc-71cc0a7f244b" loading="lazy" title="Synthesia video player - How to access Rock.estate\'s applications" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>\n',
            'how-to-use-dashboard_tooltip': '',
            'how-to-use-dashboard_question':
                "Comment utiliser le Dashboard pour les demandes d'\u00e9valuation",
            'how-to-use-dashboard_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/d138270a-19cc-43eb-8ba4-97f7275caf40" loading="lazy" title="Synthesia video player - How to use dashboard for valuation requests" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'what-is-val-report_tooltip': '',
            'what-is-val-report_question': "Qu'est-ce que le rapport d'\u00e9valuation ?",
            'what-is-val-report_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/6f3af77c-3aac-438a-803b-0fd550382581" loading="lazy" title="Synthesia video player - The valuation report" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-const_tooltip': '',
            'how-to-create-req-const_question':
                'Comment cr\u00e9er une demande pour un terrain de construction',
            'how-to-create-req-const_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/8e121e6a-1d1a-444a-ba7b-3cbd45f91e57" loading="lazy" title="Synthesia video player - How to create a request for a construction plot" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-new-house_tooltip': '',
            'how-to-create-req-new-house_question':
                'Comment cr\u00e9er une demande pour une nouvelle maison',
            'how-to-create-req-new-house_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/95d74ca1-13c4-42e1-bd35-bb0280761ca1" loading="lazy" title="Synthesia video player - How to create a request for a new house" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-existing-house_tooltip': '',
            'how-to-create-req-existing-house_question':
                'Comment cr\u00e9er une demande pour une maison existante',
            'how-to-create-req-existing-house_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/20813b72-86cb-4fab-be4b-9993cb520327" loading="lazy" title="Synthesia video player - How to create a request for an existing house" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-new-qpqrtment_tooltip': '',
            'how-to-create-req-new-qpqrtment_question':
                'Comment cr\u00e9er une demande pour un nouvel appartement',
            'how-to-create-req-new-qpqrtment_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/baaa6686-2977-40e9-88c7-4d0f28d5d320" loading="lazy" title="Synthesia video player - How to create a request for a new apartment" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-existing-apartment_tooltip': '',
            'how-to-create-req-existing-apartment_question':
                'Comment cr\u00e9er une demande pour un appartement existant',
            'how-to-create-req-existing-apartment_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/20813b72-86cb-4fab-be4b-9993cb520327" loading="lazy" title="Synthesia video player - How to create a request for an existing house" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-confirm-address-existing-prop_tooltip': '',
            'how-to-confirm-address-existing-prop_question':
                "Comment confirmer l'adresse, le b\u00e2timent et la parcelle pour une propri\u00e9t\u00e9 existante",
            'how-to-confirm-address-existing-prop_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/adaf14ec-bbc8-4916-8a41-3b28549a43a1" loading="lazy" title="Synthesia video player - How to confirm the address, building and parcel selection for an existing property" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-confirm-address-prop-under-const_tooltip': '',
            'how-to-confirm-address-prop-under-const_question':
                "Comment confirmer l'adresse et la parcelle pour une propri\u00e9t\u00e9 en construction",
            'how-to-confirm-address-prop-under-const_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/5cf12e6a-a55b-4a3f-841a-4caa155649d8" loading="lazy" title="Synthesia video player - How to confirm the address and parcel for a property under construction" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-ers-req-3D_tooltip': '',
            'how-to-create-ers-req-3D_question':
                'Comment cr\u00e9er une demande ERS avec un mod\u00e8le 3D',
            'how-to-create-ers-req-3D_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n\n<div style="position: relative; overflow: hidden; padding-top: 56.25%;"><iframe src="https://share.synthesia.io/embeds/videos/59ec70a8-f074-4f16-9265-6c9c068d6043" loading="lazy" title="Synthesia video player - How to create an ERS request with 3D model" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-ers-req-2D_tooltip': '',
            'how-to-create-ers-req-2D_question':
                'Comment cr\u00e9er une demande ERS avec une empreinte 2D',
            'how-to-create-ers-req-2D_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/caeea1e6-1968-47bc-a1ea-76bdb7c7c0a7" loading="lazy" title="Synthesia video player - How to create an ERS request with 2D footprint" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-ers-req-building-not-found_tooltip': '',
            'how-to-create-ers-req-building-not-found_question':
                "Comment cr\u00e9er une demande d'ERS lorsque le b\u00e2timent n'a pas pu \u00eatre trouv\u00e9",
            'how-to-create-ers-req-building-not-found_answer':
                '<p>Cette vid\u00e9o n\'est disponible qu\'en Anglais pour l\'instant</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/a36b0550-f792-471b-8c89-ee8cff89a1cb" loading="lazy" title="Synthesia video player - How to create an ERS request when the building could not be found" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-total-investment-cost-calculated_tooltip': '',
            'how-total-investment-cost-calculated_question':
                'Comment est calcul\u00e9 le co\u00fbt total de l\u2019investissement ?',
            'how-total-investment-cost-calculated_answer':
                "La co\u00fbt total d'investissement d'une r\u00e9novation englobe les co\u00fbts de d\u00e9molition, de transport, de mat\u00e9riaux et d'installation. Nous d\u00e9terminons les mat\u00e9riaux n\u00e9cessaires en fonction de la g\u00e9om\u00e9trie du b\u00e2timent (surface, volume, orientation, pente, etc.). Par exemple, les panneaux solaires sont install\u00e9s sur la partie du toit avec la meilleure orientation pour la lumi\u00e8re du soleil, et la capacit\u00e9 correspond aux besoins de consommation d'\u00e9lectricit\u00e9. Le prix, TVA incluse, tient compte de 6% ou 21%, selon les r\u00e8gles fiscales. Les prix totaux sont arrondis au centi\u00e8me pr\u00e8s.\n## Les co\u00fbts sont bas\u00e9s sur les donn\u00e9es des sources suivantes:\n- M\u00e9thodologie EPC pour des indications de prix moyens (par l'Agence flamande de l'\u00e9nergie)\n- UPA - BUA (Union professionnelle des architectes)\n- Archindex (documentation par et pour les ing\u00e9nieurs/architectes)\n- ASPEN (source ind\u00e9pendante et objective d'informations sur les prix pour les entrepreneurs)\n- ABEX Borderel (r\u00e9f\u00e9rence pour calculer les primes d'assurance et les polices d'assurance incendie)\n- Contributions du march\u00e9 (fournisseurs/entrepreneurs)\n- Sources en ligne  \n\nIl existe plusieurs raisons pour lesquelles un devis de votre entrepreneur peut diff\u00e9rer du co\u00fbt total estim\u00e9. Une diff\u00e9rence de 20 \u00e0 25% entre l'offre la moins ch\u00e8re et la plus ch\u00e8re sur le march\u00e9 n'est pas inhabituelle. Il est donc recommand\u00e9 de demander des devis \u00e0 plusieurs fournisseurs avant de prendre une d\u00e9cision.\n## Voici quelques facteurs qui influent sur les co\u00fbts:  \n\n- Qualit\u00e9 des mat\u00e9riaux\n- Surface totale\n- Choix de la technologie\n- \u00c9paisseur de l'isolation\n- Puissance/Capacit\u00e9\n- Marque\n- Combinaison avec d'autres travaux (par exemple, enl\u00e8vement d'amiante)  \n\nAucune consid\u00e9ration n'est donn\u00e9e aux diff\u00e9rences r\u00e9gionales de co\u00fbts (par exemple, dans les co\u00fbts d'installation de transport et d'infrastructures). Les travaux pr\u00e9alables \u00e9ventuellement n\u00e9cessaires pour rendre la r\u00e9novation techniquement faisable ne sont pas inclus dans le co\u00fbt total d'investissement.  \n\nT\u00e9l\u00e9chargez un rapport de r\u00e9novation d'un sc\u00e9nario de r\u00e9novation pour obtenir plus d'informations sur le choix des mat\u00e9riaux et de la technologie, la surface et ce qui est inclus dans le co\u00fbt total d'investissement.",
            payment_tooltip: '',
            payment_question: "Quel est le co\u00fbt d'une \u00e9valuation sur place ?",
            payment_answer:
                "Le co\u00fbt d'une \u00e9valuation sur place est d\u00e9termin\u00e9 en fonction des caract\u00e9ristiques du bien. Le prix correspondant aux caract\u00e9ristiques du bien sera communiqu\u00e9 \u00e0 l'emprunteur lors de la prise de rendez-vous pour effectuer l'\u00e9valuation sur place.",
            'payment-methods_tooltip': '',
            'payment-methods_question':
                'Quels sont les moyens de paiement accept\u00e9s ?',
            'payment-methods_answer':
                'Les modes de paiement suivants sont accept\u00e9s :\n- Bancontact\n- Visa\n- Mastercard',
            'why-payment-before_tooltip': '',
            'why-payment-before_question':
                "Pourquoi dois-je payer l'\u00e9valuation avant le rendez-vous ?",
            'why-payment-before_answer': '4',
            'when-appointment_tooltip': '',
            'when-appointment_question': 'Quand le bien sera-t-il \u00e9valu\u00e9 ?',
            'when-appointment_answer':
                "En tant qu'emprunteur, lorsque vous recevez un lien d'invitation de Rock.estate, vous avez la possibilit\u00e9 de fixer votre rendez-vous d'\u00e9valuation \u00e0 votre convenance. En suivant le lien, vous pouvez choisir le jour et l'heure qui vous conviennent le mieux. Attention, soyez certain d'\u00eatre disponible \u00e0 ce moment, il n'y aura pas de remboursement pour une non-pr\u00e9sentation le jour de l'\u00e9valuation.",
            Reschedule_tooltip: '',
            Reschedule_question: 'Puis-je reporter mon rendez-vous ?',
            Reschedule_answer:
                "Vous pouvez reporter votre rendez-vous en nous contactant via support@rock.estate. Veuillez indiquer vos disponibilit\u00e9s et laisser votre num\u00e9ro de t\u00e9l\u00e9phone. Nous vous contacterons pour fixer un nouveau rendez-vous.\n\nLa modification ou l'annulation d'un rendez-vous plus de 24 heures \u00e0 l'avance n'entra\u00eene pas de frais. Les changements effectu\u00e9s dans les 24 heures seront factur\u00e9s \u00e0 50 %, et en cas de non-pr\u00e9sentation sans pr\u00e9avis, la totalit\u00e9 des frais ne sera pas rembours\u00e9e. Veuillez vous r\u00e9f\u00e9rer \u00e0 notre FAQ pour plus de d\u00e9tails.",
            cancel_tooltip: '',
            cancel_question: 'Puis-je annuler mon rendez-vous ?',
            cancel_answer:
                "Vous pouvez annuler votre rendez-vous en nous contactant via support@rock.estate. \n\nLe report ou l'annulation d'un rendez-vous plus de 24 heures \u00e0 l'avance n'entra\u00eene pas de frais. Les changements effectu\u00e9s dans les 24 heures seront factur\u00e9s \u00e0 50 %, et en cas de non-pr\u00e9sentation sans pr\u00e9avis, la totalit\u00e9 des frais ne sera pas rembours\u00e9e. Veuillez vous r\u00e9f\u00e9rer \u00e0 notre FAQ pour plus de d\u00e9tails.",
            present_tooltip: '',
            present_question:
                "Dois-je \u00eatre pr\u00e9sent lors de l'\u00e9valuation ?",
            present_answer:
                "Vous ou un repr\u00e9sentant de votre choix devez \u00eatre pr\u00e9sent lors de l'\u00e9valuation, afin de permettre \u00e0 l'expert d'acc\u00e9der au bien.",
            timing_tooltip: '',
            timing_question:
                "Quand saurai-je l'heure exacte d'arriv\u00e9e de l'expert ?",
            timing_answer:
                "L'expert arrivera dans le cr\u00e9neau horaire de 1h30 que vous avez choisi pour votre rendez-vous. L'expert peut vous contacter avant la visite pour vous donner une heure d'arriv\u00e9e plus d\u00e9taill\u00e9e.",
            'borrower-contact-expert_tooltip': '',
            'borrower-contact-expert_question': "Comment contacter l'expert ?",
            'borrower-contact-expert_answer':
                "Si vous avez une question \u00e0 poser \u00e0 l'expert, vous pouvez contacter notre service d'assistance via support@rock.estate.",
            'borrower-contact-who_tooltip': '',
            'borrower-contact-who_question':
                "Qui puis-je contacter si l'expert n'est pas sur place au moment de l'\u00e9valuation ?",
            'borrower-contact-who_answer':
                "Vous pouvez contacter notre service d'assistance via support@rock.estate. Pour les questions urgentes, veuillez indiquer votre num\u00e9ro de t\u00e9l\u00e9phone et nous vous contacterons.",
            'bank-agent-contacted_tooltip': '',
            'bank-agent-contacted_question':
                "Mon client m'a inform\u00e9 qu'il/elle ou son repr\u00e9sentant ne pourra pas se rendre au rendez-vous. Que dois-je faire ?",
            'bank-agent-contacted_answer':
                'Veuillez nous contacter ou conseiller \u00e0 votre client de nous contacter via support@rock.estate. Nous pouvons reporter ou annuler le rendez-vous si n\u00e9cessaire.',
            'how-contact-RE_tooltip': '',
            'how-contact-RE_question': 'Comment puis-je contacter Rock.estate ?',
            'how-contact-RE_answer': 'Veuillez nous contacter via support@rock.estate.',
            'contact-representative_tooltip': '',
            'contact-representative_question':
                "Comment puis-je contacter directement le client pour l'informer de mon heure d'arriv\u00e9e ou de mon retard ?",
            'contact-representative_answer':
                "Veuillez acc\u00e9der \u00e0 l'aper\u00e7u de votre rendez-vous via votre dashboard. Vous y trouverez les coordonn\u00e9es de l'emprunteur et/ou celles du repr\u00e9sentant.",
            'how-link-calendar_tooltip': '',
            'how-link-calendar_question':
                'Comment lier mon calendrier (Google, icloud, Office 365, Exchange, Outlook.com) ?',
            'how-link-calendar_answer':
                'Veuillez vous rendre sur la page "On-site Valuer" pour ouvrir vos param\u00e8tres et cliquer sur "Availability". Vous verrez la section permettant de lier votre compte de calendrier.',
            'Several-calendars_tooltip': '',
            'Several-calendars_question': 'Puis-je lier plusieurs calendriers ?',
            'Several-calendars_answer':
                'Oui, vous pouvez ajouter plusieurs comptes de calendrier et nous les prendrons tous en compte.',
            'How-availabilities_tooltip': '',
            'How-availabilities_question':
                'Comment enregistrer mes disponibilit\u00e9s de travail ?',
            'How-availabilities_answer':
                'Apr\u00e8s avoir li\u00e9 votre calendrier, vous pouvez choisir plusieurs r\u00e9gions dans lesquelles vous travaillez. Dans la section "availability" ci-dessous, vous pouvez d\u00e9finir vos heures de travail pour chaque r\u00e9gion. Nous ne tiendrons compte de votre calendrier que pendant ces heures.',
            'Different-regions_tooltip': '',
            'Different-regions_question':
                'Puis-je travailler dans diff\u00e9rentes r\u00e9gions ?',
            'Different-regions_answer':
                'Oui, vous avez la possibilit\u00e9 de choisir plusieurs r\u00e9gions pour chaque cr\u00e9neau horaire ou de cr\u00e9er des cr\u00e9neaux horaires distincts pour diff\u00e9rentes r\u00e9gions.',
            'How-different-regions_tooltip': '',
            'How-different-regions_question':
                'Comment puis-je placer mes disponibilit\u00e9s dans diff\u00e9rentes r\u00e9gions le m\u00eame jour ?',
            'How-different-regions_answer':
                'Veuillez s\u00e9lectionner plusieurs r\u00e9gions dans un m\u00eame cr\u00e9neau de disponibilit\u00e9. Nous prendrons en consid\u00e9ration toutes les r\u00e9gions s\u00e9lectionn\u00e9es pendant les heures que vous aurez choisies dans ce cr\u00e9neau.',
            'How-register-regions_tooltip': '',
            'How-register-regions_question':
                'Comment enregistrer la (les) r\u00e9gion(s) dans laquelle (lesquelles) je travaillerai ?',
            'How-register-regions_answer':
                'Veuillez s\u00e9lectionner une ou plusieurs r\u00e9gions dans la section "district" de vos param\u00e8tres de disponibilit\u00e9.',
            'How-appointment-assigned_tooltip': '',
            'How-appointment-assigned_question':
                "Comment un rendez-vous m'est-il attribu\u00e9 ?",
            'How-appointment-assigned_answer':
                "Dans les r\u00e9gions et les heures de travail que vous avez s\u00e9lectionn\u00e9es, le(s) calendrier(s) li\u00e9(s) est (sont) pris en consid\u00e9ration. Chaque plage horaire disponible d'au moins 1 heure et 30 minutes est consid\u00e9r\u00e9e comme \"disponible\".\n\nLorsqu'il prend un rendez-vous, le client voit toutes les disponibilit\u00e9s pour la semaine \u00e0 venir en fonction de son adresse. Le client peut choisir un cr\u00e9neau horaire de 1 heure et 30 minutes.\n\nLe cr\u00e9neau horaire choisi correspond-il \u00e0 vos disponibilit\u00e9s ? Si oui, la demande vous est attribu\u00e9e. Confirmez le rendez-vous au plus tard 24 heures apr\u00e8s avoir re\u00e7u l'invitation. Contactez le client pour lui faire part de votre heure d'arriv\u00e9e exacte dans ce cr\u00e9neau horaire.\n\nNotabene : Ces disponibilit\u00e9s restent anonymes, le client ne saura pas quelles disponibilit\u00e9s sont li\u00e9es \u00e0 quel expert.",
            'Forgot-confirmation_tooltip': '',
            'Forgot-confirmation_question':
                "Je n'ai pas confirm\u00e9 le rendez-vous plus de 24 heures \u00e0 l'avance, mais j'aimerais proc\u00e9der \u00e0 l'\u00e9valuation. Que dois-je faire ?",
            'Forgot-confirmation_answer':
                "Veuillez nous contacter directement via support@rock.estate. Si aucun autre \u00e9valuateur n'a \u00e9t\u00e9 d\u00e9sign\u00e9, vous pourrez toujours confirmer l'\u00e9valuation.",
            'Optimize-appointments_tooltip': '',
            'Optimize-appointments_question':
                "Comment optimiser ma journ\u00e9e ? Par exemple, j'ai deux rendez-vous d'une dur\u00e9e de 1h30 chacun, mais les lieux sont tr\u00e8s proches l'un de l'autre et j'aimerais me rendre plus rapidement au deuxi\u00e8me rendez-vous.",
            'Optimize-appointments_answer':
                "Vous avez la libert\u00e9 d'organiser votre visite \u00e0 l'int\u00e9rieur des cr\u00e9neaux d'une heure et de 30 minutes, \u00e0 condition d'en informer l'emprunteur. Par exemple, vous pouvez effectuer votre premi\u00e8re visite dans les 30 derni\u00e8res minutes de la plage horaire initiale et votre deuxi\u00e8me visite dans les 30 premi\u00e8res minutes de la plage horaire suivante.",
            'Where-view-appointments_tooltip': '',
            'Where-view-appointments_question':
                'O\u00f9 puis-je trouver la liste de mes rendez-vous ?',
            'Where-view-appointments_answer':
                'Vous pouvez aller dans vos param\u00e8tres et s\u00e9lectionner l\'onglet "Rendez-vous". En outre, vous pouvez consulter votre dashboard pour voir les demandes en suspens et les demandes confirm\u00e9es.',
            'Where-confirm_tooltip': '',
            'Where-confirm_question':
                'O\u00f9 puis-je trouver les rendez-vous que je dois confirmer ?',
            'Where-confirm_answer':
                'Vous pouvez aller dans vos param\u00e8tres et s\u00e9lectionner l\'onglet "Rendez-vous". En outre, vous pouvez consulter votre tableau de bord pour voir les demandes en suspens et les demandes confirm\u00e9es.',
            'Flood-zones_tooltip': '',
            'Flood-zones_question':
                "D'o\u00f9 proviennent les donn\u00e9es sur les zones inondables ?",
            'Flood-zones_answer':
                'Nos zones inondables sont bas\u00e9es sur des donn\u00e9es g\u00e9ographique ouvertes et des cartes r\u00e9gionales.',
            'Parcel-area_tooltip': '',
            'Parcel-area_question':
                'Comment la superficie totale de la parcelle est-elle calcul\u00e9e ?',
            'Parcel-area_answer':
                'La superficie totale des parcelles est bas\u00e9e sur des donn\u00e9es g\u00e9ographique ouvertes (cadastre).',
            'Building-footprint_tooltip': '',
            'Building-footprint_question':
                "Comment l'empreinte du b\u00e2timent est-elle calcul\u00e9e ?",
            'Building-footprint_answer':
                "L'empreinte du b\u00e2timent est bas\u00e9e sur des donn\u00e9es g\u00e9ographiques ouvertes (cadastre).",
            'Garden-area_tooltip': '',
            'Garden-area_question':
                'Comment la superficie du jardin est-elle calcul\u00e9e ?',
            'Garden-area_answer':
                'La surface du jardin est calcul\u00e9e en soustrayant la surface du b\u00e2timent de la surface de la parcelle.',
            'Living-area_tooltip': '',
            'Living-area_question':
                'Comment la surface habitable est-elle calcul\u00e9e ?',
            'Living-area_answer':
                'La surface habitable fournie par l\'agent bancaire est d\u00e9riv\u00e9e du certificat PEB. Elle repr\u00e9sente la surface habitable "brute", \u00e0 l\'exclusion des murs int\u00e9rieurs et des structures similaires.',
            'Approximate-Living-area_tooltip': '',
            'Approximate-Living-area_question':
                'Comment la surface habitable approximative est-elle calcul\u00e9e ?',
            'Approximate-Living-area_answer':
                "Nous estimons la surface habitable d'une maison en fonction de son volume et de sa structure. Le volume est d\u00e9termin\u00e9 par des scans 3D Lidar de la propri\u00e9t\u00e9.",
            'Different-living-area_tooltip': '',
            'Different-living-area_question':
                'Pourquoi la surface habitable approximative ne correspond-elle pas \u00e0 la surface habitable ?',
            'Different-living-area_answer':
                "Nous n'avons pas visit\u00e9 la propri\u00e9t\u00e9 et nous nous basons uniquement sur une estimation. Nous estimons la surface habitable d'une maison sur la base de son volume et de sa structure. Le volume est d\u00e9termin\u00e9 \u00e0 l'aide de scans 3D Lidar de la propri\u00e9t\u00e9.",
            'EPC-certificate_tooltip': '',
            'EPC-certificate_question': 'O\u00f9 puis-je trouver le certificat PEB ?',
            'EPC-certificate_answer':
                'Si l\'agent bancaire a t\u00e9l\u00e9charg\u00e9 le certificat PEB, vous pouvez le consulter dans l\'outil d\'\u00e9valuation. Allez dans l\'onglet "Informations g\u00e9n\u00e9rales" et vous le trouverez dans la section "\u00c9tat".',
            'Market-value_tooltip': '',
            'Market-value_question':
                'Comment la valeur marchande est-elle calcul\u00e9e ?',
            'Market-value_answer':
                "Notre valeur de march\u00e9 est calcul\u00e9e \u00e0 l'aide d'un mod\u00e8le d'\u00e9valuation automatis\u00e9 bas\u00e9 sur les comparables (CBAVM), abr\u00e9g\u00e9 en AVM. \u00c0 partir d'une adresse et des caract\u00e9ristiques d'un bien, nous identifions automatiquement les 200 \u00e0 250 biens les plus similaires de notre base de donn\u00e9es. Notre mod\u00e8le compare tous ces biens \u00e0 l'aide de la r\u00e9gression pond\u00e9r\u00e9e g\u00e9ographiquement (PRG). La r\u00e9gression pond\u00e9r\u00e9e g\u00e9ographiquement est une forme de r\u00e9gression lin\u00e9aire qui incorpore des informations spatiales, en attribuant un poids plus \u00e9lev\u00e9 aux maisons proches lors de l'estimation du prix.",
            'Forced-sale-value_tooltip': '',
            'Forced-sale-value_question':
                'Comment la valeur de la vente forc\u00e9e est-elle calcul\u00e9e ?',
            'Forced-sale-value_answer':
                'Cette estimation se traduit g\u00e9n\u00e9ralement par une remise de 10 \u00e0 40 % du prix estim\u00e9 de la transaction, en fonction des caract\u00e9ristiques observ\u00e9es.',
            'Monthly-rental-value_tooltip': '',
            'Monthly-rental-value_question':
                'Comment la valeur locative mensuelle est-elle calcul\u00e9e ?',
            'Monthly-rental-value_answer':
                'La valeur locative mensuelle est calcul\u00e9e selon la m\u00eame m\u00e9thode que la valeur de march\u00e9, mais en tenant compte des prix de location dans notre ensemble de donn\u00e9es.',
            'Reconstruction-value_tooltip': '',
            'Reconstruction-value_question':
                'Comment la valeur de reconstruction est-elle calcul\u00e9e ?',
            'Reconstruction-value_answer':
                'La valeur de reconstruction est calcul\u00e9e en fonction du volume et de la complexit\u00e9 du b\u00e2timent.',
            'Reference-points_tooltip': '',
            'Reference-points_question':
                "D'o\u00f9 proviennent les donn\u00e9es pour les points de r\u00e9f\u00e9rence ?",
            'Reference-points_answer':
                'Actuellement, nos points de r\u00e9f\u00e9rence sont d\u00e9riv\u00e9s des annonces. Veuillez noter que les prix affich\u00e9s repr\u00e9sentent les prix demand\u00e9s et non les prix de transaction. Dans un avenir proche, nous int\u00e9grerons \u00e9galement les prix des transactions disponibles dans cet ensemble de donn\u00e9es.',
        },
        questions_feedback: {
            explanation_1:
                "Vous avez une question ou un commentaire sp\u00e9cifique concernant ce rapport? Ou vous souhaitez simplement obtenir plus d'informations sur la mani\u00e8re dont Rock.estate proc\u00e8de \u00e0 ces valorisations?",
            explanation_1_tooltip: '',
            explanation_2:
                "Veuillez visiter notre plateforme de valorisation : {url}.valuation_app{'.'}",
            explanation_2_tooltip: '',
        },
        punctuation: {
            ':': ' :',
            ':_tooltip': '',
        },
        status: {
            draft: '\u00c0 compl\u00e9ter',
            draft_tooltip: '',
            submitted: 'Envoy\u00e9',
            submitted_tooltip: '',
            completed: 'Compl\u00e9t\u00e9',
            completed_tooltip: '',
            valued: 'Evalu\u00e9',
            valued_tooltip: '',
            'awaiting-onsite': 'Expertise sur place n\u00e9cessaire',
            'awaiting-onsite_tooltip': '',
            cancelled: 'Annul\u00e9',
            cancelled_tooltip: '',
            canceled: 'Annul\u00e9',
            canceled_tooltip: '',
            pending_confirmation: "En attente de confirmation de l'expert",
            pending_confirmation_tooltip: '',
            failed: 'Echec',
            failed_tooltip: '',
            confirmed: "L'expert a confirm\u00e9 le rendez-vous",
            confirmed_tooltip: '',
        },
        renovation_info: {
            title: 'Devis de r\u00e9novation',
            title_tooltip: '',
            add_document: 'Ajouter un document',
            add_document_tooltip: '',
            unlink_document: 'Dissocier un document',
            unlink_document_tooltip: '',
            link_document: 'Lier un document',
            link_document_tooltip: '',
            items: '{n}\u00e9l\u00e9ment|{n}\u00e9l\u00e9ments',
            items_tooltip: '',
            linked_items: '{n}\u00e9l\u00e9ment li\u00e9|{n}\u00e9l\u00e9ments li\u00e9s',
            linked_items_tooltip: '',
        },
        renovation_item: {
            title: 'Titre ',
            title_tooltip: '',
            amount: 'Montant ',
            amount_tooltip: '',
            category: 'Cat\u00e9gorie',
            category_tooltip: '',
            subcategory: 'Sous-cat\u00e9gorie',
            subcategory_tooltip: '',
            modal_title: "Modifier l'\u00e9l\u00e9ment de r\u00e9novation",
            modal_title_tooltip: '',
        },
        renovation_category: {
            energy: '\u00c9nergie',
            energy_tooltip: '',
            structural: 'Structurel',
            structural_tooltip: '',
            aesthetic: 'Esth\u00e9tique',
            aesthetic_tooltip: '',
            other: 'Autre',
            other_tooltip: '',
        },
        renovation_subcategory: {
            insulation: 'Isolation',
            insulation_tooltip: '',
            solar_panel: 'Panneau solaire',
            solar_panel_tooltip: '',
            heating: 'Chauffage',
            heating_tooltip: '',
            other: 'Autre',
            other_tooltip: '',
            wall_extension: 'Extension de mur',
            wall_extension_tooltip: '',
            demolition: 'D\u00e9molition',
            demolition_tooltip: '',
            kitchen: 'Cuisine',
            kitchen_tooltip: '',
            bathroom: 'Salle de bains',
            bathroom_tooltip: '',
        },
        steps: {
            customer_ref: 'R\u00e9f\u00e9rence client',
            customer_ref_tooltip: '',
            building_type: 'Type de bien',
            building_type_tooltip:
                "S'agit-il d'une maison unifamiliale ou d'un appartement ?",
            address: 'Adresse',
            address_tooltip: '',
            address_confirmation: "Confirmation de l'adresse",
            address_confirmation_tooltip:
                "Pour estimer les co\u00fbts et b\u00e9n\u00e9fices des diff\u00e9rentes r\u00e9novations, il est n\u00e9cessaire pour nous de recueillir certaines informations \u00e0 propos du b\u00e2timent (par exemple la pente, la surface et l'orientation du toit pour l'installation de panneaux solaires).",
            building_selection: 'B\u00e2timent',
            building_selection_tooltip: '',
            house_info: 'Informations maison',
            house_info_tooltip: '',
            building_dimensions: 'Dimensions du b\u00e2timent',
            building_dimensions_tooltip: '',
            epc: 'PEB',
            epc_tooltip: '',
            construction_year: 'Ann\u00e9e de construction',
            construction_year_tooltip:
                "L'ann\u00e9e de construction officielle du b\u00e2timent. Ceci ne tient pas compte d'\u00e9ventuelles r\u00e9novations ayant eu lieu plus tard. Cette information est g\u00e9n\u00e9ralement fournie dans l'annonce immo, dans le certificat PEB ou dans le plan cadastral.",
            living_area: 'Surface habitable',
            living_area_tooltip:
                "La surface habitable totale de l'habitation, \u00e0 savoir le nombre de mettres carr\u00e9s chauff\u00e9s. Cette surface comprend le grenier s'il est chauff\u00e9, mais pas la cave. Cette information est g\u00e9n\u00e9ralement fournie dans l'annonce immo, ou dans le certificat PEB.",
            energy_performance: 'Performance \u00e9nerg\u00e9tique',
            energy_performance_tooltip: '',
            insulation: 'Isolation',
            insulation_tooltip: '',
            wall_insulation: 'Murs',
            wall_insulation_tooltip: '',
            roof_insulation: 'Toit',
            roof_insulation_tooltip: '',
            floor_insulation: 'Sols',
            floor_insulation_tooltip: '',
            window_glazing: 'Ch\u00e2ssis',
            window_glazing_tooltip: '',
            attic: 'Grenier',
            attic_tooltip: '',
            basement: 'Cave',
            basement_tooltip: '',
            energy_consumption: 'Consommation',
            energy_consumption_tooltip: '',
            heating: 'Chauffage',
            heating_tooltip: '',
            electricity_consumption: 'Consommation \u00e9lectrique',
            electricity_consumption_tooltip: '',
            gas_consumption: 'Consommation de gaz',
            gas_consumption_tooltip: '',
            oil_consumption: 'Consommation de mazout',
            oil_consumption_tooltip: '',
            coal_consumption: 'Consommation de charbon',
            coal_consumption_tooltip: '',
            wood_consumption: 'Consommation de bois',
            wood_consumption_tooltip: '',
            pellets_consumption: 'Consommation de pellets',
            pellets_consumption_tooltip: '',
            district_heating_consumption: 'R\u00e9seau de chaleur/ chauffage urbain',
            district_heating_consumption_tooltip: '',
            solar_panels: 'Panneaux solaires',
            solar_panels_tooltip: '',
            ventilation: 'Ventilation',
            ventilation_tooltip: '',
            consumers: 'Consommateurs',
            consumers_tooltip: '',
            big_consumers: 'Gros consommateurs',
            big_consumers_tooltip: '',
            electric_vehicles: 'Voitures \u00e9lectriques',
            electric_vehicles_tooltip: '',
            processing: 'Calcul en cours',
            processing_tooltip: '',
            finish: 'Fin',
            finish_tooltip: '',
        },
        property_type: {
            apartments: 'Appartements',
            apartments_tooltip: '',
            coming_soon:
                'Notre app ne fonctionne pas encore pour les appartements.  C\u2019est pour bient\u00f4t !',
            coming_soon_tooltip: '',
            select_type: " Indiquez l'adresse ici",
            select_type_tooltip: '',
            title: 'Confirmez le type de bien',
            title_tooltip: '',
        },
        out_of_bounds_page: {
            title: "Nous n'avons pas trouv\u00e9 de donn\u00e9es sur cette addresse",
            title_tooltip: '',
            '3d_model_not_found_subtitle':
                'Avec quelques questions suppl\u00e9mentaires, nous pouvons estimer les mesures du b\u00e2timent. Commen\u00e7ons!',
            '3d_model_not_found_subtitle_tooltip': '',
            '3d_model_not_found':
                'Il semble que nous n\u2019ayons pas trouv\u00e9 le mod\u00e8le 3D de ce b\u00e2timent',
            '3d_model_not_found_tooltip': '',
            content_tooltip: '',
            button: 'Essayer avec une autre adresse',
            button_tooltip: '',
            ing_button: 'Retourner sur le site d\u2019ING',
            ing_button_tooltip: '',
        },
        terms_page: {
            welcome: 'n/a',
            welcome_tooltip: '',
            epc: 'n/a',
            epc_tooltip: '',
            disclaimer: 'n/a',
            disclaimer_tooltip: '',
        },
        features_question: {
            insulated_floors: 'Les sols sont-ils isol\u00e9s ?',
            insulated_floors_tooltip: '',
            insulated_roof: 'Le toit est-il isol\u00e9 ?',
            insulated_roof_tooltip: '',
            insulated_walls: 'Les murs exterieurs sont-ils isol\u00e9s ?',
            insulated_walls_tooltip: '',
            has_attic: 'Y a-t-il un grenier ?',
            has_attic_tooltip: '',
            insulation_floors_when: "De quand datent les derniers travaux d'isolation ?",
            insulation_floors_when_tooltip: '',
            insulation_roof_when: 'Quand\u00a0?',
            insulation_roof_when_tooltip: '',
            insulation_walls_when: 'Quand\u00a0?',
            insulation_walls_when_tooltip: '',
            has_basement: 'Y a-t-il une cave ?',
            has_basement_tooltip: '',
            is_attic_heated: 'Cette pi\u00e8ce est-elle chauff\u00e9e ?',
            is_attic_heated_tooltip: '',
            last_floor_renovation:
                'Quand les sols ont-ils \u00e9t\u00e9s isol\u00e9s pour la derni\u00e8re fois ?',
            last_floor_renovation_tooltip: '',
            last_wall_renovation:
                'Quand les murs ont-ils \u00e9t\u00e9s isol\u00e9s pour la derni\u00e8re fois ?',
            last_wall_renovation_tooltip: '',
            last_roof_renovation:
                'Quand le toit a-t-il \u00e9t\u00e9 isol\u00e9 pour la derni\u00e8re fois ?',
            last_roof_renovation_tooltip: '',
            enter_epc_label: 'S\u00e9lectionnez le label PEB officiel',
            enter_epc_label_tooltip: '',
            enter_epc_score: 'Entrez le score PEB officiel ici',
            enter_epc_score_tooltip: '',
            epc_type_tooltip: '',
            epc_known: 'Avez-vous un certificat PEB valide ?',
            epc_known_tooltip:
                "Le certificat PEB (Performance \u00c9nerg\u00e9tique du B\u00e2timent) est la carte d'identit\u00e9 \u00e9nerg\u00e9tique d'un b\u00e2timent. Cette information est fournie dans l'annonce immo ou dans le document PEB du bien. Le certificat PEB d\u00e9taille le 'score \u00e9nerg\u00e9tique' du b\u00e2timent, exprim\u00e9 en kWh/m2/an. En fonction du score \u00e9nerg\u00e9tique, le b\u00e2timent se voit attribuer un 'label \u00e9nerg\u00e9tique' (de A++ \u00e0 G).",
            consumption_known_no_tooltip: '',
            consumption_known_yes_tooltip: '',
            epc_known_yes_tooltip: '',
            epc_known_no_tooltip: '',
            select_heating_fuel:
                'S\u00e9lectionnez le principal combustible de chauffage ',
            select_heating_fuel_tooltip: '',
            ventilation_type: 'Quel type de ventilation y a-t-il ?',
            ventilation_type_tooltip: '',
            ventilation_subtype: 'Quel type de ventilation y a-t-il ?',
            ventilation_subtype_tooltip: '',
            n_residents: "Combien de personnes vivent dans l'habitation ?",
            n_residents_tooltip: '',
            protected_consumer: 'n/a',
            protected_consumer_tooltip: '',
            heating_consumption_approx:
                'Merci de nous donner une estimation de la consommation de chauffage',
            heating_consumption_approx_tooltip: '',
            electric_consumption_approx:
                "Merci de nous donner une estimation de la consommation d'\u00e9lectricit\u00e9",
            electric_consumption_approx_tooltip: '',
            installation_year: "De quelle ann\u00e9e date l'installation ?",
            installation_year_tooltip: '',
            heater: 'Quel type de chauffage y a-t-il ?',
            heater_tooltip: '',
            energy_consumption_known:
                "Connaissez-vous votre consommation d'\u00e9nergie ?",
            energy_consumption_known_tooltip: '',
            consumption_known: "Connaissez-vous votre consommation d'\u00e9nergie ?",
            consumption_known_tooltip:
                "Vous pouvez trouver ces informations sur votre derni\u00e8re facture d'\u00e9nergie ou en comparant les valeurs de vos compteurs. Veillez \u00e0 faire attention \u00e0 ne saisir que des valeurs annuelles. Il se peut que vous deviez recalculer la valeur figurant sur la facture afin d'obtenir une valeur annuelle.",
            yearly_electricity_consumption:
                "Connaissez-vous votre consommation d'\u00e9lectricit\u00e9 annuelle ?",
            yearly_electricity_consumption_tooltip:
                "Vous pouvez trouver ces informations sur votre derni\u00e8re facture d'\u00e9lectricit\u00e9 ou en comparant les valeurs de vos compteurs. Veillez \u00e0 faire attention \u00e0 ne saisir que des valeurs annuelles. Il se peut que vous deviez recalculer la valeur figurant sur la facture afin d'obtenir une valeur annuelle.",
            yearly_electricity_consumption_subtitle:
                "La consommation d'\u00e9lectricit\u00e9 annuelle repr\u00e9sente les kWh consomm\u00e9s depuis le r\u00e9seau sur une ann\u00e9e.\nNe prenez pas en consid\u00e9ration l'\u00e9lectricit\u00e9 que vous g\u00e9n\u00e9rez.",
            yearly_electricity_consumption_subtitle_tooltip: '',
            yearly_fuel_consumption:
                'Connaissez-vous votre consommation de combustible ?',
            yearly_fuel_consumption_tooltip:
                "Vous pouvez trouver ces informations sur votre derni\u00e8re facture de combustible ou en comparant les valeurs de vos compteurs. Veillez \u00e0 faire attention \u00e0 ne saisir que des valeurs annuelles. Il se peut que vous deviez recalculer la valeur figurant sur la facture afin d'obtenir une valeur annuelle.",
            yearly_heating_consumption:
                'Connaissez-vous votre consommation annuelle de chauffage ?',
            yearly_heating_consumption_tooltip: '',
            f_construction_year:
                "En quelle ann\u00e9e l'habitation a-t-elle \u00e9t\u00e9 construite ?",
            f_construction_year_tooltip: '',
            f_living_area:
                "Quelle est la surface habitable chauff\u00e9e de l'habitation ?",
            f_living_area_tooltip:
                "La surface habitable totale du bien. Cette information est g\u00e9n\u00e9ralement fournie dans l'annonce immo, ou dans le certificat PEB.",
            approx_living_area:
                'D\'apr\u00e8s le mod\u00e8le 3D du b\u00e2timent, nous estimons la surface habitable \u00e0 <b class="has-text-primary">{area} m\u00b2</b>. Veuillez entrer la surface correcte si vous la connaissez.',
            approx_living_area_tooltip: '',
            solar_panels: 'Y a-t-il des panneaux solaires ?',
            solar_panels_tooltip: '',
            insulated_windows:
                "Quel est le type de vitrage principal dans l'habitation ?",
            insulated_windows_tooltip:
                'Le type de vitrage est mentionn\u00e9 dans la documentation technique de l\'habitation, ex. dans les factures de pose des ch\u00e2ssis. Si vous ne disposez pas de ces infos, voici deux autres options :\n- En cas de double vitrage : un code est grav\u00e9 dans l\u2019intercalaire du double vitrage. Ce code est visible \u00e0 l\u2019\u0153il nu et peut \u00eatre retrouv\u00e9 sur le site web du producteur. Le code des vitrages \u00e0 haute performance, par exemple, comporte les lettres "HR", "HR+" ou "HR++". Le triple vitrage se reconna\u00eet \u00e0 l\'inscription "HR+++".\n- Vous ne voyez pas de code ? Le double vitrage standard s\'identifie \u00e0 la bande d\'aluminium situ\u00e9e entre les deux plaques de verre. \n\n',
            insulated_single_renovated:
                "A-t-il subi une intervention pour en am\u00e9liorer l'isolation ?",
            insulated_single_renovated_tooltip: '',
            insulated_plural_renovated:
                "Ont-ils subi une intervention pour am\u00e9liorer l'isolation ?",
            insulated_plural_renovated_tooltip: '',
            consumption_title: 'Votre consommation',
            consumption_title_tooltip: '',
            consumption_yearly_consumption_tooltip: '',
            gas_consumption_known: 'Connaissez-vous la consommation annuelle de gaz ?',
            gas_consumption_known_tooltip: '',
            oil_consumption_known: 'Connaissez-vous la consommation annuelle de mazout ?',
            oil_consumption_known_tooltip: '',
            wood_consumption_known: 'Connaissez-vous la consommation annuelle de bois ?',
            wood_consumption_known_tooltip: '',
            coal_consumption_known:
                'Connaissez-vous la consommation annuelle de charbon ?',
            coal_consumption_known_tooltip: '',
            pellets_consumption_known:
                'Connaissez-vous la consommation annuelle de pellets ?',
            pellets_consumption_known_tooltip: '',
            district_heating_consumption_known:
                'Connaissez-vous la consommation annuelle du r\u00e9seau de chaleur ?',
            district_heating_consumption_known_tooltip: '',
            electricity_consumption_known:
                "Connaissez-vous la consommation annuelle d'\u00e9lectricit\u00e9 ?",
            electricity_consumption_known_tooltip: '',
            gas_consumption_approx: 'Pouvez-vous estimer la consommation de gaz ?',
            gas_consumption_approx_tooltip: '',
            oil_consumption_approx: 'Pouvez-vous estimer la consommation de mazout ?',
            oil_consumption_approx_tooltip: '',
            wood_consumption_approx: 'Pouvez-vous estimer la consommation de bois ?',
            wood_consumption_approx_tooltip: '',
            coal_consumption_approx: 'Pouvez-vous estimer la consommation de charbon ?',
            coal_consumption_approx_tooltip: '',
            pellets_consumption_approx:
                'Pouvez-vous estimer la consommation de pellets ?',
            pellets_consumption_approx_tooltip: '',
            district_heating_consumption_approx:
                'Pouvez-vous estimer la consommation du r\u00e9seau de chaleur ?',
            district_heating_consumption_approx_tooltip: '',
            electricity_consumption_approx:
                "Pouvez-vous estimer la consommation d'\u00e9lectricit\u00e9 ?",
            electricity_consumption_approx_tooltip: '',
            enter_value: 'Veuillez entrer la valeur.',
            enter_value_tooltip: '',
        },
        map_page: {
            '3d_model':
                "Sur base des informations fournies, nous avons pu \u00e9tablir ce mod\u00e8le 3D simplifi\u00e9 de l'habitation. Ceci nous permet de conna\u00eetre et de calculer des infos cl\u00e9s sur le b\u00e2timent, comme les murs mitoyens, les surfaces des murs et l'angle des toits. ",
            '3d_model_tooltip': '',
        },
        address_page: {
            title:
                "Veuillez entrer l'adresse pour r\u00e9cup\u00e9rer les mesures 3D du b\u00e2timent.",
            title_tooltip: '',
            subtitle:
                "Chaque b\u00e2timent est unique. Sur base de l'adresse, nous adaptons les r\u00e9novations aux sp\u00e9cificit\u00e9s de l'habitation. ",
            subtitle_tooltip: '',
            control_address: "Compl\u00e9tez l'adresse si n\u00e9cessaire",
            control_address_tooltip: '',
        },
        validation: {
            range: 'Veuillez introduire un nombre entre {min} et {max}',
            range_tooltip: '',
            field_required: 'Ce champ est obligatoire',
            field_required_tooltip: '',
            only_numbers: 'Veuillez introduire uniquement des chiffres',
            only_numbers_tooltip: '',
            min_4_characters: 'Ce champ requiert au minimum 4 caract\u00e8res',
            min_4_characters_tooltip: '',
            wrong_epc: "Merci d'indiquer un label PEB correct",
            wrong_epc_tooltip: '',
            valid_years: 'Entre {min} et {max}',
            valid_years_tooltip: '',
            value_too_small: 'Ce nombre est trop petit',
            value_too_small_tooltip: '',
            value_too_large: 'Ce nombre est trop grand',
            value_too_large_tooltip: '',
        },
        f_epc: {
            label: 'Label PEB',
            label_tooltip: '',
        },
        features_page: {
            title:
                'Nous aurions besoin de quelques infos pour \u00e9valuer les performances \u00e9nerg\u00e9tiques de l\u2019habitation.',
            title_tooltip: '',
        },
        consumption_page: {
            title:
                "Veuillez nous fournir plus d'informations sur la consommation d'\u00e9nergie.",
            title_tooltip: '',
            info:
                'Les gros consommateurs d\u2019\u00e9nergie sont les v\u00e9hicules enti\u00e8rement \u00e9lectriques, la climatisation, une piscine ou une salle de spa.',
            info_tooltip: '',
            big_consumer:
                'Le m\u00e9nage alimente-t-il les gros consommateurs d\u2019\u00e9nergie \u00e0 la maison ?',
            big_consumer_tooltip: '',
        },
        login_page: {
            login: "Nom d'utilisateur",
            login_tooltip: '',
        },
        wall_insulation_page: {
            info_tooltip: '',
        },
        roof_insulation_page: {
            info_tooltip: '',
        },
        building_dimensions_page: {
            is_flat: 'est plat',
            is_flat_tooltip: '',
            title_tooltip: '',
            subtitle_tooltip: '',
            floors_title_tooltip: '',
            floors_info_tooltip: '',
            roof_title_tooltip: '',
            tooltip_roof_type_tooltip: '',
            roof_pitched_tooltip: '',
            roof_flat_tooltip: '',
            roof_mixed_tooltip: '',
            facades_title_tooltip: '',
            tooltip_common_facades_tooltip: '',
            facades_type_0_tooltip: '',
            facades_type_1_tooltip: '',
            facades_type_2_tooltip: '',
        },
        welcome_page: {
            title:
                'Simulez des r\u00e9novations \u00e9nerg\u00e9tiques pour des maisons r\u00e9sidentielles',
            title_tooltip: '',
            text_welcome: 'Bienvenue!',
            text_welcome_tooltip: '',
            text_intro:
                "Ce simulateur de r\u00e9novation \u00e9nerg\u00e9tique vous permet de d\u00e9couvrir quelles sont les r\u00e9novations les plus adapt\u00e9es pour r\u00e9duire le score \u00e9nerg\u00e9tique d'une maison.",
            text_intro_tooltip: '',
            text_description:
                'Nous commen\u00e7ons par estimer le score EPC actuel de la propri\u00e9t\u00e9. Apr\u00e8s cela, vous serez en mesure de simuler les r\u00e9novations \u00e9co\u00e9nerg\u00e9tiques les plus rentables pour atteindre votre objectif de r\u00e9novation.',
            text_description_tooltip: '',
            'info-bubble':
                'Les simulations de r\u00e9novation \u00e9nerg\u00e9tique sont <b>limit\u00e9es aux maisons individuelles.</b> ',
            'info-bubble_tooltip': '',
            button_start: 'D\u00e9marrer la simulation',
            button_start_tooltip: '',
            terms: "Conditions G\u00e9n\u00e9rales d'Utilisation",
            terms_tooltip: '',
            curious:
                'Quelles sont les r\u00e9novations \u00e0 prioriser pour r\u00e9duire la consommation \u00e9nerg\u00e9tique de votre habitation ?',
            curious_tooltip: '',
        },
        error_page: {
            title: 'Une erreur est survenue',
            title_tooltip: '',
            intro:
                'Le service est momentan\u00e9ment indisponible. Veuillez r\u00e9essayer plus tard.',
            intro_tooltip: '',
            button: 'Retour au site web ING',
            button_tooltip: '',
        },
        insulation: {
            title: "De quelle mani\u00e8re est isol\u00e9e l'habitation ?",
            title_tooltip: '',
        },
        consumption: {
            gas_consumption_title: 'Consommation de gaz',
            gas_consumption_title_tooltip: '',
            oil_consumption_title: 'Consommation de mazout',
            oil_consumption_title_tooltip: '',
            wood_consumption_title: 'Consommation de bois',
            wood_consumption_title_tooltip: '',
            coal_consumption_title: 'Consommation de charbon',
            coal_consumption_title_tooltip: '',
            pellets_consumption_title: 'Consommation de pellets',
            pellets_consumption_title_tooltip: '',
            district_heating_consumption_title: 'Consommation du r\u00e9seau de chaleur',
            district_heating_consumption_title_tooltip: '',
            electricity_consumption_title: "Consommation d'\u00e9lectricit\u00e9",
            electricity_consumption_title_tooltip: '',
        },
        consumers_page: {
            info_tooltip: '',
            title: "Veuillez nous donner plus d'infos sur la consommation d'\u00e9nergie",
            title_tooltip: '',
        },
        ventilation_page: {
            ventilation_title: 'Ventilation',
            ventilation_title_tooltip: '',
        },
        energy_quizz: {
            solar: {
                qa: {
                    q:
                        "D'apr\u00e8s nos donn\u00e9es, voici comment il faudrait placer les panneaux solaires sur le toit. Est-ce que cela semble correct ?",
                    q_tooltip: '',
                    a1: "Oui, c'est correct",
                    a1_tooltip: '',
                    a2: "Non, ce n'est pas le c\u00f4t\u00e9 le plus ensoleill\u00e9",
                    a2_tooltip: '',
                    a3: 'Non, la surface ne convient pas',
                    a3_tooltip: '',
                },
                qb: {
                    q:
                        "Vous avez indiqu\u00e9 qu'il y a des panneaux solaires. Nous estimons que le toit de l'habitation peut accueillir {x} panneaux. Est-ce que cela semble correct ?",
                    q_tooltip: '',
                    a1: "Oui, c'est correct",
                    a1_tooltip: '',
                    a2: "Non, c'est impossible ",
                    a2_tooltip: '',
                    a3:
                        'Oui, mais nous avons d\u00e9cid\u00e9 de placer une autre quantit\u00e9 de panneaux solaires.',
                    a3_tooltip: '',
                },
            },
            q1: {
                q:
                    'Laquelle de ces affirmations \u00e0 propos des panneaux solaires est correcte ?',
                q_tooltip: '',
                a1: 'Les panneaux solaires sont rentables au bout de 15 ans en moyenne.',
                a1_tooltip: '',
                f1:
                    'R\u00e9ponse incorrecte. Les panneaux solaires sont rentables au bout de 6 \u00e0 8 ans. La r\u00e9ponse correcte est la num\u00e9ro 2.',
                f1_tooltip: '',
                a2:
                    "Les panneaux solaires permettent d'obtenir un meilleur PEB pour une habitation. Un meilleur PEB augmente la valeur de l'habitation.",
                a2_tooltip: '',
                f2: 'R\u00e9ponse correcte.',
                f2_tooltip: '',
                a3:
                    "Les panneaux solaires ne peuvent pas \u00eatre utilis\u00e9s pour chauffer de l'eau.",
                a3_tooltip: '',
                f3:
                    "R\u00e9ponse incorrecte. Il existe deux moyens de chauffer de l'eau avec des panneaux solaires : avec un chauffe-eau solaire, ou en alimentant le chauffe-eau. La bonne r\u00e9ponse est la 2.",
                f3_tooltip: '',
            },
            q2: {
                q:
                    "Dans quel ordre vaut-il mieux effectuer des travaux pour am\u00e9liorer l'efficacit\u00e9 \u00e9nerg\u00e9tique d'une maison ?",
                q_tooltip: '',
                a1: 'Murs - toit - ch\u00e2ssis - sols - syst\u00e8me de chauffage',
                a1_tooltip: '',
                f1: 'R\u00e9ponse incorrecte. La bonne r\u00e9ponse est la 2.',
                f1_tooltip: '',
                a2: 'Toit - murs - ch\u00e2ssis - sols - syst\u00e8me de chauffage',
                a2_tooltip: '',
                f2: 'R\u00e9ponse correcte.',
                f2_tooltip: '',
                a3: 'Toit - murs - sols - ch\u00e2ssis - syst\u00e8me de chauffage',
                a3_tooltip: '',
                f3: 'R\u00e9ponse incorrecte. La bonne r\u00e9ponse est la 2.',
                f3_tooltip: '',
                a4: 'Murs - toit - ch\u00e2ssis - sols - syst\u00e8me de chauffage',
                a4_tooltip: '',
                f4: 'R\u00e9ponse incorrecte. La bonne r\u00e9ponse est la 2.',
                f4_tooltip: '',
            },
            q3: {
                q:
                    "Que peut-on faire quand des panneaux solaires g\u00e9n\u00e8rent un surplus de production d'\u00e9nergie ?",
                q_tooltip: '',
                a1: 'Rien. Le surplus est perdu.',
                a1_tooltip: '',
                f1:
                    'R\u00e9ponse incorrecte. Ces surplus peuvent \u00eatre rentabilis\u00e9s. La bonne r\u00e9ponse est la 3.',
                f1_tooltip: '',
                a2: "Stocker l'\u00e9nergie pour plus tard.",
                a2_tooltip: '',
                f2:
                    "R\u00e9ponse incorrecte. On peut stocker une partie de l'\u00e9nergie solaire dans une batterie, mais pas l'enti\u00e8ret\u00e9, et pour une dur\u00e9e d\u00e9termin\u00e9e seulement. La bonne r\u00e9ponse est la 3.",
                f2_tooltip: '',
                a3:
                    "Vendre le surplus d'\u00e9nergie \u00e0 un fournisseur ou un distributeur d'\u00e9nergie. ",
                a3_tooltip: '',
                f3: 'R\u00e9ponse correcte.',
                f3_tooltip: '',
            },
            q4: {
                q:
                    'Parmi les astuces suivantes pour r\u00e9duire sa facture de gaz sans passer par des travaux, laquelle est d\u00e9conseill\u00e9e ?',
                q_tooltip: '',
                a1:
                    'Couvrir de film aluminium les murs non isol\u00e9s derri\u00e8re les radiateurs.',
                a1_tooltip: '',
                f1:
                    "R\u00e9ponse incorrecte. Poser un film aluminium entre des murs non isol\u00e9s et des radiateurs aide bel et bien \u00e0 r\u00e9duire la d\u00e9perdition de chaleur. Il s'agit donc d'un bon moyen de r\u00e9duire la consommation de gaz. La bonne r\u00e9ponse est la 3.",
                f1_tooltip: '',
                a2:
                    'Isoler les tuyaux de chauffage qui vont de la chaudi\u00e8re aux radiateurs situ\u00e9s au grenier ou \u00e0 la cave.',
                a2_tooltip: '',
                f2:
                    'R\u00e9ponse incorrecte. Isoler les tuyaux de chauffage dans les pi\u00e8ces non chauff\u00e9es contribue \u00e0 r\u00e9duire la d\u00e9perdition de chaleur, et donc la consommation de gaz. La bonne r\u00e9ponse est la 3.',
                f2_tooltip: '',
                a3: 'Chauffer avec une chaufferette \u00e9lectrique',
                a3_tooltip: '',
                f3:
                    "R\u00e9ponse correcte. Les chaufferettes \u00e9lectriques consomment beaucoup d'\u00e9lectricit\u00e9. Leur utilisation est couteuse et mauvaise pour l'environnement.",
                f3_tooltip: '',
            },
            q5: {
                q:
                    "Laquelle de ces mesures r\u00e9duit le plus les \u00e9missions de CO2 d'une habitation ?",
                q_tooltip: '',
                a1: 'Ne pas utiliser de s\u00e8che-linge.',
                a1_tooltip: '',
                f1: 'R\u00e9ponse incorrecte. La bonne r\u00e9ponse est la 2.',
                f1_tooltip: '',
                a2: 'Installer du chauffage par le sol.',
                a2_tooltip: '',
                f2: 'R\u00e9ponse correcte.',
                f2_tooltip: '',
                a3: 'Douche om de twee dagen',
                a3_tooltip: '',
                f3: 'R\u00e9ponse incorrecte. La bonne r\u00e9ponse est la 2.',
                f3_tooltip: '',
            },
            q6: {
                q: "Laquelle de ces affirmations n'est pas correcte ?",
                q_tooltip: '',
                a1:
                    "Isoler les sols est plus efficace en termes d'efficacit\u00e9 \u00e9nerg\u00e9tique qu'isoler les murs. ",
                a1_tooltip: '',
                f1: 'R\u00e9ponse correcte.',
                f1_tooltip: '',
                a2:
                    'Isoler son toit est plus efficace pour r\u00e9duire les \u00e9missions de CO2 que poser des panneaux solaires.',
                a2_tooltip: '',
                f2:
                    'R\u00e9ponse incorrecte. Isoler son toit est une meilleure mesure pour r\u00e9duire les \u00e9missions de CO2 que poser des panneaux solaires. La bonne r\u00e9ponse est la 1.',
                f2_tooltip: '',
                a3:
                    'Remplacer ses ch\u00e2ssis a un impact sup\u00e9rieur que remplacer son syst\u00e8me de chauffage.',
                a3_tooltip: '',
                f3:
                    "R\u00e9ponse incorrecte. Remplacer ses ch\u00e2ssis permet d'\u00e9conomiser plus d'\u00e9nergie qu'installer un nouveau syst\u00e8me de chauffage. La bonne r\u00e9ponse est la 1.",
                f3_tooltip: '',
            },
            discovery_phase: 'Phase de d\u00e9couverte',
            discovery_phase_tooltip: '',
            discovery_description:
                "C'est d\u00e9j\u00e0 pas mal ! Il faut du temps pour ma\u00eetriser le sujet de l'\u00e9nergie. Restez curieux(se) et vous apprendrez d'autres fa\u00e7ons d'\u00e9conomiser de l'\u00e9nergie.  ",
            discovery_description_tooltip: '',
            learning_phase: "Phase d'apprentissage",
            learning_phase_tooltip: '',
            learning_description:
                "Ne vous arr\u00eatez pas en si bon chemin ! Vous savez d\u00e9j\u00e0 tr\u00e8s bien comment obtenir une habitation plus \u00e9conome en \u00e9nergie. Continuez \u00e0 d\u00e9couvrir d'autres fa\u00e7ons de r\u00e9aliser des \u00e9conomies d'\u00e9nergie !",
            learning_description_tooltip: '',
            expert_phase: "Phase d'expertise",
            expert_phase_tooltip: '',
            expert_description:
                "F\u00e9licitations ! Vous \u00eates expert(e) en \u00e9conomies d'\u00e9nergie pour votre habitation. Il est temps de mettre tout cela  en pratique !",
            expert_description_tooltip: '',
        },
        ers_report: {
            language: 'FR',
            language_tooltip: '',
            header_title: "L'efficacit\u00e9 \u00e9nerg\u00e9tique actuelle",
            header_title_tooltip: '',
            header_subtitle:
                'Sur la base des informations fournies, nous avons estim\u00e9 le PEB actuel. Ceci ne remplace pas un certificat PEB*',
            header_subtitle_tooltip: '',
            header_subtitle_pdf:
                'Sur la base des informations fournies, nous avons estim\u00e9 le PEB actuel. Ceci ne remplace pas un certificat PEB*',
            header_subtitle_pdf_tooltip: '',
            epc_graph_title: "L'estimation du score PEB actuel est de {x}*",
            epc_graph_title_tooltip: '',
            epc_graph_subtitle:
                "Comme le montre l'histogramme, {x}% des habitations de {region} ont un meilleur label PEB.",
            epc_graph_subtitle_tooltip: '',
            consumption_title: "Consommation de l'habitation",
            consumption_title_tooltip: '',
            gas_title: 'Gaz',
            gas_title_tooltip: '',
            electric_title: 'Electricit\u00e9',
            electric_title_tooltip: '',
            low_title: 'Bas',
            low_title_tooltip: '',
            high_title: 'Haut',
            high_title_tooltip: '',
            average_title: 'Moyen',
            average_title_tooltip: '',
            you_title: 'Vous',
            you_title_tooltip: '',
            current_epc: 'PEB actuel',
            current_epc_tooltip: '',
            future_epc: 'Futur PEB',
            future_epc_tooltip: '',
            summary_input_title: 'R\u00e9sum\u00e9 du questionnaire',
            summary_input_title_tooltip: '',
            summary_title: 'R\u00e9sum\u00e9',
            summary_title_tooltip: '',
            summary_note:
                'Les prix et primes indiqu\u00e9s ici sont fournis \u00e0 titre indicatif. Les prix sont TVAC inclus.** ',
            summary_note_tooltip: '',
            price_title: 'Prix',
            price_title_tooltip: '',
            subsidy_title: 'Subs.',
            subsidy_title_tooltip: '',
            after_subsidy_title: 'Apr\u00e8s subs.',
            after_subsidy_title_tooltip: '',
            total_title: 'Total',
            total_title_tooltip: '',
            calculate_button_text: 'Calculer mon pr\u00eat ING',
            calculate_button_text_tooltip: '',
            download_report: 'T\u00e9l\u00e9charger mon rapport',
            download_report_tooltip: '',
            renovation_title: 'Votre objectif de r\u00e9novation',
            renovation_title_tooltip: '',
            renovation_subtitle:
                'Quel est votre objectif de r\u00e9novation ? S\u00e9lectionnez un ensemble de mesures pour voir lequel convient \u00e0 votre objectif. Ou s\u00e9lectionnez des mesures de r\u00e9novation pour d\u00e9couvrir \u00e0 quel score PEB elles correspondent.',
            renovation_subtitle_tooltip: '',
            renovation_price: 'Prix ',
            renovation_price_tooltip: '',
            renovation_subsidy: 'Subside',
            renovation_subsidy_tooltip: '',
            renovation_area: 'Superficie',
            renovation_area_tooltip: '',
            renovation_insulation_type: "Type d'isolation",
            renovation_insulation_type_tooltip: '',
            renovation_yearly: 'Economies annuelles',
            renovation_yearly_tooltip: '',
            renovation_windowsDouble: 'Ch\u00e2ssis',
            renovation_windowsDouble_tooltip: '',
            renovation_wallExt: 'Mur ext\u00e9rieur',
            renovation_wallExt_tooltip: '',
            renovation_wallCav: 'Isolation par la coulisse',
            renovation_wallCav_tooltip: '',
            renovation_roofIn: 'Toiture int\u00e9rieure',
            renovation_roofIn_tooltip: '',
            renovation_roofExt: 'Toiture ext\u00e9rieure',
            renovation_roofExt_tooltip: '',
            renovation_roofIn_attic_floor: 'Sol du grenier',
            renovation_roofIn_attic_floor_tooltip: '',
            renovation_condGas: 'Chaudi\u00e8re',
            renovation_condGas_tooltip: '',
            renovation_heatPump: 'Pompe \u00e0 chaleur',
            renovation_heatPump_tooltip: '',
            renovation_ventC: 'Ventilation type C',
            renovation_ventC_tooltip: '',
            renovation_solar: 'Panneaux solaires',
            renovation_solar_tooltip: '',
            compliance_pack_title: 'Bon d\u00e9part',
            compliance_pack_title_tooltip: '',
            compliance_pack_desc:
                'Je veux commencer \u00e0 am\u00e9liorer les performances \u00e9nerg\u00e9tiques de cette habitation.',
            compliance_pack_desc_tooltip: '',
            budget_pack_title: 'Budget vert',
            budget_pack_title_tooltip: '',
            budget_pack_desc:
                'Je veux optimiser un budget de x euros d\u00e9di\u00e9 aux r\u00e9novations \u00e9nerg\u00e9tiques.',
            budget_pack_desc_tooltip: '',
            lowest_pack_title: 'BENovation',
            lowest_pack_title_tooltip: '',
            lowest_pack_desc:
                'Je veux voir ce que donnerait une r\u00e9novation \u00e9nerg\u00e9tique totale de mon habitation.',
            lowest_pack_desc_tooltip: '',
            custom_pack_title: 'Personnalis\u00e9',
            custom_pack_title_tooltip: '',
            custom_pack_desc:
                'Je veux choisir moi-m\u00eame des mesures et travaux \u00e0 entreprendre en priorit\u00e9.',
            custom_pack_desc_tooltip: '',
            add_remove_renovations: 'Ajouter ou retirer des travaux de r\u00e9novation.',
            add_remove_renovations_tooltip: '',
            submit_button_budget: 'Soumettre',
            submit_button_budget_tooltip: '',
            already_compilance:
                "Fantastique ! Le score PEB de l'habitation est d\u00e9j\u00e0 moins de 400. Cliquez sur les autres ensembles de mesures si vous voulez d\u00e9couvrir quels autres travaux vous pourriez entreprendre.",
            already_compilance_tooltip: '',
            no_renovation_found:
                "Aucune r\u00e9novation trouv\u00e9e. Merci d'indiquer votre budget vert.",
            no_renovation_found_tooltip: '',
            renovation_subtitle_compliance_pdf:
                "F\u00e9licitations pour votre Bon D\u00e9part ! Un budget de {montant} euros peut faire passer le score PEB de votre habitation de {score}_epc_actuel \u00e0 {score}_epc_futur{'.'} \n\nVous trouverez ci-dessous l'ensemble de mesures le plus rentable pour vous permettre d'atteindre cet objectif, ainsi que les \u00e9conomies annuelles que vous pourriez faire et une indication du montant de subventions que vous pourriez toucher. \n\nPour plus d'informations sur les subventions, veuillez consulter les sites web suivants :\n- Pour la Wallonie : https://energie.wallonie.be/fr/primes.html?IDC=7015\n- Pour Bruxelles : https://renolution.brussels/fr\n- Pour la Flandre : https://www.mijnbenovatie.be/nl/wat-waarom/benovatiepremies-2022/",
            renovation_subtitle_compliance_pdf_tooltip: '',
            renovation_subtitle_budget_pdf:
                "F\u00e9licitations pour votre budget vert ! Votre objectif de r\u00e9novation est d'optimiser un budget de {amount} euros. Cet investissement peut faire passer le score PEB de votre habitation de {current_epc_score} \u00e0 {future_epc_score}. \n\nVous trouverez ci-dessous l'ensemble de mesures le plus rentable pour vous permettre d'atteindre cet objectif, ainsi que les \u00e9conomies annuelles que vous pourriez faire et une indication du montant de subventions que vous pourriez toucher. \n\nPour plus d'informations sur les subventions, veuillez consulter les sites web suivants :\n- Pour la Wallonie : https://energie.wallonie.be/fr/primes.html?IDC=7015\n- Pour Bruxelles : https://renolution.brussels/fr\n- Pour la Flandre : https://www.mijnbenovatie.be/nl/wat-waarom/benovatiepremies-2022/",
            renovation_subtitle_budget_pdf_tooltip: '',
            renovation_subtitle_custom_pdf:
                "F\u00e9licitations pour votre budget personnalis\u00e9 ! Un budget de {amount} euros peut faire passer le score PEB de votre habitation de {current_epc_score} \u00e0 {future_epc_score}. \n\nVous trouverez ci-dessous l'ensemble de mesures le plus rentable pour vous permettre d'atteindre cet objectif, ainsi que les \u00e9conomies annuelles que vous pourriez faire et une indication du montant de subventions que vous pourriez toucher. \n\nPour plus d'informations sur les subventions, veuillez consulter les sites web suivants :\n- Pour la Wallonie : https://energie.wallonie.be/fr/primes.html?IDC=7015\n- Pour Bruxelles : https://renolution.brussels/fr\n- Pour la Flandre : https://www.mijnbenovatie.be/nl/wat-waarom/benovatiepremies-2022/",
            renovation_subtitle_custom_pdf_tooltip: '',
            disclaimer: {
                title: 'Mentions l\u00e9gales',
                title_tooltip: '',
                body1:
                    "L'estimation du score PEB actuel est bas\u00e9e sur les informations fournies dans le questionnaire, combin\u00e9es aux donn\u00e9es du b\u00e2timent et aux normes techniques telles qu'indiqu\u00e9es par le logiciel PEB officiel. Plus ces informations sont pr\u00e9cises, mieux nous pouvons estimer le score PEB r\u00e9el.",
                body1_tooltip: '',
                body2: 'Ceci ne remplace pas un certificat PEB officiel',
                body2_tooltip: '',
                body3: "et n'est fourni qu'\u00e0 titre d'information uniquement.",
                body3_tooltip: '',
                body4: 'Les',
                body4_tooltip: '',
                body5: 'prix indiqu\u00e9s dans le pr\u00e9sent rapport sont indicatifs',
                body5_tooltip: '',
                body6:
                    "et doivent \u00eatre consid\u00e9r\u00e9s comme des estimations. Les co\u00fbts r\u00e9els peuvent varier en fonction de l'\u00e9tat de la maison, des d\u00e9tails sp\u00e9cifiques du projet et d'autres facteurs.",
                body6_tooltip: '',
                body7:
                    'Pour obtenir une certification PEB pr\u00e9cise et officielle et une \u00e9valuation d\u00e9taill\u00e9e des co\u00fbts, veuillez consulter un professionnel qualifi\u00e9 dans le domaine concern\u00e9.',
                body7_tooltip: '',
            },
            disclaimer_body:
                "*L'estimation du score PEB actuel est bas\u00e9e sur les informations fournies dans le questionnaire, combin\u00e9es aux donn\u00e9es du b\u00e2timent et aux normes techniques telles qu'indiqu\u00e9es par le logiciel PEB officiel. Plus ces informations sont pr\u00e9cises, mieux nous pouvons estimer le score PEB r\u00e9el. Ceci ne remplace pas un certificat PEB officiel. Veuillez consulter un professionnel pour obtenir des conseils personnalis\u00e9s. \n**Les prix incluent la TVA de 6\u00a0% ou 21\u00a0%, en fonction des donn\u00e9es fournies. Ils ne comprennent pas les travaux structurels suppl\u00e9mentaires qui pourraient \u00eatre requis avant les travaux de r\u00e9novation \u00e9nerg\u00e9tique. Nous actualisons r\u00e9guli\u00e8rement les prix et les subventions. Ils peuvent donc varier avec le temps. De m\u00eame, les subventions peuvent \u00eatre diff\u00e9rentes en fonction de votre situation. Consultez toujours un professionnel pour obtenir des conseils personnalis\u00e9s. \n\n",
            disclaimer_body_tooltip: '',
            disclaimer_body_pdf:
                "*L'estimation du score PEB actuel est bas\u00e9e sur les informations fournies dans le questionnaire, combin\u00e9es aux donn\u00e9es du b\u00e2timent et aux normes techniques telles qu'indiqu\u00e9es par le logiciel PEB officiel. Plus ces informations sont pr\u00e9cises, mieux nous pouvons estimer le score PEB r\u00e9el. Ceci ne remplace pas un certificat PEB officiel. Veuillez consulter un professionnel pour obtenir des conseils personnalis\u00e9s. \n**Les prix incluent la TVA de 6\u00a0% ou 21\u00a0%, en fonction des donn\u00e9es fournies. Ils ne comprennent pas les travaux structurels suppl\u00e9mentaires qui pourraient \u00eatre requis avant les travaux de r\u00e9novation \u00e9nerg\u00e9tique. Nous actualisons r\u00e9guli\u00e8rement les prix et les subventions. Ils peuvent donc varier avec le temps. De m\u00eame, les subventions peuvent \u00eatre diff\u00e9rentes en fonction de votre situation. Consultez toujours un professionnel pour obtenir des conseils personnalis\u00e9s. ",
            disclaimer_body_pdf_tooltip: '',
            property_page: {
                title:
                    'Augmentation de la valeur estim\u00e9e de votre propri\u00e9t\u00e9',
                title_tooltip: '',
                subtitle:
                    "Nous estimons l'augmentation de la valeur immobili\u00e8re en la comparant aux annonces de biens sur le march\u00e9 ayant des scores EPC similaires \u00e0 celui actuel et au score EPC cible. Veuillez noter qu'il s'agit d'un calcul automatique qui refl\u00e8te les conditions du march\u00e9 actuel. Pour une \u00e9valuation officielle de votre maison apr\u00e8s r\u00e9novation, il est conseill\u00e9 de consulter un professionnel certifi\u00e9.",
                subtitle_tooltip: '',
                info_bubble:
                    "Avec un score EPC de {future_epc} kWh/m\u00b2, l'augmentation de la valeur marchande actuelle est estim\u00e9e \u00e0 {val}.",
                info_bubble_tooltip: '',
                section_title: 'Vos \u00e9conomies \u00e9nerg\u00e9tiques',
                section_title_tooltip: '',
                epc_title: 'Score PEB r\u00e9duit',
                epc_title_tooltip: '',
                epc_text:
                    "Ce chiffre repr\u00e9sente l'am\u00e9lioration totale du score EPC de votre maison apr\u00e8s la mise en \u0153uvre de votre plan de r\u00e9novation \u00e9nerg\u00e9tique. En pratique, il exprime combien de kWh vous \u00e9conomisez chaque ann\u00e9e pour maintenir une temp\u00e9rature constante de 18\u00b0C par m\u00e8tre carr\u00e9. Multipliez cela par la surface totale du plancher chauff\u00e9 pour savoir combien de kWh vous \u00e9conomisez au total. Il est important de noter que l'am\u00e9lioration r\u00e9elle pourrait varier en fonction de facteurs tels que le choix des technologies et des mat\u00e9riaux d'isolation pour la r\u00e9novation.",
                epc_text_tooltip: '',
                carbon_title: 'R\u00e9duction des \u00e9missions de carbone',
                carbon_title_tooltip: '',
                carbon_text:
                    "C'est la quantit\u00e9 de kilogrammes d'\u00e9missions de carbone que vous pouvez \u00e9conomiser chaque ann\u00e9e gr\u00e2ce \u00e0 ce plan de r\u00e9novation. Les r\u00e9novations \u00e9nerg\u00e9tiques r\u00e9duisent la d\u00e9pendance de votre maison aux combustibles fossiles pour alimenter vos appareils et chauffer les pi\u00e8ces et l'eau. Ce chiffre suppose que votre m\u00e9nage ne modifie pas son comportement de consommation d'\u00e9nergie apr\u00e8s les r\u00e9novations.",
                carbon_text_tooltip: '',
                bill_title: 'R\u00e9duction des factures d\u2019\u00e9nergie',
                bill_title_tooltip: '',
                bill_text:
                    "Voici les \u00e9conomies potentielles mensuelles sur votre facture d'\u00e9nergie en euros suite aux r\u00e9novations, en fonction de la consommation \u00e9nerg\u00e9tique annuelle fournie dans le questionnaire. Nous mettons r\u00e9guli\u00e8rement \u00e0 jour les prix de l'\u00e9nergie. Veuillez noter que ces \u00e9conomies estim\u00e9es supposent que vos habitudes de consommation d'\u00e9nergie restent constantes. Les \u00e9conomies r\u00e9elles peuvent varier en raison des fluctuations de prix et des changements dans les habitudes de consommation d'\u00e9nergie de votre foyer.",
                bill_text_tooltip: '',
            },
            renovation: {
                title: {
                    gtk: 'Bon \u00e0 savoir',
                    gtk_tooltip: '',
                    works: "Qui y a-t'il d'inclus?",
                    works_tooltip: '',
                    subsidies: 'Subsides et primes',
                    subsidies_tooltip: '',
                },
                roofIn: {
                    gtk:
                        "Le toit est la principale source de perte de chaleur dans un b\u00e2timent, il est donc recommand\u00e9 de commencer par isoler le toit. L'isolation du toit par l'int\u00e9rieur est plus facile \u00e0 installer et moins ch\u00e8re que l'isolation ext\u00e9rieure. Gardez \u00e0 l'esprit que l'isolation prendra une partie de l'espace du grenier. En revanche, l'isolation ext\u00e9rieure du toit ne r\u00e9duit pas l'espace int\u00e9rieur et offre une isolation plus efficace. Les co\u00fbts varient en fonction du type de toit et des mat\u00e9riaux utilis\u00e9s. Si vous n'utilisez pas l'espace du grenier comme zone chauff\u00e9e, envisagez d'isoler le plancher du grenier \u00e0 la place.",
                    gtk_tooltip: '',
                    works:
                        "enl\u00e8vement de la couche isolante d\u00e9grad\u00e9e (y compris le pare-vapeur), installation d'une nouvelle couche isolante et d'un pare-vapeur, et ajustements autour du plan de la toiture et des lucarnes.",
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/e3-toiture-isolation-thermique-de-la-toiture',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-dak',
                        subsidies_tooltip: '',
                    },
                },
                roofExt: {
                    gtk:
                        "Le toit est la principale source de perte de chaleur dans un b\u00e2timent, il est donc recommand\u00e9 de commencer par isoler le toit. L'isolation du toit par l'ext\u00e9rieur pr\u00e9sente l'avantage de ne pas r\u00e9duire l'espace sous le toit, ce qui permet de maintenir la propret\u00e9 de la maison et son habitabilit\u00e9 pendant les travaux. Elle permet \u00e9galement d'installer le mat\u00e9riau d'isolation le plus \u00e9pais. Cependant, l'isolation ext\u00e9rieure est une option plus co\u00fbteuse par rapport \u00e0 l'isolation int\u00e9rieure du toit. Le co\u00fbt total d\u00e9pend du type de toit et des mat\u00e9riaux utilis\u00e9s. L'isolation ext\u00e9rieure du toit est un bon choix pour un toit plat ou lorsque vous utilisez l'espace sous le toit comme une pi\u00e8ce chauff\u00e9e.",
                    gtk_tooltip: '',
                    works:
                        "d\u00e9molition de la couverture et de la structure du toit, d\u00e9molition des goutti\u00e8res, installation de l'isolation et d'un pare-vapeur, mise en place de la structure et -de la couverture du toit, travail autour des \u00e9vents de toit, mise en place des goutti\u00e8res, enl\u00e8vement et r\u00e9installation des panneaux solaires s'ils sont d\u00e9j\u00e0 pr\u00e9sents et grue ou palan.",
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/e3-toiture-isolation-thermique-de-la-toiture',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-dak',
                        subsidies_tooltip: '',
                    },
                },
                atticFloor: {
                    gtk:
                        "Le toit est la principale source de perte de chaleur dans un b\u00e2timent, il est donc recommand\u00e9 de commencer par isoler le toit. Si l'espace du grenier n'est pas utilis\u00e9 comme une pi\u00e8ce chauff\u00e9e, l'isolation du plancher du grenier peut \u00eatre un choix \u00e9conomique pour pr\u00e9venir les pertes de chaleur par le toit. C'est beaucoup moins cher que l'isolation du toit lui-m\u00eame. Cela s'explique principalement par la plus petite surface \u00e0 isoler et le minimum, voire l'absence, de finition requise. Le processus d'installation est relativement rapide et simple. Cependant, ce n'est peut-\u00eatre pas le meilleur choix si vous envisagez un jour d'utiliser l'espace du grenier comme une pi\u00e8ce chauff\u00e9e.",
                    gtk_tooltip: '',
                    works:
                        "installation d'une isolation et d'un pare-vapeur, modification des canalisations et de l'\u00e9clairage existants et am\u00e9nagement de l'acc\u00e8s.",
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/h1-sols-et-planchers-isolation-thermique-de-sol-et-plancher',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-vloer',
                        subsidies_tooltip: '',
                    },
                },
                wallExt: {
                    gtk:
                        "Apr\u00e8s avoir isol\u00e9 le toit, il est recommand\u00e9 d'isoler les murs. L'isolation des murs ext\u00e9rieurs le long de la fa\u00e7ade ext\u00e9rieure pr\u00e9sente l'avantage de ne pas perdre d'espace de vie, et la maison reste habitable pendant les travaux. Elle contribue \u00e9galement \u00e0 r\u00e9duire les bruits ext\u00e9rieurs. Assurez-vous toujours que la maison convient \u00e0 l'isolation des murs ext\u00e9rieurs. \u00c9tant donn\u00e9 que les caract\u00e9ristiques esth\u00e9tiques de la fa\u00e7ade peuvent changer, il peut y avoir des exigences relatives \u00e0 un permis de construire, par exemple, si vous r\u00e9novez un b\u00e2timent historique.",
                    gtk_tooltip: '',
                    works:
                        "d\u00e9molir l'\u00e9vacuation des eaux pluviales, scier les seuils, installer l'isolation, placer les finitions (en cr\u00e9pi), mettre \u00e0 jour les ouvertures (y compris les seuils), effectuer des travaux de r\u00e9vision, agrandir la saillie du toit, renouveler l'\u00e9vacuation des eaux pluviales, et un \u00e9chafaudage.",
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/f1-facades-isolation-thermique-des-facades',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-buitenmuur',
                        subsidies_tooltip: '',
                    },
                },
                wallIn: {
                    gtk:
                        "Apr\u00e8s l'isolation du toit, il est recommand\u00e9 de poursuivre avec l'isolation des murs. Contrairement \u00e0 l'isolation ext\u00e9rieure des murs, l'isolation int\u00e9rieure a certaines limites. Elle peut r\u00e9duire votre espace de vie puisqu'elle est install\u00e9e \u00e0 l'int\u00e9rieur de votre maison. Toutefois, elle constitue g\u00e9n\u00e9ralement une option plus rentable que l'isolation ext\u00e9rieure. Il est important de noter que de nombreux mat\u00e9riaux d'isolation doivent \u00eatre recouverts d'un rev\u00eatement ignifuge, car ils peuvent d\u00e9gager des gaz toxiques lorsqu'ils sont expos\u00e9s au feu.",
                    gtk_tooltip: '',
                    works:
                        "d\u00e9molition des plinthes et des montants de fen\u00eatres, installation d'une isolation avec pare-vapeur et grilles de ventilation, application de couches de finition comprenant de nouvelles plinthes et de nouveaux montants de fen\u00eatres, enl\u00e8vement et remplacement des \u00e9l\u00e9ments de chauffage avec r\u00e9glage de l'\u00e9lectricit\u00e9.",
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/f1-facades-isolation-thermique-des-facades',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-buitenmuur',
                        subsidies_tooltip: '',
                    },
                },
                wallCav: {
                    gtk:
                        "Apr\u00e8s avoir isol\u00e9 le toit, il est recommand\u00e9 d'isoler les murs. Tous les b\u00e2timents ne poss\u00e8dent pas une cavit\u00e9 dans leurs murs, alors v\u00e9rifiez si le b\u00e2timent a des murs en cavit\u00e9 ou des murs massifs. L'isolation des murs en cavit\u00e9 peut offrir une excellente isolation thermique \u00e0 un prix abordable. Cependant, soyez conscient des probl\u00e8mes potentiels tels que la condensation et la formation de moisissures. Si la maison est situ\u00e9e dans une r\u00e9gion o\u00f9 il y a beaucoup de pluie entra\u00een\u00e9e par le vent, envisagez des alternatives pour pr\u00e9venir les probl\u00e8mes li\u00e9s \u00e0 l'humidit\u00e9.",
                    gtk_tooltip: '',
                    works:
                        "utilisation d'une nacelle \u00e9l\u00e9vatrice, pose d'une isolation en laine min\u00e9rale de 5 cm comprenant l'inspection, la pr\u00e9paration, l'insufflation et la fermeture des ouvertures.",
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/f1-facades-isolation-thermique-des-facades',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-buitenmuur',
                        subsidies_tooltip: '',
                    },
                },
                windowsDouble: {
                    gtk:
                        "Les anciennes fen\u00eatres peuvent repr\u00e9senter jusqu'\u00e0 30 % des pertes de chaleur dans une maison. La mise \u00e0 niveau vers des fen\u00eatres \u00e9co\u00e9nerg\u00e9tiques, telles que des fen\u00eatres \u00e0 double ou triple vitrage haute performance avec des cadres \u00e9tanches \u00e0 l'air, peut am\u00e9liorer consid\u00e9rablement l'isolation. Si vous pr\u00e9voyez d'isoler les murs, il est conseill\u00e9 de le faire avant ou simultan\u00e9ment avec l'installation de nouvelles fen\u00eatres. Un avantage suppl\u00e9mentaire des nouvelles fen\u00eatres est qu'elles sont plus s\u00e9curitaires en raison de la couche de verre suppl\u00e9mentaire, les rendant plus r\u00e9sistantes aux bris.",
                    gtk_tooltip: '',
                    works:
                        "d\u00e9molition et installation du verre (avec suppl\u00e9ment pour l'\u00e9quipement de levage), d\u00e9molition et installation du cadre, installation du RTO sur le verre, et d\u00e9molition et installation du verre.",
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/g1-portes-et-fenetres-exterieures-placement-et-remplacement-de-portes-et-fenetres,\nhttps://renolution.brussels/fr/aidesfinancieres/g2-portes-et-fenetres-exterieures-reparation-et-adaptation-de-fenetre',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-ramen-en-deuren',
                        subsidies_tooltip: '',
                    },
                },
                condGas: {
                    gtk:
                        "Les chaudi\u00e8res \u00e0 condensation au gaz sont con\u00e7ues pour extraire la chaleur des gaz d'\u00e9chappement produits lors du processus de combustion. **La dur\u00e9e de vie d'une chaudi\u00e8re \u00e0 condensation au gaz est g\u00e9n\u00e9ralement d'environ 15 ans.** En utilisant la chaleur extraite pour pr\u00e9chauffer l'eau, leur efficacit\u00e9 est sup\u00e9rieure \u00e0 celle d'une chaudi\u00e8re traditionnelle. Les chaudi\u00e8res \u00e0 condensation au gaz ont un impact positif sur la note de performance \u00e9nerg\u00e9tique (EPC) d'une habitation. Elles fonctionnent de mani\u00e8re optimale lorsque les murs, le toit et les fen\u00eatres sont bien isol\u00e9s. Consid\u00e9rez l'isolation de votre maison avant d'installer un nouveau syst\u00e8me de chauffage pour obtenir un r\u00e9sultat optimal.",
                    gtk_tooltip: '',
                    works:
                        "d\u00e9molition du g\u00e9n\u00e9rateur existant, installation d'une chaudi\u00e8re \u00e0 gaz \u00e0 condensation, raccordement au g\u00e9n\u00e9rateur existant, co\u00fbts suppl\u00e9mentaires pour le remplacement du syst\u00e8me climatique, isolation des tuyaux non isol\u00e9s.",
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://www.ores.be/autorites-publiques/primes-et-avantages-financiers,\nhttps://www.resa.be/fr/nos-services/les-primes/',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-gascondensatieketel-tot-en-met-31-oktober-2023',
                        subsidies_tooltip: '',
                    },
                },
                heatPump: {
                    gtk:
                        "Les pompes \u00e0 chaleur extraient de l'\u00e9nergie de l'air, du sol ou de l'eau souterraine pour chauffer ou refroidir un espace. Une maison mieux isol\u00e9e perd moins de chaleur et n\u00e9cessite donc une pompe moins puissante. Par cons\u00e9quent, le prix d'une pompe \u00e0 chaleur est plus bas lorsqu'elle est combin\u00e9e \u00e0 d'autres r\u00e9novations \u00e9co\u00e9nerg\u00e9tiques. Une pompe \u00e0 chaleur r\u00e9duit la d\u00e9pendance aux combustibles fossiles, r\u00e9duisant ainsi les \u00e9missions de carbone li\u00e9es \u00e0 votre consommation d'\u00e9nergie. Il existe diff\u00e9rents types de pompes \u00e0 chaleur, comme les pompes g\u00e9othermiques, air-air, air-eau et les syst\u00e8mes hybrides. Les prix varient en fonction du type sp\u00e9cifique de pompe \u00e0 chaleur que vous choisissez.",
                    gtk_tooltip: '',
                    works:
                        "d\u00e9molition du g\u00e9n\u00e9rateur existant, installation d'une pompe \u00e0 chaleur (avec eau du sol ; y compris le forage), raccordement au g\u00e9n\u00e9rateur existant et isolation des tuyaux non isol\u00e9s. Le remplacement du syst\u00e8me de climatisation entra\u00eenera des co\u00fbts suppl\u00e9mentaires.",
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,https://renolution.brussels/fr/aidesfinancieres/j4-chauffage-et-chauffe-eau-chauffage-pompe-chaleur,https://renolution.brussels/fr/aidesfinancieres/j9-chauffage-et-chauffe-eau-chauffe-eau-pompe-chaleur',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-warmtepomp\n',
                        subsidies_tooltip: '',
                    },
                },
                unitPv: {
                    gtk:
                        "Les panneaux solaires peuvent constituer un moyen rentable d'am\u00e9liorer la note de performance \u00e9nerg\u00e9tique (PEB) et de r\u00e9duire vos factures d'\u00e9nergie. Cependant, il est recommand\u00e9 de r\u00e9nover d'abord le toit, les murs, les fen\u00eatres et le syst\u00e8me de chauffage. L'efficacit\u00e9 des panneaux solaires d\u00e9pend de plusieurs facteurs tels que la surface, l'orientation et l'ombrage sur le toit. Dans certains cas, vous pourriez avoir besoin d'un permis pour installer des panneaux solaires, par exemple, si la maison est r\u00e9pertori\u00e9e au registre du patrimoine architectural.",
                    gtk_tooltip: '',
                    works:
                        'installation de panneaux solaires incluant tous les accessoires n\u00e9cessaires.                ',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/carte-dynamique-de-la-wallonie.html?IDC=6185&IDD=144019',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.fluvius.be/nl/thema/premies/premies-voor-huishoudelijke-klanten/premie-zonnepanelen,\nhttps://www.vlaanderen.be/premie-van-fluvius-voor-zonnepanelen-op-gebouwen',
                        subsidies_tooltip: '',
                    },
                },
                works: {
                    lead_in: "Le co\u00fbt total de l'investissement inclut: ",
                    lead_in_tooltip: '',
                },
                ceiling: {
                    gtk:
                        "Le toit est la principale source de perte de chaleur dans un b\u00e2timent, il est donc recommand\u00e9 de commencer par isoler le toit. Il n'est pas possible d'isoler les toits plats de l'int\u00e9rieur. Dans ce sc\u00e9nario, la partie plate du toit est isol\u00e9e depuis le plafond. Il est important de discuter de la faisabilit\u00e9 de cette option avec un professionnel pour \u00e9viter les ponts thermiques et la condensation. L'isolation du toit depuis l'int\u00e9rieur est plus facile \u00e0 installer et moins co\u00fbteuse par rapport \u00e0 l'isolation ext\u00e9rieure. Gardez \u00e0 l'esprit que l'isolation prendra de l'espace dans le grenier. Les co\u00fbts varient en fonction du type de toit et des mat\u00e9riaux utilis\u00e9s. ",
                    gtk_tooltip: '',
                    works:
                        "d\u00e9molition du plafond, installation de l'isolation et de la barri\u00e8re anti-vapeur, couverture du plafond, modifications des tuyaux et de l'\u00e9clairage existants.",
                    works_tooltip: '',
                },
                mixed: {
                    gtk:
                        "Le toit est la principale source de perte de chaleur dans un b\u00e2timent, il est donc recommand\u00e9 de commencer par isoler le toit. Il n'est pas possible d'isoler les toits plats de l'int\u00e9rieur. Dans ce sc\u00e9nario, la partie plate du toit est isol\u00e9e depuis le plafond, et la partie inclin\u00e9e est isol\u00e9e depuis l'int\u00e9rieur du toit. Il est important de discuter de la faisabilit\u00e9 de cette option avec un professionnel pour \u00e9viter les ponts thermiques et la condensation. L'isolation du toit depuis l'int\u00e9rieur est plus facile \u00e0 installer et moins co\u00fbteuse par rapport \u00e0 l'isolation ext\u00e9rieure. Gardez \u00e0 l'esprit que l'isolation prendra de l'espace au plafond. Les co\u00fbts varient en fonction du type de toit et des mat\u00e9riaux utilis\u00e9s. Si vous n'utilisez pas l'espace du grenier comme zone chauff\u00e9e, envisagez d'isoler le plancher du grenier \u00e0 la place. ",
                    gtk_tooltip: '',
                    works:
                        "\nPour l'isolation du plafond : d\u00e9molition du plafond, installation de l'isolation et de la barri\u00e8re anti-vapeur, couverture du plafond, modifications des tuyaux et de l'\u00e9clairage existants.\nPour l'isolation du toit int\u00e9rieur : retrait de la couche isolante d\u00e9grad\u00e9e (y compris la barri\u00e8re anti-vapeur), installation d'une nouvelle couche isolante et d'une barri\u00e8re anti-vapeur, et ajustements autour de la toiture et des lucarnes.",
                    works_tooltip: '',
                },
                subsidies: {
                    lead_in:
                        "Pour plus d'informations sur les subsides et primes, veuillez consulter",
                    lead_in_tooltip: '',
                },
            },
            title1: "L'",
            title1_tooltip: '',
            title2: 'analyse de r\u00e9novation',
            title2_tooltip: '',
            title3_tooltip: '',
            title4: 'de votre bien',
            title4_tooltip: '',
            per_year: 'par an',
            per_year_tooltip: '',
            per_month: 'par mois',
            per_month_tooltip: '',
        },
        processing_page: {
            title_started: 'Votre simulation est en cours de traitement',
            title_started_tooltip: '',
            title_finished: 'Votre simulation est pr\u00eate !',
            title_finished_tooltip: '',
            title_failed: "Une erreur s'est produite lors de votre simulation",
            title_failed_tooltip: '',
            title_pending_long:
                "Votre simulation est en file d'attente. Vous devriez obtenir vos r\u00e9sultats dans <i>{waiting} minutes</i>. Merci pour votre patience.",
            title_pending_long_tooltip: '',
            title_pending_medium:
                "Votre simulation est en cours de traitement. Vos resultats seront disponibles d'ici environ <i>{waiting} secondes</i>.",
            title_pending_medium_tooltip: '',
            title_pending_short:
                'Nous rassemblons vos donn\u00e9es. Vos r\u00e9sultats seront <i>bient\u00f4t</i> disponibles !',
            title_pending_short_tooltip: '',
            subtitle:
                "Nous sommes en train de traiter vos donn\u00e9es ! En attendant, si vous testiez vos connaissances en mati\u00e8re d'\u00e9nergie avec notre quizz ci-dessous ?",
            subtitle_tooltip: '',
            ing_button: 'Retourner vers ING',
            ing_button_tooltip: '',
            check_results: 'Consultez les r\u00e9sultats',
            check_results_tooltip: '',
            results_ready: 'Vos r\u00e9sultats sont pr\u00eats !',
            results_ready_tooltip: '',
            something_went_wrong: "Une erreur s'est produite lors de votre simulation",
            something_went_wrong_tooltip: '',
        },
        customer_ref_page: {
            title: 'Quelle est la r\u00e9f\u00e9rence interne du client ?',
            title_tooltip: '',
            tooltip: 'Cela permet de relier la simulation avec le client',
            tooltip_tooltip: '',
        },
        valuer_tool: {
            global: {
                'en-BE': 'Anglais',
                'fr-BE': 'Fran\u00e7ais',
                'nl-BE': 'N\u00e9erlandais',
                photos: 'Photos',
                plans: 'Plans',
                val_submitted: '\u00c9valuation soumise!',
                val_saved: '\u00c9valuation sauvegard\u00e9e!',
            },
            sidebar: {
                summary: {
                    title: 'R\u00e9sum\u00e9',
                    lang: 'Langue de la demande',
                    epc_score: 'Score PEB',
                },
                save_val: {
                    label: "Sauvegarder l'\u00e9valuation",
                    sub: "N'est pas soumise",
                },
                submit_val: "Soumettre l'\u00e9valuation",
            },
            borrower: {
                language: "Langue de l'emprunteur",
                appointment: {
                    warning_modal:
                        "Avant de cliquer sur <b>\u00ab Suivant \u00bb</b> apr\u00e8s avoir s\u00e9lectionn\u00e9 une date et une heure, veuillez vous assurer qu'une personne peut accorder \u00e0 l'expert l'acc\u00e8s \u00e0 la propri\u00e9t\u00e9 \u00e0 l'heure de rendez-vous pr\u00e9vue. <b>\u00c0 partir de l'\u00e9tape suivante, vous ne pourrez plus modifier cette plage horaire, en cas de s\u00e9lection incorrecte, veuillez poursuivre la demande.</b> Une fois la r\u00e9ception de l'email de confirmation, veuillez nous contacter via le formulaire de contact et nous reprogrammerons votre visite.",
                },
                'billing-address-button': 'Demande de re\u00e7u de facturation',
                'billing-address-text':
                    "Si vous avez besoin d'un re\u00e7u de facturation, veuillez nous contacter en cliquant sur le bouton ci-dessous. Notre \u00e9quipe vous aidera rapidement \u00e0 g\u00e9n\u00e9rer la documentation n\u00e9cessaire pour vos dossiers.",
                overview: 'Aper\u00e7u',
                access_property_warning:
                    "Veuillez vous assurer qu'une personne peut accorder \u00e0 l'expert l'acc\u00e8s \u00e0 la propri\u00e9t\u00e9 \u00e0 l'heure pr\u00e9vue du rendez-vous",
                valuer_appointments: {
                    edit: 'Modifier le rendez-vous',
                    'title-no-appointments': 'Aucun rendez-vous \u00e0 venir',
                    title: 'Rendez-vous',
                },
                valuer_info: {
                    title: 'Param\u00e8tres du compte',
                    description:
                        "Dans cette vue d'ensemble, vous pouvez d\u00e9finir les d\u00e9tails de votre entreprise \u00e0 afficher dans le rapport d'\u00e9valuation.",
                    'profile_card-title': "D\u00e9tails de l'expert en \u00e9valuation",
                    'accreditation_card-number': "Num\u00e9ro d'accr\u00e9ditation",
                },
                borrower_trans_val: {
                    placeholder: 'Valeur de la transaction',
                },
                borrower_email: {
                    placeholder: "Email de l'emprunteur",
                },
                set_borrower_language: "Veuillez vous assurer que c'est correct",
                calendar: {
                    message_title:
                        'Impossible de trouver un cr\u00e9neau qui vous convient ?',
                    message_content:
                        'Envoyez un e-mail \u00e0 support@rock.estate avec la r\u00e9f\u00e9rence de votre demande, vos disponibilit\u00e9s et votre num\u00e9ro de t\u00e9l\u00e9phone',
                    button: 'Ajouter au calendrier',
                    title: '\u00c9valuation sur place Rock.estate',
                },
                'booking-complete': {
                    title: 'R\u00e9servation effectu\u00e9e !',
                    description:
                        'Un e-mail de confirmation a \u00e9t\u00e9 envoy\u00e9 \u00e0 votre adresse \u00e9lectronique avec les d\u00e9tails de votre r\u00e9servation. Veuillez envoyer un courriel \u00e0 support@rock.estate pour modifier votre rendez-vous.',
                },
                receipt: {
                    button: 'Voir le re\u00e7u',
                },
                report: {
                    button: 'T\u00e9l\u00e9charger le rapport',
                },
                'payment-error':
                    "Une erreur s'est produite lors du traitement de votre paiement. Veuillez r\u00e9essayer",
                submitter: {
                    email_question: "Quelles sont les coordonn\u00e9es de l'emprunteur ?",
                    email_text:
                        "Rock.estate enverra un email contenant un lien sur lequel l'emprunteur pourra cliquer pour prendre rendez-vous pour une expertise sur place.",
                    transaction_question: 'Quel est le prix de la transaction ?',
                    transaction_text:
                        "Veuillez indiquer le montant (hors droits d'enregistrement/TVA) que l'emprunteur a pay\u00e9 pour le bien. Ceci est important pour d\u00e9terminer le co\u00fbt de l'expertise. Il ne sera pas partag\u00e9 avec l'expert.",
                    success_title: 'Le lien de r\u00e9servation est en route !',
                    success_description:
                        "Rock.estate a envoy\u00e9 un e-mail avec un lien s\u00e9curis\u00e9 via lequel le destinataire peut planifier son rendez-vous d'expertise sur place. Veuillez rappeler \u00e0 votre emprunteur de r\u00e9server rapidement un rendez-vous en utilisant ce lien.",
                    dashboard_button: 'Retour au Dashboard',
                },
                'appointment-overview': {
                    title:
                        "Voici un aper\u00e7u de l'heure de rendez-vous que vous avez s\u00e9lectionn\u00e9e.",
                    'please-share':
                        "Veuillez partager les d\u00e9tails d'acc\u00e8s ci-dessous.",
                    'will-be-present_question':
                        "Serez-vous la personne qui donnera \u00e0 l'expert l'acc\u00e8s \u00e0 la propri\u00e9t\u00e9 ?",
                    access_representative:
                        "Veuillez demander \u00e0 un membre de la famille, un ami ou un voisin d'\u00eatre sur place pour donner acc\u00e8s \u00e0 l'expert. Veuillez nous fournir leur nom et leur num\u00e9ro de t\u00e9l\u00e9phone au cas o\u00f9 nous aurions besoin de les contacter.",
                    'access_representative-label': 'Repr\u00e9sentant',
                    access_description:
                        "Veuillez d\u00e9crire clairement comment l'expert peut acc\u00e9der \u00e0 la propri\u00e9t\u00e9.",
                    'access_description-placeholder':
                        "p. ex. sonnez \u00e0 la porte 27 avec le nom 'Dorien De Ridder' dessus\np. ex. vous pouvez acc\u00e9der au garage avec le badge sur les porte-cl\u00e9s.",
                },
                'borrower-details': {
                    title:
                        'Pour planifier un rendez-vous, veuillez remplir vos coordonn\u00e9es.',
                },
                'confirm-address_unhappy-title': 'Il semble y avoir eu un probl\u00e8me.',
                'confirm-address_unhappy-description':
                    "Veuillez contacter votre conseiller en pr\u00eat si vous avez re\u00e7u une invitation incorrecte pour un rendez-vous d'expertise sur place.",
                'confirm-address_question':
                    'Confirmez-vous que vous souhaitez planifier une expertise sur place pour cette adresse ?',
                step: {
                    appointment: 'Rendez-vous',
                    'contact-details': 'Coordonn\u00e9es',
                    confirmation: 'Confirmation',
                    payment: 'Paiement',
                },
                'payment-overview': {
                    title: 'R\u00e9sum\u00e9 de votre \u00e9valuation sur place',
                    'agree-with-terms':
                        "Je suis d'accord avec les conditions g\u00e9n\u00e9rales.*",
                    'confirm-someone-present':
                        "Je confirme qu'une personne sera pr\u00e9sente pour donner acc\u00e8s \u00e0 l'expert en \u00e9valuation \u00e0 la propri\u00e9t\u00e9.",
                    cancel_title: "Politique de report et d'annulation",
                    cancel_description:
                        "Le changement ou l'annulation d'un rendez-vous plus de 24 heures \u00e0 l'avance n'entra\u00eene pas de frais. Les changements effectu\u00e9s dans les 24 heures seront factur\u00e9s \u00e0 50 % et, en cas de non-pr\u00e9sentation non notifi\u00e9e \u00e0 l'avance, l'int\u00e9gralit\u00e9 des frais ne sera pas rembours\u00e9e. Veuillez consulter notre FAQ pour plus de d\u00e9tails.",
                },
                payment: {
                    billing: 'Adresse de facturation',
                    pay: 'Payer',
                    method: 'S\u00e9lectionner une m\u00e9thode de paiement',
                },
                role: {
                    notary: 'Notaire',
                    broker: 'Courtier',
                    renter: 'Locataire',
                    other: 'Autre',
                    place_holder: 'S\u00e9lectionnez une fonction',
                },
                'appointment-making': {
                    title: 'Prise de rendez-vous',
                },
            },
            valuer: {
                info: 'Info',
                accreditations: 'Accr\u00e9ditations',
                availability: 'Disponibilit\u00e9',
                appointments: 'Rendez-vous',
            },
            reference_listing: {
                assessed: 'Analys\u00e9e',
                reference: 'R\u00e9f\u00e9rence ',
                listing_date: 'Date de plublication',
                touching_sides: 'Nombre de fa\u00e7ades en contact',
                distance: 'Distance',
                price: 'Prix',
                price_sqm: 'Prix/m\u00b2',
                streetnumber: 'Num\u00e9ro de rue ',
                use_as_reference: 'Utilser ce listing comme r\u00e9f\u00e9rence',
                add_to_remarks: 'Ajouter aux remarques',
                corrected_price: 'Prix corrig\u00e9',
                corrected_price_sqm: 'Prix corrig\u00e9/m\u00b2',
                google_maps: 'Vue sur Google Maps',
            },
            general: {
                title: 'Information g\u00e9n\u00e9rale',
                basic_infos: {
                    title: 'Information de base',
                    building_found: 'B\u00e2timent trouv\u00e9',
                },
                state: {
                    title: 'Etat',
                    epc_label: 'Label PEB',
                },
                size: {
                    title: 'Taille',
                },
                value: {
                    title: 'Valeur',
                    analytics: {
                        title: 'Analyse',
                        assessed: 'Evalu\u00e9',
                        median: 'M\u00e9diane',
                        average: 'Moyenne',
                        deviance: 'D\u00e9viance',
                    },
                },
                reference_map: {
                    title: 'Carte de r\u00e9f\u00e9rence',
                },
                reference: {
                    title: 'Points de r\u00e9f\u00e9rence',
                    map: {
                        open: 'Ouvrir la carte',
                    },
                },
            },
            exterior: {
                title: 'Ext\u00e9rieur',
                parcel: 'Parcelle',
                annexes: 'Annexes',
                roof_information: 'Informations sur le toit',
                solar_panel: {
                    question: 'Y a-t-il des panneaux solaires ?',
                },
                garage: {
                    name: 'Garage',
                    question: 'Y a-t-il un garage ferm\u00e9 ?',
                    area: 'Surface du garage',
                    add: 'Ajouter un garage +',
                },
                parking: {
                    name: 'Emplacement de parking',
                    question: 'Y a-t-il une emplacement ?',
                    area: 'Surface du parking',
                    add: 'Ajouter un parking +',
                },
                barn: {
                    question: 'Y a-t-il une grange ?',
                },
                stables: {
                    question: 'Y a-t-il des \u00e9curies ?',
                },
                pool_house: {
                    question: 'Y a-t-il un pool house ?',
                },
                swimming_pool: {
                    question: 'Y a-t-il une piscine?',
                },
                garden: {
                    question: 'Y a-t-il un jardin ?',
                },
                f_balcony_present: {
                    question: 'Y a-t-il une terrasse ou un balcon ?',
                },
                f_cellar_attic_present: {
                    question: 'Y a-t-il une cave ou un grenier ?',
                },
            },
            interior: {
                title: 'Int\u00e9rieur',
                floors: {
                    floor_mobile_title: 'Int\u00e9rieur - Etage {floor}',
                    title: 'Etages',
                    redirected:
                        "Redirig\u00e9 car aucun \u00e9tage n'a \u00e9t\u00e9 trouv\u00e9.",
                    add_floors: 'Ajouter des \u00e9tages',
                    add_apt_floors: "Ajouter des \u00e9tages \u00e0 l'appartement",
                    floor: 'Etage',
                    edit_floors: 'Modifier des \u00e9tages',
                    go_to_floor: 'Ajouter des pi\u00e8ces',
                    delete_floor: {
                        title: 'Supprimer un \u00e9tage',
                        select_transfer:
                            "Veuillez s\u00e9lectionner o\u00f9 transf\u00e9rer la pi\u00e8ce de l'\u00e9tage supprim\u00e9",
                        no_transfer:
                            "Supprimer l'\u00e9tage et les pi\u00e8ces attenantes sans les transf\u00e9rer",
                    },
                },
                tabs: {
                    interior: 'Int\u00e9rieur',
                    floors: "Plan d'\u00e9tage",
                },
                empty_floors: {
                    title:
                        "Il semble que vous n'ayez pas encore ajout\u00e9 d'\u00e9tages",
                    content:
                        'Ajoutez des \u00e9tages avant de pouvoir ajouter des pi\u00e8ces en appuyant sur le bouton',
                },
                rooms: {
                    title: 'Pi\u00e8ces',
                    generate: 'Cr\u00e9\u00e9r des pi\u00e8ces',
                    add_room: 'Ajouter une pi\u00e8ce',
                    edit_room: 'Modifier une pi\u00e8ce',
                    add_and_new_room: 'Sauvegarder et cr\u00e9er une nouvelle pi\u00e8ce',
                },
                empty_rooms: {
                    title:
                        "Il semble que vous n'ayez pas encore ajout\u00e9 de pi\u00e8ces",
                    content: 'Ajoutez des pi\u00e8ces en appuyant sur le bouton',
                },
            },
            commons: {
                title: 'Communs',
                certificates: 'Certificat PEB pour communs',
                apartment: {
                    title: "Caract\u00e9ristiques de l'appartement",
                },
                costs: {
                    title: 'Frais communs',
                    amount: 'Charges/mois',
                },
                upload: {
                    button_subtitle: 'ou glisser d\u00e9poser',
                    button_title: 'Cliquer pour t\u00e9l\u00e9charger',
                    title:
                        '<b>Cliquer pour t\u00e9l\u00e9charger</b><br />ou glisser d\u00e9poser',
                    max: '(max {size} mb)',
                },
            },
            surroundings: {
                title: 'Alentours',
                mobility: 'Mobilit\u00e9',
            },
            valuation: {
                title: 'Valuation',
                value_pre_reno: 'Valeur marchande avant r\u00e9novations',
                scheduled_renov: {
                    title: 'R\u00e9novations pr\u00e9vues',
                    comment:
                        'Please describe what the renovation budget is used for in the \u201cGeneral remarks on the report\u201d. You can find the bank agent\u2019s original input by reviewing the request via your Dashboard.',
                    budget: 'Budget de r\u00e9novation',
                },
                value_post_reno: 'Valeur marchande attendue apr\u00e8s r\u00e9novations',
                estimated_price: 'Valeur estim\u00e9e automatis\u00e9e',
                reno_adjustment: 'Correction totale en %',
                comments: 'Remarques g\u00e9n\u00e9rales sur le rapport',
            },
            internal_remarks: {
                title: 'Notes',
                description:
                    'Ces notes ne sont pas affich\u00e9es dans le rapport. Elles servent uniquement de r\u00e9f\u00e9rence personnelle.',
            },
            building_violations: {
                placeholder: 'Veuillez d\u00e9crire les infractions au b\u00e2timent',
                question:
                    "Y a-t-il des infractions de l'am\u00e9nagement du b\u00e2timent ?",
                tooltip:
                    "Violation de la r\u00e9glementation de l'am\u00e9nagement du territoire",
            },
            valuer_summary: {
                'skip-notification': 'Ignorer les notifications',
                'appointment_cancel-btn': 'Annuler le rendez-vous',
                'appointment_confirm-btn': 'Confirmer le rendez-vous',
                'payment_post-full': 'Effectuer le paiement',
                appointment_title: 'Aper\u00e7u des rendez-vous',
                'appointment_not-yet':
                    "Aucun rendez-vous n'a encore \u00e9t\u00e9 programm\u00e9 pour cette demande.",
                status: 'Statut :',
                'payment_not-needed':
                    "Aucun paiement suppl\u00e9mentaire n'est n\u00e9cessaire",
                payment_pending: 'Traitement du paiement...',
                payment_succeeded: 'Paiement re\u00e7u avec succ\u00e8s',
                payment_cancelled: 'Paiement annul\u00e9',
                payment_refunded: 'Paiement rembours\u00e9',
                payment_started: 'Paiement en attente',
                payment_null: 'Statut du paiement : Inconnu',
                'appointment_confirm-cancel':
                    '\u00cates-vous s\u00fbr de vouloir annuler ce rendez-vous ?',
                appointment_cancelled: 'Le rendez-vous a \u00e9t\u00e9 annul\u00e9',
                appointment_cancelled_by_valuer:
                    "Le rendez-vous a \u00e9t\u00e9 annul\u00e9 par l'expert",
                appointment_confirmed: "L'expert a confirm\u00e9 le rendez-vous",
                appointment_pending_confirmation:
                    "En attente de la confirmation de l'expert",
                appointment_new: 'Le rendez-vous a \u00e9t\u00e9 cr\u00e9\u00e9',
            },
            valuer_settings: {
                availability_warning:
                    "Vous n'avez pas encore partag\u00e9 de disponibilit\u00e9s avec nous. Pour faciliter l'attribution des demandes d'\u00e9valuation, veuillez lier votre calendrier et inclure au moins un cr\u00e9neau de disponibilit\u00e9.",
                availability_title: 'Gestion des disponibilit\u00e9s',
                'availability_add-button':
                    'Ajouter un cr\u00e9neau de disponibilit\u00e9',
                availability_districts: 'Districts',
                availability_delete_ays:
                    'Etes-vous s\u00fbr de vouloir supprimer ce cr\u00e9neau de disponibilit\u00e9 ?',
            },
        },
        monolith: {
            global: {
                delete: 'Supprimer',
                i_understand: 'Je comprends',
                not_available: 'Non disponible',
                language: 'Langue',
                logout: 'D\u00e9connexion',
                login: "S'identifier",
                copy: {
                    success: 'Copi\u00e9 dans le presse-papier!',
                    error:
                        "Quelque chose s'est mal pass\u00e9, veuillez contacter l'\u00e9quipe technique",
                },
                vat: 'TVA',
                subtotal: 'Total HTVA',
                total: 'Total',
                or: 'ou',
                description: 'Description',
                show_more: 'Montrer plus',
                show_less: 'Montrer moins',
                documents: 'Documents',
                update: 'Mise \u00e0 jour',
                full_name: 'Nom et pr\u00e9nom ',
                first_name: 'Pr\u00e9nom',
                last_name: 'Nom de famille',
                phone: 'T\u00e9l\u00e9phone',
                email: 'E-mail',
            },
            apps: {
                welcome: 'Bienvenue',
                valuation: {
                    name: 'Evaluation immobili\u00e8re',
                    description:
                        "Demande d'\u00e9valuation immobili\u00e8re pour une r\u00e9sidence en Belgique",
                },
                ers: {
                    name: 'Simulation de r\u00e9novations \u00e9nerg\u00e9tiques',
                    description:
                        "Faites une simulation des r\u00e9novations les plus astucieuses afin d'augmenter l'efficacit\u00e9 \u00e9nerg\u00e9tique d'une maison",
                },
                dashboard: 'Dashboard',
            },
            shared: {
                apartment: 'Un appartement',
                back: 'Retour',
                customer_ref_conflict:
                    "Il existe d\u00e9j\u00e0 une demande d'\u00e9valuation avec cette r\u00e9f\u00e9rence interne. Pour visualiser cette demande existante, cliquez sur la r\u00e9f\u00e9rence de demande d'\u00e9valuation ci-dessous :",
                leave_modal: {
                    cancel: 'Rester sur cette page',
                    confirm: 'Quitter',
                },
                next: 'Suivant',
                previous: 'Pr\u00e9c\u00e9dent',
                report: 'Report',
                saved: 'Donn\u00e9es enregistr\u00e9es!',
                streetnumber: 'Streetnumber',
                touching_sides: 'Touching sides',
                wrong_value:
                    'Certaines informations sont manquantes ou ont une valeur inattendue. Voulez-vous soumettre ces valeurs ?',
                message: 'Message',
                full_address:
                    "Le b\u00e2timent correspondant \u00e0 l'adresse n'a pas \u00e9t\u00e9 trouv\u00e9 automatiquement",
                send: 'Envoyer',
                confirm_before_quit: {
                    title: 'Vous avez des modifications non enregistr\u00e9es.',
                    content: 'Voulez-vous les enregistrer avant de quitter?',
                    confirm: 'Quitter',
                    cancel: 'Rester sur cette page',
                    save: 'Enregistrer et quitter',
                },
                customer_ref: 'R\u00e9f\u00e9rence interne',
                address: 'Addresse',
                customer: 'Client',
                request_ref: 'R\u00e9f\u00e9rence de demande',
                status_col: 'Statut',
                created_at: 'Cr\u00e9\u00e9',
                last_modified: 'Derni\u00e8re modification',
                actions: 'Actions',
                owner: 'Demandeur',
                valuer: 'Expert immobilier',
                short_lang: 'FR',
                help_me: 'Aidez-moi, je suis bloqu\u00e9 !',
                faq: 'FAQ',
                per_page: 'par page',
                search: 'Rechercher',
                email_address: 'adresse mail',
                username: "nom d'utilisateur",
                password: 'mot de passe',
                roles: 'roles',
                cancel: 'Annuler',
                type: 'Type',
                na: 'Non pr\u00e9cis\u00e9',
            },
            building_type: {
                apartment_comment:
                    "Une entit\u00e9 qui fait partie d'un b\u00e2timent plus large",
                construction_plot: 'Terrain \u00e0 b\u00e2tir',
                house: 'Une maison',
                house_comment: 'B\u00e2timent comptant une seule entit\u00e9',
                new_apartment: 'Appartement neuf',
                new_house: 'Maison neuve',
            },
            map: {
                'cannot-find-any-main-parcel': 'Je ne trouve pas la parcelle principale',
                'cannot-find-confirm-main-building':
                    "Ceci n'est pas le bon b\u00e2timent",
                'cannot-find-confirm-main-parcel': "Ce n'est pas la parcelle principale",
                'cannot-find-select-extra-parcels':
                    'Je ne trouve pas certaines parcelles',
                'cannot-find-select-main-building':
                    'Je ne trouve pas le b\u00e2timent principal',
                'cannot-find-select-main-parcel':
                    "L'emplacement est correct mais la parcelle ne devrait en \u00eatre qu'une partie (ex: lotissement)",
                'cannot-find-select-parcels': 'Je ne trouve pas certaines parcelles',
                'cannot-find-select-secondary-buildings':
                    'Je ne trouve pas certains b\u00e2timents secondaires',
                'explanation-confirm-main-parcel': 'Est-ce bien la parcelle principale ?',
                'explanation-select-extra-parcels':
                    'S\u00e9lectionnez les parcelles suppl\u00e9mentaires',
                'explanation-select-main-building':
                    'S\u00e9lectionnez le b\u00e2timent principal',
                'explanation-select-main-parcel':
                    'S\u00e9lectionnez la parcelle principale',
                'explanation-select-secondary-buildings':
                    'S\u00e9lectionnez le(s) b\u00e2timent(s) secondaire(s)',
                'explanation-view-building-parcels':
                    'Ces b\u00e2timent et parcelles ont \u00e9t\u00e9 s\u00e9lectionn\u00e9s',
                parcel_tooltip:
                    'Cliquer sur la/les parcelle(s) concernc\u00e9es par le bien',
            },
            login: {
                email: 'Votre email',
                login: "S'identifier",
                msg: {
                    'email-not-authorized':
                        'Nous ne reconnaissons pas votre adresse email. Veuillez essayer \u00e0 nouveau.',
                    'email-sent': 'Nous vous avons envoy\u00e9 un lien par email \u00e0',
                    'email-sent_message':
                        "Si vous ne l'avez pas re\u00e7u, v\u00e9rifiez votre dossier spam.",
                    'email-sent_title': 'Merci!',
                    'invalid-token':
                        'Le lien que vous avez utilis\u00e9 est invalide ou a expir\u00e9, entrez votre adresse email pour obtenir un nouveau lien.',
                    logout: 'Vous \u00eates maintenant d\u00e9connect\u00e9.',
                    'invalid-email-address':
                        "Il semble que l'adresse \u00e9lectronique que vous avez saisie ne soit pas valide",
                    'server-error':
                        "Une erreur inattendue s'est produite, veuillez r\u00e9essayer plus tard",
                    'session-expired':
                        'Votre session a expir\u00e9. Entrez votre adresse email pour obtenir un nouveau lien.',
                    'wrong-environment':
                        "Vous n'avez pas acc\u00e8s \u00e0 cet environement. Veuillez vous connecter plut\u00f4t sur {env} ",
                },
                title: 'SSO Login',
                welcome:
                    "Veuillez entrer votre adresse email pour acc\u00e9der \u00e0 l'application.",
            },
            dashboard: {
                hideFullList: 'Afficher uniquement les experts assign\u00e9s',
                showFullList: 'Afficher la liste compl\u00e8te des experts',
                specialist: 'Valuation Specialist',
                total: 'Total',
                unassigned: 'Non assign\u00e9',
                valuers_workload: 'Charge de travail des Valuation Specialists',
                my_requests: 'Mes demandes',
                last_month: 'Dernier mois',
                last_year: 'Derni\u00e8re ann\u00e9e',
                all_requests: 'Toutes les demandes',
                search_request: 'Rechercher une demande',
                review_tooltip:
                    'Cette demande a \u00e9t\u00e9 analys\u00e9e par un expert immobilier et certaines r\u00e9ponses doivent \u00eatre r\u00e9vis\u00e9es',
                badges: {
                    resubmitted: 'Soumis de nouveau',
                    needs_on_site: 'Expertise sur site recommand\u00e9e',
                    needs_borrower_email: '',
                    needs_appointment_confirmation: '',
                    needs_borrower_action: '',
                    appointment_confirmed: '',
                },
                valuer_change_modal: {
                    content:
                        "Cette demande est d\u00e9j\u00e0 attribu\u00e9e. Confirmez-vous que vous voulez changer l'expert assign\u00e9? Cela emp\u00eachera l'expert pr\u00e9c\u00e9demment assign\u00e9 de travailler sur la demande.",
                    actions: {
                        confirm: 'Confirmer',
                    },
                },
                sub_modal: {
                    content:
                        "Confirmez-vous prendre en charge cette demande ? Le demandeur actuel sera inform\u00e9 du changement d'utilisateur.",
                },
                title_tooltip: "Suivez ici l'\u00e9volution de vos demandes",
                create_report: 'G\u00e9n\u00e9rer un rapport',
                download_report: 'T\u00e9l\u00e9charger un rapport',
                refresh_report: 'G\u00e9n\u00e9rer un rapport de nouveau',
                report_loading: 'Chargement du rapport',
            },
            sidesteps: {
                house: 'Maison',
            },
            validation: {
                file_too_big: 'Please upload a file under {max_size}MB',
                incoherent_feature: 'Veuillez v\u00e9rifier la valeur de ce champ',
                renovation_cost_minValue:
                    'Veuillez entrer un co\u00fbt de renovation sup\u00e9rieur \u00e0 10000',
                required: 'Obligatoire',
                wrong_epc: 'Veuillez fournir un label PEB correct',
                floors_not_consecutive:
                    'Les \u00e9tages s\u00e9lectionn\u00e9s ne sont pas cons\u00e9cutifs',
                renovation_cost_zero_invalid:
                    'Veuillez entrer un co\u00fbt de renovation sup\u00e9rieur \u00e0 0',
            },
            app: {
                session_expiry_warning: {
                    cta: 'Continuer la session',
                    text: 'Votre session va expirer dans {countdown} secondes.',
                },
            },
            sso_login: {
                welcome: 'Click on the button to log in',
            },
            'multiple-address-modal': {
                title: 'Plusieurs adresses sont li\u00e9es \u00e0 ce b\u00e2timent',
                content: "Veuillez s\u00e9lectionner l'adresse correcte",
            },
            chat: {
                beginning: 'This is the beginning of your chat with',
                bank_agent: 'the bank agent',
                vs: 'the Rock.estate Valuation Specialist',
            },
            'action-buttons': {
                info: 'Info',
                edit: 'Modifier',
                cancel: 'Annuler',
                unvalue: 'Annuler la valorisation',
                appointment: 'Rendez-vous',
                'confirm-appointment': 'Confirmer le rendez-vous',
                view_request: 'Voir la demande',
                edit_request: 'Modifier la demande',
                dvm: 'DVM',
                ovm: '\u00c9valuation',
                automatic_valuation: '\u00c9valuation automatique',
                web_report: 'Web report',
                pdf_report: 'PDF report',
                generate_pdf_report: 'Generate PDF report',
                regenerate_pdf_report: 'Re-generate PDF report',
                downloading: 'T\u00e9l\u00e9chargement...',
                take_ownership: 'Prendre en charge',
            },
            faq: {
                title: 'Foire Aux Questions',
                question_1: 'Pourquoi dois-je remplir ce formulaire ?',
                answer_1:
                    "ING travaille avec Rockestate pour tester une nouvelle m\u00e9thode d'\u00e9valuation de biens immobiliers qui peut \u00eatre utilis\u00e9e dans le cadre du processus d'octroi de pr\u00eat hypoth\u00e9caire par ING. Cette m\u00e9thode vise \u00e0 r\u00e9pondre \u00e0 un certain nombre d 'exigences r\u00e9glementaires qui entreront en vigueur plus tard cette ann\u00e9e. Cela contribuera \u00e9galement \u00e0 simplifier le processus de transaction, car il devrait r\u00e9duire le nombre de pr\u00eats hypoth\u00e9caires pour lesquels un expert devra visiter le bien financ\u00e9. Votre participation \u00e0 ce Proof - of -Concept est importante. Cela vous donne une opportunit\u00e9 de contribuer \u00e0 la mise en forme de ce nouveau processus afin qu 'il r\u00e9ponde \u00e0 vos besoins et \u00e0 vos attentes.",
                question_2: 'Quand dois-je remplir ce formulaire ?',
                answer_2:
                    "Vous cr\u00e9ez une nouvelle demande pour chaque demande de pr\u00eat hypoth\u00e9caire li\u00e9e \u00e0 une maison ou un appartement, \u00e0 l'exception des nouvelles constructions.",
                question_3:
                    'Dois-je \u00e9galement remplir ce formulaire pour les r\u00e9novations ?',
                answer_3:
                    'Oui. Les demandes de pr\u00eat hypoth\u00e9caire qui contiennent un volet r\u00e9novation (r\u00e9novation ou achat + r\u00e9novation) sont \u00e9galement incluses.',
                question_4:
                    'Dois-je remplir ce formulaire si un expert \u00e9value le bien sur place ?',
                answer_4:
                    'Oui. Les demandes de pr\u00eat hypoth\u00e9caire pour lesquelles un expert est envoy\u00e9 sur place sont \u00e9galement incluses.',
                question_5:
                    "Les r\u00e8gles existantes d'ING en mati\u00e8re de valorisation immobili\u00e8re ont-elles chang\u00e9 ?",
                answer_5:
                    "Non. Les r\u00e8gles existantes restent en vigueur jusqu'\u00e0 nouvel ordre.",
                question_6:
                    "Je n'ai pas l'adresse exacte du bien. Que devrais-je faire ?",
                answer_6:
                    "La valeur d'une maison ou d'un appartement d\u00e9pend fortement de son emplacement. Si vous ne parvenez pas \u00e0 s\u00e9lectionner correctement l'adresse du b\u00e2timent, essayez alors d'identifier l'emplacement approximatif du bien sur la carte. Cela nous permettra de prendre correctement en compte la valeur de cet emplacement sp\u00e9cifique.",
                question_7:
                    'Pourquoi me demande-t-on de s\u00e9lectionner les parcelles li\u00e9es \u00e0 une maison ?',
                answer_7:
                    "La valeur d'une maison n'est pas seulement d\u00e9termin\u00e9e par le b\u00e2timent, mais aussi par le terrain qui l'entoure. Pour estimer correctement sa valeur, il faut donc savoir quelles parcelles sont li\u00e9es \u00e0 la maison. Dans la plupart des situations, une maison est li\u00e9e \u00e0 une seule parcelle que nous pourrons identifier automatiquement. Cependant, comme une transaction peut concerner plusieurs parcelles, il est important de les renseigner toutes.",
                question_8:
                    'O\u00f9 puis-je trouver les donn\u00e9es telles que PEB, ann\u00e9e de construction, surface habitable, etc. ?',
                answer_8:
                    "Si l'emprunteur potentiel n'est pas en mesure de vous donner ces informations imm\u00e9diatement, nous vous sugg\u00e9rons de l'aider \u00e0 les trouver soit (i) en v\u00e9rifiant l\u2019annonce en ligne sur un portail immobilier (tel que Immoweb, Zimmo, ImmoVlan), ou (ii) en demandant au vendeur ou \u00e0 l'agent immobilier. Bon \u00e0 savoir: lors de la mise en vente d 'une maison ou d'un appartement, il est obligatoire de communiquer la valeur PEB dans l 'annonce.",
                question_9: 'Il me manque quelques donn\u00e9es. Que devrais-je faire ?',
                answer_9:
                    "Dans certaines situations, vous ne pourrez peut - \u00eatre pas collecter toutes les informations requises. Dans ce cas, vous pouvez quand - m\u00eame soumettre votre demande. Nous tenons \u00e0 souligner le fait que la qualit\u00e9 d 'une valorisation diminue consid\u00e9rablement lorsque certains param\u00e8tres manquent. D'o\u00f9 l 'importance d'essayer d 'obtenir tous les param\u00e8tres \u00e0 remplir.",
                question_10:
                    'Puis-je soumettre une nouvelle demande pour le m\u00eame identifiant LOP ?',
                answer_10:
                    "Non, ce n'est actuellement pas possible. Si vous saisissez un identifiant LOP pour lequel un dossie a d\u00e9j\u00e0 \u00e9t\u00e9 soumis, vous pourrez voir toutes les informations relatives \u00e0 cette candidature. Par contre, vous ne pourrez pas la modifier.",
                question_11:
                    "Je n'ai pas encore toutes les informations. Puis-je sauvegarder ma demande en attendant ?",
                answer_11:
                    "Ce n'est pas encore possible. Nous d\u00e9veloppons actuellement cette fonctionnalit\u00e9 qui vous permettra de sauvegarder un brouillon de la demande avant de la soumettre.",
                question_12: "Puis-je avoir plus d'informations sur Rockestate ?",
                answer_12:
                    "Vous trouverez plus d'informations sur Rockestate ici : https://www.rockestate.io/about",
                question_13:
                    "Puis-je avoir plus d'informations sur les donn\u00e9es utilis\u00e9es par Rockestate ?",
                answer_13:
                    "Pour plus d'informations sur les donn\u00e9es utilis\u00e9es par Rockestate, cliquez ici : https://www.rockestate.io/blog/geo-donnees-ouvertes-un-des-ingredients-principaux-de-rockestate",
            },
        },
        dashboard: {
            reference_listing: {
                view_button: 'Voir',
                report_button: 'Rapport',
                edit_button: 'Modifier',
            },
            new_request: {
                title: 'Nouvelle demande',
            },
            type_toggles: {
                ers: 'Simulation \u00e9nerg\u00e9tique',
                dvm: "Demande d'\u00e9valuation ",
            },
        },
        energy: {
            shared: {
                tooltip_more_info: 'En savoir plus',
                insulation_year: "Ann\u00e9e d'isolation",
            },
            building_dimensions: {
                floors: {
                    infobubble:
                        'En incluant le rez-de-chauss\u00e9e, mais en excluant le sous-sol et le grenier.',
                    question: "Quel est le nombre d'\u00e9tages de la maison ?",
                    label: "Nombre d'\u00e9tages",
                },
                title: 'Estimation des dimensions du b\u00e2timent',
                roof: {
                    question: 'Quelle est la forme du toit ?',
                    tooltip:
                        "Si le toit n'est pas enti\u00e8rement plat ou enti\u00e8rement en pentes, veuillez s\u00e9lectionner 'Certaines parties sont en pente, certaines sont plates'. Utilisez le curseur pour indiquer la proportion estim\u00e9e du toit qui est plat.",
                },
                roof_type_pitched: 'Toutes les parties sont inclin\u00e9es',
                roof_type_flat: 'Toutes les parties sont plates',
                roof_type_mixed: "Certaines sont inclin\u00e9es, d'autres sont plates",
                wall_insulation: {
                    question: 'Combien de fa\u00e7ades existent-elles ?',
                    tooltip:
                        'Si deux murs ou plus sont partag\u00e9s avec des maisons voisines, s\u00e9lectionnez "Maison mitoyenne". S\'il n\'y a qu\'un seul mur commun, s\u00e9lectionnez "Maison semi-mitoyenne". Enfin, s\u00e9lectionnez "Maison individuelle" s\'il n\'y a aucun mur commun.',
                },
                facade_type_row: 'Maison mitoyenne',
                facade_type_row_end: 'Maison semi-mitoyenne',
                facade_type_isolated: 'Maison individuelle',
            },
            address: {
                map: {
                    no_model: {
                        title:
                            "Il semble que nous n'ayons pas pu trouver le mod\u00e8le 3D de ce b\u00e2timent",
                        subtitle:
                            'Avec quelques questions suppl\u00e9mentaires, nous pouvons approximer les dimensions du b\u00e2timent',
                        change_address: 'Essayez une adresse diff\u00e9rente',
                        start: 'Commen\u00e7ons !',
                    },
                    select_building: 'S\u00e9lectionnez votre b\u00e2timent sur la carte',
                    cant_find: 'Je ne trouve pas ma maison',
                    confirm_2d: 'Le b\u00e2timent s\u00e9lectionn\u00e9 est-il correct ?',
                    confirm_3d:
                        'Ce mod\u00e8le 3D simplifi\u00e9 repr\u00e9sente-t-il le bon b\u00e2timent ?',
                    title: 'Votre maison',
                    placeholder: 'Recherchez une adresse pour la voir sur la carte.',
                },
                is_loading: 'Chargement...',
                title: "Entrez l'adresse pour obtenir les dimensions du b\u00e2timent",
                title_tooltip:
                    "En fonction de l'adresse, nous r\u00e9cup\u00e9rons des informations telles que les surfaces murales, l'inclinaison et l'orientation du toit, etc. Cela nous permet d'estimer les co\u00fbts et les avantages de chaque r\u00e9novation. \nParfois, les donn\u00e9es officielles peuvent comporter des erreurs, provoquant par exemple la s\u00e9lection simultan\u00e9e de deux b\u00e2timents. Dans ce cas, veuillez indiquer que ce n'est pas le bon b\u00e2timent et que vous ne trouvez pas le v\u00f4tre. Nous poserons ensuite des questions suppl\u00e9mentaires pour estimer les mesures du b\u00e2timent.",
                subtitle:
                    "Chaque b\u00e2timent est unique. Gr\u00e2ce \u00e0 l'adresse, nous sommes en mesure d'adapter les r\u00e9novations aux caract\u00e9ristiques sp\u00e9cifiques du b\u00e2timent.",
            },
            building_type: {
                title:
                    'S\u00e9lectionnez le type de b\u00e2timent pour le projet de r\u00e9novation \u00e9nerg\u00e9tique.',
                unavailable_option:
                    "L'application ne fontionne pas pour ce type de bien.",
                title_tooltip:
                    'Selon le type de b\u00e2timent, nous posons des questions sp\u00e9cifiques pour \u00e9valuer son efficacit\u00e9 \u00e9nerg\u00e9tique et proposer des sc\u00e9narios de r\u00e9novation. Les informations n\u00e9cessaires varient en fonction du type du b\u00e2timent.',
                option: {
                    house: {
                        name: 'Maison',
                        description: 'B\u00e2timent comptant une seule entit\u00e9',
                    },
                    apartment: {
                        name: 'Appartement',
                        description:
                            'Une unit\u00e9 r\u00e9sidentielle int\u00e9gr\u00e9e dans un b\u00e2timent plus grand',
                    },
                    apartment_building: {
                        name: 'Immeuble',
                        description:
                            "Les espaces communs de l'immeuble d'appartements partag\u00e9s avec les copropri\u00e9taires.",
                    },
                },
            },
            attic: {
                question: 'Avez-vous un grenier ?',
                question_heated: 'Le grenier est-il chauff\u00e9 ?',
                tooltip:
                    "L'isolation du plancher des combles est une solution rentable pour isoler le toit, sauf si vous avez l'intention d'utiliser l'espace des combles comme une pi\u00e8ce chauff\u00e9e.",
            },
            basement: {
                question: 'Avez-vous un sous-sol ?',
                tooltip:
                    'Si votre maison n\'est pas enti\u00e8rement au niveau du sol, r\u00e9pondez "Oui". Tout espace non chauff\u00e9 situ\u00e9 en dessous du rez-de-chauss\u00e9e, y compris un vide sanitaire ou un sous-sol partiel, est consid\u00e9r\u00e9 comme un sous-sol.',
            },
            living_area: {
                question:
                    'Quelle est la superficie habitable chauff\u00e9e de la maison ?',
                lvl_3: {
                    tooltip:
                        'La surface totale de plancher faisant partie du volume chauff\u00e9. Notre estimation prend en compte si les combles sont chauff\u00e9es ou non. Vous pouvez trouver la surface de plancher chauff\u00e9 dans le certificat PEB.',
                },
                bubble_info:
                    'D\'apr\u00e8s les dimensions du b\u00e2timent, nous estimons que la superficie habitable chauff\u00e9e est de <b class="has-text-primary">{estimated_living_area} m\u00b2</b>. Veuillez entrer la surface r\u00e9elle si vous la connaissez. Vous pouvez trouver la surface de plancher chauff\u00e9 dans le certificat PEB.',
                lvl_2: {
                    tooltip:
                        'La surface totale de plancher faisant partie du volume chauff\u00e9, excluant g\u00e9n\u00e9ralement le sous-sol. Si les combles sont utilis\u00e9s comme pi\u00e8ce chauff\u00e9e, leur surface est incluse. Vous pouvez trouver la surface de plancher chauff\u00e9 dans le certificat PEB.',
                },
            },
            valid_epc: {
                question: 'Avez-vous un certificat PEB valide ?',
                answer_yes: "Veuillez saisir l'indice PEB officiel",
                answer_no: 'Simulez votre indice PEB',
                tooltip:
                    "Seuls les experts en \u00e9nergie agr\u00e9\u00e9s sont autoris\u00e9s \u00e0 d\u00e9livrer des certificats de performance \u00e9nerg\u00e9tique (PEB). Assurez-vous que le certificat est toujours valide. Le certificat PEB documente en d\u00e9tail l'efficacit\u00e9 \u00e9nerg\u00e9tique d'une habitation, aboutissant \u00e0 une consommation d'energie primaire ou \u00e0 une classe \u00e9nergetique.",
            },
            epc_score: {
                'warning_tooltip-main':
                    'Veuillez noter que nous ne copions pas le score PEB officiel. Nous estimons le score PEB en fonction de vos informations.',
                'warning_tooltip-description':
                    'Cela nous permet de calculer des sc\u00e9narios de r\u00e9novation appropri\u00e9s. Il peut parfois y avoir une diff\u00e9rence entre la note officielle et la note estim\u00e9e. Vous pouvez en savoir plus sur les raisons de cette diff\u00e9rence dans la FAQ 3.1 "Le score PEB estim\u00e9 diff\u00e8re du score PEB officiel".',
                question: "Quel est l'indice PEB officiel ?",
                tooltip:
                    "La consommation d'energie primaire est le score \u00e9nerg\u00e9tique d'une maison, indiquant le nombre de kWh/m\u00b2 n\u00e9cessaires par an pour maintenir une temp\u00e9rature constante de 18 \u00b0C. Vous pouvez le trouver sur le certificat PEB. La classe \u00e9nergetique du b\u00e2timent est \u00e9tablie en fonction de ce score, allant de A++ (tr\u00e8s efficace) \u00e0 G (moins efficace), conform\u00e9ment aux normes des diff\u00e9rentes r\u00e9gions.",
                subtitle: "S\u00e9lectionnez l'une des options",
                answer_kwh: 'kWh/m\u00b2an',
                answer_label: 'Label PEB',
                subtitle_2: "Veuillez entrer ici l'indice PEB officiel",
            },
            construction_year: {
                question: 'Quand la maison a-t-elle \u00e9t\u00e9 construite ?',
                tooltip:
                    "L'ann\u00e9e de construction officielle, sans tenir compte des \u00e9ventuelles r\u00e9novations qui ont pu suivre. Cette information peut g\u00e9n\u00e9ralement \u00eatre trouv\u00e9e dans l'annonce de vente, le registre cadastral ou l'ann\u00e9e de r\u00e9f\u00e9rence dans le certificat PEB.",
                question_specify: "Pr\u00e9cisez l'ann\u00e9e de construction",
                label_input: 'Ann\u00e9e de construction',
            },
            roof_insulation: {
                question: 'Le toit est-il isol\u00e9 ?',
                tooltip_popup:
                    "### Isolation du toit\nLes toits isol\u00e9s comportent une couche de mat\u00e9riau permettant de r\u00e9guler la temp\u00e9rature et de r\u00e9aliser des \u00e9conomies d'\u00e9nergie. **Si vous disposez d'une isolation de toit, que ce soit \u00e0 l'int\u00e9rieur ou \u00e0 l'ext\u00e9rieur, ou d'une isolation du plancher des combles, veuillez r\u00e9pondre \"oui\". Si vous n'\u00eates pas s\u00fbr, s\u00e9lectionnez \"Je ne sais pas\".** Dans ce cas, nous prendrons en compte l'isolation en fonction des normes techniques en vigueur au moment de la construction.  \n\n**Conseils pour d\u00e9terminer si votre toit est isol\u00e9 ou non:**  \n\n- Plafonds froids : Si les plafonds de votre dernier \u00e9tage sont froids au toucher, cela peut indiquer un manque d'isolation.\n- Chaleur excessive : Des toits mal isol\u00e9s peuvent permettre \u00e0 une chaleur excessive d'entrer pendant les p\u00e9riodes chaudes, ce qui est particuli\u00e8rement visible sous le toit.\n- Des factures d'\u00e9nergie \u00e9lev\u00e9es pourraient indiquer une mauvaise isolation.\nL'isolation du toit est un \u00e9l\u00e9ment essentiel de l'efficacit\u00e9 \u00e9nerg\u00e9tique des b\u00e2timents et peut r\u00e9duire consid\u00e9rablement les co\u00fbts de chauffage et de refroidissement tout en am\u00e9liorant le confort int\u00e9rieur.",
                info_bubble:
                    "L'isolation du toit peut \u00eatre <b>ext\u00e9rieure, int\u00e9rieure</b> ou <b>au niveau du plancher des combles.</b>",
                question_2:
                    'Quand le toit a-t-il \u00e9t\u00e9 isol\u00e9 pour la derni\u00e8re fois ?',
                label_input: "Ann\u00e9e d'isolation",
            },
            result: {
                footnote:
                    "*L'estimation de l'indice PEB actuel repose sur les donn\u00e9es fournies dans le questionnaire, compl\u00e9t\u00e9es par des informations sur le b\u00e2timent et les exigences techniques stipul\u00e9es par le logiciel PEB officiel. Plus ces informations sont pr\u00e9cises, plus nous pouvons obtenir une estimation fid\u00e8le de l'indice PEB r\u00e9el. Ceci ne remplace pas un certificat PEB officiel. Veuillez consulter un professionnel pour obtenir des conseils personnalis\u00e9s. **Les prix incluent incluent une TVA de 6 % ou 21 %, en fonction des donn\u00e9es fournies. Ils ne couvrent pas les travaux suppl\u00e9mentaires qui pourraient \u00eatre n\u00e9cessaires avant de proc\u00e9der \u00e0 la r\u00e9novation. Nous mettons r\u00e9guli\u00e8rement \u00e0 jour les prix. Selon le moment de votre visite, ils peuvent varier. Pour obtenir des conseils adapt\u00e9s \u00e0 votre situation, n'h\u00e9sitez pas \u00e0 consulter un professionnel.",
                EPC_label: 'Score PEB',
                budget_label: 'Votre budget',
                edit_questionnaire: 'Modifier le questionnaire',
                scenario_saved_message: 'Sc\u00e9nario enregistr\u00e9 avec succ\u00e8s',
                no_renovation:
                    "<p><span class=\"text-primary\">F\u00e9licitations !</span> Cette propri\u00e9t\u00e9 est bien \u00e9quip\u00e9e pour un avenir \u00e9conome en \u00e9nergie.</p>\n\n<p>En fonction de vos informations, notre simulateur n'a pas pu trouver de sc\u00e9narios de r\u00e9novation rentables. Il semble que cette propri\u00e9t\u00e9 soit arriv\u00e9e \u00e0 un stade o\u00f9 de nouvelles r\u00e9novations \u00e9nerg\u00e9tiques pourraient entra\u00eener des gains minimes. Si vous \u00eates d\u00e9termin\u00e9 \u00e0 faire de cette maison un exemple de vie durable, voici quelques mises \u00e0 niveau potentielles \u00e0 consid\u00e9rer :</p>\n<ul>\n<li>Choisissez un \u00e9clairage LED</li>\n<li>Installez une porte d'entr\u00e9e et une porte de garage \u00e9conomes en \u00e9nergie</li>\n<li>Envisagez un syst\u00e8me de ventilation tel que le C+ ou le syst\u00e8me D</li>\n<li>Explorez les avantages d'un chauffe-eau solaire</li>\n<li>Investissez dans une batterie domestique</li>\n</ul>\n\n<p>Merci d'\u00eatre un propri\u00e9taire soucieux de l'environnement.</p>",
                header: {
                    title: "L'efficacit\u00e9 \u00e9nerg\u00e9tique actuelle",
                    subtitle:
                        "Selon les d\u00e9tails fournis, nous avons estim\u00e9 l'indice PEB actuel et les r\u00e9novations pertinentes. Cela ne remplace pas un indice PEB officiel*",
                },
                epc_score: {
                    title:
                        "L'estimation de l'indice PEB actuel est de {current_epc_score} kWh/m\u00b2/an",
                    subtitle:
                        "Comme le montre l'histogramme, {x}% des maisons dans la r\u00e9gion de {region} ont un meilleur label PEB.",
                },
                consumption: {
                    title: 'Votre consommation',
                    elec: 'Electr.',
                    low: 'Faible',
                    high: '\u00c9lev\u00e9',
                    med: 'M\u00e9dian',
                    you: 'Vous',
                },
                package: {
                    title: 'Simulez les r\u00e9novations les plus intelligentes',
                    subtitle:
                        'Quel est votre objectif de r\u00e9novation ? S\u00e9lectionnez le label PEB souhait\u00e9e et d\u00e9couvrez le scenario le plus rentable pour atteindre votre objectif. Avez-vous un budget de r\u00e9novation ? Remplissez-le et d\u00e9couvrez la meilleure note EPC que vous pouvez obtenir avec celui-ci. Ou, cliquez et choisissez quelles r\u00e9novations vous souhaitez entreprendre.',
                    current: 'PEB actuel',
                    budget: 'Budget',
                    custom: 'Personnalisez',
                    target: 'Objectif PEB',
                    best: 'PEB optimal',
                },
                renovation: {
                    wall: 'isolation des murs',
                    roof: 'isolation du toit',
                    window: 'Vitrage des fen\u00eatres',
                    poorly_insulated:
                        "Pour respecter l'ordre recommand\u00e9 des r\u00e9novations \u00e9nerg\u00e9tiques, il convient d'ajouter les \u00e9l\u00e9ments suivants \u00e0 ce sc\u00e9nario:",
                    mixed: 'Isolation int\u00e9rieure mixte toiture et plafond',
                    mixed_tooltip_popup:
                        "### {tooltip_title} \n## Bon \u00e0 savoir\n\nLe toit est la principale source de perte de chaleur dans un b\u00e2timent, il est donc recommand\u00e9 de commencer par isoler le toit. Il n'est pas possible d'isoler les toits plats de l'int\u00e9rieur. Dans ce sc\u00e9nario, la partie plate du toit est isol\u00e9e depuis le plafond, et la partie inclin\u00e9e est isol\u00e9e depuis l'int\u00e9rieur du toit. Il est important de discuter de la faisabilit\u00e9 de cette option avec un professionnel pour \u00e9viter les ponts thermiques et la condensation. L'isolation du toit depuis l'int\u00e9rieur est plus facile \u00e0 installer et moins co\u00fbteuse par rapport \u00e0 l'isolation ext\u00e9rieure. Gardez \u00e0 l'esprit que l'isolation prendra de l'espace au plafond. Les co\u00fbts varient en fonction du type de toit et des mat\u00e9riaux utilis\u00e9s. Si vous n'utilisez pas l'espace du grenier comme zone chauff\u00e9e, envisagez d'isoler le plancher du grenier \u00e0 la place. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nPour l'isolation du plafond : d\u00e9molition du plafond, installation de l'isolation et de la barri\u00e8re anti-vapeur, couverture du plafond, modifications des tuyaux et de l'\u00e9clairage existants.\nPour l'isolation du toit int\u00e9rieur : retrait de la couche isolante d\u00e9grad\u00e9e (y compris la barri\u00e8re anti-vapeur), installation d'une nouvelle couche isolante et d'une barri\u00e8re anti-vapeur, et ajustements autour de la toiture et des lucarnes.",
                    ceiling_tooltip_popup:
                        "### {tooltip_title} \n## Bon \u00e0 savoir\n\nLe toit est la principale source de perte de chaleur dans un b\u00e2timent, il est donc recommand\u00e9 de commencer par isoler le toit. Il n'est pas possible d'isoler les toits plats de l'int\u00e9rieur. Dans ce sc\u00e9nario, la partie plate du toit est isol\u00e9e depuis le plafond. Il est important de discuter de la faisabilit\u00e9 de cette option avec un professionnel pour \u00e9viter les ponts thermiques et la condensation. L'isolation du toit depuis l'int\u00e9rieur est plus facile \u00e0 installer et moins co\u00fbteuse par rapport \u00e0 l'isolation ext\u00e9rieure. Gardez \u00e0 l'esprit que l'isolation prendra de l'espace dans le grenier. Les co\u00fbts varient en fonction du type de toit et des mat\u00e9riaux utilis\u00e9s. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nD\u00e9molition du plafond, installation de l'isolation et de la barri\u00e8re anti-vapeur, couverture du plafond, modifications des tuyaux et de l'\u00e9clairage existants.",
                    ceiling: 'Isolation du plafond',
                    roofIn: 'Isolation int\u00e9rieur du toit',
                    roofIn_tooltip_popup:
                        "### {tooltip_title}   \n## Bon \u00e0 savoir\n\nLe toit est la principale source de perte de chaleur dans un b\u00e2timent, il est donc recommand\u00e9 de commencer par isoler le toit. L'isolation du toit par l'int\u00e9rieur est plus facile \u00e0 installer et moins ch\u00e8re que l'isolation ext\u00e9rieure. Gardez \u00e0 l'esprit que l'isolation prendra une partie de l'espace du grenier. En revanche, l'isolation ext\u00e9rieure du toit ne r\u00e9duit pas l'espace int\u00e9rieur et offre une isolation plus efficace. Les co\u00fbts varient en fonction du type de toit et des mat\u00e9riaux utilis\u00e9s. Si vous n'utilisez pas l'espace du grenier comme zone chauff\u00e9e, envisagez d'isoler le plancher du grenier \u00e0 la place. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nEnl\u00e8vement de la couche isolante d\u00e9grad\u00e9e (y compris le pare-vapeur), installation d'une nouvelle couche isolante et d'un pare-vapeur, et ajustements autour du plan de la toiture et des lucarnes.",
                    atticFloor: 'Isolation du plancher du grenier',
                    atticFloor_tooltip_popup:
                        "### {tooltip_title} \n## Bon \u00e0 savoir\n\nLe toit est la principale source de perte de chaleur dans un b\u00e2timent, il est donc recommand\u00e9 de commencer par isoler le toit. Si l'espace du grenier n'est pas utilis\u00e9 comme une pi\u00e8ce chauff\u00e9e, l'isolation du plancher du grenier peut \u00eatre un choix \u00e9conomique pour pr\u00e9venir les pertes de chaleur par le toit. C'est beaucoup moins cher que l'isolation du toit lui-m\u00eame. Cela s'explique principalement par la plus petite surface \u00e0 isoler et le minimum, voire l'absence, de finition requise. Le processus d'installation est relativement rapide et simple. Cependant, ce n'est peut-\u00eatre pas le meilleur choix si vous envisagez un jour d'utiliser l'espace du grenier comme une pi\u00e8ce chauff\u00e9e. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nInstallation d'une isolation et d'un pare-vapeur, modification des canalisations et de l'\u00e9clairage existants et am\u00e9nagement de l'acc\u00e8s.",
                    roofExt: 'Isolation ext\u00e9rieur du toit',
                    roofExt_tooltip_popup:
                        "### {tooltip_title} \n## Bon \u00e0 savoir\n\nLe toit est la principale source de perte de chaleur dans un b\u00e2timent, il est donc recommand\u00e9 de commencer par isoler le toit. L'isolation du toit par l'ext\u00e9rieur pr\u00e9sente l'avantage de ne pas r\u00e9duire l'espace sous le toit, ce qui permet de maintenir la propret\u00e9 de la maison et son habitabilit\u00e9 pendant les travaux. Elle permet \u00e9galement d'installer le mat\u00e9riau d'isolation le plus \u00e9pais. Cependant, l'isolation ext\u00e9rieure est une option plus co\u00fbteuse par rapport \u00e0 l'isolation int\u00e9rieure du toit. Le co\u00fbt total d\u00e9pend du type de toit et des mat\u00e9riaux utilis\u00e9s. L'isolation ext\u00e9rieure du toit est un bon choix pour un toit plat ou lorsque vous utilisez l'espace sous le toit comme une pi\u00e8ce chauff\u00e9e. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nD\u00e9molition de la couverture et de la structure du toit, d\u00e9molition des goutti\u00e8res, installation de l'isolation et d'un pare-vapeur, mise en place de la structure et -de la couverture du toit, travail autour des \u00e9vents de toit, mise en place des goutti\u00e8res, enl\u00e8vement et r\u00e9installation des panneaux solaires s'ils sont d\u00e9j\u00e0 pr\u00e9sents et grue ou palan.",
                    windowsDouble: 'Vitrage des fen\u00eatres',
                    windowsDouble_tooltip_popup:
                        "### {tooltip_title} \n## Bon \u00e0 savoir\n\nLes anciennes fen\u00eatres peuvent repr\u00e9senter jusqu'\u00e0 30 % des pertes de chaleur dans une maison. La mise \u00e0 niveau vers des fen\u00eatres \u00e9co\u00e9nerg\u00e9tiques, telles que des fen\u00eatres \u00e0 double ou triple vitrage haute performance avec des cadres \u00e9tanches \u00e0 l'air, peut am\u00e9liorer consid\u00e9rablement l'isolation. Si vous pr\u00e9voyez d'isoler les murs, il est conseill\u00e9 de le faire avant ou simultan\u00e9ment avec l'installation de nouvelles fen\u00eatres. Un avantage suppl\u00e9mentaire des nouvelles fen\u00eatres est qu'elles sont plus s\u00e9curitaires en raison de la couche de verre suppl\u00e9mentaire, les rendant plus r\u00e9sistantes aux bris. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nD\u00e9molition et installation du verre (avec suppl\u00e9ment pour l'\u00e9quipement de levage), d\u00e9molition et installation du cadre, installation du RTO sur le verre, et d\u00e9molition et installation du verre.",
                    condGas: 'Chaudi\u00e8re \u00e0 gaz \u00e0 condensation',
                    condGas_tooltip_popup:
                        "### {tooltip_title} \n## Bon \u00e0 savoir\n\nLes chaudi\u00e8res \u00e0 condensation au gaz sont con\u00e7ues pour extraire la chaleur des gaz d'\u00e9chappement produits lors du processus de combustion. **La dur\u00e9e de vie d'une chaudi\u00e8re \u00e0 condensation au gaz est g\u00e9n\u00e9ralement d'environ 15 ans.** En utilisant la chaleur extraite pour pr\u00e9chauffer l'eau, leur efficacit\u00e9 est sup\u00e9rieure \u00e0 celle d'une chaudi\u00e8re traditionnelle. Les chaudi\u00e8res \u00e0 condensation au gaz ont un impact positif sur la note de performance \u00e9nerg\u00e9tique (EPC) d'une habitation. Elles fonctionnent de mani\u00e8re optimale lorsque les murs, le toit et les fen\u00eatres sont bien isol\u00e9s. Consid\u00e9rez l'isolation de votre maison avant d'installer un nouveau syst\u00e8me de chauffage pour obtenir un r\u00e9sultat optimal. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nD\u00e9molition du g\u00e9n\u00e9rateur existant, installation d'une chaudi\u00e8re \u00e0 gaz \u00e0 condensation, raccordement au g\u00e9n\u00e9rateur existant, co\u00fbts suppl\u00e9mentaires pour le remplacement du syst\u00e8me climatique, isolation des tuyaux non isol\u00e9s.",
                    heatPump: 'Pompe \u00e0 chaleur',
                    heatPump_tooltip_popup:
                        "### {tooltip_title} \n## Bon \u00e0 savoir\n\nLes pompes \u00e0 chaleur extraient de l'\u00e9nergie de l'air, du sol ou de l'eau souterraine pour chauffer ou refroidir un espace. Une maison mieux isol\u00e9e perd moins de chaleur et n\u00e9cessite donc une pompe moins puissante. Par cons\u00e9quent, le prix d'une pompe \u00e0 chaleur est plus bas lorsqu'elle est combin\u00e9e \u00e0 d'autres r\u00e9novations \u00e9co\u00e9nerg\u00e9tiques. Une pompe \u00e0 chaleur r\u00e9duit la d\u00e9pendance aux combustibles fossiles, r\u00e9duisant ainsi les \u00e9missions de carbone li\u00e9es \u00e0 votre consommation d'\u00e9nergie. Il existe diff\u00e9rents types de pompes \u00e0 chaleur, comme les pompes g\u00e9othermiques, air-air, air-eau et les syst\u00e8mes hybrides. Les prix varient en fonction du type sp\u00e9cifique de pompe \u00e0 chaleur que vous choisissez. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nD\u00e9molition du g\u00e9n\u00e9rateur existant, installation d'une pompe \u00e0 chaleur (avec eau du sol ; y compris le forage), raccordement au g\u00e9n\u00e9rateur existant et isolation des tuyaux non isol\u00e9s. Le remplacement du syst\u00e8me de climatisation entra\u00eenera des co\u00fbts suppl\u00e9mentaires.",
                    wallCav: 'Isolation des murs creux',
                    wallCav_tooltip_popup:
                        "### {tooltip_title} \n## Bon \u00e0 savoir\n\nApr\u00e8s avoir isol\u00e9 le toit, il est recommand\u00e9 d'isoler les murs. Tous les b\u00e2timents ne poss\u00e8dent pas une cavit\u00e9 dans leurs murs, alors v\u00e9rifiez si le b\u00e2timent a des murs en cavit\u00e9 ou des murs massifs. L'isolation des murs en cavit\u00e9 peut offrir une excellente isolation thermique \u00e0 un prix abordable. Cependant, soyez conscient des probl\u00e8mes potentiels tels que la condensation et la formation de moisissures. Si la maison est situ\u00e9e dans une r\u00e9gion o\u00f9 il y a beaucoup de pluie entra\u00een\u00e9e par le vent, envisagez des alternatives pour pr\u00e9venir les probl\u00e8mes li\u00e9s \u00e0 l'humidit\u00e9. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nUtilisation d'une nacelle \u00e9l\u00e9vatrice, pose d'une isolation en laine min\u00e9rale de 5 cm comprenant l'inspection, la pr\u00e9paration, l'insufflation et la fermeture des ouvertures.",
                    unitPv: 'Panneaux solaires',
                    unitPv_tooltip_popup:
                        "### {tooltip_title} \n## Bon \u00e0 savoir\n\nLes panneaux solaires peuvent constituer un moyen rentable d'am\u00e9liorer la note de performance \u00e9nerg\u00e9tique (PEB) et de r\u00e9duire vos factures d'\u00e9nergie. Cependant, il est recommand\u00e9 de r\u00e9nover d'abord le toit, les murs, les fen\u00eatres et le syst\u00e8me de chauffage. L'efficacit\u00e9 des panneaux solaires d\u00e9pend de plusieurs facteurs tels que la surface, l'orientation et l'ombrage sur le toit. Dans certains cas, vous pourriez avoir besoin d'un permis pour installer des panneaux solaires, par exemple, si la maison est r\u00e9pertori\u00e9e au registre du patrimoine architectural. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nInstallation de panneaux solaires incluant tous les accessoires n\u00e9cessaires.                ",
                    wallExt: 'Isolation ext\u00e9rieur des murs',
                    wallExt_tooltip_popup:
                        "\n### {tooltip_title} \n## Bon \u00e0 savoir\n\nApr\u00e8s avoir isol\u00e9 le toit, il est recommand\u00e9 d'isoler les murs. L'isolation des murs ext\u00e9rieurs le long de la fa\u00e7ade ext\u00e9rieure pr\u00e9sente l'avantage de ne pas perdre d'espace de vie, et la maison reste habitable pendant les travaux. Elle contribue \u00e9galement \u00e0 r\u00e9duire les bruits ext\u00e9rieurs. Assurez-vous toujours que la maison convient \u00e0 l'isolation des murs ext\u00e9rieurs. \u00c9tant donn\u00e9 que les caract\u00e9ristiques esth\u00e9tiques de la fa\u00e7ade peuvent changer, il peut y avoir des exigences relatives \u00e0 un permis de construire, par exemple, si vous r\u00e9novez un b\u00e2timent historique. \n\n## Qui y a-t'il d'inclus? \nLe co\u00fbt total de l'investissement inclut:  \nD\u00e9molir l'\u00e9vacuation des eaux pluviales, scier les seuils, installer l'isolation, placer les finitions (en cr\u00e9pi), mettre \u00e0 jour les ouvertures (y compris les seuils), effectuer des travaux de r\u00e9vision, agrandir la saillie du toit, renouveler l'\u00e9vacuation des eaux pluviales, et un \u00e9chafaudage.",
                },
                warning: {
                    solar_panel:
                        "Si vous envisagez d'isoler le toit \u00e0 l'avenir, pensez \u00e0 l'ajouter au sc\u00e9nario de r\u00e9novation. Vous \u00e9viterez ainsi les co\u00fbts suppl\u00e9mentaires li\u00e9s \u00e0 l'enl\u00e8vement et \u00e0 la r\u00e9installation des panneaux solaires. N'oubliez pas qu'il est interdit d'installer des panneaux solaires sur un toit contenant de l'amiante.",
                    window:
                        "Envisagez d'ajouter l'isolation du toit et/ou des murs au sc\u00e9nario de r\u00e9novation afin d'\u00e9viter les co\u00fbts futurs li\u00e9s \u00e0 l'enl\u00e8vement des ch\u00e2ssis de fen\u00eatres pour installer l'isolation.",
                    heating:
                        "\u00c9valuez si le toit, les murs et les vitrages offrent une isolation suffisante avant de r\u00e9nover le syst\u00e8me de chauffage. Si vous installez un nouveau syst\u00e8me de chauffage dans une maison insuffisamment isol\u00e9e, vous aurez besoin d'un syst\u00e8me plus grand et donc plus co\u00fbteux pour chauffer le m\u00eame volume.",
                },
                summary: {
                    title: 'R\u00e9sum\u00e9',
                    subtitle:
                        'Les prix ci-dessous sont indicatifs. Le pourcentage de TVA est bas\u00e9 sur la l\u00e9gislation fiscale.',
                    item: 'Item',
                    price_incl_vat: 'Prix TTC',
                    price_excl_vat: 'Prix HT',
                },
                property_value: 'Valeur marchande de la propri\u00e9t\u00e9',
                savings: {
                    title: '\u00c9conomies',
                    epc: 'Am\u00e9lioration PEB',
                    carbon: '\u00c9missions de CO\u2082',
                    bills: '\u00c9conomies sur la facture',
                },
                button: {
                    add_remove: 'Ajouter ou supprimer des r\u00e9novations',
                    download: 'T\u00e9l\u00e9charger',
                    share: 'Partager',
                    edit_input: 'Editer',
                },
                one_renovation_available:
                    'Selon vos informations, notre simulateur a pu trouver uniquement un seul sc\u00e9nario de r\u00e9novation rentable',
                price: '{value} \u20ac',
            },
            summary: {
                epc: 'Certificat PEB',
                answers_needs_to_be_fixed:
                    'Certaines r\u00e9ponses doivent \u00eatre corrig\u00e9es, veuillez remplir les valeurs des questions entour\u00e9es en rouge',
                energy_consumption_known: "Consommation d'\u00e9nergie connue",
                heated: 'Chauff\u00e9',
                not_heated: 'Non chauff\u00e9',
                insulation_year: "Ann\u00e9e d'isolation",
                residents: "Nombre d'habitants",
                heating_consumption: 'Consommation de chauffage',
                electricity_consumption: "Consommation d'\u00e9lectricit\u00e9",
                high: 'Elev\u00e9',
                medium: 'Mod\u00e9r\u00e9',
                low: 'Faible',
                big_consumer: "Gros consommateurs d'\u00e9nergie",
                fuel_error:
                    "Le type de chauffage \u00e0 chang\u00e9 et certaines r\u00e9ponses ont besoin d'\u00eatre ajust\u00e9es en cons\u00e9quence.",
                construction_year_error:
                    "L'ann\u00e9e de construction a chang\u00e9 et certaines r\u00e9ponses ont besoin d'\u00eatre ajust\u00e9es en cons\u00e9quence.",
                title: 'Voici un r\u00e9capitulatif de votre demande',
                subtitle:
                    'Prenez un moment pour v\u00e9rifier votre saisie. Si des corrections sont n\u00e9cessaires, cliquez sur le crayon pour modifier.',
            },
            package: {
                epc: {
                    title: 'Je veux atteindre un score PEB',
                    description:
                        'Calculer le sc\u00e9nario qui atteint un score PEB avec le budget le plus bas',
                },
                budget: {
                    title: "J'ai un budget maximum",
                    description:
                        'Calculer le sc\u00e9nario qui obtient le meilleur score PEB avec votre budget',
                },
                custom: {
                    title: 'Je veux choisir mon sc\u00e9nario',
                    description:
                        'Cliquez et choisissez votre propre ensemble de r\u00e9novations pour cr\u00e9er des sc\u00e9narios personnalis\u00e9s.',
                },
            },
            wall_insulation: {
                question: 'Les fa\u00e7ades sont-elles isol\u00e9es ?',
                tooltip_popup:
                    "### Murs ext\u00e9rieurs\nLes murs ext\u00e9rieurs isol\u00e9s sont dot\u00e9s d'une couche de mat\u00e9riau qui emp\u00eache les pertes de chaleur.  \n**Si tous les murs ext\u00e9rieurs ne sont pas isol\u00e9s, veuillez s\u00e9lectionner \"Non\". Si vous n'\u00eates pas s\u00fbr, choisissez \"Je ne sais pas\".** Dans ce cas, nous prendrons en compte l'isolation en fonction des normes techniques en vigueur au moment de la construction.  \n  \n**Conseils pour d\u00e9terminer si vos murs ne sont pas isol\u00e9s**\n- Murs froids : Si les murs sont froids au toucher, ils peuvent manquer d'isolation.\n- Bruits excessifs : Des murs mal isol\u00e9s peuvent ne pas bloquer le bruit.\n- Des factures d'\u00e9nergie \u00e9lev\u00e9es pourraient indiquer une mauvaise isolation.  \n\nL'isolation des murs est un \u00e9l\u00e9ment essentiel de l'efficacit\u00e9 \u00e9nerg\u00e9tique des b\u00e2timents, permettant de r\u00e9duire consid\u00e9rablement les co\u00fbts de chauffage et de refroidissement tout en am\u00e9liorant le confort int\u00e9rieur.",
                bubble_info:
                    "L'isolation des murs peut \u00eatre <b>ext\u00e9rieure, int\u00e9rieure</b> ou <b>par remplissage de la cavit\u00e9 murale</b>",
                question_2:
                    'Quand les fa\u00e7ades ont-elles \u00e9t\u00e9 isol\u00e9es pour la derni\u00e8re fois ?',
            },
            floor_insulation: {
                question:
                    'Le plafond du rez-de-chauss\u00e9e ou du sous-sol est-il isol\u00e9 ?',
                tooltip_popup:
                    "### L'isolation des planchers  \nLes planchers isol\u00e9s comportent une couche de mat\u00e9riau permettant de r\u00e9guler la temp\u00e9rature et de r\u00e9aliser des \u00e9conomies d'\u00e9nergie. **Si vous avez une isolation de plancher, veuillez r\u00e9pondre \"oui\". Si vous n'\u00eates pas s\u00fbr, s\u00e9lectionnez \"Je ne sais pas\".** Dans ce cas, nous prendrons en compte l'isolation en fonction des normes de construction de l'ann\u00e9e.  \n\n**Conseils pour d\u00e9terminer si vos planchers sont isol\u00e9s ou non**  \n\n- Planchers froids : Si vos planchers sont froids au toucher, cela peut indiquer un manque d'isolation.\n- Des factures d'\u00e9nergie \u00e9lev\u00e9es pourraient indiquer une mauvaise isolation.",
                question_2:
                    'Quand le sol a-t-il \u00e9t\u00e9 isol\u00e9 pour la derni\u00e8re fois ?',
            },
            window: {
                warning_tooltip:
                    'La propri\u00e9t\u00e9 a \u00e9t\u00e9 construite apr\u00e8s 2000. Il est donc peu probable que ce type de vitrage ait \u00e9t\u00e9 utilis\u00e9.',
                question:
                    'Quel est le type de vitrage principal utilis\u00e9 pour les fen\u00eatres de la maison ?',
                tooltip_popup:
                    '### Fen\u00eatres\n\nSi vous disposez de documentation technique, telle que des factures d\'installation de fen\u00eatres, r\u00e9f\u00e9rez-vous \u00e0 celle-ci pour obtenir des informations sur le vitrage des fen\u00eatres.  \n\n**Si aucune documentation n\'est disponible, voici quelques conseils pour d\u00e9terminer le vitrage:**  \n\n- **Vitrage simple, double ou triple :** Tenez un objet devant la vitre ; une r\u00e9flexion indique une fen\u00eatre \u00e0 simple vitrage, deux r\u00e9flexions indiquent une fen\u00eatre \u00e0 double vitrage et trois r\u00e9flexions indiquent une fen\u00eatre \u00e0 triple vitrage.\n- **Double vitrage, vitrage haute performance ou triple vitrage:** Recherchez la bande d\'aluminium entre deux couches de verre. Le vitrage haute performance est parfois marqu\u00e9 par les lettres "HR", "HR+" ou "HR++". Le triple vitrage est marqu\u00e9 avec "HR+++". Vous pouvez \u00e9galement rechercher le code marqu\u00e9 \u00e0 l\'int\u00e9rieur de la bande de la fen\u00eatre sur le site Web du fabricant.',
            },
            heating: {
                question: 'S\u00e9lectionnez le syst\u00e8me de chauffage principal',
                tooltip:
                    "Nous partons du principe que le m\u00eame syst\u00e8me de chauffage assure \u00e0 la fois le chauffage et la production d'eau chaude. Si la maison dispose de plusieurs syst\u00e8mes de chauffage, veuillez s\u00e9lectionner celui qui chauffe le plus grand volume.",
            },
            end_section: {
                got_it: "J'ai compris !",
                text:
                    "Gr\u00e2ce \u00e0 ces informations, nous sommes en mesure d'estimer l'indice PEB et de recommander des r\u00e9novations adapt\u00e9es.",
                go_to_consumption: 'Passez \u00e0 la Consommation',
            },
            energy_consumption: {
                question:
                    "Connaissez-vous la consommation annuelle d'\u00e9nergie de votre m\u00e9nage ?",
                bubble_info:
                    "Vous pouvez v\u00e9rifier votre consommation sur la facture de votre fournisseur d'\u00e9nergie ou en ligne aupr\u00e8s de votre gestionnaire de r\u00e9seau. Passer d'un appartement \u00e0 une maison, ou \u00e0 un logement mieux ou moins bien isol\u00e9, peut avoir un impact sur votre consommation d'\u00e9nergie annuelle. Veuillez estimer en cons\u00e9quence.",
                yes_text: "Je souhaite remplir ma consommation annuelle d'\u00e9nergie",
                no_text:
                    "Aidez-moi \u00e0 estimer ma consommation annuelle d'\u00e9nergie",
            },
            consumers: {
                title: 'Votre consommation',
                question_1a: 'Combien de personnes vivent dans la maison ?',
                tooltip_1:
                    "Prenez en compte uniquement les r\u00e9sidents permanents \u00e0 l'ann\u00e9e. Veuillez exclure les personnes pr\u00e9sentes uniquement les week-ends ou temporairement. Cela permet d'estimer la consommation d'\u00e9lectricit\u00e9 et de chauffage selon la taille du m\u00e9nage.",
                question_2a:
                    "Quelle est la consommation annuelle d'\u00e9nergie du r\u00e9seau ?",
                tooltip_2:
                    "Votre consommation annuelle d'\u00e9nergie est disponible dans le relev\u00e9 annuel fourni par votre fournisseur d'\u00e9nergie. Si vous utilisez des syst\u00e8mes de chauffage \u00e9lectrique comme des pompes \u00e0 chaleur ou des radiateurs \u00e9lectriques, n'oubliez pas de les inclure dans le calcul de votre consommation d'\u00e9lectricit\u00e9 globale.",
                bubble_info:
                    "La consommation annuelle d'\u00e9lectricit\u00e9 correspond au total en kWh consomm\u00e9 \u00e0 partir du r\u00e9seau sur une ann\u00e9e. N'incluez pas l'\u00e9lectricit\u00e9 que vous pourriez produire vous-m\u00eame.",
                question_1b: 'Comment estimeriez-vous votre consommation de chauffage ?',
                tooltip_popup_1:
                    "### Estimation de la consommation de chauffage\n- Faible : Studios et petits m\u00e9nages avec chauffage \u00e9cologique. Environ ~{min} kWh/an pour le chauffage.\n- Moyen : M\u00e9nages de taille moyenne avec \u00e9quipements standards. Environ ~{med} kWh/an pour le chauffage.\n- \u00c9lev\u00e9 : Grands m\u00e9nages avec besoins de chauffage plus \u00e9lev\u00e9s en raison d'un plus grand espace. Environ ~{max} kWh/an pour le chauffage.",
                question_2b:
                    "Comment estimeriez-vous votre consommation d'\u00e9lectricit\u00e9 ?",
                tooltip_popup_2:
                    "### Estimation de la consommation d'\u00e9lectricit\u00e9\n- Faible : M\u00e9nages de 1 \u00e0 2 personnes, ou m\u00e9nages avec panneaux solaires. Environ ~{min} kWh/an.\n- Moyen : M\u00e9nages de taille moyenne avec des appareils standards. Environ ~{med} kWh/an.\n- \u00c9lev\u00e9 : Grand m\u00e9nage ou m\u00e9nages avec des appareils \u00e9nergivores tels que le chauffage \u00e9lectrique, la climatisation, les voitures \u00e9lectriques ou les piscines. Environ ~{max} kWh/an.",
            },
            big_consumers: {
                question:
                    "Y a-t-il d'importants consommateurs d'\u00e9nergie \u00e0 la maison ?",
                tooltip:
                    "Les gros consommateurs d'\u00e9nergie incluent les v\u00e9hicules \u00e9lectriques, la climatisation, la piscine et le spa.",
            },
        },
        admin_panel: {
            user_mgmt: {
                new_accreditation: 'Nouvelle accr\u00e9ditation',
                add_accreditation: 'Ajouter',
                accreditation_number: 'Num\u00e9ro ccr\u00e9ditation',
                accreditation_institution: 'Institution',
            },
        },
        dvm: {
            shared: {
                actions: {
                    generating_report: 'Generating pdf report',
                    incoherent_features: 'Select incoherent features',
                    onsite: 'Request on site valuation',
                    resubmit: 'Resubmit',
                    save: 'Save valuation without submitting',
                    submit: 'Submit valuation',
                },
                add_to_remarks: 'Add to remarks',
                anchors: {
                    avm: 'AVM',
                    description: 'Description',
                    dvm: 'Desktop Valuation',
                    flood_map: 'Flood map',
                },
                duplicates: 'Duplicates',
                duplicates_modal: {
                    close: 'Close',
                    copy_ref: "Copy request's reference",
                    open_dvm: 'Open Valuation Tool for this request',
                    reason: 'Reason',
                    reasons: {
                        'close point': 'Close point',
                        'same address': 'Same address',
                        'same customer_ref': 'Same customer reference',
                        'same place': 'Same place',
                    },
                    title: 'Showing duplicates for',
                },
                error_modal: {
                    actions: {
                        incoherent_patch:
                            'PATCH call of the incoherent features submission',
                        incoherent_put: 'PUT call of the incoherent features submission',
                        onsite_patch: 'PATCH call of the onsite submission',
                        onsite_put: 'PUT call of the onsite submission',
                        report_post: 'POST report (report generation)',
                        resubmit_patch: 'PATCH call of the resubmission',
                        resubmit_put: 'PUT call of the resubmission',
                        submitVal_patch: 'PATCH call of the valuation submission',
                        submitVal_put: 'PUT call of the valuation submission',
                    },
                    back_to_dashboard: 'Go back to the Dashboard',
                    cancel: 'Cancel',
                    content:
                        'An error occured while doing the <pre>{action} </pre> for the request <pre>{ref} </pre>\nPlease report it to the engineering team including those informations as well as this error message:',
                    title: 'An error occured',
                },
                incoherent_features_modal: {
                    back_to_dashboard: 'Go back to the Dashboard',
                    confirmation_message: 'Valuation request sent for review!',
                    submit: 'Send incoherent features',
                    title: 'Incoherent features',
                },
                onsite_modal: {
                    back_to_dashboard: 'Go back to the Dashboard',
                    confirmation_message: 'Valuation request deferred on-site!',
                    reasons: {
                        onsite_commercial_building: 'Commercial building',
                        onsite_exceptional_property: 'Exceptional property for the area',
                        onsite_extensive_renovation: 'Ratio renovation/current value',
                        onsite_few_comparison: 'Not enough comparison data points',
                        onsite_flood_zone: 'Flood zone risk',
                        onsite_incoherent_features: 'Wrong input filled',
                        onsite_others: 'Other',
                        onsite_streetview: 'Streetview data not available or outdated',
                        onsite_volume_missing: 'Building volume missing',
                    },
                    submit: 'Defer to on-site',
                    title: 'Request on-site valuation',
                },
                price: 'Price',
                price_per_sqm: 'Price per sqm',
                price_sqm: 'Price/sqm',
                address: 'adresse',
                transaction_value: '',
            },
            request: {
                add_document: 'Ajouter un document',
            },
            dashboard: {
                all: 'Tous les clients',
            },
            avm: {
                analysis: 'Analyse',
            },
            description: {
                annexes: {
                    title: 'Annexes',
                },
                apartment_features: {
                    title: 'Apartment features',
                },
                basic_info: {
                    building_found: 'Building found',
                    building_type: {
                        label: 'Building Type',
                        options: {
                            apartment: 'Apartment',
                            construction_plot: 'Construction plot',
                            house: 'House',
                            new_apartment: 'New apartment',
                            new_house: 'New house',
                        },
                    },
                    level: 'Level',
                    renovations: {
                        label: 'Renovations',
                        warning: 'Renovations costs > 15% of AVM price',
                    },
                    title: 'Basic info',
                    touching_sides: 'Number of touching sides',
                },
                other: {
                    f_dist_building_flood: 'Building distance to nearest flood zone',
                    f_dist_parcel_flood: 'Parcel distance to nearest flood zone',
                    f_matched_entities: 'Matched economic entities',
                    title: 'Other',
                },
                size: {
                    title: 'Size',
                },
                state: {
                    f_epc_label: 'EPC Label',
                    title: 'State',
                },
            },
            desktop: {
                apply_influence: 'Appliquer les ajustements',
                dvm_adjustment: 'Ajustement DVM total',
                environment: {
                    'above-avg': 'Au dessus de la moyenne',
                    avg: 'Dans la moyenne',
                    'below-avg': 'Sous la moyenne',
                    title: 'Environnement (not shown on the report)',
                },
                market_correction: 'Correction marchande',
                overridden_influence: 'Deviation manuelle',
                total_influence: 'D\u00e9viation totale',
                update_remarks: 'Ajouter les ajustements aux remarques internes',
            },
            feedback: {
                or_not:
                    "Nous aimerions vous poser quelques questions suppl\u00e9mentaires sur votre exp\u00e9rience d'utilisation.",
            },
            validation: {
                parcel_cost_minValue:
                    'Veuillez entrer un co\u00fbt du terrain sup\u00e9rieur \u00e0 10000',
            },
            modal: {
                success_modal: {
                    actions: {
                        back_to_dashboard: 'Go back to the Dashboard',
                        show_report: 'Go to report',
                        stay_on_page: 'Stay on this page',
                    },
                    content: 'Your valuation was submitted.',
                    title: 'Valuation submitted',
                },
            },
        },
        argenta: {
            valuation: {
                enter: {
                    alt_customer_ref_title:
                        'Quel est le num\u00e9ro de bien du pr\u00eat ?',
                },
                start: {
                    welcome_text_2:
                        "Chaque demande commence par la saisie de la r\u00e9f\u00e9rence interne du pr\u00eat immobilier, c'est-\u00e0-dire le num\u00e9ro de client de (l'un des) l'emprunteur(s). Ensuite, nous vous posons quelques questions sur le bien en question. Pour plus d'informations, veuillez consulter la FAQ.",
                    welcome_text_3:
                        "Cet outil n'est accessible que pour le personnel d'Argenta lors d'une demande de pr\u00eat hypoth\u00e9caire via l'application de demande de cr\u00e9dit. En outre, cette application ne peut \u00eatre utilis\u00e9e que dans les cas o\u00f9 le client a accept\u00e9 de soumettre une demande de cr\u00e9dit \u00e0 Argenta.",
                },
            },
        },
        avm: {
            step1: {
                errors: {
                    default:
                        "Une erreur inconnue s'est produite. Une \u00e9valuation desktop est conseill\u00e9e dans ce cas.",
                    too_few_reference_listings:
                        'Cette localit\u00e9 a trop peu de points de r\u00e9f\u00e9rence dans les environs. Une \u00e9valuation a distance est conseill\u00e9e dans ce cas.',
                },
            },
            shared: {
                extreme_value: 'Valeur extr\u00eame pour',
            },
            form: {
                step4: {
                    details: {
                        close: 'Fermer',
                        link: 'Voir en d\u00e9tail >',
                        text:
                            'Plus la surface habitable est grande, plus la maison est ch\u00e8re. Le graphique ci-dessous montre la corr\u00e9lation plus en d\u00e9tail',
                        title:
                            'La principale caract\u00e9ristique est la surface habitable',
                    },
                    plot_title: {
                        f_construction_year: 'Ann\u00e9e de construction',
                        f_epc: 'PEB',
                        f_living_area: 'Surface habitable',
                        f_parcel_area: 'Suface de la parcelle',
                    },
                    subtitle:
                        "C'est une maison avec un jardin relativement petit | La maison est assez spacieuse | C'est une maison assez r\u00e9cente",
                },
                step5: {
                    card1: {
                        li_1:
                            'La maison est d\u00e9su\u00e8te et doit \u00eatre enti\u00e8rement r\u00e9nov\u00e9e',
                        li_2: 'La maison est loin des commerces',
                        title:
                            'Pourquoi le prix demand\u00e9 pourrait-il \u00eatre plus bas?',
                    },
                    card2: {
                        li_1: "La maison vient d'\u00eatre r\u00e9nov\u00e9e",
                        li_2: 'La maison a un bel emplacement',
                        li_3: 'Il y a beaucoup de lumi\u00e8re dans la maison',
                        title:
                            'Pourquoi le prix demand\u00e9 pourrait-il \u00eatre plus \u00e9lev\u00e9?',
                    },
                    send: 'envoyer',
                    subtitle:
                        "Entrez l'adresse email ci-dessous \u00e0 laquelle nous pouvons envoyer les r\u00e9sultats.",
                    text1:
                        'Le graphique montre comment ce prix cible est li\u00e9 aux prix de 200 maisons de la r\u00e9gion.',
                    text2:
                        "Cette \u00e9valuation automatique est une \u00e9valuation statistique bas\u00e9e sur les informations fournies et une comparaison avec plusieurs autres propri\u00e9t\u00e9s voisines. Il n'y a pas d'examen par un expert immobilier et l'\u00e9valuation finale peut changer en cons\u00e9quence.",
                    title: 'T\u00e9l\u00e9charger les r\u00e9sultats',
                },
            },
        },
        ing: {
            valuation: {
                enter: {
                    customer_ref_title: 'Quel est le LOP ID du pr\u00eat ?',
                    forbidden_substring: 'Ce champ ne peut contenir 0000000',
                },
                request: {
                    tab_title: 'Formulaire ING',
                },
                start: {
                    welcome_text_2:
                        "Chaque demande commence avec l'entr\u00e9e d'un LOP ID. Nous vous posons ensuite quelques questions concernant le bien en question. Pour plus d'informations, consultez la FAQ.",
                    welcome_text_3:
                        "Cet outil ne peut \u00eatre utilis\u00e9 que par les employ\u00e9es ING munis d'une licence hypoth\u00e9caire et ce uniquement pour un dossier LOP r\u00e9el. Le lien vers cet outil ne peut \u00eatre transmis, ni \u00e0 l'int\u00e9rieur ni \u00e0 l'ext\u00e9rieur du r\u00e9seau ING. Ceci est d\u00fb aux mesures internes contre la fraude ou l'abus.",
                },
            },
            monolith: {
                shared: {
                    customer_ref: 'LOP ID',
                },
            },
        },
        keytrade: {
            valuation: {
                start: {
                    welcome_text_2:
                        "Chaque demande commence par l'introduction de la r\u00e9f\u00e9rence interne li\u00e9e au pr\u00eat. Ensuite, Rock.estate vous demandes quelques questions relatives au bien. Pour plus d'informations, veuillez vous r\u00e9f\u00e9rer \u00e0 la FAQ.",
                    welcome_text_3:
                        "Cet outil ne peut \u00eatre utilis\u00e9 que par les employ\u00e9s de Keytrade disposant d'une licence hypoth\u00e9caire et uniquement pour des fichiers de r\u00e9f\u00e9rence internes r\u00e9els.",
                },
            },
        },
        ovm_dispatch: {
            settings: {
                title: 'Dispatcher dashboard',
                subtitle: 'Availability',
                nuts: {
                    placeholder: 'Select a NUTS',
                    caption: 'Number of available valuers in this NUTS:',
                },
                valuer: {
                    placeholder: 'Select a valuer',
                    error: 'No availability info found for this selection.',
                },
            },
            request: {
                confim: 'Confirm changes',
                notification: {
                    end_time: 'End time should be later than start time',
                },
                appointment: {
                    title: 'Create new appointment',
                    subtitle:
                        "The appointment detailed above will be cancelled and a new one will be created. The assigned valuer will be notified of the appointment's cancellation.",
                    button: 'Create appointment',
                    previous: 'Previous appointment records',
                },
            },
        },
        ovm: {
            settings: {
                unsaved_warning:
                    'You have unsaved changes. Please save them before switching tabs.',
            },
        },
    },
    'nl-BE': {
        unit: {
            m: 'm',
            m_tooltip: '',
            m2: 'm\u00b2',
            m2_tooltip: '',
            m3: 'm\u00b3',
            m3_tooltip: '',
            'kwh/m2year': 'kWh/m\u00b2jr',
            'kwh/m2year_tooltip': '',
            euro: '\u20ac',
            euro_tooltip: '',
            'euro/month': '\u20ac/maand',
            'euro/month_tooltip': '',
            'euro/year': '\u20ac/jr',
            'euro/year_tooltip': '',
            'euro/m2': '\u20ac/m\u00b2',
            'euro/m2_tooltip': '',
            'kgco2/m2year': 'kgCO\u2082/m\u00b2jr',
            'kgco2/m2year_tooltip': '',
            'kgco2/year': 'kgCO\u2082/jr',
            'kgco2/year_tooltip': '',
            'kwh/year': 'kWh/jr',
            'kwh/year_tooltip': '',
            'l/year': 'l/jr',
            'l/year_tooltip': '',
            'kg/year': 'kg/jr',
            'kg/year_tooltip': '',
            'm3/year': 'm\u00b3/jr',
            'm3/year_tooltip': '',
            percent: '%',
            percent_tooltip: '',
            month: '/maand',
            month_tooltip: '',
            kWh: 'kWh',
            kWh_tooltip: '',
            l: 'l',
            l_tooltip: '',
            kg: 'kg',
            kg_tooltip: '',
            'kWh/m2/yr': 'kWh/m\u00b2/jaar',
            'kWh/m2/yr_tooltip': '',
            'kWh/yr': 'kWh/jaar',
            'kWh/yr_tooltip': '',
            'l/yr': 'l/jaar',
            'l/yr_tooltip': '',
            'm3/yr': 'm\u00b3/jaar',
            'm3/yr_tooltip': '',
            'kg/co2/yr': 'kg/co2/jaar',
            'kg/co2/yr_tooltip': '',
            'kg/yr': 'kg/jaar',
            'kg/yr_tooltip': '',
        },
        address: {
            full_address: 'Adres',
            full_address_tooltip:
                'Selecteer het adres van het pand dat wordt gefinancierd. Gelieve dit niet te verwarren met het adres van eventuele andere panden die gebruikt worden als extra zekerheid.',
            streetname: 'Straat',
            streetname_tooltip: '',
            streetnumber: 'Nummer',
            streetnumber_tooltip: '',
            boxnumber: 'Bus',
            boxnumber_tooltip: '',
            postalcode: 'Postcode',
            postalcode_tooltip: '',
            municipality: 'Stad',
            municipality_tooltip: '',
        },
        valuation: {
            date: 'Waarderingsdatum',
            date_tooltip: '',
            type: 'Soort waardering',
            type_tooltip: '',
            performed_for: 'Uitgevoerd voor',
            performed_for_tooltip: '',
            valuer: 'Uitgevoerd door',
            valuer_tooltip: '',
            monitor: 'Gecontroleerd door',
            monitor_tooltip: '',
            market_value: 'Marktwaarde',
            market_value_tooltip: '',
            market_value_post_renovation: 'Verwachte marktwaarde na renovatie',
            market_value_post_renovation_tooltip: '',
            construction_cost: 'Bouwkosten',
            construction_cost_tooltip: '',
            market_value_pre_construction: 'Marktwaarde voor het bouwen ',
            market_value_pre_construction_tooltip: '',
            forced_sale_value_pre_construction: 'Gedwongen verkoopwaarde voor het bouwen',
            forced_sale_value_pre_construction_tooltip: '',
            forced_sale_value_post_renovation:
                'Verwachte gedwongen verkoopwaarde na renovatie',
            forced_sale_value_post_renovation_tooltip: '',
            forced_sale_value: 'Gedwongen verkoopwaarde',
            forced_sale_value_tooltip: '',
            rental_value: 'Maandelijkse huurprijs',
            rental_value_tooltip: '',
            reconstruction_value: 'Heropbouwwaarde',
            reconstruction_value_tooltip: '',
            cadastral_income: 'Kadastraal inkomen',
            cadastral_income_tooltip: '',
            index_value: 'Index',
            index_value_tooltip: '',
            index_type: 'Soort index',
            index_type_tooltip: '',
            explanation_1:
                'De waardering van dit gebouw berust gedeeltelijk op een data-gedreven statistisch model. Het resultaat werd door een vastgoedschatter gecontroleerd en bijgestuurd waar nodig. Het betreft een proces in twee stappen:',
            explanation_1_tooltip: '',
            explanation_2: 'Stap 1: Schatting door waarderingsmodel',
            explanation_2_tooltip: '',
            explanation_3:
                'Een eerste schatting van de marktwaarde van het pand wordt door het model berekend op basis van alle input van de klant alsook enkele bijkomende inputparameters (cf. blz. 2). Deze schatting geeft de gemiddelde marktwaarde voor een pand met deze locatie en karakteristieken.(*)',
            explanation_3_tooltip: '',
            construction_plot_explanation_3:
                'Een eerste schatting van de marktwaarde van het pand wordt berekend op basis van de totale oppervlakte van het perceel en de historische prijs per vierkante meter van panden in de omgeving.',
            construction_plot_explanation_3_tooltip: '',
            explanation_4: 'Stap 2: Evaluatie en verfijning door vastgoedschatter',
            explanation_4_tooltip: '',
            explanation_5:
                'De vastgoedschatter verifieert het model in stap 1 en houdt vervolgens rekening met de andere inputparameters. Dit resulteert in de marktwaarde van het pand (rode lijn in grafiek). Afhankelijk van de correcties die door de vastgoedschatter worden toegepast, kan de marktwaarde lager of hoger uitvallen dan de oorspronkelijke waardering van het model.\nDe onderstaande grafiek illustreert hoe de marktwaarde van dit pand zich vergelijkt met andere panden in de omgeving. Het kan helpen om deze waardering te contextualiseren.',
            explanation_5_tooltip: '',
            construction_plot_explanation_5:
                'De vastgoedschatter verifieert het model in stap 1 en houdt vervolgens rekening met de andere inputparameters.',
            construction_plot_explanation_5_tooltip: '',
            explanation_6:
                'De marktwaarde in dit rapport is gebaseerd op een waardering uitgevoerd door een vastgoedschatter op afstand. De waardering tracht een zo goed mogelijk zicht te geven op de huidige waarde van het pand. Het blijft echter een schatting waarbij de volgende elementen in aanmerking moeten worden genomen:\n- Waardering op afstand: de schatter heeft het pand van op afstand ge\u00ebvalueerd en heeft dit niet effectief bezocht.\n- Nauwkeurigheid van het model: de waardering berust gedeeltelijk op een statistisch model met een bepaalde foutenmarge.\n- Subjectiviteit: zelfs de best mogelijke waardering uitgevoerd door een schatter bevat een zeker niveau van subjectiviteit.',
            explanation_6_tooltip: '',
            onsite_explanation_6:
                'De marktwaarde in dit rapport is gebaseerd op een waardering uitgevoerd door een vastgoedschatter ter plaatse. De waardering tracht een zo goed mogelijk zicht te geven op de huidige waarde van het pand. Het blijft echter een schatting waarbij de volgende elementen in aanmerking moeten worden genomen:\n- Nauwkeurigheid van het model: de waardering berust gedeeltelijk op een statistisch model met een bepaalde foutenmarge.\n- Subjectiviteit: zelfs de best mogelijke waardering uitgevoerd door een schatter bevat een zeker niveau van subjectiviteit.',
            onsite_explanation_6_tooltip: '',
            shared: {
                apartment: 'Appartement',
                assessed: 'Assessed',
                destructive_safeguard: {
                    confirm: 'Bevestig',
                    content: 'Bent u zeker dat u wilt verdergaan?',
                    title:
                        'Opgelet: indien u verdergaat met deze wijziging, wordt het input formulier gereset.',
                },
                distance: 'Distance',
                listing_date: 'Listing date',
                reference: 'Reference',
            },
            desktop: {
                avm_features_influence: 'AVM Features Deviation',
            },
            sidesteps: {
                borrower_details: 'Gegevens lener',
                chat: {
                    button: 'Chat',
                    title: 'Your conversation with the Valuation Specialist',
                },
                construction_plot: 'Bouwgrond',
                extra_info: 'Extra informatie',
                feedback: 'Feedback',
            },
            floors: {
                close: 'Sluiten',
            },
            enter: {
                conflict_modal: {
                    back: 'Terug',
                    content:
                        'Om deze bestaande aanvraag te bekijken, klikt u op de Dashboard knop hieronder:',
                    continue: 'Doorgaan',
                    cta: 'Wilt u doorgaan met de gedupliceerde referentie?',
                    dashboard: 'Bekijk in dashboard',
                    title:
                        'Er bestaat reeds een aanvraag met dezelfde interne referentie.',
                },
                customer_ref_title: 'Wat is de interne referentie van de lening?',
                tooltip_text:
                    'Hiermee wordt de link gelegd tussen de aanvraag en de lening.',
            },
            extra_info: {
                construction_cost_minValue:
                    'Gelieve bouwkosten hoger dan 10000 in te voeren',
                documents: 'Documenten',
                documents_modal: {
                    label: 'Documenten toevoegen (.jpg, .jpeg, .png, .pdf)',
                    steps: {
                        online: 'Verzonden',
                        upload: 'Toevoegen',
                        uploading: 'Laden',
                    },
                    title: 'Documenten verzenden',
                    warning:
                        'Alle gedeelde documenten die andere informatie bevatten dan het EPC document of een exterieur foto van het gebouw zullen worden genegeerd en verwijderd.',
                },
            },
            feedback: {
                customer_present: 'Heeft u dit formulier samen met de klant ingevuld?',
                more_questions:
                    'U kunt de status van uw aanvraag volgen op het dashboard.',
                question_one:
                    'Hoe beoordeelt u de ervaring bij het invoeren van deze aanvraag?',
                question_three_blocked:
                    'Vertel ons wat er is gebeurd en waarom u niet verder kunt gaan.',
                question_three_sent: 'Andere opmerkingen',
                question_two: 'Welke documenten had de klant beschikbaar?',
                question_two_1: 'EPC certificaat',
                question_two_1_text: 'Referentie',
                question_two_2: 'Immo advertentie',
                question_two_2_link: 'Link / referentie',
                question_two_2_text: 'Bron',
                question_two_3: 'Ondertekend bod',
                question_two_4: 'Compromis',
                question_two_5: 'Verkoopakte',
                question_two_6: 'Expertise rapport',
                rating_1: '1: Zeer slecht',
                rating_2: '2: Slecht',
                rating_3: '3: Ok',
                rating_4: '4: Goed',
                rating_5: '5: Zeer goed',
                send: 'Feedback verzenden en opnieuw beginnen',
                rating_description: '(1 = zeer slecht / 5 = zeer goed)',
            },
            start: {
                dashboard: 'Dashboard',
                welcome_text_1:
                    'Welkom! Deze toepassing werkt voor elk huis of appartement met een adres in Belgi\u00eb.',
                welcome_text_2:
                    'Elke aanvraag start met het invoeren van de relevante pand informatie.',
                welcome_text_3:
                    'Dit is een testversie van de Rockestate schattingstoepassing. De configuratie is opgezet op een manier om u toe te laten om een goed idee te vormen over de verschillende waarderingsalternatieven die Rockestate aanbiedt (automatisch, op afstand & ter plaatse). De implementatie van deze applicatie in een productie-omgeving kan licht verschillen van deze testversie.',
                welcome_title: 'Bereken een vastgoedprijs',
            },
            avm: {
                no_bedroom: '0 bedrooms!',
            },
            request: {
                start_button_text: 'Start',
                start_over: 'Opnieuw beginnen zonder feedback verzenden',
                tab_title: 'Input Form',
                text_too_long: 'Dit veld is te lang',
                textarea_placeholder: 'Typ hier uw opmerkingen',
                title: 'We zijn er bijna. Nog enkele vraagjes om af te ronden.',
                which_type: 'Welk type pand wordt gefinancierd?',
                which_address: 'Wat is het adres van het te financieren pand?',
                title_blocked: 'Het spijt ons dat u bent geblokkeerd',
                title_sent: 'Uw aanvraag werd verzonden!',
            },
            building_type: {
                tooltip_text:
                    'Financiert de klant een \u00e9\u00e9ngezinswoning of een appartement?',
            },
            address: {
                tooltip_text:
                    'Selecteer het adres van het pand dat wordt gefinancierd. Gelieve dit niet te verwarren met het adres van eventuele andere panden die gebruikt worden als extra zekerheid.',
            },
            map: {
                'tooltip-for-confirm-main-building':
                    'Als dit niet het juiste gebouw is, kunt u op de onderstaande link klikken om een ander gebouw te kiezen',
                'tooltip-for-confirm-main-parcel':
                    'Het hoofdperceel is het perceel waar een huis gebouwd zou worden.',
                'tooltip-for-select-extra-parcels':
                    'Klik met de muis op de andere percelen die bij de woning horen',
                'tooltip-for-select-main-building':
                    'Klik met de muis op het hoofdgebouw verbonden aan het door u opgegeven adres',
                'tooltip-for-select-main-parcel':
                    'Het hoofdperceel is het perceel waar een huis gebouwd zou worden.',
                'tooltip-for-select-parcels':
                    'Klik met de muis op de percelen verbonden aan de woning',
                'tooltip-for-select-secondary-buildings': '',
                'tooltip-for-view-building-parcels':
                    'Indien u deze gegevens wenst te wijzigen, dient u deze aanvraag te annuleren en een nieuwe aanvraag in te dienen',
                use_as_reference: 'Use as reference',
            },
            '': {
                upload_documents_tooltip: 'document(en) verzonden',
            },
        },
        assessment: {
            date_tooltip: '',
            type_tooltip: '',
        },
        value: {
            avm: 'Automatische waardering',
            avm_tooltip: '',
            dvm: 'Waardering op afstand',
            dvm_tooltip: '',
            ovm: 'Waardering ter plaatse',
            ovm_tooltip: '',
            flood_assessment_tooltip: '',
            ers: 'Energetische renovatie simulatie',
            ers_tooltip: '',
            short: {
                avm: 'Automatische waardering',
                avm_tooltip: '',
                dvm: 'Waardering op afstand',
                dvm_tooltip: '',
                ovm: 'Waardering ter plaatse',
                ovm_tooltip: '',
                ers: 'Energetische renovatie',
                ers_tooltip: '',
            },
            '-': ' ',
            '-_tooltip': '',
            new_loan: 'Nieuwe kredietaanvraag',
            new_loan_tooltip: '',
            revaluation: 'Herwaardering',
            revaluation_tooltip: '',
            classic_tooltip: '',
            renovation_light_tooltip: '',
            renovation_full_tooltip: '',
            new_building: 'Woning in aanbouw',
            new_building_tooltip: 'onder BTW-stelsel',
            existing_building: 'Bestaande woning',
            existing_building_tooltip: 'onder registratierechten',
            house: 'Huis',
            house_tooltip: 'Gebouw met \u00e9\u00e9n enkele woonentiteit',
            apartment: 'Appartement',
            apartment_tooltip: 'Een woonentiteit die deel uitmaakt van een groter gebouw',
            annex: 'Bijgebouw',
            annex_tooltip: '',
            new_construction: 'Nieuwbouw',
            new_construction_tooltip: '',
            new_house: 'Nieuwbouw woning',
            new_house_tooltip: 'Gebouw met \u00e9\u00e9n enkele woonentiteit',
            new_apartment: 'Nieuwbouw appartement',
            new_apartment_tooltip:
                'Een woonentiteit die deel uitmaakt van een groter gebouw',
            construction_plot: 'Bouwgrond',
            construction_plot_tooltip: '',
            attached: 'Gesloten bebouwing',
            attached_tooltip: '',
            semi: 'Half-open bebouwing',
            semi_tooltip: '',
            detached: 'Open bebouwing',
            detached_tooltip: '',
            yes: 'Ja',
            yes_tooltip: '',
            no: 'Nee',
            no_tooltip: '',
            traditional: 'Traditioneel',
            traditional_tooltip: '',
            modern: 'Modern',
            modern_tooltip: '',
            contemporary: 'Hedendaags',
            contemporary_tooltip: '',
            mediterranean: 'Mediterraans',
            mediterranean_tooltip: '',
            other: 'Andere',
            other_tooltip: '',
            ground_floor: 'Gelijkvloers',
            ground_floor_tooltip: '',
            1: '1',
            '1_tooltip': '',
            2: '2',
            '2_tooltip': '',
            3: '3',
            '3_tooltip': '',
            4: '4',
            '4_tooltip': '',
            '>4': '>4',
            '>4_tooltip': '',
            interior: 'Interieur',
            interior_tooltip: '',
            exterior: 'Exterieur',
            exterior_tooltip: '',
            private: 'Privatieve tuin',
            private_tooltip: '',
            common: 'Gemeenschappelijke tuin',
            common_tooltip: '',
            'private+common': 'Privatieve en gemeenschappelijke tuin',
            'private+common_tooltip': '',
            maintenance_required: 'Onderhoud nodig',
            maintenance_required_tooltip: '',
            good: 'Goed',
            good_tooltip: '',
            very_good: 'Zeer goed',
            very_good_tooltip: '',
            security: 'Beveiligingssysteem',
            security_tooltip: '',
            water_softener: 'Waterverzachter',
            water_softener_tooltip: '',
            air_con: 'Airconditioning',
            air_con_tooltip: '',
            elevator: 'Lift',
            elevator_tooltip: '',
            domotics: 'Domotica',
            domotics_tooltip: '',
            storage: '(Fiets)opslag',
            storage_tooltip: '',
            rain_water: 'Regenwaterput',
            rain_water_tooltip: '',
            hot_tub: 'Hot-tub',
            hot_tub_tooltip: '',
            cinder_blocks: 'Betonblokken',
            cinder_blocks_tooltip: '',
            wood: 'Hout',
            wood_tooltip: '',
            plaster: 'Gips',
            plaster_tooltip: '',
            natural_stone: 'Natuursteen',
            natural_stone_tooltip: '',
            metal: 'Metaal',
            metal_tooltip: '',
            concrete: 'Beton',
            concrete_tooltip: '',
            brick: 'Baksteen',
            brick_tooltip: '',
            tiles: 'Pannen',
            tiles_tooltip: '',
            bitumen_roofing: 'Roofing',
            bitumen_roofing_tooltip: '',
            slate_shingles: 'Leistenen dakpan',
            slate_shingles_tooltip: '',
            black_concrete_tiles: 'Zwarte betontegels',
            black_concrete_tiles_tooltip: '',
            thatched: 'Rieten dak',
            thatched_tooltip: '',
            asbestos: 'Asbest',
            asbestos_tooltip: '',
            green_roof: 'Groen dak',
            green_roof_tooltip: '',
            home_liberal_profession_or_office: 'Huis, vrij beroep of kantoor',
            home_liberal_profession_or_office_tooltip: '',
            home_other_professional_activity: 'Andere beroepsactiviteit',
            home_other_professional_activity_tooltip: '',
            home: 'Huis',
            home_tooltip: '',
            no_economic_activity: 'Geen economische activiteit',
            no_economic_activity_tooltip: '',
            activity_unlikely: 'Activiteit onwaarschijnlijk',
            activity_unlikely_tooltip: '',
            activity_possible: 'Activiteit mogelijk',
            activity_possible_tooltip: '',
            activity_likely: 'Activiteit waarschijnlijk',
            activity_likely_tooltip: '',
            activity_very_likely: 'Activiteit zeer waarschijnlijk',
            activity_very_likely_tooltip: '',
            n: 'N',
            n_tooltip: '',
            ne: 'NO',
            ne_tooltip: '',
            e: 'O',
            e_tooltip: '',
            se: 'ZO',
            se_tooltip: '',
            s: 'Z',
            s_tooltip: '',
            sw: 'ZW',
            sw_tooltip: '',
            w: 'W',
            w_tooltip: '',
            nw: 'NW',
            nw_tooltip: '',
            limited: 'Beperkt',
            limited_tooltip: '',
            details_previous_page: '(details op vorige pagina)',
            details_previous_page_tooltip: '',
            below_average: 'Onder het gemiddelde',
            below_average_tooltip: '',
            average: 'Gemiddeld',
            average_tooltip: '',
            above_average: 'Boven het gemiddelde',
            above_average_tooltip: '',
            low: 'Laag',
            low_tooltip: '',
            medium: 'Gemiddeld',
            medium_tooltip: '',
            high: 'Hoog',
            high_tooltip: '',
            unknown: 'Onbekend',
            unknown_tooltip: '',
            urban: 'Stedelijk ',
            urban_tooltip: '',
            rural: 'Landelijk',
            rural_tooltip: '',
            isolated: 'Ge\u00efsoleerd',
            isolated_tooltip: '',
            city: 'Stad',
            city_tooltip: '',
            suburbs: 'Stedelijk ',
            suburbs_tooltip: '',
            village: 'Dorp',
            village_tooltip: '',
            none: 'Geen',
            none_tooltip: '',
            classified_facade: 'Beschermde gevel',
            classified_facade_tooltip: '',
            green_neighbourhood: 'Groene buurt',
            green_neighbourhood_tooltip: '',
            sea_view: 'Zeezicht',
            sea_view_tooltip: '',
            no_direct_traffic: 'Geen direct verkeer',
            no_direct_traffic_tooltip: '',
            exceptional_view: 'Uitzonderlijk zicht',
            exceptional_view_tooltip: '',
            tram: 'Tram',
            tram_tooltip: '',
            train: 'Trein',
            train_tooltip: '',
            metro: 'Metro',
            metro_tooltip: '',
            traffic: 'Verkeer',
            traffic_tooltip: '',
            busy_area: 'Drukke omgeving',
            busy_area_tooltip: '',
            user_estimate: 'Schatting',
            user_estimate_tooltip: '',
            certificate: 'Certificaat',
            certificate_tooltip: '',
            refinancing: 'Herfinanciering of wederopname',
            refinancing_tooltip: '',
            bedroom_tooltip: '',
            bathroom: 'Badkamer',
            bathroom_tooltip: '',
            toilet_tooltip: '',
            abex: 'ABEX',
            abex_tooltip: '',
            apartment_block_info:
                'De gemeenschappelijke delen van het gebouw gedeeld door mede-eigenaars',
            apartment_block_info_tooltip: '',
            apartment_block: 'Appartementsgebouw ',
            apartment_block_tooltip: '',
            other_type: 'Ander',
            other_type_tooltip: '',
            single: 'Enkel',
            single_tooltip: '',
            ordinary_double: 'Standaard dubbel',
            ordinary_double_tooltip: '',
            hr_double_after_2000: 'Hoog rendement dubbel (na 2000)',
            hr_double_after_2000_tooltip: '',
            hr_double_before_2000: 'Hoog rendement dubbel (voor 2000)',
            hr_double_before_2000_tooltip: '',
            triple: 'Driedubbel',
            triple_tooltip: '',
            gas: 'Gas',
            gas_tooltip: '',
            oil: 'Stookolie',
            oil_tooltip: '',
            pellets: 'Pellets',
            pellets_tooltip: '',
            coal: 'Kool',
            coal_tooltip: '',
            district_heating: 'Warmtedistributie / stadsverwarming',
            district_heating_tooltip: '',
            'boiler:condensing': 'Condensatieketel',
            'boiler:condensing_tooltip': '',
            heat_pump: 'Warmtepomp',
            heat_pump_tooltip: '',
            'boiler:standard': 'Standaard ketel',
            'boiler:standard_tooltip': '',
            chp: 'Warmetkrachtkoppeling',
            chp_tooltip: '',
            stove: 'Kachel',
            stove_tooltip: '',
            electricity: 'Elektriciteit',
            electricity_tooltip: '',
            electric_heater: 'Elektrische verwarming',
            electric_heater_tooltip: '',
            no_ventilation: 'Geen ventilatie',
            no_ventilation_tooltip: '',
            natural: 'Natuurlijk',
            natural_tooltip:
                'Natuurlijke toe- en afvoer van lucht via ramen en roosters.',
            mechanical: 'Mechanisch',
            mechanical_tooltip: '',
            system_b: 'Systeem B',
            system_b_tooltip:
                'Mechanische toevoer van verse lucht, natuurlijke afvoer van vervuilde lucht.',
            system_c: 'Systeem C',
            system_c_tooltip:
                'Natuurlijke toevoer van verse lucht, mechanische afvoer van vervuilde lucht.',
            system_cplus: 'Systeem C+',
            system_cplus_tooltip:
                'Vraaggestuurde mechanische toe- en afvoer van lucht op basis van luchtkwaliteit.',
            system_d: 'Systeem D',
            system_d_tooltip:
                'Volledig geautomatiseerde continue mechanische toe- en afvoer van lucht, ook wel "balansventilatie" genoemd.',
            pur_pir: 'PUR/PIR',
            pur_pir_tooltip: '',
            mineral_wool: 'Minerale wol',
            mineral_wool_tooltip: '',
            hr_double: 'Hoog rendement dubbel',
            hr_double_tooltip: '',
            air_water: 'Lucht-water',
            air_water_tooltip: '',
            monocrystalline: 'Monokristallijn',
            monocrystalline_tooltip: '',
        },
        request: {
            references: 'Referenties',
            references_tooltip: '',
            valuation_request_ref: 'Rock.estate referentie',
            valuation_request_ref_tooltip: '',
            customer_ref: 'Interne referentie',
            customer_ref_tooltip:
                'Hiermee wordt de link gelegd tussen de aanvraag en de lening.',
            bank: 'Bank',
            bank_tooltip: '',
            customer: 'Klant',
            customer_tooltip: '',
            purpose: 'Doel van waardering',
            purpose_tooltip: '',
            package_tooltip: '',
            map_select: {
                'explanation-confirm-main-parcel':
                    'Zijn de locatie en totale perceeloppervlakte van het hoofdperceel correct?',
                'cannot-find-confirm-main-parcel':
                    'Neen, de locatie of de totale perceeloppervlakte is niet correct.',
                'explanation-select-main-parcel':
                    'Selecteer het juiste hoofdperceel indien de locatie incorrect was.',
                'explanation-select-main-parcel-no-selection':
                    'Selecteer het hoofdperceel.',
                'cannot-find-select-main-parcel':
                    'De locatie is correct, maar de totale perceeloppervlakte is kleiner (vb. verkaveling).',
                'explanation-select-extra-parcels':
                    'Selecteer bijkomende percelen inbegrepen in de aankoop. Kijk na of de totale perceeloppervlakte klopt.',
                'cannot-find-select-extra-parcels':
                    'Ik wil de totale perceeloppervlakte corrigeren.',
                'explanation-confirm-main-building': 'Is dit het juiste gebouw?',
                'cannot-find-confirm-main-building': 'Dit is niet het juiste gebouw',
                'explanation-select-main-building': 'Selecteer het hoofdgebouw',
                'cannot-find-select-main-building': 'Ik kan het hoofdgebouw niet vinden',
                'explanation-select-secondary-buildings':
                    'Selecteer het/de bijgebouw(en)',
                'cannot-find-select-secondary-buildings':
                    'Ik kan sommige bijgebouwen niet vinden',
                'explanation-select-parcels': 'Selecteer percelen',
                'cannot-find-select-parcels': 'Ik kan sommige percelen niet vinden',
                'tooltip-for-select-parcels':
                    'Klik met de muis op de percelen verbonden aan de woning',
                'explanation-view-building-parcels':
                    'Dit gebouw en deze percelen werden geselecteerd',
            },
        },
        footer: {
            text: 'Voor meer informatie, bezoek {url}',
            text_tooltip: '',
            data_version: 'Gegevens bijgewerkt op {data_version}',
        },
        url: {
            rockestate_main: 'https://www.rock.estate',
            rockestate_main_tooltip: '',
            dashboard: '/valuation/default/dashboard',
            dashboard_tooltip: '',
            rockestate_info: 'https://www.rock.estate/',
            rockestate_info_tooltip: '',
            valuation_app: '/valuation/default/',
            valuation_app_tooltip: '',
        },
        export: {
            by: 'Uitgevoerd door',
            by_tooltip: '',
            date: 'Datum',
            date_tooltip: '',
            reference: 'Referentie',
            reference_tooltip: '',
        },
        section: {
            reconstruction_value: 'Heropbouw',
            reconstruction_value_tooltip: '',
            address_location: 'Adres en locatie',
            address_location_tooltip: '',
            secondary_buildings: 'Bijgebouwen',
            secondary_buildings_tooltip: '',
            economic_activity: 'Economische activiteit',
            economic_activity_tooltip: '',
            roof: 'Dak',
            roof_tooltip: '',
            transaction: 'Transacties',
            transaction_tooltip: '',
            general: 'Algemeen',
            general_tooltip: '',
            report: 'Verslag',
            report_tooltip: '',
            application: 'Toepassing',
            application_tooltip: '',
            dashboard: 'Dashboard',
            dashboard_tooltip: '',
            dispatcher: 'Dispatcher',
            dispatcher_tooltip: '',
            'user-admin': 'Gebruikers',
            'user-admin_tooltip': '',
            apps: 'Apps',
            apps_tooltip: '',
            results: 'Resultaten',
            results_tooltip: '',
            flood_regular_tooltip: '',
            flood_insurance_exclusion_tooltip: '',
            helpcenter: 'Helpcentrum',
            helpcenter_tooltip: '',
            'faq-search-results': 'Zoekresultaten',
            'faq-search-results_tooltip': '',
            warnings: 'Waarschuwingen',
            warnings_tooltip: '',
            renovation: 'Geplande renovatie',
            renovation_tooltip: '',
            general_info: 'Algemene informatie',
            general_info_tooltip: '',
            parcels_and_buildings: 'Percelen en gebouwen',
            parcels_and_buildings_tooltip: '',
            c_parcels: 'Grond',
            c_parcels_tooltip: '',
            c_building: 'Hoofdgebouw',
            c_building_tooltip: '',
            building: 'Gebouw',
            building_tooltip: '',
            secondary_buildings2: 'Bijgebouwen',
            secondary_buildings2_tooltip: '',
            building_structure: 'Structuur van het gebouw',
            building_structure_tooltip: '',
            common_parts: 'Gemeenschappelijke delen',
            common_parts_tooltip: '',
            building_purpose_classification: 'Bestemming en klassering van het gebouw',
            building_purpose_classification_tooltip: '',
            parcels: 'Perceel/percelen',
            parcels_tooltip: '',
            surroundings: 'Directe omgeving',
            surroundings_tooltip: '',
            mobility: 'Mobiliteit',
            mobility_tooltip: '',
            interior: 'Interieur',
            interior_tooltip: '',
            room: 'Kamer',
            room_tooltip: '',
            valuations: 'Waarderingen',
            valuations_tooltip: '',
            reference_properties_location: 'Referentiepanden: locatie',
            reference_properties_location_tooltip: '',
            reference_properties_characteristics: 'Referentiepanden: kenmerken',
            reference_properties_characteristics_tooltip: '',
            flood: 'Overstromingsgebieden',
            flood_tooltip: '',
            energy: 'Energie',
            energy_tooltip: '',
            flood_simple: 'Overstromingsgebieden',
            flood_simple_tooltip: '',
            faq: 'Veelgestelde vragen',
            faq_tooltip: '',
            questions_feedback: 'Vragen en feedback',
            questions_feedback_tooltip: '',
            contact_info: 'Contactgegevens',
            contact_info_tooltip: '',
            disclaimer: 'Disclaimer',
            disclaimer_tooltip: '',
            heating: 'Verwarming',
            heating_tooltip: '',
            ventilation: 'Ventilatie',
            ventilation_tooltip: '',
            renewables: 'Hernieuwbare energie',
            renewables_tooltip: '',
            additional_consumption: 'n/a',
            additional_consumption_tooltip: '',
            consumers: 'Verbruikers',
            consumers_tooltip: '',
            energy_consumption_info_tooltip: '',
            house_info: 'Woning gegevens',
            house_info_tooltip: '',
            consumption: 'Verbruik',
            consumption_tooltip: '',
            property_type: 'Type woning',
            property_type_tooltip: '',
            address: 'Adres bevestiging',
            address_tooltip: '',
            insulation: 'Isolatie',
            insulation_tooltip: '',
            house_information: 'Woning gegevens',
            house_information_tooltip: '',
        },
        front: {
            title: 'Waarderingsverslag',
            title_tooltip: '',
            core_title: 'Eigendomsrapport ',
            core_title_tooltip: '',
            flood_assessment: {
                title_tooltip: '',
            },
        },
        features: {
            renovation_cost: 'Renovatiekosten (excl BTW)',
            renovation_cost_tooltip: '',
            energetic_renovation_cost: 'Energetische renovatiekosten (excl BTW)',
            energetic_renovation_cost_tooltip: '',
            energetic_renovation_added_value:
                'Toegevoegde waarde energetische renovaties',
            energetic_renovation_added_value_tooltip: '',
            construction_cost: 'Bouwkosten (excl BTW)',
            construction_cost_tooltip:
                'De totale kosten om de woning te bouwen, inclusief de kosten van materialen en arbeid.',
            parcel_cost: 'Waarde van de bouwgrond (excl. belastingen)',
            parcel_cost_tooltip:
                'De totale kost om de grond te kopen waar het pand gebouwd wordt/zal worden gebouwd.',
            building_class: 'Type pand',
            building_class_tooltip: 'Welke type pand financiert de klant?',
            f_building_type: 'Type woning',
            f_building_type_tooltip:
                'Financiert de klant een \u00e9\u00e9ngezinswoning of een appartement?',
            f_touching_sides: 'Gemeenschappelijke muren',
            f_touching_sides_tooltip: '',
            f_number_of_facades: 'Type bebouwing',
            f_number_of_facades_tooltip: '',
            f_number_of_facades_or_type: 'Type bebouwing',
            f_number_of_facades_or_type_tooltip:
                'Als de woning naar verwachting twee gemeenschappelijke muren zal hebben, selecteer dan "Gesloten bebouwing", als het slechts \u00e9\u00e9n gemeenschappelijke muur zal hebben, selecteer dan "Half-open bebouwing". Selecteer tenslotte "Open bebouwing" als de woning geen gemeenschappelijke muren met zijn buren heeft.',
            f_parcel_area: 'Totale perceeloppervlakte',
            f_parcel_area_tooltip:
                'De totale oppervlakte van het perceel/de percelen, zoals opgenomen in het Kadaster',
            f_building_area: 'Bebouwde oppervlakte',
            f_building_area_tooltip: '',
            f_others: 'Andere',
            f_others_tooltip: '',
            f_x_annexes: 'Bijgebouw(en)',
            f_x_annexes_tooltip: '',
            f_annexes_area: 'Totale oppervlakte van bijgebouw(en)',
            f_annexes_area_tooltip: '',
            f_area_largest_annex: 'Grootste bijgebouw',
            f_area_largest_annex_tooltip: '',
            distances_annexes: 'Afstanden tot het hoofdgebouw',
            distances_annexes_tooltip: '',
            parcel_ids: 'Kadastrale referentie',
            parcel_ids_tooltip: '',
            f_lng: 'Lengtegraad',
            f_lng_tooltip: '',
            f_lat: 'Breedtegraad',
            f_lat_tooltip: '',
            f_number_of_addresses: 'Aantal adressen',
            f_number_of_addresses_tooltip: '',
            f_living_area: 'Bewoonbare oppervlakte',
            f_living_area_tooltip:
                'De totale bewoonbare oppervlakte van de woning. Deze info is doorgaans te vinden in het EPC attest.',
            f_expected_living_area: 'Bewoonbare oppervlakte na oplevering',
            f_expected_living_area_tooltip:
                'Verwachte totale bewoonbare oppervlakte van het pand. Deze informatie is te vinden in het lastenboek of de plannen van de woning.',
            f_approx_living_area: 'Geschatte bewoonbare oppervlakte',
            f_approx_living_area_tooltip: '',
            n_rooms: 'Aantal kamers',
            n_rooms_tooltip: '',
            approx_n_rooms: 'Geschat aantal kamers',
            approx_n_rooms_tooltip: '',
            transaction_value: 'Transactieprijs',
            transaction_value_tooltip: '',
            transaction_date_tooltip: '',
            approx_price_sqm_tooltip: '',
            co2_sqm_tooltip: '',
            co2_label_tooltip: '',
            f_approx_epc: 'Verwachte EPC na oplevering',
            f_approx_epc_tooltip: '',
            f_construction_year: 'Bouwjaar',
            f_construction_year_tooltip:
                'Het jaar waarin de woning officieel gebouwd werd. Dit houdt geen rekening met eventuele renovaties op een later tijdstip. Deze info is doorgaans te vinden in de verkoopadvertentie.',
            f_expected_construction_year: 'Verwachte jaar van oplevering',
            f_expected_construction_year_tooltip:
                'Dit is het verwachte jaar waarin de woning klaar zal zijn voor bewoning. Dit jaartal is te vinden op de folder van de promotor of het lastenboek als bij een promotor wordt gekocht. Als het pand door een onafhankelijke partij wordt gebouwd, moet het verwachte bouwjaar worden vermeld in de bouwvergunning.',
            f_epc: 'EPC',
            f_epc_tooltip:
                'De EPC-waarde wordt uitgedrukt in kWh/m\u00b2 per jaar en is terug te vinden in het EPC attest.',
            f_epc_label: 'EPC',
            f_epc_label_tooltip: '',
            f_epc_numeric: 'EPC',
            f_epc_numeric_tooltip: '',
            f_expected_epc: 'Verwachte EPC na oplevering',
            f_expected_epc_tooltip:
                'De EPC-waarde wordt uitgedrukt in kWh/m\u00b2 per jaar en is terug te vinden in het EPC attest. Voor nieuwbouw kunt u deze informatie halen uit het EPB-certificaat. Als uw klant dit niet heeft ontvangen, gebruiken wij het wettelijk minimum voor nieuwbouw in uw regio.',
            f_bedrooms: 'Aantal slaapkamers',
            f_bedrooms_tooltip:
                'Totaal aantal kamers die kunnen dienen als slaapkamer. Keuken, badkamer en woonkamer worden hier niet bij meegerekend.',
            f_floor: 'Verdieping',
            f_floor_tooltip:
                'De verdieping waarop het appartement zich bevindt. Indien meerdere, selecteer ze allemaal.',
            f_bottom_floor: 'Onderste verdieping van het gebouw',
            f_bottom_floor_tooltip:
                'De onderste verdieping van een gebouw is ofwel 0 ofwel een negatief getal, afhankelijk van het aantal ondergrondse verdiepingen. \nWijs een waarde van 0 toe als het gebouw geen ondergrondse verdiepingen heeft. \nWijs een negatieve waarde toe als het gebouw een kelder/ondergrondse garage/... heeft.',
            f_top_floor: 'Bovenste verdieping van het gebouw',
            f_top_floor_tooltip:
                'De bovenste verdieping van een gebouw is de laatste bewoonbare verdieping van een gebouw. Soms kan dit op de zolderverdieping zijn.',
            f_floors: 'Verdieping(en) van het appartement',
            f_floors_tooltip:
                'Selecteer de verdieping(en) waarop het appartement zich bevindt in de gegenereerde lijst.\nBijvoorbeeld: voor een duplex gelegen op verdiepingen 2 en 3, selecteert u beide verdiepingen.',
            f_balcony_present: 'Terras',
            f_balcony_present_tooltip:
                "U kan het vakje 'Ja' aanduiden als het appartement ten minste \u00e9\u00e9n buitenruimte heeft. Hetzij een balkon of een terras waar u op kunt staan.",
            f_garage_present: 'Garage',
            f_garage_present_tooltip:
                'Het appartment kan beschikken over \u00e9\u00e9n of meerdere garageplaatsen. Dit kan zowel een standplaats zijn als een box, binnen of buiten.',
            f_n_closed_garage: 'Aantal gesloten garages',
            f_n_closed_garage_tooltip:
                'Een gesloten garage is een garagebox, dit kan binnen of buiten zijn. Vermeld het aantal gesloten garages die bij het beoordeelde appartement behoren.',
            f_n_parking_spot: 'Aantal parkeerplaatsen',
            f_n_parking_spot_tooltip:
                'Een parkeerplaats is een staanplaats buiten of binnen en is afgebakend door markeringen en niet door muren (in tegenstelling tot gesloten garages).\nVermeld het aantal parkeerplaatsen die bij het pand horen.',
            f_cellar_attic: 'Kelder en/of zolder',
            f_cellar_attic_tooltip: '',
            f_garden_access: 'Tuin',
            f_garden_access_tooltip:
                'Het appartement kan toegang hebben tot een privatieve of gemeenschappelijke tuin.',
            f_garden_common: 'Toegang tot een gemeenschappelijke tuin',
            f_garden_common_tooltip:
                'Een gemeenschappelijke tuin is alleen toegankelijk voor de bewoners van het gebouw waar de woning wordt beoordeeld. \nAls er een gemeenschappelijke tuin is, heeft het te beoordelen appartement er dan toegang toe? Zo ja, selecteer ja.',
            f_garden_private: 'Toegang tot een privatieve tuin',
            f_garden_private_tooltip:
                'Een priv\u00e9tuin is enkel voor de bewoners van het beoordeelde appartement en grenst aan het appartement. Het verschil tussen een tuin en een terras is dat een tuin gras heeft.',
            f_volume: 'Volume hoofdgebouw',
            f_volume_tooltip: '',
            exterior_wall_area: 'Oppervlakte buitenmuren',
            exterior_wall_area_tooltip: '',
            f_roof_area: 'Dakoppervlakte',
            f_roof_area_tooltip: '',
            f_mean_tilt: 'Gemiddelde dakhelling',
            f_mean_tilt_tooltip: '',
            f_percent_of_roof_flat: 'Plat dak proportie',
            f_percent_of_roof_flat_tooltip: '',
            f_min_height: 'Minimale dakhoogte',
            f_min_height_tooltip: '',
            f_max_height: 'Maximale dakhoogte',
            f_max_height_tooltip: '',
            f_n_parts: 'Delen van het hoofdgebouw',
            f_n_parts_tooltip: '',
            f_n_roof_panes: 'Dakdelen',
            f_n_roof_panes_tooltip: '',
            f_x_matched_entities: 'Entiteiten bekend op dit adres',
            f_x_matched_entities_tooltip: '',
            c_economic_activity_class: 'Soort economische activiteit',
            c_economic_activity_class_tooltip: '',
            c_economic_activity_level: 'Niveau van economische activiteit',
            c_economic_activity_level_tooltip: '',
            f_garden_area: 'Tuinoppervlakte',
            f_garden_area_tooltip: '',
            f_flood_risk: 'Overstromingsrisico',
            f_flood_risk_tooltip: '',
            f_dist_building_flood: 'Dichtstbijzijnd overstromingsgebied',
            f_dist_building_flood_tooltip: '',
            f_parcel_flood_risk: 'Overstromingsrisico van perceel(en)',
            f_parcel_flood_risk_tooltip: '',
            f_dist_parcel_flood: 'Dichtstbijzijnde overstromingszone bij perceel(en)',
            f_dist_parcel_flood_tooltip: '',
            f_flood_risk_insurance_exclusion:
                'Overstromingsrisico\n(verzekering uitgesloten)',
            f_flood_risk_insurance_exclusion_tooltip: '',
            f_dist_building_flood_insurance_exclusion:
                'Dichtstbijzijnd overstromingsgebied\n(verzekering uitgesloten)',
            f_dist_building_flood_insurance_exclusion_tooltip: '',
            f_parcel_flood_risk_insurance_exclusion:
                'Overstromingsrisico van perceel(en) (verzekering uitgesloten)',
            f_parcel_flood_risk_insurance_exclusion_tooltip: '',
            f_dist_parcel_flood_insurance_exclusion:
                'Dichtstbijzijnde overstromingszone bij perceel(en) (verzekering uitgesloten)',
            f_dist_parcel_flood_insurance_exclusion_tooltip: '',
            f_flood_risk_composite: 'Samengesteld overstromingsrisico',
            f_flood_risk_composite_tooltip: '',
            f_flood_risk_max_parcel:
                'Maximaal overstromingsrisico van alle gebouwen op het perceel',
            f_flood_risk_max_parcel_tooltip: '',
            epc_source: 'EPC bron',
            epc_source_tooltip: '',
            level: 'Informatieniveau',
            level_tooltip: '',
            f_ground_height_above_sea: 'Hoogte (boven zeespiegel)',
            f_ground_height_above_sea_tooltip: '',
            no_building_picture: 'Geen grafisch beeldmateriaal van het gebouw',
            no_building_picture_tooltip: '',
            no_parcel_picture: 'Geen beeldmateriaal van perceel',
            no_parcel_picture_tooltip: '',
            no_garden_technical_drawing: 'Geen technische tekening van de tuin',
            no_garden_technical_drawing_tooltip: '',
            parcel_selection: 'Perceel selectie',
            parcel_selection_tooltip: '',
            vat: 'BTW',
            vat_tooltip: '',
            property_type: 'Type woning',
            property_type_tooltip: '',
            insulated_floors: 'Ge\u00efsoleerde vloeren',
            insulated_floors_tooltip: '',
            insulated_roof: 'Ge\u00efsoleerd dak',
            insulated_roof_tooltip: '',
            insulated_walls: 'Ge\u00efsoleerde muren',
            insulated_walls_tooltip: '',
            window_type: 'Beglazing',
            window_type_tooltip: '',
            has_attic: 'Zolder',
            has_attic_tooltip: '',
            floors_insulation_years: 'Jaar plaatsing vloerisolatie',
            floors_insulation_years_tooltip: '',
            roof_insulation_year: 'Jaar plaatsing dakisolatie',
            roof_insulation_year_tooltip: '',
            walls_insulation_year: 'Jaar plaatsing muurisolatie',
            walls_insulation_year_tooltip: '',
            has_basement: 'Kelder',
            has_basement_tooltip: '',
            is_attic_heated: 'Verwarmde zolderruimte',
            is_attic_heated_tooltip: '',
            epc_score: 'EPC score',
            epc_score_tooltip: '',
            heating_fuel: 'Brandstof',
            heating_fuel_tooltip: '',
            heating_type: 'Type verwarming',
            heating_type_tooltip: '',
            heating_installation_year: 'Installatiejaar verwarming',
            heating_installation_year_tooltip: '',
            ventilation_type: 'Type ventilatie',
            ventilation_type_tooltip: '',
            solar_boiler: 'Zonneboiler',
            solar_boiler_tooltip: '',
            solar_panels: 'Zonnepanelen',
            solar_panels_tooltip: '',
            battery: 'Batterij',
            battery_tooltip: '',
            air_conditioner: 'n/a',
            air_conditioner_tooltip: '',
            spa_room: 'n/a',
            spa_room_tooltip: '',
            swimming_pool: 'n/a',
            swimming_pool_tooltip: '',
            electric_vehicle: 'Elektrische wagens',
            electric_vehicle_tooltip: '',
            n_residents: 'Aantal bewoners',
            n_residents_tooltip: '',
            protected_consumer: 'n/a',
            protected_consumer_tooltip: '',
            yearly_electricity_consumption: 'Jaarlijks elektriciteitsverbruik',
            yearly_electricity_consumption_tooltip: '',
            gas_consumption_approx: 'Jaarlijks gasverbruik',
            gas_consumption_approx_tooltip: '',
            insulation_material: 'Isolatiemateriaal',
            insulation_material_tooltip: '',
            heat_pump_type: 'Type warmtepomp',
            heat_pump_type_tooltip: '',
            pv_type: 'Type zonnepaneel',
            pv_type_tooltip: '',
        },
        disclaimer: {
            avm_tooltip: '',
            dvm:
                'Dit waarderingsverslag is het resultaat van een evaluatie op afstand van het pand door een vastgoedschatter. Deze persoon heeft het pand niet bezocht, maar heeft op basis van diverse beschikbare data en een statistisch model een onafhankelijke waardering van het pand gemaakt. Voor meer informatie over deze waarderingsmethode verwijzen wij u naar de laatste pagina van dit rapport.',
            dvm_tooltip: '',
            ovm:
                'Dit waarderingsverslag is het resultaat van een evaluatie van het pand gemaakt ter plaatse door een vastgoedexpert. Deze onafhankelijke waardering werd gemaakt op basis van de geobserveerde situatie van het pand door de expert, en wordt verder ondersteund door een statistisch model. Voor meer informatie over deze waarderingsmethode verwijzen wij u naar de laatste pagina van dit verslag.',
            ovm_tooltip: '',
            epc_unavailable_1:
                'Ik bevestig dat er geen geldig EPC certificaat beschikbaar is, en dat deze schatting bij dit pand hoort',
            epc_unavailable_1_tooltip: '',
            epc_unavailable_2:
                'Ik bevestig dat het doel van deze aanvraag in het kader van een herfinanciering of wederopname is',
            epc_unavailable_2_tooltip: '',
            part_1:
                'Deze evaluatie werd uitgevoerd voor het hierbij aangegeven doel. Er wordt geen verantwoordelijkheid aanvaard voor het geval dat dit rapport wordt gebruikt voor een ander doel of door een andere partij dan de partij tot wie het is gericht. Indien een andere partij dit rapport wenst te gebruiken, dient zij vooraf de schriftelijke toestemming van Rock.estate te krijgen.\n',
            part_1_tooltip: '',
            part_2:
                'De publicatie van dit waarderingsverslag, in zijn geheel of gedeeltelijk, is verboden zonder de schriftelijke toestemming van Rock.estate. Het auteursrecht van dit rapport blijft te allen tijde eigendom van Rock.estate. Dit rapport mag niet worden overgedragen aan een derde partij zonder de expliciete toestemming van de eigenaar van het copyright.',
            part_2_tooltip: '',
            reconstruction_value_title: 'Heropbouwwaarde berekening',
            reconstruction_value_title_tooltip: '',
            reconstruction_value:
                'De heropbouwwaarde is de totale kostprijs om een gebouw opnieuw op te bouwen volgens de huidige bouwnormen. Deze berekening is inclusief BTW en erelonen van architecten, is niet afhankelijk van de locatie en omvat geen sloopkosten of bijgebouwen. Hierdoor is het mogelijk dat de heropbouwwaarde hoger is dan de marktwaarde. De heropbouwwaarde is gebaseerd op de {index_type} {index_value} index.',
            reconstruction_value_tooltip: '',
            part_3:
                'Dit waarderingsverslag spreekt zich niet uit over, noch aanvaardt het enige verantwoordelijkheid voor, het (on)vermogen en de (on)wil van de hypotheeknemer om zijn verplichtingen in het kader van de voorgestelde lening na te komen.',
            part_3_tooltip: '',
        },
        document: {
            purpose_tooltip: '',
            ers_report: 'ERS rapport',
            ers_report_tooltip: '',
            epc_certificate: 'EPC attest | EPC attesten',
            epc_certificate_tooltip: '',
            exterior_picture: "Foto van buiten |\u00a0Foto's van buiten",
            exterior_picture_tooltip: '',
            building_blueprint: 'Bouwtekening | Bouwtekeningen',
            building_blueprint_tooltip: '',
            specifications: 'Lastenboek | Lastenboeken',
            specifications_tooltip: '',
            cadastral_plan: 'Kadastraal plan |\u00a0Kadastraal plannen',
            cadastral_plan_tooltip: '',
            sales_agreement: 'Compromis | Compromissen',
            sales_agreement_tooltip: '',
            expected_epc: 'Verwachte EPC',
            expected_epc_tooltip: '',
        },
        common: {
            select_one: 'Selecteer',
            select_one_tooltip: '',
            floor: 'Verdieping',
            floor_tooltip: '',
            cancel: 'Annuleren',
            cancel_tooltip: '',
            new: 'Nieuw',
            new_tooltip: '',
            save: 'Opslaan',
            save_tooltip: '',
            edit: 'Bewerken',
            edit_tooltip: '',
            total: 'Totaal',
            total_tooltip: '',
            previous: 'Vorige',
            previous_tooltip: '',
            next: 'Volgende',
            next_tooltip: '',
            refresh: 'Vernieuw',
            refresh_tooltip: '',
            back: 'Terug',
            back_tooltip: '',
            price: 'Prijs',
            price_tooltip: '',
            module: 'Module',
            module_tooltip: '',
            uploading: 'Aan het uploaden',
            uploading_tooltip: '',
            go_to_consumption_next: 'Ga naar Verbruik',
            go_to_consumption_next_tooltip: '',
            lets_get_started: 'Laten we beginnen!',
            lets_get_started_tooltip: '',
            go_to_consumption:
                '<h2>Perfect!</h2> <p>Met deze informatie kunnen wij de EPC-score inschatten en passende renovaties aanbevelen.</p>',
            go_to_consumption_tooltip: '',
            thank_you_so_far:
                'Gebouw gevonden! Laten we nu eens kijken naar de energie performantie.',
            thank_you_so_far_tooltip: '',
            yes: 'Ja',
            yes_tooltip: '',
            no: 'Nee',
            no_tooltip: '',
            number_input: 'Vul de energiescore hier in',
            number_input_tooltip: '',
            multiple_choice: 'Selecteer \u00e9\u00e9n van de opties',
            multiple_choice_tooltip: '',
            we_are_sorry: 'Onze excuses.',
            we_are_sorry_tooltip: '',
            sorry: 'Oeps!',
            sorry_tooltip: '',
            enter_address: 'Vul het adres hier in',
            enter_address_tooltip: '',
            back_to_ing: 'Terug naar ING website',
            back_to_ing_tooltip: '',
            maintenance:
                'Deze website is momenteel in onderhoud. Graag verwelkomen we u snel terug!',
            maintenance_tooltip: '',
            send: 'Verzenden',
            send_tooltip: '',
            start_now: 'Start',
            start_now_tooltip: '',
            i_dont_know: 'Weet ik niet',
            i_dont_know_tooltip: '',
        },
        info: {
            data_from_customer: 'data verkregen van de klant',
            data_from_customer_tooltip: '',
        },
        autocomplete: {
            enter_address: 'Vul het adres hier in',
            enter_address_tooltip: '',
            address_not_found: 'Het adres staat niet in de lijst',
            address_not_found_tooltip: '',
            enter_parcel: 'Vul de kadastrale referentie hier in',
            enter_parcel_tooltip: '',
            parcel_not_found: 'De kadastrale referentie staat niet in de lijst',
            parcel_not_found_tooltip: '',
            enter_dual: 'Vul het adres of de kadastrale referentie hier in',
            enter_dual_tooltip: '',
            dual_not_found:
                'Het adres of de kadastrale referentie staat niet in de lijst',
            dual_not_found_tooltip: '',
        },
        dvm_features: {
            style_of_house: 'Bouwstijl',
            style_of_house_tooltip: '',
            exterior_state: 'Staat van het pand aan de buitenkant',
            exterior_state_tooltip: '',
            facade_material: 'Gevelmateriaal',
            facade_material_tooltip: '',
            roof_material: 'Dakbedekking',
            roof_material_tooltip: '',
            n_roof_windows: 'Aantal dakvensters',
            n_roof_windows_tooltip: '',
            n_roof_dormers: 'Aantal dakkapellen',
            n_roof_dormers_tooltip: '',
            solar_panel: 'Zonnepanelen',
            solar_panel_tooltip: '',
            solar_panel_area: 'Aantal zonnepanelen',
            solar_panel_area_tooltip: '',
            f_building_listed: 'Heeft het gebouw een erfgoedstatuut?',
            f_building_listed_tooltip: '',
            garden_orientation: 'Ori\u00ebntatie van de tuin',
            garden_orientation_tooltip: '',
            garden_arrangement: '(Potenti\u00eble) tuininrichting',
            garden_arrangement_tooltip: '',
            garden_common_arrangement:
                '(Potenti\u00eble) gemeenschappelijke tuininrichting',
            garden_common_arrangement_tooltip: '',
            f_swimming_pool: 'Ingebouwd zwembad',
            f_swimming_pool_tooltip: '',
            f_swimming_pool_area: 'Grootte buitenzwembad',
            f_swimming_pool_area_tooltip: '',
            environment: 'Omgeving',
            environment_tooltip: '',
            public_transport: 'Openbaar vervoer',
            public_transport_tooltip: '',
            education: 'Onderwijs',
            education_tooltip: '',
            recreation: 'Recreatie, sport, cultuur',
            recreation_tooltip: '',
            shops: 'Winkels & diensten',
            shops_tooltip: '',
            healthcare: 'Gezondheidszorg',
            healthcare_tooltip: '',
            direct_traffic_level: 'Niveau van direct straatverkeer',
            direct_traffic_level_tooltip: '',
            indirect_traffic_level: 'Nabijheid van indirect straatverkeer',
            indirect_traffic_level_tooltip: '',
            surroundings: 'Beschrijving van de omgeving',
            surroundings_tooltip: '',
            other_positive: '\nAndere elementen met een positieve impact',
            other_positive_tooltip: '',
            other_positive_details: 'Extra opmerking',
            other_positive_details_tooltip: '',
            other_negative: 'Andere elementen met een negatieve impact',
            other_negative_tooltip: '',
            other_negative_details: 'Extra opmerking',
            other_negative_details_tooltip: '',
            remarks: 'Opmerkingen van de Vastgoeddeskundige',
            remarks_tooltip: '',
            internal_remarks: 'Interne opmerkingen',
            internal_remarks_tooltip: '',
        },
        ovm_features: {
            garages: 'Gesloten garages',
            garages_tooltip: '',
            parkings: 'Parkeerplaatsen',
            parkings_tooltip: '',
            pool_house: 'Pool house',
            pool_house_tooltip: '',
            pool_house_area: 'Oppervlakte van het pool house',
            pool_house_area_tooltip: '',
            barn: 'Schuur',
            barn_tooltip: '',
            barn_area: 'Oppervlakte van de schuur',
            barn_area_tooltip: '',
            stables: 'Stallen',
            stables_tooltip: '',
            stables_area: 'Oppervlakte van de stallen',
            stables_area_tooltip: '',
            common_parts_state: 'Algemene staat van de gemeenschappelijke delen',
            common_parts_state_tooltip: '',
            interior_state: 'Algemene staat van het interieur',
            interior_state_tooltip: '',
            apartment_quotity: 'Quotiteit',
            apartment_quotity_tooltip: '',
            reserve_savings: 'Spaargeld in reservefonds',
            reserve_savings_tooltip: '',
            comfort: 'Comfort & uitrusting',
            comfort_tooltip: '',
            common_comfort: 'Comfort & uitrusting',
            common_comfort_tooltip: '',
            interior_positive: '\nAndere elementen met een positieve impact',
            interior_positive_tooltip: '',
            interior_negative: 'Andere elementen met een negatieve impact',
            interior_negative_tooltip: '',
        },
        fixed: {
            parcels_and_building_shapes: 'Vorm van perceel en gebouw',
            parcels_and_building_shapes_tooltip: '',
            parcels_shapes: 'Vorm van perceel',
            parcels_shapes_tooltip: '',
        },
        '': {
            f_distance_to_street: 'Afstand tot midden van de straat',
            f_distance_to_street_tooltip: '',
        },
        global: {
            comments: 'Opmerkingen',
            comments_tooltip: '',
            commons: {
                before: 'voor',
                between: 'tussen {min} en {max}',
                after: 'na',
            },
            map: {
                aerial_view: 'Luchtfoto',
                cadastral_view: 'Kadastrale weergave',
                flood_zone_low: 'Reguliere overstromingszone laag',
                flood_zone_medium: 'Reguliere overstromingszone gemiddeld',
                flood_zone_high: 'Reguliere overstromingszone hoog',
                exclusion_flood_zone: 'Verzekeringsuitsluiting overstromingszones',
                swimming_pools: 'Zwembaden',
                street_name: 'Straatnaam',
            },
            shared: {
                placeholder: {
                    streetname: 'Straatnaam van uw domicilie',
                    streetnumber: 'Huisnummer',
                    postalcode: 'Postcode van 4 cijfers',
                    municipality: 'Gemeente',
                    vat: 'Voer het BTW-nummer in',
                    'company-name': 'Bedrijfsnaam',
                    'contact-email': 'Voer uw e-mailadres in',
                },
                resend_email: 'E-mail opnieuw verzenden',
                email_notification: 'E-mail succesvol verzonden',
                edit_email: 'E-mail bewerken',
                streetname: 'Straatnaam',
                streetnumber: 'Huisnummer',
                boxnumber: 'Busnummer',
                postalcode: 'Postcode',
                municipality: 'Gemeente',
                vat: 'BTW-nummer',
                name: 'Naam',
                email: 'E-mail',
                company: 'Bedrijf (indien van toepassing)',
                customer_ref_modal: {
                    title:
                        'Er bestaat reeds een aanvraag met dezelfde interne referentie.',
                    content:
                        'Om deze bestaande aanvraag te bekijken, klikt u op de Dashboard knop hieronder:',
                    cta: 'Wilt u doorgaan met de gedupliceerde referentie?',
                    dashboard: 'Bekijk in dashboard',
                    continue: 'Doorgaan',
                },
                january: ' Januari',
                february: 'Februari',
                march: 'Maart',
                april: 'April',
                may: 'Mei',
                june: 'Juni',
                july: 'Juli',
                august: 'Augustus',
                september: 'September',
                october: 'Oktober',
                november: 'November',
                december: 'December',
                flanders: 'Vlaanderen',
                wallonia: 'Walloni\u00eb',
                brussels: 'Brussel',
            },
            action: {
                confirm: 'Bevestig',
            },
            helpcenter: {
                video_tutorials: 'Videohandleiding',
                faq: 'FAQ',
                question: 'Niet gevonden wat u zocht?',
                contact_cta: 'Contacteer ons',
                contact_form: {
                    title: 'Vraag om ondersteuning',
                    content:
                        'Als u in de FAQ niet kan vinden wat u zoekt, helpen wij u graag. Vertel ons wat het probleem is en wij nemen zo spoedig mogelijk contact met u op.',
                    'subject_req-invoice': '',
                    subject_label: 'Onderwerp',
                    'subject_req-failing': 'Mijn aanvraag loopt steeds mis',
                    'subject_req-not-eval-yet': 'Mijn aanvraag is nog niet gewaardeerd',
                    'subject_req-back-to-draft':
                        'Mijn aanvraag is terug onder "Ontwerp" status maar alle informatie is correct',
                    'subject_cant-download-val-report':
                        'Ik kan het verslag van mijn aanvraag niet downloaden',
                    'subject_req-not-in-dashboard':
                        'Mijn aanvraag verschijnt niet in mijn Dashboard',
                    'subject_cancel-req': 'Ik wil mijn aanvraag annuleren',
                    subject_other: 'Andere',
                    other_label: 'Vul uw reden in',
                    customer_ref: 'Interne referentie van de lening',
                    not_specific_req: 'Dit gaat niet over een specifiek aanvraag',
                    message: 'Uw vraag',
                    screenshot_label: 'Voeg schermafbeeldingen toe',
                    screenshot_info:
                        'Omwille van cyberbeveiliging kunnen alleen bestanden met de volgende formaten worden gedeeld met Rock.estate: .jpg, .jpeg, .png',
                    submit: 'Verzenden',
                    feedback_title: 'Bedankt om ons te contacteren',
                    feedback_content:
                        'Wij zullen binnenkort contact met u opnemen om een oplossing voor uw probleem of een antwoord op uw vraag te vinden.',
                    close: 'Sluiten',
                    ing: 'LOP ID',
                },
            },
            errors: {
                no_valuers_in_region:
                    'Er zijn geen schatters beschikbaar in uw regio. Neem contact met ons op via support@rock.estate om een oplossing te vinden.',
            },
        },
        section_data: {
            room: {
                type: 'Type kamer',
                type_tooltip: '',
                living_area: 'Oppervlakte',
                living_area_tooltip: '',
                comment: 'Opmerkingen',
                comment_tooltip: '',
            },
        },
        footnote: {
            no_renovation_included:
                'Alle waarden zijn berekend voor de huidige staat van het pand en houden geen rekening met eventuele geplande renovaties',
            no_renovation_included_tooltip: '',
            avm: 'Automatische waardering',
            avm_tooltip: '',
            q25: '25e percentiel',
            q25_tooltip: '',
            q75: '75e percentiel',
            q75_tooltip: '',
        },
        reference_properties_location: {
            explanation_1:
                'De waardering van dit pand is gebaseerd op {num_references} referentiepanden in de buurt (binnen een afstand van {reference}_radius km). Elk referentiepand deelt een aantal elementen inzake ligging, grootte en andere vergelijkbare kenmerken. Het onderliggende statistische model van deze waardering is gebaseerd op een "Geographically Weighted Regression" (GWR), waarbij referentiepunten in de onmiddellijke nabijheid van het pand een grotere gewicht krijgen in vergelijking met referentiepunten die zich verderaf bevinden.',
            explanation_1_tooltip: '',
            explanation_2:
                'De onderstaande kaart geeft een overzicht van de locatie van de referentiepanden en de afstand tot het te evalueren pand. De kleurenlegende geeft een goede indicatie van de gemiddelde marktwaarde van woningen in uw omgeving.',
            explanation_2_tooltip: '',
        },
        reference_properties_characteristics: {
            explanation_1:
                'Een pand heeft diverse objectieve kenmerken die bijdragen aan de prijs zoals locatie, grootte en energie-effici\u00ebntie. De onderstaande grafieken vergelijken een aantal van deze kenmerken van deze woning met de andere referentiepanden in de buurt.',
            explanation_1_tooltip: '',
            property_characteristics: 'Kenmerken pand',
            property_characteristics_tooltip: '',
            properties_in_the_area: 'Referentiepanden in uw buurt',
            properties_in_the_area_tooltip: '',
        },
        flood: {
            explanation_1:
                "Overzicht van de offici\u00eble overstromingsgebieden in de nabijheid van de woning. Er worden verschillende risicocategorie\u00ebn berekend op basis van verschillende overstromingsrisicoscenario's, vari\u00ebrend van laag tot hoog.",
            explanation_1_tooltip: '',
            check_ground_floor: {
                title: 'Bevindt het appartement zich op het gelijkvloers?',
                yes_info: 'Het appartement bevindt zich op het gelijkvloers',
                no_info: 'Het appartement bevindt zich niet op de begane grond',
                tooltip: 'Het gelijkvloers verwijst naar de verdieping op straatniveau',
            },
            flood_page: {
                title: 'Analyse overstromingsrisico',
                download_report: 'Download overstromingsrisico rapport',
                contextual_message_building_risk_high:
                    'Dit gebouw heeft een hoog overstromingsrisico omdat het slechts {distance}  meter van een uitsluitingszone voor verzekeringen ligt. Vanwege dit risico is het niet wenselijk om een lening voor dit pand te verstrekken.',
                contextual_message_parcel_risk_high:
                    'Dit perceel heeft een hoog overstromingsrisico omdat het slechts {distance}  meter van een uitsluitingszone voor verzekeringen ligt. Vanwege dit risico is het niet wenselijk om een lening voor dit pand te verstrekken.',
                contextual_message_risk_none:
                    'Het risico op overstromingen wordt geaccepteerd',
                contextual_message_risk_high_not_ground_floor:
                    'Het overstromingsrisico wordt geaccepteerd sinds de woning geen begane grond omvat.',
                open_map: 'Open overstromingskaart',
                more_information:
                    'Voor meer gedetailleerde informatie over normaal overstromingsrisico, raadpleeg het verslag',
                proceed_valuation: 'Ga door met waardering',
            },
            confirm_decision_popup: {
                title: 'Overstromingsrisico uitgesloten van verzekering',
                message:
                    'Het pand is gelegen in een overstromingszone die uitgesloten is van verzekering, wat mogelijk kan leiden tot frequente en/of ernstige overstromingen. Een lening voor dit pand kan worden geweigerd.',
                confirmation: 'Wilt u doorgaan met de waardebepaling van het pand?',
                yes_proceed: 'Ja, ga door met waardering',
            },
        },
        faq: {
            q_incorrect_valuation:
                'Het adres van de gewaardeerde woning is onjuist, wat moet ik doen?',
            q_incorrect_valuation_tooltip: '',
            a_incorrect_valuation:
                "Misschien ging er iets mis bij het selecteren van het adres, het gebouw of de percelen die bij het pand horen. U kunt de adresgegevens bekijken via de volgende link: {url}.dashboard{'.'}",
            a_incorrect_valuation_tooltip: '',
            q_incorrect_characteristics:
                'Het adres van het pand is juist, maar andere kenmerken in dit waarderingsverslag zijn niet correct, wat moet ik doen?',
            q_incorrect_characteristics_tooltip: '',
            a_incorrect_characteristics:
                'Indien u denkt dat bepaalde informatie in dit verslag substantieel kunnen verschillen, en dit zou kunnen leiden tot een belangrijke impact op de waardering van het onroerend goed, volg dan deze link {url}.dashboard om de onjuiste/ontbrekende informatie te controleren en te verduidelijken.',
            a_incorrect_characteristics_tooltip: '',
            q_transaction_vs_market_value:
                'Waarom verschilt de transactieprijs die ik heb betaald van de marktwaarde die in dit verslag wordt bepaald?',
            q_transaction_vs_market_value_tooltip: '',
            a_transaction_vs_market_value_dvm:
                "Dit waarderingsverslag is het resultaat van de waardering van het pand in kwestie, uitgevoerd door een vastgoedschatter op afstand, en ondersteund door een statistisch model. Het verslag geeft een nauwkeurige indicatie van de geschatte waarde van het pand, op basis van de beschikbare informatie. Aangezien de schatter het onroerend goed niet effectief heeft bezocht, kan het gebeuren dat de impact van bepaalde, specifieke kenmerken van het onroerend goed, niet volledig tot uiting komen in de geschatte transactieprijs. Neem een kijkje op onze website voor meer informatie: {url}.rockestate_info{'.'}",
            a_transaction_vs_market_value_dvm_tooltip: '',
            a_transaction_vs_market_value_ovm:
                "Dit waarderingsverslag is het resultaat van de evaluatie, door een vastgoedexpert, op afstand en ondersteund door een statistisch model. Het verslag geeft een nauwkeurige indicatie van de geschatte waarde van het pand, op basis van de beschikbare informatie. Aangezien de expert het onroerend goed niet effectief heeft bezocht, kan het gebeuren dat de impact van bepaalde, specifieke kenmerken van het onroerend goed, niet volledig tot uiting komen in de geschatte transactieprijs. Neem een kijkje op onze website voor meer informatie: {url}.rockestate_info{'.'}",
            a_transaction_vs_market_value_ovm_tooltip: '',
            q_loan_accepted:
                'Nu ik mijn waarderingsverslag heb ontvangen, betekent dit dat mijn kredietaanvraag is goedgekeurd?',
            q_loan_accepted_tooltip: '',
            a_loan_accepted:
                'Wij hebben dit waarderingsverslag met u en uw bank gedeeld. Dit verslag zal door de bank worden gebruikt als \u00e9\u00e9n van de verschillende elementen in haar beslissingsproces. De uiteindelijke beslissing komt toe aan de bank. Rock.estate komt hier op geen enkele manier in tussen.',
            a_loan_accepted_tooltip: '',
            'what-is-avm_tooltip': '',
            'what-is-avm_question': 'Wat is een automatische schatting? ',
            'what-is-avm_answer':
                "Een Statistische Waarderingsmethode is elke vorm van wiskundige tool die gebruikt kan worden om de waarde van een onroerend goed te schatten door middel van deterministische berekeningen.\n\nRock.estate gebruikt een implementatie van een Comparables-Based Automated Valuation Model (CBAVM of kortweg AVM). CBVAM's selecteren panden die recentelijk te koop werden gezet om een regressiemodel op te bouwen en een schatting te leveren voor het betreffende pand. \n\nAutomatic Valuations zijn per definitie automatisch: zij worden op afstand uitgevoerd zonder menselijke tussenkomst.",
            'what-is-dvm_tooltip': '',
            'what-is-dvm_question': 'Wat is een schatting op afstand? ',
            'what-is-dvm_answer':
                'Een schatting op afstand - of "Desktop Valuation" - wordt uitgevoerd door een schatter, zonder dat deze het onroerend goed van binnen bezoekt. De schatter baseert zich op verschillende gegevensbronnen, een statistisch model en andere informatie die door de kredietnemer wordt verstrekt.\n\nEen succesvolle schatting op afstand combineert een sterk data gedreven model met de expertise van een schatter. Dit is een valabel alternatief voor de traditionele schattingen ter plaatse voor het grootste deel van het residentieel vastgoed.\n',
            'what-is-ovm_tooltip': '',
            'what-is-ovm_question': 'Wat is een schatting ter plaatse? ',
            'what-is-ovm_answer':
                'Een schatting ter plaatse - of "On-site Valuation" - is de traditionele schatting waarbij een schatter het interieur en exterieur van een woning bezoekt om de waarde van het pand te schatten. Dit biedt het meest complete beeld op het pand en de waardering. Dit type waardering vergt echter de meeste middelen en tijd.',
            'why-ovm_tooltip': '',
            'why-ovm_question':
                'Waarom moet het pand ter plaatse worden gewaardeerd en niet op afstand?',
            'why-ovm_answer':
                "Een waardering op afstand is niet haalbaar in de volgende scenario's:\n\n- Indien de beslissing wordt genomen door een expert om af te zien van een waardering op afstand. Deze keuze kan be\u00efnvloed worden door factoren zoals uitzonderlijke kenmerken of een gebrek aan voldoende data en informatie.\n\n- Wanneer het pand buiten de door de bank gedefinieerde parameters valt voor een waardering op afstand, zoals te duur, niet-residentieel, of aanzienlijke renovaties vereist.",
            'what-is-dashboard_tooltip': '',
            'what-is-dashboard_question': 'Wat is het Dashboard?',
            'what-is-dashboard_answer':
                "Het Dashboard is de pagina in Rock.estate's applicatie waar u al uw aanvragen kan raadplegen evenals meta-data zoals de creatie- of wijzigingsdatum, huidige status, etc. Gebruikers met de juiste rol kunnen ook de aanvragen van collega's vinden. Dit is handig als u (tijdelijk) een aanvraag moet overnemen, bijvoorbeeld tijdens vakanties.\n\nIn het Dashboard kunt u de volgende acties nemen:\n\n- Bekijk en vervolledig onvolledige aanvragen\n- Herbekijk bestaande aanvragen\n- Download het rapport van de voltooide (gewaardeerde) aanvragen\n- Neem een aanvraag over van een collega (indien van toepassing)",
            'what-is-draft_tooltip': '',
            'what-is-draft_question':
                'Wat gebeurt er wanneer mijn aanvraag de status "Ontwerp" heeft?',
            'what-is-draft_answer':
                'De status "Ontwerp" wordt gebruikt in twee gevallen:\n\n1. Voor zowel Energetische renovatie simulaties als Waarderingsaanvragen: U wacht op ontbrekende informatie van de klant om de aanvraag in te vullen. Daarom heeft u besloten om de aanvraag niet af te ronden en als "Ontwerp" op te slaan. Wanneer u alle informatie hebt, kan u de aanvraag vervolledigen en indienen.\n2. Alleen voor Waarderingsaanvragen: Een Waarderingsspecialist heeft incoherente informatie gevonden die ze wensen te benadrukken. Gelieve de informatie te controleren en, indien nodig, te corrigeren. Zodra dit gedaan is, kunt u de aanvraag opnieuw indienen.',
            'when-report_tooltip': '',
            'when-report_question': 'Wanneer kan ik het waarderingsverslag verwachten?',
            'when-report_answer':
                'Het waarderingsverslag is doorgaans beschikbaar binnen twee werkdagen na het bezoek ter plaatse van de schatter-expert.',
            'how-download-report_tooltip': '',
            'how-download-report_question':
                'hoe kan ik het waarderingsverslag downloaden?',
            'how-download-report_answer':
                '\nU ontvangt een e-mailmelding zodra het verlsag is ingediend door onze expert. Deze e-mail bevat een link om het verslag te downloaden.',
            'market-price-incorrect_tooltip': '',
            'market-price-incorrect_question':
                'De marktwaarde in het verslag is niet juist.',
            'market-price-incorrect_answer':
                'Als de door de schatter opgegeven marktwaarde sterk afwijkt van de transactieprijs van de leningaanvraag\n- controleer of het geschatte onroerend goed het juiste is;\n- controleer dat de ingevoerde gegevens correct zijn;\n- als de gegevens juist zijn, neem contact op met uw manager om te bespreken wat de volgende stap is. \n\nAls u na controle nog steeds van mening bent dat de afwijking te groot is, neem dan contact met ons op via het contactformulier voor meer informatie.',
            'issue-parcels_tooltip': '',
            'issue-parcels_question':
                'De percelen in het verslag komen niet overeen met de werkelijke percelen.',
            'issue-parcels_answer':
                'Als de geselecteerde percelen niet juist zijn, kan dit te wijten zijn aan een foutieve selectie tijdens het invoeren van gegevens. \n\nKlik op "Aanvraag bekijken" naast de desbetrefferende aanvraag in uw Dashboard en controleer de ingevoerde gegegens.\n\nAls de invoer correct is, laat het ons dan weten via ons contactformulier. Dit is essenti\u00eble informatie om de marktwaarde correct the kunnen schatten.',
            'old-picture-or-3d_tooltip': '',
            'old-picture-or-3d_question':
                "De woning is aanzienlijk veranderd ten opzichte van de foto's of het 3D model in het verslag.",
            'old-picture-or-3d_answer':
                "Als u ziet dat de foto's in het rapport niet overeenkomen met de werkelijkheid, neem dan contact met ons op via ons contactformulier. ",
            'report-language_tooltip': '',
            'report-language_question':
                'Hoe kan ik het verslag in een andere taal verkrijgen? ',
            'report-language_answer':
                'Bij een Waarderingsaanvraag wordt het waarderingsrapport gegenereerd in de taal van de aanvraag. Als u een rapport in een andere taal wilt ontvangen, moet u de aanvraag opnieuw indienen in de gewenste taal. Houd er rekening mee dat de opmerkingen van onze Waarderingsspecialist niet worden vertaald, aangezien deze handmatig worden geschreven tijdens de waardering.\n\nOm het rapport in een andere taal te krijgen voor een Energetische renovatie simulatie selecteert u de gewenste taal in de rechterbovenhoek van het scherm op de Rapport pagina. U kunt nu het rapport in de juiste taal downloaden.',
            'wrong-pictures_tooltip': '',
            'wrong-pictures_question':
                'De foto in het verslag komt niet overeen met de geschatte woning.',
            'wrong-pictures_answer':
                'De street view op het verslag is geselecteerd door Google en geeft soms niet het het juiste gebouw weer. Dit betekent niet dat de schatter het verkeerde pand heeft geschat. Als u toegang hebt tot het webverslag, kan u de street view zelf wijzigen.',
            sharing_tooltip: '',
            sharing_question: 'Kan ik het rapport met de klant delen?',
            sharing_answer:
                'Dit hangt af van de interne regels van uw bedrijf. We raden aan dit te bespreken met het management. Om een rapport met een klant te delen, kunt u het downloaden door te klikken op de groene knop "PDF report" in uw Dashboard naast de aanvraag.\n\nIn het geval van Energetische renovatie simulaties, klikt u op de "Delen" knop op de simulatiepagina. Dit genereert een e-mail met een link naar de resultaten. U kunt deze link naar uw klant sturen. Houd er rekening mee dat uw klant geen invoer kan bewerken en opnieuw berekenen.',
            'remarks-language_tooltip': '',
            'remarks-language_question':
                'Waarom worden de opmerkingen in het verslag niet aangepast aan de taal van het Dashboard en de rest van het verslag wel?',
            'remarks-language_answer':
                'Wanneer een aanvrager een schatting aanvraagt in een specifieke taal (bv. Frans), worden de opmerkingen geschreven in de geselecteerde taal of in het Engels. Als de aanvrager de taal wijzigt na het indienen van zijn aanvraag, zal de taal van de opmerkingen niet worden gewijzigd, aangezien dit niet geautomatiseerd is. ',
            'appeal-missing-feature_tooltip': '',
            'appeal-missing-feature_question':
                'De schatter heeft met een bepaald element geen rekening gehouden (zonnepanelen, extra percelen, zwembad,...)',
            'appeal-missing-feature_answer':
                'Als de schatter geen rekening heeft gehouden met een element dat mogelijk van invloed is op de waarde van het onroerend goed, neem dan contact op met ons via het contactformulier om dit te laten weten.\nElementen die als potentieel belangrijk worden beschouwd zijn de volgende:\n- Adres\n- BEbouw oppervlakte\n- Oppervlakte van het perceel\n- EPC\n- Bewoonbaar oppervlakte\n- Bouwjaar\n- Aantal slaapkamers\n- Appartement verdieping(en)\n- Aanwezigheid van een priv\u00e9 of gemeenschappelijke tuin\n- Terras\n- Buitenzwembad\n- Zonnepanelen\n- Historische classificatie van het eigendom (voorgevel of volledig gebouw)\n- Overstromingsgebieden\n- Secundaire gebouwen\n- Aanwezigheid van parking of gesloten garage\n\n',
            'ING-how-ovm-request_tooltip': '',
            'ING-how-ovm-request_question':
                'Hoe kan ik een waardering ter plaatse aanvragen?',
            'ING-how-ovm-request_answer':
                'Het is momenteel niet mogelijk om rechtstreeks een waardering ter plaatse aan te vragen. We voeren alleen waarderingen ter plaatse uit voor panden die binnen de scope vallen voor een waardering op afstand, maar waar onze expert beslist dat een op afstand uitgevoerde waardering niet mogelijk is.\n\nIn dergelijke gevallen ontvangt u een e-mail waarin wordt gevraagd naar de contactgegevens van de klant. Dit is noodzakelijk voor ons om door te gaan met het plannen van de afspraak en de betaling.',
            'where-customer-ref_tooltip': '',
            'where-customer-ref_question':
                'Waar kan ik de interne referentie van de lening vinden? ',
            'where-customer-ref_answer':
                'Deze referentie is intern bij de bank en wij raden aan deze referentie te kopi\u00ebren/plakken uit jullie systeem voor het opstellen/aanmaken van leningen.',
            'building-type-apartment-building_tooltip': '',
            'building-type-apartment-building_question':
                'Hoe kan ik een schatting aanvragen voor een appartementsgebouw?',
            'building-type-apartment-building_answer':
                'Rock.estate schat geen appartementsgebouwen. Een dergelijk verzoek zal resulteren in een schatting ter plaatse.',
            'address-not-found_tooltip': '',
            'address-not-found_question':
                "Rock.estate's applicatie herkent het adres van het betreffende pand niet.",
            'address-not-found_answer':
                'Als het automatisch geselecteerde gebouw niet juist is, kunt u op "Dit is niet het juiste gebouw" klikken om handmatig een ander gebouw op de kaart te selecteren. Als de automatische adresselectie niet werkt en/of de toepassing het gebouw niet kan vinden, selecteer dan de optie "Ik kan mijn gebouw niet vinden" en volg de instructies.',
            'building-not-found_tooltip': '',
            'building-not-found_answer':
                'Als u het gebouw niet kan vinden, volg deze procedure:\n-Klik op "Dit is niet het juiste gebouw" en het platform zal u toelaten een ander gebouw te selecteren.\n-Als u het nog steeds niet kan vinden, klik dan op "Ik kan het hoofdgebouw niet vinden" en u wordt doorgestuurd naar een nieuwe pagina. Op deze pagina moet u extra informatie opgeven, zoals de oppervlakte van het perceel, de bebouwde oppervlakte en het aantal gevels. \n\n',
            'find-epc_tooltip': '',
            'find-epc_question': 'Waar kan ik de EPC score van het pand vinden?',
            'find-epc_answer':
                'Een geldig EPC-certificaat is een verplicht document bij de verkoop van een pand. Als de klant deze informatie niet heeft, kan u de verkoopadvertentie raadplegen of de online database voor [Vlaanderen](https://apps.energiesparen.be/zoek-een-epc) of [Brussel](https://www.peb-epb.brussels/certificats-certificaten/). Merk op dat een EPC-score niet verplicht is om een Energetische renovatie simulatie te maken.',
            'epc-label-vs-number_tooltip': '',
            'epc-label-vs-number_question':
                'EPC: Is het beter om het label te geven (letter van A tot G) of om het exacte aantal kWh/(m\u00b2 jaar) op te geven?',
            'epc-label-vs-number_answer':
                'De schatting is sterk afhankelijk van de locatie, het perceel, de bewoonbare oppervlakte, het bouwjaar en de EPC-score. Daarom raden wij aan de aanvraag in te dienen met de exacte EPC score in kWh/sqm-jaar. \nAls u alleen de labelletter van A tot en met G geeft, zullen wij de woning waarderen door de gemiddelde score van elk label te nemen, wat zal resulteren in een benaderende schatting van de marktwaarde van de woning.',
            'find-living-area_tooltip': '',
            'find-living-area_question':
                'Waar kan ik de correcte bewoonbare oppervlakte van een woning vinden?',
            'find-living-area_answer':
                'U kan de bewoonbare oppervlakte terugvinden in verschillende documenten met betrekking tot het onroerend goed, zoals bijvoorbeeld de verkoopovereenkomst of het EPC-certificaat. Houd er rekening mee dat een bijgebouw/kelder/ongebruikte zolder niet als bewoonbare ruimte en dus niet als bewoonbaar oppervlakte worden beschouwd. ',
            'find-box-number_tooltip': '',
            'find-box-number_question':
                'Waar kan ik het busnummer van een appartement vinden?',
            'find-box-number_answer':
                'Het busnummer van een appartement maakt deel uit van het adres dat moet worden ingevuld op de verkoopovereenkomst of het EPC-certificaat. Als u niet zeker bent van deze informatie, neem dan contact op met de kredietnemer en vul de aanvraag aan zodra u de informatie hebt. ',
            'find-construction-year_tooltip': '',
            'find-construction-year_question': 'Waar kan ik het bouwjaar vinden?',
            'find-construction-year_answer':
                'Het offici\u00eble bouwjaar kan u meestal vinden in de verkoopadvertentie, het kadaster of het referentiejaar in het EPC-certificaat. Onthoud dat het bouwjaar verwijst naar het jaar van constructie en niet naar het jaar van eventuele latere (ingrijpende) renovaties.',
            'construction-vs-renovation_tooltip': '',
            'construction-vs-renovation_question':
                'Het pand is volledig gerenoveerd. Wat vul ik in als bouwjaar: het oorspronkelijke jaar of het jaar van renovatie?',
            'construction-vs-renovation_answer':
                'Vul als bouwjaar het jaar van daadwerkelijke constructie van het gebouw in, en niet het jaar van eventuele renovaties of verbouwingen. We houden rekening met renovaties op basis van andere relevante informatiebronnen, zoals het EPC certificaat.',
            'over-two-days_tooltip': '',
            'over-two-days_question':
                'Het is meer dan 2 werkdagen geleden en mijn aanvraag is nog steeds niet geschat, wat moet ik doen?',
            'over-two-days_answer':
                'De werkdagen van Rock.estate zijn van maandag tot en met vrijdag. Het is mogelijk dat u een zaterdag of een feestdag hebt meegerekend in de twee werkdagen waarnaar u verwijst.\n\nZo niet, neem dan contact op via ons contactformulier met vermelding van het referentienummer.',
            'right-info-flagged-incorrect_tooltip': '',
            'right-info-flagged-incorrect_question':
                'Wat gebeurt er als de schatter bepaalde informatie als "incorrect" heeft gemarkeerd, maar ik weet zeker dat dit de juiste informatie is?',
            'incoherent-submitted-twice_tooltip': '',
            'incoherent-submitted-twice_question':
                'Wat gebeurt er als een schatting tweemaal is teruggestuurd met "incorrecte informatie"?',
            'processing-time_tooltip': '',
            'processing-time_question':
                'Hoe lang duurt het voordat een aanvraag wordt verwerkt? ',
            'multiple-addresses_tooltip': '',
            'multiple-addresses_question':
                'Is het normaal dat er meer dan \u00e9\u00e9n adres is voor \u00e9\u00e9n gebouw? ',
            'what-is-bedroom_tooltip': '',
            'what-is-bedroom_question': 'Wat is een slaapkamer?',
            'what-is-garden_tooltip': '',
            'what-is-garden_question': 'Wat is een gemeenschappelijke tuin?',
            'what-is-private-garden_tooltip': '',
            'what-is-private-garden_question':
                'Wat wordt gezien als een privatieve tuin? ',
            'what-is-closed-garage_tooltip': '',
            'what-is-closed-garage_question': 'Wat is een gesloten garage?',
            'what-is-parking-spot_tooltip': '',
            'what-is-parking-spot_question': 'Wat is een parkeerplaats? ',
            'what-is-cellar-basement_tooltip': '',
            'what-is-cellar-basement_question': 'Wat is een kelder/zolder? ',
            carport_tooltip: '',
            carport_question: 'Is een carport een parkeerplaats of een gesloten garage? ',
            carport_answer:
                'Een carport verwijst naar een parkeerplaats, niet naar een gesloten garage. ',
            'personal-use_tooltip': '',
            'personal-use_question':
                'Kan ik een schatting aanvragen van mijn eigen woning? ',
            'personal-use_answer':
                "Rock.estate's Schatting Platform kan alleen worden gebruikt voor professionele doeleinden.\nHet is de verantwoordelijkheid van elke geautoriseerde gebruiker om zich hieraan te houden. Vandaar dat wij niet aanraden om een schatting aan te vragen van uw eigen woning of van iemand die u kent.",
            'is-request-submitted_tooltip': '',
            'is-request-submitted_question':
                'Hoe kan ik zien of ik mijn aanvraag met succes heb ingediend?',
            'is-request-submitted_answer':
                "Zodra u uw aanvraag met succes hebt ingediend, zou de status van de aanvraag in het Dashboard moeten veranderen naar 'Ingediend'. \nU ontvangt ook een e-mail met de melding dat het verzoek is ingediend en dat een van onze schatters het binnen twee werkdagen zal verwerken.",
            review_tooltip: '',
            review_question:
                'De aanvraag die ik indiende kwam terug als "ontwerp" in het rood, wat moet ik doen? ',
            review_answer:
                'Als u een aanvraag hebt ontvangen met de status "Ontwerp", betekent dit dat de schatter \u00e9\u00e9n of meerdere gegevens als "onjuist" heeft gemarkeerd. Als u zeker bent dat deze informatie toch juist is, dient u de aanvraag opnieuw in zoals ze is of neem contact op met ons via het contactformulier. ',
            'find-previous-request_tooltip': '',
            'find-previous-request_question':
                'Hoe kan ik een eerdere aanvraag terugvinden? ',
            'find-previous-request_answer':
                'Om een eerdere aanvraag terug te vinden, ga naar uw Dashboard en gebruik de zoekbalk. U kan zoeken op datum, referentie, interne referentie, adres, etc. ',
            'download-report_tooltip': '',
            'download-report_question': 'Hoe kan ik het verslag downloaden? ',
            'download-report_answer':
                "Om het verslag te downloaden, kilkt u op het groene vakje naast uw aanvraag genaamd 'PDF verslag'.  \nHet verslag is alleen beschikbaar nadat uw aanvraag met succes is geschat door een schatter van Rock.estate.",
            'language-impact_tooltip': '',
            'language-impact_question':
                'Verandert er iets aan het proces als ik het Rock.estate schatting platform in een andere taal gebruik? ',
            'language-impact_answer':
                'Als u een schatting aanvraagt in een bepaalde taal, ontvangt u een verslag van dat onroerend goed in diezelfde taal. U kan de taal van het verslag wijzigen, maar de opmerking blijven in de oorspronkelijke taal.\nEr zal geen invloed zijn op de gegevens of de marktwaarde van een onroerend goed.',
            'unsubmission-window_tooltip': '',
            'unsubmission-window_question':
                'Hoe kan ik een aanvraag aanpassen na indienen?',
            'unsubmission-window_answer':
                'Om een aanvraag aan te passen na indienen, ga naar uw Dashboard en klik op "Bewerken". Voor een Waarderingsaanvraag heeft u 60 minuten de tijd na indienen om aanpassingen te doen of te verwijderen. Voor een Energetische renovatie simulatie, klik op "Bewerk" in de rechterbovenhoek van de Rapport pagina. Zorg ervoor dat u uw aanpassingen doorvoert door opnieuw "Indienen" te selecteren.',
            'after-sixty-minutes_tooltip': '',
            'after-sixty-minutes_question':
                'Wat kan ik doen als ik mijn aanvraag na 60 minuten na het indienden nog moet wijzigen? ',
            'after-sixty-minutes_answer':
                'Als u een aanvraag na 60 minuten wil wijzigen of annuleren, laat het ons dan zo snel mogelijk weten via ons contactformulier. Dit verzoek kan in rekening worden gebracht afhankelijk van de voortgang van de schatter.',
            'review-billing_tooltip': '',
            'review-billing_question':
                'Mijn aanvraag kwam terug als een "ontwerp", betekent dit dat de bank twee keer moet betalen voor deze aanvraag?',
            'review-billing_answer':
                'Nee, de bank wordt slechts eenmaal gefactureerd nadat de aanvraag succesvol is geschat of wordt aanbevolen voor een schatting ter plaatse. \nIndien de aanvraag na twee keer terugsturen als "ontwerp" niet met succes op afstand kan worden geschat, zal een aanbeveling worden gedaan voor een schatting ter plaatse.',
            'access-requests_tooltip': '',
            'access-requests_question':
                "Hoe kan ik toegang krijgen tot de verzoeken van mijn collega's? ",
            substitution_tooltip: '',
            substitution_question:
                'Hoe kan ik eigenaar worden van een verzoek dat niet van mij is? ',
            'what-is-ers_tooltip': '',
            'what-is-ers_question': 'Wat is een Energetische renovatie simulatie?',
            'what-is-ers_answer':
                'Rock.estate\u2019s Energetische renovatie simulator is een krachtige tool die de huidige EPC score van een residentieel pand schat en relevante renovatie scenario\u2019s voorstelt op basis van energetische karakteristieken. In slechts enkele minuten kunnen gebruikers de renovaties ontdekken die het best passen bij hun persoonlijke doelen en de details van het gebouw.\n\nNa het invullen van een eenvoudige vragenlijst schat de simulator in welke energieverbeteringen nodig zijn om een beoogde EPC-score te halen, en dit met optimalisatie van de return-on-investment. De schatting is gebaseerd op de ingevulde gegevens van de gebruiker, gecombineerd met bouwgegevens en technische bouwvereisten in Belgi\u00eb. Een correcte invulling van de vragenlijst resulteert in een meer nauwkeurige schatting van de EPC-score.\n\nBelangrijk om op te merken is dat de resultaten indicatief zijn. Ze vervangen geen officieel EPC-certificaat, noch bieden ze definitieve aanbevelingen voor renovatie. Raadpleeg altijd een professional voor gepersonaliseerd advies.',
            'what-is-common-wall_tooltip': '',
            'what-is-common-wall_question': 'Wat is een gedeelde muur?',
            'what-is-common-wall_answer':
                'Een gedeelde muur, ook wel een gemeenschappelijke muur genoemd, wordt vaak geplaatst tussen twee naburige eigendommen. Het is de scheiding tussen onderling verbonden gebouwen. Deze muren zijn meestal ge\u00efsoleerd en hebben geen extra isolatie nodig. Een huis kan meerdere gemeenschappelijke muren hebben, die elk gedeeld worden met \u00e9\u00e9n of verschillende naburige huizen.',
            'what-is-protected-volume_tooltip': '',
            'what-is-protected-volume_question': 'Wat is het beschermde volume?',
            'what-is-protected-volume_answer':
                'Het beschermde volume is de binnenruimte van uw huis dat u wilt beschermen tegen warmteverliezen. Dit volume omvat verwarmde kamers en soms ook zolders of kelders. Het doel is om binnen dit volume een constante temperatuur te behouden.',
            'what-is-living-area_tooltip': '',
            'what-is-living-area_question': 'Wat is de bewoonbare oppervlakte?',
            'what-is-living-area_answer':
                'De bewoonbare oppervlakte verwijst naar het totale vloeroppervlakte dat deel uitmaakt van het verwarmde volume. Dat zijn alle kamers waar u warmteverliezen wilt vermijden. Daarom wordt de kelder meestal uitgesloten. Tel de zolderruimte mee in de totale oppervlakte als dit een verwarmde kamer is. U kan het bruikbare vloeroppervlakte vinden in het EPC-certificaat.',
            'apartment-ers_tooltip': '',
            'apartment-ers_question':
                'Hoe kan ik een Energetische renovatie simulatie voor een appartement of appartementgebouw aanvragen?',
            'apartment-ers_answer':
                'Op dit moment zijn Energetische renovatie simulaties niet beschikbaar voor appartementen of appartementencomplexen. Ons team werkt actief aan het uitbreiden van de scope van de simulator om deze eigendomstypes in de toekomst op te nemen. We waarderen uw begrip en geduld terwijl we streven naar een breder aanbod.',
            'no-3d-model-ers-quality_tooltip': '',
            'no-3d-model-ers-quality_question':
                'Het 3D model werd niet gevonden. Zijn de resultaten relevant?',
            'no-3d-model-ers-quality_answer':
                'Wanneer we niet over voldoende 3D-modelgegevens beschikken, vragen we aanvullende informatie om de afmetingen van het gebouw te schatten. Onze benadering sluit nauw aan bij de kenmerken van een traditioneel gebouwd huis. De nauwkeurigheid van de benadering is daarom hoger voor woningen die voldoen aan conventionele bouwnormen en wanneer de ingevulde gegevens correct zijn, vooral voor essenti\u00eble parameters zoals het verwarmde bewoonbare oppervlakte. Omgekeerd kan afwijking van conventionele normen de resultaten be\u00efnvloeden.',
            'what-is-renovation-goal_tooltip': '',
            'what-is-renovation-goal_question':
                'Ik moet een renovatiedoel opgeven. Wat is dat?',
            'what-is-renovation-goal_answer':
                'Er zijn verschillende redenen waarom huiseigenaren kunnen overwegen om energiezuinige renovaties uit te voeren, waaronder milieuoverwegingen, besparing op energierekeningen, verbeterd comfort of het verhogen van de marktwaarde van het pand. Wat de motivatie ook is om te renoveren, deze kan waarschijnlijk worden vertaald naar een beoogde EPC-score, een budget of een persoonlijke selectie van renovaties.\n\nGebaseerd op het renovatiedoel van de klant, stelt het platform het meest effici\u00ebnte renovatiescenario voor om aan de doelstellingen te voldoen. Hier zijn de verschillende opties die door ons platform worden gepresenteerd:\n\n- Target EPC: Als u ernaar streeft om een bepaalde EPC-score te behalen, is dit een goede keuze. Het retourneert het meest kosteneffici\u00ebnte pakket dat aan de beoogde EPC-score voldoet.\n- Budget: Geef ons uw budget door en we stellen het pakket voor met de laagste EPC-score na renovatie dat past bij wat u bereid bent te investeren. Op deze manier haalt u het meeste uit uw geld.\n- Klik en kies: Als er beperkingen zijn voor het type renovaties dat aansluit bij uw behoeften, stel dan uw eigen plan samen door de renovaties van uw keuze te selecteren. Met Klik en kies heeft u de flexibiliteit om een op maat gemaakt renovatieplan te maken.',
            'missing-renovation-option_tooltip': '',
            'missing-renovation-option_question':
                'Ik vind niet alle renovatie- opties (vb. binnenmuur-, plafondisolatie, etc.). Hoe komt dat?',
            'missing-renovation-option_answer':
                'Voor sommige renovatie- opties is het ten sterkste aangeraden een professional te raadplegen. Zo riskeert men bij binnenmuurisolatie of plafondisolatie problemen met warmtebruggen of condensatie indien het technisch niet goed onderzocht werd. Vloerisolatie in tussenverdiepingen is kosten-baten dan weer niet het effici\u00ebntst. Omdat we naar best vermogen trachten foutief advies van onze automatische simulator te vermijden, hebben we ervoor gekozen vandaag niet alle opties te presenteren. Raadt een professional dit toch aan, kan het budget in de simulator een overschatting zijn. Wij selecteren renovaties die op de meeste woningen toepasbaar zijn en het grootste positieve effect hebben op een woning. Indien we merken dat hier vraag naar is, kunnen we het aantal aangeboden renovatie- opties uitbreiden.',
            'choosing-insulation-material_tooltip': '',
            'choosing-insulation-material_question':
                'Kan ik zelf het isolatiemateriaal kiezen voor elke renovatie?',
            'choosing-insulation-material_answer':
                'Op dit moment is de optie om specifieke isolatiematerialen te kiezen niet beschikbaar. Het is echter belangrijk op te merken dat we zorgvuldig materialen selecteren die vaak worden gebruikt voor elk type isolatie. We willen deze optie in de toekomst wel aanbieden. We willen zo veel mogelijk flexibiliteit bieden.',
            'own-property-ers_tooltip': '',
            'own-property-ers_question':
                'Kan ik een Energetische renovatie simulatie indienen voor mijn eigen woning?',
            'own-property-ers_answer':
                'Het platform van Rock.estate is uitsluitend bedoeld voor professionele doeleinden. Het is de verantwoordelijkheid van elke geautoriseerde gebruiker om hieraan te voldoen. Daarom raden we aan om geen simulatie in te dienen voor uw eigen pand of voor iemand die u kent. Houd er rekening mee dat het essentieel is om het beoogde gebruik van de service te respecteren.',
            'estimated-epc-different-than-actual-epc_tooltip': '',
            'estimated-epc-different-than-actual-epc_question':
                'De geschatte EPC score verschilt van de offici\u00eble EPC score.',
            'estimated-epc-different-than-actual-epc_answer':
                'Er zijn een aantal redenen waarom de geschatte EPC-score kan afwijken:\n\n- Zorg ervoor dat het beoordeelde pand het juiste is en dat de ingevulde gegevens in lijn zijn met de realiteit.\n- Een EPC-certificaat is 10 jaar geldig. Bepaalde renovaties, zoals dakisolatie of het vernieuwen van het verwarmingssysteem, kunnen de energie-effici\u00ebntie en de EPC-score van een huis be\u00efnvloeden. In geval er energetische renovaties gebeurd zijn na de uitgifte van het EPC certificaat, is het document niet meer up to date.\n- De EPC-simulator gaat uit van \u00e9\u00e9n verwarmingssysteem voor het totale beschermde volume en hetzelfde type beglazing voor alle ramen. Meerdere verwarmingssystemen en verschillende types raambeglazing kunnen invloed hebben op de werkelijke EPC-score. Daarnaast gaat de simulator uit van dezelfde isolatie voor alle buitenmuren. Als sommige muren ge\u00efsoleerd zijn terwijl andere dat niet zijn, kan ook dat de EPC-score be\u00efnvloeden.\n- Wanneer een 3D-model niet beschikbaar is, gebruiken we aanvullende vragen om de afmetingen te schatten. Wanneer het huis in realiteit andere afmetingen heeft, zoals plafondhoogtes en dakori\u00ebntatie, kan dit verschillen in EPC scores veroorzaken. Dit effect is sterker wanneer de voetafdruk van het gebouw ontbreekt. Hetzelfde geldt voor renovaties aan het gebouw die het 3D-model verouderd maken.\n- Als de isolatiematerialen die tijdens de bouw of renovatie zijn gebruikt significant verschillen van industriestandaarden, kan de werkelijke EPC-score verschillen van de geschatte EPC score.',
            'how-is-vat-computed_tooltip': '',
            'how-is-vat-computed_question': 'Hoe wordt BTW berekend?',
            'how-is-vat-computed_answer':
                'Overeenkomstig de federale belastingwetgeving is er een tarief van 6% BTW van toepassing op energetische renovaties voor huizen die ouder zijn dan 10 jaar, en anders is 21% BTW van toepassing. Om recht te hebben op 6% BTW, moet een aannemer de werken uitvoeren. Voor zonnepanelen en warmtepompen hebben ook huizen die jonger zijn dan 10 jaar recht op 6% BTW tot het einde van 2023.',
            'price-ers-includes_tooltip': '',
            'price-ers-includes_question':
                'Wat zit inbegrepen in de prijs van renovaties?',
            'price-ers-includes_answer':
                'De prijzen zijn inclusief BTW, isolatiematerialen en uitvoering.\n\nMeer in detail,\n- Buitenste dakisolatie omvat het verwijderen van dakbedekking en -structuur, evenals dakgoten, het plaatsen van isolatie en een dampremmende laag, het aanbrengen van de dakstructuur en -bedekking, werken rond dakventilatie, het installeren van dakgoten, het verwijderen en opnieuw plaatsen van zonnepanelen indien aanwezig, en het gebruik van een kraan of hijsinstallatie.\n- Binnenste dakisolatie omvat het verwijderen van de versleten isolatielaag (inclusief dampremmende laag), het installeren van een nieuwe isolatielaag en dampremmende laag, en het aanpassen rond het dakvlak en de dakkapellen.\nIsolatie van de zoldervloer omvat het plaatsen van isolatie en dampremmende laag, aanpassingen aan bestaande leidingen en verlichting, en aanpassingen aan de toegang.\n- Buitenmuurisolatie omvat het verwijderen van regenwaterafvoer, het afzagen van dorpels, het plaatsen van isolatie, het aanbrengen van afwerkingen (zoals crepi), het updaten van openingen (inclusief dorpels), het uitvoeren van aanpassingen, het vergroten van dakoverstekken, het vernieuwen van regenwaterafvoer, en het gebruik van stellingen.\n- Isolatie van de spouwmuur omvat het gebruik van een hoogwerker, het plaatsen van 5 cm minerale wol isolatie, inclusief inspectie, voorbereiding, inblazen van de isolatie en het sluiten van de openingen.\n- Diensten voor ramen omvatten het verwijderen en plaatsen van glas (met extra kosten voor hijsapparatuur), het verwijderen en plaatsen van het raamkozijn, het plaatsen van thermische isolatie op het glas, en het vervangen van het glas.\n- Diensten voor warmtepompen omvatten het verwijderen van het bestaande verwarmingssysteem, het installeren van een warmtepomp (met bodem- of waterbronnen, inclusief boren), het aansluiten op het bestaande systeem, en het isoleren van niet-ge\u00efsoleerde leidingen. Bijkomende kosten kunnen van toepassing zijn voor het vervangen van het klimaatsysteem.\n- Diensten voor condenserende gasketels omvatten het verwijderen van het huidige verwarmingssysteem, het installeren van een condenserende gasketel, het berekenen van de kosten op basis van de capaciteit van de ketel, het aansluiten op het bestaande systeem, extra kosten voor het vervangen van het distributiesysteem, en het isoleren van niet-ge\u00efsoleerde leidingen.\n- Diensten voor zonnepanelen omvatten het plaatsen van zonnepanelen samen met alle benodigde accessoires.\n',
            'incorrect-region_tooltip': '',
            'incorrect-region_question': 'De regio is niet correct.',
            'incorrect-region_answer':
                "We begrijpen dat het nauwkeurig identificeren van de locatie cruciaal is. Het is belangrijk op te merken dat hetzelfde adres in meerdere steden kan voorkomen.\n\nBij het invoeren van het adres, zorg ervoor dat u de juiste gemeente selecteert uit de beschikbare opties. Controleer vervolgens zorgvuldig de ingevoerde adresgegevens om eventuele inconsistensies te voorkomen.\n\nSommige gemeenten bevinden zich op de grenzen van de regio's Vlaanderen, Brussen en Walloni\u00eb, wat inconsistenties kan veroorzaken. Als u er \u00e9\u00e9n tegenkomt, neem dan contact met ons op via het Helpcenter.",
            'interaction-between-renovations_tooltip': '',
            'interaction-between-renovations_question':
                'Waarom worden soms renovaties gedeselecteert wanneer ik een ander item toevoeg?',
            'interaction-between-renovations_answer':
                'Onze tool geeft een optimale combinatie van renovaties terug om een beoogde EPC-score te halen tegen minimale kosten. Vanuit kostenoogpunt is het niet optimaal om bepaalde renovaties te combineren, omdat ze soortgelijke doelen dienen of elkaars effecten tegenwerken. De automatische uitsluiting van contraproductieve combinaties zorgt ervoor dat uw investering maximaal rendeert.\n\nBijvoorbeeld, als u het dak van binnenuit isoleert, is het mogelijk niet nodig om het ook van buitenaf te isoleren.',
            'ers-reliability_tooltip': '',
            'ers-reliability_question':
                'Hoe betrouwbaar zijn de gegevens in het rapport?',
            'ers-reliability_answer':
                'De gegevens in het rapport zijn indicatief. Ze worden berekend op basis van gebruikersinvoer en verschillende bronnen over marktprijzen. Ze vervangen geen officieel EPC-certificaat of professioneel advies. Prijzen kunnen vari\u00ebren afhankelijk van de staat van het huis en de gekozen materialen voor renovatie. Hoe nauwkeuriger de gebruikersinvoer, des te accurater de resultaten zijn. Het is belangrijk op te merken dat prijzen de marktomstandigheden van vandaag vertegenwoordigen en in de loop der tijd kunnen veranderen. Consulteer steeds een professional voor finale check, gezien deze berekeningen door veelvuldige factoren kunnen worden be\u00efnvloed.',
            'report-measurements-dont-match_tooltip': '',
            'report-measurements-dont-match_question':
                'De afmetingen in het rapport komen niet overeen met die van het gebouw.',
            'report-measurements-dont-match_answer':
                'Er kunnen een paar redenen zijn voor de inconsistenties die u opmerkt. Houd er rekening mee dat u de optie hebt om de afmetingen van het gebouw te laten schatten door "Dit is niet het juiste gebouw" te selecteren en de instructies te volgen.\n\n- Het 3D-model weerspiegelt niet de huidige staat van het huis (bijvoorbeeld recente wijzigingen zijn aangebracht: het toevoegen van een veranda, enz.).\n- Het 3D-model van het gekozen huis was niet het juiste huis.\n- De bewoonbare oppervlakte was niet correct.\n- Het 3D-model was niet beschikbaar. We hebben de antwoorden op aanvullende vragen gebruikt om afmetingen te benaderen, maar deze wijken mogelijk af van de werkelijke afmetingen van het pand.\n- De oppervlaktes van ramen en het dak worden benaderd op basis van bouwnormen, die af kunnen wijken van de werkelijkheid.\n',
            'how-to-create-val-req_tooltip': '',
            'how-to-create-val-req_question': 'Hoe u een Waarderingsaanvraag aanmaakt',
            'how-to-create-val-req_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/e1e6ecce-a8b7-4425-9d2a-bd5d355a37f9" loading="lazy" title="Synthesia video player - How to start a Valuation request" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-access-app_tooltip': '',
            'how-to-access-app_question':
                "Hoe u toegang krijgt tot Rock.estate's applicaties ",
            'how-to-access-app_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/0b3b14d4-ae8f-4ab5-9bdc-71cc0a7f244b" loading="lazy" title="Synthesia video player - How to access Rock.estate\'s applications" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-use-dashboard_tooltip': '',
            'how-to-use-dashboard_question':
                'Hoe u uw dashboard gebruikt voor Waarderingsaanvragen',
            'how-to-use-dashboard_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/d138270a-19cc-43eb-8ba4-97f7275caf40" loading="lazy" title="Synthesia video player - How to use dashboard for valuation requests" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'what-is-val-report_tooltip': '',
            'what-is-val-report_question': 'Wat is het waarderingsrapport?',
            'what-is-val-report_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/6f3af77c-3aac-438a-803b-0fd550382581" loading="lazy" title="Synthesia video player - The valuation report" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-const_tooltip': '',
            'how-to-create-req-const_question':
                'Hoe u een aanvraag indient voor bouwgrond',
            'how-to-create-req-const_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/8e121e6a-1d1a-444a-ba7b-3cbd45f91e57" loading="lazy" title="Synthesia video player - How to create a request for a construction plot" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-new-house_tooltip': '',
            'how-to-create-req-new-house_question':
                'Hoe u een aanvraag indient voor een nieuwbouw huis',
            'how-to-create-req-new-house_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/95d74ca1-13c4-42e1-bd35-bb0280761ca1" loading="lazy" title="Synthesia video player - How to create a request for a new house" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-existing-house_tooltip': '',
            'how-to-create-req-existing-house_question':
                'Hoe u een aanvraag indient voor een bestaand huis',
            'how-to-create-req-existing-house_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/20813b72-86cb-4fab-be4b-9993cb520327" loading="lazy" title="Synthesia video player - How to create a request for an existing house" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-new-qpqrtment_tooltip': '',
            'how-to-create-req-new-qpqrtment_question':
                'Hoe u een aanvraag indient voor een nieuwbouw appartement',
            'how-to-create-req-new-qpqrtment_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/baaa6686-2977-40e9-88c7-4d0f28d5d320" loading="lazy" title="Synthesia video player - How to create a request for a new apartment" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-existing-apartment_tooltip': '',
            'how-to-create-req-existing-apartment_question':
                'Hoe u een aanvraag indient voor een bestaand appartement',
            'how-to-create-req-existing-apartment_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/20813b72-86cb-4fab-be4b-9993cb520327" loading="lazy" title="Synthesia video player - How to create a request for an existing house" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-confirm-address-existing-prop_tooltip': '',
            'how-to-confirm-address-existing-prop_question':
                'Hoe u het adres, gebouw en perceel  bevestigt voor een bestaande woning',
            'how-to-confirm-address-existing-prop_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/adaf14ec-bbc8-4916-8a41-3b28549a43a1" loading="lazy" title="Synthesia video player - How to confirm the address, building and parcel selection for an existing property" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-confirm-address-prop-under-const_tooltip': '',
            'how-to-confirm-address-prop-under-const_question':
                'Hoe u het adres en perceel bevestigt voor een nieuwbouw woning',
            'how-to-confirm-address-prop-under-const_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/5cf12e6a-a55b-4a3f-841a-4caa155649d8" loading="lazy" title="Synthesia video player - How to confirm the address and parcel for a property under construction" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-ers-req-3D_tooltip': '',
            'how-to-create-ers-req-3D_question':
                'Hoe u een ERS aanvraag met een 3D model aanmaakt',
            'how-to-create-ers-req-3D_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; padding-top: 56.25%;"><iframe src="https://share.synthesia.io/embeds/videos/59ec70a8-f074-4f16-9265-6c9c068d6043" loading="lazy" title="Synthesia video player - How to create an ERS request with 3D model" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-ers-req-2D_tooltip': '',
            'how-to-create-ers-req-2D_question':
                'Hoe u een ERS aanvraag met een 2D voetafdruk aanmaakt',
            'how-to-create-ers-req-2D_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/caeea1e6-1968-47bc-a1ea-76bdb7c7c0a7" loading="lazy" title="Synthesia video player - How to create an ERS request with 2D footprint" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-ers-req-building-not-found_tooltip': '',
            'how-to-create-ers-req-building-not-found_question':
                'Hoe maak je een ERS-verzoek aan wanneer het gebouw niet kon worden gevonden',
            'how-to-create-ers-req-building-not-found_answer':
                '<p>Deze video is momenteel enkel in het Engels beschikbaar</p>\n\n<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/a36b0550-f792-471b-8c89-ee8cff89a1cb" loading="lazy" title="Synthesia video player - How to create an ERS request when the building could not be found" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-total-investment-cost-calculated_tooltip': '',
            'how-total-investment-cost-calculated_question':
                'Hoe wordt de totale investeringkost berekend?',
            'how-total-investment-cost-calculated_answer':
                'De totale investeringkost van een renovatie omvat de kosten voor sloop, transport, materialen en installatie. We bepalen de benodigde materialen op basis van de geometrie van het gebouw (oppervlakte, volume, ori\u00ebntatie, helling, enz.). Bijvoorbeeld, zonnepanelen worden geplaatst op het dakdeel met de beste ori\u00ebntatie voor zonlicht, en de capaciteit stemt overeen met de behoeften aan elektriciteitsverbruik. De prijs inclusief btw houdt rekening met 6% of 21%, afhankelijk van de belastingregels. Totale prijzen worden afgerond naar het dichtstbijzijnde honderdtal.\n## Kosten zijn gebaseerd op data van de volgende bronnen:  \n\n- EPC methodiek voor gemiddelde prijsindicaties (door Vlaams Energieagentschap)\n- UPA - BUA (Beroepsunie van architecten)\n- Archindex (documentatie voor en door ingenieurs/architecten)\n- ASPEN (onafhankelijke en objectieve bron van prijsinformatie voor aannemers)\n- ABEX Borderel (referentie om verzekeringspremies en brandpolissen te berekenen)\n- Input van de markt (leveranciers/aannemers)\n- Online bronnen  \n\nEr zijn verschillende redenen waarom een offerte van uw aannemer kan afwijken van de geschatte totale investeringskost. Een verschil van 20-25% tussen het goedkoopste en duurste aanbod op de markt is niet ongebruikelijk. Het is daarom aangeraden om offertes op te vragen bij meerdere aanbieders voordat u een beslissing neemt.\n## Hieronder vind u een aantal factoren die de kosten be\u00efnvloeden:  \n\n- Kwaliteit van materialen\n- Totale oppervlakte\n- Keuze van technologie\n- Dikte van isolatie\n- Vermogen/Capaciteit\n- Merk\n- Gecombineerd met andere werken (bijv. asbestverwijdering)  \n\n\nEr wordt geen rekening gehouden met regionale verschillen in kosten (vb. in transport- en infrastructuurinstallatiekosten).  Voorafgaande werken die eventueel nodig zijn om de renovatie technisch haalbaar te maken, zijn niet inbegrepen in de totale investeringkost.\nDownload een renovatierapport van een renovatiescenario om meer inzicht te krijgen over de keuze van materialen en technologie, de oppervlakte, en wat is inbegrepen in de totale investeringkost.',
            payment_tooltip: '',
            payment_question: 'Hoeveel kost een waardering ter plaatse?',
            payment_answer:
                '\nDe kost van een waardering ter plaatse is afhankelijk van de eigenschappen van het pand. Deze prijs wordt aan de klant medegedeeld tijdens het plannen van de afspraak voor de waardering ter plaatse.',
            'payment-methods_tooltip': '',
            'payment-methods_question': 'Welke betaalmethoden worden geaccepteerd?',
            'payment-methods_answer':
                'De volgende betaalmethoden worden geaccepteerd:\n- Bancontact\n- Visa\n- Mastercard',
            'why-payment-before_tooltip': '',
            'why-payment-before_question':
                'Waarom moet voorafgaand aan de afsrpaak de waardering betalen?',
            'why-payment-before_answer':
                '\nDoor de betaling vooraf te regelen, kunnen we direct na het bezoek van onze expert uw gedetailleerde waarderingsverslag leveren. Op deze manier bieden we u de snelste en meest effici\u00ebnte ervaring mogelijk.',
            'when-appointment_tooltip': '',
            'when-appointment_question': 'Waneer zal het pand gewaardeerd worden?',
            'when-appointment_answer':
                '\nAls klante heeft u, wanneer u een uitnodigingslink van Rock.estate ontvangt, de mogelijkheid om uw afspraak voor de waardering op een voor u geschikt moment in te plannen. Door de link te volgen, kunt u de dag en tijd kiezen die u het beste uitkomen. Zorg ervoor dat u beschikbaar bent op dat moment, aangezien er geen restituties zullen worden verstrekt voor niet-verschijnen op de dag van de waardering.',
            Reschedule_tooltip: '',
            Reschedule_question: 'Kan ik mijn afsrpaak herplannen?',
            Reschedule_answer:
                'U kunt uw afspraak opnieuw inplannen door contact met ons op te nemen via support@rock.estate. Geef alstublieft bij voorbaat uw beschikbaarheden door en laat uw telefoonnummer achter. We nemen contact met u op om een nieuwe afspraak te plannen.\n\nEr zijn geen kosten verbonden aan het opnieuw inplannen of annuleren van afspraken als dit meer dan 24 uur van tevoren gebeurt. Wijzigingen die binnen 24 uur worden aangebracht, zijn onderhevig aan 50% van de kosten, en in geval van niet verschijnen zonder voorafgaande kennisgeving wordt het volledige bedrag niet terugbetaald. Raadpleeg onze FAQ voor aanvullende details.',
            cancel_tooltip: '',
            cancel_question: 'Kan ik mijn afspraak annuleren?',
            cancel_answer:
                'U kunt uw afspraak annuleren door contact met ons op te nemen via support@rock.estate.\n\nEr zijn geen kosten verbonden aan het opnieuw inplannen of annuleren van afspraken als dit meer dan 24 uur van tevoren gebeurt. Wijzigingen die binnen 24 uur worden aangebracht, zijn onderhevig aan 50% van de kosten, en in geval van niet verschijnen zonder voorafgaande kennisgeving wordt het volledige bedrag niet terugbetaald. Raadpleeg onze FAQ voor aanvullende details.',
            present_tooltip: '',
            present_question: 'Moet ik aanwezig zijn tijdens de waardering?',
            present_answer:
                'Uzelf of een vertegenwoordiger moet aanwezig zijn tijdens de waardering, om de expert toegang te verlenen tot het pand.',
            timing_tooltip: '',
            timing_question:
                'Waneer krijg ik de exacte aankomsttijd van de expert te horen?',
            timing_answer:
                'De expert zal arriveren binnen het tijdvak van 1 uur en 30 minuten dat u heeft geselecteerd voor uw afspraak. De expert kan contact met u opnemen v\u00f3\u00f3r het bezoek met een meer gedetailleerde aankomsttijd.',
            'borrower-contact-expert_tooltip': '',
            'borrower-contact-expert_question': 'Hoe kan ik de expert contacteren?',
            'borrower-contact-expert_answer':
                'Indien u een vraag heeft voor de expert, kunt u contact opnemen met onze helpdesk via support@rock.estate.',
            'borrower-contact-who_tooltip': '',
            'borrower-contact-who_question':
                'Met wie kan ik contact opnemen als de expert niet ter plaatste is op het moment van de waardering?',
            'borrower-contact-who_answer':
                'U kunt contact opnemen met onze helpdesk via support@rock.estate. Voor dringende zaken verzoeken wij u vriendelijk uw telefoonnummer achter te laten, zodat wij u kunnen bereiken.',
            'bank-agent-contacted_tooltip': '',
            'bank-agent-contacted_question':
                '\nMijn klant heeft mij laten weten dat hij/zij/de vertegenwoordiger niet aanwezig kan zijn bij de afspraak. Wat moet ik doen?',
            'bank-agent-contacted_answer':
                'Neem alstublieft contact met ons op of adviseer uw cli\u00ebnt om contact met ons op te nemen via support@rock.estate. We kunnen de afspraak opnieuw inplannen of annuleren indien nodig.',
            'how-contact-RE_tooltip': '',
            'how-contact-RE_question':
                '\nHoe kan ik het contactcenter van Rock.estate bereiken?',
            'how-contact-RE_answer':
                'Neem alstublieft contact met ons op via support@rock.estate.',
            'contact-representative_tooltip': '',
            'contact-representative_question':
                'Hoe kan ik rechtstreeks contact opnemen met de klant om hem op de hoogte te stellen van mijn aankomsttijd of eventuele vertraging?',
            'contact-representative_answer':
                'Gelieve naar uw afspraakoverzicht te gaan via uw dashboard. Daar kunt u de contactgegevens van de klant en/of de contactgegevens van de vertegenwoordiger bekijken.',
            'how-link-calendar_tooltip': '',
            'how-link-calendar_question':
                '\nHoe koppel ik mijn agenda (Google, iCloud, Office 365, Exchange, Outlook.com)?',
            'how-link-calendar_answer':
                "Gelieve naar de pagina 'On-site Valuer' te gaan om uw instellingen te openen en te klikken op 'Beschikbaarheid'. U zult het gedeelte zien om uw kalenderaccount te koppelen.",
            'Several-calendars_tooltip': '',
            'Several-calendars_question': "\nKan ik meerdere agenda's koppelen?",
            'Several-calendars_answer':
                '\nJa, u kunt meerdere kalenderaccounts toevoegen, en we zullen met al deze accounts rekening houden.',
            'How-availabilities_tooltip': '',
            'How-availabilities_question': 'Hoe registreer ik mijn beschikbaarheden?',
            'How-availabilities_answer':
                "\nNa het koppelen van uw kalender, kunt u meerdere regio's kiezen waarin u werkt. In de sectie 'beschikbaarheid' hieronder kunt u uw werkuren instellen voor elke regio. We zullen alleen rekening houden met uw kalender tijdens die aangewezen uren.",
            'Different-regions_tooltip': '',
            'Different-regions_question': "Kan ik in verschillende regio's werken?",
            'Different-regions_answer':
                "\nJa, u heeft de flexibiliteit om meerdere regio's te kiezen voor elk tijdslot of afzonderlijke tijdvakken te cre\u00ebren voor verschillende regio's.",
            'How-different-regions_tooltip': '',
            'How-different-regions_question':
                "Hoe kan ik mijn beschikbaarheid in verschillende regio's op dezelfde dag aangeven?",
            'How-different-regions_answer':
                "\nGelieve meerdere regio's te selecteren binnen \u00e9\u00e9n beschikbaarheidsslot. We zullen alle geselecteerde regio's overwegen gedurende uw aangewezen uren binnen dat tijdvak.",
            'How-register-regions_tooltip': '',
            'How-register-regions_question':
                "Hoe registreer ik de regio('s) waarin ik zal werken?",
            'How-register-regions_answer':
                "\nGelieve een of meerdere regio's te selecteren binnen de sectie 'district' in uw beschikbaarheidsinstellingen.",
            'How-appointment-assigned_tooltip': '',
            'How-appointment-assigned_question':
                'Hoe wordt een afspraak aan mij toegewezen?',
            'How-appointment-assigned_answer':
                "Binnen uw geselecteerde regio's en werkuren wordt rekening gehouden met de gekoppelde kalender(s). Elk beschikbaar tijdvak van minimaal 1 uur en 30 minuten wordt beschouwd als 'beschikbaar'.\n\nBij het boeken van een afspraak ziet de klant alle beschikbaarheden voor de komende week op basis van hun adres. De klant kan een tijdvak van 1 uur en 30 minuten kiezen.\n\nValt dit gekozen tijdvak binnen uw beschikbaarheid? Indien ja, wordt het verzoek aan u toegewezen. Bevestig de afspraak uiterlijk 24 uur vna het ontvangen van de uitnodiging. Neem contact op met de klant om uw exacte aankomsttijd binnen dit tijdvak te delen.\n\nNotabene: Deze beschikbaarheden blijven anoniem; de klant zal niet weten welke beschikbaarheden zijn gekoppeld aan welke expert.",
            'Forgot-confirmation_tooltip': '',
            'Forgot-confirmation_question':
                '\nIk heb de afspraak niet bevestigd binnen 24 uur na ontvangst van de melding, maar ik zou toch graag de waardering willen uitvoeren. Wat moet ik doen?',
            'Forgot-confirmation_answer':
                'Gelieve rechtstreeks contact met ons op te nemen via support@rock.estate. Indien er geen andere schatter is toegewezen, kunt u nog steeds de waardering bevestigen.',
            'Optimize-appointments_tooltip': '',
            'Optimize-appointments_question':
                '\nHoe kan ik mijn dag optimaliseren? Bijvoorbeeld, ik heb twee afspraken van elk 1 uur en 30 minuten geboekt, maar de locaties liggen heel dicht bij elkaar en ik wil graag sneller bij de tweede afspraak zijn.',
            'Optimize-appointments_answer':
                'U heeft de vrijheid om uw bezoek te organiseren binnen het tijdvak van 1 uur en 30 minuten, mits u de klant op de hoogte stelt. Bijvoorbeeld, u kunt uw eerste bezoek uitvoeren in de laatste 30 minuten van het oorspronkelijke tijdvak en uw tweede bezoek in de eerste 30 minuten van het daaropvolgende tijdvak.',
            'Where-view-appointments_tooltip': '',
            'Where-view-appointments_question':
                'Waar kan ik de lijst van mijn afspraken vinden?',
            'Where-view-appointments_answer':
                "U kunt naar uw instellingen gaan en het tabblad 'Afspraken' selecteren. Daarnaast kunt u uw dashboard controleren om uitstaande en bevestigde verzoeken te bekijken.",
            'Where-confirm_tooltip': '',
            'Where-confirm_question':
                '\nWaar kan ik de afspraken vinden die ik moet bevestigen?',
            'Where-confirm_answer':
                "U kunt naar uw instellingen gaan en het tabblad 'Afspraken' selecteren. Daarnaast kunt u uw dashboard controleren om uitstaande en bevestigde verzoeken te bekijken.",
            'Flood-zones_tooltip': '',
            'Flood-zones_question':
                'Waar komt de data over overstromingsgebieden vandaan?',
            'Flood-zones_answer':
                '\nOnze overstromingszones zijn gebaseerd op open Geodata en regionale kaarten.',
            'Parcel-area_tooltip': '',
            'Parcel-area_question': 'Hoe wordt de totale perceeloppervlakte berekend?',
            'Parcel-area_answer':
                '\nHet totale perceeloppervlak is gebaseerd op open Geodata (kadastrale gegevens).',
            'Building-footprint_tooltip': '',
            'Building-footprint_question':
                'Hoe wordt de oppervlakte van het gebouw berekend?',
            'Building-footprint_answer':
                '\nDe voetafdruk van het gebouw is gebaseerd op open Geodata (kadastrale gegevens).',
            'Garden-area_tooltip': '',
            'Garden-area_question': 'Hoe wordt de oppervlakte van de tuin berekend?',
            'Garden-area_answer':
                '\nHet tuinoppervlak wordt berekend door de voetafdruk van het gebouw af te trekken van het perceeloppervlak.',
            'Living-area_tooltip': '',
            'Living-area_question': 'Hoe wordt de bewoonbare oppervlakte berekend?',
            'Living-area_answer':
                "\nDe bewoonbare oppervlakte die door de bankagent wordt verstrekt, is afgeleid van het EPC-certificaat. Het vertegenwoordigt de 'bruto' bewoonbare oppervlakte, exclusief binnenmuren en vergelijkbare structuren.",
            'Approximate-Living-area_tooltip': '',
            'Approximate-Living-area_question':
                'Hoe wordt de geschatte bewoonbare oppervlakte berekend?',
            'Approximate-Living-area_answer':
                '\nWe schatten de bewoonbare oppervlakte van een huis op basis van het volume en de structuur ervan. Het volume wordt bepaald aan de hand van 3D Lidar-scans van het pand.',
            'Different-living-area_tooltip': '',
            'Different-living-area_question':
                'Waarom komt de geschatte bewoonbare oppervlakte niet overeen met de bewoonbare oppervlakte?',
            'Different-living-area_answer':
                'We hebben het pand niet bezocht, en het is puur gebaseerd op schatting. We schatten de bewoonbare oppervlakte van een huis op basis van het volume en de structuur ervan. Het volume wordt bepaald aan de hand van 3D Lidar-scans van het pand.',
            'EPC-certificate_tooltip': '',
            'EPC-certificate_question': 'Waar kan ik het EPC-certificaat vinden?',
            'EPC-certificate_answer':
                "\nAls de bankagent het EPC-certificaat heeft ge\u00fcpload, kunt u het bekijken in de waarderingstool. Ga naar het tabblad 'Algemene informatie', en u zult het vinden in de sectie 'Status'.",
            'Market-value_tooltip': '',
            'Market-value_question': 'Hoe wordt de marktwaarde berekend?',
            'Market-value_answer':
                '\nOnze marktwaarde wordt berekend door middel van een op vergelijkingen gebaseerd geautomatiseerd waarderingsmodel (CBAVM), afgekort als AVM. Met behulp van een adres en kenmerken van het onroerend goed identificeren we automatisch de (200-250) meest vergelijkbare panden in onze dataset. Ons model vergelijkt al deze panden met Geographically Weighted Regression (GWR). GWR is een vorm van lineaire regressie die ruimtelijke informatie incorporeert en hogere gewichten toekent aan nabijgelegen huizen bij het schatten van de prijs.',
            'Forced-sale-value_tooltip': '',
            'Forced-sale-value_question':
                'Hoe wordt de gedwongen verkoopwaarde berekend?',
            'Forced-sale-value_answer':
                'Deze schatting verrekent doorgaans tussen de 10% en 40% van de geschatte transactieprijs, afhankelijk van de waargenomen kenmerken.',
            'Monthly-rental-value_tooltip': '',
            'Monthly-rental-value_question':
                'Hoe wordt de maandelijkse huurwaarde berekend?',
            'Monthly-rental-value_answer':
                'De maandelijkse huurwaarde wordt berekend met dezelfde methode als de marktwaarde, maar met overweging van huurprijzen in onze dataset.',
            'Reconstruction-value_tooltip': '',
            'Reconstruction-value_question': 'Hoe wordt de reconstructiewaarde berekend?',
            'Reconstruction-value_answer':
                'De reconstructiewaarde wordt berekend op basis van het volume en de complexiteit van het gebouw.',
            'Reference-points_tooltip': '',
            'Reference-points_question':
                'Waar komen de gegevens voor de referentiepunten vandaan?',
            'Reference-points_answer':
                '\nMomenteel zijn onze gegevensreferentiepunten afkomstig van advertenties op portaalsites. Houd er rekening mee dat de weergegeven prijzen vraagprijzen vertegenwoordigen, geen transactieprijzen. In de nabije toekomst zullen we ook beschikbare transactieprijzen opnemen in deze dataset.',
        },
        questions_feedback: {
            explanation_1:
                'Heeft u een specifieke vraag of opmerking over dit rapport? Of bent u gewoon op zoek naar wat meer informatie over hoe Rock.estate tot deze waardering komt?',
            explanation_1_tooltip: '',
            explanation_2: "Bezoek ons waarderingsportaal: {url}.valuation_app{'.'}",
            explanation_2_tooltip: '',
        },
        punctuation: {
            ':': ':',
            ':_tooltip': '',
        },
        status: {
            draft: 'Ontwerp',
            draft_tooltip: '',
            submitted: 'Ingediend',
            submitted_tooltip: '',
            completed: 'Voltooid',
            completed_tooltip: '',
            valued: 'Gewaardeerd',
            valued_tooltip: '',
            'awaiting-onsite': 'On-site expertise vereist',
            'awaiting-onsite_tooltip': '',
            cancelled: 'Geannuleerd',
            cancelled_tooltip: '',
            canceled: 'Geannuleerd',
            canceled_tooltip: '',
            pending_confirmation: 'Wachten op bevestiging van expert',
            pending_confirmation_tooltip: '',
            failed: 'Gefaald',
            failed_tooltip: '',
            confirmed: 'De expert heeft de afspraak bevestigd',
            confirmed_tooltip: '',
        },
        renovation_info: {
            title: 'Renovatie offertes',
            title_tooltip: '',
            add_document: 'Document toevoegen',
            add_document_tooltip: '',
            unlink_document: 'Document loskoppelen',
            unlink_document_tooltip: '',
            link_document: 'Document koppelen',
            link_document_tooltip: '',
            items: '{n} item|{n} items',
            items_tooltip: '',
            linked_items: '{n} gekoppeld item|{n} gekoppelde items',
            linked_items_tooltip: '',
        },
        renovation_item: {
            title: 'Titel',
            title_tooltip: '',
            amount: 'Bedrag',
            amount_tooltip: '',
            category: 'Categorie',
            category_tooltip: '',
            subcategory: 'Subcategorie',
            subcategory_tooltip: '',
            modal_title: 'Bewerk renovatie item',
            modal_title_tooltip: '',
        },
        renovation_category: {
            energy: 'Energie',
            energy_tooltip: '',
            structural: 'Structureel',
            structural_tooltip: '',
            aesthetic: 'Esthetisch',
            aesthetic_tooltip: '',
            other: 'Overige',
            other_tooltip: '',
        },
        renovation_subcategory: {
            insulation: 'Isolatie',
            insulation_tooltip: '',
            solar_panel: 'Zonnepaneel',
            solar_panel_tooltip: '',
            heating: 'Verwarming',
            heating_tooltip: '',
            other: 'Andere',
            other_tooltip: '',
            wall_extension: 'Muuruitbreiding',
            wall_extension_tooltip: '',
            demolition: 'Slopen',
            demolition_tooltip: '',
            kitchen: 'Keuken',
            kitchen_tooltip: '',
            bathroom: 'Badkamer',
            bathroom_tooltip: '',
        },
        steps: {
            customer_ref: 'Klantreferentie',
            customer_ref_tooltip: '',
            building_type: 'Type woning',
            building_type_tooltip:
                'Gaat het om een \u00e9\u00e9ngezinswoning of een appartement?',
            address: 'Adres',
            address_tooltip: '',
            address_confirmation: 'Adres bevestiging',
            address_confirmation_tooltip:
                'Om de kosten-baten van renovaties te schatten verzamelen we de nodige informatie over het gebouw, bv. de helling, oppervlakte, en ori\u00ebntatie van het dak voor zonnepanelen.',
            building_selection: 'Gebouw',
            building_selection_tooltip: '',
            house_info: 'Woning informatie',
            house_info_tooltip: '',
            building_dimensions: 'Afmetingen gebouw',
            building_dimensions_tooltip: '',
            epc: 'EPC',
            epc_tooltip: '',
            construction_year: 'Bouwjaar',
            construction_year_tooltip:
                'Het jaar waarin de woning officieel gebouwd werd. Dit houdt geen rekening met eventuele renovaties op een later tijdstip. Deze info is doorgaans te vinden in de verkoopadvertentie, het referentie bouwjaar in het EPC attest of de kadastrale legger.',
            living_area: 'Bewoonbare oppervlakte',
            living_area_tooltip:
                'De totale bewoonbare oppervlakte van de woning op basis van verwarmde vloeroppervlakte. Normaliter wordt de kelder dus niet meegeteld, en de zolder enkel in geval dit een verwarmde kamer is. Deze info is doorgaans te vinden in de advertentie van de woning of de bruikbare vloeroppervlakte in het EPC attest.',
            energy_performance: 'Energieprestatie',
            energy_performance_tooltip: '',
            insulation: 'Isolatie',
            insulation_tooltip: '',
            wall_insulation: 'Muren',
            wall_insulation_tooltip: '',
            roof_insulation: 'Dak',
            roof_insulation_tooltip: '',
            floor_insulation: 'Vloer',
            floor_insulation_tooltip: '',
            window_glazing: 'Ramen',
            window_glazing_tooltip: '',
            attic: 'Zolder',
            attic_tooltip: '',
            basement: 'Kelder',
            basement_tooltip: '',
            energy_consumption: 'Consumptie',
            energy_consumption_tooltip: '',
            heating: 'Verwarming',
            heating_tooltip: '',
            electricity_consumption: 'Elektriciteitsverbruik',
            electricity_consumption_tooltip: '',
            gas_consumption: 'Gas verbruik',
            gas_consumption_tooltip: '',
            oil_consumption: 'Stookolie verbruik',
            oil_consumption_tooltip: '',
            coal_consumption: 'Kool verbruik',
            coal_consumption_tooltip: '',
            wood_consumption: 'Hout verbruik',
            wood_consumption_tooltip: '',
            pellets_consumption: 'Pellets verbruik',
            pellets_consumption_tooltip: '',
            district_heating_consumption: 'Warmtedistributie/stadsverwarming',
            district_heating_consumption_tooltip: '',
            solar_panels: 'Zonnepanelen',
            solar_panels_tooltip: '',
            ventilation: 'Ventilatie',
            ventilation_tooltip: '',
            consumers: 'Verbruikers',
            consumers_tooltip: '',
            big_consumers: 'Grote verbruikers',
            big_consumers_tooltip: '',
            electric_vehicles: 'Elektrische wagens',
            electric_vehicles_tooltip: '',
            processing: 'Berekenen',
            processing_tooltip: '',
            finish: 'Afronden',
            finish_tooltip: '',
        },
        property_type: {
            apartments: 'Appartementen',
            apartments_tooltip: '',
            coming_soon:
                'De tool werkt nog niet voor appartementen. Dat is voor binnenkort!',
            coming_soon_tooltip: '',
            select_type: 'Vul het adres hier in',
            select_type_tooltip: '',
            title: 'Bevestig het type vastgoed',
            title_tooltip: '',
        },
        out_of_bounds_page: {
            title: 'We hebben geen gegevens gevonden voor dit adres',
            title_tooltip: '',
            '3d_model_not_found_subtitle':
                'Met nog een paar vragen kunnen we de afmetingen van het gebouw benaderen. Laten we beginnen!',
            '3d_model_not_found_subtitle_tooltip': '',
            '3d_model_not_found':
                'Het lijkt erop dat we het 3D-model van dit gebouw niet kunnen vinden',
            '3d_model_not_found_tooltip': '',
            content_tooltip: '',
            button: 'Probeer een ander adres',
            button_tooltip: '',
            ing_button: 'Keer terug naar de ING website',
            ing_button_tooltip: '',
        },
        terms_page: {
            welcome: 'n/a',
            welcome_tooltip: '',
            epc: 'n/a',
            epc_tooltip: '',
            disclaimer: 'n/a',
            disclaimer_tooltip: '',
        },
        features_question: {
            insulated_floors: 'Zijn de vloeren ge\u00efsoleerd?',
            insulated_floors_tooltip: '',
            insulated_roof: 'Is het dak ge\u00efsoleerd?',
            insulated_roof_tooltip: '',
            insulated_walls: 'Zijn de muren ge\u00efsoleerd?',
            insulated_walls_tooltip: '',
            has_attic: 'Heeft u een zolder?',
            has_attic_tooltip: '',
            insulation_floors_when:
                'Wanneer vond de meest recente verbetering in isolatie plaats?',
            insulation_floors_when_tooltip: '',
            insulation_roof_when:
                'Wanneer vond de meest recente verbetering in isolatie plaats?',
            insulation_roof_when_tooltip: '',
            insulation_walls_when:
                'Wanneer vond de meest recente verbetering in isolatie plaats?',
            insulation_walls_when_tooltip: '',
            has_basement: 'Is er een kelder?',
            has_basement_tooltip: '',
            is_attic_heated: 'Is de zolderruimte verwarmd?',
            is_attic_heated_tooltip: '',
            last_floor_renovation_tooltip: '',
            last_wall_renovation_tooltip: '',
            last_roof_renovation_tooltip: '',
            enter_epc_label: 'Selecteer het offici\u00eble EPC-label',
            enter_epc_label_tooltip: '',
            enter_epc_score: 'Voer hier het offici\u00eble EPC-score in',
            enter_epc_score_tooltip: '',
            epc_type_tooltip: '',
            epc_known: 'Kent u de offici\u00eble EPC score van de woning?',
            epc_known_tooltip:
                'Het Energie Prestatie Co\u00ebfficient (EPC) is de energiescore van een woning. Deze info is doorgaans te vinden in de verkoopadvertentie en in het EPC certificaat. De EPC score wordt uitgedrukt in kWh/m2jaar. Op basis van de EPC score krijgt elk gebouw een EPC label toegekend. Afhankelijk van de regio kan dit label gaan van A++ tot G.',
            consumption_known_no_tooltip: '',
            consumption_known_yes_tooltip: '',
            epc_known_yes_tooltip: '',
            epc_known_no_tooltip: '',
            select_heating_fuel: 'Selecteer de hoofdbrandstof voor verwarming',
            select_heating_fuel_tooltip: '',
            ventilation_type: 'Welk type ventilatiesysteem heeft de woning?',
            ventilation_type_tooltip: '',
            ventilation_subtype: 'Welk type ventilatiesysteem heeft de woning?',
            ventilation_subtype_tooltip: '',
            n_residents: 'Hoeveel personen leven in de woning?',
            n_residents_tooltip: '',
            protected_consumer: 'n/a',
            protected_consumer_tooltip: '',
            heating_consumption_approx:
                'Geef ons een schatting van uw verbruik voor verwarming',
            heating_consumption_approx_tooltip: '',
            electric_consumption_approx:
                'Geef ons een schatting van uw elektriciteitsverbruik',
            electric_consumption_approx_tooltip: '',
            installation_year: 'Wanneer werd dit ge\u00efnstalleerd?',
            installation_year_tooltip: '',
            heater: 'Welk type verwarming heeft u?',
            heater_tooltip: '',
            energy_consumption_known_tooltip: '',
            consumption_known: 'Kent u uw huidig energievebruik?',
            consumption_known_tooltip:
                'U kan deze informatie opzoeken op uw meest recente energiefactuur, of door de meterstanden te vergelijken. Opgelet, wij houden rekening met jaarlijkse waardes. Mogelijks dient u de waarde op de factuur om te rekenen naar een jaarlijkse verbruik.',
            yearly_electricity_consumption: 'Kent u uw huidig elektriciteitsvebruik?',
            yearly_electricity_consumption_tooltip:
                'U kan deze informatie opzoeken op uw meest recente elektriciteteitsfactuur, of door de meterstanden te vergelijken. Opgelet, wij houden rekening met jaarlijkse waardes. Mogelijks dient u de waarde op de factuur om te rekenen naar een jaarlijkse verbruik.',
            yearly_electricity_consumption_subtitle:
                'Het jaarlijkse elektriciteitsverbruik verwijst naar het totaal aan kWh van het net geconsumeerd in een jaar.\nHoud dus geen rekening met elektriciteit die u eventueel zelf opwekt.',
            yearly_electricity_consumption_subtitle_tooltip: '',
            yearly_fuel_consumption: 'Kent u uw jaarlijks vebruik aan brandstof?',
            yearly_fuel_consumption_tooltip:
                'U kan deze informatie opzoeken op uw meest recente factuur aan brandstof of door de meterstanden te vergelijken. Opgelet, wij houden rekening met jaarlijkse waardes. Mogelijks dient u de waarde op de factuur om te rekenen naar een jaarlijkse verbruik.',
            yearly_heating_consumption: 'Kent u uw jaarlijks vebruik voor verwarming?',
            yearly_heating_consumption_tooltip: '',
            f_construction_year: 'In welk jaar werd de woning gebouwd?',
            f_construction_year_tooltip: '',
            f_living_area: 'Wat is de bewoonbare oppervlakte van de woning?',
            f_living_area_tooltip:
                'De totale bewoonbare oppervlakte van de woning. Deze info is doorgaans te vinden in de advertentie van de woning of de bruikbare vloeroppervlakte in het EPC attest.',
            approx_living_area:
                'Op basis van het 3D-model schatten we de bewoonbare oppervlakte van de woning op <b class="has-text-primary">{area} m\u00b2</b>. Gelieve de eigenlijke bewoonbare oppervlakte in te geven indien u die kent.',
            approx_living_area_tooltip: '',
            solar_panels: 'Zijn er zonnepanelen aanwezig?',
            solar_panels_tooltip: '',
            insulated_windows: 'Welk hoofdtype beglazing heeft de woning?',
            insulated_windows_tooltip:
                'U kan het type beglazing opzoeken in technische documentatie van de woning, zoals in facturen van de plaatsing van ramen. Indien dit er niet is, kunnen volgende tips helpen. Voor alle types dubbele beglazing kan u de code gemarkeerd op de strip aan de binnenkant van het raam opzoeken op de website van de producent. Als dat niet lukt, kan standaard dubbele beglazing herkend worden aan de aluminium strip tussen de twee glasplaten. Hoogrendementsbeglazing is vaak te herkennen aan de letters "HR", "HR+" of "HR++". Driedubbele beglazing wordt gemarkeerd met "HR+++" aan de binnenkant van het raamstrip.',
            insulated_single_renovated:
                'Werd er betere isolatie geplaatst na het bouwen?',
            insulated_single_renovated_tooltip: '',
            insulated_plural_renovated:
                'Werd er betere isolatie geplaatst na het bouwen?',
            insulated_plural_renovated_tooltip: '',
            consumption_title_tooltip: '',
            consumption_yearly_consumption_tooltip: '',
            gas_consumption_known: 'Kent u uw jaarlijks gasverbruik?',
            gas_consumption_known_tooltip: '',
            oil_consumption_known: 'Kent u uw jaarlijks mazoutverbruik?',
            oil_consumption_known_tooltip: '',
            wood_consumption_known: 'Kent u uw jaarlijks hout verbruik?',
            wood_consumption_known_tooltip: '',
            coal_consumption_known: 'Kent u uw jaarlijks kool verbruik?',
            coal_consumption_known_tooltip: '',
            pellets_consumption_known: 'Kent u uw jaarlijks verbruik aan pellets?',
            pellets_consumption_known_tooltip: '',
            district_heating_consumption_known:
                'Kent u uw jaarlijks verbruik aan stadsverwarming?',
            district_heating_consumption_known_tooltip: '',
            electricity_consumption_known: 'Kent u uw jaarlijks elektriciteitsverbruik?',
            electricity_consumption_known_tooltip: '',
            gas_consumption_approx: 'Hoe zou u uw gasverbruik inschatten?',
            gas_consumption_approx_tooltip: '',
            oil_consumption_approx: 'Hoe zou u uw mazoutverbruik inschatten?',
            oil_consumption_approx_tooltip: '',
            wood_consumption_approx: 'Hoe zou u uw verbruik aan hout inschatten?',
            wood_consumption_approx_tooltip: '',
            coal_consumption_approx: 'Hoe zou u uw verbruik aan kolen inschatten?',
            coal_consumption_approx_tooltip: '',
            pellets_consumption_approx: 'Hoe zou u uw verbruik aan pellets inschatten?',
            pellets_consumption_approx_tooltip: '',
            district_heating_consumption_approx:
                'Hoe zou u uw verbruik aan stadsverwarming inschatten?',
            district_heating_consumption_approx_tooltip: '',
            electricity_consumption_approx:
                'Hoe zou u uw elektriciteitsverbruik inschatten?',
            electricity_consumption_approx_tooltip: '',
            enter_value: 'Vul hier de waarde in.',
            enter_value_tooltip: '',
        },
        map_page: {
            '3d_model':
                'Op basis van dit adres hebben we een vereenvoudigd 3D model van de woning gegenereerd. Zo kunnen we de nodige informatie berekenen zoals de aangrezende muren van het gebouw, muuroppervlaktes, en de helling van het dak.',
            '3d_model_tooltip': '',
        },
        address_page: {
            title: 'Vul het adres in om de 3D afmetingen van dit gebouw op te halen.',
            title_tooltip: '',
            subtitle:
                'Elk gebouw is uniek. Via het adres kunnen we renovaties afstemmen op de specifieke kenmerken van het gebouw.',
            subtitle_tooltip: '',
            control_address: 'Vervolledig het adres indien nodig',
            control_address_tooltip: '',
        },
        validation: {
            range: 'Gelieve een getal in te voeren tussen {min} en {max}',
            range_tooltip: '',
            field_required: 'Dit veld is verplicht',
            field_required_tooltip: '',
            only_numbers: 'Gelieve enkel cijfers in te vullen',
            only_numbers_tooltip: '',
            min_4_characters: 'Dit veld vereist min. 4 karakters',
            min_4_characters_tooltip: '',
            wrong_epc: 'Gelieve een correct EPC label in te geven',
            wrong_epc_tooltip: '',
            valid_years: 'Tussen {min} en {max}',
            valid_years_tooltip: '',
            value_too_small: 'Het aantal is te klein',
            value_too_small_tooltip: '',
            value_too_large: 'Het aantal is te groot',
            value_too_large_tooltip: '',
        },
        f_epc: {
            label: 'EPC label',
            label_tooltip: '',
        },
        features_page: {
            title:
                'We hebben bijkomende informatie nodig om de energie performantie van de woning te begrijpen.',
            title_tooltip: '',
        },
        consumption_page: {
            title: 'Kan u ons meer informatie geven omtrent uw energieverbruik?',
            title_tooltip: '',
            info_tooltip: '',
            big_consumer: 'Heeft u een elektrische of hybride wagen?',
            big_consumer_tooltip: '',
        },
        login_page: {
            login: 'Login',
            login_tooltip: '',
        },
        wall_insulation_page: {
            info_tooltip: '',
        },
        roof_insulation_page: {
            info_tooltip: '',
        },
        building_dimensions_page: {
            is_flat: 'is plat',
            is_flat_tooltip: '',
            title_tooltip: '',
            subtitle_tooltip: '',
            floors_title_tooltip: '',
            floors_info_tooltip: '',
            roof_title_tooltip: '',
            tooltip_roof_type_tooltip: '',
            roof_pitched_tooltip: '',
            roof_flat_tooltip: '',
            roof_mixed_tooltip: '',
            facades_title_tooltip: '',
            tooltip_common_facades_tooltip: '',
            facades_type_0_tooltip: '',
            facades_type_1_tooltip: '',
            facades_type_2_tooltip: '',
        },
        welcome_page: {
            title: 'Energetische renovaties voor woonhuizen simuleren',
            title_tooltip: '',
            text_welcome: 'Welkom!',
            text_welcome_tooltip: '',
            text_intro:
                'Met de energetische renovatie simulator komt u erachter welke renovaties het meest geschikt zijn om de energiescore van een woning te verlagen.\n',
            text_intro_tooltip: '',
            text_description:
                'We starten met een schatting van de huidige EPC-score van het residenti\u00eble pand. Op basis daarvan kan u de meest kosteneffici\u00ebnte energiebesparende verbouwingen simuleren om uw renovatiedoel te realiseren.',
            text_description_tooltip: '',
            'info-bubble':
                'Energetische renovatie simulaties werken <b>enkel voor residenti\u00eble huizen. </b>',
            'info-bubble_tooltip': '',
            button_start: 'Simulatie starten',
            button_start_tooltip: '',
            terms: 'voorwaarden',
            terms_tooltip: '',
            curious:
                'Wat zijn de slimste renovaties om het energieverbruik van uw woning te verbeteren?',
            curious_tooltip: '',
        },
        error_page: {
            title: 'Er liep iets mis',
            title_tooltip: '',
            intro:
                'De service is momenteel niet beschikbaar. Probeer het later nog eens.',
            intro_tooltip: '',
            button: 'Terug naar de ING website',
            button_tooltip: '',
        },
        insulation: {
            title: 'Hoe is de isolatie van de woning?',
            title_tooltip: '',
        },
        consumption: {
            gas_consumption_title: 'Gasverbruik',
            gas_consumption_title_tooltip: '',
            oil_consumption_title: 'Mazoutverbruik',
            oil_consumption_title_tooltip: '',
            wood_consumption_title: 'Verbruik aan hout',
            wood_consumption_title_tooltip: '',
            coal_consumption_title: 'Verbruik aan kolen',
            coal_consumption_title_tooltip: '',
            pellets_consumption_title: 'Verbruik aan pellets',
            pellets_consumption_title_tooltip: '',
            district_heating_consumption_title: 'Verbruk aan stadsverwarming',
            district_heating_consumption_title_tooltip: '',
            electricity_consumption_title: 'Elektriciteitsverbruik',
            electricity_consumption_title_tooltip: '',
        },
        consumers_page: {
            info_tooltip: '',
            title: 'Geef ons meer informatie over uw energieverbruik.',
            title_tooltip: '',
        },
        ventilation_page: {
            ventilation_title: 'Ventilatie',
            ventilation_title_tooltip: '',
        },
        energy_quizz: {
            solar: {
                qa: {
                    q:
                        'Volgens onze data is dit de beste manier om zonnepanelen te plaatsen. Gaat u hiermee akkoord?',
                    q_tooltip: '',
                    a1: 'Ja, ik ga akkoord',
                    a1_tooltip: '',
                    a2: 'Neen, dit is niet de zijde waarop het meeste zonlicht valt',
                    a2_tooltip: '',
                    a3: 'Neen, dit is niet de juiste oppervlakte',
                    a3_tooltip: '',
                },
                qb: {
                    q:
                        'U duidde aan dat u zonnepanelen heeft. Wij schatten dat er {x} zonnepanelen op het dak passen. Gaat u hiermee akkoord?',
                    q_tooltip: '',
                    a1: 'Ja, ik ga akkoord',
                    a1_tooltip: '',
                    a2: 'Neen, dat is niet mogelijk.',
                    a2_tooltip: '',
                    a3:
                        'Ja, maar we hebben beslist voor een ander aantal panelen te gaan.',
                    a3_tooltip: '',
                },
            },
            q1: {
                q: 'Welke stelling over zonnepanelen is correct?',
                q_tooltip: '',
                a1: 'Zonnepanelen hebben een gemiddelde terugverdientijd van 15 jaar. ',
                a1_tooltip: '',
                f1:
                    'Dat is niet juist. De gemiddelde terugverdientijd is 6-8 jaar. Het juiste antwoord is 2.',
                f1_tooltip: '',
                a2:
                    'Zonnepanelen verlagen de EPC score van de woning. Een lagere EPC score betekent een hogere waarde van de woning. ',
                a2_tooltip: '',
                f2: 'Super, dat is juist.',
                f2_tooltip: '',
                a3: 'Zonnepanelen kunnen niet ingezet worden om water te verwarmen.',
                a3_tooltip: '',
                f3:
                    'Dat is niet juist. Er zijn 2 manieren om water met zonnepanelen te verwarmen: via een zonneboiler of door de waterpomp aan te sturen met zonne-energie. Het juiste antwoord is 2.',
                f3_tooltip: '',
            },
            q2: {
                q:
                    'Wat is de juiste volgorde van renovaties om de energie effici\u00ebntie van een woning te verbeteren?',
                q_tooltip: '',
                a1: 'Muren - dak - ramen - vloeren - verwarming',
                a1_tooltip: '',
                f1: 'Dat is niet juist. Het juiste antwoord is 2.',
                f1_tooltip: '',
                a2: 'Dak - muren - ramen - vloeren - verwarming',
                a2_tooltip: '',
                f2: 'Super, dat is juist.',
                f2_tooltip: '',
                a3: 'Dak - muren - vloeren - ramen - verwarming',
                a3_tooltip: '',
                f3: 'Dat is niet juist. Het juiste antwoord is 2.',
                f3_tooltip: '',
                a4: 'Muren - dak - ramen - verwarming - vloeren',
                a4_tooltip: '',
                f4: 'Dat is niet juist. Het juiste antwoord is 2.',
                f4_tooltip: '',
            },
            q3: {
                q:
                    'Wat kan u doen wanneer u meer zonne-energie cre\u00ebert dan verbruikt?',
                q_tooltip: '',
                a1: 'Niets. Die gaat verloren.',
                a1_tooltip: '',
                f1:
                    'Dat is niet juist. Er zijn interessante manieren om alles uit zonne-energie te halen. Het juiste antwoord is 3.',
                f1_tooltip: '',
                a2: 'Alle energie opslaan voor wanneer u het nodig heeft',
                a2_tooltip: '',
                f2:
                    'Dat is niet juist. U kan een batterij opladen met zonne-energie, maar niet alle stroom kan voor onbepaalde tijd worden opgeslagen. Het juiste antwoord is 3.',
                f2_tooltip: '',
                a3:
                    'Verkoop de overbodige energie, zoals aan een energie-leverancier of retailer',
                a3_tooltip: '',
                f3: 'Super, dat is juist.',
                f3_tooltip: '',
            },
            q4: {
                q:
                    'Wat is geen goede manier om de gas rekening te verlagen zonder renovatiewerken?',
                q_tooltip: '',
                a1:
                    'Plaats aluminium folie tussen radiatoren en niet-ge\u00efsoleerde buitenmuren',
                a1_tooltip: '',
                f1:
                    'Dat is niet juist. Folie tussen radiatoren en niet-ge\u00efsoleerde buitenmuren vermindert het warmteverlies. Het is een goede manier om het gasverbruik te verminderen. Het juiste antwoord is 3.',
                f1_tooltip: '',
                a2:
                    'Isoleer leidingen die lopen tussen de verwarmingsketel naar de radiatoren in kelder of zolder',
                a2_tooltip: '',
                f2:
                    'Dat is niet correct. Leidingen isoleren die lopen in ruimtes die u niet verwarmt is een goede manier om minder gas te verbruiken omdat dit het warmteverlies vermindert. Het juiste antwoord is 3.',
                f2_tooltip: '',
                a3: 'Verwarm met een elektrische radiator',
                a3_tooltip: '',
                f3:
                    'Super, dat is juist. Een elektrische verwarming is een grote energie-verbruiker. Dit kost niet alleen veel geld, maar het heeft ook een negatieve impact op het milieu.',
                f3_tooltip: '',
            },
            q5: {
                q: 'Welke maatregel vermindert de CO2-uitstoot van een woning het meest?',
                q_tooltip: '',
                a1: 'Gebruik geen droogkast',
                a1_tooltip: '',
                f1: 'Dat is niet juist. Het juiste antwoord is 2.',
                f1_tooltip: '',
                a2: 'Installeer vloerverwarming',
                a2_tooltip: '',
                f2: 'Super, dat is juist.',
                f2_tooltip: '',
                a3: 'Douch om de twee dagen',
                a3_tooltip: '',
                f3: 'Dat is niet juist. Het juiste antwoord is 2.',
                f3_tooltip: '',
            },
            q6: {
                q: 'Welke stelling is niet juist?',
                q_tooltip: '',
                a1: 'Vloerisolatie spaart meer energie dan muurisolatie',
                a1_tooltip: '',
                f1: 'Super, dat is juist.',
                f1_tooltip: '',
                a2: 'Dakisolatie spaart meer CO2- uitstoot dan zonnepanelen',
                a2_tooltip: '',
                f2:
                    'Dat is niet juist. Dakisolatie is beter om CO2-uitstoot te verminderen dan zonnepanelen. Het juiste antwoord is 1.',
                f2_tooltip: '',
                a3:
                    'Ramen vervangen heeft een grotere impact dan een nieuw verwarmingssysteem installeren',
                a3_tooltip: '',
                f3:
                    'Dat is niet juist. De kwaliteit van de ramen verbeteren kan meer energie sparen dan een nieuw verwarmingssysteem installeren. Het juiste antwoord is 1.',
                f3_tooltip: '',
            },
            discovery_phase: 'Ontdekkingsfase',
            discovery_phase_tooltip: '',
            discovery_description:
                'Goed gedaan! U bent op weg om alles over energie te ontdekken. Blijf nieuwsgierig en blijf leren hoe u energie kunt besparen.',
            discovery_description_tooltip: '',
            learning_phase: 'Leerfase',
            learning_phase_tooltip: '',
            learning_description:
                'Doe zo voort! U heeft kennis over hoe u uw woning energie effici\u00ebnt maakt. Blijf leren en nieuwe manieren vinden om uw huis energie-zuinig te maken.',
            learning_description_tooltip: '',
            expert_phase: 'Expert fase',
            expert_phase_tooltip: '',
            expert_description:
                'Proficiat! U bent een expert wanneer het gaat om uw huis energie-zuinig te maken. Tijd om dit een realiteit te maken!',
            expert_description_tooltip: '',
        },
        ers_report: {
            language: 'NL',
            language_tooltip: '',
            header_title: 'De huidige energie effici\u00ebntie',
            header_title_tooltip: '',
            header_subtitle:
                'Op basis van de gegeven informatie hebben wij de huidige EPC-score gesimuleerd. Dit vervangt geen offici\u00eble EPC-score.*',
            header_subtitle_tooltip: '',
            header_subtitle_pdf:
                'Op basis van de gegeven informatie hebben wij de huidige EPC-score gesimuleerd. Dit vervangt geen offici\u00eble EPC-score.*',
            header_subtitle_pdf_tooltip: '',
            epc_graph_title: 'De geschatte huidige EPC score is {x}*',
            epc_graph_title_tooltip: '',
            epc_graph_subtitle:
                'Zoals u ziet op het histogram hebben {x}% van de woningen in {region} een beter EPC label.',
            epc_graph_subtitle_tooltip: '',
            consumption_title: 'Verbruik',
            consumption_title_tooltip: '',
            gas_title: 'Gas',
            gas_title_tooltip: '',
            electric_title: 'Elektriciteit',
            electric_title_tooltip: '',
            low_title: 'Laag',
            low_title_tooltip: '',
            high_title: 'Hoog',
            high_title_tooltip: '',
            average_title: 'Gemiddeld',
            average_title_tooltip: '',
            you_title: 'Uw',
            you_title_tooltip: '',
            current_epc: 'Huidige EPC score',
            current_epc_tooltip: '',
            future_epc: 'Toekomstige EPC score',
            future_epc_tooltip: '',
            summary_input_title: 'Samenvatting invoer',
            summary_input_title_tooltip: '',
            summary_title: 'Samenvatting',
            summary_title_tooltip: '',
            summary_note:
                'De prijzen en subsidies hieronder zijn indicatief. Prijzen zijn inclusief BTW.**',
            summary_note_tooltip: '',
            price_title: 'Prijs',
            price_title_tooltip: '',
            subsidy_title: 'Subs.',
            subsidy_title_tooltip: '',
            after_subsidy_title: 'Na subs.',
            after_subsidy_title_tooltip: '',
            total_title: 'Totaal',
            total_title_tooltip: '',
            calculate_button_text: 'Bereken mijn ING lening',
            calculate_button_text_tooltip: '',
            download_report: 'Download mijn rapport',
            download_report_tooltip: '',
            renovation_title: 'Uw Renovatie Doelstelling',
            renovation_title_tooltip: '',
            renovation_subtitle:
                'Wat is uw renovatie doelstelling? Selecteer een renovatie pakket om te ontdekken welke renovaties de meest effici\u00ebnte zijn om dit doe te bereiken. Of, selecteer renovatie opties om te ontdekken met welke EPC score ze overeenkomen.',
            renovation_subtitle_tooltip: '',
            renovation_price: 'Prijs',
            renovation_price_tooltip: '',
            renovation_subsidy: 'Subsidie',
            renovation_subsidy_tooltip: '',
            renovation_area: 'Oppervlakte',
            renovation_area_tooltip: '',
            renovation_insulation_type: 'Type isolatie',
            renovation_insulation_type_tooltip: '',
            renovation_yearly: 'Jaarlijkse besparing',
            renovation_yearly_tooltip: '',
            renovation_windowsDouble: 'Beglazing',
            renovation_windowsDouble_tooltip: '',
            renovation_wallExt: 'Buitenmuur',
            renovation_wallExt_tooltip: '',
            renovation_wallCav: 'Spouwmuur ',
            renovation_wallCav_tooltip: '',
            renovation_roofIn: 'Binnenkant dak',
            renovation_roofIn_tooltip: '',
            renovation_roofExt: 'Buitenkant dak',
            renovation_roofExt_tooltip: '',
            renovation_roofIn_attic_floor: 'Zoldervloer',
            renovation_roofIn_attic_floor_tooltip: '',
            renovation_condGas: 'Ketel',
            renovation_condGas_tooltip: '',
            renovation_heatPump: 'Warmtepomp',
            renovation_heatPump_tooltip: '',
            renovation_ventC: 'Ventilatie type C',
            renovation_ventC_tooltip: '',
            renovation_solar: 'Zonnepanelen',
            renovation_solar_tooltip: '',
            compliance_pack_title: 'Goed begin',
            compliance_pack_title_tooltip: '',
            compliance_pack_desc:
                'Ik wil voldoen aan de wettelijke voorwaarden omtrent EPC score in Vlaanderen.',
            compliance_pack_desc_tooltip: '',
            budget_pack_title: 'Groen budget',
            budget_pack_title_tooltip: '',
            budget_pack_desc:
                'Ik wil een budget van x euro optimaliseren aan energetische renovaties',
            budget_pack_desc_tooltip: '',
            lowest_pack_title: 'BENovatie',
            lowest_pack_title_tooltip: '',
            lowest_pack_desc:
                'Ik wil een volledig energetisch renovatietraject voor de woning.',
            lowest_pack_desc_tooltip: '',
            custom_pack_title: 'Gepersonaliseerd pakket',
            custom_pack_title_tooltip: '',
            custom_pack_desc: 'Ik wil mijn eigen combinatie aan renovaties samenstellen',
            custom_pack_desc_tooltip: '',
            add_remove_renovations: 'Renovaties toevoegen of verwijderen',
            add_remove_renovations_tooltip: '',
            submit_button_budget: 'Indienen',
            submit_button_budget_tooltip: '',
            already_compilance:
                'Super! Uw woning voldoet reeds aan de wettelijke voorwaarden vanaf 2023 in Vlaanderen. Klik op de andere paketten om te ontdekken wat u nog meer kan doen.',
            already_compilance_tooltip: '',
            no_renovation_found:
                'Geen renovaties gevonden. Gelieve een groen budget in te geven.',
            no_renovation_found_tooltip: '',
            renovation_subtitle_compliance_pdf:
                'Proficiat met uw Goede Begin! Met een budget van {amount} euro kan de EPC score van de woning verbeteren van een EPC score {current_epc_score} naar een EPC score {future_epc_score}.\n\nHieronder vind u het meest energie-effici\u00ebnte pakket dat u zal helpen dit doel te behalen evenals uw jaarlijkse besparingen en een idee van mogelijk subsidies.\n\nVoor meer informatie over subsidies kan u de volgende websites bezoeken:\n- Voor Vlaanderen, ga naar https://www.mijnbenovatie.be/nl/wat-waarom/benovatiepremies-2022/\n- Voor Walloni\u00eb, ga naar https://energie.wallonie.be/fr/primes.html?IDC=7015\n- Voor Brussel, ga naar https://renolution.brussels/nl',
            renovation_subtitle_compliance_pdf_tooltip: '',
            renovation_subtitle_budget_pdf:
                'Proficiat met uw Groen Budget! Uw renovatiedoel is om een budget van {amount}} euro te optimaliseren. Deze investering kan de EPC score van uw woning verbeteren van een EPC score {current_epc_score}} naar een EPC score {future_epc_score}.\n\nHieronder vindt u het meest energie-effici\u00ebnte pakket dat u zal helpen dit doel te behalen evenals uw jaarlijkse besparingen en een idee van mogelijk subsidies.\n\nVoor meer informatie over subsidies kan u de volgende websites bezoeken:\n- Voor Vlaanderen, ga naar https://www.mijnbenovatie.be/nl/wat-waarom/benovatiepremies-2022/\n- Voor Walloni\u00eb, ga naar https://energie.wallonie.be/fr/primes.html?IDC=7015\n- Voor Brussel, ga naar https://renolution.brussels/nl',
            renovation_subtitle_budget_pdf_tooltip: '',
            renovation_subtitle_custom_pdf:
                'Proficiat met uw gepersonaliseerd pack! Met een budget van {amount} euro kan de EPC score van uw woning verbeteren van een EPC score {current_epc_score} naar een EPC score {future_epc_score}.\n\nHieronder vind u het meest energie-effici\u00ebnte pakket dat u zal helpen dit doel te behalen evenals uw jaarlijkse besparingen en een idee van mogelijk subsidies.\n\nVoor meer informatie over subsidies kan u de volgende websites bezoeken:\n- Voor Vlaanderen, ga naar https://www.mijnbenovatie.be/nl/wat-waarom/benovatiepremies-2022/\n- Voor Walloni\u00eb, ga naar https://energie.wallonie.be/fr/primes.html?IDC=7015\n- Voor Brussel, ga naar https://renolution.brussels/nl',
            renovation_subtitle_custom_pdf_tooltip: '',
            disclaimer: {
                title: 'Disclaimer',
                title_tooltip: '',
                body1:
                    'De schatting van de huidige EPC score is gebaseerd op de verstrekte informatie in de vragenlijst, in combinatie met data over het gebouw en technische eisen zoals vastgelegd in de offici\u00eble EPC software. Hoe correcter de doorgegeven informatie, des te accurater de simulatie is. ',
                body1_tooltip: '',
                body2: 'De simulatie vervangt geen officieel EPC certificaat.',
                body2_tooltip: '',
                body3: 'Het is alleen bedoeld voor informatieve doeleinden.',
                body3_tooltip: '',
                body4: 'De',
                body4_tooltip: '',
                body5: 'prijzen in dit rapport zijn indicatief',
                body5_tooltip: '',
                body6:
                    'en moeten worden beschouwd als schattingen. De werkelijke kosten kunnen vari\u00ebren afhankelijk van de toestand van het huis, specifieke projectdetails en andere factoren.',
                body6_tooltip: '',
                body7:
                    'Enkel een gecertifieerd energie expert kan een offici\u00ebel EPC-certificaat uitgeven. Raadpleeg een gekwalificeerde professional op het relevante gebied voor een gedetailleerde kostenraming.',
                body7_tooltip: '',
            },
            disclaimer_body:
                '*De schatting van de huidige EPC score is gebaseerd op de verstrekte informatie in de vragenlijst, in combinatie met data over het gebouw en technische eisen zoals vastgelegd in de offici\u00eble EPC software. Hoe correcter de doorgegeven informatie, des te accurater de simulatie is. De simulatie vervangt geen officieel EPC certificaat. Raadpleeg steeds een professional voor gepersonaliseerd advies. \n**Prijzen zijn inclusief 6% BTW of 21 % BTW afhankelijk van de leeftijd van het huis en het type renovatie. Wij updaten prijzen en subsidies op een regelmatige basis. Afhankelijk van wanneer u de simulator gebruikt, kan de uitkomst daarom verschillen. Het rapport vermeldt welke werken inbegrepen zijn in de renovatieprijs. Enige bijkomende werken die nodig zijn voor renovatie zijn niet inbegrepen in de vermelde prijs. Raadpleeg steeds een professional voor gepersonaliseerd advies. ',
            disclaimer_body_tooltip: '',
            disclaimer_body_pdf:
                '*De schatting van de huidige EPC score is gebaseerd op de verstrekte informatie in de vragenlijst, in combinatie met data over het gebouw en technische eisen zoals vastgelegd in de offici\u00eble EPC software. Hoe correcter de doorgegeven informatie, des te accurater de simulatie is. De simulatie vervangt geen officieel EPC certificaat. Raadpleeg steeds een professional voor gepersonaliseerd advies. \n**Prijzen zijn inclusief 6% BTW of 21 % BTW afhankelijk van de leeftijd van het huis en het type renovatie. Wij updaten prijzen en subsidies op een regelmatige basis. Afhankelijk van wanneer u de simulator gebruikt, kan de uitkomst daarom verschillen. Het rapport vermeldt welke werken inbegrepen zijn in de renovatieprijs. Enige bijkomende werken die nodig zijn voor renovatie zijn niet inbegrepen in de vermelde prijs. Raadpleeg steeds een professional voor gepersonaliseerd advies. ',
            disclaimer_body_pdf_tooltip: '',
            property_page: {
                title: 'De geschatte stijging in marktwaarde ',
                title_tooltip: '',
                subtitle:
                    'We schatten de stijging in marktwaarde door marktprijzen te vergelijken van panden met EPC-scores die de huidige en beoogde EPC-score benaderen. Houd er rekening mee dat dit een automatische berekening is die de huidige marktomstandigheden weerspiegelt. Voor een offici\u00eble post-renovatie waardebepaling van uw woning is het aangeraden om een gecertificeerde schatter te raadplegen.',
                subtitle_tooltip: '',
                info_bubble:
                    'Met een EPC-score van {future_epc} kWh/m\u00b2 wordt de stijging van de huidige marktwaarde ingeschat op {val}',
                info_bubble_tooltip: '',
                section_title: 'Uw energetische besparingen',
                section_title_tooltip: '',
                epc_title: 'Verlaging in EPC score',
                epc_title_tooltip: '',
                epc_text:
                    'Dit getal vertegenwoordigt de totale verbetering in EPC-score van uw woning na uitvoering van het energetische renovatieplan. In de praktijk geeft dit aan hoeveel kWh u jaarlijks bespaart om een constante temperatuur van 18\u00b0C per vierkante meter te behouden. Vermenigvuldig dit met het totale verwarmde vloeroppervlak om te weten hoeveel kWh u in totaal bespaart. Het is belangrijk op te merken dat de werkelijke verbetering kan vari\u00ebren afhankelijk van factoren zoals de keuze van technologie\u00ebn en isolatiematerialen voor de renovatie.',
                epc_text_tooltip: '',
                carbon_title: 'Vermindering CO\u2082 uitstoot',
                carbon_title_tooltip: '',
                carbon_text:
                    'Dit is de hoeveelheid kilogram aan koolstofemissies die u jaarlijks kunt besparen dankzij dit renovatieplan. Energetische renovaties verlagen de afhankelijkheid van fossiele brandstoffen om uw apparaten te gebruiken, kamers en sanitair water te verwarmen. Dit cijfer gaat ervan uit dat uw huishouden zijn energie consumptiegedrag niet verandert na renovaties.',
                carbon_text_tooltip: '',
                bill_title: 'Besparing op energiefactuur',
                bill_title_tooltip: '',
                bill_text:
                    "Dit is de mogelijke maandelijkse besparing op uw energiefactuur in euro's, gebaseerd op het jaarlijkse energieverbruik dat werd ingevuld. We actualiseren regelmatig de energieprijzen. Houd er rekening mee dat deze geschatte besparingen ervan uitgaan dat u niet meer energie zou verbruiken na renovaties. Werkelijke besparingen kunnen vari\u00ebren door prijsschommelingen en veranderingen in het energieverbruik van het huishouden.",
                bill_text_tooltip: '',
            },
            renovation: {
                title: {
                    gtk: 'Goed om te weten',
                    gtk_tooltip: '',
                    works: 'Wat is inbegrepen?',
                    works_tooltip: '',
                    subsidies: 'Subsidies en premies',
                    subsidies_tooltip: '',
                },
                roofIn: {
                    gtk:
                        'Het dak is de voornaamste bron van warmteverlies in een gebouw. Het is dus aangeraden om te beginnen met het dak te isoleren. Dakisolatie langs binnen is eenvoudiger te installeren en goedkoper in vergelijking met isolatie langs de buitenkant. Houd er rekening mee dat de isolatie een deel van de zolderruimte zal innemen. Dakisolatie langs de buitenkant verkleint de ruimte dan weer niet, en biedt effici\u00ebntere isolatie. De kosten vari\u00ebren op basis van het type dak en de gebruikte materialen. Gebruikt u de zolderruimte niet als verwarmde ruimte, overweeg dan om de zoldervloer te isoleren. ',
                    gtk_tooltip: '',
                    works:
                        'verwijdering van de aangetaste isolatielaag (inclusief dampscherm), installatie van een nieuwe isolatielaag en dampscherm, en aanpassingen rond het dakvlak en de dakkapel.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/nl/de-renolution-premies-2023,\nhttps://renolution.brussels/nl/premies-stimuli/e3-dak-thermische-dakisolatie',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-dak',
                        subsidies_tooltip: '',
                    },
                },
                roofExt: {
                    gtk:
                        'Het dak is de voornaamste bron van warmteverlies in een gebouw. Het is dus aangeraden om te beginnen met het dak te isoleren. Dakisolatie langs de buitenkant heeft het voordeel dat dit de ruimte onder het dak niet verkleint, de woning minder bevuilt en bewoonbaar blijft tijdens de werken. Ook laat het toe om voor de dikste isolatie te kiezen. Isolatie langs buiten is echter een duurdere optie dan langs de binnenkant van het dak. De totale kost hangt af van het type dak en de gebruikte materialen. Dakisolatie langs de buitenkant is een goede keuze voor een plat dak, of wanneer u de ruimte onder het dak als verwarmde kamer gebruikt. ',
                    gtk_tooltip: '',
                    works:
                        'slopen van dakbedekking en -structuur, slopen van dakgoten, aanbrengen van isolatie en een dampscherm, plaatsen van dakstructuur en -bedekking, werken rond dakventilatieopeningen, plaatsen van dakgoten, verwijderen en opnieuw installeren van zonnepanelen indien reeds aanwezig en een kraan of lift.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/nl/de-renolution-premies-2023,\nhttps://renolution.brussels/nl/premies-stimuli/e3-dak-thermische-dakisolatie',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-dak',
                        subsidies_tooltip: '',
                    },
                },
                atticFloor: {
                    gtk:
                        'Het dak is de voornaamste bron van warmteverlies in een gebouw. Het is dus aangeraden om te beginnen met het dak te isoleren. Als de zolderruimte niet gebruikt wordt als verwarmde kamer, kan zoldervloerisolatie een kosteneffici\u00ebnte keuze zijn om warmteverlies via het dak tegen te gaan. Het is veel goedkoper in vergelijking met dakisolatie. Dit komt voornamelijk door de kleinere te isoleren oppervlakte en minimale of geen benodigde afwerking. Het installatieproces verloopt relatief snel en eenvoudig. Dit is echter niet de beste keuze indien u in de toekomst de zolderruimte als verwarmde kamer wilt benutten.',
                    gtk_tooltip: '',
                    works:
                        'installatie van isolatie en dampscherm, aanpassingen aan bestaande leidingen en verlichting, en aanpassing van de toegang.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/nl/de-renolution-premies-2023,\nhttps://renolution.brussels/nl/premies-stimuli/h1-vloeren-thermische-vloerisolatie',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-vloer',
                        subsidies_tooltip: '',
                    },
                },
                wallExt: {
                    gtk:
                        'Na dakisolatie is het aangeraden om de muren te isoleren. Gevelisolatie langs de buitenzijde biedt het voordeel dat u geen leefruimte verliest en het huis bewoonbaar blijft tijdens de werkzaamheden. Het helpt ook om geluiden van buiten te reduceren. Ga steeds na of de woning geschikt is voor buitenmuurisolatie. Gezien de esthetische kenmerken van de gevel veranderen zijn er mogelijks vereisten voor een bouwvergunning, bijvoorbeeld als u een historisch pand renoveert. Houd hier dus rekening mee.',
                    gtk_tooltip: '',
                    works:
                        'regenwaterafvoer afbreken, dorpels afzagen, isolatie aanbrengen, afwerkingen plaatsen (in crepi), openingen bijwerken (inclusief dorpels), aanpassingen uitvoeren, dakoverstek vergroten, regenwaterafvoer vernieuwen en een steiger.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/nl/de-renolution-premies-2023,\nhttps://renolution.brussels/nl/premies-stimuli/f1-gevels-thermische-gevelisolatie',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-buitenmuur',
                        subsidies_tooltip: '',
                    },
                },
                wallIn: {
                    gtk:
                        'Na het isoleren van het dak is het aan te raden om verder te gaan met muurisolatie. In tegenstelling tot buitenmuurisolatie heeft binnenmuurisolatie bepaalde beperkingen. Het kan de leefruimte verkleinen omdat het aan de binnekant van het huis wordt ge\u00efnstalleerd. Over het algemeen is het echter een meer kosteneffectieve optie in vergelijking met externe isolatie. Het is belangrijk om te weten dat veel isolatiematerialen een brandwerende bekleding vereisen, omdat ze giftige gassen kunnen afgeven wanneer ze worden blootgesteld aan vuur.',
                    gtk_tooltip: '',
                    works:
                        'slopen van plinten en vensterbanken, aanbrengen van isolatie met dampscherm en ventilatieroosters, aanbrengen van afwerklagen inclusief nieuwe plinten en vensterbanken, verwijderen en vervangen van verwarmingselementen met elektriciteitsaanpassingen.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/nl/de-renolution-premies-2023,\nhttps://renolution.brussels/nl/premies-stimuli/f1-gevels-thermische-gevelisolatie',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-buitenmuur',
                        subsidies_tooltip: '',
                    },
                },
                wallCav: {
                    gtk:
                        'Nadat het dak werd ge\u00efsoleerd is het aangeraden om de muren te isoleren. Niet alle gevels hebben een spouw. Ga dus na of het gebouw spouw- of massieve muren heeft. Spouwmuurisolatie kan uitstekende thermische isolatie bieden tegen een betaalbare prijs. Wees echter bewust van mogelijke problemen zoals condensatie en schimmelvorming. Als de woning zich in een gebied met veel windgedreven regen bevindt, overweeg dan alternatieven om vochtgerelateerde problemen te voorkomen.',
                    gtk_tooltip: '',
                    works:
                        'gebruik van een hoogtewerker, installatie van 5 cm minerale wolisolatie inclusief inspectie, voorbereiding, inblazen en sluiten van de openingen.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/nl/de-renolution-premies-2023,\nhttps://renolution.brussels/nl/premies-stimuli/f1-gevels-thermische-gevelisolatie',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-buitenmuur',
                        subsidies_tooltip: '',
                    },
                },
                windowsDouble: {
                    gtk:
                        "Oude ramen dragen tot zo'n 30% bij aan het warmteverlies van een woning. Upgraden naar energie-effici\u00ebnte ramen, zoals hoogrendement dubbele of driedubbele beglazing met luchtdicht schrijnwerk, kan de isolatie aanzienlijk verbeteren. Als u van plan bent de gevels te isoleren, is het is aangeraden om dit te doen alvorens of tegelijk met de installatie van nieuwe ramen. Een bijkomend voordeel van nieuwe ramen is dat deze beter beveiligd zijn dankzij een extra glaslaag. Hierdoor zijn ze beter bestand tegen glasbreuk.",
                    gtk_tooltip: '',
                    works:
                        'slopen en plaatsen van glas (met toeslag voor hijsapparatuur), slopen en plaatsen van het kozijn, plaatsen van RTO op het glas, en slopen en plaatsen van het glas.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/nl/de-renolution-premies-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/g1-portes-et-fenetres-exterieures-placement-et-remplacement-de-portes-et-fenetres,\nhttps://renolution.brussels/nl/premies-stimuli/g2-buitenschrijnwerk-herstelling-en-aanpassing-van-ramen',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-ramen-en-deuren',
                        subsidies_tooltip: '',
                    },
                },
                condGas: {
                    gtk:
                        "Gascondensatieketels zijn ontworpen om warmte te onttrekken aan de uitlaatgassen die tijdens het verbrandingsproces worden geproduceerd.  **De levensduur van een gascondensatieketel is zo'n 15 jaar.** Door de onttrokken warmte te gebruiken om water voor te verwarmen is de effici\u00ebnte hoger dan die van een klassieke ketel. Gascondensatieketels hebben een positieve impact op de EPC score van een woning. Ze werken het effici\u00ebntst als de muren, dak en ramen goed ge\u00efsoleerd zijn. Overweeg om uw huis te isoleren alvorens een nieuw verwarmingssysteem te installeren voor het beste resultaat.",
                    gtk_tooltip: '',
                    works:
                        'sloop van de bestaande generator, installatie van een condensatieketel op gas, koppeling met de bestaande generator, extra kosten voor het vervangen van het klimaatsysteem, isolatie van niet-ge\u00efsoleerde leidingen.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://www.ores.be/autorites-publiques/primes-et-avantages-financiers,\nhttps://www.resa.be/fr/nos-services/les-primes/',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-gascondensatieketel-tot-en-met-31-oktober-2023',
                        subsidies_tooltip: '',
                    },
                },
                heatPump: {
                    gtk:
                        'Warmtepompen onttrekken energie uit de lucht, grond of grondwater om een ruimte te verwarmen of te koelen. Een beter ge\u00efsoleerde woning verliest minder warmte en heeft bijgevolg een minder zware pomp nodig. Daardoor is de prijs van een warmtepomp lager in combinatie met andere energetische renovaties. Een warmtepomp vermindert de afhankelijkheid van fossiele brandstoffen en aldus de koolstofemissies van uw verbruik. Er bestaan verschillende soorten warmtepompen, zoals geothermische, lucht-lucht, lucht/water en hybride systemen. Prijzen vari\u00ebren afhankelijk van het specifieke type warmtepomp.',
                    gtk_tooltip: '',
                    works:
                        'sloop van de bestaande generator, installatie van een warmtepomp (met grondwater; inclusief boren), aansluiten op de bestaande generator en isoleren van niet-ge\u00efsoleerde leidingen. Voor het vervangen van het klimaatsysteem gelden extra kosten.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/nl/de-renolution-premies-2023,https://renolution.brussels/nl/premies-stimuli/j4-verwarming-verwarming-met-warmtepomp,https://renolution.brussels/nl/premies-stimuli/j9-verwarming-warmtepompboiler',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-warmtepomp\n',
                        subsidies_tooltip: '',
                    },
                },
                unitPv: {
                    gtk:
                        'Zonnepanelen kunnen een kosteneffectieve manier zijn om de EPC-score te verbeteren en de energiefactuur te verlagen. Het is echter aangeraden eerst het dak, muren, beglazing en verwarming te renoveren. De effici\u00ebntie van zonnepanelen hangt af van meerdere factoren zoals oppervlakte, ori\u00ebntatie en schaduw op het dak. In bepaalde gevallen heeft u een vergunning nodig om zonnepanelen te installeren, bijvoorbeeld als de woning in het architecturaal erfgoedregister staat.',
                    gtk_tooltip: '',
                    works:
                        'de plaatsing van zonnepanelen inclusief all accessoires.                 ',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/carte-dynamique-de-la-wallonie.html?IDC=6185&IDD=144019',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.fluvius.be/nl/thema/premies/premies-voor-huishoudelijke-klanten/premie-zonnepanelen,\nhttps://www.vlaanderen.be/premie-van-fluvius-voor-zonnepanelen-op-gebouwen',
                        subsidies_tooltip: '',
                    },
                },
                works: {
                    lead_in: 'De totale investeringskosten zijn inclusief: ',
                    lead_in_tooltip: '',
                },
                ceiling: {
                    gtk:
                        'Het dak is de voornaamste bron van warmteverlies in een gebouw. Het is dus aangeraden om te beginnen met het dak te isoleren. In dit scenario wordt het platte gedeelte van het dak ge\u00efsoleerd vanaf het plafond. Het is belangrijk dat u de haalbaarheid van deze optie bespreekt met een vakman om thermische bruggen en condensatie te vermijden.  Dakisolatie langs binnen is eenvoudiger te installeren en goedkoper in vergelijking met isolatie langs de buitenkant. De kosten vari\u00ebren op basis van het type dak en de gebruikte materialen.  ',
                    gtk_tooltip: '',
                    works:
                        'afbraakwerken plafond, plaatsen van isolatie en dampscherm, afwerking van plafond, aanpassingen aan bestaande leidingen en verlichting',
                    works_tooltip: '',
                },
                mixed: {
                    gtk:
                        'Het dak is de voornaamste bron van warmteverlies in een gebouw. Het is dus aangeraden om te beginnen met het dak te isoleren. Het is niet mogelijk om platte daken van de binnenkant te isoleren. In dit scenario wordt het platte gedeelte van het dak ge\u00efsoleerd vanaf het plafond en het schuine gedeelte vanaf de binnenkant van het dak. Het is belangrijk dat u de haalbaarheid van deze optie bespreekt met een vakman om thermische bruggen en condensatie te vermijden. Dakisolatie langs binnen is eenvoudiger te installeren en goedkoper in vergelijking met isolatie langs de buitenkant. Houd er rekening mee dat de isolatie een deel van de zolderruimte zal innemen. De kosten vari\u00ebren op basis van het type dak en de gebruikte materialen. Gebruikt u de zolderruimte niet als verwarmde ruimte, overweeg dan om de zoldervloer te isoleren.  ',
                    gtk_tooltip: '',
                    works:
                        'Voor plafondisolatie: afbraakwerken plafond, plaatsen van isolatie en dampscherm, afwerking van plafond, aanpassingen aan bestaande leidingen en verlichting\nVoor dakisolatie langs binnenkant: verwijdering van de aangetaste isolatielaag (inclusief dampscherm), installatie van een nieuwe isolatielaag en dampscherm, en aanpassingen rond het dakvlak en de dakkapel.',
                    works_tooltip: '',
                },
                subsidies: {
                    lead_in: 'Voor meer informatie over subsidies en premies, ga naar',
                    lead_in_tooltip: '',
                },
            },
            title1: 'De',
            title1_tooltip: '',
            title2: 'renovatieanalyse',
            title2_tooltip: '',
            title3_tooltip: '',
            title4: 'van uw woning',
            title4_tooltip: '',
            per_year: 'per jaar',
            per_year_tooltip: '',
            per_month: 'per maand',
            per_month_tooltip: '',
        },
        processing_page: {
            title_started: 'Uw simulatie wordt verwerkt',
            title_started_tooltip: '',
            title_finished: 'Uw simulatie is klaar!',
            title_finished_tooltip: '',
            title_failed: 'Er ging iets mis met uw simulatie',
            title_failed_tooltip: '',
            title_pending_long:
                'Uw simulatie staat in de wachtrij. U zal het resultaat naar verwachting binnen <i>{waiting} minuten</i> ontvangen. Dank u voor uw geduld!',
            title_pending_long_tooltip: '',
            title_pending_medium:
                "Uw simulatie wordt momenteel verwerkt. Het resultaat zal in zo'n <i>{waiting} seconden</i> beschikbaar zijn.",
            title_pending_medium_tooltip: '',
            title_pending_short:
                'We verzamelen de gegevens. Uw resultaten zullen zo <i>dadelijk</i> beschikbaar zijn!',
            title_pending_short_tooltip: '',
            subtitle:
                'Wij zijn de gegevens aan het verwerken. Test intussen uw kennis omtrent energie effici\u00ebnt wonen met onze quiz!',
            subtitle_tooltip: '',
            ing_button: 'Ga terug naar ING ',
            ing_button_tooltip: '',
            check_results: 'Bekijk de resultaten',
            check_results_tooltip: '',
            results_ready: 'Uw resultaten zijn klaar!',
            results_ready_tooltip: '',
            something_went_wrong: 'Er ging iets mis met uw simulatie',
            something_went_wrong_tooltip: '',
        },
        customer_ref_page: {
            title: 'Wat is de interne referentie van de klant?',
            title_tooltip: '',
            tooltip: 'Hiermee wordt de link gelegd tussen de simulatie en de klant',
            tooltip_tooltip: '',
        },
        valuer_tool: {
            global: {
                'en-BE': 'Engels',
                'fr-BE': 'Frans',
                'nl-BE': 'Nederlands',
                photos: "Foto's",
                plans: 'Plannen',
                val_submitted: 'Waardering ingediend!',
                val_saved: 'Waardering opgeslagen!',
            },
            sidebar: {
                summary: {
                    title: 'Samenvatting',
                    lang: 'Taal',
                    epc_score: 'EPC Score',
                },
                save_val: {
                    label: 'Waardering opslaan',
                    sub: 'Wordt niet ingediend',
                },
                submit_val: 'Waardering indienen',
            },
            borrower: {
                language: 'Taal van de kredietnemer',
                appointment: {
                    warning_modal:
                        'Voordat u op <b>\u201cVolgende\u201d</b> klikt na het kiezen van een datum en tijd, zorg er voor dat iemand de expert toegang kan verlenen tot het pand op het geplande afspraakmoment. <b>U zal de geselecteerde tijdslot niet meer kunnen wijzigen na deze stap.</b> Blijkt u toch een verkeerd tijdslot te hebben geselecteerd, ga dan door met de aanvraag tot na de betaling. Zodra u een bevestigingsmail hebt ontvangen, neemt u contact met ons op en we plannen het opnieuw in.',
                },
                'billing-address-button': 'Factuur aanvragen',
                'billing-address-text':
                    'Als u een factuur nodig hebt, kunt u contact met ons opnemen door op de onderstaande knop te klikken. Ons team zal u snel helpen bij het genereren van de benodigde documentatie voor uw administratie.',
                overview: 'Overzicht',
                access_property_warning:
                    'Zorg ervoor dat iemand de expert toegang kan verlenen tot het pand op het geplande afspraakmoment.',
                valuer_appointments: {
                    edit: 'Afspraak bewerken',
                    'title-no-appointments': 'Geen aanstaande afspraken',
                    title: 'Afspraak',
                },
                valuer_info: {
                    title: 'Accountinstellingen',
                    description:
                        'In dit overzicht kunt u de gegevens van uw bedrijf instellen om weer te geven in het waarderingsrapport.',
                    'profile_card-title': 'Gegevens van de waarderingsexpert',
                    'accreditation_card-number': 'Accreditatienummer',
                },
                borrower_trans_val: {
                    placeholder: 'Transactiewaarde',
                },
                borrower_email: {
                    placeholder: 'E-mail van de lener',
                },
                set_borrower_language: 'Zorg ervoor dat dit correct is',
                calendar: {
                    message_title: 'Vind u geen geschikt tijdstip?',
                    message_content:
                        'Stuur een e-mail naar support@rock.estate met de referentie van uw verzoek, uw beschikbaarheden en uw telefoonnummer',
                    button: 'Toevoegen aan de kalender',
                    title: 'Ter plaatse waardering Rock.estate',
                },
                'booking-complete': {
                    title: 'Boeking voltooid!',
                    description:
                        'Een bevestigingsmail met de details van uw boeking is naar uw e-mailadres verzonden. Contacteer ons via support@rock.estate om uw afspraak te wijzigen.',
                },
                receipt: {
                    button: 'Bekijk het ontvangstbewijs ',
                },
                report: {
                    button: 'Rapport downloaden',
                },
                'payment-error':
                    'Er is een fout opgetreden tijdens het verwerken van uw betaling. Probeer het opnieuw',
                submitter: {
                    email_question: 'Wat zijn de contactgegevens van de lener?',
                    email_text:
                        'Rock.estate zal een e-mail sturen met een link, waarop de lener kan klikken om een afspraak voor een expertise ter plaatse in te plannen.',
                    transaction_question: 'Wat is de transactieprijs?',
                    transaction_text:
                        'Voer het bedrag (excl. registratierechten/BTW) in dat de kredietnemer betaalt voor de woning. Dit is belangrijk om de kosten van de expertise te bepalen. Het wordt niet\ngedeeld met de schatter.',
                    success_title: 'De boekingslink is onderweg!',
                    success_description:
                        'Rock.estate heeft een e-mail verstuurd met een beveiligde link waarmee de ontvanger\nzijn afspraak voor on-site expertise kan inplannen. Herinner alstublieft uw\nlener eraan om snel een afspraak te maken via deze link.',
                    dashboard_button: 'Terug naar Dashboard',
                },
                'appointment-overview': {
                    title: 'Hier is een overzicht van de door u gekozen afspraaktijd.',
                    'please-share': 'Deel alstublieft de toegangsdetails hieronder.',
                    'will-be-present_question':
                        'Zult u de persoon zijn die de expert toegang geeft tot het pand?',
                    access_representative:
                        'Vraag de persoon die de expert toegang kan geven om ter plaatse te zijn. Dit kan bv. de makelaar zijn, een huurder, of iemand anders die u hiermee vertrouwt. Gelieve hun naam en telefoonnummer te noteren zodat we deze persoon kunnen contacteren indien nodig.',
                    'access_representative-label': 'Vertegenwoordiger',
                    access_description:
                        'Beschrijf alstublieft duidelijk hoe de expert toegang kan krijgen tot het pand.',
                    'access_description-placeholder':
                        "bijv. Bel aan bij bel 27 met de naam 'Dorien De Ridder' erop \nbijv. U kunt de garage betreden met de badge aan de sleutelhanger.",
                },
                'borrower-details': {
                    title:
                        'Om een afspraak in te plannen, vul alstublieft uw contactgegevens in.',
                },
                'confirm-address_unhappy-title':
                    'Er lijkt sprake te zijn van verwarring.',
                'confirm-address_unhappy-description':
                    'Neem contact op met uw leenadviseur als u een onjuiste uitnodiging heeft ontvangen voor een expertiseafspraak ter plaatse.',
                'confirm-address_question':
                    'Bevestigt u dat u een expertise ter plaatse voor dit adres zou willen inplannen?',
                step: {
                    appointment: 'Afspraak',
                    'contact-details': 'Contactgegevens',
                    confirmation: 'Bevestiging',
                    payment: 'Betaling',
                },
                'payment-overview': {
                    title: 'Samenvatting van uw on-site waardering',
                    'agree-with-terms':
                        'Ik ga hierbij akkoord met de algemene voorwaarden.*',
                    'confirm-someone-present':
                        'Ik bevestig hierbij dat er iemand aanwezig zal zijn om de expert toegang te geven tot het pand.',
                    cancel_title: 'Beleid voor het opnieuw plannen en annuleren',
                    cancel_description:
                        'Er worden geen kosten in rekening gebracht voor het verplaatsen of annuleren van afspraken als dit meer dan 24 uur van tevoren gebeurt. Voor wijzigingen binnen 24 uur worden 50% kosten in rekening gebracht en in het geval van een no-show zonder voorafgaande kennisgeving, wordt het volledige bedrag niet terugbetaald. Raadpleeg onze FAQ voor meer informatie.',
                },
                payment: {
                    billing: 'Factuuradres',
                    pay: 'Betalen',
                    method: 'Selecteer een betaalmethode',
                },
                role: {
                    notary: 'Notaris',
                    broker: 'Makelaar',
                    renter: 'Huurder',
                    other: 'Andere',
                    place_holder: 'Kies een rol',
                },
                'appointment-making': {
                    title: 'Boek een afspraak',
                },
            },
            valuer: {
                info: 'Info',
                accreditations: 'Certificering',
                availability: 'Beschikbaarheid',
                appointments: 'Afpsraken',
            },
            reference_listing: {
                assessed: 'Beoordeeld',
                reference: 'Referentie',
                listing_date: 'Publicatiedatum',
                touching_sides: 'Gevels in contact',
                distance: 'Afstand',
                price: 'Prijs',
                price_sqm: 'Prijs/m\u00b2',
                streetnumber: 'Huisnummer',
                use_as_reference: 'Als referentie gebruiken',
                add_to_remarks: 'Toevoegen aan opmerking',
                corrected_price: 'Gecorrigeerde prijs',
                corrected_price_sqm: 'Gecorrigeerde prijs/m2',
                google_maps: 'Bekijk op Google Maps',
            },
            general: {
                title: 'Algemene informatie',
                basic_infos: {
                    title: 'Basis informatie',
                    building_found: 'Gebouw gevonden',
                },
                state: {
                    title: 'Staat',
                    epc_label: 'EPC Label',
                },
                size: {
                    title: 'Afmetingen',
                },
                value: {
                    title: 'Waarde',
                    analytics: {
                        title: 'Analyse',
                        assessed: 'Beoordeeld',
                        median: 'Mediaan',
                        average: 'Gemiddelde',
                        deviance: 'Afwijking',
                    },
                },
                reference_map: {
                    title: 'Referentiekaart',
                },
                reference: {
                    title: 'Referentiepunten',
                    map: {
                        open: 'Open map',
                    },
                },
            },
            exterior: {
                title: 'Exterieur',
                parcel: 'Perceel',
                annexes: 'Bijgebouwen',
                roof_information: 'Dak informatie',
                solar_panel: {
                    question: 'Zijn er zonnepanelen?',
                },
                garage: {
                    name: 'Garage',
                    question: 'Is er een gesloten garage?',
                    area: 'Oppverlakte garage',
                    add: 'Garage toevoegen +',
                },
                parking: {
                    name: 'Parkeerplaats',
                    question: 'Is er een parkeerplaats? ',
                    area: 'Oppervlakte parkeerplaats',
                    add: 'Parkeerplaats toevoegen +',
                },
                barn: {
                    question: 'Is er een schuur?',
                },
                stables: {
                    question: 'Zijn er stallen?',
                },
                pool_house: {
                    question: 'Is er een pool house?',
                },
                swimming_pool: {
                    question: 'Is er een zwembad?',
                },
                garden: {
                    question: 'Is er een tuin?',
                },
                f_balcony_present: {
                    question: 'Is er een terras of balkon?',
                },
                f_cellar_attic_present: {
                    question: 'Is er een kelder of een zolder?',
                },
            },
            interior: {
                title: 'Interieur',
                floors: {
                    floor_mobile_title: 'Int\u00e9rieur - Verdieping {floor}',
                    title: 'Verdiepingen',
                    redirected: 'Doorgestuurd omdat er geen verdiepingen zijn gevonden.',
                    add_floors: 'Verdiepingen toevoegen',
                    add_apt_floors: 'Verdiepingen van appartement toevoegen',
                    floor: 'Verdieping',
                    edit_floors: 'Bewerk verdiepingen',
                    go_to_floor: 'Ruimtes toevoegen',
                    delete_floor: {
                        title: 'Verwijder verdieping',
                        select_transfer:
                            'Selecteer waar u de verwijderde ruimte van de verdieping naartoe wilt verplaatsen',
                        no_transfer:
                            'Verdieping en aangrenzende ruimtes verwijderen zonder ze over te dragen',
                    },
                },
                tabs: {
                    interior: 'Interieur',
                    floors: 'Indeling',
                },
                empty_floors: {
                    title: 'Het lijkt erop dat u nog geen verdiepingen hebt toegevoegd',
                    content:
                        'Voeg verdiepingen toe voordat u ruimtes kunt toevoegen door op de knop te drukken',
                },
                rooms: {
                    title: 'Ruimtes ',
                    generate: 'Genereer ruimtes',
                    add_room: 'Voeg een ruimte toe',
                    edit_room: 'Bewerk ruimte',
                    add_and_new_room: 'Opslaan en extra ruimte toevoegen',
                },
                empty_rooms: {
                    title: 'Het lijkt erop dat u nog geen ruimtes hebt toegevoegd',
                    content: 'Voeg ruimtes toe door op de knop te drukken',
                },
            },
            commons: {
                title: 'Gemeenschappelijke delen',
                certificates: 'EPC gemeenschappelijke delen',
                apartment: {
                    title: 'Eigenschappen appartement',
                },
                costs: {
                    title: 'Gemeenschappelijke kosten',
                    amount: 'Kosten/maand',
                },
                upload: {
                    button_subtitle: 'of drag en drop',
                    button_title: 'Klik om te uploaden',
                    title: '<b>Klik om te uploaden</b><br />of drag en drop',
                    max: '(max {size} mb)',
                },
            },
            surroundings: {
                title: 'Omgeving',
                mobility: 'Mobiliteit',
            },
            valuation: {
                title: 'Waardering',
                value_pre_reno: 'Marktwaarde voor renovatie',
                scheduled_renov: {
                    title: 'Geplande renovaties',
                    comment:
                        'Beschrijf waarvoor het renovatiebudget wordt gebruikt in de "Algemene opmerkingen". U kan de oorspronkelijke invoer van de bankagent vinden door de aanvraag te bekijken via uw Dashboard.',
                    budget: 'Renovatiebudget',
                },
                value_post_reno: 'Verwachte marktwaarde na renovatie',
                estimated_price: 'Geautomatiseerde geschatte waarde',
                reno_adjustment: 'Totale correctie in %',
                comments: 'Algemene opmerkingen op het rapport',
            },
            internal_remarks: {
                title: 'Notities',
                description:
                    'De notities worden niet weergegeven in het waarderingsverslag. Ze zijn alleen bedoeld voor persoonlijke referentiedoeleinden.',
            },
            building_violations: {
                placeholder: 'Beschrijf alstublieft de bouwovertredingen',
                question: 'Zijn er bouwovertredingen?',
                tooltip: 'Schending van de reglementering van de ruimtelijke ordening',
            },
            valuer_summary: {
                'skip-notification': 'Meldingen overslaan',
                'appointment_cancel-btn': 'Afspraak annuleren',
                'appointment_confirm-btn': 'Afspraak bevestigen',
                'payment_post-full': 'Volledige betaling bevestigen',
                appointment_title: 'Overzicht afspraak',
                'appointment_not-yet':
                    'Er is nog geen afspraak gepland voor deze aanvraag',
                status: 'Status:',
                'payment_not-needed': 'Geen extra betaling nodig',
                payment_pending: 'Betaling verwerken...',
                payment_succeeded: 'Betaling succesvol ontvangen',
                payment_cancelled: 'Betaling geannuleerd',
                payment_refunded: 'Betaling teruggestort',
                payment_started: 'Betaling in behandeling',
                payment_null: 'Status betaling: Onbekend',
                'appointment_confirm-cancel':
                    'Weet u zeker dat u deze afspraak wilt annuleren?',
                appointment_cancelled: 'Afspraak is geannuleerd',
                appointment_cancelled_by_valuer: 'Afspraak is geannuleerd door de expert',
                appointment_confirmed: 'De expert heeft de afspraak bevestigd',
                appointment_pending_confirmation: 'Wachten op bevestiging van de expert',
                appointment_new: 'Afspraak is aangemaakt',
            },
            valuer_settings: {
                availability_warning:
                    'U heeft nog geen beschikbaarheden met ons gedeeld. Om het toewijzen van aanvragen mogelijk te maken, verzoeken we u om uw agenda te koppelen en ten minste \u00e9\u00e9n beschikbaarheidsperiode toe te voegen.',
                availability_title: 'Beheer beschikbaarheid',
                'availability_add-button': 'Beschikbaarheidsslot toevoegen',
                availability_districts: 'Arrondissementen',
                availability_delete_ays:
                    'Weet u zeker dat u deze beschikbaarheid wilt verwijderen?',
            },
        },
        monolith: {
            global: {
                delete: 'Verwijder',
                i_understand: 'Ik begrijp het',
                not_available: 'Niet beschikbaar',
                language: 'Taal',
                logout: 'Afmelden',
                login: 'Log in',
                copy: {
                    success: 'Gekopieerd naar klembord!',
                    error:
                        'Er is iets misgegaan, neem contact op met het technische team',
                },
                vat: 'BTW',
                subtotal: 'Totaal excl. btw',
                total: 'Totaal',
                or: 'of',
                description: 'Beschrijving ',
                show_more: 'Meer tonen',
                show_less: 'Minder tonen',
                documents: 'Documenten',
                update: 'Bijwerken',
                full_name: 'Volledige naam',
                first_name: 'Voornaam',
                last_name: 'Achternaam',
                phone: 'Telefoon',
                email: 'E-mail',
            },
            apps: {
                welcome: 'Welkom',
                valuation: {
                    name: 'Vastgoedwaardering',
                    description:
                        'Vraag een waardering aan voor een residenti\u00ebel pand in Belgi\u00eb',
                },
                ers: {
                    name: 'Energetische renovatie simulatie',
                    description:
                        'Simuleer de slimste renovaties om de energie-effici\u00ebntie van een woning te verbeteren',
                },
                dashboard: 'Dashboard',
            },
            shared: {
                apartment: 'Een appartement',
                back: 'Terug',
                customer_ref_conflict: '',
                leave_modal: {
                    cancel: 'Blijf op de pagina',
                    confirm: 'Afsluiten',
                },
                next: 'Volgende',
                previous: 'Vorige',
                report: 'Report',
                saved: 'Data opgeslagen!',
                streetnumber: 'Streetnumber',
                touching_sides: 'Touching sides',
                wrong_value:
                    'Sommige informatie ontbreekt nog of is onverwacht. Wilt u dit onvolledige formulier toch indienen?',
                message: 'Bericht',
                full_address:
                    'Het gebouw op het opgegeven adres kan niet automatisch gevonden worden',
                send: 'Verzenden',
                confirm_before_quit: {
                    title: 'Er zijn niet opgeslagen wijzigingen.',
                    content: 'Wil je opslaan voor je vertrekt?',
                    confirm: 'Afsluiten',
                    cancel: 'Blijf op de pagina',
                    save: 'Opslaan en afsluiten',
                },
                customer_ref: 'Interne referentie',
                address: '',
                customer: '',
                request_ref: 'Aanvraag referentie',
                status_col: 'Status',
                created_at: 'Gecre\u00eberd',
                last_modified: 'Laatst gewijzigd',
                actions: 'Acties',
                owner: 'Aanvrager',
                valuer: 'Vastgoeddeskundige',
                short_lang: 'NL',
                help_me: 'Help me, ik ben geblokkeerd!',
                faq: 'Meer informatie',
                per_page: 'per pagina',
                search: 'Zoeken',
                email_address: '',
                username: '',
                password: '',
                roles: '',
                cancel: 'Annuleren',
                type: 'Type',
                na: 'Niet gespecificeerd',
            },
            building_type: {
                apartment_comment:
                    'Een woonentiteit die deel uitmaakt van een groter gebouw',
                construction_plot: 'Bouwgrond',
                house: 'Een huis',
                house_comment: 'Gebouw met \u00e9\u00e9n enkele woonentiteit',
                new_apartment: 'Nieuwbouw appartement',
                new_house: 'Nieuwbouw woning',
            },
            map: {
                'cannot-find-any-main-parcel': 'Ik kan het hoofdperceel niet vinden',
                'cannot-find-confirm-main-building': 'Dit is niet het juiste gebouw',
                'cannot-find-confirm-main-parcel': 'Dit is niet het hoofdperceel',
                'cannot-find-select-extra-parcels':
                    'Ik kan een aantal percelen niet vinden',
                'cannot-find-select-main-building': 'Ik kan het hoofdgebouw niet vinden',
                'cannot-find-select-main-parcel':
                    'De locatie is correct, maar het perceel zou slechts een deel ervan moeten zijn (b.v. verkaveling)',
                'cannot-find-select-parcels': 'Ik kan sommige percelen niet vinden',
                'cannot-find-select-secondary-buildings':
                    'Ik kan sommige bijgebouwen niet vinden',
                'explanation-confirm-main-parcel': 'Is dit het hoofdperceel?',
                'explanation-select-extra-parcels': 'Selecteer extra percelen',
                'explanation-select-main-building': 'Selecteer het hoofdgebouw',
                'explanation-select-main-parcel': 'Selecteer het hoofdperceel',
                'explanation-select-secondary-buildings':
                    'Selecteer het/de bijgebouw(en)',
                'explanation-view-building-parcels':
                    'Deze gebouw en percelen werden geselecteerd',
                parcel_tooltip: '',
            },
            login: {
                email: 'Uw email',
                login: 'Log In',
                msg: {
                    'email-not-authorized':
                        'Uw emailadres werd niet herkend. Gelieve opnieuw te proberen.',
                    'email-sent': 'We stuurden u een toegangslink naar',
                    'email-sent_message':
                        'Als u geen link heeft ontvangen, kijk dan in uw spam folder.',
                    'email-sent_title': 'Dank u!',
                    'invalid-token':
                        'De toegangslink is niet (langer) geldig. Voer uw emailadres in om een nieuwe link te ontvangen.',
                    logout: 'U bent nu uitgelogd.',
                    'invalid-email-address':
                        'Het lijkt erop dat het ingevoerde e-mailadres ongeldig is',
                    'server-error':
                        'Er is een onverwachte fout opgetreden, probeer het later nog eens',
                    'session-expired':
                        'Uw sessie is verlopen. Voer uw emailadres in om een nieuwe link te ontvangen.',
                    'wrong-environment':
                        'U heeft geen toegang tot deze omgeving. Log in op {env} ',
                },
                title: 'SSO Login',
                welcome:
                    'Gelieve uw emailadres in te geven om toegang te krijgen tot de applicatie.',
            },
            dashboard: {
                hideFullList: 'Toon alleen de toegewezen experts',
                showFullList: 'Toon de volledige lijst van experts',
                specialist: 'Valuation Specialist',
                total: 'Totaal',
                unassigned: 'Niet toegewezen',
                valuers_workload: 'Werkdruk Valuations Specialists',
                my_requests: 'Mijn aanvragen',
                last_month: 'Laatste maand',
                last_year: 'Laatste jaar',
                all_requests: 'Alle aanvragen',
                search_request: 'Aanvraag zoeken',
                review_tooltip:
                    'Deze aanvraag is door een vastgoeddeskundige geanalyseerd en sommige antwoorden moeten worden herzien',
                badges: {
                    resubmitted: 'Opnieuw ingediend',
                    needs_on_site: 'Expertise ter plaatse aanbevolen',
                    needs_borrower_email: '',
                    needs_appointment_confirmation: '',
                    needs_borrower_action: '',
                    appointment_confirmed: '',
                },
                valuer_change_modal: {
                    content:
                        'Dit verzoek is al toegewezen. Bevestigt u dat u de toegewezen expert wilt veranderen? Hierdoor kan de eerder toegewezen expert niet meer aan de aanvraag werken.',
                    actions: {
                        confirm: 'Bevestigen',
                    },
                },
                sub_modal: {
                    content:
                        'Graag nogmaals bevestiging om deze aanvraag over te nemen. De huidige aanvrager zal hiervan een bericht krijgen.',
                },
                title_tooltip: 'Volg hier de status van uw aanvraagen',
                create_report: 'Genereer een verslag',
                download_report: 'Verslag opslaan',
                refresh_report: 'Genereer een nieuw verslag',
                report_loading: 'Verslag is aan het laden',
            },
            sidesteps: {
                house: 'Huis',
            },
            validation: {
                file_too_big: 'Please upload a file under {max_size}MB',
                incoherent_feature: 'Gelieve de waarde in dit veld te controleren',
                renovation_cost_minValue:
                    'Gelieve renovatiekosten hoger dan 10000 in te voeren',
                required: 'Verplicht',
                wrong_epc: 'Gelieve een correct EPC label in te geven',
                floors_not_consecutive:
                    'De geselecteerde verdiepingen zijn niet opeenvolgend',
                renovation_cost_zero_invalid:
                    'Gelieve renovatiekosten hoger dan 0 in te voeren',
            },
            app: {
                session_expiry_warning: {
                    cta: 'Verleng sessie',
                    text: 'Uw sessie zal aflopen in {countdown} seconden.',
                },
            },
            sso_login: {
                welcome: 'Click on the button to log in',
            },
            'multiple-address-modal': {
                title: 'Meerdere adressen voor dit gebouw',
                content: 'Gelieve het juiste adres te selecteren',
            },
            chat: {
                beginning: 'This is the beginning of your chat with',
                bank_agent: 'the bank agent',
                vs: 'the Rock.estate Valuation Specialist',
            },
            'action-buttons': {
                info: 'Info',
                edit: 'Bewerken',
                cancel: 'Annuleren',
                unvalue: 'Waardering ongedaan maken',
                appointment: 'Afspraak',
                'confirm-appointment': 'Bevestig afspraak',
                view_request: 'Bekijk verzoek',
                edit_request: 'Bewerk verzoek',
                dvm: 'DVM',
                ovm: 'Waardering',
                automatic_valuation: 'Automatische waardering',
                web_report: 'Webrapport',
                pdf_report: 'PDF-rapport',
                generate_pdf_report: 'Genereer PDF-rapport',
                regenerate_pdf_report: 'Her-generer PDF-rapport',
                downloading: 'Downloaden...',
                take_ownership: 'Eigenaarschap nemen',
            },
            faq: {
                title: 'Veelgestelde vragen',
                question_1: 'Waarom dien ik dit webformulier in te vullen?',
                answer_1:
                    'ING werkt momenteel samen met Rockestate om een \u200b\u200bnieuwe oplossing voor het waarderen van vastgoed te testen die kan worden gebruikt bij het verlenen van een hypothecair krediet. In de eerste plaats is het de bedoeling om hiermee te beantwoorden aan een aantal nieuwe regels die in voege treden later dit jaar.Verder zal deze oplossing ook bijdragen aan de vereenvoudiging van het transactieproces, aangezien het aantal dossiers waarvoor een expertise ter plaatse vereist is vermoedelijk zal verminderen. Uw deelname aan deze Proof - of -Concept is belangrijk.Het geeft u de kans om mee vorm te geven aan dit nieuwe proces en ervoor te zorgen dat het aan uw behoeften en verwachtingen voldoet.',
                question_2: 'Wanneer dien ik dit webformulier in te vullen?',
                answer_2:
                    'Voor elke nieuwe aanvraag voor een hypothecaire krediet die betrekking heeft op een huis of appartement. Enkel voor nieuwbouw hoeft u voorlopig nog geen formulier invullen.',
                question_3: 'Dien ik dit webformulier ook in te vullen voor renovatie?',
                answer_3:
                    'Ja. Kredietaanvragen met een renovatie component (renovatie of aankoop + renovatie) vallen hier ook onder.',
                question_4:
                    'Moet ik dit webformulier invullen als een expert al ter plaatse gaat?',
                answer_4:
                    'Ja. Kredietaanvragen waarvoor een expert ter plaatse gaat vallen hier ook onder.',
                question_5:
                    'Betekent dit dat de huidige ING-regels inzake expertises gewijzigd zijn?',
                answer_5:
                    'Nee. De bestaande ING-regels blijven van kracht tot nader order.',
                question_6:
                    'Ik heb niet het exacte adres van het gebouw. Wat moet ik doen?',
                answer_6:
                    'De waarde van een huis of appartement is sterk afhankelijk van de ligging. Als u het adres van het gebouw niet correct kunt selecteren, moet u proberen de locatie van het gebouw bij benadering op de kaart te identificeren. Dit helpt ons om beter rekening te houden met de waarde van die specifieke locatie.',
                question_7:
                    'Waarom moet ik de percelen selecteren die betrekking hebben op een huis?',
                answer_7:
                    'De waarde van een woning wordt niet alleen bepaald door het gebouw, maar ook door het omliggende terrein. Om de waarde correct in te schatten, moeten we daarom weten welke percelen deel uitmaken van de eigendom. Doorgaans heeft een huis slechts \u00e9\u00e9n perceel dat we automatisch kunnen identificeren. Indien een huis echter meerdere percelen heeft, dan is het belangrijk dat u die extra percelen op de kaart aangeeft.',
                question_8:
                    'Waar kan ik informatie vinden zoals EPC, bouwjaar, bewoonde oppervlakte, etc.?',
                answer_8:
                    'Als de potenti\u00eble kredietnemer u deze informatie niet meteen kan geven, raden wij u aan hem te helpen deze informatie te vinden door ofwel (i) de online advertentie op een vastgoedportaal (bv. Immoweb, Zimmo, ImmoVlan) te raadplegen, of het te (ii) vragen aan de verkoper of makelaar. Goed om weten: Bij het te koop aanbieden van een huis of appartement is het in principe verplicht om de EPC - waarde in de advertentie vermelden.',
                question_9: 'Ik mis enkele inputparameters. Wat doe ik?',
                answer_9:
                    'Er kunnen zich situaties voordoen waarbij u niet alle vereiste informatie kunt verzamelen. U kunt in dat geval nog steeds een aanvraag indienen. We willen hierbij wel benadrukken dat de kwaliteit van de schatting aanzienlijk zal afnemen als bepaalde inputparameters ontbreken. Daarom is het belangrijk om te proberen alle gevraagde informatie in te voeren waar mogelijk.',
                question_10: 'Kan ik een nieuwe aanvraag indienen voor dezelfde LOP ID?',
                answer_10:
                    'Nee. Dit is momenteel niet mogelijk. Als u een LOP-ID invoert waarvoor al een aanvraag werd ingediend, zal u alle informatie over deze aanvraag kunnen zien. Het indienen van een nieuwe aanvraag zal (voorlopig) echter niet lukken.',
                question_11:
                    'Ik heb nog niet alle informatie. Kan ik mijn lopende aanvraag opslaan?',
                answer_11:
                    'Dit is voorlopig nog niet mogelijk. We zijn momenteel bezig met het ontwikkelen van deze functionaliteit die het mogelijk maakt om een aanvraag tijdelijk op te slaan voordat deze wordt ingediend.',
                question_12: 'Waar vind ik meer info over Rockestate?',
                answer_12:
                    'Meer informatie over Rockestate vindt u hier: https://www.rockestate.io/about',
                question_13:
                    'Waar vind ik meer info over over de data die Rockestate gebruikt?',
                answer_13:
                    'Meer informatie over de data die Rockestate gebruikt, vindt u hier: https://www.rockestate.io/blog/open-geo-data-rockestates-belangrijkste-ingredient',
            },
        },
        dashboard: {
            reference_listing: {
                view_button: 'Bekijk',
                report_button: 'Rapport',
                edit_button: 'Bewerken',
            },
            new_request: {
                title: 'Nieuwe aanvraag',
            },
            type_toggles: {
                ers: 'Energie simulatie',
                dvm: 'Waarderingsaanvraag',
            },
        },
        energy: {
            shared: {
                tooltip_more_info: 'Meer informatie',
                insulation_year: 'Isolatiejaar',
            },
            building_dimensions: {
                floors: {
                    infobubble: 'Inclusief het gelijkvloers, exclusief kelder en zolder.',
                    question: 'Hoeveel verdiepingen telt het huis?',
                    label: 'Aantal verdiepingen',
                },
                title: 'Benader de afmetingen van het gebouw',
                roof: {
                    question: 'Wat is de vorm van het dak?',
                    tooltip:
                        "Indien het dak niet bestaat uit ofwel enkel platte, ofwel enkel hellende delen, selecteer 'Sommige delen zijn hellend, andere zijn plat'. Gebruik de slider om aan te geven welke proportie van het dak ongeveer plat is.",
                },
                roof_type_pitched: 'Alle delen zijn hellend',
                roof_type_flat: 'Alle delen zijn plat',
                roof_type_mixed: 'Sommige delen zijn hellend, anderen plat',
                wall_insulation: {
                    question: 'Hoeveel gevels zijn er?',
                    tooltip:
                        'Indien twee of meer muren gedeeld zijn met aangrenzende huizen, selecteer "Gesloten". Is er slechts \u00e9\u00e9n gemeenschappelijke muur, selecteer "Halfopen". Selecteer "Open" indien er geen gemeenschappelijke muren zijn.',
                },
                facade_type_row: 'Gesloten bebouwing',
                facade_type_row_end: 'Halfopen bebouwing',
                facade_type_isolated: 'Open bebouwing',
            },
            address: {
                map: {
                    no_model: {
                        title:
                            'Het lijkt erop dat we het 3D-model van dit gebouw niet konden vinden.',
                        subtitle:
                            'Met enkele bijkomende vragen kunnen we de afmetingen van het gebouw benaderen.',
                        change_address: 'Probeer een ander adres',
                        start: 'Laten we beginnen!',
                    },
                    select_building: 'Selecteer uw gebouw op de kaart',
                    cant_find: 'Ik vind mijn gebouw niet',
                    confirm_2d: 'Is het juiste gebouw geselecteerd op de kaart?',
                    confirm_3d:
                        '\nStelt dit vereenvoudigd 3D-model het juiste gebouw voor?',
                    title: 'Uw huis',
                    placeholder: 'Vul een adres in om het op de kaart te zien',
                },
                is_loading: 'bezig met laden...',
                title: 'Vul het adres in om de afmetingen van dit gebouw op te halen',
                title_tooltip:
                    'Op basis van het adres halen we informatie op zoals muuroppervlakken, dakhelling en -ori\u00ebntatie, enz. Hierdoor kunnen we de kosten en baten van renovaties inschatten.\nSoms kunnen offici\u00eble gegevens fouten bevatten, waardoor bijvoorbeeld twee gebouwen tegelijkertijd worden geselecteerd. Antwoord in dit geval dat het niet het juiste huis is en dat u het gebouw niet kunt vinden. We zullen dan aanvullende vragen stellen om de afmetingen van het gebouw te benaderen.',
                subtitle:
                    'Elk gebouw is uniek. Via het adres kunnen we renovaties afstemmen op de specifieke kenmerken van het gebouw.',
            },
            building_type: {
                title: 'Selecteer het type pand dat een energierenovatie ondergaat.',
                unavailable_option:
                    'De applicatie werkt momenteel niet voor dit type woning.',
                title_tooltip:
                    "Afhankelijk van het type pand is andere informatie vereist om de energie performatie te schatten en renovatiescenario's voor te stellen.",
                option: {
                    house: {
                        name: 'Huis',
                        description: 'Gebouw met \u00e9\u00e9n enkele woonentiteit',
                    },
                    apartment: {
                        name: 'Appartement',
                        description: 'Een woonentiteit dat deel is van een groter gebouw',
                    },
                    apartment_building: {
                        name: 'Apartementsgebouw',
                        description:
                            'De gemene delen van een apartementsgebouw gedeeld door mede-eigenaars.',
                    },
                },
            },
            attic: {
                question: 'Heeft u een zolder?',
                question_heated: 'Wordt de zolder gebruikt als verwarmde kamer?',
                tooltip:
                    'Zoldervloerisolatie is een kosteneffici\u00ebnte oplossing om het dak te isoleren, tenzij u van plan bent de zolderruimte als verwarmde kamer  te gebruiken.',
            },
            basement: {
                question: 'Heeft u een kelder?',
                tooltip:
                    'Indien uw woning niet op volle grond staat, antwoord "Ja". Elke onverwarmde ruimte onder het gelijkvloers, inclusief een kruipkelder of gedeeltelijke kelder wordt beschouwd als kelder.',
            },
            living_area: {
                question: 'Wat is de bewoonbare vloeroppervlakte?',
                lvl_3: {
                    tooltip:
                        "Totale vloeroppervlakte dat deel uitmaakt van het beschermde volume. Het beschermde volume omvat alle kamers die u verwarmt. Onze schatting houdt er rekening mee of uw zolderruimte al dan niet verwarmd is. U kan deze informatie vinden in het EPC certificaat onder 'Bruikbare vloeroppervlakte'. ",
                },
                bubble_info:
                    'Op basis van de afmetingen van het gebouw schatten we het verwarmde vloeroppervlakte op <b class="has-text-primary">{estimated_living_area} m\u00b2</b>. Voer de werkelijke oppervlakte in als u die kent.  U kan deze informatie vinden in het EPC certificaat onder \'Bruikbare vloeroppervlakte\'. ',
                lvl_2: {
                    tooltip:
                        "Totale vloeroppervlakte dat deel uitmaakt van het beschermde volume. De kelder is doorgaans uitgesloten. Voeg de zoldervloer toe indien de zolderruimte als verwarmde kamer dient. U kan deze informatie vinden in het EPC certificaat onder 'Bruikbare vloeroppervlakte'. ",
                },
            },
            valid_epc: {
                question: 'Heeft u een geldig EPC certificaat?',
                answer_yes: 'Geef de offici\u00eble EPC score in',
                answer_no: 'Simuleer uw EPC score',
                tooltip:
                    'Enkel erkende energie experten mogen EPC certificaten uitgeven.  Ga na dat het certificaat nog geldig is. Het EPC certificaat documenteert de energie effici\u00ebntie van een woning in detail, resulterend in een Energie Performatie Co\u00ebfficient (EPC) score of EPC label.',
            },
            epc_score: {
                'warning_tooltip-main':
                    'Merk op dat we de offici\u00eble EPC-score niet kopi\u00ebren. We schatten de EPC-score op basis van uw invoer.',
                'warning_tooltip-description':
                    'Zo kunnen we geschikte renovatiescenario\'s berekenen. Soms kan de offici\u00eble EPC score verschillen van de geschatte EPC score. U kunt nagaan waarom dit gebeurt in de FAQ 3.1 "De geschatte EPC score verschilt van de offici\u00eble EPC score".',
                question: 'Wat is de offici\u00eble EPC score?',
                tooltip:
                    "De Energie Performatie Co\u00ebfficient (EPC) is de energiescore van een woning. Het drukt uit hoeveel kWh/m\u00b2 nodig is per jaar om een constante temperatuur van 18\u00b0C te behouden. U vindt de score in het EPC certificaat. Het gebouw's EPC label is gebaseerd op deze score. Afhankelijk van de regionale standaarden zijn labels opgedeeld van A++ (zeer effici\u00ebnt) tot G (minst effici\u00ebnt). ",
                subtitle: 'Selecteer een optie',
                answer_kwh: 'kWh/m\u00b2jr',
                answer_label: 'EPC label',
                subtitle_2: 'Geef de offici\u00eble EPC score in',
            },
            construction_year: {
                question: 'Wanneer werd de woning gebouwd?',
                tooltip:
                    'Het offici\u00eble bouwjaar, niet rekening houdend met enige renovaties die eventueel volgden. Deze informatie kan men meestal terugvinden in de verkoopsadvertentie, het kadaster of het referentiejaar in het EPC certificaat.',
                question_specify: 'Specifieer het bouwjaar',
                label_input: 'Bouwjaar',
            },
            roof_insulation: {
                question: 'Is het dak ge\u00efsoleerd?',
                tooltip_popup:
                    "### Dakisolatie\n\nGe\u00efsoleerde daken hebben een isolatielaag die warmteverliezen tegengaat en zo energie bespaart. **Als u dakisolatie langs binnen- of buitenzijde heeft of zoldervloerisolatie, antwoord dan met 'Ja'. Als u het niet zeker weet, selecteer dan 'Ik weet het niet'.** In dat geval zullen we de isolatienormen nemen die golden in het bouwjaar. \n\n**Tips om te bepalen of uw dak ge\u00efsoleerd is:**\n\n- Koude plafonds: Als de plafonds op de bovenste verdieping koud aanvoelen wanneer u ze aanraakt, kan dit duiden op een gebrek aan isolatie.\n- Overmatige warmte: Slecht ge\u00efsoleerde daken kunnen tijdens warm weer overmatige hitte binnenlaten, vooral op te merken onder het dak.\n- Hoge energierekeningen kunnen wijzen op een slechte isolatie.\nDakisolatie is een belangrijk onderdeel van energiezuinig bouwontwerp en kan aanzienlijk bijdragen aan het verminderen van verwarmings- en koelkosten, terwijl het comfortniveau in het gebouw wordt verbeterd.",
                info_bubble:
                    'Dakisolatie kan langs de <b>binnen- of buitenkant van het dak</b> zijn of <b>zoldervloerisolatie.</b>',
                question_2: 'Wanneer werd het dak laatst ge\u00efsoleerd?',
                label_input: 'Isolatiejaar',
            },
            result: {
                footnote:
                    '*De schatting van de huidige EPC score is gebaseerd op de informatie gegeven in het vragenformulier, in combinatie met data over het gebouw en technische eisen zoals vastgelegd in de offici\u00eble EPC software. Hoe correcter de doorgegeven informatie, des te accurater de simulatie is. De simulatie vervangt geen officieel EPC certificaat. Raadpleeg steeds een professional voor gepersonaliseerd advies. **Prijzen zijn inclusief 6 % of 21 % BTW afhankelijk van de doorgegeven situatie. Enige bijkomende werken die vereist zijn voor de renovatie zijn niet inbegrepen in de prijs. Wij updaten prijzen en subsidies op een regelmatige basis. Afhankelijk van wanneer u de simulator gebruikt, kan de uitkomst daarom verschillen. Subsidies kunnen verschillen afhankelijk van uw persoonlijke situatie. Raadpleeg steeds een professional voor gepersonaliseerd advies.',
                EPC_label: 'EPC-score',
                budget_label: 'Uw budget',
                edit_questionnaire: 'Vragenlijst bewerken',
                scenario_saved_message: 'Scenario succesvol opgeslagen',
                no_renovation:
                    '<p><span class="text-primary">Pluim!</span> Deze woning is goed uitgerust voor een energiezuinige toekomst.</p>\n\n<p>Op basis van uw input kon onze simulator geen winstgevende renovatiescenario\'s vinden. Het lijkt erop dat dit pand een punt heeft bereikt waarop verdere energetische renovaties minimale winst kunnen opleveren. Als u van dit huis een voorbeeld wilt maken voor duurzaam leven, zijn hier een paar mogelijke upgrades die u kunt overwegen:</p>\n<ul>\n<li>Kies LED-verlichting</li>\n<li>Installeer een energiezuinige voordeur en garagedeur</li>\n<li>Overweeg een ventilatiesysteem zoals C+ of systeem D</li>\n<li>Ontdek de voordelen van een zonneboiler</li>\n<li>Investeer in een thuisbatterij</li>\n</ul>\n\n<p>Bedankt dat u een milieubewuste huiseigenaar bent.</p>',
                header: {
                    title: 'De huidige energie-effici\u00ebntie',
                    subtitle:
                        'Gebaseerd op de verstrekte gegevens hebben we de huidige EPC-score en relevante renovaties geschat. Dit vervangt geen offici\u00eble EPC-score*.',
                },
                epc_score: {
                    title:
                        'De geschatte huidige EPC score is {current_epc_score} kWh/m\u00b2/jr.',
                    subtitle:
                        'Zoals u ziet op het histogram hebben {x}% van de huizen in {region} een beter EPC label.',
                },
                consumption: {
                    title: 'Uw verbruik',
                    elec: 'Elektr.',
                    low: 'Laag',
                    high: 'Hoog',
                    med: 'Mediaan',
                    you: 'U',
                },
                package: {
                    title: 'Simuleer de slimste renovaties',
                    subtitle:
                        'Wat is uw renovatiedoel? Selecteer het beoogde EPC label en ontdekt het meest kosteneffici\u00ebnte pakket om uw doel te behalen. Heeft u een renovatiebudget? Vul dit dan in en ontdek de beste EPC score die u hiermee kan behalen. Of, klik en kies zelf welke renovaties u wilt uitvoeren.',
                    current: 'Huidig EPC',
                    budget: 'Budget',
                    custom: 'Klik & kies',
                    target: 'EPC doel',
                    best: 'Beste EPC',
                },
                renovation: {
                    wall: 'muren',
                    roof: 'het dak',
                    window: 'ramen',
                    poorly_insulated:
                        'Om de aangeraden volgorde van energetische renovaties aan te houden, voegt u het volgende toe aan dit scenario:',
                    mixed: 'Dakisolatie langs binnen en plafond',
                    mixed_tooltip_popup:
                        '### {tooltip_title}  \n## Goed om te weten\n\nHet dak is de voornaamste bron van warmteverlies in een gebouw. Het is dus aangeraden om te beginnen met het dak te isoleren. Het is niet mogelijk om platte daken van de binnenkant te isoleren. In dit scenario wordt het platte gedeelte van het dak ge\u00efsoleerd vanaf het plafond en het schuine gedeelte vanaf de binnenkant van het dak. Het is belangrijk dat u de haalbaarheid van deze optie bespreekt met een vakman om thermische bruggen en condensatie te vermijden. Dakisolatie langs binnen is eenvoudiger te installeren en goedkoper in vergelijking met isolatie langs de buitenkant. Houd er rekening mee dat de isolatie een deel van de zolderruimte zal innemen. De kosten vari\u00ebren op basis van het type dak en de gebruikte materialen. Gebruikt u de zolderruimte niet als verwarmde ruimte, overweeg dan om de zoldervloer te isoleren.  \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nVoor plafondisolatie: afbraakwerken plafond, plaatsen van isolatie en dampscherm, afwerking van plafond, aanpassingen aan bestaande leidingen en verlichting\nVoor dakisolatie langs binnenkant: verwijdering van de aangetaste isolatielaag (inclusief dampscherm), installatie van een nieuwe isolatielaag en dampscherm, en aanpassingen rond het dakvlak en de dakkapel.',
                    ceiling_tooltip_popup:
                        '### {tooltip_title}    \n## Goed om te weten\n\nHet dak is de voornaamste bron van warmteverlies in een gebouw. Het is dus aangeraden om te beginnen met het dak te isoleren. In dit scenario wordt het platte gedeelte van het dak ge\u00efsoleerd vanaf het plafond. Het is belangrijk dat u de haalbaarheid van deze optie bespreekt met een vakman om thermische bruggen en condensatie te vermijden.  Dakisolatie langs binnen is eenvoudiger te installeren en goedkoper in vergelijking met isolatie langs de buitenkant. De kosten vari\u00ebren op basis van het type dak en de gebruikte materialen.  \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nAfbraakwerken plafond, plaatsen van isolatie en dampscherm, afwerking van plafond, aanpassingen aan bestaande leidingen en verlichting',
                    ceiling: 'Plafondisolatie',
                    roofIn: 'Dakisolatie langs binnen',
                    roofIn_tooltip_popup:
                        '### {tooltip_title}    \n## Goed om te weten\n\nHet dak is de voornaamste bron van warmteverlies in een gebouw. Het is dus aangeraden om te beginnen met het dak te isoleren. Dakisolatie langs binnen is eenvoudiger te installeren en goedkoper in vergelijking met isolatie langs de buitenkant. Houd er rekening mee dat de isolatie een deel van de zolderruimte zal innemen. Dakisolatie langs de buitenkant verkleint de ruimte dan weer niet, en biedt effici\u00ebntere isolatie. De kosten vari\u00ebren op basis van het type dak en de gebruikte materialen. Gebruikt u de zolderruimte niet als verwarmde ruimte, overweeg dan om de zoldervloer te isoleren.  \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nVerwijdering van de aangetaste isolatielaag (inclusief dampscherm), installatie van een nieuwe isolatielaag en dampscherm, en aanpassingen rond het dakvlak en de dakkapel.',
                    atticFloor: 'Zoldervloerisolatie',
                    atticFloor_tooltip_popup:
                        '### {tooltip_title}    \n## Goed om te weten\n\nHet dak is de voornaamste bron van warmteverlies in een gebouw. Het is dus aangeraden om te beginnen met het dak te isoleren. Als de zolderruimte niet gebruikt wordt als verwarmde kamer, kan zoldervloerisolatie een kosteneffici\u00ebnte keuze zijn om warmteverlies via het dak tegen te gaan. Het is veel goedkoper in vergelijking met dakisolatie. Dit komt voornamelijk door de kleinere te isoleren oppervlakte en minimale of geen benodigde afwerking. Het installatieproces verloopt relatief snel en eenvoudig. Dit is echter niet de beste keuze indien u in de toekomst de zolderruimte als verwarmde kamer wilt benutten. \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nInstallatie van isolatie en dampscherm, aanpassingen aan bestaande leidingen en verlichting, en aanpassing van de toegang.',
                    roofExt: 'Dakisolatie langs buiten',
                    roofExt_tooltip_popup:
                        '### {tooltip_title}    \n## Goed om te weten\n\nHet dak is de voornaamste bron van warmteverlies in een gebouw. Het is dus aangeraden om te beginnen met het dak te isoleren. Dakisolatie langs de buitenkant heeft het voordeel dat dit de ruimte onder het dak niet verkleint, de woning minder bevuilt en bewoonbaar blijft tijdens de werken. Ook laat het toe om voor de dikste isolatie te kiezen. Isolatie langs buiten is echter een duurdere optie dan langs de binnenkant van het dak. De totale kost hangt af van het type dak en de gebruikte materialen. Dakisolatie langs de buitenkant is een goede keuze voor een plat dak, of wanneer u de ruimte onder het dak als verwarmde kamer gebruikt.  \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nSlopen van dakbedekking en -structuur, slopen van dakgoten, aanbrengen van isolatie en een dampscherm, plaatsen van dakstructuur en -bedekking, werken rond dakventilatieopeningen, plaatsen van dakgoten, verwijderen en opnieuw installeren van zonnepanelen indien reeds aanwezig en een kraan of lift.',
                    windowsDouble: 'Ramen',
                    windowsDouble_tooltip_popup:
                        "### {tooltip_title}    \n## Goed om te weten\n\nOude ramen dragen tot zo'n 30% bij aan het warmteverlies van een woning. Upgraden naar energie-effici\u00ebnte ramen, zoals hoogrendement dubbele of driedubbele beglazing met luchtdicht schrijnwerk, kan de isolatie aanzienlijk verbeteren. Als u van plan bent de gevels te isoleren, is het is aangeraden om dit te doen alvorens of tegelijk met de installatie van nieuwe ramen. Een bijkomend voordeel van nieuwe ramen is dat deze beter beveiligd zijn dankzij een extra glaslaag. Hierdoor zijn ze beter bestand tegen glasbreuk. \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nSlopen en plaatsen van glas (met toeslag voor hijsapparatuur), slopen en plaatsen van het kozijn, plaatsen van RTO op het glas, en slopen en plaatsen van het glas.",
                    condGas: 'Gascondensatieketel',
                    condGas_tooltip_popup:
                        "### {tooltip_title}    \n## Goed om te weten\n\nGascondensatieketels zijn ontworpen om warmte te onttrekken aan de uitlaatgassen die tijdens het verbrandingsproces worden geproduceerd.  **De levensduur van een gascondensatieketel is zo'n 15 jaar.** Door de onttrokken warmte te gebruiken om water voor te verwarmen is de effici\u00ebnte hoger dan die van een klassieke ketel. Gascondensatieketels hebben een positieve impact op de EPC score van een woning. Ze werken het effici\u00ebntst als de muren, dak en ramen goed ge\u00efsoleerd zijn. Overweeg om uw huis te isoleren alvorens een nieuw verwarmingssysteem te installeren voor het beste resultaat. \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nSloop van de bestaande generator, installatie van een condensatieketel op gas, koppeling met de bestaande generator, extra kosten voor het vervangen van het klimaatsysteem, isolatie van niet-ge\u00efsoleerde leidingen.",
                    heatPump: 'Warmtepomp',
                    heatPump_tooltip_popup:
                        '### {tooltip_title}    \n## Goed om te weten\n\nWarmtepompen onttrekken energie uit de lucht, grond of grondwater om een ruimte te verwarmen of te koelen. Een beter ge\u00efsoleerde woning verliest minder warmte en heeft bijgevolg een minder zware pomp nodig. Daardoor is de prijs van een warmtepomp lager in combinatie met andere energetische renovaties. Een warmtepomp vermindert de afhankelijkheid van fossiele brandstoffen en aldus de koolstofemissies van uw verbruik. Er bestaan verschillende soorten warmtepompen, zoals geothermische, lucht-lucht, lucht/water en hybride systemen. Prijzen vari\u00ebren afhankelijk van het specifieke type warmtepomp. \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nSloop van de bestaande generator, installatie van een warmtepomp (met grondwater; inclusief boren), aansluiten op de bestaande generator en isoleren van niet-ge\u00efsoleerde leidingen. Voor het vervangen van het klimaatsysteem gelden extra kosten.',
                    wallCav: 'Spouwmuurisolatie',
                    wallCav_tooltip_popup:
                        '### {tooltip_title}    \n## Goed om te weten\n\nNadat het dak werd ge\u00efsoleerd is het aangeraden om de muren te isoleren. Niet alle gevels hebben een spouw. Ga dus na of het gebouw spouw- of massieve muren heeft. Spouwmuurisolatie kan uitstekende thermische isolatie bieden tegen een betaalbare prijs. Wees echter bewust van mogelijke problemen zoals condensatie en schimmelvorming. Als de woning zich in een gebied met veel windgedreven regen bevindt, overweeg dan alternatieven om vochtgerelateerde problemen te voorkomen. \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nGebruik van een hoogtewerker, installatie van 5 cm minerale wolisolatie inclusief inspectie, voorbereiding, inblazen en sluiten van de openingen.',
                    unitPv: 'Zonnepanelen',
                    unitPv_tooltip_popup:
                        '### {tooltip_title}    \n## Goed om te weten\n\nZonnepanelen kunnen een kosteneffectieve manier zijn om de EPC-score te verbeteren en de energiefactuur te verlagen. Het is echter aangeraden eerst het dak, muren, beglazing en verwarming te renoveren. De effici\u00ebntie van zonnepanelen hangt af van meerdere factoren zoals oppervlakte, ori\u00ebntatie en schaduw op het dak. In bepaalde gevallen heeft u een vergunning nodig om zonnepanelen te installeren, bijvoorbeeld als de woning in het architecturaal erfgoedregister staat. \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nDe plaatsing van zonnepanelen inclusief all accessoires.                 ',
                    wallExt: 'Gevelisolatie langs buiten',
                    wallExt_tooltip_popup:
                        '### {tooltip_title}    \n## Goed om te weten\n\nNa dakisolatie is het aangeraden om de muren te isoleren. Gevelisolatie langs de buitenzijde biedt het voordeel dat u geen leefruimte verliest en het huis bewoonbaar blijft tijdens de werkzaamheden. Het helpt ook om geluiden van buiten te reduceren. Ga steeds na of de woning geschikt is voor buitenmuurisolatie. Gezien de esthetische kenmerken van de gevel veranderen zijn er mogelijks vereisten voor een bouwvergunning, bijvoorbeeld als u een historisch pand renoveert. Houd hier dus rekening mee. \n\n## Wat is inbegrepen? \nDe totale investeringskosten zijn inclusief:  \nRegenwaterafvoer afbreken, dorpels afzagen, isolatie aanbrengen, afwerkingen plaatsen (in crepi), openingen bijwerken (inclusief dorpels), aanpassingen uitvoeren, dakoverstek vergroten, regenwaterafvoer vernieuwen en een steiger.',
                },
                warning: {
                    solar_panel:
                        'Indien u van plan bent het dak in de toekomst te isoleren, overweeg dan om dit aan het renovatie scenario toe te voegen. Zo vermijd u de kosten die voortvloeien uit het weghalen en opnieuw installeren van zonnepanelen. Het is niet toegestaan om zonnepanelen te installeren op een dak dat asbest bevat.',
                    window:
                        'Overweeg dak- en/of muurisolatie toe te voegen aan uw renovatie scenario om toekomstige kosten te vermijden die voortvloeien uit het het opnieuw verwijderen van raamkozijnen om isolatie te installeren.',
                    heating:
                        'Overweeg het dak, de muren en de beglazing voldoende te isoleren vooraleer u het verwarmingssysteem renoveert. Als u een nieuw verwarmingssysteem installeert in een onvoldoende ge\u00efsoleerde woning, heeft u een groter en aldus duurder systeem nodig om hetzelfde volume te verwarmen.',
                },
                summary: {
                    title: 'Samenvatting',
                    subtitle:
                        'De prijzen hieronder zijn indicatief. Het BTW-percentage is gebaseerd op de belastingwetgeving.**',
                    item: 'Item',
                    price_incl_vat: 'Prijs incl. BTW',
                    price_excl_vat: 'Prijs excl. BTW',
                },
                property_value: 'Vastgoedmarktwaarde',
                savings: {
                    title: 'Besparingen',
                    epc: 'EPC verbetering',
                    carbon: 'CO\u2082-uitstoot',
                    bills: 'Energiefactuur',
                },
                button: {
                    add_remove: 'Renovaties toevoegen of verwijderen',
                    download: 'Download',
                    share: 'Delen',
                    edit_input: 'Bewerk invoer',
                },
                one_renovation_available:
                    'Op basis van uw input heeft onze simulator slechts \u00e9\u00e9n winstgevend renovatiescenario kunnen vinden',
                price: '\u20ac {value}',
            },
            summary: {
                epc: 'EPC-certificaat',
                answers_needs_to_be_fixed:
                    'Sommige antwoorden moeten worden aangepast. Vul de waarden in van de vragen die rood zijn omgeven',
                energy_consumption_known: 'Energieverbruik bekend',
                heated: 'Verwarmde',
                not_heated: 'Niet verwarmd',
                insulation_year: 'Isolatiejaar',
                residents: 'Bewoners',
                heating_consumption: 'Verwarming verbruik',
                electricity_consumption: 'Elektriciteitsverbruik',
                high: 'Hoog',
                medium: 'Gemiddeld',
                low: 'Laag',
                big_consumer: 'Grote energieverbruikers',
                fuel_error:
                    'De brandstof is veranderd en sommige antwoorden moeten dienovereenkomstig worden aangepast.',
                construction_year_error:
                    'Het bouwjaar verandert en er zijn zeker reacties op de veranderingen met gevolgen.',
                title: 'Hier is een samenvatting van uw invoer ter validatie.',
                subtitle:
                    'Neem even de tijd om de invoer te controleren. Als u iets wil veranderen, klik op het potlood icoon.',
            },
            package: {
                epc: {
                    title: 'Ik wil een EPC score behalen',
                    description:
                        'Dit berekent het scenario dat de beoogde EPC score behaalt voor het laagste budget',
                },
                budget: {
                    title: 'Ik heb een maximum budget',
                    description:
                        'Dit berekent het scenario dat de best mogelijke EPC score behaalt binnen het maximum budget',
                },
                custom: {
                    title: 'Ik wil mijn scenario kiezen',
                    description:
                        "Klik en kies uw eigen set van renovaties om gepersonaliseerde scenario's te cre\u00ebren",
                },
            },
            wall_insulation: {
                question: 'Zijn de gevels ge\u00efsoleerd?',
                tooltip_popup:
                    "### Ge\u00efsoleerde gevels\nGe\u00efsoleerde gevels hebben een isolatielaag die warmteverliezen tegengaat en zo energie bespaart. **Als niet alle gevels ge\u00efsoleerd zijn, selecteer dan 'Nee'. Als u het niet zeker weet, selecteer dan 'Ik weet het niet'.** In dat geval zullen we de isolatienormen nemen die golden in het bouwjaar.\n\n**Tips om te bepalen of uw gevels ge\u00efsoleerd zijn:**\n\n- Koude muren: Als de muren koud aanvoelen wanneer u ze aanraakt, kan dit duiden op een gebrek aan isolatie.\n- Overmatig geluid: Slecht ge\u00efsoleerde muren kunnen geluid niet goed tegenhouden.\n- Hoge energierekeningen kunnen wijzen op een slechte isolatie.\n\nMuurisolatie is een belangrijk onderdeel van energiezuinig bouwontwerp en kan aanzienlijk bijdragen aan het verminderen van verwarmings- en koelkosten, terwijl het comfortniveau in het gebouw wordt verbeterd.",
                bubble_info:
                    'Gevelisolatie kan langs de <b>buiten- of binnenzijde<b> zijn of <b>spouwmuurisolatie.<b>',
                question_2: 'Wanneer zijn de gevels laatst ge\u00efsoleerd?',
            },
            floor_insulation: {
                question: 'Is het gelijkvloers of het kelderplafond ge\u00efsoleerd?',
                tooltip_popup:
                    "### Vloerisolatie\n\nGe\u00efsoleerde vloeren hebben een isolatielaag die warmteverliezen tegengaat en zo energie bespaart. **Als u vloerisolatie heeft, antwoord dan met 'Ja'. Als u het niet zeker weet, selecteer dan 'Ik weet het niet'.** In dat geval zullen we de isolatienormen nemen die golden in het bouwjaar.\n\n**Tips om te bepalen of uw vloeren ge\u00efsoleerd zijn**  \n\n- Koude vloeren: Als uw vloeren koud aanvoelen wanneer u ze aanraakt, kan dit duiden op een gebrek aan isolatie.\n- Hoge energierekeningen kunnen wijzen op een slechte isolatie.",
                question_2: 'Wanneer werd de vloer het laatst ge\u00efsoleerd?',
            },
            window: {
                warning_tooltip:
                    'Het pand is na 2000 gebouwd. Het is dus onwaarschijnlijk dat dit type raambeglazing werd gebruikt.',
                question: 'Wat is het hoofdtype beglazing?',
                tooltip_popup:
                    '### Beglazing\nAls u technische documentatie heeft, zoals facturen van raamplaatsing, kan u die raadplegen voor informatie over de beglazing.\n\n**Als er geen documentatie beschikbaar is, zijn hier enkele tips om de beglazing te bepalen**  \n\n- **Enkel, dubbel, of driedubbel glas:** Houd een voorwerp tegen het glas; \u00e9\u00e9n reflectie geeft aan dat het een raam is met enkel glas, twee reflecties wijzen op dubbel glas, en drie reflecties duiden op driedubbel glas.\n- **Dubbel, hoogrendements of driedubbel glas:** Zoek naar de aluminium strip tussen twee glaslagen. Hoogrendementsglas wordt soms gemarkeerd met de letters "HR", "HR+", of "HR++". Driedubbel glas is gemarkeerd met "HR+++". U kunt ook zoeken naar de code die aan de binnenkant van de raamstrip is gemarkeerd op de website van de fabrikant.',
            },
            heating: {
                question: 'Selecteer het belangrijkste verwarmingssysteem',
                tooltip:
                    'We maken de assumptie dat hetzelfde verwarmingssysteem zowel verwarming als warm water voorziet. Indien de woning meer dan \u00e9\u00e9n verwarmingssysteem heeft, selecteert u het systeem dat het grootste volume verwarmt.',
            },
            end_section: {
                got_it: 'Begrepen!',
                text:
                    'Met deze informatie kunnen we de EPC-score schatten en geschikte renovaties aanbevelen.',
                go_to_consumption: 'Ga naar Consumptie',
            },
            energy_consumption: {
                question: 'Kent u het jaarlijkse energie verbruik van uw gezin?',
                bubble_info:
                    'U kan uw verbruik nagaan op de afrekening van uw energieleverancier of online bij uw netbeerder. Verhuizen van een appartement naar een huis, of naar een beter of slechter ge\u00efsoleerde woning, kan een impact hebben op uw jaarlijks verbruik. Neem dit mee in uw schatting.',
                yes_text: 'Ik wil mijn jaarlijks verbruik invullen',
                no_text: 'Help me mijn jaarlijks verbruik te schatten',
            },
            consumers: {
                title: 'Uw verbruik',
                question_1a: 'Hoeveel personen wonen in het huis?',
                tooltip_1:
                    'Tel enkel bewoners die doorheen heel het jaar in de woning verblijven. Personen die tijdelijk of alleen tijdens het weekend verblijven telt u niet mee. Dit helpt om energieverbruik te schatten op basis van het aantal bewoners.',
                question_2a: 'Wat is het jaarlijkse verbruik van het net?',
                tooltip_2:
                    'U kan uw jaarlijkse energieverbruik terugvinden in de jaarlijkse afrekening van uw energieleverancier(s). Indien uw verwarmingssysteem op elektriciteit werkt, zoals een warmtepomp of elektrische verwarming, neem dit verbruik dan in rekening in uw totale elektriciteitsverbruik.',
                bubble_info:
                    'Het jaarlijks elektriciteitsverbruik verwijst naar het totale aantal kWh dat u van het het net neemt in een jaar.\nHoud geen rekening met elektriciteit die u eventueel zelf opwekt.',
                question_1b: 'Hoe zou u uw verbruik voor verwarming inschatten?',
                tooltip_popup_1:
                    "### Schatting van het verwarmingsverbruik  \n- Laag: Studio's en kleine huishoudens met een ecologisch verwarming systeem. ~{min} kWh/jaar voor verwarming\n- Gemiddeld: Gemiddeld huishouden met standaard toestellen ~{med} kWh/jaar voor verwarming\n- Hoog: Grote huishoudens in woningen met een grotere woonoppervlakte. ~{max} kWh/jaar voor verwarming",
                question_2b: 'Hoe zou u uw elektriciteitsverbruik inschatten?',
                tooltip_popup_2:
                    "### Schatting van het elektriciteitsverbruik\n- Laag: Gezin van 1-2 personen, of gezin met zonnepanelen. ~{min} kWh/jaar\n- Gemiddeld: Gemiddelde gezinsgrootte met standaard toestellen. ~{med} kWh/jaar\n- Hoog: Grote gezinnen of energie-intesieve toestellen zoals elektrische verwarming, air conditioning, elektrische auto's of zwembad. ~{max} kWh/jaar",
            },
            big_consumers: {
                question: 'Gebruikt het gezin grote elektriciteitsverbruikers?',
                tooltip:
                    'Grote elektriciteitsverbruikers zijn volledig elektrische voertuigen, airconditioning, een zwembad of een wellnessruimte.',
            },
        },
        admin_panel: {
            user_mgmt: {
                new_accreditation: 'Nieuwe certificering',
                add_accreditation: 'Toevoegen',
                accreditation_number: 'Certificeringnummer',
                accreditation_institution: 'Instelling',
            },
        },
        dvm: {
            shared: {
                actions: {
                    generating_report: 'Generating pdf report',
                    incoherent_features: 'Select incoherent features',
                    onsite: 'Request on site valuation',
                    resubmit: 'Resubmit',
                    save: 'Save valuation without submitting',
                    submit: 'Submit valuation',
                },
                add_to_remarks: 'Add to remarks',
                anchors: {
                    avm: 'AVM',
                    description: 'Description',
                    dvm: 'Desktop Valuation',
                    flood_map: 'Flood map',
                },
                duplicates: 'Duplicates',
                duplicates_modal: {
                    close: 'Close',
                    copy_ref: "Copy request's reference",
                    open_dvm: 'Open Valuation Tool for this request',
                    reason: 'Reason',
                    reasons: {
                        'close point': 'Close point',
                        'same address': 'Same address',
                        'same customer_ref': 'Same customer reference',
                        'same place': 'Same place',
                    },
                    title: 'Showing duplicates for',
                },
                error_modal: {
                    actions: {
                        incoherent_patch:
                            'PATCH call of the incoherent features submission',
                        incoherent_put: 'PUT call of the incoherent features submission',
                        onsite_patch: 'PATCH call of the onsite submission',
                        onsite_put: 'PUT call of the onsite submission',
                        report_post: 'POST report (report generation)',
                        resubmit_patch: 'PATCH call of the resubmission',
                        resubmit_put: 'PUT call of the resubmission',
                        submitVal_patch: 'PATCH call of the valuation submission',
                        submitVal_put: 'PUT call of the valuation submission',
                    },
                    back_to_dashboard: 'Go back to the Dashboard',
                    cancel: 'Cancel',
                    content:
                        'An error occured while doing the <pre>{action} </pre> for the request <pre>{ref} </pre>\nPlease report it to the engineering team including those informations as well as this error message:',
                    title: 'An error occured',
                },
                incoherent_features_modal: {
                    back_to_dashboard: 'Go back to the Dashboard',
                    confirmation_message: 'Valuation request sent for review!',
                    submit: 'Send incoherent features',
                    title: 'Incoherent features',
                },
                onsite_modal: {
                    back_to_dashboard: 'Go back to the Dashboard',
                    confirmation_message: 'Valuation request deferred on-site!',
                    reasons: {
                        onsite_commercial_building: 'Commercial building',
                        onsite_exceptional_property: 'Exceptional property for the area',
                        onsite_extensive_renovation: 'Ratio renovation/current value',
                        onsite_few_comparison: 'Not enough comparison data points',
                        onsite_flood_zone: 'Flood zone risk',
                        onsite_incoherent_features: 'Wrong input filled',
                        onsite_others: 'Other',
                        onsite_streetview: 'Streetview data not available or outdated',
                        onsite_volume_missing: 'Building volume missing',
                    },
                    submit: 'Defer to on-site',
                    title: 'Request on-site valuation',
                },
                price: 'Price',
                price_per_sqm: 'Price per sqm',
                price_sqm: 'Price/sqm',
                address: 'adres',
                transaction_value: '',
            },
            request: {
                add_document: 'Een document toevoegen',
            },
            dashboard: {
                all: 'Alle klanten',
            },
            avm: {
                analysis: 'Analysis',
            },
            description: {
                annexes: {
                    title: 'Annexes',
                },
                apartment_features: {
                    title: 'Apartment features',
                },
                basic_info: {
                    building_found: 'Building found',
                    building_type: {
                        label: 'Building Type',
                        options: {
                            apartment: 'Apartment',
                            construction_plot: 'Construction plot',
                            house: 'House',
                            new_apartment: 'New apartment',
                            new_house: 'New house',
                        },
                    },
                    level: 'Level',
                    renovations: {
                        label: 'Renovations',
                        warning: 'Renovations costs > 15% of AVM price',
                    },
                    title: 'Basic info',
                    touching_sides: 'Number of touching sides',
                },
                other: {
                    f_dist_building_flood: 'Building distance to nearest flood zone',
                    f_dist_parcel_flood: 'Parcel distance to nearest flood zone',
                    f_matched_entities: 'Matched economic entities',
                    title: 'Other',
                },
                size: {
                    title: 'Size',
                },
                state: {
                    f_epc_label: 'EPC Label',
                    title: 'State',
                },
            },
            desktop: {
                apply_influence: 'Apply Features Deviation',
                dvm_adjustment: 'Total DVM Adjustment',
                environment: {
                    'above-avg': 'Above average',
                    avg: 'Average',
                    'below-avg': 'Below average',
                    title: 'Environment (not shown on the report)',
                },
                market_correction: 'Market Correction',
                overridden_influence: 'Overridden Deviation',
                total_influence: 'Total Deviation',
                update_remarks: 'Update Internal Remarks with Deviations',
            },
            feedback: {
                or_not: 'Graag stellen we u nog enkele vragen over de gebruikservaring.',
            },
            validation: {
                parcel_cost_minValue:
                    'Gelieve een waarde van de bouwgrond hoger dan 10000 in te voeren',
            },
            modal: {
                success_modal: {
                    actions: {
                        back_to_dashboard: 'Go back to the Dashboard',
                        show_report: 'Go to report',
                        stay_on_page: 'Stay on this page',
                    },
                    content: 'Your valuation was submitted.',
                    title: 'Valuation submitted',
                },
            },
        },
        argenta: {
            valuation: {
                enter: {
                    alt_customer_ref_title: 'Wat is het goednummer van de lening?',
                },
                start: {
                    welcome_text_2:
                        'Elke aanvraag start met het invoeren van de interne referentie van het krediet, zijnde het klantnummer van (\u00e9\u00e9n van) de kredietnemer(s). Vervolgens stellen we u enkele vragen over het pand in kwestie. Voor meer informatie, raadpleeg de FAQ.',
                    welcome_text_3:
                        'Deze tool mag enkel gebruikt worden door Argenta-medewerkers die hypothecaire kredieten aanvragen via de applicatie kredietaanvraag. Bovendien mag deze toepassing enkel gebruikt worden in dossiers waarin de klant heeft ingestemd met het indienen van een kredietaanvraag bij Argenta.',
                },
            },
        },
        avm: {
            step1: {
                errors: {
                    default:
                        'Er is een onbekende fout opgetreden. Een desktop waardering wordt aanbevolen in dit geval.',
                    too_few_reference_listings:
                        'Deze locatie heeft te weinig referentie punten in de omgeving. Een desktop waardering wordt aanbevolen in dit geval.',
                },
            },
            shared: {
                extreme_value: 'Extreme value for',
            },
            form: {
                step4: {
                    details: {
                        close: 'Sluiten',
                        link: 'Bekijk in detail >',
                        text:
                            'Hoe groter de bewoonbare oppervlakte, hoe duurder de woning. Op onderstaande grafiek zie je de correlatie in meer detail',
                        title: 'De belangrijkste eigenschap is de bewoonbare oppervlakte',
                    },
                    plot_title: {
                        f_construction_year: 'Bouwjaar',
                        f_epc: 'EPC',
                        f_living_area: 'Bewoonbare oppervlakte',
                        f_parcel_area: 'Perceel oppervlakte',
                    },
                    subtitle:
                        'Het is een woning met een relatief kleine tuin | De woning is redelijk ruim | Het is een vrij recente woning',
                },
                step5: {
                    card1: {
                        li_1:
                            'De woning is verouderd en moet volledig gerenoveerd worden',
                        li_2: 'De woning ligt ver uit de buurt van winkels',
                        title: 'Waarom zou de vraagrijs lager kunnen zijn?',
                    },
                    card2: {
                        li_1: 'De woning is net gerenoveerd',
                        li_2: 'De woning heeft een prachtige ligging',
                        li_3: 'Er is veel lichtinval in de woning',
                        title: 'Waarom zou de vraagrijs hoger kunnen zijn?',
                    },
                    send: 'Verzenden',
                    subtitle:
                        'Vul hieronder het email adres in waar we de resultaten naartoe mogen sturen.',
                    text1:
                        'Op de grafiek ziet u hoe deze richtprijs zich verhoudt tot de woning prijzen van de 200 woningen in de buurt.',
                    text2:
                        'Deze automatische waardeering is een statistische waardeering op basis van verstrekte informatie en een vergelijking met verschillende andere naburige eigendommen. Er is geen controle door een onroerend goed deskundige, en de uiteindelijke waardeering kan daardoor veranderen.',
                    title: 'Resultaten downloaden',
                },
            },
        },
        ing: {
            valuation: {
                enter: {
                    customer_ref_title: 'Wat is de LOP ID van de lening?',
                    forbidden_substring: 'Dit veld kan niet 0000000 bevatten',
                },
                request: {
                    tab_title: 'ING Input Form',
                },
                start: {
                    welcome_text_2:
                        'Elke aanvraag start met het invoeren van de relevante LOP ID. Vervolgens stellen we u enkele vragen over het pand in kwestie. Voor meer informatie, raadpleeg de FAQ.',
                    welcome_text_3:
                        'Deze tool mag enkel gebruikt worden door ING-medewerkers met een hypothecair brevet en dit voor een re\u00ebel LOP dossier. De link naar deze tool mag niet doorgestuurd worden, noch binnen noch buiten het ING netwerk. Dit omwille van interne maatregelen tegen fraude of misbruik.',
                },
            },
            monolith: {
                shared: {
                    customer_ref: 'LOP ID',
                },
            },
        },
        keytrade: {
            valuation: {
                start: {
                    welcome_text_2:
                        'Elke aanvraag start met het invoeren van de relevante interne referentie van de lening. Vervolgens stellen we u enkele vragen over het pand in kwestie. Voor meer informatie, raadpleeg de FAQ.',
                    welcome_text_3:
                        'Deze tool mag enkel gebruikt worden door Keytrade-medewerkers met een hypothecair brevet en dit voor een re\u00ebel dossier met interne referentie.',
                },
            },
        },
        ovm_dispatch: {
            settings: {
                title: 'Dispatcher dashboard',
                subtitle: 'Availability',
                nuts: {
                    placeholder: 'Select a NUTS',
                    caption: 'Number of available valuers in this NUTS:',
                },
                valuer: {
                    placeholder: 'Select a valuer',
                    error: 'No availability info found for this selection.',
                },
            },
            request: {
                confim: 'Confirm changes',
                notification: {
                    end_time: 'End time should be later than start time',
                },
                appointment: {
                    title: 'Create new appointment',
                    subtitle:
                        "The appointment detailed above will be cancelled and a new one will be created. The assigned valuer will be notified of the appointment's cancellation.",
                    button: 'Create appointment',
                    previous: 'Previous appointment records',
                },
            },
        },
        ovm: {
            settings: {
                unsaved_warning:
                    'You have unsaved changes. Please save them before switching tabs.',
            },
        },
    },
    'en-BE': {
        unit: {
            m: 'm',
            m_tooltip: '',
            m2: 'm\u00b2',
            m2_tooltip: '',
            m3: 'm\u00b3',
            m3_tooltip: '',
            'kwh/m2year': 'kWh/m\u00b2yr',
            'kwh/m2year_tooltip': '',
            euro: '\u20ac',
            euro_tooltip: '',
            'euro/month': '\u20ac/month',
            'euro/month_tooltip': '',
            'euro/year': '\u20ac/year',
            'euro/year_tooltip': '',
            'euro/m2': '\u20ac/m\u00b2',
            'euro/m2_tooltip': '',
            'kgco2/m2year': 'kgCO\u2082/m\u00b2yr',
            'kgco2/m2year_tooltip': '',
            'kgco2/year': 'kgCO\u2082/yr',
            'kgco2/year_tooltip': '',
            'kwh/year': 'kWh/yr',
            'kwh/year_tooltip': '',
            'l/year': 'l/yr',
            'l/year_tooltip': '',
            'kg/year': 'kg/yr',
            'kg/year_tooltip': '',
            'm3/year': 'm\u00b3/yr',
            'm3/year_tooltip': '',
            percent: '%',
            percent_tooltip: '',
            month: '/month',
            month_tooltip: '',
            kWh: 'kWh',
            kWh_tooltip: '',
            l: 'l',
            l_tooltip: '',
            kg: 'kg',
            kg_tooltip: '',
            'kWh/m2/yr': 'kWh/m\u00b2/year',
            'kWh/m2/yr_tooltip': '',
            'kWh/yr': 'kWh/year',
            'kWh/yr_tooltip': '',
            'l/yr': 'l/year',
            'l/yr_tooltip': '',
            'm3/yr': 'm\u00b3/year',
            'm3/yr_tooltip': '',
            'kg/co2/yr': 'kg/co2/year',
            'kg/co2/yr_tooltip': '',
            'kg/yr': 'kg/year',
            'kg/yr_tooltip': '',
        },
        address: {
            full_address: 'Address',
            full_address_tooltip:
                'Select the address of the property that is being financed. Please do not confuse this with the address of possible other properties that are being used as additional collateral.',
            streetname: 'Street',
            streetname_tooltip: '',
            streetnumber: 'Number',
            streetnumber_tooltip: '',
            boxnumber: 'Box number',
            boxnumber_tooltip: '',
            postalcode: 'Postal code',
            postalcode_tooltip: '',
            municipality: 'City',
            municipality_tooltip: '',
        },
        valuation: {
            date: 'Valuation date',
            date_tooltip: '',
            type: 'Valuation type',
            type_tooltip: '',
            performed_for: 'Performed for',
            performed_for_tooltip: '',
            valuer: 'Performed by',
            valuer_tooltip: '',
            monitor: 'Monitored by',
            monitor_tooltip: '',
            market_value: 'Market value',
            market_value_tooltip: '',
            market_value_post_renovation: 'Expected market value after renovation',
            market_value_post_renovation_tooltip: '',
            construction_cost: 'Construction cost',
            construction_cost_tooltip: '',
            market_value_pre_construction: 'Market value before construction',
            market_value_pre_construction_tooltip: '',
            forced_sale_value_pre_construction: 'Forced sale value before construction',
            forced_sale_value_pre_construction_tooltip: '',
            forced_sale_value_post_renovation:
                'Expected forced sale value after renovation',
            forced_sale_value_post_renovation_tooltip: '',
            forced_sale_value: 'Forced sale value',
            forced_sale_value_tooltip: '',
            rental_value: 'Monthly rental value',
            rental_value_tooltip: '',
            reconstruction_value: 'Reconstruction value',
            reconstruction_value_tooltip: '',
            cadastral_income: 'Cadastral income',
            cadastral_income_tooltip: '',
            index_value: 'Index',
            index_value_tooltip: '',
            index_type: 'Index type',
            index_type_tooltip: '',
            explanation_1:
                'The valuation of this property relies in part on a data-driven statistical model. Its result has been reviewed and fine-tuned by a real estate expert. This is a two-step process:',
            explanation_1_tooltip: '',
            explanation_2: 'Step 1: Estimate by valuation model',
            explanation_2_tooltip: '',
            explanation_3:
                'An initial estimate of the property\u2019s Market value is calculated by the model based on all Customer input and some of the other input parameters (cf. page 2). This valuation represents the average market value for a property with this location and characteristics.(*)',
            explanation_3_tooltip: '',
            construction_plot_explanation_3:
                'An initial estimate of the property\u2019s Market value is calculated based on the total parcel area and the historical price per square meter of properties sold in the same area.',
            construction_plot_explanation_3_tooltip: '',
            explanation_4: 'Step 2: Review and fine-tuning by real estate expert',
            explanation_4_tooltip: '',
            explanation_5:
                "The real estate expert supervises the model valuation in Step 1 and subsequently factors in the remaining input parameters. This results in the Market value of the property (red line in graph). Depending on the corrections applied by the real estate expert, the Market value can be lower or higher compared to the initial estimate of the valuation model.\n\nThe chart below illustrates how the Market value of this property compares to other properties in the neighbourhoud. It always contextualizes the expert's review.",
            explanation_5_tooltip: '',
            construction_plot_explanation_5:
                'The real estate expert supervises the model valuation in Step 1 and subsequently factors in other parameters than the area.',
            construction_plot_explanation_5_tooltip: '',
            explanation_6:
                'The Market value in this report is based on an expert-reviewed desktop valuation and attempts to give the best possible view on the property\u2019s current value. However, it remains an estimation where the following elements need to be taken into account:\n- Remote valuation: the expert has evaluated the property remotely and did not actually visit the property.\n- Model accuracy: the valuation relies, at least partially, on a statistical model which has a certain margin of error.\n- Level of subjectivity: even the best expert valuation is somewhat biased by a level of subjectivity.',
            explanation_6_tooltip: '',
            onsite_explanation_6:
                'The Market value in this report is based on an expert-reviewed on-site valuation and attempts to give the best possible view on the property\u2019s current value. However, it remains an estimation where the following elements need to be taken into account:\n- Model accuracy: the valuation relies, at least partially, on a statistical model which has a certain margin of error.\n- Level of subjectivity: even the best expert valuation is somewhat biased by a level of subjectivity.',
            onsite_explanation_6_tooltip: '',
            shared: {
                apartment: 'Apartment',
                assessed: 'Assessed',
                destructive_safeguard: {
                    confirm: 'Confirm',
                    content: 'Are you sure you want to proceed with that change?',
                    title: 'Warning: this change will reset the rest of your input.',
                },
                distance: 'Distance',
                listing_date: 'Listing date',
                reference: 'Reference',
            },
            desktop: {
                avm_features_influence: 'AVM Features Deviation',
            },
            sidesteps: {
                borrower_details: 'Borrower details',
                chat: {
                    button: 'Chat',
                    title: 'Your conversation with the Valuation Specialist',
                },
                construction_plot: 'Construction plot',
                extra_info: 'Extra information',
                feedback: 'Feedback',
            },
            floors: {
                close: 'Close',
            },
            enter: {
                conflict_modal: {
                    back: 'Back',
                    content:
                        'To view this existing request, click on the Dashboard button below:',
                    continue: 'Continue',
                    cta: 'Do you want to proceed with the duplicated reference?',
                    dashboard: 'View in dashboard',
                    title:
                        'There already is a valuation request with the same internal reference.',
                },
                customer_ref_title: 'What is the internal reference of the loan?',
                tooltip_text: 'This allows to link the valuation request with the loan.',
            },
            extra_info: {
                construction_cost_minValue:
                    'Please enter a construction cost higher than 10000',
                documents: 'Documents',
                documents_modal: {
                    label: 'Add documents (.jpg, .jpeg, .png, .pdf)',
                    steps: {
                        online: 'Uploaded',
                        upload: 'Upload',
                        uploading: 'Uploading',
                    },
                    title: 'Upload documents',
                    warning:
                        'Any shared document that contains information other than EPC or pictures of the exterior of the property will be disregarded and deleted.',
                },
            },
            feedback: {
                customer_present: 'Did you fill in this form together with the customer?',
                more_questions:
                    'You can follow the progress of your request on the dashboard.',
                question_one:
                    'What was your overall experience for entering this valuation request?',
                question_three_blocked:
                    'Tell us what happened and why you cannot proceed.',
                question_three_sent: 'Other remarks',
                question_two: 'Which documents did the customer have available?',
                question_two_1: 'EPC Certificate',
                question_two_1_text: 'Reference',
                question_two_2: 'Ad listing',
                question_two_2_link: 'Link / reference',
                question_two_2_text: 'Source',
                question_two_3: 'Signed offer',
                question_two_4: 'Compromis',
                question_two_5: 'Sales Deed',
                question_two_6: 'Expert report',
                rating_1: '1: Very bad',
                rating_2: '2: Bad',
                rating_3: '3: Ok',
                rating_4: '4: Good',
                rating_5: '5: Very good',
                send: 'Send feedback and start over',
                rating_description: '(1 = very bad / 5 = very good)',
            },
            start: {
                dashboard: 'Dashboard',
                welcome_text_1:
                    'Welcome! This application lets you estimate a price for every house or apartment with an address in Belgium.',
                welcome_text_2:
                    'Every request starts with the input of the relevant property details.',
                welcome_text_3:
                    'This is a demo version of the Rockestate valuation tool. It is configured in such a way to give you a good idea of how the Rockestate valuation alternatives (automatic, desktop & on-site) could function. Please note an implementation of this tool in a production environment could slightly differ from this demo version.',
                welcome_title: 'Calculate a real estate price',
            },
            avm: {
                no_bedroom: '0 bedrooms!',
            },
            request: {
                start_button_text: 'Start',
                start_over: 'Start over without giving feedback',
                tab_title: 'Input Form',
                text_too_long: 'This field is too long',
                textarea_placeholder: 'Enter your comments here',
                title: "We're almost there. These are the final questions.",
                which_type: 'What type of property is being financed?',
                which_address: 'What is the address of the property being financed?',
                title_blocked: "We're sorry you're blocked",
                title_sent: 'Your request was sent!',
            },
            building_type: {
                tooltip_text:
                    'Is the Borrower financing a single-family home or an apartment?',
            },
            address: {
                tooltip_text:
                    'Select the address of the property that is being financed. Please do not confuse this with the address of possible other properties that are being used as additional collateral.',
            },
            map: {
                'tooltip-for-confirm-main-building':
                    'If this is not the right building, you can click on the link below to be able to select a different one',
                'tooltip-for-confirm-main-parcel':
                    'The main parcel is the one where a house would be built',
                'tooltip-for-select-extra-parcels':
                    'Click with the mouse on the other parcels associated with the property',
                'tooltip-for-select-main-building':
                    'Click with the mouse on the main building associated with the address you entered',
                'tooltip-for-select-main-parcel':
                    'The main parcel is the one where a house would be built',
                'tooltip-for-select-parcels':
                    'Click with the mouse on the parcels associated with the house',
                'tooltip-for-select-secondary-buildings': '',
                'tooltip-for-view-building-parcels':
                    'If you wish to change this information, you must cancel this request and create a new one',
                use_as_reference: 'Use as reference',
            },
            '': {
                upload_documents_tooltip: 'document(s) uploaded',
            },
        },
        assessment: {
            date: 'Assessment date',
            date_tooltip: '',
            type: 'Assessment type',
            type_tooltip: '',
        },
        value: {
            avm: 'Automatic valuation',
            avm_tooltip: '',
            dvm: 'Remote valuation',
            dvm_tooltip: '',
            ovm: 'On-site valuation',
            ovm_tooltip: '',
            flood_assessment: 'Flood assessment',
            flood_assessment_tooltip: '',
            ers: 'Energy renovation simulation',
            ers_tooltip: '',
            short: {
                avm: 'Automatic valuation',
                avm_tooltip: '',
                dvm: 'Remote valuation',
                dvm_tooltip: '',
                ovm: 'On-site valuation',
                ovm_tooltip: '',
                ers: 'Energy renovation',
                ers_tooltip: '',
            },
            '-': ' ',
            '-_tooltip': '',
            new_loan: 'New loan application',
            new_loan_tooltip: '',
            revaluation: 'Revaluation',
            revaluation_tooltip: '',
            classic_tooltip: '',
            renovation_light_tooltip: '',
            renovation_full_tooltip: '',
            new_building: 'Property under construction',
            new_building_tooltip: 'under VAT regime',
            existing_building: 'Existing property',
            existing_building_tooltip: 'under registration fees',
            house: 'House',
            house_tooltip: 'Building with one single living entity',
            apartment: 'Apartment',
            apartment_tooltip: 'A living entity part of a larger building',
            annex: 'Annex',
            annex_tooltip: '',
            new_construction: 'New construction',
            new_construction_tooltip: '',
            new_house: 'New house',
            new_house_tooltip: 'Building with one single living entity',
            new_apartment: 'New apartment',
            new_apartment_tooltip: 'A living entity part of a larger building',
            construction_plot: 'Construction plot',
            construction_plot_tooltip: '',
            attached: 'Attached',
            attached_tooltip: '',
            semi: 'Semi detached',
            semi_tooltip: '',
            detached: 'Detached',
            detached_tooltip: '',
            yes: 'Yes',
            yes_tooltip: '',
            no: 'No',
            no_tooltip: '',
            traditional: 'Traditional',
            traditional_tooltip: '',
            modern: 'Modern',
            modern_tooltip: '',
            contemporary: 'Contemporary',
            contemporary_tooltip: '',
            mediterranean: 'Mediterranean',
            mediterranean_tooltip: '',
            other: 'Other',
            other_tooltip: '',
            ground_floor: 'Ground floor',
            ground_floor_tooltip: '',
            1: '1',
            '1_tooltip': '',
            2: '2',
            '2_tooltip': '',
            3: '3',
            '3_tooltip': '',
            4: '4',
            '4_tooltip': '',
            '>4': '>4',
            '>4_tooltip': '',
            interior: 'Interior',
            interior_tooltip: '',
            exterior: 'Exterior',
            exterior_tooltip: '',
            private: 'Private garden',
            private_tooltip: '',
            common: 'Common garden',
            common_tooltip: '',
            'private+common': 'Private and common garden',
            'private+common_tooltip': '',
            maintenance_required: 'Maintenance required',
            maintenance_required_tooltip: '',
            good: 'Good',
            good_tooltip: '',
            very_good: 'Very good',
            very_good_tooltip: '',
            security: 'Security system',
            security_tooltip: '',
            water_softener: 'Water softener',
            water_softener_tooltip: '',
            air_con: 'Air conditioning',
            air_con_tooltip: '',
            elevator: 'Elevator',
            elevator_tooltip: '',
            domotics: 'Domotica',
            domotics_tooltip: '',
            storage: '(Bicycle) storage',
            storage_tooltip: '',
            rain_water: 'Rain water',
            rain_water_tooltip: '',
            hot_tub: 'Hot-tub',
            hot_tub_tooltip: '',
            cinder_blocks: 'Cinder blocks',
            cinder_blocks_tooltip: '',
            wood: 'Wood',
            wood_tooltip: '',
            plaster: 'Plaster',
            plaster_tooltip: '',
            natural_stone: 'Natural stone',
            natural_stone_tooltip: '',
            metal: 'Metal',
            metal_tooltip: '',
            concrete: 'Concrete',
            concrete_tooltip: '',
            brick: 'Brick',
            brick_tooltip: '',
            tiles: 'Tiles',
            tiles_tooltip: '',
            bitumen_roofing: 'Bitumen roofing',
            bitumen_roofing_tooltip: '',
            slate_shingles: 'Slate shingles',
            slate_shingles_tooltip: '',
            black_concrete_tiles: 'Black concrete tiles',
            black_concrete_tiles_tooltip: '',
            thatched: 'Thatched roof',
            thatched_tooltip: '',
            asbestos: 'Asbestos',
            asbestos_tooltip: '',
            green_roof: 'Green roof',
            green_roof_tooltip: '',
            home_liberal_profession_or_office: 'Home, liberal profession or office',
            home_liberal_profession_or_office_tooltip: '',
            home_other_professional_activity: 'Other professional activity',
            home_other_professional_activity_tooltip: '',
            home: 'Home',
            home_tooltip: '',
            no_economic_activity: 'No economic activity',
            no_economic_activity_tooltip: '',
            activity_unlikely: 'Activity unlikely',
            activity_unlikely_tooltip: '',
            activity_possible: 'Activity possible',
            activity_possible_tooltip: '',
            activity_likely: 'Activity likely',
            activity_likely_tooltip: '',
            activity_very_likely: 'Activity very likely',
            activity_very_likely_tooltip: '',
            n: 'N',
            n_tooltip: '',
            ne: 'NE',
            ne_tooltip: '',
            e: 'E',
            e_tooltip: '',
            se: 'SE',
            se_tooltip: '',
            s: 'S',
            s_tooltip: '',
            sw: 'SW',
            sw_tooltip: '',
            w: 'W',
            w_tooltip: '',
            nw: 'NW',
            nw_tooltip: '',
            limited: 'Limited',
            limited_tooltip: '',
            details_previous_page: '(details on previous page)',
            details_previous_page_tooltip: '',
            below_average: 'Below average',
            below_average_tooltip: '',
            average: 'Average',
            average_tooltip: '',
            above_average: 'Above average',
            above_average_tooltip: '',
            low: 'Low',
            low_tooltip: '',
            medium: 'Medium',
            medium_tooltip: '',
            high: 'High',
            high_tooltip: '',
            unknown: 'Unknown',
            unknown_tooltip: '',
            urban: 'Urban',
            urban_tooltip: '',
            rural: 'Rural',
            rural_tooltip: '',
            isolated: 'Isolated',
            isolated_tooltip: '',
            city: 'City',
            city_tooltip: '',
            suburbs: 'Suburbian',
            suburbs_tooltip: '',
            village: 'Village',
            village_tooltip: '',
            none: 'None',
            none_tooltip: '',
            classified_facade: 'Classified facade',
            classified_facade_tooltip: '',
            green_neighbourhood: 'Green neighbourhood',
            green_neighbourhood_tooltip: '',
            sea_view: 'Sea view',
            sea_view_tooltip: '',
            no_direct_traffic: 'No direct traffic',
            no_direct_traffic_tooltip: '',
            exceptional_view: 'Exceptional view',
            exceptional_view_tooltip: '',
            tram: 'Tram',
            tram_tooltip: '',
            train: 'Train',
            train_tooltip: '',
            metro: 'Metro',
            metro_tooltip: '',
            traffic: 'Traffic',
            traffic_tooltip: '',
            busy_area: 'Busy area',
            busy_area_tooltip: '',
            user_estimate: 'Estimate',
            user_estimate_tooltip: '',
            certificate: 'Certificate',
            certificate_tooltip: '',
            refinancing: 'Refinancing or reinstatement',
            refinancing_tooltip: '',
            bedroom: 'Bedroom',
            bedroom_tooltip: '',
            bathroom: 'Bathroom',
            bathroom_tooltip: '',
            toilet: 'Toilet',
            toilet_tooltip: '',
            abex: 'ABEX',
            abex_tooltip: '',
            apartment_block_info: 'The common parts of the building shared by co-owners',
            apartment_block_info_tooltip: '',
            apartment_block: 'Apartment block',
            apartment_block_tooltip: '',
            other_type: 'Other',
            other_type_tooltip: '',
            single: 'Single',
            single_tooltip: '',
            ordinary_double: 'Ordinary double',
            ordinary_double_tooltip: '',
            hr_double_after_2000: 'High performance double (after 2000)',
            hr_double_after_2000_tooltip: '',
            hr_double_before_2000: 'High performance double (before 2000)',
            hr_double_before_2000_tooltip: '',
            triple: 'Triple',
            triple_tooltip: '',
            gas: 'Gas',
            gas_tooltip: '',
            oil: 'Oil',
            oil_tooltip: '',
            pellets: 'Pellets',
            pellets_tooltip: '',
            coal: 'Coal',
            coal_tooltip: '',
            district_heating: 'District heating',
            district_heating_tooltip: '',
            'boiler:condensing': 'Condensing boiler',
            'boiler:condensing_tooltip': '',
            heat_pump: 'Heat pump',
            heat_pump_tooltip: '',
            'boiler:standard': 'Standard boiler',
            'boiler:standard_tooltip': '',
            chp: 'Combined heat and power',
            chp_tooltip: '',
            stove: 'Stove',
            stove_tooltip: '',
            electricity: 'Electricity',
            electricity_tooltip: '',
            electric_heater: 'Electric heater',
            electric_heater_tooltip: '',
            no_ventilation: 'No ventilation',
            no_ventilation_tooltip: '',
            natural: 'Natural',
            natural_tooltip:
                '\nNatural supply and exhaust of air through windows and grilles.',
            mechanical: 'Mechanical',
            mechanical_tooltip: '',
            system_b: 'System B',
            system_b_tooltip:
                'Mechanical supply of fresh air, natural exhaust of polluted air.',
            system_c: 'System C',
            system_c_tooltip:
                'Natural supply of fresh air, mechanical exhaust of polluted air.',
            system_cplus: 'System C+',
            system_cplus_tooltip:
                'Demand-driven mechanical air supply and exhaust based on air quality.',
            system_d: 'System D',
            system_d_tooltip:
                'Fully automated continuous mechanical air supply and exhaust, also called "balanced ventilation".',
            pur_pir: 'PUR/PIR',
            pur_pir_tooltip: '',
            mineral_wool: 'Mineral wool',
            mineral_wool_tooltip: '',
            hr_double: 'High performance double',
            hr_double_tooltip: '',
            air_water: 'Air-water',
            air_water_tooltip: '',
            monocrystalline: 'Monocrystalline',
            monocrystalline_tooltip: '',
        },
        request: {
            references: 'References',
            references_tooltip: '',
            valuation_request_ref: 'Rock.estate reference',
            valuation_request_ref_tooltip: '',
            customer_ref: 'Internal reference',
            customer_ref_tooltip:
                'This allows to link the valuation request with the loan.',
            bank: 'Bank',
            bank_tooltip: '',
            customer: 'Customer',
            customer_tooltip: '',
            purpose: 'Valuation purpose',
            purpose_tooltip: '',
            package_tooltip: '',
            map_select: {
                'explanation-confirm-main-parcel':
                    'Are the location and total parcel area of the main parcel correct?',
                'cannot-find-confirm-main-parcel':
                    'No, the location or the total parcel area is incorrect.',
                'explanation-select-main-parcel':
                    'Select the right main parcel if the location was incorrect.',
                'explanation-select-main-parcel-no-selection': 'Select the main parcel.',
                'cannot-find-select-main-parcel':
                    'The location is correct but the total parcel area is smaller (e.g. allotment).',
                'explanation-select-extra-parcels':
                    'Select additional parcels included in the purchase. Make sure the total parcel area is correct.',
                'cannot-find-select-extra-parcels':
                    'I want to correct the total parcel area.',
                'explanation-confirm-main-building': 'Is this the right building?',
                'cannot-find-confirm-main-building': 'This is not the right building',
                'explanation-select-main-building': 'Select the main building',
                'cannot-find-select-main-building': 'I cannot find the main building',
                'explanation-select-secondary-buildings': 'Select secondary building(s)',
                'cannot-find-select-secondary-buildings':
                    'I cannot find some secondary building(s)',
                'explanation-select-parcels': 'Select parcels',
                'cannot-find-select-parcels': 'I cannot find some parcels',
                'tooltip-for-select-parcels':
                    'Click with the mouse on the parcels associated with the house',
                'explanation-view-building-parcels':
                    'These building and parcels were selected',
            },
        },
        footer: {
            text: 'For more information, check out {url}',
            text_tooltip: '',
            data_version: 'Data updated on {data_version}',
        },
        url: {
            rockestate_main: 'https://www.rock.estate',
            rockestate_main_tooltip: '',
            dashboard: '/valuation/default/dashboard',
            dashboard_tooltip: '',
            rockestate_info: 'https://www.rock.estate/',
            rockestate_info_tooltip: '',
            valuation_app: '/valuation/default/',
            valuation_app_tooltip: '',
        },
        export: {
            by: 'Exported by',
            by_tooltip: '',
            date: 'Date',
            date_tooltip: '',
            reference: 'Reference',
            reference_tooltip: '',
        },
        section: {
            reconstruction_value: 'Reconstruction',
            reconstruction_value_tooltip: '',
            address_location: 'Address and location',
            address_location_tooltip: '',
            secondary_buildings: 'Secondary buildings',
            secondary_buildings_tooltip: '',
            economic_activity: 'Economic activity',
            economic_activity_tooltip: '',
            roof: 'Roof',
            roof_tooltip: '',
            transaction: 'Transactions',
            transaction_tooltip: '',
            general: 'General',
            general_tooltip: '',
            report: 'Report',
            report_tooltip: '',
            application: 'Application',
            application_tooltip: '',
            dashboard: 'Dashboard',
            dashboard_tooltip: '',
            dispatcher: 'Dispatcher',
            dispatcher_tooltip: '',
            'user-admin': 'Users',
            'user-admin_tooltip': '',
            apps: 'Apps',
            apps_tooltip: '',
            results: 'Results',
            results_tooltip: '',
            flood_regular: 'Regular flood zones',
            flood_regular_tooltip: '',
            flood_insurance_exclusion: 'Insurance exclusion flood zones',
            flood_insurance_exclusion_tooltip: '',
            helpcenter: 'Help center',
            helpcenter_tooltip: '',
            'faq-search-results': 'Search results',
            'faq-search-results_tooltip': '',
            warnings: 'Warnings',
            warnings_tooltip: '',
            renovation: 'Planned renovation',
            renovation_tooltip: '',
            general_info: 'General info',
            general_info_tooltip: '',
            parcels_and_buildings: 'Parcels and buildings',
            parcels_and_buildings_tooltip: '',
            c_parcels: 'Land',
            c_parcels_tooltip: '',
            c_building: 'Main building',
            c_building_tooltip: '',
            building: 'Building',
            building_tooltip: '',
            secondary_buildings2: 'Secondary buildings',
            secondary_buildings2_tooltip: '',
            building_structure: 'Building structure',
            building_structure_tooltip: '',
            common_parts: 'Common parts',
            common_parts_tooltip: '',
            building_purpose_classification: 'Building purpose & classification',
            building_purpose_classification_tooltip: '',
            parcels: 'Parcel(s)',
            parcels_tooltip: '',
            surroundings: 'Surroundings',
            surroundings_tooltip: '',
            mobility: 'Mobility',
            mobility_tooltip: '',
            interior: 'Interior',
            interior_tooltip: '',
            room: 'Room',
            room_tooltip: '',
            valuations: 'Valuations',
            valuations_tooltip: '',
            reference_properties_location: 'Reference properties: location',
            reference_properties_location_tooltip: '',
            reference_properties_characteristics: 'Reference properties: characteristics',
            reference_properties_characteristics_tooltip: '',
            flood: 'Flood zones',
            flood_tooltip: '',
            energy: 'Energy',
            energy_tooltip: '',
            flood_simple: 'Flood zones',
            flood_simple_tooltip: '',
            faq: 'Frequently asked questions',
            faq_tooltip: '',
            questions_feedback: 'Questions and feedback',
            questions_feedback_tooltip: '',
            contact_info: 'Contact information',
            contact_info_tooltip: '',
            disclaimer: 'Disclaimer',
            disclaimer_tooltip: '',
            heating: 'Heating',
            heating_tooltip: '',
            ventilation: 'Ventilation',
            ventilation_tooltip: '',
            renewables: 'Renewables',
            renewables_tooltip: '',
            additional_consumption: 'Additional consumption',
            additional_consumption_tooltip: '',
            consumers: 'Consumers',
            consumers_tooltip: '',
            energy_consumption_info:
                'Moving to a house or changing insulation levels can affect yearly energy use, so estimate accordingly.',
            energy_consumption_info_tooltip: '',
            house_info: 'House information',
            house_info_tooltip: '',
            consumption: 'Consumption',
            consumption_tooltip: '',
            property_type: 'Building type',
            property_type_tooltip: '',
            address: 'Address confirmation',
            address_tooltip: '',
            insulation: 'Insulation',
            insulation_tooltip: '',
            house_information: 'House information',
            house_information_tooltip: '',
        },
        front: {
            title: 'Property valuation report',
            title_tooltip: '',
            core_title: 'Property report',
            core_title_tooltip: '',
            flood_assessment: {
                title: 'Flood assessment report',
                title_tooltip: '',
            },
        },
        features: {
            renovation_cost: 'Renovation cost (excl VAT)',
            renovation_cost_tooltip: '',
            energetic_renovation_cost: 'Energetic renovation cost (excl VAT)',
            energetic_renovation_cost_tooltip: '',
            energetic_renovation_added_value: 'Energetic renovation added value',
            energetic_renovation_added_value_tooltip: '',
            construction_cost: 'Construction cost (excl VAT)',
            construction_cost_tooltip:
                'The total cost to construct the property including the costs of materials and labour. ',
            parcel_cost: 'Land cost (excl. taxes)',
            parcel_cost_tooltip:
                'The total cost to buy the land where the property will or is being built.',
            building_class: 'Property type',
            building_class_tooltip: 'What type of property is the borrower financing?',
            f_building_type: 'Building type',
            f_building_type_tooltip:
                'Is the Borrower financing a single-family home or an apartment?',
            f_touching_sides: 'Touching sides',
            f_touching_sides_tooltip: '',
            f_number_of_facades: 'House type',
            f_number_of_facades_tooltip: '',
            f_number_of_facades_or_type: 'House type',
            f_number_of_facades_or_type_tooltip:
                'If the construction is expected to have two common walls, select \u201cAttached\u201d, if it will only have one common wall, select \u201cSemi-attached\u201d. Finally, select \u201cDetached\u201d if the construction has no common walls with its neighbours.',
            f_parcel_area: 'Total parcel area',
            f_parcel_area_tooltip:
                'The total area of the parcel(s) selected, as recorded in the cadastre',
            f_building_area: 'Building footprint ',
            f_building_area_tooltip: '',
            f_others: 'Other',
            f_others_tooltip: '',
            f_x_annexes: 'Secondary building(s)',
            f_x_annexes_tooltip: '',
            f_annexes_area: 'Total area of secondary building(s)',
            f_annexes_area_tooltip: '',
            f_area_largest_annex: 'Largest secondary building',
            f_area_largest_annex_tooltip: '',
            distances_annexes: 'Distances to main building',
            distances_annexes_tooltip: '',
            parcel_ids: 'Cadastral reference',
            parcel_ids_tooltip: '',
            f_lng: 'Longitude',
            f_lng_tooltip: '',
            f_lat: 'Latitude',
            f_lat_tooltip: '',
            f_number_of_addresses: 'Number of addresses',
            f_number_of_addresses_tooltip: '',
            f_living_area: 'Living area',
            f_living_area_tooltip:
                'Total living area of the home. This info can be retrieved from the EPC document.',
            f_expected_living_area: '(Expected) living area',
            f_expected_living_area_tooltip:
                'Expected total living area of the property. This information can be found in the specifications or in the blueprints.',
            f_approx_living_area: 'Approximate living area',
            f_approx_living_area_tooltip: '',
            n_rooms: 'Number of rooms',
            n_rooms_tooltip: '',
            approx_n_rooms: 'Approximate number of rooms',
            approx_n_rooms_tooltip: '',
            transaction_value: 'Transaction value',
            transaction_value_tooltip: '',
            transaction_date: 'Transaction date',
            transaction_date_tooltip: '',
            approx_price_sqm: 'Approximate price',
            approx_price_sqm_tooltip: '',
            co2_sqm: 'Greenhouse gas emission',
            co2_sqm_tooltip: '',
            co2_label: 'Greenhouse gas emission label',
            co2_label_tooltip: '',
            f_approx_epc: 'Approximate energy consumption',
            f_approx_epc_tooltip: '',
            f_construction_year: 'Construction year',
            f_construction_year_tooltip:
                'The official year of construction. This does not take into account any renovation works that may have followed at a later point in time. This info can usually be found in the sales ad.',
            f_expected_construction_year: 'Expected year of completion',
            f_expected_construction_year_tooltip:
                'This is the expected year when the property will be ready for move-in. This year can be found on promoter leaflet or specifications if the purchase is from a real estate promoter. If the property will be built by an independent, the year expected for completion of the works should be mentioned in the construction permit.',
            f_epc: 'EPC',
            f_epc_tooltip:
                'The Energy consumption of a property is expressed in kWh/m\u00b2yr and can be found in the EPC cerificate.',
            f_epc_label: 'EPC',
            f_epc_label_tooltip: '',
            f_epc_numeric: 'EPC',
            f_epc_numeric_tooltip: '',
            f_expected_epc: 'Expected EPC after completion',
            f_expected_epc_tooltip:
                'The Energy consumption of a property is expressed in kWh/m\u00b2yr and can be found in the EPC cerificate. For new construction, you can get this information from the EPB certificate. If this is not received by your client at the moment of the request, we will use the minimum legal score allowed for new construction in your region.',
            f_bedrooms: 'Number of bedrooms',
            f_bedrooms_tooltip:
                'Total number of rooms that could serve as bedroom. Kitchen, bathroom and living room should not be included.',
            f_floor: 'Floor',
            f_floor_tooltip:
                'The floor on which the apartment is located. If multiple, select all of them.',
            f_bottom_floor: 'Bottom floor of the building',
            f_bottom_floor_tooltip:
                'The bottom floor of a building is either 0 or a negative number depending on the number of underground floors. \nAssign the value 0 if the building has no floor under the ground/earth level. \nAssign a negative value if the building has a basement/ underground garage/\u2026',
            f_top_floor: 'Top floor of the building',
            f_top_floor_tooltip:
                'The top floor of a building is the last liveable floor of a building. Sometimes it can be in the attic of the building.',
            f_floors: 'Floor(s) of the apartment',
            f_floors_tooltip:
                'Select the floor(s) the apartment is located on in the list generated.\nFor example: for a duplex located on floors 2 and 3, select both floors.',
            f_balcony_present: 'Terrace',
            f_balcony_present_tooltip:
                "You can select 'yes' if the apartment has at least one exterior space. Either a balcony or a terrace on which you can stand on.",
            f_garage_present: 'Garage',
            f_garage_present_tooltip:
                'The apartment can give access to one or multiple parking spaces. This includes both a simple parking spot as well as a garage box, inside or outside.',
            f_n_closed_garage: 'Number of closed garages',
            f_n_closed_garage_tooltip:
                'A closed garage is a box garage that can be indoor or outdoor. Enter the number of closed garages belonging to the assessed apartment.',
            f_n_parking_spot: 'Number of parking spots',
            f_n_parking_spot_tooltip:
                'A parking spot is an outdoor or indoor parking place that is delineated by surface markings and not walls (vs. closed garages).\nEnter the number of parking spots sold with the property assessed.',
            f_cellar_attic: 'Cellar and/or attic',
            f_cellar_attic_tooltip: '',
            f_garden_access: 'Garden',
            f_garden_access_tooltip:
                'The apartment can have access to a private or common garden.',
            f_garden_common: 'Access to a common garden',
            f_garden_common_tooltip:
                'A common garden is only accessible to any tenants of the building where the property is assessed. If there is a common garden, does the apartment assessed give access to it? If it does, select yes.',
            f_garden_private: 'Access to a private garden',
            f_garden_private_tooltip:
                'A private garden is restricted to the tenants of the assessed apartment and is adjacent to the apartment. The difference between a garden and a terrace is that a garden has grass.',
            f_volume: 'Main building volume',
            f_volume_tooltip: '',
            exterior_wall_area: 'Exterior wall area',
            exterior_wall_area_tooltip: '',
            f_roof_area: 'Roof area',
            f_roof_area_tooltip: '',
            f_mean_tilt: 'Mean roof angle',
            f_mean_tilt_tooltip: '',
            f_percent_of_roof_flat: 'Flat roof proportion',
            f_percent_of_roof_flat_tooltip: '',
            f_min_height: 'Minimum roof height',
            f_min_height_tooltip: '',
            f_max_height: 'Maximum roof height',
            f_max_height_tooltip: '',
            f_n_parts: 'Parts of the main building',
            f_n_parts_tooltip: '',
            f_n_roof_panes: 'Roof panes',
            f_n_roof_panes_tooltip: '',
            f_x_matched_entities: 'Known entities at this address',
            f_x_matched_entities_tooltip: '',
            c_economic_activity_class: 'Economic activity class',
            c_economic_activity_class_tooltip: '',
            c_economic_activity_level: 'Economic activity level',
            c_economic_activity_level_tooltip: '',
            f_garden_area: 'Garden area',
            f_garden_area_tooltip: '',
            f_flood_risk: 'Flood risk',
            f_flood_risk_tooltip: '',
            f_dist_building_flood: 'Nearest flood zone',
            f_dist_building_flood_tooltip: '',
            f_parcel_flood_risk: 'Parcel flood risk',
            f_parcel_flood_risk_tooltip: '',
            f_dist_parcel_flood: 'Nearest flood zone to parcel(s)',
            f_dist_parcel_flood_tooltip: '',
            f_flood_risk_insurance_exclusion: 'Flood risk\n(insurance exclusion)',
            f_flood_risk_insurance_exclusion_tooltip: '',
            f_dist_building_flood_insurance_exclusion:
                'Nearest flood zone\n(insurance exclusion)',
            f_dist_building_flood_insurance_exclusion_tooltip: '',
            f_parcel_flood_risk_insurance_exclusion:
                'Parcel flood risk (insurance exclusion)',
            f_parcel_flood_risk_insurance_exclusion_tooltip: '',
            f_dist_parcel_flood_insurance_exclusion:
                'Nearest flood zone to parcel(s) (insurance exclusion)',
            f_dist_parcel_flood_insurance_exclusion_tooltip: '',
            f_flood_risk_composite: 'Composite flood risk',
            f_flood_risk_composite_tooltip: '',
            f_flood_risk_max_parcel: 'Max flood risk of all buildings on Parcel',
            f_flood_risk_max_parcel_tooltip: '',
            epc_source: 'EPC source',
            epc_source_tooltip: '',
            level: 'Level of information',
            level_tooltip: '',
            f_ground_height_above_sea: 'Altitude (above sea level)',
            f_ground_height_above_sea_tooltip: '',
            no_building_picture: 'No graphic image of the building',
            no_building_picture_tooltip: '',
            no_parcel_picture: 'No graphic image of the parcel',
            no_parcel_picture_tooltip: '',
            no_garden_technical_drawing: 'No technical drawing of the garden',
            no_garden_technical_drawing_tooltip: '',
            parcel_selection: 'Parcel selection',
            parcel_selection_tooltip: '',
            vat: 'VAT',
            vat_tooltip: '',
            property_type: 'Building type',
            property_type_tooltip: '',
            insulated_floors: 'Insulated floors',
            insulated_floors_tooltip: '',
            insulated_roof: 'Insulated roof',
            insulated_roof_tooltip: '',
            insulated_walls: 'Insulated walls',
            insulated_walls_tooltip: '',
            window_type: 'Windows insulation',
            window_type_tooltip: '',
            has_attic: 'Attic',
            has_attic_tooltip: '',
            floors_insulation_years: 'Floors insulation year',
            floors_insulation_years_tooltip: '',
            roof_insulation_year: 'Roof insulation year',
            roof_insulation_year_tooltip: '',
            walls_insulation_year: 'Walls insulation year',
            walls_insulation_year_tooltip: '',
            has_basement: 'Basement',
            has_basement_tooltip: '',
            is_attic_heated: 'Attic heated',
            is_attic_heated_tooltip: '',
            epc_score: 'EPC score',
            epc_score_tooltip: '',
            heating_fuel: 'Heating fuel',
            heating_fuel_tooltip: '',
            heating_type: 'Heating type',
            heating_type_tooltip: '',
            heating_installation_year: 'Heating installation year',
            heating_installation_year_tooltip: '',
            ventilation_type: 'Type of ventilation',
            ventilation_type_tooltip: '',
            solar_boiler: 'Solar boiler',
            solar_boiler_tooltip: '',
            solar_panels: 'Solar panels',
            solar_panels_tooltip: '',
            battery: 'Battery',
            battery_tooltip: '',
            air_conditioner: 'Air conditioner',
            air_conditioner_tooltip: '',
            spa_room: 'Spa room',
            spa_room_tooltip: '',
            swimming_pool: 'Swimming pool',
            swimming_pool_tooltip: '',
            electric_vehicle: 'Electric cars',
            electric_vehicle_tooltip: '',
            n_residents: 'Number of people living in the house',
            n_residents_tooltip: '',
            protected_consumer: 'Protected consumer?',
            protected_consumer_tooltip: '',
            yearly_electricity_consumption: 'Yearly electric consumption',
            yearly_electricity_consumption_tooltip: '',
            gas_consumption_approx: 'Yearly gas consumption',
            gas_consumption_approx_tooltip: '',
            insulation_material: 'Insulation material',
            insulation_material_tooltip: '',
            heat_pump_type: 'Heat pump type',
            heat_pump_type_tooltip: '',
            pv_type: 'Type of solar panel',
            pv_type_tooltip: '',
        },
        disclaimer: {
            avm_tooltip: '',
            dvm:
                'This valuation report is the result of a remote assessment of the property by a real estate valuer. The valuer did not visit the property but relied on various data sources and a statistical model to make an independent valuation of the property. For more information regarding this valuation approach, please refer to the final page of this report.',
            dvm_tooltip: '',
            ovm:
                'This valuation report is the result of an on-site assessment of the property by a real estate expert. The independent valuation has been based on the property situation observed by the expert, and is further supported by a statistical model. For more information regarding this valuation approach, please refer to the final page of this report.',
            ovm_tooltip: '',
            epc_unavailable_1:
                'I confirm that there is no valid EPC certificate, and that this EPC estimate is for this property',
            epc_unavailable_1_tooltip: '',
            epc_unavailable_2:
                'I confirm the purpose of this request is refinancing or reinstatement',
            epc_unavailable_2_tooltip: '',
            part_1:
                'This valuation has been completed for the purpose expressed herein, no responsibility is accepted in the event of this report being used for any other purpose or by any other party than to whom it is addressed. Should any other party wish to use or rely upon this report for any purpose they must first obtain our written consent.\n',
            part_1_tooltip: '',
            part_2:
                'The publication of this report, in whole or in part, is prohibited without the written approval of Rock.estate. The copyright of this report at all times remains the property of Rock.estate. This report may not be assigned to a third party without the express consent of the owner of the copyright.',
            part_2_tooltip: '',
            reconstruction_value_title: 'Reconstruction value computation',
            reconstruction_value_title_tooltip: '',
            reconstruction_value:
                "Reconstruction value is the total cost to reconstruct a building considering the current construction requirements. The calculation includes VAT and cost of an architect, is independent on the location, and does not include demolishment works nor secondary buildings. As a result, it is possible to have a reconstruction value \nhigher than the market value. The reconstruction value is based on an {index_type} index of {index_value}{'.'}",
            reconstruction_value_tooltip: '',
            part_3:
                'In making this valuation report we express no opinion as to, and accept no liability for, the ability and willingness of the proposed mortgagor to meet his/her/its commitments under the proposed loan.',
            part_3_tooltip: '',
        },
        document: {
            purpose_tooltip: '',
            ers_report: 'ERS report',
            ers_report_tooltip: '',
            epc_certificate: 'EPC certificate | EPC certificates',
            epc_certificate_tooltip: '',
            exterior_picture: 'Exterior picture |\u00a0Exterior pictures',
            exterior_picture_tooltip: '',
            building_blueprint: 'Building blueprint | Building blueprints',
            building_blueprint_tooltip: '',
            specifications: 'Specifications',
            specifications_tooltip: '',
            cadastral_plan: 'Cadastral plan | Cadastral plans',
            cadastral_plan_tooltip: '',
            sales_agreement: 'Sales agreement | Sales agreements',
            sales_agreement_tooltip: '',
            expected_epc: 'Expected EPC',
            expected_epc_tooltip: '',
        },
        common: {
            select_one: 'Select',
            select_one_tooltip: '',
            floor: 'Floor',
            floor_tooltip: '',
            cancel: 'Cancel',
            cancel_tooltip: '',
            new: 'New',
            new_tooltip: '',
            save: 'Save',
            save_tooltip: '',
            edit: 'Edit',
            edit_tooltip: '',
            total: 'Total',
            total_tooltip: '',
            previous: 'Previous',
            previous_tooltip: '',
            next: 'Next',
            next_tooltip: '',
            refresh: 'Refresh',
            refresh_tooltip: '',
            back: 'Back',
            back_tooltip: '',
            price: 'Price',
            price_tooltip: '',
            module: 'Module',
            module_tooltip: '',
            uploading: 'Uploading',
            uploading_tooltip: '',
            go_to_consumption_next: 'Go to Consumption',
            go_to_consumption_next_tooltip: '',
            lets_get_started: 'Let\u2019s get started!',
            lets_get_started_tooltip: '',
            go_to_consumption:
                '<h2>Got it !</h2><p>With this information we can estimate the EPC score and recommend suitable renovations.</p>',
            go_to_consumption_tooltip: '',
            thank_you_so_far:
                "Got it! Let's now have a look at the building's energy performance.",
            thank_you_so_far_tooltip: '',
            yes: 'Yes',
            yes_tooltip: '',
            no: 'No',
            no_tooltip: '',
            number_input: 'Enter the energy score here',
            number_input_tooltip: '',
            multiple_choice: 'Select one of the options',
            multiple_choice_tooltip: '',
            we_are_sorry: 'We are sorry.',
            we_are_sorry_tooltip: '',
            sorry: 'Oops!',
            sorry_tooltip: '',
            enter_address: 'Enter address here',
            enter_address_tooltip: '',
            back_to_ing: 'Back to ING website',
            back_to_ing_tooltip: '',
            maintenance:
                'This website is currently in maintenance. We welcome you back soon!',
            maintenance_tooltip: '',
            send: 'Send',
            send_tooltip: '',
            start_now: 'Start now',
            start_now_tooltip: '',
            i_dont_know: "I don't know",
            i_dont_know_tooltip: '',
        },
        info: {
            data_from_customer: 'data input by customer',
            data_from_customer_tooltip: '',
        },
        autocomplete: {
            enter_address: 'Enter address here',
            enter_address_tooltip: '',
            address_not_found: 'The address is not in the list',
            address_not_found_tooltip: '',
            enter_parcel: 'Enter parcel ID here',
            enter_parcel_tooltip: '',
            parcel_not_found: 'The parcel ID is not in the list',
            parcel_not_found_tooltip: '',
            enter_dual: 'Enter address or parcel ID here',
            enter_dual_tooltip: '',
            dual_not_found: 'The address or parcel ID is not in the list',
            dual_not_found_tooltip: '',
        },
        dvm_features: {
            style_of_house: 'Building style',
            style_of_house_tooltip: '',
            exterior_state: 'Exterior state of the property',
            exterior_state_tooltip: '',
            facade_material: 'Facade material',
            facade_material_tooltip: '',
            roof_material: 'Roof material',
            roof_material_tooltip: '',
            n_roof_windows: 'Number of roof windows',
            n_roof_windows_tooltip: '',
            n_roof_dormers: 'Number of dormers',
            n_roof_dormers_tooltip: '',
            solar_panel: 'Solar panels',
            solar_panel_tooltip: '',
            solar_panel_area: 'Number of solar/photovoltaic panels',
            solar_panel_area_tooltip: '',
            f_building_listed: 'Is the building listed for historical purposes?',
            f_building_listed_tooltip: '',
            garden_orientation: 'Orientation of garden',
            garden_orientation_tooltip: '',
            garden_arrangement: '(Potential of) garden arrangement',
            garden_arrangement_tooltip: '',
            garden_common_arrangement: '(Potential of) common garden arrangement',
            garden_common_arrangement_tooltip: '',
            f_swimming_pool: 'In-ground exterior swimming pool',
            f_swimming_pool_tooltip: '',
            f_swimming_pool_area: 'Exterior swimming pool size',
            f_swimming_pool_area_tooltip: '',
            environment: 'Environment',
            environment_tooltip: '',
            public_transport: 'Public transport',
            public_transport_tooltip: '',
            education: 'Education',
            education_tooltip: '',
            recreation: 'Recreation, sports, culture',
            recreation_tooltip: '',
            shops: 'Shops & services',
            shops_tooltip: '',
            healthcare: 'Healthcare',
            healthcare_tooltip: '',
            direct_traffic_level: 'Level of direct street traffic',
            direct_traffic_level_tooltip: '',
            indirect_traffic_level: 'Proximity of indirect street traffic',
            indirect_traffic_level_tooltip: '',
            surroundings: 'Description of the surroundings',
            surroundings_tooltip: '',
            other_positive: 'Other elements having a positive impact',
            other_positive_tooltip: '',
            other_positive_details: 'Additional comment ',
            other_positive_details_tooltip: '',
            other_negative: 'Other elements having a negative impact',
            other_negative_tooltip: '',
            other_negative_details: 'Additional comment ',
            other_negative_details_tooltip: '',
            remarks: 'Remarks of the Valuation Specialist',
            remarks_tooltip: '',
            internal_remarks: 'Internal remarks',
            internal_remarks_tooltip: '',
        },
        ovm_features: {
            garages: 'Closed garages',
            garages_tooltip: '',
            parkings: 'Parking spots',
            parkings_tooltip: '',
            pool_house: 'Pool house',
            pool_house_tooltip: '',
            pool_house_area: 'Pool house area',
            pool_house_area_tooltip: '',
            barn: 'Barn',
            barn_tooltip: '',
            barn_area: 'Barn area',
            barn_area_tooltip: '',
            stables: 'Stables',
            stables_tooltip: '',
            stables_area: 'Stables area',
            stables_area_tooltip: '',
            common_parts_state: 'General state of common parts',
            common_parts_state_tooltip: '',
            interior_state: 'General state of the interior',
            interior_state_tooltip: '',
            apartment_quotity: 'Quotity',
            apartment_quotity_tooltip: '',
            reserve_savings: 'Savings in reserve fund',
            reserve_savings_tooltip: '',
            comfort: 'Comfort & equipment',
            comfort_tooltip: '',
            common_comfort: 'Comfort & equipment',
            common_comfort_tooltip: '',
            interior_positive: 'Other elements having a positive impact',
            interior_positive_tooltip: '',
            interior_negative: 'Other elements having a negative impact',
            interior_negative_tooltip: '',
        },
        fixed: {
            parcels_and_building_shapes: 'Shape of parcel and building',
            parcels_and_building_shapes_tooltip: '',
            parcels_shapes: "Parcel's shapes",
            parcels_shapes_tooltip: '',
        },
        '': {
            f_distance_to_street: 'Distance to middle of the street',
            f_distance_to_street_tooltip: '',
        },
        global: {
            comments: 'Comments',
            comments_tooltip: '',
            commons: {
                before: 'before',
                between: 'between {min} and {max}',
                after: 'after',
            },
            map: {
                aerial_view: 'Aerial view',
                cadastral_view: 'Cadastral view',
                flood_zone_low: 'Regular flood zone Low',
                flood_zone_medium: 'Regular flood zone Medium',
                flood_zone_high: 'Regular flood zone High',
                exclusion_flood_zone: 'Insurance exclusion flood zones',
                swimming_pools: 'Swimming pools',
                street_name: 'Street name',
            },
            shared: {
                placeholder: {
                    streetname: 'Enter the street name of your domicile',
                    streetnumber: 'Enter house number',
                    postalcode: '4-digit postal code',
                    municipality: 'Municipality',
                    vat: 'Enter VAT Number',
                    'company-name': 'Enter company name',
                    'contact-email': 'Enter your email',
                },
                resend_email: 'Resend email',
                email_notification: 'Email sent successfully',
                edit_email: 'Edit email',
                streetname: 'Street name',
                streetnumber: 'House number',
                boxnumber: 'Box number',
                postalcode: 'Postal code',
                municipality: 'Municipality',
                vat: 'VAT number',
                name: 'Name',
                email: 'Email',
                company: 'Company (if applicable)',
                customer_ref_modal: {
                    title:
                        'There already is a valuation request with the same internal reference.',
                    content:
                        'To view this existing request, click on the Dashboard button below:',
                    cta: 'Do you want to proceed with the duplicated reference?',
                    dashboard: 'View in dashboard',
                    continue: 'Continue',
                },
                january: 'January',
                february: 'February',
                march: 'March',
                april: 'April',
                may: 'May',
                june: 'June',
                july: 'July',
                august: 'August',
                september: 'September',
                october: 'October',
                november: 'November',
                december: 'December',
                flanders: 'Flanders',
                wallonia: 'Wallonia',
                brussels: 'Brussels',
            },
            action: {
                confirm: 'Confirm',
            },
            helpcenter: {
                video_tutorials: 'Video tutorials',
                faq: 'FAQ',
                question: "Can't find what you're looking for?",
                contact_cta: 'Contact us',
                contact_form: {
                    title: 'Ask for support',
                    content:
                        "If you can't find what you are looking for in the FAQ, we'll be happy to help. Tell us what the problem is and we'll get back to you as soon as possible.",
                    'subject_req-invoice': 'Request an invoice',
                    subject_label: 'Subject',
                    'subject_req-failing': 'My request keeps failing',
                    'subject_req-not-eval-yet': 'My request has not been evaluated yet',
                    'subject_req-back-to-draft':
                        'My request is back under "Draft" status but all the information are correct',
                    'subject_cant-download-val-report':
                        "I can't download the report of my request",
                    'subject_req-not-in-dashboard':
                        'My request does not appear in my dashboard',
                    'subject_cancel-req': 'I want to cancel my request',
                    subject_other: 'Other',
                    other_label: 'Fill out your reason',
                    customer_ref: 'Internal reference of the loan',
                    not_specific_req: 'This is not about a specific request',
                    message: 'Your question',
                    screenshot_label: 'Add screenshots',
                    screenshot_info:
                        'Due to security reasons, only files with the following formats can be shared with Rock.estate: .jpg, .jpeg, .png',
                    submit: 'Send',
                    feedback_title: 'Thank you for reaching out',
                    feedback_content:
                        "We'll be in touch shortly with a solution for your problem or answer to your question.",
                    close: 'Close',
                    ing: 'LOP ID',
                },
            },
            errors: {
                no_valuers_in_region:
                    'There are no valuers available in your region. Please contact us via support@rock.estate to find a solution.',
            },
        },
        section_data: {
            room: {
                type: 'Room type',
                type_tooltip: '',
                living_area: 'Area',
                living_area_tooltip: '',
                comment: 'Comments',
                comment_tooltip: '',
            },
        },
        footnote: {
            no_renovation_included:
                'All values are computed for the current state of the property and do not take into account any planned renovations',
            no_renovation_included_tooltip: '',
            avm: 'Automatic valuation',
            avm_tooltip: '',
            q25: '25th percentile',
            q25_tooltip: '',
            q75: '75th percentile',
            q75_tooltip: '',
        },
        reference_properties_location: {
            explanation_1:
                'The valuation of this property relies on {num_references} reference properties which have been selected in the property\u2019s neighbourhood (within a distance of {reference}_radius km). Each reference property shares a number of similarities in terms of location, size and other characteristics with the property under valuation. The underlying statistical model of this valuation is based on a Geographically Weighted Regression (GWR) where reference properties in the immediate proximity of the valued property receive a larger weighting compared to reference properties which are located further away.',
            explanation_1_tooltip: '',
            explanation_2:
                'The map below gives on overview of the location of the reference properties and their respective distance versus the valued property. The color gradient on the map gives a good indication of the average market value of properties in the area.',
            explanation_2_tooltip: '',
        },
        reference_properties_characteristics: {
            explanation_1:
                'A property has various objective characteristics that contribute to its price, such as location, size and energy efficiency. The charts below compare some of these characteristics of this property with those of the reference properties in the area.',
            explanation_1_tooltip: '',
            property_characteristics: 'Property characteristics',
            property_characteristics_tooltip: '',
            properties_in_the_area: 'Properties in the area',
            properties_in_the_area_tooltip: '',
        },
        flood: {
            explanation_1:
                'Overview of the official flood zones in the proximity of the property. Several categories of flood risk are calculated according to different flood risk scenarios, varying from Low to High.',
            explanation_1_tooltip: '',
            check_ground_floor: {
                title: 'Does the apartment include the ground floor ?',
                yes_info: 'The ground floor is part of the apartement unit',
                no_info: 'The ground floor is not part of the apartement unit',
                tooltip:
                    'The ground floor refers to the floor of the building that is at street level',
            },
            flood_page: {
                title: 'Flood risk assessment',
                download_report: 'Download Flood risk report',
                contextual_message_building_risk_high:
                    'This building is at high risk of flooding as it is located just {distance} meters from an insurance exclusion zone. Due to the elevated flood risk, providing a loan for this property is not desirable.',
                contextual_message_parcel_risk_high:
                    'This parcel is at high risk of flooding as it is located just {distance}  meters from an insurance exclusion zone. Due to the elevated flood risk, providing a loan for this property is not desirable.',
                contextual_message_risk_none: 'The flood risk is accepted',
                contextual_message_risk_high_not_ground_floor:
                    'The flood risk is accepted since the apartment do not include ground floor',
                open_map: 'Open flood map',
                more_information:
                    'For more detailed information about regular flood risk, please refer to the report.',
                proceed_valuation: 'Proceed with valuation',
            },
            confirm_decision_popup: {
                title: 'Insurance exclusion flood risk',
                message:
                    'The property is situated in an insurance exclusion flood zone, potentially leading to frequent and/or severe flooding. A loan for this property may be refused.',
                confirmation:
                    'Do you want to proceed with the valuation of the property?',
                yes_proceed: 'Yes, proceed with valuation',
            },
        },
        faq: {
            q_incorrect_valuation:
                'The address of the valued property is incorrect, what should I do?',
            q_incorrect_valuation_tooltip: '',
            a_incorrect_valuation:
                "It seems that something must have gone wrong when selecting the address, the building or the parcels related to the property. You can review the address information via the following link: {url}.dashboard{'.'}",
            a_incorrect_valuation_tooltip: '',
            q_incorrect_characteristics:
                'The address of the valued property is correct, but some of the other characteristics in this valuation report are incorrect, what should I do?',
            q_incorrect_characteristics_tooltip: '',
            a_incorrect_characteristics:
                'If you believe that some information  in this report may substantially differ from the actual situation, which could lead to a material impact on the valuation of the property, follow this link {url}.dashboard to review and clarify the incorrect/missing information.',
            a_incorrect_characteristics_tooltip: '',
            q_transaction_vs_market_value:
                'Why is the transaction price I paid different from the market value determined in this report?',
            q_transaction_vs_market_value_tooltip: '',
            a_transaction_vs_market_value_dvm:
                "This valuation report is the result of the remote assessment of the property in question by a real estate expert, supported by a data-driven statistical model. The report should give an accurate indication of the expected value of the property, based on the information at hand. Since the valuer did not actually visit the property, it can happen that the impact of certain, specific, property characteristics has not been fully reflected in the estimated transaction price. Please have a look at our information page via the following link: {url}.rockestate_info{'.'}",
            a_transaction_vs_market_value_dvm_tooltip: '',
            a_transaction_vs_market_value_ovm:
                "This valuation report is the result of the assessment of a real estate expert, supported by a data-driven statistical model. The report should give an accurate indication of the expected value of the property, based on the information at hand. Since the valuer did actually visit the property, the impact of certain, specific, property characteristics should be fully reflected in the estimated transaction price. Please have a look at our information page via the following link: {url}.rockestate_info{'.'}",
            a_transaction_vs_market_value_ovm_tooltip: '',
            q_loan_accepted:
                'Now that I have received my valuation report, does that mean my loan application was accepted?',
            q_loan_accepted_tooltip: '',
            a_loan_accepted:
                'We have shared this valuation report with you and your bank. This valuation report will be used by the bank as one of the elements in its credit risk approval process. The final decision remains theirs. Rock.estate is not involved in any way in this decision.',
            a_loan_accepted_tooltip: '',
            'what-is-avm_tooltip': '',
            'what-is-avm_question': 'What is an automatic valuation?',
            'what-is-avm_answer':
                'A Statistical Valuation Method is any form of mathematical tool that can be used to estimate a property value through deterministic computations.\n\nRock.estate uses a Comparables-Based Automated Valuation Model (CBAVM or simply AVM). CBAVMs select recently listed comparable assets to build a regression model and deliver an estimation for the given property. \n\nAutomatic Valuations are by design automatic: they are performed remotely without any human intervention.',
            'what-is-dvm_tooltip': '',
            'what-is-dvm_question': 'What is a remote valuation? ',
            'what-is-dvm_answer':
                'A remote valuation - or "Desktop Valuation" - is performed by a Real Estate Expert remotely (also called Valuation Specialist), without physically visiting the property. The Valuation Specialist relies on several data sources, a statistical model and any information provided by the Appicant.\n\nA successful Desktop Valuation combines a strong data-driven model with a Valuation Specialist\'s expertise. This is a valid alternative to traditional On-site Valuations for the majority of residential real estate.',
            'what-is-ovm_tooltip': '',
            'what-is-ovm_question': 'What is an on-site valuation? ',
            'what-is-ovm_answer':
                'An On-site Valuation is the traditional valuation where a Valuaiton Specialist physically visits the property to fully describe it and estimate its value. Compared with AVMs and DVMs, this offers the most complete view on a property and its value. It is also the most resource intensive valuation service.',
            'why-ovm_tooltip': '',
            'why-ovm_question':
                'Why does the property have to be valued on-site and not remotely?',
            'why-ovm_answer':
                'Remote valuation is not feasible in the following scenarios:\n\n- If the decision is made to refrain from conducting a remote valuation. This choice may be influenced by factors such as the property possessing exceptional characteristics or a lack of adequate data and information.\n\n- When the property falls outside the parameters defined by the bank for remote valuations, such as being too costly, categorized as non-residential, or requiring significant renovations.',
            'what-is-dashboard_tooltip': '',
            'what-is-dashboard_question': 'What is the Dashboard?',
            'what-is-dashboard_answer':
                "The Dashboard is the page on Rock.estate's application where you can consult all your requests and related meta-data such as creation or modification date, current status, etc. Users with the right access roles can also see colleagues' requests. This is useful if the ownership of a request (temporarily) needs to be transferred, e.g. during holidays.\n\nThe Dashboard allows you to take the following actions:\n- View and complete draft requests\n- Review submitted requests\n- Download reports of completed (valued) requests\n- Take ownership of requests from a colleague (if applicable)",
            'what-is-draft_tooltip': '',
            'what-is-draft_question':
                'What happens when my request is under the status "Draft"?',
            'what-is-draft_answer':
                'The Draft status is used in two cases: \n\n1. For both Energy renovation simulations and Valuation requests: You are waiting on missing information from the client to complete the questionnaire. Therefore, you decided to temporarily pause the process and save the request as a "Draft". Submit the request once it is complete.\n2. For Valuation requests only: A Valuation Specialist found incoherent information that they wish to flag. Please review the information and correct if needed. Re-submit the request once it is reviewed/corrected.',
            'when-report_tooltip': '',
            'when-report_question': 'When can I expect to receive the valuation report?',
            'when-report_answer':
                '\nAnticipate the delivery of the valuation report within two business days following the on-site inspection conducted by our valuation expert.',
            'how-download-report_tooltip': '',
            'how-download-report_question': 'How can I download the valuation report?',
            'how-download-report_answer':
                'You will receive an email notification once the report has been submitted by our expert. This email will contain a link to download the report.',
            'market-price-incorrect_tooltip': '',
            'market-price-incorrect_question':
                'The market price in the report is incorrect',
            'market-price-incorrect_answer':
                'If the market value given by the Valuation Specialist does not match the transaction price of the loan request:\n- Make sure the assessed property is the correct one;\n- Double check the accuracy of all inputs;\n- If the inputs are correct, reach out to your manager for advice on the next steps.\n\nIf after a review you still find the deviation is too large, please get in touch with us through our contact form to get additional info.',
            'issue-parcels_tooltip': '',
            'issue-parcels_question':
                'The parcels shown in the report do not match with the property',
            'issue-parcels_answer':
                'If the parcel(s) selected for the valuation is(are) not correct, this might come from a wrong selection during the data entry process. \n\nClick on "View request" next to the relevant request in your Dashboard and review the inital input.\n\nIf the input is correct, please inform us via our contact form as it is an essential feature impacting the value of the property.',
            'old-picture-or-3d_tooltip': '',
            'old-picture-or-3d_question':
                'The property has significantly changed compared to the pictures or 3D model in the valuation report',
            'old-picture-or-3d_answer':
                'If pictures in the report do not match the reality, please reach out via our contact form.',
            'report-language_tooltip': '',
            'report-language_question': 'How can I get the report in another language?',
            'report-language_answer':
                "For Valuation requests, the valuation report matches the language selected in the app when submiting the request. If you want a different language, please resubmit the request in that language. Keep in mind that the Valuation Specialist's remarks will not be translated as they are written manually during valuation.\n\nFor Energy renovation simulations, to get a report in another language, go to the Report page and choose your preferred language from the top right corner. You can then download the report in your chosen language.",
            'wrong-pictures_tooltip': '',
            'wrong-pictures_question':
                'The photo on the valuation report does not correspond to the assessed building.',
            'wrong-pictures_answer':
                'The street view on the report is selected by Google and sometimes does not represent the assessed property. It does not mean that the valuer assessed the wrong property. If you have access to the web report, the street view image is actually interactive and you can move in the street.',
            sharing_tooltip: '',
            sharing_question: 'Can I share the report with my client?',
            sharing_answer:
                'It depends on the internal policies of your company. We recommend discussing it with the management. To share a report with a client, download it by clicking on the green button "PDF Report" in your Dashboard next to the request. \nIn the case of Energy renovation simulations, click on the "Share" button on the simulation page. This will generate an email containing a link to the results. You can send this link to your client. Please note that your client will not be able to change any input.',
            'remarks-language_tooltip': '',
            'remarks-language_question':
                'Why do the remarks in the valuation report not change accordingly to the language of the dashboard if the rest of the report does?',
            'remarks-language_answer':
                "When an Applicant request a valuation in a specific language (e.g: French), the remark will be written either in the selected language or English. If the applicant change the language after submitting its request, the language of the remarks won't changed accordingly as it is not automated. ",
            'appeal-missing-feature_tooltip': '',
            'appeal-missing-feature_question':
                'The valuation specialist did not take into account one element (solar panels, extra parcel, swimming pool,...)',
            'appeal-missing-feature_answer':
                'If the valuation specialist did not take into account an element that could potentially impact the value of the property, please reach out via our contact form to let us know.\nElement considered as potentially important are the following:\n- Address\n- Building area\n- Parcel area\n- EPC\n- Living area\n- Construction year\n- Number of bedrooms\n- Apartment floor(s)\n- Presence of a private or common garden\n- Terrace\n- External Swimming pool\n- Solar panel(s)\n- Historical classification of the property (fa\u00e7ade or full buiding)\n- Flood zones\n- Secondary buildings\n- Presence of parking or closed garage',
            'ING-how-ovm-request_tooltip': '',
            'ING-how-ovm-request_question': 'How can I request an on-site valuation?',
            'ING-how-ovm-request_answer':
                "Currently, it is not possible to submit directly an on-site valuation request. We only perform on-site valuations for the properties that are within scope for remote valuations, but where our expert decides that a remote valuation is not possible.\n\nIn such instances, you will receive an email requesting the borrower's contact details. This is necessary for us to proceed with the appointment scheduling and payment.",
            'where-customer-ref_tooltip': '',
            'where-customer-ref_question':
                'Where can I find the internal reference of the loan?',
            'where-customer-ref_answer':
                'This reference is internal to the bank and we suggest you to copy/paste this reference from your loan origination/creation system.',
            'building-type-apartment-building_tooltip': '',
            'building-type-apartment-building_question':
                'How can I request a valuation for an apartment buidling?',
            'building-type-apartment-building_answer':
                'Rock.estate does not value Apartment buildings. A request of this kind will result in an on-site valuation and will not be valuated.',
            'address-not-found_tooltip': '',
            'address-not-found_question':
                "Rock.estate's application does not recognize the address of the property in scope.",
            'address-not-found_answer':
                'If the automatically selected building is not correct, you can click on \u201cThis is not the right building\u201d to manually select a different building on the map.\nIf the auto-complete does not work and/or the application cannot find the address, please select the option \u201cI cannot find my building\u201d and follow the instructions.',
            'building-not-found_tooltip': '',
            'building-not-found_question':
                'The building automatically selected is not the right building. What should I do?',
            'building-not-found_answer':
                'If you cannot find the building, you can follow the procedure:\n-Click on "This is not the right building" and the platform will allow you to select another one.\n-If you still cannot select/find it, click on "I cannot find the main building" and you will be redirected to a new page. On this page, you\'ll have to provide extra information such as the size of the plot, the size of the building and the number of touching sides. ',
            'find-epc_tooltip': '',
            'find-epc_question': 'Where can I find the EPC of a property?',
            'find-epc_answer':
                'A valid EPC certificate is a mandatory document when selling a property. If the client cannot provide this information, please consider checking the sales advertisement or the online database for [Flanders](https://apps.energiesparen.be/zoek-een-epc) or [Brussels](https://www.peb-epb.brussels/certificats-certificaten/). An EPC score is not mandatory to create an Energy renovation simulation.',
            'epc-label-vs-number_tooltip': '',
            'epc-label-vs-number_question':
                'EPC: Is it better to give the label (letter from A to G) or to give the exact kWh/sqm-yr?',
            'epc-label-vs-number_answer':
                'The valuation depends heavily on the location, parcel, liveable space, construction year, and the EPC score. Therefore, we recommend to enter the request with the exact EPC score in kWh/sqm-yr. \nIf you only have the label letter from A to G, we will value the property taking the average score of the each label that will result in an approximate result of the market value of the property.',
            'find-living-area_tooltip': '',
            'find-living-area_question':
                'Where can I find the correct living area of a property?',
            'find-living-area_answer':
                'You can find the living area in several documents linked to the property such as a sale agreement, or an EPC certificate. Please note that any secondary building/basement/unused attic are not included as liveable space and, therefore, as a living area. ',
            'find-box-number_tooltip': '',
            'find-box-number_question':
                'Where can I find the box number of an apartment?',
            'find-box-number_answer':
                "A box number of an apartment is a part of the address that should be stated in the sale agreement or in the EPC certificate. If you're not sure of this information, please reach out to the borrower and complete the request once you have the information.",
            'find-construction-year_tooltip': '',
            'find-construction-year_question': 'Where can I find the construction year?',
            'find-construction-year_answer':
                'You can usually find the official construction year in the sales ad, cadastral register, or the EPC certificate. Remember, it is the year the building was first constructed and does not include later renovations.',
            'construction-vs-renovation_tooltip': '',
            'construction-vs-renovation_question':
                'The property has been totally remodeled: what should be the construction year, the orginal one or the date of the makeover?',
            'construction-vs-renovation_answer':
                'Please provide the year the building was originally constructed, not the year of any later renovations. We do consider renovations using the EPC certificate and other relevant sources.',
            'over-two-days_tooltip': '',
            'over-two-days_question':
                'It is more than 2 business days and my request is still not valued, what should I do?',
            'over-two-days_answer':
                'Working days at Rock.estate are from Monday to Friday. \nYou might have counted Saturday or a public holiday in the 2 business working day you are referring to. \n\nIf not, reach out via our contact form with the reference number. ',
            'right-info-flagged-incorrect_tooltip': '',
            'right-info-flagged-incorrect_question':
                'What happens if the Valuation Specialist flagged an information input in the request as "incorrect" but I know this is the right information?',
            'right-info-flagged-incorrect_answer':
                'If you have receive back a request under the status "Draft", it means that Rock.estate valuation specialist has flagged 1 or more information as "incorrect". If you know this/these information is indeed correct you can either decide to re-submit the request as it is or contact us via our contact form. ',
            'incoherent-submitted-twice_tooltip': '',
            'incoherent-submitted-twice_question':
                'What happens after a valuation is sent back twice with "incorrect information"?',
            'incoherent-submitted-twice_answer':
                'After 2 reviews by the Rock.estate valuation team, an on-site valuation will be recommended automatically. ',
            'processing-time_tooltip': '',
            'processing-time_question':
                'How long does it take for a request to be processed? ',
            'processing-time_answer':
                'It should not take more than 2 business working day for a request to be processed. \nRock.estate accounts business working days as follow:\n- From Monday to Friday (9am to 5pm)\n- Bank & Public Holidays are excluded\n\nIf a request is submitted on a Friday 7pm, for example, the first business working day will be the next Monday (except if it is a bank or public holiday)',
            'multiple-addresses_tooltip': '',
            'multiple-addresses_question':
                'Is it normal that there is more than one address for one building?',
            'multiple-addresses_answer':
                'Yes, sometimes a building will have more than one address. You can select the building with the address corresponding to your request. ',
            'what-is-bedroom_tooltip': '',
            'what-is-bedroom_question': 'What is a bedroom?',
            'what-is-bedroom_answer':
                'A bedroom is a room with a mininum of 8 sqm. and with a window. ',
            'what-is-garden_tooltip': '',
            'what-is-garden_question': 'What is a common garden?',
            'what-is-garden_answer':
                'A common garden is only accessible to the occupants of the building. It does not need to be closed but the assessed property needs to give the right to use this garden. ',
            'what-is-private-garden_tooltip': '',
            'what-is-private-garden_question': 'What is considered as a private garden?',
            'what-is-private-garden_answer':
                'A private garden is only accessible by the occupants of the assessed apartment and is adjacent to the apartment.',
            'what-is-closed-garage_tooltip': '',
            'what-is-closed-garage_question': 'What is a closed garage?',
            'what-is-closed-garage_answer':
                'A closed garage/ garage box can either be outside the building or inside an underground parking as long as there is a door that closes and that its access is only resticted to occupants of the assessed property. ',
            'what-is-parking-spot_tooltip': '',
            'what-is-parking-spot_question': 'What is a parking spot?',
            'what-is-parking-spot_answer':
                'A parking spot can either be indoor or outdoor and that is delineated by lines not walls (vs. closed garage)',
            'what-is-cellar-basement_tooltip': '',
            'what-is-cellar-basement_question': 'What is a cellar/basement?',
            'what-is-cellar-basement_answer':
                "Any room that is not counted in the liveable space that you can use as storage within the building. Examples: basement, maid's room, cellar, ...",
            carport_tooltip: '',
            carport_question: 'Does a carport refer to a parking spot or a garage?',
            carport_answer: 'A carport refers to a parking spot not a closed garage. ',
            'personal-use_tooltip': '',
            'personal-use_question': 'Can I request a valuation of my own property?',
            'personal-use_answer':
                'Rock.estate\u2019s Valuation Application can be used for professional purpose only.\nIt is the responsibility of each authorized user to comply with this. Hence, we do not recommend you to request a valuation of your own property or from someone you know.',
            'is-request-submitted_tooltip': '',
            'is-request-submitted_question':
                'How do I see if I successfully submitted my request?',
            'is-request-submitted_answer':
                "Once you have succesfully submitted your request, the status of the request in your Dashboard should change to 'Submitted'. \nYou will also receive an email informing you that the request has been submitted and one of our valuation specialists will process it within two working days.",
            review_tooltip: '',
            review_question:
                'The request I submited came back as a Draft in red, what am I supposed to do?',
            review_answer:
                'If you have received back a request under the status "Draft", it means that Rock.estate valuation specialist has flagged 1 or more information as "incorrect". If you know this/these information is indeed correct you can either decide to re-submit the request as it is or contact us via our contact form. ',
            'find-previous-request_tooltip': '',
            'find-previous-request_question': 'How can I find a previous request?',
            'find-previous-request_answer':
                'To find a previous request, go to your Dashboard and use the searching toolbar. You can enter a date, a reference, an internal reference, an address etc.',
            'download-report_tooltip': '',
            'download-report_question': 'How can I download the report?',
            'download-report_answer':
                "To download the report, you can click on the green box next to your request called 'PDF report'.  \nIt will only be available, after your request has been successfully valued by Rock.estate valuation team.",
            'language-impact_tooltip': '',
            'language-impact_question':
                'Does it change anything to the process if I use Rock.estate Valuation Application in a different language?',
            'language-impact_answer':
                'If you request a valuation in one language, you will receive a report of that property in the same language. You can change the language of the report but the remark will stay in the original language.\nThere will be no impact on the data or the market value of a property.',
            'unsubmission-window_tooltip': '',
            'unsubmission-window_question':
                'How can I modify a request after submission?',
            'unsubmission-window_answer':
                'To edit a request after submitting, go to your Dashboard and click "Edit." For Valuation requests, you have 60 minutes to edit or delete it after submission. For Energy renovation simulations, click "Edit input" at the top right of the result page. After editing, be sure to click "Submit" to save your changes.',
            'after-sixty-minutes_tooltip': '',
            'after-sixty-minutes_question':
                'After 60 minutes of submission, what can I do if I need to edit my request?',
            'after-sixty-minutes_answer':
                'If you want to edit or cancel a request after 60 minutes, let us know as soon as possible via our contact form. This request could be charged depending on the progress of the Valuation Specialist.',
            'review-billing_tooltip': '',
            'review-billing_question':
                'My request came back as a Draft, does that mean that the bank will have to pay twice for this request?',
            'review-billing_answer':
                'No, the bank will only be charged once after the request is successfully valued or recommended for an onsite valuation. \nIf after two reviews from Rock.estate valuation team it can not be successfully remotely valued, a recommendation for an on-site valuation will be performed. ',
            'access-requests_tooltip': '',
            'access-requests_question':
                'How can I have access to the requests of my colleagues?',
            'access-requests_answer':
                'You only have access to your own requests. A manager can have access to the requests of their employees. ',
            substitution_tooltip: '',
            substitution_question:
                'How can I take the ownership of a request that is not mine?',
            'what-is-ers_tooltip': '',
            'what-is-ers_question': 'What is an Energy renovation simulation?',
            'what-is-ers_answer':
                'Rock.estate\u2019s Energy Renovation Simulator is a powerful tool that estimates the current EPC score of a residential property and proposes relevant renovation scenarios based on its energy characteristics. In just a few minutes, users can explore which renovations best fit their personal goals and the specifics of the building.\n\nAfter filling out a questionnaire, the simulator estimates which energy improvements will meet a target EPC score, while optimizing return-on-investment. The estimate is derived from the user inputs, combined with the building data and the technical building requirements in Belgium. Accurate completion of the questionnaire enhances the precision of the EPC score estimate.\n\nIt is important to note that the results are indicative. They do not substitute an official EPC certificate, nor do they provide definitive renovation recommendations. Always consult a professional for personalized advice.',
            'what-is-common-wall_tooltip': '',
            'what-is-common-wall_question': 'What is a common wall?',
            'what-is-common-wall_answer':
                'A shared wall, also known as a common wall, is often found between the two neighbouring properties. It acts as a dividing barrier that separates and connects two interconnected buildings, belonging to both properties. These walls are usually insulated and do not require additional insulation. Within a house, multiple common walls can exist, each being shared with either one or different neighbouring houses.',
            'what-is-protected-volume_tooltip': '',
            'what-is-protected-volume_question': 'What is the protected volume?',
            'what-is-protected-volume_answer':
                'A protected volume is the inside space of your house that you want to protect from heat losses. This includes heated rooms, and sometimes attics and basements. The goal is to keep a constant temperature inside.',
            'what-is-living-area_tooltip': '',
            'what-is-living-area_question': 'What is the heated living area?',
            'what-is-living-area_answer':
                'The heated living area refers to the total floor area that is a part of the heated volume. This includes all rooms that you wish to prevent from heat losses. Therefore, the basement is generally excluded. Include the attic space in case it is a heated room. You can find the usable floor area in the EPC certificate.',
            'apartment-ers_tooltip': '',
            'apartment-ers_question':
                'How can I request an Energy Renovation Simulation for an apartment or an apartment building?',
            'apartment-ers_answer':
                'Currently, the Energy Renovation Simulator is not available for residential apartments or apartment buildings. Our team is actively working to expand the scope of the simulator to include these property types in the future. We appreciate your understanding and patience as we strive to enhance the capabilities of our service.',
            'no-3d-model-ers-quality_tooltip': '',
            'no-3d-model-ers-quality_question':
                'The 3D model could not be found. Are the results relevant?',
            'no-3d-model-ers-quality_answer':
                'Our 3D models enable direct observation of certain features, eliminating the necessity for user input. In the absence of a 3D model, we seek this information from the user. If accurate values are given, the valuation is as valid as it would be with a 3D model.',
            'what-is-renovation-goal_tooltip': '',
            'what-is-renovation-goal_question':
                'I have to select a renovation goal. What is that?',
            'what-is-renovation-goal_answer':
                'Homeowners pursue energy-efficient renovations for various reasons including environmental sustainability, energy bill reduction, comfort improvement, and property value enhancement. Regardless of the motivation, the objective often translates into a desired EPC score, budget, or specific renovation selections.\n\nOur platform recommends the most effective renovation plan tailored to client goals, offering three distinct options:\n\n- Target EPC: Ideal for achieving a specific EPC score, it suggests the most cost-effective renovations to meet your goal.\n- Budget: Share your budget, and receive the renovation package that maximizes energy efficiency within your financial constraints.\n- Click & Choose: For personalized renovation needs, select your preferred improvements manually, crafting a tailored plan.',
            'missing-renovation-option_tooltip': '',
            'missing-renovation-option_question':
                "I don't find all renovation options (e.g. insulation for interior wall, ceiling, etc.). Why is that?",
            'missing-renovation-option_answer':
                'For some renovation options, it is highly recommended to consult a professional. For example, with interior wall insulation or ceiling insulation, there is a risk of thermal bridges or condensation if not properly assessed technically. On the other hand, insulating floors in intermediate levels might not always be the most cost-effective choice. To avoid providing inaccurate advice from our automated simulator to the best of our ability, we have chosen not to present all possible options today. If a professional still recommends certain renovations, the budget in the simulator might be an overestimate. We select renovations that are applicable to most homes and have the greatest positive impact on the property. If we notice a demand for it, we can expand the number of offered renovation options.',
            'choosing-insulation-material_tooltip': '',
            'choosing-insulation-material_question':
                'Am I able to choose the insulation material for each renovation?',
            'choosing-insulation-material_answer':
                'Currently, the option to choose specific insulation materials for each renovation is not available. However, it is important to note that we carefully select materials commonly used for each type of insulation. This is a feature we are looking forward to incorporating in the future. We understand the importance of customization and we want to provide you with the best flexibility possible.',
            'own-property-ers_tooltip': '',
            'own-property-ers_question':
                'Can I submit an Energy Renovation Simulation of my own property?',
            'own-property-ers_answer':
                'Rock.estate\u2019s platform is intended for professional purposes only. It is the responsibility of every authorized user to comply with this. Hence, we do not recommend you submit a simulation of your own property or from someone you know. Please keep in mind that it is essential to respect the intended use of the service.',
            'estimated-epc-different-than-actual-epc_tooltip': '',
            'estimated-epc-different-than-actual-epc_question':
                'The estimated EPC score is different from the official EPC score.',
            'estimated-epc-different-than-actual-epc_answer':
                "There are a number of reasons why the estimated EPC score can deviate:\n\n- Please confirm the accuracy of the selected property and the information provided.\n- An EPC certificate is valid for 10 years. Certain renovations, like adding roof insulation or upgrading the heating system, can impact home's energy efficiency and EPC score. If the score is estimated after the certificate was issued, the document becomes outdated. \n- The EPC simulator assumes a single heating system for the total protected volume and uniform glazing with the standard windows. Multiple heating systems and variations in glazing insulation values can impact the actual EPC score. Additionally, the simulator assumes consistent insulation across all exterior walls. However, if certain walls are insulated while others are not, the EPC score may be affected.\n- When the 3D model is unavailable, we rely on the additional questions to accurately estimate the dimensions. Variations resulting from the house's actual shape, like ceiling heights and roof orientation, can influence surfaces and volume. This effect is more pronounced when the building footprint is absent. Building updates can also impact surfaces and volume, thus rendering the 3D model outdated and affecting the EPC score.\n- If the insulation materials used during construction or renovation exceeded the industry standards at the time of installation, the actual EPC score might surpass the estimated score.\n\n",
            'how-is-vat-computed_tooltip': '',
            'how-is-vat-computed_question': 'How is VAT computed?',
            'how-is-vat-computed_answer':
                "In line with the federal taxation legislation, 6% VAT is applicable to renovate houses that are older than 10 years, otherwise 21% VAT is applicable. You're only eligible for 6% VAT if a contractor conducts the works. For solar panels and heat pumps, 6% VAT is applicable for houses younger than 10 years until the end of 2023.",
            'price-ers-includes_tooltip': '',
            'price-ers-includes_question':
                'What\u2019s included in the price of a renovation?',
            'price-ers-includes_answer':
                'Prices include VAT, insulation materials, and works.\n\nMore precisely: \n- Exterior roof insulation includes the demolition of the roof covering- and structure, demolition of gutters, installation of insulation and a vapour barrier, placement of the roof structure and -covering, working around roof vents, placement of gutters, removing and reinstalling solar panels if already present and a crane or hoist.\n- Interior roof insulation includes the removal of the degraded insulating layer (including vapor barrier), installation of a new insulating layer and a vapor barrier, and adjustments around the roof plane and dormer windows.\n- Attic floor insulation includes the installation of insulation and vapor barrier, modifications to the existing pipes and lighting, and access adjustment.\n- Exterior wall insulation includes breaking down rainwater drainage, sawing off sills, installing insulation, placement of finishes (in crepi), updating openings (including sills), carrying out edits, enlarge roof projection, renewing rainwater drainage, and scaffolding.\n- Wall cavity insulation includes the use of an aerial work platform, installation of 5 cm mineral wool insulation, including inspection, preparation, blowing in and closing the openings.                \n- Windows include the demolition and installation of glass (with surcharge for hoisting equipment), demolition and installation of the frame, installation of RTO on the glass, and demolition and installation of the glass.\n- Heat pump includes demolition of the existing generator, installation of a heat pump (with soil water, including drilling), connecting it to the existing generator and insulating non-insulated pipes. Additional costs will apply for replacing the climate system.                \n- Condensing gas boilers include the removal of the existing generator, installation of a condensing gas boiler, linear cost of a condensing boiler based on the boiler capacity, connection to the existing generator, additional costs for replacing the distribution system, and insulation of uninsulated pipes.\n- Solar panels include installation of solar panels including all accessories.    ',
            'incorrect-region_tooltip': '',
            'incorrect-region_question': 'The region is incorrect.',
            'incorrect-region_answer':
                'We understand that accurately identifying your location is crucial. It is important to note that the same address can exist in multiple cities.\n\nWhen entering the address of your property, make sure to select the appropriate city among the options provided. Then, carefully review the address details you have entered to prevent any inaccuracies.\n\nSome municipalities lay on the borders of different regions, which may create inconsistencies. If you find one, please contact us via support.',
            'interaction-between-renovations_tooltip': '',
            'interaction-between-renovations_question':
                'Why does adding one renovation sometimes unselect another I already had?',
            'interaction-between-renovations_answer':
                'Our tool returns an optimal combination of upgrades to meet a target EPC score at minimal cost. From a cost perspective, it is not optimal to combine certain renovation items as they serve similar purposes or may counteract each other\u2019s effects. The automatic deselection of counterproductive renovation combinations ensures that your investment leads to the best outcomes in terms of return-on-investment.\n\nFor example, if you are insulating the roof from the interior, it might not be necessary to insulate it from the exterior as well.',
            'ers-reliability_tooltip': '',
            'ers-reliability_question':
                'How reliable are the figures stated in the report?',
            'ers-reliability_answer':
                "The figures provided in the report are indicative. They are calculated based on user input and various sources on market pricing. They do not replace an official EPC certificate or professional advice. Prices can vary depending on the condition of the house and the materials chosen for renovation. The more accurate the user input is, the more realistic the results are. It is important to note that the estimates represent today's market conditions and may be subject to change over time. For exact figures, it is recommended to consult a professional as these calculations can be affected by various factors.",
            'report-measurements-dont-match_tooltip': '',
            'report-measurements-dont-match_question':
                'The measurements in the report do not match the property',
            'report-measurements-dont-match_answer':
                'There could be a few reasons for the inconsistencies you are observing. Please note that you have the option to enter building dimensions manually by selecting \u201cThis is not the right building\u201d and following the instructions.\n\n- The 3D model may not reflect the current state of the house (for instance, changes were recently made: adding a room, etc.).\n- The 3D model of a chosen house was not your actual house.\n- The living area was not correct.\n- The 3D model was not available. We used the responses to additional questions to approximate building measurements, but these may be different from the actual dimensions of the property.\n- The surface areas of the windows and the roof are approximated based on the construction standards, which may differ from reality.\n',
            'how-to-create-val-req_tooltip': '',
            'how-to-create-val-req_question': 'How to create a Valuation request',
            'how-to-create-val-req_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/e1e6ecce-a8b7-4425-9d2a-bd5d355a37f9" loading="lazy" title="Synthesia video player - How to start a Valuation request" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-access-app_tooltip': '',
            'how-to-access-app_question': "How to access Rock.estate's applications",
            'how-to-access-app_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/0b3b14d4-ae8f-4ab5-9bdc-71cc0a7f244b" loading="lazy" title="Synthesia video player - How to access Rock.estate\'s applications" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-use-dashboard_tooltip': '',
            'how-to-use-dashboard_question':
                'How to use the dashboard for Valuation requests',
            'how-to-use-dashboard_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/d138270a-19cc-43eb-8ba4-97f7275caf40" loading="lazy" title="Synthesia video player - How to use dashboard for valuation requests" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'what-is-val-report_tooltip': '',
            'what-is-val-report_question': 'What is the valuation report?',
            'what-is-val-report_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/6f3af77c-3aac-438a-803b-0fd550382581" loading="lazy" title="Synthesia video player - The valuation report" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-const_tooltip': '',
            'how-to-create-req-const_question':
                'How to create a request for a construction plot',
            'how-to-create-req-const_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/8e121e6a-1d1a-444a-ba7b-3cbd45f91e57" loading="lazy" title="Synthesia video player - How to create a request for a construction plot" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-new-house_tooltip': '',
            'how-to-create-req-new-house_question':
                'How to create a request for a new house',
            'how-to-create-req-new-house_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/95d74ca1-13c4-42e1-bd35-bb0280761ca1" loading="lazy" title="Synthesia video player - How to create a request for a new house" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-existing-house_tooltip': '',
            'how-to-create-req-existing-house_question':
                'How to create a request for an existing house',
            'how-to-create-req-existing-house_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/20813b72-86cb-4fab-be4b-9993cb520327" loading="lazy" title="Synthesia video player - How to create a request for an existing house" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-new-qpqrtment_tooltip': '',
            'how-to-create-req-new-qpqrtment_question':
                'How to create a request for a new apartment',
            'how-to-create-req-new-qpqrtment_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/baaa6686-2977-40e9-88c7-4d0f28d5d320" loading="lazy" title="Synthesia video player - How to create a request for a new apartment" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-req-existing-apartment_tooltip': '',
            'how-to-create-req-existing-apartment_question':
                'How to create a request for an existing apartment',
            'how-to-create-req-existing-apartment_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/20813b72-86cb-4fab-be4b-9993cb520327" loading="lazy" title="Synthesia video player - How to create a request for an existing house" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-confirm-address-existing-prop_tooltip': '',
            'how-to-confirm-address-existing-prop_question':
                'How to confirm the address, building and parcel for an existing property',
            'how-to-confirm-address-existing-prop_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/adaf14ec-bbc8-4916-8a41-3b28549a43a1" loading="lazy" title="Synthesia video player - How to confirm the address, building and parcel selection for an existing property" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-confirm-address-prop-under-const_tooltip': '',
            'how-to-confirm-address-prop-under-const_question':
                'How to confirm the address and parcel for a property under construction',
            'how-to-confirm-address-prop-under-const_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/5cf12e6a-a55b-4a3f-841a-4caa155649d8" loading="lazy" title="Synthesia video player - How to confirm the address and parcel for a property under construction" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-ers-req-3D_tooltip': '',
            'how-to-create-ers-req-3D_question':
                'How to create an ERS request with 3D model',
            'how-to-create-ers-req-3D_answer':
                '<div style="position: relative; overflow: hidden; padding-top: 56.25%;"><iframe src="https://share.synthesia.io/embeds/videos/59ec70a8-f074-4f16-9265-6c9c068d6043" loading="lazy" title="Synthesia video player - How to create an ERS request with 3D model" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-ers-req-2D_tooltip': '',
            'how-to-create-ers-req-2D_question':
                'How to create an ERS request with 2D footprint',
            'how-to-create-ers-req-2D_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/caeea1e6-1968-47bc-a1ea-76bdb7c7c0a7" loading="lazy" title="Synthesia video player - How to create an ERS request with 2D footprint" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-to-create-ers-req-building-not-found_tooltip': '',
            'how-to-create-ers-req-building-not-found_question':
                'How to create an ERS request when the building could not be found',
            'how-to-create-ers-req-building-not-found_answer':
                '<div style="position: relative; overflow: hidden; aspect-ratio: 1920/1080"><iframe src="https://share.synthesia.io/embeds/videos/a36b0550-f792-471b-8c89-ee8cff89a1cb" loading="lazy" title="Synthesia video player - How to create an ERS request when the building could not be found" allow="encrypted-media; fullscreen;" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0; margin: 0; overflow:hidden;"></iframe></div>',
            'how-total-investment-cost-calculated_tooltip': '',
            'how-total-investment-cost-calculated_question':
                'How is the total investment cost calculated?',
            'how-total-investment-cost-calculated_answer':
                'The total investment cost of a renovation item includes expenses for demolition, transport, materials, and installation with finishes. We determine the materials required based on the building\u2019s geometry (surface, volume, orientation, pitch, etc). For instance, solar panels are placed on the roof pane with the optimal orientation for sunlight, and the capacity aligns with electricity consumption needs. The price including VAT takes into account 6% or 21% in line with the regulator\u2019s taxation. Total prices are rounded to the nearest hundreds.  \n\n## Costs are based on data from the following sources:\n- EPC method for average price indications (by Vlaams Energieagentschap)\n- UPA \u2013 BUA (Beroepsunie van architecten)\n- Archindex (publishes building material prices for engineers/architects)\n- ASPEN (independent and objective source on price information for contractors)\n- ABEX Borderel (reference to price insurance premiums and fire policies)\n- Input from the market (providers/ contractors)\n- Online resources  \n \nThere are various reasons why a quote from your contractor may deviate from the estimated total investment cost. A difference of 20-25% between the cheapest and most expensive offer in the market is not uncommon. It is therefore advisable to ask for quotes from multiple providers before making a decision. \n\n## Here is a non-exhaustive list of factors that influence costs:\n- Quality of materials\n- Total surface\n- Choice of technology\n- Thickness of insulation\n- Power/ Capacity\n- Brand\n- Combined with other works (e.g. removing asbestos)  \n\nNote that regional disparities, such as variances in transport and infrastructure installation costs between urban and rural areas, are not factored into the prices. Any pre-requisite works necessary to make the renovation technically feasible are not included in the total investment cost. \n\nTo see what\u2019s included in the total investment cost, download a renovation report of a specific scenario. The report also gives insights into the choice of materials and technology, and the surface.',
            payment_tooltip: '',
            payment_question: 'How much does an on-site valuation cost?',
            payment_answer:
                'The cost of an on-site valuation is determined according to the characteristics of the property. The price corresponding to the characteristics of the property will be communicated to the borrower during the booking of the appointment for the on-site valuation.',
            'payment-methods_tooltip': '',
            'payment-methods_question': 'Which payment methods are accepted?',
            'payment-methods_answer':
                'The following payment methods are accepted:\n- Bancontact\n- Visa\n- Mastercard',
            'why-payment-before_tooltip': '',
            'why-payment-before_question':
                'Why do I have to pay for the valuation before the appointment?',
            'why-payment-before_answer':
                'By securing payment beforehand, we can immediately deliver your detailed valuation report right after our expert completes the on-site visit, offering you the quickest and most efficient experience possible.',
            'when-appointment_tooltip': '',
            'when-appointment_question': 'When will the property be valued?',
            'when-appointment_answer':
                'As a borrower, when you receive an invitation link from Rock.estate, you have the opportunity to schedule your assessment appointment at your convenience. By following the link, you can choose the day and time that suits you best. Please be sure to be available at that time, as there will be no refunds for no-shows on the day of the assessment.',
            Reschedule_tooltip: '',
            Reschedule_question: 'Can I reschedule my appointment?',
            Reschedule_answer:
                'You can reschedule your appointment by contacting us via support@rock.estate. Please already provide your availabilities and leave your phone number. We will contact you to schedule a new appointment.\n\nNo fees are incurred for rescheduling or cancelling appointments if done more than 24 hours in advance. Changes made within 24 hours will be subject to a 50% charge, and in case of a no-show without prior notice, the entire fee will not be refunded. Please refer to our FAQ for additional details.',
            cancel_tooltip: '',
            cancel_question: 'Can I cancel my appointment?',
            cancel_answer:
                'You can cancel your appointment by contacting us via support@rock.estate. \n\nNo fees are incurred for rescheduling or cancelling appointments if done more than 24 hours in advance. Changes made within 24 hours will be subject to a 50% charge, and in case of a no-show without prior notice, the entire fee will not be refunded. Please refer to our FAQ for additional details.',
            present_tooltip: '',
            present_question: 'Do I have to be present during the valuation?',
            present_answer:
                'You or a representative of your choice must be present during the valuation, in order to give the expert access to the property.',
            timing_tooltip: '',
            timing_question: "When will I know the expert's exact arrival time?",
            timing_answer:
                'The expert will arrive within the 1h30 time slot that you have selected for your appointment. The expert can contact you prior to the visit with a more detailed arrival time. ',
            'borrower-contact-expert_tooltip': '',
            'borrower-contact-expert_question': 'How do I contact the expert?',
            'borrower-contact-expert_answer':
                'If you have a question for the expert, you can contact our helpdesk via support@rock.estate. ',
            'borrower-contact-who_tooltip': '',
            'borrower-contact-who_question':
                'Who can I contact if the expert is not on-site at the time of the valuation?',
            'borrower-contact-who_answer':
                'You can contact our helpdesk via support@rock.estate. For urgent matters please leave your phone number and we will reach out to you.',
            'bank-agent-contacted_tooltip': '',
            'bank-agent-contacted_question':
                'My client has informed me that he/she/their representative will not be able to attend the appointment. What should I do?',
            'bank-agent-contacted_answer':
                'Please contact us or advice your client to reach out to us via support@rock.estate. We can reschedule or cancel the appointment if needed.',
            'how-contact-RE_tooltip': '',
            'how-contact-RE_question': "How can I reach Rock.estate's contact center?",
            'how-contact-RE_answer': 'Please contact us via support@rock.estate. ',
            'contact-representative_tooltip': '',
            'contact-representative_question':
                'How can I contact the customer directly to let him know my arrival time or my delay?',
            'contact-representative_answer':
                "Please go to your appointment overview via your dashboard. You can see the borrower's contact details and/or the contact details of the representative.",
            'how-link-calendar_tooltip': '',
            'how-link-calendar_question':
                'How do I link my calendar (Google, icloud, Office 365, Exchange, Outlook.com)?',
            'how-link-calendar_answer':
                'Please go to the "On-site Valuer" page to open your settings and click on "Availability". You will see the section to link your calendar account. ',
            'Several-calendars_tooltip': '',
            'Several-calendars_question': 'Can I link several calendars?',
            'Several-calendars_answer':
                'Yes, you can add multiple calendar accounts and we will take all of them into account.',
            'How-availabilities_tooltip': '',
            'How-availabilities_question': 'How do I register my work availabilities?',
            'How-availabilities_answer':
                "After linking your calendar, you can choose multiple regions where you work. In the 'availability' section below, you can set your working hours for each region. We will only consider your calendar during those designated hours.",
            'Different-regions_tooltip': '',
            'Different-regions_question': 'Can I work in different regions?',
            'Different-regions_answer':
                'Yes, you have the flexibility to choose multiple regions for each time slot or create separate time slots for different regions.',
            'How-different-regions_tooltip': '',
            'How-different-regions_question':
                'How can I put my availabilities in different regions on the same day?',
            'How-different-regions_answer':
                'Please select multiple regions within one availability slot. We will consider all the regions selected during your designated hours within that slot.',
            'How-register-regions_tooltip': '',
            'How-register-regions_question':
                "How do I register the region(s) I'll be working in?",
            'How-register-regions_answer':
                "Please select one or more regions within the 'district' section in your availability settings.",
            'How-appointment-assigned_tooltip': '',
            'How-appointment-assigned_question': 'How is an appointment assigned to me?',
            'How-appointment-assigned_answer':
                "Within your selected regions and working hours, the linked calendar(s) are taken into consideration. Every available time slot of at least 1 hour and 30 minutes is regarded as 'available.'\n\nWhen booking an appointment, the customer sees all availabilities for the upcoming week based on their address. The customer can choose a time slot of 1 hour and 30 minutes.\n\nIs this chosen time slot within your availability? If so, the request is assigned to you. Confirm the appointment no later than 24 hours after receiving the invitation. Contact the customer to share your exact arrival time within this time slot.\n\nNotabene: These availabilities remain anonymous, the customer will not know which availabilities are linked to which expert.",
            'Forgot-confirmation_tooltip': '',
            'Forgot-confirmation_question':
                "I didn't confirm the appointment in the 24 hours after receiving the notification, but I'd like to do the valuation. What should I do?",
            'Forgot-confirmation_answer':
                'Please contact us directly via support@rock.estate. If no other valuer has been assigned, you will still be able to confirm the valuation.',
            'Optimize-appointments_tooltip': '',
            'Optimize-appointments_question':
                "How can I optimize my day? For example, I have two appointments booked for 1h30 each, but the locations are very close to each other and I'd like to get to the second appointment more quickly.",
            'Optimize-appointments_answer':
                'You have the freedom to organize your visit within the 1-hour and 30-minute time slot, provided you inform the borrower. For instance, you can conduct your first visit in the last 30 minutes of the initial time slot and your second visit in the first 30 minutes of the subsequent time slot.',
            'Where-view-appointments_tooltip': '',
            'Where-view-appointments_question':
                'Where can I find the list of my appointments?',
            'Where-view-appointments_answer':
                "You can go to your settings and select the 'Appointments' tab. Additionally, you can check your Dashboard to view outstanding and confirmed requests.",
            'Where-confirm_tooltip': '',
            'Where-confirm_question':
                'Where can I find the appointments I need to confirm?',
            'Where-confirm_answer':
                "You can go to your settings and select the 'Appointments' tab. Additionally, you can check your Dashboard to view outstanding and confirmed requests.",
            'Flood-zones_tooltip': '',
            'Flood-zones_question': 'Where does the data on flood zones come from?',
            'Flood-zones_answer':
                'Our flood zones are based on open Geodata and regional maps. ',
            'Parcel-area_tooltip': '',
            'Parcel-area_question': 'How is the total parcel area calculated?',
            'Parcel-area_answer':
                'The total parcel area is based on open Geodata (cadastre).',
            'Building-footprint_tooltip': '',
            'Building-footprint_question': 'How is the Building footprint calculated?',
            'Building-footprint_answer':
                'The building footprint is based on open Geodata (cadastre).',
            'Garden-area_tooltip': '',
            'Garden-area_question': 'How is the Garden area calculated?',
            'Garden-area_answer':
                'The garden area is calculated by subtracting the building area from the parcel area.',
            'Living-area_tooltip': '',
            'Living-area_question': 'How is the Living area calculated?',
            'Living-area_answer':
                "The living area provided by the bank agent is derived from the EPC certificate. It represents the 'gross' living area, excluding interior walls and similar structures.",
            'Approximate-Living-area_tooltip': '',
            'Approximate-Living-area_question':
                'How is the Approximate living area calculated?',
            'Approximate-Living-area_answer':
                'We estimate the living area of a house based on its volume and structure. The volume is determined through 3D Lidar scans of the property.',
            'Different-living-area_tooltip': '',
            'Different-living-area_question':
                "Why the Approximate living area doesn't correspond to the Living area?",
            'Different-living-area_answer':
                'We did not visit the property, and it is purely based on estimation. We estimate the living area of a house based on its volume and structure. The volume is determined through 3D Lidar scans of the property.',
            'EPC-certificate_tooltip': '',
            'EPC-certificate_question': 'Where can I find the EPC certificate?',
            'EPC-certificate_answer':
                "If the bank agent uploaded the EPC certificate, you can view it in the valuer tool. Please go to the general information tab, and you will find it in the 'State' section.",
            'Market-value_tooltip': '',
            'Market-value_question': 'How is the market value calculated?',
            'Market-value_answer':
                'Our market value is calculated by a Comparables-Based Automated Valuation Model (CBAVM), abbreviated as AVM. Using an address and property characteristics, we automatically identify the (200-250) most similar properties in our dataset. Our model compares all these properties using Geographically Weighted Regression (GWR). GWR is a form of linear regression that incorporates spatial information, assigning higher weights to nearby houses when estimating the price.',
            'Forced-sale-value_tooltip': '',
            'Forced-sale-value_question': 'How is the Forced Sale Value calculated?',
            'Forced-sale-value_answer':
                'This estimation typically discounts between 10% to 40% of the estimated transaction price, depending on the observed features. ',
            'Monthly-rental-value_tooltip': '',
            'Monthly-rental-value_question': 'How is monthly rental value calculated?',
            'Monthly-rental-value_answer':
                'The monthly rental value is calculated using the same method as the market value, but with consideration for rental prices in our dataset.',
            'Reconstruction-value_tooltip': '',
            'Reconstruction-value_question': 'How is Reconstruction value calculated?',
            'Reconstruction-value_answer':
                'The reconstruction value is calculated based on the volume and complexity of the building.',
            'Reference-points_tooltip': '',
            'Reference-points_question':
                'Where do the data for the reference points come from?',
            'Reference-points_answer':
                'Currently, our data reference points are derived from ad listings. Please note that the displayed prices represent asking prices, not transaction prices. In the near future, we will also incorporate available transaction prices within this dataset.',
        },
        questions_feedback: {
            explanation_1:
                'Do you have a specific question or comment regarding this report? Or are you just looking for some more information on how Rock.estate makes these valuation?',
            explanation_1_tooltip: '',
            explanation_2: "Please visit our valuation portal: {url}.valuation_app{'.'}",
            explanation_2_tooltip: '',
        },
        punctuation: {
            ':': ':',
            ':_tooltip': '',
        },
        status: {
            draft: 'Draft',
            draft_tooltip: '',
            submitted: 'Submitted',
            submitted_tooltip: '',
            completed: 'Completed',
            completed_tooltip: '',
            valued: 'Valued',
            valued_tooltip: '',
            'awaiting-onsite': 'Awaiting onsite',
            'awaiting-onsite_tooltip': '',
            cancelled: 'Cancelled',
            cancelled_tooltip: '',
            canceled: 'Cancelled',
            canceled_tooltip: '',
            pending_confirmation: "Waiting for expert's confirmation",
            pending_confirmation_tooltip: '',
            failed: 'Failed',
            failed_tooltip: '',
            confirmed: 'The expert has confirmed the appointment',
            confirmed_tooltip: '',
        },
        renovation_info: {
            title: 'Renovation Quotations',
            title_tooltip: '',
            add_document: 'Add document',
            add_document_tooltip: '',
            unlink_document: 'Unlink document',
            unlink_document_tooltip: '',
            link_document: 'Link document',
            link_document_tooltip: '',
            items: '{n} item|{n} items',
            items_tooltip: '',
            linked_items: '{n} linked item|{n} linked items',
            linked_items_tooltip: '',
        },
        renovation_item: {
            title: 'Title',
            title_tooltip: '',
            amount: 'Amount',
            amount_tooltip: '',
            category: 'Category',
            category_tooltip: '',
            subcategory: 'Subcategory',
            subcategory_tooltip: '',
            modal_title: 'Edit renovation item',
            modal_title_tooltip: '',
        },
        renovation_category: {
            energy: 'Energy',
            energy_tooltip: '',
            structural: 'Structural',
            structural_tooltip: '',
            aesthetic: 'Aesthetic',
            aesthetic_tooltip: '',
            other: 'Other',
            other_tooltip: '',
        },
        renovation_subcategory: {
            insulation: 'Insulation',
            insulation_tooltip: '',
            solar_panel: 'Solar panel',
            solar_panel_tooltip: '',
            heating: 'Heating',
            heating_tooltip: '',
            other: 'Other',
            other_tooltip: '',
            wall_extension: 'Wall extension',
            wall_extension_tooltip: '',
            demolition: 'Demolition',
            demolition_tooltip: '',
            kitchen: 'Kitchen',
            kitchen_tooltip: '',
            bathroom: 'Bathroom',
            bathroom_tooltip: '',
        },
        steps: {
            customer_ref: 'Customer reference',
            customer_ref_tooltip: '',
            building_type: 'Building type',
            building_type_tooltip: 'Is it a single-family house or an apartment?',
            address: 'Address',
            address_tooltip: '',
            address_confirmation: 'Address confirmation',
            address_confirmation_tooltip:
                'To estimate the costs and benefits of renovations it is necessary to gather certain information on the building, e.g. the pitch, surface and orientation of the roof for solar panels.',
            building_selection: 'Building selection',
            building_selection_tooltip: '',
            house_info: 'House information',
            house_info_tooltip: '',
            building_dimensions: 'Building dimensions',
            building_dimensions_tooltip: '',
            epc: 'EPC',
            epc_tooltip: '',
            construction_year: 'Construction year',
            construction_year_tooltip:
                'The official year of construction. This does not take into account any renovation works that may have followed at a later point in time. This info can usually be found in the sales ad, the reference year in the EPC certificate or the cadastral register.',
            living_area: 'Living area',
            living_area_tooltip:
                'Total living area of the home in terms of the total heated square footage.Therefore it generally does not include the basement. It includes the attic in case this is a heated room. This info can usually be found in the sales ad or the heated square footage in the EPC certificate.',
            energy_performance: 'Energy performance',
            energy_performance_tooltip: '',
            insulation: 'Insulation',
            insulation_tooltip: '',
            wall_insulation: 'Walls',
            wall_insulation_tooltip: '',
            roof_insulation: 'Roof',
            roof_insulation_tooltip: '',
            floor_insulation: 'Floor',
            floor_insulation_tooltip: '',
            window_glazing: 'Windows',
            window_glazing_tooltip: '',
            attic: 'Attic',
            attic_tooltip: '',
            basement: 'Basement',
            basement_tooltip: '',
            energy_consumption: 'Consumption',
            energy_consumption_tooltip: '',
            heating: 'Heating',
            heating_tooltip: '',
            electricity_consumption: 'Electric consumption',
            electricity_consumption_tooltip: '',
            gas_consumption: 'Gas consumption',
            gas_consumption_tooltip: '',
            oil_consumption: 'Oil consumption',
            oil_consumption_tooltip: '',
            coal_consumption: 'Coal consumption',
            coal_consumption_tooltip: '',
            wood_consumption: 'Wood consumption',
            wood_consumption_tooltip: '',
            pellets_consumption: 'Pellets consumption',
            pellets_consumption_tooltip: '',
            district_heating_consumption: 'District heating consumption',
            district_heating_consumption_tooltip: '',
            solar_panels: 'Solar panels',
            solar_panels_tooltip: '',
            ventilation: 'Ventilation',
            ventilation_tooltip: '',
            consumers: 'Consumers',
            consumers_tooltip: '',
            big_consumers: 'Big consumers',
            big_consumers_tooltip: '',
            electric_vehicles: 'Electric cars',
            electric_vehicles_tooltip: '',
            processing: 'Processing',
            processing_tooltip: '',
            finish: 'Finish',
            finish_tooltip: '',
        },
        property_type: {
            apartments: 'Apartments',
            apartments_tooltip: '',
            coming_soon: "The app does not work for apartments yet. It's coming soon! ",
            coming_soon_tooltip: '',
            select_type: 'Enter the address here',
            select_type_tooltip: '',
            title: 'Confirm the type of property',
            title_tooltip: '',
        },
        out_of_bounds_page: {
            title: 'We did not find any data on the requested address',
            title_tooltip: '',
            '3d_model_not_found_subtitle':
                "With a few more questions we can approximate the building measurements. Let's get started!",
            '3d_model_not_found_subtitle_tooltip': '',
            '3d_model_not_found':
                'It looks like we could not find this building\u2019s 3D model',
            '3d_model_not_found_tooltip': '',
            content_tooltip: '',
            button: 'Try another address',
            button_tooltip: '',
            ing_button: 'Return to ING',
            ing_button_tooltip: '',
        },
        terms_page: {
            welcome: 'n/a',
            welcome_tooltip: '',
            epc: 'n/a',
            epc_tooltip: '',
            disclaimer: 'n/a',
            disclaimer_tooltip: '',
        },
        features_question: {
            insulated_floors: 'Is the ground floor or basement ceiling insulated?',
            insulated_floors_tooltip: '',
            insulated_roof: 'Is the roof insulated?',
            insulated_roof_tooltip: '',
            insulated_walls: 'Are the facades insulated?',
            insulated_walls_tooltip: '',
            has_attic: 'Do you have an attic?',
            has_attic_tooltip: '',
            insulation_floors_when: 'When was the most recent insulation renovation?',
            insulation_floors_when_tooltip: '',
            insulation_roof_when: 'When was the most recent insulation renovation?',
            insulation_roof_when_tooltip: '',
            insulation_walls_when: 'When was the most recent insulation renovation?',
            insulation_walls_when_tooltip: '',
            has_basement: 'Is there a basement?',
            has_basement_tooltip: '',
            is_attic_heated: 'Is the attic space heated?',
            is_attic_heated_tooltip: '',
            last_floor_renovation: 'When was the floor last insulated? ',
            last_floor_renovation_tooltip: '',
            last_wall_renovation: 'When was the wall last insulated? ',
            last_wall_renovation_tooltip: '',
            last_roof_renovation: 'When was the roof last insulated? ',
            last_roof_renovation_tooltip: '',
            enter_epc_label: 'Select the official EPC label',
            enter_epc_label_tooltip: '',
            enter_epc_score: 'Enter the official EPC score here',
            enter_epc_score_tooltip: '',
            epc_type: 'What is the official EPC score?',
            epc_type_tooltip: '',
            epc_known: 'Do you have a valid EPC certificate?',
            epc_known_tooltip:
                "The Energy Performance Coefficient (EPC) is the energy score of a home. This info can usually be found in the sales ad or on the EPC certificate. The EPC score is expressed in kWh/m2year The building's EPC label is based on the EPC score. Depending on the region, this can go from A++ up to G.",
            consumption_known_no: 'I want to estimate my yearly energy consumption',
            consumption_known_no_tooltip: '',
            consumption_known_yes: 'I want to fill out my yearly energy consumption',
            consumption_known_yes_tooltip: '',
            epc_known_yes: 'Start from the official EPC score',
            epc_known_yes_tooltip: '',
            epc_known_no: 'Simulate your EPC score',
            epc_known_no_tooltip: '',
            select_heating_fuel: 'Select the main heating fuel',
            select_heating_fuel_tooltip: '',
            ventilation_type: 'What type of ventilation do you have?',
            ventilation_type_tooltip: '',
            ventilation_subtype: 'What type of system do you have?',
            ventilation_subtype_tooltip: '',
            n_residents: 'How many people live in the house?',
            n_residents_tooltip: '',
            protected_consumer: 'Are you a protected consumer?',
            protected_consumer_tooltip: '',
            heating_consumption_approx:
                'Please provide us with an estimation of your heating consumption',
            heating_consumption_approx_tooltip: '',
            electric_consumption_approx:
                'Please provide us with an estimation of your electrical consumption',
            electric_consumption_approx_tooltip: '',
            installation_year: 'When was it installed?',
            installation_year_tooltip: '',
            heater: 'What kind of heater do you have?',
            heater_tooltip: '',
            energy_consumption_known: 'Do you know your energy consumption?',
            energy_consumption_known_tooltip: '',
            consumption_known: 'Do you know your energy consumption?',
            consumption_known_tooltip:
                'You can find this information on your latest energy invoice or by comparing meter values. Please pay attention to enter yearly values only. You may have to recalculate the value on the invoice to a yearly value.',
            yearly_electricity_consumption: 'Do you know your electric consumption?',
            yearly_electricity_consumption_tooltip:
                'You can find this information on your latest electricity invoice or by comparing meter values. Please pay attention to enter yearly values only. You may have to recalculate the value on the invoice to a yearly value.',
            yearly_electricity_consumption_subtitle:
                'The annual electricity consumption refers to the total kWh of the grid consumed in a year.\nDo not take into account electricity that you may generate yourself.',
            yearly_electricity_consumption_subtitle_tooltip: '',
            yearly_fuel_consumption: 'Do you know your fuel consumption?',
            yearly_fuel_consumption_tooltip:
                'You can find this information on your latest fuel invoice or by comparing meter values. Please pay attention to enter yearly values only. You may have to recalculate the value on the invoice to a yearly value.',
            yearly_heating_consumption: 'Do you know your yearly heating consumption?',
            yearly_heating_consumption_tooltip: '',
            f_construction_year: 'When was the house built?',
            f_construction_year_tooltip: '',
            f_living_area: 'What\u2019s the house\u2019s heated living area?',
            f_living_area_tooltip:
                'Total living area of the home. This info can usually be found in the sales ad or the heated square footage in the EPC certificate. ',
            approx_living_area:
                'Based on the building\'s 3D-model, we estimate the living area at <b class="has-text-primary">{area} m\u00b2</b>. Please enter the actual living area if you know it.',
            approx_living_area_tooltip: '',
            solar_panels: 'Are there solar panels?',
            solar_panels_tooltip: '',
            insulated_windows: 'What is the main type of window glazing in the home?',
            insulated_windows_tooltip:
                'You can find the type of glazing in technical documentation of the home, e.g. in invoices of the placement of the windows. If this is not available, here are some tips. For all types of double glazing, search the code marked on the inside of the window strip on the website of the producer. If this does not work, standard double glazing can be recognized by the aluminum strip between the two glass plates. High performance glazing can be recognized by the aluminum strip that are often marked by the letters "HR", "HR+" or "HR++". Triple glazing can be recognized by the tag "HR+++" inside the window strip.',
            insulated_single_renovated:
                'Was improved insulation installed after construction?',
            insulated_single_renovated_tooltip: '',
            insulated_plural_renovated:
                'Was improved insulation installed after construction?',
            insulated_plural_renovated_tooltip: '',
            consumption_title: 'Your consumption',
            consumption_title_tooltip: '',
            consumption_yearly_consumption:
                'What is the yearly energy consumption of the grid?',
            consumption_yearly_consumption_tooltip: '',
            gas_consumption_known: 'Do you know your yearly gas consumption?',
            gas_consumption_known_tooltip: '',
            oil_consumption_known: 'Do you know your yearly oil consumption?',
            oil_consumption_known_tooltip: '',
            wood_consumption_known: 'Do you know your yearly wood consumption?',
            wood_consumption_known_tooltip: '',
            coal_consumption_known: 'Do you know your yearly coal consumption?',
            coal_consumption_known_tooltip: '',
            pellets_consumption_known: 'Do you know your yearly pellets consumption?',
            pellets_consumption_known_tooltip: '',
            district_heating_consumption_known:
                'Do you know your yearly consumption from district heating?',
            district_heating_consumption_known_tooltip: '',
            electricity_consumption_known:
                'Do you know your yearly electricity consumption?',
            electricity_consumption_known_tooltip: '',
            gas_consumption_approx: 'How would you estimate your gas consumption?',
            gas_consumption_approx_tooltip: '',
            oil_consumption_approx: 'How would you estimate your oil consumption?',
            oil_consumption_approx_tooltip: '',
            wood_consumption_approx: 'How would you estimate your wood consumption?',
            wood_consumption_approx_tooltip: '',
            coal_consumption_approx: 'How would you estimate your coal consumption?',
            coal_consumption_approx_tooltip: '',
            pellets_consumption_approx:
                'How would you estimate your pellets consumption?',
            pellets_consumption_approx_tooltip: '',
            district_heating_consumption_approx:
                'How would you estimate your consumption from district heating?',
            district_heating_consumption_approx_tooltip: '',
            electricity_consumption_approx:
                'How would you estimate your electricity consumption?',
            electricity_consumption_approx_tooltip: '',
            enter_value: 'Please fill in the value.',
            enter_value_tooltip: '',
        },
        map_page: {
            '3d_model':
                'Based on the address, we generated a simplified 3D model of the property. This enables us to calculate required building information like the touching sides, wall surfaces, and the pitch of the roof. ',
            '3d_model_tooltip': '',
        },
        address_page: {
            title: "Enter the address to retrieve the building's 3D measurements.",
            title_tooltip:
                'To estimate the costs and benefits of renovations it is necessary to gather certain information on the building, e.g. the pitch, surface and orientation of the roof for solar panels.',
            subtitle:
                "Every building is unique. Through the address, we're able to tailor renovations to the specifics of the building. ",
            subtitle_tooltip: '',
            control_address: 'Complete the address if needed',
            control_address_tooltip: '',
        },
        validation: {
            range: 'Please enter a value between {min} and {max}',
            range_tooltip: '',
            field_required: 'This field is required',
            field_required_tooltip: '',
            only_numbers: 'Please enter only numeric values',
            only_numbers_tooltip: '',
            min_4_characters: 'Input should contain min. 4 characters',
            min_4_characters_tooltip: '',
            wrong_epc: 'Please enter a correct EPC label',
            wrong_epc_tooltip: '',
            valid_years: 'Between {min} and {max}',
            valid_years_tooltip: '',
            value_too_small: 'The number is too small',
            value_too_small_tooltip: '',
            value_too_large: 'The number is too large',
            value_too_large_tooltip: '',
        },
        f_epc: {
            label: 'EPC Label',
            label_tooltip: '',
        },
        features_page: {
            title:
                "We need some information to understand this home's energy performance",
            title_tooltip: '',
        },
        consumption_page: {
            title: 'Please provide us more information on your energy consumption.',
            title_tooltip: '',
            info:
                'Big energy consumers are fully electric vehicles, air conditioning, a swimming pool or a spa room. ',
            info_tooltip: '',
            big_consumer: 'Does the household power big energy consumers at home?',
            big_consumer_tooltip: '',
        },
        login_page: {
            login: 'Login',
            login_tooltip: '',
        },
        wall_insulation_page: {
            info:
                'Wall insulation can be <b>exterior - or interior wall insulation</b> or <b>wall cavity insulation.</b>',
            info_tooltip: '',
        },
        roof_insulation_page: {
            info:
                'Roof insulation can be <b>exterior - or interior roof insulation</b> or <b>attic floor insulation.</b>',
            info_tooltip: '',
        },
        building_dimensions_page: {
            is_flat: 'is flat',
            is_flat_tooltip: '',
            title: 'Approximate the building\u2019s measurements',
            title_tooltip: '',
            subtitle:
                "It looks like we could not find this building\u2019s 3D model. With a few more questions we can approximate the building measurements. Let's get started!",
            subtitle_tooltip: '',
            floors_title: 'How many floors does the house count?',
            floors_title_tooltip: '',
            floors_info:
                'Including the ground floor, excluding the basement and the attic. ',
            floors_info_tooltip: '',
            roof_title: 'Which of these images best resembles the roof of the house?',
            roof_title_tooltip: '',
            tooltip_roof_type: 'test',
            tooltip_roof_type_tooltip: '',
            roof_pitched: 'All parts are pitched',
            roof_pitched_tooltip: '',
            roof_flat: 'All parts are flat',
            roof_flat_tooltip: '',
            roof_mixed: 'Some parts are pitched, \u2028and some are flat',
            roof_mixed_tooltip: '',
            facades_title: 'How many common facades are there? ',
            facades_title_tooltip: '',
            tooltip_common_facades: 'test',
            tooltip_common_facades_tooltip: '',
            facades_type_0: 'detached houses',
            facades_type_0_tooltip: '',
            facades_type_1: 'semi-detached house',
            facades_type_1_tooltip: '',
            facades_type_2: 'terraced houses',
            facades_type_2_tooltip: '',
        },
        welcome_page: {
            title: 'Simulate energetic renovations for residential houses',
            title_tooltip: '',
            text_welcome: 'Welcome!',
            text_welcome_tooltip: '',
            text_intro:
                'The Energy Renovation Simulator lets you discover what the smartest renovations are to reduce a home\u2019s energy score.',
            text_intro_tooltip: '',
            text_description:
                'We start with estimating the current EPC score of the residential property. After that, you\u2019re able to simulate the most cost-efficient energy-saving renovations to meet your renovation goal.',
            text_description_tooltip: '',
            'info-bubble':
                'Energy renovation simulations only work for <b> single-unit residential houses.<b/> ',
            'info-bubble_tooltip': '',
            button_start: 'Start simulation',
            button_start_tooltip: '',
            terms: 'terms and conditions',
            terms_tooltip: '',
            curious:
                'What are the smartest renovations to reduce your home\u2019s energy consumption?',
            curious_tooltip: '',
        },
        error_page: {
            title: 'Something went wrong',
            title_tooltip: '',
            intro:
                'An error occured and the service is currently unavailable. Please try again later.',
            intro_tooltip: '',
            button: 'Return to ING',
            button_tooltip: '',
        },
        insulation: {
            title: 'How is the insulation of the property?',
            title_tooltip: '',
        },
        consumption: {
            gas_consumption_title: 'Gas consumption',
            gas_consumption_title_tooltip: '',
            oil_consumption_title: 'Oil consumption',
            oil_consumption_title_tooltip: '',
            wood_consumption_title: 'Wood consumption',
            wood_consumption_title_tooltip: '',
            coal_consumption_title: 'Coal consumption',
            coal_consumption_title_tooltip: '',
            pellets_consumption_title: 'Pellets consumption',
            pellets_consumption_title_tooltip: '',
            district_heating_consumption_title: 'Consumption from district heating',
            district_heating_consumption_title_tooltip: '',
            electricity_consumption_title: 'Electricity consumption',
            electricity_consumption_title_tooltip: '',
        },
        consumers_page: {
            info:
                'The annual electricity consumption refers to the total kWh of the grid consumed in a year. \u2028Do not take into account electricity that you may generate yourself.',
            info_tooltip: '',
            title: 'Please provide us more information on your energy consumption.',
            title_tooltip: '',
        },
        ventilation_page: {
            ventilation_title: 'Ventilation',
            ventilation_title_tooltip: '',
        },
        energy_quizz: {
            solar: {
                qa: {
                    q:
                        'According to our data we think this is the best way to place solar panels on the roof. Would you agree?',
                    q_tooltip: '',
                    a1: 'Yes, I agree',
                    a1_tooltip: '',
                    a2: 'No, this is not the side that catches the most sun',
                    a2_tooltip: '',
                    a3: 'No, this is not the right surface',
                    a3_tooltip: '',
                },
                qb: {
                    q:
                        "You've indicated that there are solar panels. We estimate that {x} panels fit on your roof. Would you agree?",
                    q_tooltip: '',
                    a1: 'Yes, I agree',
                    a1_tooltip: '',
                    a2: 'No, that is not feasible',
                    a2_tooltip: '',
                    a3: 'Yes, but we decided to get a different amount of solar panels',
                    a3_tooltip: '',
                },
            },
            q1: {
                q: 'Which statement on solar panels is correct?',
                q_tooltip: '',
                a1: 'Solar panels have an average payback period of 15 years.',
                a1_tooltip: '',
                f1:
                    "That's not correct. The average payback period is around 6-8 years. The correct answer is 2.",
                f1_tooltip: '',
                a2:
                    'Solar panels lower the EPC value of a house. A lower EPC score increases the property value.',
                a2_tooltip: '',
                f2: "Awesome, that's correct. ",
                f2_tooltip: '',
                a3: 'Solar panels cannot be used to heat up water',
                a3_tooltip: '',
                f3:
                    "That's not correct. There are two ways of heating water with solar panels: via a solar boiler or by powering the water boiler. The correct answer is 2.",
                f3_tooltip: '',
            },
            q2: {
                q:
                    'What is the right order of renovations to improve the energy efficiency of a house?',
                q_tooltip: '',
                a1: 'Walls - roof - windows - floors - heating',
                a1_tooltip: '',
                f1: "That's not correct. The correct answer is 2.",
                f1_tooltip: '',
                a2: 'Roof - walls - windows - floors - heating',
                a2_tooltip: '',
                f2: "Awesome, that's correct. ",
                f2_tooltip: '',
                a3: 'Roof - walls - floors - windows - heating',
                a3_tooltip: '',
                f3: "That's not correct. The correct answer is 2.",
                f3_tooltip: '',
                a4: 'Walls - roof - windows - heating - floor',
                a4_tooltip: '',
                f4: "That's not correct. The correct answer is 2.",
                f4_tooltip: '',
            },
            q3: {
                q:
                    'What can you do when you create more energy with solar panels than you consume?',
                q_tooltip: '',
                a1: 'Nothing. It will be lost',
                a1_tooltip: '',
                f1:
                    "That's not correct. There are interesting ways to get the most out of the generated solar power. The correct answer is 3.",
                f1_tooltip: '',
                a2: 'Store all energy for when you need it',
                a2_tooltip: '',
                f2:
                    "That's not correct. While you can charge a battery with solar power, not all power can be stored for an unlimited amount of time. The correct answer is 3.",
                f2_tooltip: '',
                a3: 'Sell the excess energy, e.g. to an energy provider or a retailer',
                a3_tooltip: '',
                f3: "Awesome, that's correct. ",
                f3_tooltip: '',
            },
            q4: {
                q: 'What is not a good way to save on the gas bill without renovating?',
                q_tooltip: '',
                a1:
                    'Place aluminum foil between the heating radiator and non-isolated walls',
                a1_tooltip: '',
                f1:
                    "That's not correct. Aluminum foil between the heating radiator and non-insulated exterior walls diminishes the heat loss. It is a good way to decrease gas consumption. The correct answer is 3.",
                f1_tooltip: '',
                a2:
                    'Isolate heating pipes that run from the kettle to the heating radiators in the cellar or attic',
                a2_tooltip: '',
                f2:
                    "That's not correct. Isolating heating pipes in rooms that you do not heat is a good way to consume less gas because this decreases heat getting lost. The correct answer is 3.",
                f2_tooltip: '',
                a3: 'Heat with an electric heater',
                a3_tooltip: '',
                f3:
                    "Awesome, that's correct. An electric heater is a big electricity consumer. Not only does this cost a lot of money, but it also has a negative impact on the environment.",
                f3_tooltip: '',
            },
            q5: {
                q: "What measure decreases a house's CO2 emissions the most?",
                q_tooltip: '',
                a1: "Don't use a washing dryer",
                a1_tooltip: '',
                f1: "That's not correct. The correct answer is 2.",
                f1_tooltip: '',
                a2: 'Install underfloor heating',
                a2_tooltip: '',
                f2: "Awesome, that's correct. ",
                f2_tooltip: '',
                a3: 'Shower ever 2 days',
                a3_tooltip: '',
                f3: "That's not correct. The correct answer is 2.",
                f3_tooltip: '',
            },
            q6: {
                q: 'Which statement is not correct?',
                q_tooltip: '',
                a1: 'Floor insulation saves more energy than wall insulation',
                a1_tooltip: '',
                f1: "Awesome, that's correct. ",
                f1_tooltip: '',
                a2: 'Roof insulation saves more CO2 emissions than solar panels',
                a2_tooltip: '',
                f2:
                    "That's not correct. Roof insulation is better for reducing CO2 emissions than solar panels. The correct answer is 1.",
                f2_tooltip: '',
                a3:
                    'Replacing windows has a bigger impact than getting a new heating system',
                a3_tooltip: '',
                f3:
                    "That's not correct. Improving the quality of the windows can save more energy than getting a new heating system. The correct answer is 1.",
                f3_tooltip: '',
            },
            discovery_phase: 'Discovery phase',
            discovery_phase_tooltip: '',
            discovery_description:
                'Good job! You are on a path of discovering everything about energy. Stay curious and continue learning about how you can save energy.',
            discovery_description_tooltip: '',
            learning_phase: 'Learning phase',
            learning_phase_tooltip: '',
            learning_description:
                'Keep up the good work! You are knowledgeable on how to make your property energy efficient. Continue discovering more ways on how to save energy!',
            learning_description_tooltip: '',
            expert_phase: 'Expert phase',
            expert_phase_tooltip: '',
            expert_description:
                'Congrats! You are an expert when it comes to creating an energy efficient home. Time to put it into practice!',
            expert_description_tooltip: '',
        },
        ers_report: {
            language: 'EN',
            language_tooltip: '',
            header_title: 'The current energy efficiency',
            header_title_tooltip: '',
            header_subtitle:
                'Based on the given information, we have simulated the current EPC score. This does not replace an official EPC score.*',
            header_subtitle_tooltip: '',
            header_subtitle_pdf:
                'Based on the given information, we have simulated the current EPC score. This does not replace an official EPC score.*',
            header_subtitle_pdf_tooltip: '',
            epc_graph_title: 'The estimated current EPC score is {x}*',
            epc_graph_title_tooltip: '',
            epc_graph_subtitle:
                'As shown by the histogram, {x}% of homes in {region} have a better EPC label.',
            epc_graph_subtitle_tooltip: '',
            consumption_title: 'Consumption',
            consumption_title_tooltip: '',
            gas_title: 'Gas',
            gas_title_tooltip: '',
            electric_title: 'Electric',
            electric_title_tooltip: '',
            low_title: 'Low',
            low_title_tooltip: '',
            high_title: 'High',
            high_title_tooltip: '',
            average_title: 'Average',
            average_title_tooltip: '',
            you_title: 'You',
            you_title_tooltip: '',
            current_epc: 'Current EPC',
            current_epc_tooltip: '',
            future_epc: 'Future EPC',
            future_epc_tooltip: '',
            summary_input_title: 'Input summary',
            summary_input_title_tooltip: '',
            summary_title: 'Summary',
            summary_title_tooltip: '',
            summary_note:
                'The prices and subsidies below are indicative. Prices include VAT.**',
            summary_note_tooltip: '',
            price_title: 'Price',
            price_title_tooltip: '',
            subsidy_title: 'Subs.',
            subsidy_title_tooltip: '',
            after_subsidy_title: 'After Subs',
            after_subsidy_title_tooltip: '',
            total_title: 'Total',
            total_title_tooltip: '',
            calculate_button_text: 'Calculate my ING loan',
            calculate_button_text_tooltip: '',
            download_report: 'Download my report',
            download_report_tooltip: '',
            renovation_title: 'Your Renovation Goal',
            renovation_title_tooltip: '',
            renovation_subtitle:
                'What is your renovation goal? Select a renovation package to see which renovations are the most efficient to reach that goal. Or, select renovations to see with which EPC score they align.',
            renovation_subtitle_tooltip: '',
            renovation_price: 'Price ',
            renovation_price_tooltip: '',
            renovation_subsidy: 'Subsidy',
            renovation_subsidy_tooltip: '',
            renovation_area: 'Area',
            renovation_area_tooltip: '',
            renovation_insulation_type: 'Insulation type',
            renovation_insulation_type_tooltip: '',
            renovation_yearly: 'Yearly savings',
            renovation_yearly_tooltip: '',
            renovation_windowsDouble: 'Glazing',
            renovation_windowsDouble_tooltip: '',
            renovation_wallExt: 'Wall Exterior',
            renovation_wallExt_tooltip: '',
            renovation_wallCav: 'Wall Cavity',
            renovation_wallCav_tooltip: '',
            renovation_roofIn: 'Roof Interior',
            renovation_roofIn_tooltip: '',
            renovation_roofExt: 'Roof Exterior',
            renovation_roofExt_tooltip: '',
            renovation_roofIn_attic_floor: 'Roof Attic floor',
            renovation_roofIn_attic_floor_tooltip: '',
            renovation_condGas: 'Boiler',
            renovation_condGas_tooltip: '',
            renovation_heatPump: 'Heat pump',
            renovation_heatPump_tooltip: '',
            renovation_ventC: 'Ventilation type C',
            renovation_ventC_tooltip: '',
            renovation_solar: 'Solar Panels',
            renovation_solar_tooltip: '',
            compliance_pack_title: 'Good start',
            compliance_pack_title_tooltip: '',
            compliance_pack_desc:
                'I wish to improve the energy score of this home to meet energy targets.',
            compliance_pack_desc_tooltip: '',
            budget_pack_title: 'Green budget',
            budget_pack_title_tooltip: '',
            budget_pack_desc:
                'I wish to optimize a budget of x euros on energy renovations.',
            budget_pack_desc_tooltip: '',
            lowest_pack_title: 'BENovation',
            lowest_pack_title_tooltip: '',
            lowest_pack_desc:
                'I wish to see the full energy renovation trajectory for this property.',
            lowest_pack_desc_tooltip: '',
            custom_pack_title: 'Custom pack',
            custom_pack_title_tooltip: '',
            custom_pack_desc:
                'I wish to create my own combination of renovation measures. ',
            custom_pack_desc_tooltip: '',
            add_remove_renovations: 'Add or remove renovations',
            add_remove_renovations_tooltip: '',
            submit_button_budget: 'Submit',
            submit_button_budget_tooltip: '',
            already_compilance:
                'Congratulations! With an EPC score below 400, this property is compliant with legal requirements in Flanders as of 2023. Click on the other packages to find out what other investment you can make.',
            already_compilance_tooltip: '',
            no_renovation_found: 'No renovations found. Submit your green budget',
            no_renovation_found_tooltip: '',
            renovation_subtitle_compliance_pdf:
                'Congratulations on your Good Start! With a budget of EUR {amount}, the EPC score of the property can go from {current_epc_score} to {future_epc_score}.\n\nBelow you find the most cost-efficient package that will help you realize this goal as well as your yearly savings and an indication on subsidies.\n\nFor more information on subsidies, please visit the following websites:\n- For Flanders, go to https://www.mijnbenovatie.be/nl/wat-waarom/benovatiepremies-2022/\n- For Wallonia, go to https://energie.wallonie.be/fr/primes.html?IDC=7015\n- For Brussels, go to https://renolution.brussels/nl',
            renovation_subtitle_compliance_pdf_tooltip: '',
            renovation_subtitle_budget_pdf:
                'Congratulations on your Green Budget! Your renovation goal is to optimize a budget of EUR {amount}. This investment can improve the EPC score of your property from an EPC score {current_epc_score} to an EPC score {future_epc_score}.\n\nBelow you find the most cost-efficient package that will help you realize this goal as well as your yearly savings and an indication on subsidies.\n\nFor more information on subsidies, please visit the following websites:\n- For Flanders, go to https://www.mijnbenovatie.be/nl/wat-waarom/benovatiepremies-2022/\n- For Wallonia, go to https://energie.wallonie.be/fr/primes.html?IDC=7015\n- For Brussels, go to https://renolution.brussels/nl',
            renovation_subtitle_budget_pdf_tooltip: '',
            renovation_subtitle_custom_pdf:
                'Congratulations on your custom pack! With a budget of EUR {amount}, the EPC score of the property can go from an EPC score {current_epc_score} to an EPC score {future_epc_score}.\n\nBelow you find the most cost-efficient package that will help you realize this goal as well as your yearly savings and an indication on subsidies.\n\nFor more information on subsidies, please visit the following websites:\n- For Flanders, go to https://www.mijnbenovatie.be/nl/wat-waarom/benovatiepremies-2022/\n- For Wallonia, go to https://energie.wallonie.be/fr/primes.html?IDC=7015\n- For Brussels, go to https://renolution.brussels/nl',
            renovation_subtitle_custom_pdf_tooltip: '',
            disclaimer: {
                title: 'Disclaimer',
                title_tooltip: '',
                body1:
                    'The estimation of the current EPC score is based on the information provided in the questionnaire combined with building data, and technical requirements as stated by the official EPC software. The accuracy of this information allows us to better approximate the actual EPC score.',
                body1_tooltip: '',
                body2: 'This does not replace an official EPC certificate.',
                body2_tooltip: '',
                body3: 'It is provided for informational purposes only.',
                body3_tooltip: '',
                body4: 'Please be aware that the',
                body4_tooltip: '',
                body5: 'prices indicated throughout this report are indicative',
                body5_tooltip: '',
                body6:
                    'and should be treated as estimates. Actual costs may vary depending on house conditions, specific project details, and other factors.',
                body6_tooltip: '',
                body7:
                    'Only a certified energy expert can issue an official EPC certification. Please consult a qualified professional in the relevant field for a detailed cost assessment.',
                body7_tooltip: '',
            },
            disclaimer_body:
                '*The estimation of the current EPC score is based on the information provided in the questionnaire, combined with building data and technical requirements as defined in the official EPC software. The more accurate the information you provide, the more accurate the simulation will be. The simulation does not replace an official EPC certificate. Always consult a professional for personalized advice.\n\n**Prices include 6% or 21% VAT, depending on the age of the house and the type of renovation. We regularly update prices and subsidies, so the outcome may vary depending on when you use the simulator. The report specifies which works are included in the renovation price. Any additional work required for renovation is not included in the stated price. Always consult a professional for personalized advice.',
            disclaimer_body_tooltip: '',
            disclaimer_body_pdf:
                '*The estimation of the current EPC score is based on the information provided in the questionnaire, combined with building data and technical requirements as defined in the official EPC software. The more accurate the information you provide, the more accurate the simulation will be. The simulation does not replace an official EPC certificate. Always consult a professional for personalized advice.\n\n**Prices include 6% or 21% VAT, depending on the age of the house and the type of renovation. We regularly update prices and subsidies, so the outcome may vary depending on when you use the simulator. The report specifies which works are included in the renovation price. Any additional work required for renovation is not included in the stated price. Always consult a professional for personalized advice.',
            disclaimer_body_pdf_tooltip: '',
            property_page: {
                title: "Your property's estimated value increase",
                title_tooltip: '',
                subtitle:
                    'We estimate the property value increase by comparing it to listings of properties in the market with EPC scores that are similar to the current and target EPC score. Please note that this is an automatic calculation that reflects today\u2019s market conditions. For an official post-renovation valuation of your home, it\u2019s advisable to consult a certified professional.',
                subtitle_tooltip: '',
                info_bubble:
                    'With an EPC score of {future_epc} kWh/m\u00b2, the increase in today\u2019s fair market value is estimated at {val}',
                info_bubble_tooltip: '',
                section_title: 'Your energy savings',
                section_title_tooltip: '',
                epc_title: 'Reduced EPC Score',
                epc_title_tooltip: '',
                epc_text:
                    'This number is the total improvement in your home\u2019s EPC score after realizing your energy renovation plan. In practice it expresses how many kWh you save on a yearly basis to keep a constant temperature of 18\u00b0C per sq m. Multiply this with the total heated floor surface to know how many kWh\u2019s you save in total. It\u2019s important to note that the actual improvement could vary due to factors like the choice of technologies and insulation materials for the renovation.',
                epc_text_tooltip: '',
                carbon_title: 'Reduced carbon emissions ',
                carbon_title_tooltip: '',
                carbon_text:
                    'This is how much kg in carbon emissions you can save on a yearly basis thanks to this renovation plan.  Energy renovations makes your home less reliant on fossil fuels to power your appliances and heat the rooms and water. This number assumes that your household doesn\u2019t change its energy consumption behaviour after renovations.',
                carbon_text_tooltip: '',
                bill_title: 'Reduced energy bills',
                bill_title_tooltip: '',
                bill_text:
                    'This is the potential monthly energy bill savings in euros following renovations, based on the annual energy consumption provided in the questionnaire. We update energy prices on a regular basis. Please note that these estimated savings assume your energy usage patterns remain consistent. Actual savings can vary due to price fluctuations and changes in household energy consumption habits.',
                bill_text_tooltip: '',
            },
            renovation: {
                title: {
                    gtk: 'Good to know',
                    gtk_tooltip: '',
                    works: "What's included?",
                    works_tooltip: '',
                    subsidies: 'Subsidies',
                    subsidies_tooltip: '',
                },
                roofIn: {
                    gtk:
                        'The roof is the primary source of heat loss in a building, so it is recommended to start with insulating the roof. Insulating the roof from the inside is easier to install and cheaper compared to external insulation. Keep in mind that the insulation will take up some of the attic space. On the other hand, external roof insulation does not reduce interior space and provides more efficient insulation. The costs vary based on the type of roof and the materials used. If you do not use the attic space as a heated area, consider insulating the attic floor instead.',
                    gtk_tooltip: '',
                    works:
                        'removal of the degraded insulating layer (including vapor barrier), installation of a new insulating layer and vapor barrier, and adjustments around the roof plane and dormer windows.                ',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/e3-toiture-isolation-thermique-de-la-toiture',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-dak',
                        subsidies_tooltip: '',
                    },
                },
                roofExt: {
                    gtk:
                        'The roof is the primary source of heat loss in a building, so it is recommended to start with insulating the roof. External roof insulation has the advantage of not reducing the space under the roof, keeping the home cleaner and habitable during the works. It also allows to install the thickest insulation material. However, insulating from the outside is a more expensive option compared to insulating from the inside of the roof. The total cost depends on the type of roof and the materials used. External roof insulation is a good choice for a flat roof or when you use the space under the roof as a heated room.',
                    gtk_tooltip: '',
                    works:
                        'demolition of roof covering and structure, demolition of gutters, installation of insulation and a vapour barrier, placement of roof structure and -covering, working around roof vents, placement of gutters, removing and reinstalling solar panels if already present and a crane or hoist.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/e3-toiture-isolation-thermique-de-la-toiture',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-dak',
                        subsidies_tooltip: '',
                    },
                },
                atticFloor: {
                    gtk:
                        'The roof is the primary source of heat loss in a building, so it is recommended to start with insulating the roof. If the attic space is not used as a heated room, insulating the attic floor can be a cost-effective choice to prevent heat loss through the roof. It is much cheaper compared to insulating the roof itself. This is mainly because of the smaller surface area that needs insulation and the minimal or no finishing required. The installation process is relatively quick and straightforward. However, it may not be the best choice if you ever plan to use the attic space as a heated room.',
                    gtk_tooltip: '',
                    works:
                        'installation of insulation and vapor barrier, modifications to existing pipes and lighting, and access adjustment.                ',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/h1-sols-et-planchers-isolation-thermique-de-sol-et-plancher',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-vloer',
                        subsidies_tooltip: '',
                    },
                },
                wallExt: {
                    gtk:
                        "After roof insulation, it is recommended to insulate the walls. External wall insulation along the outer fa\u00e7ade has the advantage that you don't lose living space, and the house remains habitable during the work. It also helps to reduce external noise. Always check if the home is suitable for external wall insulation. Since the aesthetic characteristics of the fa\u00e7ade may change, there may be requirements for a building permit, for example, if you are renovating a historic building. ",
                    gtk_tooltip: '',
                    works:
                        'breaking down rainwater drainage, sawing off sills, installing insulation, placement of finishes (in crepi), update openings (including sills), carry out edits, enlarge roof projection, renew rainwater drainage, and a scaffolding.                ',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/f1-facades-isolation-thermique-des-facades',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-buitenmuur',
                        subsidies_tooltip: '',
                    },
                },
                wallIn: {
                    gtk:
                        "After insulating the roof, it is recommended to continue with wall insulation. Unlike external wall insulation, internal insulation has certain limitations. It can reduce your living space as it is installed within the interior of your home. However, it is generally a more cost-effective option compared to external insulation. It's important to note that many insulation materials require a fire-rated covering, as they may release toxic gases when exposed to fire.",
                    gtk_tooltip: '',
                    works:
                        'demolition of skirting boards and window sills, installation of insulation with vapor barrier and ventilation grilles, application of finishing layers including new skirting boards and window sills, removal and replacement of heating elements with electricity adjustments.\t\t',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/f1-facades-isolation-thermique-des-facades',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-buitenmuur',
                        subsidies_tooltip: '',
                    },
                },
                wallCav: {
                    gtk:
                        'After insulating the roof, it is recommended to insulate the walls. Not all buildings have a cavity (spouw) in their walls, so check whether the building has cavity walls or solid walls. Cavity wall insulation can provide excellent thermal insulation at an affordable price. However, be aware of potential issues like condensation and mold formation. If the home is located in an area with a lot of wind-driven rain, consider alternatives to prevent moisture-related problems.',
                    gtk_tooltip: '',
                    works:
                        'use of an aerial work platform, installation of 5 cm mineral wool insulation including inspection, preparation, blowing in and closing the openings.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/f1-facades-isolation-thermique-des-facades',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-buitenmuur',
                        subsidies_tooltip: '',
                    },
                },
                windowsDouble: {
                    gtk:
                        'Old windows can account for up to 30% of the heat loss in a home. Upgrading to energy-efficient windows, such as high-performance double or triple glazing with airtight frames, can significantly improve insulation. If you plan to insulate the walls, it is advisable to do this before or simultaneously with the installation of new windows. An additional benefit of new windows is that they are more secure due to the extra glass layer, making them more resistant to breakage.',
                    gtk_tooltip: '',
                    works:
                        'demolition and installation of glass (with surcharge for hoisting equipment), demolition and installation of the frame, installation of RTO on the glass, and demolition and installation of the glass.                ',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,\nhttps://renolution.brussels/fr/aidesfinancieres/g1-portes-et-fenetres-exterieures-placement-et-remplacement-de-portes-et-fenetres,\nhttps://renolution.brussels/fr/aidesfinancieres/g2-portes-et-fenetres-exterieures-reparation-et-adaptation-de-fenetre',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-ramen-en-deuren',
                        subsidies_tooltip: '',
                    },
                },
                condGas: {
                    gtk:
                        "Gas condensing boilers are designed to extract heat from the exhaust gases produced during the combustion process. **The lifespan of a gas condensing boiler is typically around 15 years.** By using the extracted heat to preheat water, the efficiency is higher than that of a traditional boiler. Gas condensing boilers have a positive impact on a home's EPC score. They work most efficiently when the walls, roof, and windows are well insulated. Consider insulating your home before installing a new heating system for an optimal result.",
                    gtk_tooltip: '',
                    works:
                        'demolition of existing generator, gas condensing boiler installation, link to existing generator, extra costs for replacing the climate system, insulation non-insulated pipes.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://www.ores.be/autorites-publiques/primes-et-avantages-financiers,\nhttps://www.resa.be/fr/nos-services/les-primes/',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-gascondensatieketel-tot-en-met-31-oktober-2023',
                        subsidies_tooltip: '',
                    },
                },
                heatPump: {
                    gtk:
                        'Heat pumps extract energy from the air, ground, or groundwater to heat or cool a space. A better-insulated home loses less heat and, therefore, requires a less powerful pump. Consequently, the price of a heat pump is lower when combined with other energy-efficient renovations. A heat pump reduces dependence on fossil fuels, thus lowering the carbon emissions from your energy consumption. There are different types of heat pumps, such as geothermal, air-air, air-water, and hybrid systems. Prices vary depending on the specific type of heat pump you choose.',
                    gtk_tooltip: '',
                    works:
                        'demolition of the existing generator, installation of a heat pump (with soil water; including drilling), connecting it to the existing generator and insulating non-insulated pipes. Additional costs will apply for replacing the climate system.',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/primes-habitation-a-partir-du-1er-juillet-2023.html?IDC=10441',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies:
                            'https://renolution.brussels/fr/les-primes-renolution-2023,https://renolution.brussels/fr/aidesfinancieres/j4-chauffage-et-chauffe-eau-chauffage-pompe-chaleur,https://renolution.brussels/fr/aidesfinancieres/j9-chauffage-et-chauffe-eau-chauffe-eau-pompe-chaleur',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.vlaanderen.be/bouwen-wonen-en-energie/bouwen-en-verbouwen/premies-en-belastingvoordelen/mijn-verbouwpremie/mijn-verbouwpremie-voor-warmtepomp\n',
                        subsidies_tooltip: '',
                    },
                },
                unitPv: {
                    gtk:
                        'Solar panels can be a cost-effective way to improve the EPC score and reduce your energy bills. However, it is recommended to first renovate the roof, walls, windows, and heating system. The efficiency of solar panels depends on several factors such as surface area, orientation, and shading on the roof. In some cases, you may need a permit to install solar panels, for example, if the home is listed in the architectural heritage register.',
                    gtk_tooltip: '',
                    works:
                        'installation of solar panels including all accessories.                ',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies:
                            'https://energie.wallonie.be/fr/carte-dynamique-de-la-wallonie.html?IDC=6185&IDD=144019',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies:
                            'https://www.fluvius.be/nl/thema/premies/premies-voor-huishoudelijke-klanten/premie-zonnepanelen,\nhttps://www.vlaanderen.be/premie-van-fluvius-voor-zonnepanelen-op-gebouwen',
                        subsidies_tooltip: '',
                    },
                },
                works: {
                    lead_in: 'The total investment cost includes: ',
                    lead_in_tooltip: '',
                },
                ceiling: {
                    gtk:
                        'The roof is the primary source of heat loss in a building, so it is recommended to start with insulating the roof. It is not possible to insulate flat roofs from the interior. In this scenario, the flat part of the roof is insulated from the ceiling. It is important that you discuss the feasibility of this option with a profession to avoid thermal bridges and condensation. Insulating the roof from the inside is easier to install and cheaper compared to external insulation. Keep in mind that the insulation will take up some of the attic space. The costs vary based on the type of roof and the materials used. ',
                    gtk_tooltip: '',
                    works:
                        'demolition of ceiling, installation of insulation and vapour barrier, ceiling coverage, modifications to existing pipes and lighting',
                    works_tooltip: '',
                },
                mixed: {
                    gtk:
                        'The roof is the primary source of heat loss in a building, so it is recommended to start with insulating the roof. It is not possible to insulate flat roofs from the interior. In this scenario, the flat part of the roof is insulated from the ceiling and the pitched part is insulated from the interior of the roof. It is important that you discuss the feasibility of this option with a profession to avoid thermal bridges and condensation. Insulating the roof from the inside is easier to install and cheaper compared to external insulation. Keep in mind that the insulation will take up some of the ceiling space. The costs vary based on the type of roof and the materials used. If you do not use the attic space as a heated area, consider insulating the attic floor instead. ',
                    gtk_tooltip: '',
                    works:
                        'For ceiling insulation: demolition of ceiling, installation of insulation and vapour barrier, ceiling coverage, modifications to existing pipes and lighting.\nFor inteior roof insulation: removal of the degraded insulating layer (including vapor barrier), installation of a new insulating layer and vapor barrier, and adjustments around the roof plane and dormer windows.                ',
                    works_tooltip: '',
                },
                subsidies: {
                    lead_in: 'For information on subsidies, please visit',
                    lead_in_tooltip: '',
                },
            },
            title1: 'Your',
            title1_tooltip: '',
            title2: "property's",
            title2_tooltip: '',
            title3: 'renovation',
            title3_tooltip: '',
            title4: 'analysis',
            title4_tooltip: '',
            per_year: 'per year',
            per_year_tooltip: '',
            per_month: 'per month',
            per_month_tooltip: '',
        },
        processing_page: {
            title_started: 'Your simulation is being processed',
            title_started_tooltip: '',
            title_finished: 'Your simulation is ready!',
            title_finished_tooltip: '',
            title_failed: 'Something went wrong with your simulation',
            title_failed_tooltip: '',
            title_pending_long:
                'Your simulation is queued for processing. You can expect your results in <i>{waiting} minutes</i>. Thanks for your patience.',
            title_pending_long_tooltip: '',
            title_pending_medium:
                'Your simulation is being processed. Your results will be here in about <i>{waiting} seconds</i>.',
            title_pending_medium_tooltip: '',
            title_pending_short:
                "We're compiling the data. Your results will be available <i>any time soon</i>!",
            title_pending_short_tooltip: '',
            subtitle:
                'We are processing the information. While waiting for the results, test your knowledge on energy efficient housing with our quiz!',
            subtitle_tooltip: '',
            ing_button: 'Go back to ING',
            ing_button_tooltip: '',
            check_results: 'Check out the results',
            check_results_tooltip: '',
            results_ready: 'Your results are ready!',
            results_ready_tooltip: '',
            something_went_wrong: 'Something went wrong with your simulation',
            something_went_wrong_tooltip: '',
        },
        customer_ref_page: {
            title: 'What is the internal reference of the customer?',
            title_tooltip: '',
            tooltip: 'This allows to link the simulation with the client',
            tooltip_tooltip: '',
        },
        valuer_tool: {
            global: {
                'en-BE': 'English',
                'fr-BE': 'French',
                'nl-BE': 'Dutch',
                photos: 'Photos',
                plans: 'Plans',
                val_submitted: 'Valuation submitted!',
                val_saved: 'Valuation saved!',
            },
            sidebar: {
                summary: {
                    title: 'Summary',
                    lang: 'Request language',
                    epc_score: 'EPC Score',
                },
                save_val: {
                    label: 'Save valuation',
                    sub: 'Does not submit',
                },
                submit_val: 'Submit valuation',
            },
            borrower: {
                language: 'Borrower\u2019s language',
                appointment: {
                    warning_modal:
                        'Before clicking <b>\u201cNext\u201d</b> after selecting a date and time, please make sure that someone can grant the expert access to the property at the scheduled appointment time. <b>You will not be able to change the selected time slot after proceeding to the next step.</b> In case you\u2019ve selected the wrong slot, please proceed with the request. Once you\u2019ve received a confirmation email, get in touch via the contact form and we will reschedule.',
                },
                'billing-address-button': 'Request invoice',
                'billing-address-text':
                    'If you require an invoice, please contact us by clicking the button below. Our team will assist you promptly in generating the necessary documentation for your records.',
                overview: 'Overview',
                access_property_warning:
                    'Please ensure that someone can grant the expert access to the property at the scheduled appointment time ',
                valuer_appointments: {
                    edit: 'Edit appointment',
                    'title-no-appointments': 'No upcoming appointments',
                    title: 'Appointments',
                },
                valuer_info: {
                    title: 'Account settings',
                    description:
                        'In this overview you can set your company\u2019s details to display in the valuation report.',
                    'profile_card-title': 'Valuation expert details',
                    'accreditation_card-number': 'Accreditation number',
                },
                borrower_trans_val: {
                    placeholder: 'Transaction value',
                },
                borrower_email: {
                    placeholder: "Borrower's email",
                },
                set_borrower_language: 'Please ensure this is correct',
                calendar: {
                    message_title: "Can't find a slot that works for you?",
                    message_content:
                        'Send an email to support@rock.estate with the reference to your request, your availabilities and your phone number',
                    button: 'Add to calendar',
                    title: 'Rock.estate on-site valuation',
                },
                'booking-complete': {
                    title: 'Booking complete!',
                    description:
                        'A confirmation email has been sent to your email with the details of your booking. Please send an email to support@rock.estate to change your appointment.',
                },
                receipt: {
                    button: 'View receipt',
                },
                report: {
                    button: 'Download report',
                },
                'payment-error':
                    'There was an error while processing your payment. Please try again',
                submitter: {
                    email_question: 'What are the contact details of the borrower? ',
                    email_text:
                        'Rock.estate will send an email containing a link, which the borrower can click to schedule an on-site expertise appointment.',
                    transaction_question: 'What is the transaction price?',
                    transaction_text:
                        'Please enter the amount (excl. registration fees/VAT) that the borrower pays for the property. This is important to determine the cost of the expertise. It will not be\nshared with the valuation expert.',
                    success_title: 'The booking link is on its way!',
                    success_description:
                        '                Rock.estate has sent an email with a secure link via which the recipient\n                can schedule its on-site expertise appointment. Kindly remind your\n                borrower to promptly book an appointment using this link.',
                    dashboard_button: 'Back to Dashboard',
                },
                'appointment-overview': {
                    title: 'Here\u2019s an overview of your selected appointment time.',
                    'please-share': 'Please share the access details below.',
                    'will-be-present_question':
                        'Will you be the person to give the expert access to the property?',
                    access_representative:
                        'Please request the person that can grant the expert access to the property to be present. This can be the broker, a renter, or someone else you trust the keys with. Please enter their name and phone number so we can contact them if necessary.',
                    'access_representative-label': 'Representative',
                    access_description:
                        'Please clearly describe how the expert can access the property',
                    'access_description-placeholder':
                        'e.g. Ring bell 27 with the name \u2018Dorien De Ridder\u2019 on it\ne.g. You can access the garage with the badge on the keychains.',
                },
                'borrower-details': {
                    title:
                        'To schedule an appointment, please fill out your contact information',
                },
                'confirm-address_unhappy-title': 'There seems to have been a mix up',
                'confirm-address_unhappy-description':
                    'Please get in touch with your loan advisor if you\u2019ve received an incorrect\n                invitation for an on-site expertise appointment.',
                'confirm-address_question':
                    'Do you confirm that you wish to schedule an on-site expertise for this\n                    address?',
                step: {
                    appointment: 'Appointment',
                    'contact-details': 'Contact details',
                    confirmation: 'Confirmation',
                    payment: 'Payment',
                },
                'payment-overview': {
                    title: 'Summary of your on-site valuation',
                    'agree-with-terms':
                        'I hereby agree with the general terms & conditions.*',
                    'confirm-someone-present':
                        'I hereby confirm that someone will be present to give the valuation\n                    expert access to the property.',
                    cancel_title: 'Rescheduling and cancellation policy',
                    cancel_description:
                        'No fees are incurred for rescheduling or cancelling appointments if done more than 24 hours in advance. Changes made within 24 hours will be subject to a 50% charge, and in case of a no-show without prior notice, the entire fee will not be refunded. Please refer to our FAQ for additional details.',
                },
                payment: {
                    billing: 'Billing address',
                    pay: 'Pay',
                    method: 'Select a payment method',
                },
                role: {
                    notary: 'Notary',
                    broker: 'Broker',
                    renter: 'Renter',
                    other: 'Other',
                    place_holder: 'Choose a role',
                },
                'appointment-making': {
                    title: 'Book an appointment',
                },
            },
            valuer: {
                info: 'Info',
                accreditations: 'Accreditations',
                availability: 'Availability',
                appointments: 'Appointments',
            },
            reference_listing: {
                assessed: 'Assessed',
                reference: 'Reference',
                listing_date: 'Listing date',
                touching_sides: 'Touching sides',
                distance: 'Distance',
                price: 'Price',
                price_sqm: 'Price/sqm',
                streetnumber: 'Streetnumber',
                use_as_reference: 'Use as reference',
                add_to_remarks: 'Add to remarks',
                corrected_price: 'Corrected price',
                corrected_price_sqm: 'Corrected price/sqm',
                google_maps: 'View on Google Maps',
            },
            general: {
                title: 'General information',
                basic_infos: {
                    title: 'Basic information',
                    building_found: 'Building found',
                },
                state: {
                    title: 'State',
                    epc_label: 'EPC Label',
                },
                size: {
                    title: 'Size',
                },
                value: {
                    title: 'Value',
                    analytics: {
                        title: 'Analytics',
                        assessed: 'Assessed',
                        median: 'Median',
                        average: 'Average',
                        deviance: 'Deviance',
                    },
                },
                reference_map: {
                    title: 'Reference map',
                },
                reference: {
                    title: 'Reference points',
                    map: {
                        open: 'Open map',
                    },
                },
            },
            exterior: {
                title: 'Exterior',
                parcel: 'Parcel',
                annexes: 'Annexes',
                roof_information: 'Roof information',
                solar_panel: {
                    question: 'Are there solar panels?',
                },
                garage: {
                    name: 'Garage',
                    question: 'Is there a closed garage?',
                    area: 'Garage area',
                    add: 'Add garage +',
                },
                parking: {
                    name: 'Parking spot',
                    question: 'Is there a parking spot?',
                    area: 'Parking area',
                    add: 'Add parking +',
                },
                barn: {
                    question: 'Is there a barn?',
                },
                stables: {
                    question: 'Are there stables?',
                },
                pool_house: {
                    question: 'Is there a pool house?',
                },
                swimming_pool: {
                    question: 'Is there a swimming pool?',
                },
                garden: {
                    question: 'Is there a garden?',
                },
                f_balcony_present: {
                    question: 'Is there a terrace or balcony?',
                },
                f_cellar_attic_present: {
                    question: 'Is there a cellar or an attic?',
                },
            },
            interior: {
                title: 'Interior',
                floors: {
                    floor_mobile_title: 'Interior - Floor {floor}',
                    title: 'Floors',
                    redirected: 'Redirected because no floors were found.',
                    add_floors: 'Add floors',
                    add_apt_floors: 'Add apartment floors',
                    floor: 'Floor',
                    edit_floors: 'Edit floors',
                    go_to_floor: 'Add rooms',
                    delete_floor: {
                        title: 'Delete floor',
                        select_transfer:
                            "Please select where to transfer the deleted floor's room",
                        no_transfer:
                            'Delete floor and attached rooms without transferring them',
                    },
                },
                tabs: {
                    interior: 'Interior',
                    floors: 'Floorplan',
                },
                empty_floors: {
                    title: 'Looks like you didn\u2019t add any floors yet',
                    content: 'Add floors before you can add rooms by pressing the button',
                },
                rooms: {
                    title: 'Rooms',
                    generate: 'Generate rooms',
                    add_room: 'Add a room',
                    edit_room: 'Edit room',
                    add_and_new_room: 'Save and create additional room',
                },
                empty_rooms: {
                    title: 'Looks like you didn\u2019t add any rooms yet',
                    content: 'Add rooms by pressing the button',
                },
            },
            commons: {
                title: 'Common parts',
                certificates: 'EPC certificate common parts',
                apartment: {
                    title: 'Apartment features',
                },
                costs: {
                    title: 'Common costs',
                    amount: 'Cost/month',
                },
                upload: {
                    button_subtitle: 'or drag and drop',
                    button_title: 'Click to upload',
                    title: '<b>Click to upload</b><br />or drag and drop',
                    max: '(max {size} mb)',
                },
            },
            surroundings: {
                title: 'Surroundings',
                mobility: 'Mobility',
            },
            valuation: {
                title: 'Valuation',
                value_pre_reno: 'Market value before renovations',
                scheduled_renov: {
                    title: 'Scheduled renovations',
                    comment:
                        'Please describe what the renovation budget is used for in the \u201cGeneral remarks on the report\u201d. You can find the bank agent\u2019s original input by reviewing the request via your Dashboard.',
                    budget: 'Renovation budget',
                },
                value_post_reno: 'Expected market value after renovations',
                estimated_price: 'Automated estimated value',
                reno_adjustment: 'Total adjustment in %',
                comments: 'General remarks on the report',
            },
            internal_remarks: {
                title: 'Notes',
                description:
                    'These notes are not displayed on the Valuation report. They are for personal reference purposes only.',
            },
            building_violations: {
                placeholder: 'Please describe the building violations',
                question: 'Are there any building violations?',
                tooltip: 'Violation of spatial planning regulations',
            },
            valuer_summary: {
                'skip-notification': 'Skip notifications',
                'appointment_cancel-btn': 'Cancel appointment',
                'appointment_confirm-btn': 'Confirm appointment',
                'payment_post-full': 'Post full payment',
                appointment_title: 'Appointment summary',
                'appointment_not-yet':
                    'No appointment has been scheduled for this request yet.',
                status: 'Status:',
                'payment_not-needed': 'No extra payment needed',
                payment_pending: 'Payment processing\u2026',
                payment_succeeded: 'Payment successfully received',
                payment_cancelled: 'Payment cancelled',
                payment_refunded: 'Payment refunded',
                payment_started: 'Payment pending',
                payment_null: 'Payment status: Unknown',
                'appointment_confirm-cancel':
                    'Are you sure you want to cancel this appointment?',
                appointment_cancelled: 'Appointment has been cancelled',
                appointment_cancelled_by_valuer:
                    'Appointment has been cancelled by the valuer',
                appointment_confirmed: 'The expert has confirmed the appointment',
                appointment_pending_confirmation: "Waiting for expert's confirmation",
                appointment_new: 'Appointment has been created',
            },
            valuer_settings: {
                availability_warning:
                    "You haven't shared any availabilities with us yet. To facilitate the assignment of valuation requests, kindly link your calendar and include at least one availability slot. ",
                availability_title: 'Availability management',
                'availability_add-button': 'Add availability slot',
                availability_districts: 'Districts',
                availability_delete_ays:
                    'Are you sure you want to delete this availability slot?',
            },
        },
        monolith: {
            global: {
                delete: 'Delete',
                i_understand: 'I understand',
                not_available: 'Not available',
                language: 'Language',
                logout: 'Logout',
                login: 'Log in',
                copy: {
                    success: 'Copied to clipboard!',
                    error: 'Something went wrong, please get in touch with the tech team',
                },
                vat: 'VAT',
                subtotal: 'Subtotal',
                total: 'Total',
                or: 'or',
                description: 'Description',
                show_more: 'Show more',
                show_less: 'Show less',
                documents: 'Documents',
                update: 'Update',
                full_name: 'Full name',
                first_name: 'First name',
                last_name: 'Last name',
                phone: 'Phone',
                email: 'Email',
            },
            apps: {
                welcome: 'Welcome',
                valuation: {
                    name: 'Real estate valuation',
                    description:
                        'Request a valuation for a residential property in Belgium',
                },
                ers: {
                    name: 'Energy renovation simulation',
                    description:
                        'Simulate the smartest renovations to increase a home\u2019s energy efficiency',
                },
                dashboard: 'Dashboard',
            },
            shared: {
                apartment: 'An apartment',
                back: 'Back',
                customer_ref_conflict:
                    'There already is a valuation request with the same internal reference. To view this existing request, click on the valuation request reference below:',
                leave_modal: {
                    cancel: 'Stay on the page',
                    confirm: 'Exit',
                },
                next: 'Next',
                previous: 'Previous',
                report: 'Report',
                saved: 'Data saved!',
                streetnumber: 'Streetnumber',
                touching_sides: 'Touching sides',
                wrong_value: '',
                message: 'Message',
                full_address:
                    'The building corresponding to the address cannot be found automatically',
                send: 'Send',
                confirm_before_quit: {
                    title: 'You have unsaved changes.',
                    content: 'Do you want to save before you leave?',
                    confirm: 'Exit',
                    cancel: 'Stay on the page',
                    save: 'Save and exit',
                },
                customer_ref: 'Customer reference',
                address: 'Address',
                customer: 'Customer',
                request_ref: 'Request ref',
                status_col: 'Status',
                created_at: 'Created',
                last_modified: 'Last modified',
                actions: 'Actions',
                owner: 'Owner',
                valuer: 'Valuer',
                short_lang: 'EN',
                help_me: 'Help me, I am blocked!',
                faq: 'FAQ',
                per_page: 'per page',
                search: 'Search',
                email_address: 'email address',
                username: 'username',
                password: 'password',
                roles: 'roles',
                cancel: 'Cancel',
                type: 'Type',
                na: 'Not specified',
            },
            building_type: {
                apartment_comment: 'A living entity part of a larger building',
                construction_plot: 'A construction plot',
                house: 'A house',
                house_comment: 'Building with one single living entity',
                new_apartment: 'New apartment',
                new_house: 'New house',
            },
            map: {
                'cannot-find-any-main-parcel': 'I cannot find the main parcel',
                'cannot-find-confirm-main-building': 'This is not the right building',
                'cannot-find-confirm-main-parcel': 'This is not the main parcel',
                'cannot-find-select-extra-parcels': 'I cannot find some parcels',
                'cannot-find-select-main-building': 'I cannot find the main building',
                'cannot-find-select-main-parcel':
                    'The location is correct but the parcel should only be a part of it (e.g. allotment)',
                'cannot-find-select-parcels': 'I cannot find some parcels',
                'cannot-find-select-secondary-buildings':
                    'I cannot find some secondary building(s)',
                'explanation-confirm-main-parcel': 'Is this the main parcel?',
                'explanation-select-extra-parcels': 'Select additional parcels',
                'explanation-select-main-building': 'Select the main building',
                'explanation-select-main-parcel': 'Select the main parcel',
                'explanation-select-secondary-buildings': 'Select secondary building(s)',
                'explanation-view-building-parcels':
                    'These building and parcels were selected',
                parcel_tooltip: '',
            },
            login: {
                email: 'Your email',
                login: 'Log In',
                msg: {
                    'email-not-authorized':
                        'We could not recognize your email. Please try again.',
                    'email-sent': 'We sent an email with an access link to',
                    'email-sent_message':
                        "If you haven't received a link, please check your spam folder.",
                    'email-sent_title': 'Thank you!',
                    'invalid-token':
                        'The link you used is invalid or has expired, please enter your email address to get a new link.',
                    logout: 'You are successfully logged out.',
                    'invalid-email-address':
                        "It seems like the email address you've entered is invalid",
                    'server-error': 'Unexpected error happened, please try again later',
                    'session-expired':
                        'Your session expired. Please enter your email address to get a new link.',
                    'wrong-environment':
                        'You do not have access to this environment. Please log in at {env} instead',
                },
                title: 'SSO Login',
                welcome: 'Please enter your e-mail to access the application.',
            },
            dashboard: {
                hideFullList: 'Show only assigned valuers',
                showFullList: 'Show full list of valuers',
                specialist: 'Valuation Specialist',
                total: 'Total',
                unassigned: 'Unassigned',
                valuers_workload: 'Valuers Workload',
                my_requests: 'My Requests',
                last_month: 'Last month',
                last_year: 'Last year',
                all_requests: 'All Requests',
                search_request: 'Search Request',
                review_tooltip:
                    'This request has been analyzed by a valuation specialist and some answers need to be reviewed',
                badges: {
                    resubmitted: 'Resubmitted',
                    needs_on_site: 'OVM Needed',
                    needs_borrower_email: 'Borrower email needed',
                    needs_appointment_confirmation: 'Appointment confirmation needed',
                    needs_borrower_action: 'Borrower action needed',
                    appointment_confirmed: 'Appointment confirmed',
                },
                valuer_change_modal: {
                    content:
                        'This request is already assigned. Do you confirm you want to change the assigned valuer? This will prevent the previously assigned valuer from working on the request.',
                    actions: {
                        confirm: 'Confirm',
                    },
                },
                sub_modal: {
                    content:
                        'Do you confirm you want to take ownership of this request? The current owner will be notified of the ownership transfer.',
                },
                title_tooltip: 'Follow here the status of your valuation requests',
                create_report: 'Generate report',
                download_report: 'Save report',
                refresh_report: 'Generate new report',
                report_loading: 'Report loading',
            },
            sidesteps: {
                house: 'House',
            },
            validation: {
                file_too_big: 'Please upload a file under {max_size}MB',
                incoherent_feature: 'Please review the value in this field',
                renovation_cost_minValue:
                    'Please enter a renovation cost higher than 10000',
                required: 'Required',
                wrong_epc: 'Please enter a correct EPC label',
                floors_not_consecutive: 'The selected floors are not consecutive',
                renovation_cost_zero_invalid:
                    'Please enter a renovation cost higher than 0',
            },
            app: {
                session_expiry_warning: {
                    cta: 'Continue session',
                    text: 'Your session will expire in {countdown} seconds.',
                },
            },
            sso_login: {
                welcome: 'Click on the button to log in',
            },
            'multiple-address-modal': {
                title: 'Multiple addresses for this building',
                content: 'Please select the appropriate one',
            },
            chat: {
                beginning: 'This is the beginning of your chat with',
                bank_agent: 'the bank agent',
                vs: 'the Rock.estate Valuation Specialist',
            },
            'action-buttons': {
                info: 'Info',
                edit: 'Edit',
                cancel: 'Cancel',
                unvalue: 'Undo valuation',
                appointment: 'Appointment',
                'confirm-appointment': 'Confirm appointment',
                view_request: 'View request',
                edit_request: 'Edit request',
                dvm: 'DVM',
                ovm: 'Valuation',
                automatic_valuation: 'Automatic valuation',
                web_report: 'Web report',
                pdf_report: 'PDF report',
                generate_pdf_report: 'Generate PDF report',
                regenerate_pdf_report: 'Re-generate PDF report',
                downloading: 'Downloading...',
                take_ownership: 'Take ownership',
            },
            faq: {
                title: 'Frequently Asked Questions',
                question_1: 'Why should I fill in this webform?',
                answer_1:
                    'ING is currently working together with Rockestate to test a new real estate valuation methodology which can be used as part of ING\u2019s mortgage loan origination process. This methodology aims at addressing a number of regulatory requirements that will enter into force later this year. It will also contribute to a simplified transaction process as it should decrease the number of mortgage loans for which an expert will need to visit the property that is being financed. Your participation in this Proof - of -Concept is important. It gives you a chance to help shape this new process ensuring that it meets your needs and expectations.',
                question_2: 'When should I fill in this webform?',
                answer_2:
                    'You are expected to create a new application for every mortgage loan related to a house or apartment, except for new construction.',
                question_3: 'Should I also fill in this webform for renovations?',
                answer_3:
                    'Yes. Mortgage loan applications with a renovation component (renovation or purchase + renovation) are also included.',
                question_4:
                    'Should I fill in this webform if an expert will visit the property?',
                answer_4:
                    'Yes. Mortgage loan applications where an expert needs to be sent on-site are also included.',
                question_5:
                    'Have the existing ING rules in terms of property valuation changed?',
                answer_5:
                    'No. The existing ING rules remain in place until further notice.',
                question_6:
                    'I don\u2019t have the exact address of the building. What should I do?',
                answer_6:
                    'The value of a house or apartment strongly depends on its location. If you are unable to correctly select the building\u2019s address, you should try to identify the approximate location of the building on the map. This will allow us to correctly take into account the value of that specific location.',
                question_7: 'Why am I asked to select the parcels related to a house?',
                answer_7:
                    'The value of a house is not only determined by the building but also by the terrain surrounding it. To correctly estimate its value, we therefore need to know which parcels are related to the house. In the majority of situations, a house has one parcel which we will be able to automatically identify. However, if a house would have multiple parcels, it is important that you indicate those additional parcels on the map.',
                question_8:
                    'Where can I find the input parameters such as EPC, construction year, living area, etc.?',
                answer_8:
                    'If the potential Borrower is not able to give you this information right away, we suggest that you help him find this information by either (i) checking the online ad listing on a real estate portal (e.g. Immoweb, Zimmo, ImmoVlan), or (ii) ask the seller or real estate agent. Useful to know: When putting a house or apartment for sale, it is mandatory to communicate the EPC - value in the listing.',
                question_9: 'I am missing some input parameters. What should I do?',
                answer_9:
                    'There will be situations that you may not be able to collect all the required information. In that case, you can still submit your application. We would like to stress the fact that the quality of a valuation will significantly drop when certain input parameters are missing. Hence the importance of trying to get all the input parameters.',
                question_10: 'Can I submit a new application for the same LOP ID?',
                answer_10:
                    'No. This is currently not possible. If you input a LOP ID for which an application has already been submitted, then you will be able to see all the info related to this application. You will only be able to see this in read-only mode and no overwrite is possible at this stage.',
                question_11:
                    'I don\u2019t have all the information yet. Can I save my pending application?',
                answer_11:
                    'This is not yet possible. We are currently developing this functionality which will make it possible to save a draft of an application before submitting it.',
                question_12: 'Can I have more info about Rockestate?',
                answer_12:
                    'More information regarding Rockestate can be found here: https://www.rockestate.io/about',
                question_13: 'Can I have more info about the data Rockestate uses?',
                answer_13:
                    'More information regarding the data used by Rockestate can be here: https://www.rockestate.io/blog/open-geo-data-rockestates-key-ingredient',
            },
        },
        dashboard: {
            reference_listing: {
                view_button: 'View',
                report_button: 'Report',
                edit_button: 'Edit',
            },
            new_request: {
                title: 'New request',
            },
            type_toggles: {
                ers: 'Energy simulation',
                dvm: 'Valuation request',
            },
        },
        energy: {
            shared: {
                tooltip_more_info: 'More information',
                insulation_year: 'Insulation year',
            },
            building_dimensions: {
                floors: {
                    infobubble:
                        'Including the ground floor, excluding the basement and the attic. ',
                    question: 'How many floors does the house count?',
                    label: 'Number of floors',
                },
                title: 'Approximate the building\u2019s measurements',
                roof: {
                    question: 'What is the shape of the roof?',
                    tooltip:
                        "If the roof does not exist only of flat parts or only of pitched parts, please select 'Some parts are pitched, some are flat'. Use the slider to indicate the estimated proportion of the roof that is flat.",
                },
                roof_type_pitched: 'All parts are pitched',
                roof_type_flat: 'All parts are flat',
                roof_type_mixed: 'Some parts are pitched, and some are flat',
                wall_insulation: {
                    question: 'How many facades are there?',
                    tooltip:
                        'If two or more walls are shared with neighbouring houses, select \u201cAttached\u201d. If there is only one common wall, select \u201cSemi-attached\u201d. Finally, select \u201cDetached\u201d if there are no common walls.',
                },
                facade_type_row: 'Attached house',
                facade_type_row_end: 'Semi-detached house',
                facade_type_isolated: 'Detached house',
            },
            address: {
                map: {
                    no_model: {
                        title:
                            'It looks like we could not find this building\u2019s 3D model',
                        subtitle:
                            'With a few more questions we can approximate the building measurements',
                        change_address: 'Try a different address',
                        start: 'Let\u2019s get started!',
                    },
                    select_building: 'Select your building on the map',
                    cant_find: 'I can\u2019t find my building',
                    confirm_2d: 'Is the right building selected on the map?',
                    confirm_3d:
                        'Does this simplified 3D model represent the right building?',
                    title: 'Your house',
                    placeholder: 'Search for an address to see it on the map.',
                },
                is_loading: 'Loading...',
                title: 'Enter the address to retrieve the building\u2019s measurements',
                title_tooltip:
                    'Based on the address, we retrieve information such as wall surfaces, roof pitch, orientation etc. This enables us to estimate the costs and benefits of renovations.\nOccasionally, official data may contain errors, leading to issues like simultaneously selecting two buildings. In this case please answer that it is not the right house and you cannot find your building. We will then ask additional questions to approximate the buildings measurements.',
                subtitle:
                    "Every building is unique. Through the address, we're able to tailor renovations to the specifics of the building.",
            },
            building_type: {
                title:
                    'Select the building type in scope of the energy renovation project.',
                unavailable_option: 'The tool does not support this type of dwelling.',
                title_tooltip:
                    'Based on the type of property, different information is required to estimate the energy efficiency and propose renovation scenarios. ',
                option: {
                    house: {
                        name: 'A house',
                        description: 'Building with a single living entity',
                    },
                    apartment: {
                        name: 'An apartment',
                        description: 'A living entity part of a larger building',
                    },
                    apartment_building: {
                        name: 'Apartment building',
                        description:
                            'The common parts of the apartment building shared with co-owners',
                    },
                },
            },
            attic: {
                question: 'Do you have an attic?',
                question_heated: 'Is the attic space heated?',
                tooltip:
                    'Attic floor insulation is a cost-efficient solution for insulating the roof area, unless you intend to utilize the attic space as a heated room.',
            },
            basement: {
                question: 'Do you have a basement?',
                tooltip:
                    'If your house is not on the full ground, answer "Yes". Any unheated space below the ground floor, including a crawl space or a partial basement, is considered a basement.',
            },
            living_area: {
                question: 'What\u2019s the house\u2019s living area?',
                lvl_3: {
                    tooltip:
                        'Total floor area that is part of the heated volume. Our estimate takes into account if the attic space is heated or not. You can find the usable floor area in the EPC certificate. ',
                },
                bubble_info:
                    'Based on the building dimensions, we estimate the heated living area at <b class="has-text-primary">{estimated_living_area} m\u00b2</b>. Please enter the actual surface if you know it. You can find the usable floor area in the EPC certificate.',
                lvl_2: {
                    tooltip:
                        'Total floor area that is part of the heated volume, therefore the basement is generally excluded. Include the attic space in case this is a heated room. You can find the usable floor area in the EPC certificate.',
                },
            },
            valid_epc: {
                question: 'Do you have a valid EPC certificate?',
                answer_yes: 'Enter the official EPC score',
                answer_no: 'Simulate your EPC score',
                tooltip:
                    'Only accredited energy experts are allowed to issue EPC certificates. Make sure the certificate is still valid. The EPC certificate documents the energy efficiency of a home in detail, resulting in an Energy Performance Coefficient (EPC) score or EPC label.',
            },
            epc_score: {
                'warning_tooltip-main':
                    'Please note that we do not copy the official EPC score. Instead, we estimate the EPC score based on your input.',
                'warning_tooltip-description':
                    'This allows us to calculate appropriate renovation scenarios. Sometimes the official EPC score can be different from the estimated EPC score. You can check out why this happens in the FAQ 3.1 "The estimated EPC score is different from the official EPC score."',
                question: 'What is the official EPC score?',
                tooltip:
                    "The Energy Performance Coefficient (EPC) is the energy score of a home. It expresses how much kWh /m\u00b2 is needed per year to keep a constant temperature of 18 \u00b0C. You can find it on the EPC certificate. The building's EPC label is based on this score, ranging from A++ (highly efficient) up to G (least efficient), depending on the region's standards. ",
                subtitle: 'Select one of the options',
                answer_kwh: 'kWh/m\u00b2yr',
                answer_label: 'EPC label',
                subtitle_2: 'Enter the official EPC score here',
            },
            construction_year: {
                question: 'When was the house built?',
                tooltip:
                    'The official year of construction, not considering any renovations that may have followed. This info can usually be found in the sales ad, the cadastral register, or the reference year in the EPC certificate.',
                question_specify: 'Specify the construction year',
                label_input: 'Construction year',
            },
            roof_insulation: {
                question: 'Is the roof insulated?',
                tooltip_popup:
                    '### Roof insulation\n\nInsulated roofs have a layer of material to regulate temperature and save energy. **If you have either interior or exterior roof insulation, or attic floor insulation, please answer "Yes". If you are not sure, select "I don\'t know".** In that case, we will consider insulation based on the technical standards at the time of construction.  \n\n**Tips to determine if your roof is insulated or not:**\n\n- Cold ceilings: If the ceilings in your uppermost floor feel cold to the touch, they may lack insulation.\n- Excessive heat: Poorly insulated roofs may allow excessive heat to enter during hot weather, especially noticeable under the roof.\n- High energy bills could indicate poor insulation.\nRoof insulation is an important component of energy-efficient building design and can significantly reduce heating and cooling costs, while improving comfort levels inside the building.',
                info_bubble:
                    'Roof insulation can be <b>exterior or interior roof insulation</b> or <b>attic floor insulation.</b>',
                question_2: 'When was the roof last insulated?',
                label_input: 'Insulation year',
            },
            result: {
                footnote:
                    '*The estimation of the current EPC score is based on the information provided in the questionnaire combined with the building data, and technical requirements as stated by the official EPC software. The more accurate this information is, the better we can approximate the actual EPC score. This does not replace an official EPC certificate. Please consult a professional for a personalized advice. **Prices include 6% or 21% VAT depending on the provided information. They do not include additional works that could be a pre-requisite for the renovation. We update prices on a regular basis. Depending on the time of your visit, the outcome may vary. Always consult a professional to get a personalized advice.',
                EPC_label: 'EPC score',
                budget_label: 'Your budget',
                edit_questionnaire: 'Edit questionnaire',
                scenario_saved_message: 'Scenario saved succesfully',
                no_renovation:
                    '<p><span class="text-primary">Kudos!</span> This property is well equipped for an energy-efficient future.</p>\n\n<p>Based on your input, our simulator could not find profitable renovation scenarios. It seems this property has reached a point where further energy renovations might yield minimal gains. If you\'re committed to making this home an example for sustainable living, here are a few potential upgrades to consider:</p>\n<ul>\n<li>Choose LED lighting</li>\n<li>Install an energy-efficient front door and garage door</li>\n<li>Consider a ventilation system like C+ or system D</li>\n<li>Explore the benefits of a solar boiler</li>\n<li>Invest in a home battery</li>\n</ul>\n\n<p>Thank you for being an eco-conscious homeowner.</p>',
                header: {
                    title: 'The current energy efficiency',
                    subtitle:
                        "Based on the provided details, we've estimated the current EPC score and relevant renovations. This doesn't replace an official EPC score*.",
                },
                epc_score: {
                    title:
                        'The estimated current EPC score is {current_epc_score} kWh/m\u00b2/yr.',
                    subtitle:
                        'As shown by the histogram, {x}% of houses in {region} have a better EPC label.',
                },
                consumption: {
                    title: 'Your consumption',
                    elec: 'Electr.',
                    low: 'Low',
                    high: 'High',
                    med: 'Median',
                    you: 'You',
                },
                package: {
                    title: 'Simulate the smartest renovations',
                    subtitle:
                        'What is your renovation goal? Select the desired EPC label and discover the most cost-effective package to achieve your goal. Do you have a renovation budget? Fill it in and discover the best EPC score you can achieve with it. Or, click and choose which renovations you want to undertake.',
                    current: 'Current EPC',
                    budget: 'Budget',
                    custom: 'Click & choose',
                    target: 'Target EPC',
                    best: 'Best EPC',
                },
                renovation: {
                    wall: 'wall insulation',
                    roof: 'roof insulation',
                    window: 'windows',
                    poorly_insulated:
                        'To adhere to the recommended sequence of energy renovations, the following should be added to this scenario:',
                    mixed: 'Interior roof and ceiling insulation',
                    mixed_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nThe roof is the primary source of heat loss in a building, so it is recommended to start with insulating the roof. It is not possible to insulate flat roofs from the interior. In this scenario, the flat part of the roof is insulated from the ceiling and the pitched part is insulated from the interior of the roof. It is important that you discuss the feasibility of this option with a profession to avoid thermal bridges and condensation. Insulating the roof from the inside is easier to install and cheaper compared to external insulation. Keep in mind that the insulation will take up some of the ceiling space. The costs vary based on the type of roof and the materials used. If you do not use the attic space as a heated area, consider insulating the attic floor instead. \n\n## What's included? \nThe total investment cost includes:  \nFor ceiling insulation: demolition of ceiling, installation of insulation and vapour barrier, ceiling coverage, modifications to existing pipes and lighting.\nFor inteior roof insulation: removal of the degraded insulating layer (including vapor barrier), installation of a new insulating layer and vapor barrier, and adjustments around the roof plane and dormer windows.                ",
                    ceiling_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nThe roof is the primary source of heat loss in a building, so it is recommended to start with insulating the roof. It is not possible to insulate flat roofs from the interior. In this scenario, the flat part of the roof is insulated from the ceiling. It is important that you discuss the feasibility of this option with a profession to avoid thermal bridges and condensation. Insulating the roof from the inside is easier to install and cheaper compared to external insulation. Keep in mind that the insulation will take up some of the attic space. The costs vary based on the type of roof and the materials used. \n\n## What's included? \nThe total investment cost includes:  \nDemolition of ceiling, installation of insulation and vapour barrier, ceiling coverage, modifications to existing pipes and lighting",
                    ceiling: 'Ceiling insulation',
                    roofIn: 'Interior roof insulation',
                    roofIn_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nThe roof is the primary source of heat loss in a building, so it is recommended to start with insulating the roof. Insulating the roof from the inside is easier to install and cheaper compared to external insulation. Keep in mind that the insulation will take up some of the attic space. On the other hand, external roof insulation does not reduce interior space and provides more efficient insulation. The costs vary based on the type of roof and the materials used. If you do not use the attic space as a heated area, consider insulating the attic floor instead. \n\n## What's included? \nThe total investment cost includes:  \nRemoval of the degraded insulating layer (including vapor barrier), installation of a new insulating layer and vapor barrier, and adjustments around the roof plane and dormer windows.                ",
                    atticFloor: 'Attic floor insulation',
                    atticFloor_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nThe roof is the primary source of heat loss in a building, so it is recommended to start with insulating the roof. If the attic space is not used as a heated room, insulating the attic floor can be a cost-effective choice to prevent heat loss through the roof. It is much cheaper compared to insulating the roof itself. This is mainly because of the smaller surface area that needs insulation and the minimal or no finishing required. The installation process is relatively quick and straightforward. However, it may not be the best choice if you ever plan to use the attic space as a heated room. \n\n## What's included? \nThe total investment cost includes:  \nInstallation of insulation and vapor barrier, modifications to existing pipes and lighting, and access adjustment.                ",
                    roofExt: 'Exterior roof insulation',
                    roofExt_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nThe roof is the primary source of heat loss in a building, so it is recommended to start with insulating the roof. External roof insulation has the advantage of not reducing the space under the roof, keeping the home cleaner and habitable during the works. It also allows to install the thickest insulation material. However, insulating from the outside is a more expensive option compared to insulating from the inside of the roof. The total cost depends on the type of roof and the materials used. External roof insulation is a good choice for a flat roof or when you use the space under the roof as a heated room. \n\n## What's included? \nThe total investment cost includes:  \nDemolition of roof covering and structure, demolition of gutters, installation of insulation and a vapour barrier, placement of roof structure and -covering, working around roof vents, placement of gutters, removing and reinstalling solar panels if already present and a crane or hoist.",
                    windowsDouble: 'Windows',
                    windowsDouble_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nOld windows can account for up to 30% of the heat loss in a home. Upgrading to energy-efficient windows, such as high-performance double or triple glazing with airtight frames, can significantly improve insulation. If you plan to insulate the walls, it is advisable to do this before or simultaneously with the installation of new windows. An additional benefit of new windows is that they are more secure due to the extra glass layer, making them more resistant to breakage. \n\n## What's included? \nThe total investment cost includes:  \nDemolition and installation of glass (with surcharge for hoisting equipment), demolition and installation of the frame, installation of RTO on the glass, and demolition and installation of the glass.                ",
                    condGas: 'Condensing gas boiler',
                    condGas_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nGas condensing boilers are designed to extract the heat from the exhaust gases produced during the combustion process. **The lifespan of a gas condensing boiler is typically around 15 years.** By using the extracted heat to preheat the water, the efficiency is higher than that of a traditional boiler. Gas condensing boilers have a positive impact on the EPC score of a house. They work most efficiently when the walls, roof, and windows are well insulated. Consider insulating your home before installing a new heating system for the optimal result. \n\n## What's included? \nThe total investment cost includes:  \nDemolition of existing generator, gas condensing boiler installation, link to existing generator, extra costs for replacing the climate system, insulation non-insulated pipes.",
                    heatPump: 'Heat pump',
                    heatPump_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nHeat pumps extract energy from the air, ground, or the groundwater to heat or cool a space. A better-insulated home loses less heat and, therefore, requires a less powerful pump. Consequently, the price of a heat pump is lower when combined with other energy-efficient renovations. A heat pump reduces dependence on fossil fuels, thus lowering the carbon emissions from your energy consumption. There are different types of heat pumps, such as geothermal, air-air, air-water, and hybrid systems. Prices vary depending on the specific type of a heat pump you choose. \n\n## What's included? \nThe total investment cost includes:  \nDemolition of the existing generator, installation of a heat pump (with soil water; including drilling), connecting it to the existing generator and insulating non-insulated pipes. Additional costs will apply for replacing the climate system.",
                    wallCav: 'Wall cavity insulation',
                    wallCav_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nAfter insulating the roof, it is recommended to insulate the walls. Not all buildings have a cavity (spouw) in their walls, so check whether the building has cavity walls or solid walls. Cavity wall insulation can provide excellent thermal insulation at an affordable price. However, be aware of potential issues like condensation and mold formation. If the home is located in an area with a lot of wind-driven rain, consider alternatives to prevent moisture-related problems. \n\n## What's included? \nThe total investment cost includes:  \nUse of an aerial work platform, installation of 5 cm mineral wool insulation including inspection, preparation, blowing in and closing the openings.",
                    unitPv: 'Solar panels',
                    unitPv_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nSolar panels can be a cost-effective way to improve the EPC score and reduce your energy bills. However, it is recommended to first renovate the roof, walls, windows, and heating system. The efficiency of solar panels depends on several factors such as surface area, orientation, and shading on the roof. In some cases, you may need a permit to install solar panels, for example, if the home is listed in the architectural heritage register. \n\n## What's included? \nThe total investment cost includes:  \nInstallation of solar panels including all accessories.                ",
                    wallExt: 'Exterior wall insulation',
                    wallExt_tooltip_popup:
                        "### {tooltip_title}  \n## Good to know\n\nAfter roof insulation, it is recommended to insulate the walls. External wall insulation along the outer fa\u00e7ade has the advantage that you don't lose living space, and the house remains habitable during the work. It also helps to reduce external noise. Always check if the home is suitable for external wall insulation. Since the aesthetic characteristics of the fa\u00e7ade may change, there may be requirements for a building permit, for example, if you are renovating a historic building.  \n\n## What's included? \nThe total investment cost includes:  \nBreaking down rainwater drainage, sawing off sills, installing insulation, placement of finishes (in crepi), update openings (including sills), carry out edits, enlarge roof projection, renew rainwater drainage, and a scaffolding.                ",
                },
                warning: {
                    solar_panel:
                        'If you plan on insulating the roof in the future, consider adding it to the renovation scenario. This way you avoid the additional costs from removing and reinstalling solar panels. Remember that it is not allowed to install solar panels on a roof that contains asbestos.',
                    window:
                        'Consider adding roof and/or wall insulation to the renovation scenario to avoid future costs from removing window frames again to install insulation.',
                    heating:
                        'Consider whether the roof, walls, and glazing provide sufficient insulation before renovating the heating system. If you install a new heating system in a poorly insulated home, you will need a larger and consequently more expensive system to heat the same volume.',
                },
                summary: {
                    title: 'Summary',
                    subtitle:
                        'The prices below are indicative. The VAT percentage is based on taxation legislation.**',
                    item: 'Item',
                    price_incl_vat: 'Price incl. VAT',
                    price_excl_vat: 'Price excl. VAT',
                },
                property_value: 'Property market value',
                savings: {
                    title: 'Savings',
                    epc: 'EPC improvement',
                    carbon: 'Carbon emissions',
                    bills: 'Energy bills',
                },
                button: {
                    add_remove: 'Add or remove renovations',
                    download: 'Download',
                    share: 'Share',
                    edit_input: 'Edit input',
                },
                one_renovation_available:
                    'Based on your input, our simulator could find only one profitable renovation scenarios',
                price: '\u20ac{value}',
            },
            summary: {
                epc: 'EPC certificate',
                answers_needs_to_be_fixed:
                    'Some answers needs to be fixed, please fill values of questions surrounded in red.',
                energy_consumption_known: 'Energy consumption known',
                heated: 'Heated',
                not_heated: 'Not heated',
                insulation_year: 'Insulation year',
                residents: 'Number of inhabitants ',
                heating_consumption: 'Heating consumption',
                electricity_consumption: 'Electricity consumption',
                high: 'High',
                medium: 'Medium',
                low: 'Low',
                big_consumer: 'Big energy consumers',
                fuel_error:
                    'The fuel type has changed and some answers needs to be fixed accordingly.',
                construction_year_error:
                    'The construction year has changed and some answers need to be fixed accordingly.',
                title: 'Here\u2019s a summary of your request for validation',
                subtitle:
                    'Take a moment to verify your input. If anything needs correction, click the pencil icon.',
            },
            package: {
                epc: {
                    title: 'I want to meet an EPC score',
                    description:
                        'This returns the scenario that meets the target EPC score for the lowest budget',
                },
                budget: {
                    title: 'I have a maximum budget',
                    description:
                        'This returns the scenario that achieves the best EPC score within the maximum budget',
                },
                custom: {
                    title: 'I want to choose my scenario',
                    description:
                        'Click & choose your own set of renovations to create custom scenarios',
                },
            },
            wall_insulation: {
                question: 'Are the facades insulated?',
                tooltip_popup:
                    '### Facade insulation\nInsulated facades have a layer of material to prevent heat losses. \n**If the facades are not insulated, please select "No".\nIf you are not sure, select "I don\'t know".** In that case, we will consider insulation based on the technical standards at the time of construction.  \n\n**Tips to determine if your walls are not insulated:** \n- Cold walls: If the walls feel cold to the touch, they may lack insulation.\n- Excessive noise: Poorly insulated walls may not block noise.\n- High energy bills could indicate poor insulation.\n\nWall insulation is an important component of the energy-efficient building design and can significantly reduce heating and cooling costs, while improving comfort levels inside the building.',
                bubble_info:
                    'Wall insulation can be <b>exterior or interior wall insulation</b> or <b>wall cavity insulation.</b>',
                question_2: 'When were the facades last insulated?',
            },
            floor_insulation: {
                question: 'Is the ground floor or basement ceiling insulated?',
                tooltip_popup:
                    '### Floor insulation\n\nInsulated floors have a layer of material to regulate temperature and save energy. **If you have floor insulation, please answer "Yes". If you are not sure, select "I don\'t know".** In that case, we will consider insulation based on the construction year standards.  \n\n**Tips to determine if your floors are insulated or not:**\n- Cold floors: If the floors feel cold to the touch, they may lack insulation.\n- High energy bills could indicate poor insulation.',
                question_2: 'When was the floor last insulated?',
            },
            window: {
                warning_tooltip:
                    "The property was built after 2000. So it's unlikely this type of window glazing was used.",
                question: 'What is the main type of window glazing in the home?',
                tooltip_popup:
                    '### Windows\n\nIf you have a technical documentation, such as an invoice from the window installation, refer to it for the information on window glazing.\n\n**If there is no documentation available, here are some tips to determine window glazing:**\n\n- **Single, double, or triple glazing:** Hold up an item to the glass; one reflection indicates a single-pane window, two reflections indicate a double-pane window, and three reflections indicate a triple-pane window.\n- **Double, all high performance or triple glazing:** Look for the aluminum strip between two glass layers. High-performance glazing is sometimes marked by the letters "HR", "HR+", or "HR++". Triple glazing is marked with "HR+++". You can also search for the code marked on the inside of the window strip on the producer\'s website.',
            },
            heating: {
                question: 'Select the main heating system',
                tooltip:
                    'We make the assumption that the same heating system provides heating and hot water. If the house has more than one heating system, please select the one that heats the biggest volume.',
            },
            end_section: {
                got_it: 'Got it!',
                text:
                    'With this information we can estimate the EPC score and recommend suitable renovations.',
                go_to_consumption: 'Go to Consumption',
            },
            energy_consumption: {
                question: "Do you know your household's annual energy consumption?",
                bubble_info:
                    'You can check your consumption on the invoice from your energy provider or online with your network operator. Moving from an apartment to a house, or to a better or worse insulated dwelling, can affect your annual energy consumption. Please estimate accordingly.',
                yes_text: 'I want to fill out my yearly energy consumption',
                no_text: 'Help me estimate my yearly energy consumption',
            },
            consumers: {
                title: 'Your consumption',
                question_1a: 'How many people live in the house?',
                tooltip_1:
                    'Count only year-round residents. Please exclude individuals who are present only on the weekends or temporarily. This helps to estimate energy consumption based on the household size.',
                question_2a: 'What is the yearly energy consumption of the grid?',
                tooltip_2:
                    'You can find your annual energy consumption in the yearly settlement provided by your energy provider. If you use electric heating systems such as heat pumps and electric heaters, make sure to take them into account when calculating your overall electricity consumption.',
                bubble_info:
                    'The annual electricity consumption refers to the total kWh of the grid consumed in a year. Do not take into account electricity that you may generate yourself.',
                question_1b: 'How would you estimate your heating consumption?',
                tooltip_popup_1:
                    '### Heating consumption estimation \n- Low: Studio renters, small households with eco-friendly heating systems. ~{min} kWh/year for heating\n- Medium: Average-sized households with standard appliance. ~{med} kWh/year for heating\n- High: Large households and higher heating demands due to larger living space. ~{max} kWh/year for heating',
                question_2b: 'How would you estimate your electricity consumption?',
                tooltip_popup_2:
                    '### Electricity consumption estimation\n- Low: Households of 1-2 people, or households with solar panels. ~{min} kWh/year\n- Medium: Average-sized households with standard appliance. ~{med} kWh/year\n- High: Large household or energy-intensive appliances like electric heating, air conditioner, electric cars, or swimming pools. ~{max} kWh/year',
            },
            big_consumers: {
                question: 'Does the household power big energy consumers at home?',
                tooltip:
                    'Big energy consumers are fully electric vehicles, air conditioning, a swimming pool, or a spa room.',
            },
        },
        admin_panel: {
            user_mgmt: {
                new_accreditation: 'New accreditation',
                add_accreditation: 'Add',
                accreditation_number: 'Accreditation number',
                accreditation_institution: 'Institution',
            },
        },
        dvm: {
            shared: {
                actions: {
                    generating_report: 'Generating pdf report',
                    incoherent_features: 'Select incoherent features',
                    onsite: 'Request on site valuation',
                    resubmit: 'Resubmit',
                    save: 'Save valuation without submitting',
                    submit: 'Submit valuation',
                },
                add_to_remarks: 'Add to remarks',
                anchors: {
                    avm: 'AVM',
                    description: 'Description',
                    dvm: 'Desktop Valuation',
                    flood_map: 'Flood map',
                },
                duplicates: 'Duplicates',
                duplicates_modal: {
                    close: 'Close',
                    copy_ref: "Copy request's reference",
                    open_dvm: 'Open Valuation Tool for this request',
                    reason: 'Reason',
                    reasons: {
                        'close point': 'Close point',
                        'same address': 'Same address',
                        'same customer_ref': 'Same customer reference',
                        'same place': 'Same place',
                    },
                    title: 'Showing duplicates for',
                },
                error_modal: {
                    actions: {
                        incoherent_patch:
                            'PATCH call of the incoherent features submission',
                        incoherent_put: 'PUT call of the incoherent features submission',
                        onsite_patch: 'PATCH call of the onsite submission',
                        onsite_put: 'PUT call of the onsite submission',
                        report_post: 'POST report (report generation)',
                        resubmit_patch: 'PATCH call of the resubmission',
                        resubmit_put: 'PUT call of the resubmission',
                        submitVal_patch: 'PATCH call of the valuation submission',
                        submitVal_put: 'PUT call of the valuation submission',
                    },
                    back_to_dashboard: 'Go back to the Dashboard',
                    cancel: 'Cancel',
                    content:
                        'An error occured while doing the <pre>{action} </pre> for the request <pre>{ref} </pre>\nPlease report it to the engineering team including those informations as well as this error message:',
                    title: 'An error occured',
                },
                incoherent_features_modal: {
                    back_to_dashboard: 'Go back to the Dashboard',
                    confirmation_message: 'Valuation request sent for review!',
                    submit: 'Send incoherent features',
                    title: 'Incoherent features',
                },
                onsite_modal: {
                    back_to_dashboard: 'Go back to the Dashboard',
                    confirmation_message: 'Valuation request deferred on-site!',
                    reasons: {
                        onsite_commercial_building: 'Commercial building',
                        onsite_exceptional_property: 'Exceptional property for the area',
                        onsite_extensive_renovation: 'Ratio renovation/current value',
                        onsite_few_comparison: 'Not enough comparison data points',
                        onsite_flood_zone: 'Flood zone risk',
                        onsite_incoherent_features: 'Wrong input filled',
                        onsite_others: 'Other',
                        onsite_streetview: 'Streetview data not available or outdated',
                        onsite_volume_missing: 'Building volume missing',
                    },
                    submit: 'Defer to on-site',
                    title: 'Request on-site valuation',
                },
                price: 'Price',
                price_per_sqm: 'Price per sqm',
                price_sqm: 'Price/sqm',
                address: 'address',
                transaction_value: 'Transaction value',
            },
            request: {
                add_document: 'Add a document',
            },
            dashboard: {
                all: 'All customers',
            },
            avm: {
                analysis: 'Analysis',
            },
            description: {
                annexes: {
                    title: 'Annexes',
                },
                apartment_features: {
                    title: 'Apartment features',
                },
                basic_info: {
                    building_found: 'Building found',
                    building_type: {
                        label: 'Building Type',
                        options: {
                            apartment: 'Apartment',
                            construction_plot: 'Construction plot',
                            house: 'House',
                            new_apartment: 'New apartment',
                            new_house: 'New house',
                        },
                    },
                    level: 'Level',
                    renovations: {
                        label: 'Renovations',
                        warning: 'Renovations costs > 15% of AVM price',
                    },
                    title: 'Basic info',
                    touching_sides: 'Number of touching sides',
                },
                other: {
                    f_dist_building_flood: 'Building distance to nearest flood zone',
                    f_dist_parcel_flood: 'Parcel distance to nearest flood zone',
                    f_matched_entities: 'Matched economic entities',
                    title: 'Other',
                },
                size: {
                    title: 'Size',
                },
                state: {
                    f_epc_label: 'EPC Label',
                    title: 'State',
                },
            },
            desktop: {
                apply_influence: 'Apply Features Deviation',
                dvm_adjustment: 'Total DVM Adjustment',
                environment: {
                    'above-avg': 'Above average',
                    avg: 'Average',
                    'below-avg': 'Below average',
                    title: 'Environment (not shown on the report)',
                },
                market_correction: 'Market Correction',
                overridden_influence: 'Overridden Deviation',
                total_influence: 'Total Deviation',
                update_remarks: 'Update Internal Remarks with Deviations',
            },
            feedback: {
                or_not:
                    'We would like to ask you a few more questions about your experience.',
            },
            validation: {
                parcel_cost_minValue: 'Please enter a land cost higher than 10000',
            },
            modal: {
                success_modal: {
                    actions: {
                        back_to_dashboard: 'Go back to the Dashboard',
                        show_report: 'Go to report',
                        stay_on_page: 'Stay on this page',
                    },
                    content: 'Your valuation was submitted.',
                    title: 'Valuation submitted',
                },
            },
        },
        argenta: {
            valuation: {
                enter: {
                    alt_customer_ref_title: 'What is the property number of the loan?',
                },
                start: {
                    welcome_text_2:
                        'Every request starts with the input of the internal reference of the loan, being the customer number of (one of) the borrower(s). We then ask you a couple of questions related to the property. For more information, please refer to the FAQ.',
                    welcome_text_3:
                        'This tool may only be used by Argenta personnel who apply for mortgage loans via the loan application. Furthermore, this application may only be used in cases where the customer has agreed to submit a credit application to Argenta.',
                },
            },
        },
        avm: {
            step1: {
                errors: {
                    default:
                        'An unknown error occured. A desktop valuation is advised in this case.',
                    too_few_reference_listings:
                        'This location has too few reference listings in the neighbourhood. A desktop valuation is advised in this case.',
                },
            },
            shared: {
                extreme_value: 'Extreme value for',
            },
            form: {
                step4: {
                    details: {
                        close: 'Close',
                        link: 'View details >',
                        text:
                            'The larger the habitable surface, the more expensive the house. The graph below shows the correlation in more detail',
                        title: 'The main feature is the habitable surface',
                    },
                    plot_title: {
                        f_construction_year: 'Construction year',
                        f_epc: 'EPC',
                        f_living_area: 'Living area',
                        f_parcel_area: 'Parcel area',
                    },
                    subtitle:
                        'It is a house with a relatively small garden | The house is quite spacious | It is a fairly recent home',
                },
                step5: {
                    card1: {
                        li_1:
                            'The house is outdated and needs to be completely renovated',
                        li_2: 'The house is far away from shops',
                        title: 'Why could the asking price be lower?',
                    },
                    card2: {
                        li_1: 'The house has just been renovated',
                        li_2: 'The house has a beautiful location',
                        li_3: 'There is a lot of light in the house',
                        title: 'Why could the asking price be higher?',
                    },
                    send: 'Send',
                    subtitle:
                        'Enter the email address below to which we can send the results.',
                    text1:
                        'The graph shows how this target price relates to the house prices of the 200 houses in the area.',
                    text2:
                        'This automatic valuation is a statistical valuation based on information provided and a comparison with several other neighboring properties. There is no review by a real estate expert, and the final valuation may change as a result.',
                    title: 'Download results',
                },
            },
        },
        ing: {
            valuation: {
                enter: {
                    customer_ref_title: 'What is the LOP ID of the loan?',
                    forbidden_substring: 'This field cannot contain 0000000',
                },
                request: {
                    tab_title: 'ING Input Form',
                },
                start: {
                    welcome_text_2:
                        'Every request starts with the input of the relevant LOP ID. We then ask you a couple of question related to the property. For more info, please refer to the FAQ.',
                    welcome_text_3:
                        'This tool may only be used by ING employees with a mortgage license and this for actual LOP files only. The link to this tool may not be forwarded, nor inside nor outside the ING network. This is because of internal measures against fraud or abuse.',
                },
            },
            monolith: {
                shared: {
                    customer_ref: 'LOP ID',
                },
            },
        },
        keytrade: {
            valuation: {
                start: {
                    welcome_text_2:
                        'Every request starts with the input of the relevant internal reference of the loan. We then ask you a couple of questions related to the property. For more information, please refer to the FAQ.',
                    welcome_text_3:
                        'This tool may only be used by Keytrade employees with a mortgage license and only for actual internal reference files only.',
                },
            },
        },
        ovm_dispatch: {
            settings: {
                title: 'Dispatcher dashboard',
                subtitle: 'Availability',
                nuts: {
                    placeholder: 'Select a NUTS',
                    caption: 'Number of available valuers in this NUTS:',
                },
                valuer: {
                    placeholder: 'Select a valuer',
                    error: 'No availability info found for this selection.',
                },
            },
            request: {
                confim: 'Confirm changes',
                notification: {
                    end_time: 'End time should be later than start time',
                },
                appointment: {
                    title: 'Create new appointment',
                    subtitle:
                        "The appointment detailed above will be cancelled and a new one will be created. The assigned valuer will be notified of the appointment's cancellation.",
                    button: 'Create appointment',
                    previous: 'Previous appointment records',
                },
            },
        },
        ovm: {
            settings: {
                unsaved_warning:
                    'You have unsaved changes. Please save them before switching tabs.',
            },
        },
    },
    technical: {
        unit: {
            m: 'unit.m',
            m_tooltip: '',
            m2: 'unit.m2',
            m2_tooltip: '',
            m3: 'unit.m3',
            m3_tooltip: '',
            'kwh/m2year': 'unit.kwh/m2year',
            'kwh/m2year_tooltip': '',
            euro: 'unit.euro',
            euro_tooltip: '',
            'euro/month': 'unit.euro/month',
            'euro/month_tooltip': '',
            'euro/year': 'unit.euro/year',
            'euro/year_tooltip': '',
            'euro/m2': 'unit.euro/m2',
            'euro/m2_tooltip': '',
            'kgco2/m2year': 'unit.kgco2/m2year',
            'kgco2/m2year_tooltip': '',
            'kgco2/year': 'unit.kgco2/year',
            'kgco2/year_tooltip': '',
            'kwh/year': 'unit.kwh/year',
            'kwh/year_tooltip': '',
            'l/year': 'unit.l/year',
            'l/year_tooltip': '',
            'kg/year': 'unit.kg/year',
            'kg/year_tooltip': '',
            'm3/year': 'unit.m3/year',
            'm3/year_tooltip': '',
            percent: 'unit.percent',
            percent_tooltip: '',
            month: 'unit.month',
            month_tooltip: '',
            kWh: 'unit.kWh',
            kWh_tooltip: '',
            l: 'unit.l',
            l_tooltip: '',
            kg: 'unit.kg',
            kg_tooltip: '',
            'kWh/m2/yr': 'unit.kWh/m2/yr',
            'kWh/m2/yr_tooltip': '',
            'kWh/yr': 'unit.kWh/yr',
            'kWh/yr_tooltip': '',
            'l/yr': 'unit.l/yr',
            'l/yr_tooltip': '',
            'm3/yr': 'unit.m3/yr',
            'm3/yr_tooltip': '',
            'kg/co2/yr': 'unit.kg/co2/yr',
            'kg/co2/yr_tooltip': '',
            'kg/yr': 'unit.kg/yr',
            'kg/yr_tooltip': '',
        },
        address: {
            full_address: 'address.full_address',
            full_address_tooltip: 'address.full_address_tooltip',
            streetname: 'address.streetname',
            streetname_tooltip: '',
            streetnumber: 'address.streetnumber',
            streetnumber_tooltip: '',
            boxnumber: 'address.boxnumber',
            boxnumber_tooltip: '',
            postalcode: 'address.postalcode',
            postalcode_tooltip: '',
            municipality: 'address.municipality',
            municipality_tooltip: '',
        },
        valuation: {
            date: 'valuation.date',
            date_tooltip: '',
            type: 'valuation.type',
            type_tooltip: '',
            performed_for: 'valuation.performed_for',
            performed_for_tooltip: '',
            valuer: 'valuation.valuer',
            valuer_tooltip: '',
            monitor: 'valuation.monitor',
            monitor_tooltip: '',
            market_value: 'valuation.market_value',
            market_value_tooltip: '',
            market_value_post_renovation: 'valuation.market_value_post_renovation',
            market_value_post_renovation_tooltip: '',
            construction_cost: 'valuation.construction_cost',
            construction_cost_tooltip: '',
            market_value_pre_construction: 'valuation.market_value_pre_construction',
            market_value_pre_construction_tooltip: '',
            forced_sale_value_pre_construction:
                'valuation.forced_sale_value_pre_construction',
            forced_sale_value_pre_construction_tooltip: '',
            forced_sale_value_post_renovation:
                'valuation.forced_sale_value_post_renovation',
            forced_sale_value_post_renovation_tooltip: '',
            forced_sale_value: 'valuation.forced_sale_value',
            forced_sale_value_tooltip: '',
            rental_value: 'valuation.rental_value',
            rental_value_tooltip: '',
            reconstruction_value: 'valuation.reconstruction_value',
            reconstruction_value_tooltip: '',
            cadastral_income: 'valuation.cadastral_income',
            cadastral_income_tooltip: '',
            index_value: 'valuation.index_value',
            index_value_tooltip: '',
            index_type: 'valuation.index_type',
            index_type_tooltip: '',
            explanation_1: 'valuation.explanation_1',
            explanation_1_tooltip: '',
            explanation_2: 'valuation.explanation_2',
            explanation_2_tooltip: '',
            explanation_3: 'valuation.explanation_3',
            explanation_3_tooltip: '',
            construction_plot_explanation_3: 'valuation.construction_plot_explanation_3',
            construction_plot_explanation_3_tooltip: '',
            explanation_4: 'valuation.explanation_4',
            explanation_4_tooltip: '',
            explanation_5: 'valuation.explanation_5',
            explanation_5_tooltip: '',
            construction_plot_explanation_5: 'valuation.construction_plot_explanation_5',
            construction_plot_explanation_5_tooltip: '',
            explanation_6: 'valuation.explanation_6',
            explanation_6_tooltip: '',
            onsite_explanation_6: 'valuation.onsite_explanation_6',
            onsite_explanation_6_tooltip: '',
            shared: {
                apartment: 'valuation.shared.apartment',
                assessed: 'valuation.shared.assessed',
                destructive_safeguard: {
                    confirm: 'valuation.shared.destructive_safeguard.confirm',
                    content: 'valuation.shared.destructive_safeguard.content',
                    title: 'valuation.shared.destructive_safeguard.title',
                },
                distance: 'valuation.shared.distance',
                listing_date: 'valuation.shared.listing_date',
                reference: 'valuation.shared.reference',
            },
            desktop: {
                avm_features_influence: 'valuation.desktop.avm_features_influence',
            },
            sidesteps: {
                borrower_details: 'valuation.sidesteps.borrower_details',
                chat: {
                    button: 'valuation.sidesteps.chat.button',
                    title: 'valuation.sidesteps.chat.title',
                },
                construction_plot: 'valuation.sidesteps.construction_plot',
                extra_info: 'valuation.sidesteps.extra_info',
                feedback: 'valuation.sidesteps.feedback',
            },
            floors: {
                close: 'valuation.floors.close',
            },
            enter: {
                conflict_modal: {
                    back: 'valuation.enter.conflict_modal.back',
                    content: 'valuation.enter.conflict_modal.content',
                    continue: 'valuation.enter.conflict_modal.continue',
                    cta: 'valuation.enter.conflict_modal.cta',
                    dashboard: 'valuation.enter.conflict_modal.dashboard',
                    title: 'valuation.enter.conflict_modal.title',
                },
                customer_ref_title: 'valuation.enter.customer_ref_title',
                tooltip_text: 'valuation.enter.tooltip_text',
            },
            extra_info: {
                construction_cost_minValue:
                    'valuation.extra_info.construction_cost_minValue',
                documents: 'valuation.extra_info.documents',
                documents_modal: {
                    label: 'valuation.extra_info.documents_modal.label',
                    steps: {
                        online: 'valuation.extra_info.documents_modal.steps.online',
                        upload: 'valuation.extra_info.documents_modal.steps.upload',
                        uploading: 'valuation.extra_info.documents_modal.steps.uploading',
                    },
                    title: 'valuation.extra_info.documents_modal.title',
                    warning: 'valuation.extra_info.documents_modal.warning',
                },
            },
            feedback: {
                customer_present: 'valuation.feedback.customer_present',
                more_questions: 'valuation.feedback.more_questions',
                question_one: 'valuation.feedback.question_one',
                question_three_blocked: 'valuation.feedback.question_three_blocked',
                question_three_sent: 'valuation.feedback.question_three_sent',
                question_two: 'valuation.feedback.question_two',
                question_two_1: 'valuation.feedback.question_two_1',
                question_two_1_text: 'valuation.feedback.question_two_1_text',
                question_two_2: 'valuation.feedback.question_two_2',
                question_two_2_link: 'valuation.feedback.question_two_2_link',
                question_two_2_text: 'valuation.feedback.question_two_2_text',
                question_two_3: 'valuation.feedback.question_two_3',
                question_two_4: 'valuation.feedback.question_two_4',
                question_two_5: 'valuation.feedback.question_two_5',
                question_two_6: 'valuation.feedback.question_two_6',
                rating_1: 'valuation.feedback.rating_1',
                rating_2: 'valuation.feedback.rating_2',
                rating_3: 'valuation.feedback.rating_3',
                rating_4: 'valuation.feedback.rating_4',
                rating_5: 'valuation.feedback.rating_5',
                send: 'valuation.feedback.send',
                rating_description: 'valuation.feedback.rating_description',
            },
            start: {
                dashboard: 'valuation.start.dashboard',
                welcome_text_1: 'valuation.start.welcome_text_1',
                welcome_text_2: 'valuation.start.welcome_text_2',
                welcome_text_3: 'valuation.start.welcome_text_3',
                welcome_title: 'valuation.start.welcome_title',
            },
            avm: {
                no_bedroom: 'valuation.avm.no_bedroom',
            },
            request: {
                start_button_text: 'valuation.request.start_button_text',
                start_over: 'valuation.request.start_over',
                tab_title: 'valuation.request.tab_title',
                text_too_long: 'valuation.request.text_too_long',
                textarea_placeholder: 'valuation.request.textarea_placeholder',
                title: 'valuation.request.title',
                which_type: 'valuation.request.which_type',
                which_address: 'valuation.request.which_address',
                title_blocked: 'valuation.request.title_blocked',
                title_sent: 'valuation.request.title_sent',
            },
            building_type: {
                tooltip_text: 'valuation.building_type.tooltip_text',
            },
            address: {
                tooltip_text: 'valuation.address.tooltip_text',
            },
            map: {
                'tooltip-for-confirm-main-building':
                    'valuation.map.tooltip-for-confirm-main-building',
                'tooltip-for-confirm-main-parcel':
                    'valuation.map.tooltip-for-confirm-main-parcel',
                'tooltip-for-select-extra-parcels':
                    'valuation.map.tooltip-for-select-extra-parcels',
                'tooltip-for-select-main-building':
                    'valuation.map.tooltip-for-select-main-building',
                'tooltip-for-select-main-parcel':
                    'valuation.map.tooltip-for-select-main-parcel',
                'tooltip-for-select-parcels': 'valuation.map.tooltip-for-select-parcels',
                'tooltip-for-select-secondary-buildings':
                    'valuation.map.tooltip-for-select-secondary-buildings',
                'tooltip-for-view-building-parcels':
                    'valuation.map.tooltip-for-view-building-parcels',
                use_as_reference: 'valuation.map.use_as_reference',
            },
            '': {
                upload_documents_tooltip: 'valuation..upload_documents_tooltip',
            },
        },
        assessment: {
            date: 'assessment.date',
            date_tooltip: '',
            type: 'assessment.type',
            type_tooltip: '',
        },
        value: {
            avm: 'value.avm',
            avm_tooltip: '',
            dvm: 'value.dvm',
            dvm_tooltip: '',
            ovm: 'value.ovm',
            ovm_tooltip: '',
            flood_assessment: 'value.flood_assessment',
            flood_assessment_tooltip: '',
            ers: 'value.ers',
            ers_tooltip: '',
            short: {
                avm: 'value.short.avm',
                avm_tooltip: '',
                dvm: 'value.short.dvm',
                dvm_tooltip: '',
                ovm: 'value.short.ovm',
                ovm_tooltip: '',
                ers: 'value.short.ers',
                ers_tooltip: '',
            },
            '-': 'value.-',
            '-_tooltip': '',
            new_loan: 'value.new_loan',
            new_loan_tooltip: '',
            revaluation: 'value.revaluation',
            revaluation_tooltip: '',
            classic_tooltip: '',
            renovation_light_tooltip: '',
            renovation_full_tooltip: '',
            new_building: 'value.new_building',
            new_building_tooltip: 'value.new_building_tooltip',
            existing_building: 'value.existing_building',
            existing_building_tooltip: 'value.existing_building_tooltip',
            house: 'value.house',
            house_tooltip: 'value.house_tooltip',
            apartment: 'value.apartment',
            apartment_tooltip: 'value.apartment_tooltip',
            annex: 'value.annex',
            annex_tooltip: '',
            new_construction: 'value.new_construction',
            new_construction_tooltip: '',
            new_house: 'value.new_house',
            new_house_tooltip: 'value.new_house_tooltip',
            new_apartment: 'value.new_apartment',
            new_apartment_tooltip: 'value.new_apartment_tooltip',
            construction_plot: 'value.construction_plot',
            construction_plot_tooltip: '',
            attached: 'value.attached',
            attached_tooltip: '',
            semi: 'value.semi',
            semi_tooltip: '',
            detached: 'value.detached',
            detached_tooltip: '',
            yes: 'value.yes',
            yes_tooltip: '',
            no: 'value.no',
            no_tooltip: '',
            traditional: 'value.traditional',
            traditional_tooltip: '',
            modern: 'value.modern',
            modern_tooltip: '',
            contemporary: 'value.contemporary',
            contemporary_tooltip: '',
            mediterranean: 'value.mediterranean',
            mediterranean_tooltip: '',
            other: 'value.other',
            other_tooltip: '',
            ground_floor: 'value.ground_floor',
            ground_floor_tooltip: '',
            1: 'value.1',
            '1_tooltip': '',
            2: 'value.2',
            '2_tooltip': '',
            3: 'value.3',
            '3_tooltip': '',
            4: 'value.4',
            '4_tooltip': '',
            '>4': 'value.>4',
            '>4_tooltip': '',
            interior: 'value.interior',
            interior_tooltip: '',
            exterior: 'value.exterior',
            exterior_tooltip: '',
            private: 'value.private',
            private_tooltip: '',
            common: 'value.common',
            common_tooltip: '',
            'private+common': 'value.private+common',
            'private+common_tooltip': '',
            maintenance_required: 'value.maintenance_required',
            maintenance_required_tooltip: '',
            good: 'value.good',
            good_tooltip: '',
            very_good: 'value.very_good',
            very_good_tooltip: '',
            security: 'value.security',
            security_tooltip: '',
            water_softener: 'value.water_softener',
            water_softener_tooltip: '',
            air_con: 'value.air_con',
            air_con_tooltip: '',
            elevator: 'value.elevator',
            elevator_tooltip: '',
            domotics: 'value.domotics',
            domotics_tooltip: '',
            storage: 'value.storage',
            storage_tooltip: '',
            rain_water: 'value.rain_water',
            rain_water_tooltip: '',
            hot_tub: 'value.hot_tub',
            hot_tub_tooltip: '',
            cinder_blocks: 'value.cinder_blocks',
            cinder_blocks_tooltip: '',
            wood: 'value.wood',
            wood_tooltip: '',
            plaster: 'value.plaster',
            plaster_tooltip: '',
            natural_stone: 'value.natural_stone',
            natural_stone_tooltip: '',
            metal: 'value.metal',
            metal_tooltip: '',
            concrete: 'value.concrete',
            concrete_tooltip: '',
            brick: 'value.brick',
            brick_tooltip: '',
            tiles: 'value.tiles',
            tiles_tooltip: '',
            bitumen_roofing: 'value.bitumen_roofing',
            bitumen_roofing_tooltip: '',
            slate_shingles: 'value.slate_shingles',
            slate_shingles_tooltip: '',
            black_concrete_tiles: 'value.black_concrete_tiles',
            black_concrete_tiles_tooltip: '',
            thatched: 'value.thatched',
            thatched_tooltip: '',
            asbestos: 'value.asbestos',
            asbestos_tooltip: '',
            green_roof: 'value.green_roof',
            green_roof_tooltip: '',
            home_liberal_profession_or_office: 'value.home_liberal_profession_or_office',
            home_liberal_profession_or_office_tooltip: '',
            home_other_professional_activity: 'value.home_other_professional_activity',
            home_other_professional_activity_tooltip: '',
            home: 'value.home',
            home_tooltip: '',
            no_economic_activity: 'value.no_economic_activity',
            no_economic_activity_tooltip: '',
            activity_unlikely: 'value.activity_unlikely',
            activity_unlikely_tooltip: '',
            activity_possible: 'value.activity_possible',
            activity_possible_tooltip: '',
            activity_likely: 'value.activity_likely',
            activity_likely_tooltip: '',
            activity_very_likely: 'value.activity_very_likely',
            activity_very_likely_tooltip: '',
            n: 'value.n',
            n_tooltip: '',
            ne: 'value.ne',
            ne_tooltip: '',
            e: 'value.e',
            e_tooltip: '',
            se: 'value.se',
            se_tooltip: '',
            s: 'value.s',
            s_tooltip: '',
            sw: 'value.sw',
            sw_tooltip: '',
            w: 'value.w',
            w_tooltip: '',
            nw: 'value.nw',
            nw_tooltip: '',
            limited: 'value.limited',
            limited_tooltip: '',
            details_previous_page: 'value.details_previous_page',
            details_previous_page_tooltip: '',
            below_average: 'value.below_average',
            below_average_tooltip: '',
            average: 'value.average',
            average_tooltip: '',
            above_average: 'value.above_average',
            above_average_tooltip: '',
            low: 'value.low',
            low_tooltip: '',
            medium: 'value.medium',
            medium_tooltip: '',
            high: 'value.high',
            high_tooltip: '',
            unknown: 'value.unknown',
            unknown_tooltip: '',
            urban: 'value.urban',
            urban_tooltip: '',
            rural: 'value.rural',
            rural_tooltip: '',
            isolated: 'value.isolated',
            isolated_tooltip: '',
            city: 'value.city',
            city_tooltip: '',
            suburbs: 'value.suburbs',
            suburbs_tooltip: '',
            village: 'value.village',
            village_tooltip: '',
            none: 'value.none',
            none_tooltip: '',
            classified_facade: 'value.classified_facade',
            classified_facade_tooltip: '',
            green_neighbourhood: 'value.green_neighbourhood',
            green_neighbourhood_tooltip: '',
            sea_view: 'value.sea_view',
            sea_view_tooltip: '',
            no_direct_traffic: 'value.no_direct_traffic',
            no_direct_traffic_tooltip: '',
            exceptional_view: 'value.exceptional_view',
            exceptional_view_tooltip: '',
            tram: 'value.tram',
            tram_tooltip: '',
            train: 'value.train',
            train_tooltip: '',
            metro: 'value.metro',
            metro_tooltip: '',
            traffic: 'value.traffic',
            traffic_tooltip: '',
            busy_area: 'value.busy_area',
            busy_area_tooltip: '',
            user_estimate: 'value.user_estimate',
            user_estimate_tooltip: '',
            certificate: 'value.certificate',
            certificate_tooltip: '',
            refinancing: 'value.refinancing',
            refinancing_tooltip: '',
            bedroom: 'value.bedroom',
            bedroom_tooltip: '',
            bathroom: 'value.bathroom',
            bathroom_tooltip: '',
            toilet: 'value.toilet',
            toilet_tooltip: '',
            abex: 'value.abex',
            abex_tooltip: '',
            apartment_block_info: 'value.apartment_block_info',
            apartment_block_info_tooltip: '',
            apartment_block: 'value.apartment_block',
            apartment_block_tooltip: '',
            other_type: 'value.other_type',
            other_type_tooltip: '',
            single: 'value.single',
            single_tooltip: '',
            ordinary_double: 'value.ordinary_double',
            ordinary_double_tooltip: '',
            hr_double_after_2000: 'value.hr_double_after_2000',
            hr_double_after_2000_tooltip: '',
            hr_double_before_2000: 'value.hr_double_before_2000',
            hr_double_before_2000_tooltip: '',
            triple: 'value.triple',
            triple_tooltip: '',
            gas: 'value.gas',
            gas_tooltip: '',
            oil: 'value.oil',
            oil_tooltip: '',
            pellets: 'value.pellets',
            pellets_tooltip: '',
            coal: 'value.coal',
            coal_tooltip: '',
            district_heating: 'value.district_heating',
            district_heating_tooltip: '',
            'boiler:condensing': 'value.boiler:condensing',
            'boiler:condensing_tooltip': '',
            heat_pump: 'value.heat_pump',
            heat_pump_tooltip: '',
            'boiler:standard': 'value.boiler:standard',
            'boiler:standard_tooltip': '',
            chp: 'value.chp',
            chp_tooltip: '',
            stove: 'value.stove',
            stove_tooltip: '',
            electricity: 'value.electricity',
            electricity_tooltip: '',
            electric_heater: 'value.electric_heater',
            electric_heater_tooltip: '',
            no_ventilation: 'value.no_ventilation',
            no_ventilation_tooltip: '',
            natural: 'value.natural',
            natural_tooltip: 'value.natural_tooltip',
            mechanical: 'value.mechanical',
            mechanical_tooltip: '',
            system_b: 'value.system_b',
            system_b_tooltip: 'value.system_b_tooltip',
            system_c: 'value.system_c',
            system_c_tooltip: 'value.system_c_tooltip',
            system_cplus: 'value.system_cplus',
            system_cplus_tooltip: 'value.system_cplus_tooltip',
            system_d: 'value.system_d',
            system_d_tooltip: 'value.system_d_tooltip',
            pur_pir: 'value.pur_pir',
            pur_pir_tooltip: '',
            mineral_wool: 'value.mineral_wool',
            mineral_wool_tooltip: '',
            hr_double: 'value.hr_double',
            hr_double_tooltip: '',
            air_water: 'value.air_water',
            air_water_tooltip: '',
            monocrystalline: 'value.monocrystalline',
            monocrystalline_tooltip: '',
        },
        request: {
            references: 'request.references',
            references_tooltip: '',
            valuation_request_ref: 'request.valuation_request_ref',
            valuation_request_ref_tooltip: '',
            customer_ref: 'request.customer_ref',
            customer_ref_tooltip: 'request.customer_ref_tooltip',
            bank: 'request.bank',
            bank_tooltip: '',
            customer: 'request.customer',
            customer_tooltip: '',
            purpose: 'request.purpose',
            purpose_tooltip: '',
            package_tooltip: '',
            map_select: {
                'explanation-confirm-main-parcel':
                    'request.map_select.explanation-confirm-main-parcel',
                'cannot-find-confirm-main-parcel':
                    'request.map_select.cannot-find-confirm-main-parcel',
                'explanation-select-main-parcel':
                    'request.map_select.explanation-select-main-parcel',
                'explanation-select-main-parcel-no-selection':
                    'request.map_select.explanation-select-main-parcel-no-selection',
                'cannot-find-select-main-parcel':
                    'request.map_select.cannot-find-select-main-parcel',
                'explanation-select-extra-parcels':
                    'request.map_select.explanation-select-extra-parcels',
                'cannot-find-select-extra-parcels':
                    'request.map_select.cannot-find-select-extra-parcels',
                'explanation-confirm-main-building':
                    'request.map_select.explanation-confirm-main-building',
                'cannot-find-confirm-main-building':
                    'request.map_select.cannot-find-confirm-main-building',
                'explanation-select-main-building':
                    'request.map_select.explanation-select-main-building',
                'cannot-find-select-main-building':
                    'request.map_select.cannot-find-select-main-building',
                'explanation-select-secondary-buildings':
                    'request.map_select.explanation-select-secondary-buildings',
                'cannot-find-select-secondary-buildings':
                    'request.map_select.cannot-find-select-secondary-buildings',
                'explanation-select-parcels':
                    'request.map_select.explanation-select-parcels',
                'cannot-find-select-parcels':
                    'request.map_select.cannot-find-select-parcels',
                'tooltip-for-select-parcels':
                    'request.map_select.tooltip-for-select-parcels',
                'explanation-view-building-parcels':
                    'request.map_select.explanation-view-building-parcels',
            },
        },
        footer: {
            text: 'footer.text',
            text_tooltip: '',
        },
        url: {
            rockestate_main: 'url.rockestate_main',
            rockestate_main_tooltip: '',
            dashboard: 'url.dashboard',
            dashboard_tooltip: '',
            rockestate_info: 'url.rockestate_info',
            rockestate_info_tooltip: '',
            valuation_app: 'url.valuation_app',
            valuation_app_tooltip: '',
        },
        export: {
            by: 'export.by',
            by_tooltip: '',
            date: 'export.date',
            date_tooltip: '',
            reference: 'export.reference',
            reference_tooltip: '',
        },
        section: {
            reconstruction_value: 'section.reconstruction_value',
            reconstruction_value_tooltip: '',
            address_location: 'section.address_location',
            address_location_tooltip: '',
            secondary_buildings: 'section.secondary_buildings',
            secondary_buildings_tooltip: '',
            economic_activity: 'section.economic_activity',
            economic_activity_tooltip: '',
            roof: 'section.roof',
            roof_tooltip: '',
            transaction: 'section.transaction',
            transaction_tooltip: '',
            general: 'section.general',
            general_tooltip: '',
            report: 'section.report',
            report_tooltip: '',
            application: 'section.application',
            application_tooltip: '',
            dashboard: 'section.dashboard',
            dashboard_tooltip: '',
            dispatcher: 'section.dispatcher',
            dispatcher_tooltip: '',
            'user-admin': 'section.user-admin',
            'user-admin_tooltip': '',
            apps: 'section.apps',
            apps_tooltip: '',
            results: 'section.results',
            results_tooltip: '',
            flood_regular: 'section.flood_regular',
            flood_regular_tooltip: '',
            flood_insurance_exclusion: 'section.flood_insurance_exclusion',
            flood_insurance_exclusion_tooltip: '',
            helpcenter: 'section.helpcenter',
            helpcenter_tooltip: '',
            'faq-search-results': 'section.faq-search-results',
            'faq-search-results_tooltip': '',
            warnings: 'section.warnings',
            warnings_tooltip: '',
            renovation: 'section.renovation',
            renovation_tooltip: '',
            general_info: 'section.general_info',
            general_info_tooltip: '',
            parcels_and_buildings: 'section.parcels_and_buildings',
            parcels_and_buildings_tooltip: '',
            c_parcels: 'section.c_parcels',
            c_parcels_tooltip: '',
            c_building: 'section.c_building',
            c_building_tooltip: '',
            building: 'section.building',
            building_tooltip: '',
            secondary_buildings2: 'section.secondary_buildings2',
            secondary_buildings2_tooltip: '',
            building_structure: 'section.building_structure',
            building_structure_tooltip: '',
            common_parts: 'section.common_parts',
            common_parts_tooltip: '',
            building_purpose_classification: 'section.building_purpose_classification',
            building_purpose_classification_tooltip: '',
            parcels: 'section.parcels',
            parcels_tooltip: '',
            surroundings: 'section.surroundings',
            surroundings_tooltip: '',
            mobility: 'section.mobility',
            mobility_tooltip: '',
            interior: 'section.interior',
            interior_tooltip: '',
            room: 'section.room',
            room_tooltip: '',
            valuations: 'section.valuations',
            valuations_tooltip: '',
            reference_properties_location: 'section.reference_properties_location',
            reference_properties_location_tooltip: '',
            reference_properties_characteristics:
                'section.reference_properties_characteristics',
            reference_properties_characteristics_tooltip: '',
            flood: 'section.flood',
            flood_tooltip: '',
            energy: 'section.energy',
            energy_tooltip: '',
            flood_simple: 'section.flood_simple',
            flood_simple_tooltip: '',
            faq: 'section.faq',
            faq_tooltip: '',
            questions_feedback: 'section.questions_feedback',
            questions_feedback_tooltip: '',
            contact_info: 'section.contact_info',
            contact_info_tooltip: '',
            disclaimer: 'section.disclaimer',
            disclaimer_tooltip: '',
            heating: 'section.heating',
            heating_tooltip: '',
            ventilation: 'section.ventilation',
            ventilation_tooltip: '',
            renewables: 'section.renewables',
            renewables_tooltip: '',
            additional_consumption: 'section.additional_consumption',
            additional_consumption_tooltip: '',
            consumers: 'section.consumers',
            consumers_tooltip: '',
            energy_consumption_info: 'section.energy_consumption_info',
            energy_consumption_info_tooltip: '',
            house_info: 'section.house_info',
            house_info_tooltip: '',
            consumption: 'section.consumption',
            consumption_tooltip: '',
            property_type: 'section.property_type',
            property_type_tooltip: '',
            address: 'section.address',
            address_tooltip: '',
            insulation: 'section.insulation',
            insulation_tooltip: '',
            house_information: 'section.house_information',
            house_information_tooltip: '',
        },
        front: {
            title: 'front.title',
            title_tooltip: '',
            core_title: 'front.core_title',
            core_title_tooltip: '',
            flood_assessment: {
                title: 'front.flood_assessment.title',
                title_tooltip: '',
            },
        },
        features: {
            renovation_cost: 'features.renovation_cost',
            renovation_cost_tooltip: '',
            energetic_renovation_cost: 'features.energetic_renovation_cost',
            energetic_renovation_cost_tooltip: '',
            energetic_renovation_added_value: 'features.energetic_renovation_added_value',
            energetic_renovation_added_value_tooltip: '',
            construction_cost: 'features.construction_cost',
            construction_cost_tooltip: 'features.construction_cost_tooltip',
            parcel_cost: 'features.parcel_cost',
            parcel_cost_tooltip: 'features.parcel_cost_tooltip',
            building_class: 'features.building_class',
            building_class_tooltip: 'features.building_class_tooltip',
            f_building_type: 'features.f_building_type',
            f_building_type_tooltip: 'features.f_building_type_tooltip',
            f_touching_sides: 'features.f_touching_sides',
            f_touching_sides_tooltip: '',
            f_number_of_facades: 'features.f_number_of_facades',
            f_number_of_facades_tooltip: '',
            f_number_of_facades_or_type: 'features.f_number_of_facades_or_type',
            f_number_of_facades_or_type_tooltip:
                'features.f_number_of_facades_or_type_tooltip',
            f_parcel_area: 'features.f_parcel_area',
            f_parcel_area_tooltip: 'features.f_parcel_area_tooltip',
            f_building_area: 'features.f_building_area',
            f_building_area_tooltip: '',
            f_others: 'features.f_others',
            f_others_tooltip: '',
            f_x_annexes: 'features.f_x_annexes',
            f_x_annexes_tooltip: '',
            f_annexes_area: 'features.f_annexes_area',
            f_annexes_area_tooltip: '',
            f_area_largest_annex: 'features.f_area_largest_annex',
            f_area_largest_annex_tooltip: '',
            distances_annexes: 'features.distances_annexes',
            distances_annexes_tooltip: '',
            parcel_ids: 'features.parcel_ids',
            parcel_ids_tooltip: '',
            f_lng: 'features.f_lng',
            f_lng_tooltip: '',
            f_lat: 'features.f_lat',
            f_lat_tooltip: '',
            f_number_of_addresses: 'features.f_number_of_addresses',
            f_number_of_addresses_tooltip: '',
            f_living_area: 'features.f_living_area',
            f_living_area_tooltip: 'features.f_living_area_tooltip',
            f_expected_living_area: 'features.f_expected_living_area',
            f_expected_living_area_tooltip: 'features.f_expected_living_area_tooltip',
            f_approx_living_area: 'features.f_approx_living_area',
            f_approx_living_area_tooltip: '',
            n_rooms: 'features.n_rooms',
            n_rooms_tooltip: '',
            approx_n_rooms: 'features.approx_n_rooms',
            approx_n_rooms_tooltip: '',
            transaction_value: 'features.transaction_value',
            transaction_value_tooltip: '',
            transaction_date: 'features.transaction_date',
            transaction_date_tooltip: '',
            approx_price_sqm: 'features.approx_price_sqm',
            approx_price_sqm_tooltip: '',
            co2_sqm: 'features.co2_sqm',
            co2_sqm_tooltip: '',
            co2_label: 'features.co2_label',
            co2_label_tooltip: '',
            f_approx_epc: 'features.f_approx_epc',
            f_approx_epc_tooltip: '',
            f_construction_year: 'features.f_construction_year',
            f_construction_year_tooltip: 'features.f_construction_year_tooltip',
            f_expected_construction_year: 'features.f_expected_construction_year',
            f_expected_construction_year_tooltip:
                'features.f_expected_construction_year_tooltip',
            f_epc: 'features.f_epc',
            f_epc_tooltip: 'features.f_epc_tooltip',
            f_epc_label: 'features.f_epc_label',
            f_epc_label_tooltip: '',
            f_epc_numeric: 'features.f_epc_numeric',
            f_epc_numeric_tooltip: '',
            f_expected_epc: 'features.f_expected_epc',
            f_expected_epc_tooltip: 'features.f_expected_epc_tooltip',
            f_bedrooms: 'features.f_bedrooms',
            f_bedrooms_tooltip: 'features.f_bedrooms_tooltip',
            f_floor: 'features.f_floor',
            f_floor_tooltip: 'features.f_floor_tooltip',
            f_bottom_floor: 'features.f_bottom_floor',
            f_bottom_floor_tooltip: 'features.f_bottom_floor_tooltip',
            f_top_floor: 'features.f_top_floor',
            f_top_floor_tooltip: 'features.f_top_floor_tooltip',
            f_floors: 'features.f_floors',
            f_floors_tooltip: 'features.f_floors_tooltip',
            f_balcony_present: 'features.f_balcony_present',
            f_balcony_present_tooltip: 'features.f_balcony_present_tooltip',
            f_garage_present: 'features.f_garage_present',
            f_garage_present_tooltip: 'features.f_garage_present_tooltip',
            f_n_closed_garage: 'features.f_n_closed_garage',
            f_n_closed_garage_tooltip: 'features.f_n_closed_garage_tooltip',
            f_n_parking_spot: 'features.f_n_parking_spot',
            f_n_parking_spot_tooltip: 'features.f_n_parking_spot_tooltip',
            f_cellar_attic: 'features.f_cellar_attic',
            f_cellar_attic_tooltip: '',
            f_garden_access: 'features.f_garden_access',
            f_garden_access_tooltip: 'features.f_garden_access_tooltip',
            f_garden_common: 'features.f_garden_common',
            f_garden_common_tooltip: 'features.f_garden_common_tooltip',
            f_garden_private: 'features.f_garden_private',
            f_garden_private_tooltip: 'features.f_garden_private_tooltip',
            f_volume: 'features.f_volume',
            f_volume_tooltip: '',
            exterior_wall_area: 'features.exterior_wall_area',
            exterior_wall_area_tooltip: '',
            f_roof_area: 'features.f_roof_area',
            f_roof_area_tooltip: '',
            f_mean_tilt: 'features.f_mean_tilt',
            f_mean_tilt_tooltip: '',
            f_percent_of_roof_flat: 'features.f_percent_of_roof_flat',
            f_percent_of_roof_flat_tooltip: '',
            f_min_height: 'features.f_min_height',
            f_min_height_tooltip: '',
            f_max_height: 'features.f_max_height',
            f_max_height_tooltip: '',
            f_n_parts: 'features.f_n_parts',
            f_n_parts_tooltip: '',
            f_n_roof_panes: 'features.f_n_roof_panes',
            f_n_roof_panes_tooltip: '',
            f_x_matched_entities: 'features.f_x_matched_entities',
            f_x_matched_entities_tooltip: '',
            c_economic_activity_class: 'features.c_economic_activity_class',
            c_economic_activity_class_tooltip: '',
            c_economic_activity_level: 'features.c_economic_activity_level',
            c_economic_activity_level_tooltip: '',
            f_garden_area: 'features.f_garden_area',
            f_garden_area_tooltip: '',
            f_flood_risk: 'features.f_flood_risk',
            f_flood_risk_tooltip: '',
            f_dist_building_flood: 'features.f_dist_building_flood',
            f_dist_building_flood_tooltip: '',
            f_parcel_flood_risk: 'features.f_parcel_flood_risk',
            f_parcel_flood_risk_tooltip: '',
            f_dist_parcel_flood: 'features.f_dist_parcel_flood',
            f_dist_parcel_flood_tooltip: '',
            f_flood_risk_insurance_exclusion: 'features.f_flood_risk_insurance_exclusion',
            f_flood_risk_insurance_exclusion_tooltip: '',
            f_dist_building_flood_insurance_exclusion:
                'features.f_dist_building_flood_insurance_exclusion',
            f_dist_building_flood_insurance_exclusion_tooltip: '',
            f_parcel_flood_risk_insurance_exclusion:
                'features.f_parcel_flood_risk_insurance_exclusion',
            f_parcel_flood_risk_insurance_exclusion_tooltip: '',
            f_dist_parcel_flood_insurance_exclusion:
                'features.f_dist_parcel_flood_insurance_exclusion',
            f_dist_parcel_flood_insurance_exclusion_tooltip: '',
            f_flood_risk_composite: 'features.f_flood_risk_composite',
            f_flood_risk_composite_tooltip: '',
            f_flood_risk_max_parcel: 'features.f_flood_risk_max_parcel',
            f_flood_risk_max_parcel_tooltip: '',
            epc_source: 'features.epc_source',
            epc_source_tooltip: '',
            level: 'features.level',
            level_tooltip: '',
            f_ground_height_above_sea: 'features.f_ground_height_above_sea',
            f_ground_height_above_sea_tooltip: '',
            no_building_picture: 'features.no_building_picture',
            no_building_picture_tooltip: '',
            no_parcel_picture: 'features.no_parcel_picture',
            no_parcel_picture_tooltip: '',
            no_garden_technical_drawing: 'features.no_garden_technical_drawing',
            no_garden_technical_drawing_tooltip: '',
            parcel_selection: 'features.parcel_selection',
            parcel_selection_tooltip: '',
            vat: 'features.vat',
            vat_tooltip: '',
            property_type: 'features.property_type',
            property_type_tooltip: '',
            insulated_floors: 'features.insulated_floors',
            insulated_floors_tooltip: '',
            insulated_roof: 'features.insulated_roof',
            insulated_roof_tooltip: '',
            insulated_walls: 'features.insulated_walls',
            insulated_walls_tooltip: '',
            window_type: 'features.window_type',
            window_type_tooltip: '',
            has_attic: 'features.has_attic',
            has_attic_tooltip: '',
            floors_insulation_years: 'features.floors_insulation_years',
            floors_insulation_years_tooltip: '',
            roof_insulation_year: 'features.roof_insulation_year',
            roof_insulation_year_tooltip: '',
            walls_insulation_year: 'features.walls_insulation_year',
            walls_insulation_year_tooltip: '',
            has_basement: 'features.has_basement',
            has_basement_tooltip: '',
            is_attic_heated: 'features.is_attic_heated',
            is_attic_heated_tooltip: '',
            epc_score: 'features.epc_score',
            epc_score_tooltip: '',
            heating_fuel: 'features.heating_fuel',
            heating_fuel_tooltip: '',
            heating_type: 'features.heating_type',
            heating_type_tooltip: '',
            heating_installation_year: 'features.heating_installation_year',
            heating_installation_year_tooltip: '',
            ventilation_type: 'features.ventilation_type',
            ventilation_type_tooltip: '',
            solar_boiler: 'features.solar_boiler',
            solar_boiler_tooltip: '',
            solar_panels: 'features.solar_panels',
            solar_panels_tooltip: '',
            battery: 'features.battery',
            battery_tooltip: '',
            air_conditioner: 'features.air_conditioner',
            air_conditioner_tooltip: '',
            spa_room: 'features.spa_room',
            spa_room_tooltip: '',
            swimming_pool: 'features.swimming_pool',
            swimming_pool_tooltip: '',
            electric_vehicle: 'features.electric_vehicle',
            electric_vehicle_tooltip: '',
            n_residents: 'features.n_residents',
            n_residents_tooltip: '',
            protected_consumer: 'features.protected_consumer',
            protected_consumer_tooltip: '',
            yearly_electricity_consumption: 'features.yearly_electricity_consumption',
            yearly_electricity_consumption_tooltip: '',
            gas_consumption_approx: 'features.gas_consumption_approx',
            gas_consumption_approx_tooltip: '',
            insulation_material: 'features.insulation_material',
            insulation_material_tooltip: '',
            heat_pump_type: 'features.heat_pump_type',
            heat_pump_type_tooltip: '',
            pv_type: 'features.pv_type',
            pv_type_tooltip: '',
        },
        disclaimer: {
            avm_tooltip: '',
            dvm: 'disclaimer.dvm',
            dvm_tooltip: '',
            ovm: 'disclaimer.ovm',
            ovm_tooltip: '',
            epc_unavailable_1: 'disclaimer.epc_unavailable_1',
            epc_unavailable_1_tooltip: '',
            epc_unavailable_2: 'disclaimer.epc_unavailable_2',
            epc_unavailable_2_tooltip: '',
            part_1: 'disclaimer.part_1',
            part_1_tooltip: '',
            part_2: 'disclaimer.part_2',
            part_2_tooltip: '',
            reconstruction_value_title: 'disclaimer.reconstruction_value_title',
            reconstruction_value_title_tooltip: '',
            reconstruction_value: 'disclaimer.reconstruction_value',
            reconstruction_value_tooltip: '',
            part_3: 'disclaimer.part_3',
            part_3_tooltip: '',
        },
        document: {
            purpose_tooltip: '',
            ers_report: 'document.ers_report',
            ers_report_tooltip: '',
            epc_certificate: 'document.epc_certificate',
            epc_certificate_tooltip: '',
            exterior_picture: 'document.exterior_picture',
            exterior_picture_tooltip: '',
            building_blueprint: 'document.building_blueprint',
            building_blueprint_tooltip: '',
            specifications: 'document.specifications',
            specifications_tooltip: '',
            cadastral_plan: 'document.cadastral_plan',
            cadastral_plan_tooltip: '',
            sales_agreement: 'document.sales_agreement',
            sales_agreement_tooltip: '',
            expected_epc: 'document.expected_epc',
            expected_epc_tooltip: '',
        },
        common: {
            select_one: 'common.select_one',
            select_one_tooltip: '',
            floor: 'common.floor',
            floor_tooltip: '',
            cancel: 'common.cancel',
            cancel_tooltip: '',
            new: 'common.new',
            new_tooltip: '',
            save: 'common.save',
            save_tooltip: '',
            edit: 'common.edit',
            edit_tooltip: '',
            total: 'common.total',
            total_tooltip: '',
            previous: 'common.previous',
            previous_tooltip: '',
            next: 'common.next',
            next_tooltip: '',
            refresh: 'common.refresh',
            refresh_tooltip: '',
            back: 'common.back',
            back_tooltip: '',
            price: 'common.price',
            price_tooltip: '',
            module: 'common.module',
            module_tooltip: '',
            uploading: 'common.uploading',
            uploading_tooltip: '',
            go_to_consumption_next: 'common.go_to_consumption_next',
            go_to_consumption_next_tooltip: '',
            lets_get_started: 'common.lets_get_started',
            lets_get_started_tooltip: '',
            go_to_consumption: 'common.go_to_consumption',
            go_to_consumption_tooltip: '',
            thank_you_so_far: 'common.thank_you_so_far',
            thank_you_so_far_tooltip: '',
            yes: 'common.yes',
            yes_tooltip: '',
            no: 'common.no',
            no_tooltip: '',
            number_input: 'common.number_input',
            number_input_tooltip: '',
            multiple_choice: 'common.multiple_choice',
            multiple_choice_tooltip: '',
            we_are_sorry: 'common.we_are_sorry',
            we_are_sorry_tooltip: '',
            sorry: 'common.sorry',
            sorry_tooltip: '',
            enter_address: 'common.enter_address',
            enter_address_tooltip: '',
            back_to_ing: 'common.back_to_ing',
            back_to_ing_tooltip: '',
            maintenance: 'common.maintenance',
            maintenance_tooltip: '',
            send: 'common.send',
            send_tooltip: '',
            start_now: 'common.start_now',
            start_now_tooltip: '',
            i_dont_know: 'common.i_dont_know',
            i_dont_know_tooltip: '',
        },
        info: {
            data_from_customer: 'info.data_from_customer',
            data_from_customer_tooltip: '',
        },
        autocomplete: {
            enter_address: 'autocomplete.enter_address',
            enter_address_tooltip: '',
            address_not_found: 'autocomplete.address_not_found',
            address_not_found_tooltip: '',
            enter_parcel: 'autocomplete.enter_parcel',
            enter_parcel_tooltip: '',
            parcel_not_found: 'autocomplete.parcel_not_found',
            parcel_not_found_tooltip: '',
            enter_dual: 'autocomplete.enter_dual',
            enter_dual_tooltip: '',
            dual_not_found: 'autocomplete.dual_not_found',
            dual_not_found_tooltip: '',
        },
        dvm_features: {
            style_of_house: 'dvm_features.style_of_house',
            style_of_house_tooltip: '',
            exterior_state: 'dvm_features.exterior_state',
            exterior_state_tooltip: '',
            facade_material: 'dvm_features.facade_material',
            facade_material_tooltip: '',
            roof_material: 'dvm_features.roof_material',
            roof_material_tooltip: '',
            n_roof_windows: 'dvm_features.n_roof_windows',
            n_roof_windows_tooltip: '',
            n_roof_dormers: 'dvm_features.n_roof_dormers',
            n_roof_dormers_tooltip: '',
            solar_panel: 'dvm_features.solar_panel',
            solar_panel_tooltip: '',
            solar_panel_area: 'dvm_features.solar_panel_area',
            solar_panel_area_tooltip: '',
            f_building_listed: 'dvm_features.f_building_listed',
            f_building_listed_tooltip: '',
            garden_orientation: 'dvm_features.garden_orientation',
            garden_orientation_tooltip: '',
            garden_arrangement: 'dvm_features.garden_arrangement',
            garden_arrangement_tooltip: '',
            garden_common_arrangement: 'dvm_features.garden_common_arrangement',
            garden_common_arrangement_tooltip: '',
            f_swimming_pool: 'dvm_features.f_swimming_pool',
            f_swimming_pool_tooltip: '',
            f_swimming_pool_area: 'dvm_features.f_swimming_pool_area',
            f_swimming_pool_area_tooltip: '',
            environment: 'dvm_features.environment',
            environment_tooltip: '',
            public_transport: 'dvm_features.public_transport',
            public_transport_tooltip: '',
            education: 'dvm_features.education',
            education_tooltip: '',
            recreation: 'dvm_features.recreation',
            recreation_tooltip: '',
            shops: 'dvm_features.shops',
            shops_tooltip: '',
            healthcare: 'dvm_features.healthcare',
            healthcare_tooltip: '',
            direct_traffic_level: 'dvm_features.direct_traffic_level',
            direct_traffic_level_tooltip: '',
            indirect_traffic_level: 'dvm_features.indirect_traffic_level',
            indirect_traffic_level_tooltip: '',
            surroundings: 'dvm_features.surroundings',
            surroundings_tooltip: '',
            other_positive: 'dvm_features.other_positive',
            other_positive_tooltip: '',
            other_positive_details: 'dvm_features.other_positive_details',
            other_positive_details_tooltip: '',
            other_negative: 'dvm_features.other_negative',
            other_negative_tooltip: '',
            other_negative_details: 'dvm_features.other_negative_details',
            other_negative_details_tooltip: '',
            remarks: 'dvm_features.remarks',
            remarks_tooltip: '',
            internal_remarks: 'dvm_features.internal_remarks',
            internal_remarks_tooltip: '',
        },
        ovm_features: {
            garages: 'ovm_features.garages',
            garages_tooltip: '',
            parkings: 'ovm_features.parkings',
            parkings_tooltip: '',
            pool_house: 'ovm_features.pool_house',
            pool_house_tooltip: '',
            pool_house_area: 'ovm_features.pool_house_area',
            pool_house_area_tooltip: '',
            barn: 'ovm_features.barn',
            barn_tooltip: '',
            barn_area: 'ovm_features.barn_area',
            barn_area_tooltip: '',
            stables: 'ovm_features.stables',
            stables_tooltip: '',
            stables_area: 'ovm_features.stables_area',
            stables_area_tooltip: '',
            common_parts_state: 'ovm_features.common_parts_state',
            common_parts_state_tooltip: '',
            interior_state: 'ovm_features.interior_state',
            interior_state_tooltip: '',
            apartment_quotity: 'ovm_features.apartment_quotity',
            apartment_quotity_tooltip: '',
            reserve_savings: 'ovm_features.reserve_savings',
            reserve_savings_tooltip: '',
            comfort: 'ovm_features.comfort',
            comfort_tooltip: '',
            common_comfort: 'ovm_features.common_comfort',
            common_comfort_tooltip: '',
            interior_positive: 'ovm_features.interior_positive',
            interior_positive_tooltip: '',
            interior_negative: 'ovm_features.interior_negative',
            interior_negative_tooltip: '',
        },
        fixed: {
            parcels_and_building_shapes: 'fixed.parcels_and_building_shapes',
            parcels_and_building_shapes_tooltip: '',
            parcels_shapes: 'fixed.parcels_shapes',
            parcels_shapes_tooltip: '',
        },
        '': {
            f_distance_to_street: '.f_distance_to_street',
            f_distance_to_street_tooltip: '',
        },
        global: {
            comments: 'global.comments',
            comments_tooltip: '',
            commons: {
                before: 'global.commons.before',
                between: 'global.commons.between',
                after: 'global.commons.after',
            },
            map: {
                aerial_view: 'global.map.aerial_view',
                cadastral_view: 'global.map.cadastral_view',
                flood_zone_low: 'global.map.flood_zone_low',
                flood_zone_medium: 'global.map.flood_zone_medium',
                flood_zone_high: 'global.map.flood_zone_high',
                exclusion_flood_zone: 'global.map.exclusion_flood_zone',
                swimming_pools: 'global.map.swimming_pools',
                street_name: 'global.map.street_name',
            },
            shared: {
                placeholder: {
                    streetname: 'global.shared.placeholder.streetname',
                    streetnumber: 'global.shared.placeholder.streetnumber',
                    postalcode: 'global.shared.placeholder.postalcode',
                    municipality: 'global.shared.placeholder.municipality',
                    vat: 'global.shared.placeholder.vat',
                    'company-name': 'global.shared.placeholder.company-name',
                    'contact-email': 'global.shared.placeholder.contact-email',
                },
                resend_email: 'global.shared.resend_email',
                email_notification: 'global.shared.email_notification',
                edit_email: 'global.shared.edit_email',
                streetname: 'global.shared.streetname',
                streetnumber: 'global.shared.streetnumber',
                boxnumber: 'global.shared.boxnumber',
                postalcode: 'global.shared.postalcode',
                municipality: 'global.shared.municipality',
                vat: 'global.shared.vat',
                name: 'global.shared.name',
                email: 'global.shared.email',
                company: 'global.shared.company',
                customer_ref_modal: {
                    title: 'global.shared.customer_ref_modal.title',
                    content: 'global.shared.customer_ref_modal.content',
                    cta: 'global.shared.customer_ref_modal.cta',
                    dashboard: 'global.shared.customer_ref_modal.dashboard',
                    continue: 'global.shared.customer_ref_modal.continue',
                },
                january: 'global.shared.january',
                february: 'global.shared.february',
                march: 'global.shared.march',
                april: 'global.shared.april',
                may: 'global.shared.may',
                june: 'global.shared.june',
                july: 'global.shared.july',
                august: 'global.shared.august',
                september: 'global.shared.september',
                october: 'global.shared.october',
                november: 'global.shared.november',
                december: 'global.shared.december',
                flanders: 'global.shared.flanders',
                wallonia: 'global.shared.wallonia',
                brussels: 'global.shared.brussels',
            },
            action: {
                confirm: 'global.action.confirm',
            },
            helpcenter: {
                video_tutorials: 'global.helpcenter.video_tutorials',
                faq: 'global.helpcenter.faq',
                question: 'global.helpcenter.question',
                contact_cta: 'global.helpcenter.contact_cta',
                contact_form: {
                    title: 'global.helpcenter.contact_form.title',
                    content: 'global.helpcenter.contact_form.content',
                    'subject_req-invoice':
                        'global.helpcenter.contact_form.subject_req-invoice',
                    subject_label: 'global.helpcenter.contact_form.subject_label',
                    'subject_req-failing':
                        'global.helpcenter.contact_form.subject_req-failing',
                    'subject_req-not-eval-yet':
                        'global.helpcenter.contact_form.subject_req-not-eval-yet',
                    'subject_req-back-to-draft':
                        'global.helpcenter.contact_form.subject_req-back-to-draft',
                    'subject_cant-download-val-report':
                        'global.helpcenter.contact_form.subject_cant-download-val-report',
                    'subject_req-not-in-dashboard':
                        'global.helpcenter.contact_form.subject_req-not-in-dashboard',
                    'subject_cancel-req':
                        'global.helpcenter.contact_form.subject_cancel-req',
                    subject_other: 'global.helpcenter.contact_form.subject_other',
                    other_label: 'global.helpcenter.contact_form.other_label',
                    customer_ref: 'global.helpcenter.contact_form.customer_ref',
                    not_specific_req: 'global.helpcenter.contact_form.not_specific_req',
                    message: 'global.helpcenter.contact_form.message',
                    screenshot_label: 'global.helpcenter.contact_form.screenshot_label',
                    screenshot_info: 'global.helpcenter.contact_form.screenshot_info',
                    submit: 'global.helpcenter.contact_form.submit',
                    feedback_title: 'global.helpcenter.contact_form.feedback_title',
                    feedback_content: 'global.helpcenter.contact_form.feedback_content',
                    close: 'global.helpcenter.contact_form.close',
                    ing: 'global.helpcenter.contact_form.ing',
                },
            },
            errors: {
                no_valuers_in_region: 'global.errors.no_valuers_in_region',
            },
        },
        section_data: {
            room: {
                type: 'section_data.room.type',
                type_tooltip: '',
                living_area: 'section_data.room.living_area',
                living_area_tooltip: '',
                comment: 'section_data.room.comment',
                comment_tooltip: '',
            },
        },
        footnote: {
            no_renovation_included: 'footnote.no_renovation_included',
            no_renovation_included_tooltip: '',
            avm: 'footnote.avm',
            avm_tooltip: '',
            q25: 'footnote.q25',
            q25_tooltip: '',
            q75: 'footnote.q75',
            q75_tooltip: '',
        },
        reference_properties_location: {
            explanation_1: 'reference_properties_location.explanation_1',
            explanation_1_tooltip: '',
            explanation_2: 'reference_properties_location.explanation_2',
            explanation_2_tooltip: '',
        },
        reference_properties_characteristics: {
            explanation_1: 'reference_properties_characteristics.explanation_1',
            explanation_1_tooltip: '',
            property_characteristics:
                'reference_properties_characteristics.property_characteristics',
            property_characteristics_tooltip: '',
            properties_in_the_area:
                'reference_properties_characteristics.properties_in_the_area',
            properties_in_the_area_tooltip: '',
        },
        flood: {
            explanation_1: 'flood.explanation_1',
            explanation_1_tooltip: '',
            check_ground_floor: {
                title: 'flood.check_ground_floor.title',
                yes_info: 'flood.check_ground_floor.yes_info',
                no_info: 'flood.check_ground_floor.no_info',
                tooltip: 'flood.check_ground_floor.tooltip',
            },
            flood_page: {
                title: 'flood.flood_page.title',
                download_report: 'flood.flood_page.download_report',
                contextual_message_building_risk_high:
                    'flood.flood_page.contextual_message_building_risk_high',
                contextual_message_parcel_risk_high:
                    'flood.flood_page.contextual_message_parcel_risk_high',
                contextual_message_risk_none:
                    'flood.flood_page.contextual_message_risk_none',
                contextual_message_risk_high_not_ground_floor:
                    'flood.flood_page.contextual_message_risk_high_not_ground_floor',
                open_map: 'flood.flood_page.open_map',
                more_information: 'flood.flood_page.more_information',
                proceed_valuation: 'flood.flood_page.proceed_valuation',
            },
            confirm_decision_popup: {
                title: 'flood.confirm_decision_popup.title',
                message: 'flood.confirm_decision_popup.message',
                confirmation: 'flood.confirm_decision_popup.confirmation',
                yes_proceed: 'flood.confirm_decision_popup.yes_proceed',
            },
        },
        faq: {
            q_incorrect_valuation: 'faq.q_incorrect_valuation',
            q_incorrect_valuation_tooltip: '',
            a_incorrect_valuation: 'faq.a_incorrect_valuation',
            a_incorrect_valuation_tooltip: '',
            q_incorrect_characteristics: 'faq.q_incorrect_characteristics',
            q_incorrect_characteristics_tooltip: '',
            a_incorrect_characteristics: 'faq.a_incorrect_characteristics',
            a_incorrect_characteristics_tooltip: '',
            q_transaction_vs_market_value: 'faq.q_transaction_vs_market_value',
            q_transaction_vs_market_value_tooltip: '',
            a_transaction_vs_market_value_dvm: 'faq.a_transaction_vs_market_value_dvm',
            a_transaction_vs_market_value_dvm_tooltip: '',
            a_transaction_vs_market_value_ovm: 'faq.a_transaction_vs_market_value_ovm',
            a_transaction_vs_market_value_ovm_tooltip: '',
            q_loan_accepted: 'faq.q_loan_accepted',
            q_loan_accepted_tooltip: '',
            a_loan_accepted: 'faq.a_loan_accepted',
            a_loan_accepted_tooltip: '',
            'what-is-avm_tooltip': '',
            'what-is-avm_question': 'faq.what-is-avm_question',
            'what-is-avm_answer': 'faq.what-is-avm_answer',
            'what-is-dvm_tooltip': '',
            'what-is-dvm_question': 'faq.what-is-dvm_question',
            'what-is-dvm_answer': 'faq.what-is-dvm_answer',
            'what-is-ovm_tooltip': '',
            'what-is-ovm_question': 'faq.what-is-ovm_question',
            'what-is-ovm_answer': 'faq.what-is-ovm_answer',
            'why-ovm_tooltip': '',
            'why-ovm_question': 'faq.why-ovm_question',
            'why-ovm_answer': 'faq.why-ovm_answer',
            'what-is-dashboard_tooltip': '',
            'what-is-dashboard_question': 'faq.what-is-dashboard_question',
            'what-is-dashboard_answer': 'faq.what-is-dashboard_answer',
            'what-is-draft_tooltip': '',
            'what-is-draft_question': 'faq.what-is-draft_question',
            'what-is-draft_answer': 'faq.what-is-draft_answer',
            'when-report_tooltip': '',
            'when-report_question': 'faq.when-report_question',
            'when-report_answer': 'faq.when-report_answer',
            'how-download-report_tooltip': '',
            'how-download-report_question': 'faq.how-download-report_question',
            'how-download-report_answer': 'faq.how-download-report_answer',
            'market-price-incorrect_tooltip': '',
            'market-price-incorrect_question': 'faq.market-price-incorrect_question',
            'market-price-incorrect_answer': 'faq.market-price-incorrect_answer',
            'issue-parcels_tooltip': '',
            'issue-parcels_question': 'faq.issue-parcels_question',
            'issue-parcels_answer': 'faq.issue-parcels_answer',
            'old-picture-or-3d_tooltip': '',
            'old-picture-or-3d_question': 'faq.old-picture-or-3d_question',
            'old-picture-or-3d_answer': 'faq.old-picture-or-3d_answer',
            'report-language_tooltip': '',
            'report-language_question': 'faq.report-language_question',
            'report-language_answer': 'faq.report-language_answer',
            'wrong-pictures_tooltip': '',
            'wrong-pictures_question': 'faq.wrong-pictures_question',
            'wrong-pictures_answer': 'faq.wrong-pictures_answer',
            sharing_tooltip: '',
            sharing_question: 'faq.sharing_question',
            sharing_answer: 'faq.sharing_answer',
            'remarks-language_tooltip': '',
            'remarks-language_question': 'faq.remarks-language_question',
            'remarks-language_answer': 'faq.remarks-language_answer',
            'appeal-missing-feature_tooltip': '',
            'appeal-missing-feature_question': 'faq.appeal-missing-feature_question',
            'appeal-missing-feature_answer': 'faq.appeal-missing-feature_answer',
            'ING-how-ovm-request_tooltip': '',
            'ING-how-ovm-request_question': 'faq.ING-how-ovm-request_question',
            'ING-how-ovm-request_answer': 'faq.ING-how-ovm-request_answer',
            'where-customer-ref_tooltip': '',
            'where-customer-ref_question': 'faq.where-customer-ref_question',
            'where-customer-ref_answer': 'faq.where-customer-ref_answer',
            'building-type-apartment-building_tooltip': '',
            'building-type-apartment-building_question':
                'faq.building-type-apartment-building_question',
            'building-type-apartment-building_answer':
                'faq.building-type-apartment-building_answer',
            'address-not-found_tooltip': '',
            'address-not-found_question': 'faq.address-not-found_question',
            'address-not-found_answer': 'faq.address-not-found_answer',
            'building-not-found_tooltip': '',
            'building-not-found_question': 'faq.building-not-found_question',
            'building-not-found_answer': 'faq.building-not-found_answer',
            'find-epc_tooltip': '',
            'find-epc_question': 'faq.find-epc_question',
            'find-epc_answer': 'faq.find-epc_answer',
            'epc-label-vs-number_tooltip': '',
            'epc-label-vs-number_question': 'faq.epc-label-vs-number_question',
            'epc-label-vs-number_answer': 'faq.epc-label-vs-number_answer',
            'find-living-area_tooltip': '',
            'find-living-area_question': 'faq.find-living-area_question',
            'find-living-area_answer': 'faq.find-living-area_answer',
            'find-box-number_tooltip': '',
            'find-box-number_question': 'faq.find-box-number_question',
            'find-box-number_answer': 'faq.find-box-number_answer',
            'find-construction-year_tooltip': '',
            'find-construction-year_question': 'faq.find-construction-year_question',
            'find-construction-year_answer': 'faq.find-construction-year_answer',
            'construction-vs-renovation_tooltip': '',
            'construction-vs-renovation_question':
                'faq.construction-vs-renovation_question',
            'construction-vs-renovation_answer': 'faq.construction-vs-renovation_answer',
            'over-two-days_tooltip': '',
            'over-two-days_question': 'faq.over-two-days_question',
            'over-two-days_answer': 'faq.over-two-days_answer',
            'right-info-flagged-incorrect_tooltip': '',
            'right-info-flagged-incorrect_question':
                'faq.right-info-flagged-incorrect_question',
            'right-info-flagged-incorrect_answer':
                'faq.right-info-flagged-incorrect_answer',
            'incoherent-submitted-twice_tooltip': '',
            'incoherent-submitted-twice_question':
                'faq.incoherent-submitted-twice_question',
            'incoherent-submitted-twice_answer': 'faq.incoherent-submitted-twice_answer',
            'processing-time_tooltip': '',
            'processing-time_question': 'faq.processing-time_question',
            'processing-time_answer': 'faq.processing-time_answer',
            'multiple-addresses_tooltip': '',
            'multiple-addresses_question': 'faq.multiple-addresses_question',
            'multiple-addresses_answer': 'faq.multiple-addresses_answer',
            'what-is-bedroom_tooltip': '',
            'what-is-bedroom_question': 'faq.what-is-bedroom_question',
            'what-is-bedroom_answer': 'faq.what-is-bedroom_answer',
            'what-is-garden_tooltip': '',
            'what-is-garden_question': 'faq.what-is-garden_question',
            'what-is-garden_answer': 'faq.what-is-garden_answer',
            'what-is-private-garden_tooltip': '',
            'what-is-private-garden_question': 'faq.what-is-private-garden_question',
            'what-is-private-garden_answer': 'faq.what-is-private-garden_answer',
            'what-is-closed-garage_tooltip': '',
            'what-is-closed-garage_question': 'faq.what-is-closed-garage_question',
            'what-is-closed-garage_answer': 'faq.what-is-closed-garage_answer',
            'what-is-parking-spot_tooltip': '',
            'what-is-parking-spot_question': 'faq.what-is-parking-spot_question',
            'what-is-parking-spot_answer': 'faq.what-is-parking-spot_answer',
            'what-is-cellar-basement_tooltip': '',
            'what-is-cellar-basement_question': 'faq.what-is-cellar-basement_question',
            'what-is-cellar-basement_answer': 'faq.what-is-cellar-basement_answer',
            carport_tooltip: '',
            carport_question: 'faq.carport_question',
            carport_answer: 'faq.carport_answer',
            'personal-use_tooltip': '',
            'personal-use_question': 'faq.personal-use_question',
            'personal-use_answer': 'faq.personal-use_answer',
            'is-request-submitted_tooltip': '',
            'is-request-submitted_question': 'faq.is-request-submitted_question',
            'is-request-submitted_answer': 'faq.is-request-submitted_answer',
            review_tooltip: '',
            review_question: 'faq.review_question',
            review_answer: 'faq.review_answer',
            'find-previous-request_tooltip': '',
            'find-previous-request_question': 'faq.find-previous-request_question',
            'find-previous-request_answer': 'faq.find-previous-request_answer',
            'download-report_tooltip': '',
            'download-report_question': 'faq.download-report_question',
            'download-report_answer': 'faq.download-report_answer',
            'language-impact_tooltip': '',
            'language-impact_question': 'faq.language-impact_question',
            'language-impact_answer': 'faq.language-impact_answer',
            'unsubmission-window_tooltip': '',
            'unsubmission-window_question': 'faq.unsubmission-window_question',
            'unsubmission-window_answer': 'faq.unsubmission-window_answer',
            'after-sixty-minutes_tooltip': '',
            'after-sixty-minutes_question': 'faq.after-sixty-minutes_question',
            'after-sixty-minutes_answer': 'faq.after-sixty-minutes_answer',
            'review-billing_tooltip': '',
            'review-billing_question': 'faq.review-billing_question',
            'review-billing_answer': 'faq.review-billing_answer',
            'access-requests_tooltip': '',
            'access-requests_question': 'faq.access-requests_question',
            'access-requests_answer': 'faq.access-requests_answer',
            substitution_tooltip: '',
            substitution_question: 'faq.substitution_question',
            'what-is-ers_tooltip': '',
            'what-is-ers_question': 'faq.what-is-ers_question',
            'what-is-ers_answer': 'faq.what-is-ers_answer',
            'what-is-common-wall_tooltip': '',
            'what-is-common-wall_question': 'faq.what-is-common-wall_question',
            'what-is-common-wall_answer': 'faq.what-is-common-wall_answer',
            'what-is-protected-volume_tooltip': '',
            'what-is-protected-volume_question': 'faq.what-is-protected-volume_question',
            'what-is-protected-volume_answer': 'faq.what-is-protected-volume_answer',
            'what-is-living-area_tooltip': '',
            'what-is-living-area_question': 'faq.what-is-living-area_question',
            'what-is-living-area_answer': 'faq.what-is-living-area_answer',
            'apartment-ers_tooltip': '',
            'apartment-ers_question': 'faq.apartment-ers_question',
            'apartment-ers_answer': 'faq.apartment-ers_answer',
            'no-3d-model-ers-quality_tooltip': '',
            'no-3d-model-ers-quality_question': 'faq.no-3d-model-ers-quality_question',
            'no-3d-model-ers-quality_answer': 'faq.no-3d-model-ers-quality_answer',
            'what-is-renovation-goal_tooltip': '',
            'what-is-renovation-goal_question': 'faq.what-is-renovation-goal_question',
            'what-is-renovation-goal_answer': 'faq.what-is-renovation-goal_answer',
            'missing-renovation-option_tooltip': '',
            'missing-renovation-option_question':
                'faq.missing-renovation-option_question',
            'missing-renovation-option_answer': 'faq.missing-renovation-option_answer',
            'choosing-insulation-material_tooltip': '',
            'choosing-insulation-material_question':
                'faq.choosing-insulation-material_question',
            'choosing-insulation-material_answer':
                'faq.choosing-insulation-material_answer',
            'own-property-ers_tooltip': '',
            'own-property-ers_question': 'faq.own-property-ers_question',
            'own-property-ers_answer': 'faq.own-property-ers_answer',
            'estimated-epc-different-than-actual-epc_tooltip': '',
            'estimated-epc-different-than-actual-epc_question':
                'faq.estimated-epc-different-than-actual-epc_question',
            'estimated-epc-different-than-actual-epc_answer':
                'faq.estimated-epc-different-than-actual-epc_answer',
            'how-is-vat-computed_tooltip': '',
            'how-is-vat-computed_question': 'faq.how-is-vat-computed_question',
            'how-is-vat-computed_answer': 'faq.how-is-vat-computed_answer',
            'price-ers-includes_tooltip': '',
            'price-ers-includes_question': 'faq.price-ers-includes_question',
            'price-ers-includes_answer': 'faq.price-ers-includes_answer',
            'incorrect-region_tooltip': '',
            'incorrect-region_question': 'faq.incorrect-region_question',
            'incorrect-region_answer': 'faq.incorrect-region_answer',
            'interaction-between-renovations_tooltip': '',
            'interaction-between-renovations_question':
                'faq.interaction-between-renovations_question',
            'interaction-between-renovations_answer':
                'faq.interaction-between-renovations_answer',
            'ers-reliability_tooltip': '',
            'ers-reliability_question': 'faq.ers-reliability_question',
            'ers-reliability_answer': 'faq.ers-reliability_answer',
            'report-measurements-dont-match_tooltip': '',
            'report-measurements-dont-match_question':
                'faq.report-measurements-dont-match_question',
            'report-measurements-dont-match_answer':
                'faq.report-measurements-dont-match_answer',
            'how-to-create-val-req_tooltip': '',
            'how-to-create-val-req_question': 'faq.how-to-create-val-req_question',
            'how-to-create-val-req_answer': 'faq.how-to-create-val-req_answer',
            'how-to-access-app_tooltip': '',
            'how-to-access-app_question': 'faq.how-to-access-app_question',
            'how-to-access-app_answer': 'faq.how-to-access-app_answer',
            'how-to-use-dashboard_tooltip': '',
            'how-to-use-dashboard_question': 'faq.how-to-use-dashboard_question',
            'how-to-use-dashboard_answer': 'faq.how-to-use-dashboard_answer',
            'what-is-val-report_tooltip': '',
            'what-is-val-report_question': 'faq.what-is-val-report_question',
            'what-is-val-report_answer': 'faq.what-is-val-report_answer',
            'how-to-create-req-const_tooltip': '',
            'how-to-create-req-const_question': 'faq.how-to-create-req-const_question',
            'how-to-create-req-const_answer': 'faq.how-to-create-req-const_answer',
            'how-to-create-req-new-house_tooltip': '',
            'how-to-create-req-new-house_question':
                'faq.how-to-create-req-new-house_question',
            'how-to-create-req-new-house_answer':
                'faq.how-to-create-req-new-house_answer',
            'how-to-create-req-existing-house_tooltip': '',
            'how-to-create-req-existing-house_question':
                'faq.how-to-create-req-existing-house_question',
            'how-to-create-req-existing-house_answer':
                'faq.how-to-create-req-existing-house_answer',
            'how-to-create-req-new-qpqrtment_tooltip': '',
            'how-to-create-req-new-qpqrtment_question':
                'faq.how-to-create-req-new-qpqrtment_question',
            'how-to-create-req-new-qpqrtment_answer':
                'faq.how-to-create-req-new-qpqrtment_answer',
            'how-to-create-req-existing-apartment_tooltip': '',
            'how-to-create-req-existing-apartment_question':
                'faq.how-to-create-req-existing-apartment_question',
            'how-to-create-req-existing-apartment_answer':
                'faq.how-to-create-req-existing-apartment_answer',
            'how-to-confirm-address-existing-prop_tooltip': '',
            'how-to-confirm-address-existing-prop_question':
                'faq.how-to-confirm-address-existing-prop_question',
            'how-to-confirm-address-existing-prop_answer':
                'faq.how-to-confirm-address-existing-prop_answer',
            'how-to-confirm-address-prop-under-const_tooltip': '',
            'how-to-confirm-address-prop-under-const_question':
                'faq.how-to-confirm-address-prop-under-const_question',
            'how-to-confirm-address-prop-under-const_answer':
                'faq.how-to-confirm-address-prop-under-const_answer',
            'how-to-create-ers-req-3D_tooltip': '',
            'how-to-create-ers-req-3D_question': 'faq.how-to-create-ers-req-3D_question',
            'how-to-create-ers-req-3D_answer': 'faq.how-to-create-ers-req-3D_answer',
            'how-to-create-ers-req-2D_tooltip': '',
            'how-to-create-ers-req-2D_question': 'faq.how-to-create-ers-req-2D_question',
            'how-to-create-ers-req-2D_answer': 'faq.how-to-create-ers-req-2D_answer',
            'how-to-create-ers-req-building-not-found_tooltip': '',
            'how-to-create-ers-req-building-not-found_question':
                'faq.how-to-create-ers-req-building-not-found_question',
            'how-to-create-ers-req-building-not-found_answer':
                'faq.how-to-create-ers-req-building-not-found_answer',
            'how-total-investment-cost-calculated_tooltip': '',
            'how-total-investment-cost-calculated_question':
                'faq.how-total-investment-cost-calculated_question',
            'how-total-investment-cost-calculated_answer':
                'faq.how-total-investment-cost-calculated_answer',
            payment_tooltip: '',
            payment_question: 'faq.payment_question',
            payment_answer: 'faq.payment_answer',
            'payment-methods_tooltip': '',
            'payment-methods_question': 'faq.payment-methods_question',
            'payment-methods_answer': 'faq.payment-methods_answer',
            'why-payment-before_tooltip': '',
            'why-payment-before_question': 'faq.why-payment-before_question',
            'why-payment-before_answer': 'faq.why-payment-before_answer',
            'when-appointment_tooltip': '',
            'when-appointment_question': 'faq.when-appointment_question',
            'when-appointment_answer': 'faq.when-appointment_answer',
            Reschedule_tooltip: '',
            Reschedule_question: 'faq.Reschedule_question',
            Reschedule_answer: 'faq.Reschedule_answer',
            cancel_tooltip: '',
            cancel_question: 'faq.cancel_question',
            cancel_answer: 'faq.cancel_answer',
            present_tooltip: '',
            present_question: 'faq.present_question',
            present_answer: 'faq.present_answer',
            timing_tooltip: '',
            timing_question: 'faq.timing_question',
            timing_answer: 'faq.timing_answer',
            'borrower-contact-expert_tooltip': '',
            'borrower-contact-expert_question': 'faq.borrower-contact-expert_question',
            'borrower-contact-expert_answer': 'faq.borrower-contact-expert_answer',
            'borrower-contact-who_tooltip': '',
            'borrower-contact-who_question': 'faq.borrower-contact-who_question',
            'borrower-contact-who_answer': 'faq.borrower-contact-who_answer',
            'bank-agent-contacted_tooltip': '',
            'bank-agent-contacted_question': 'faq.bank-agent-contacted_question',
            'bank-agent-contacted_answer': 'faq.bank-agent-contacted_answer',
            'how-contact-RE_tooltip': '',
            'how-contact-RE_question': 'faq.how-contact-RE_question',
            'how-contact-RE_answer': 'faq.how-contact-RE_answer',
            'contact-representative_tooltip': '',
            'contact-representative_question': 'faq.contact-representative_question',
            'contact-representative_answer': 'faq.contact-representative_answer',
            'how-link-calendar_tooltip': '',
            'how-link-calendar_question': 'faq.how-link-calendar_question',
            'how-link-calendar_answer': 'faq.how-link-calendar_answer',
            'Several-calendars_tooltip': '',
            'Several-calendars_question': 'faq.Several-calendars_question',
            'Several-calendars_answer': 'faq.Several-calendars_answer',
            'How-availabilities_tooltip': '',
            'How-availabilities_question': 'faq.How-availabilities_question',
            'How-availabilities_answer': 'faq.How-availabilities_answer',
            'Different-regions_tooltip': '',
            'Different-regions_question': 'faq.Different-regions_question',
            'Different-regions_answer': 'faq.Different-regions_answer',
            'How-different-regions_tooltip': '',
            'How-different-regions_question': 'faq.How-different-regions_question',
            'How-different-regions_answer': 'faq.How-different-regions_answer',
            'How-register-regions_tooltip': '',
            'How-register-regions_question': 'faq.How-register-regions_question',
            'How-register-regions_answer': 'faq.How-register-regions_answer',
            'How-appointment-assigned_tooltip': '',
            'How-appointment-assigned_question': 'faq.How-appointment-assigned_question',
            'How-appointment-assigned_answer': 'faq.How-appointment-assigned_answer',
            'Forgot-confirmation_tooltip': '',
            'Forgot-confirmation_question': 'faq.Forgot-confirmation_question',
            'Forgot-confirmation_answer': 'faq.Forgot-confirmation_answer',
            'Optimize-appointments_tooltip': '',
            'Optimize-appointments_question': 'faq.Optimize-appointments_question',
            'Optimize-appointments_answer': 'faq.Optimize-appointments_answer',
            'Where-view-appointments_tooltip': '',
            'Where-view-appointments_question': 'faq.Where-view-appointments_question',
            'Where-view-appointments_answer': 'faq.Where-view-appointments_answer',
            'Where-confirm_tooltip': '',
            'Where-confirm_question': 'faq.Where-confirm_question',
            'Where-confirm_answer': 'faq.Where-confirm_answer',
            'Flood-zones_tooltip': '',
            'Flood-zones_question': 'faq.Flood-zones_question',
            'Flood-zones_answer': 'faq.Flood-zones_answer',
            'Parcel-area_tooltip': '',
            'Parcel-area_question': 'faq.Parcel-area_question',
            'Parcel-area_answer': 'faq.Parcel-area_answer',
            'Building-footprint_tooltip': '',
            'Building-footprint_question': 'faq.Building-footprint_question',
            'Building-footprint_answer': 'faq.Building-footprint_answer',
            'Garden-area_tooltip': '',
            'Garden-area_question': 'faq.Garden-area_question',
            'Garden-area_answer': 'faq.Garden-area_answer',
            'Living-area_tooltip': '',
            'Living-area_question': 'faq.Living-area_question',
            'Living-area_answer': 'faq.Living-area_answer',
            'Approximate-Living-area_tooltip': '',
            'Approximate-Living-area_question': 'faq.Approximate-Living-area_question',
            'Approximate-Living-area_answer': 'faq.Approximate-Living-area_answer',
            'Different-living-area_tooltip': '',
            'Different-living-area_question': 'faq.Different-living-area_question',
            'Different-living-area_answer': 'faq.Different-living-area_answer',
            'EPC-certificate_tooltip': '',
            'EPC-certificate_question': 'faq.EPC-certificate_question',
            'EPC-certificate_answer': 'faq.EPC-certificate_answer',
            'Market-value_tooltip': '',
            'Market-value_question': 'faq.Market-value_question',
            'Market-value_answer': 'faq.Market-value_answer',
            'Forced-sale-value_tooltip': '',
            'Forced-sale-value_question': 'faq.Forced-sale-value_question',
            'Forced-sale-value_answer': 'faq.Forced-sale-value_answer',
            'Monthly-rental-value_tooltip': '',
            'Monthly-rental-value_question': 'faq.Monthly-rental-value_question',
            'Monthly-rental-value_answer': 'faq.Monthly-rental-value_answer',
            'Reconstruction-value_tooltip': '',
            'Reconstruction-value_question': 'faq.Reconstruction-value_question',
            'Reconstruction-value_answer': 'faq.Reconstruction-value_answer',
            'Reference-points_tooltip': '',
            'Reference-points_question': 'faq.Reference-points_question',
            'Reference-points_answer': 'faq.Reference-points_answer',
        },
        questions_feedback: {
            explanation_1: 'questions_feedback.explanation_1',
            explanation_1_tooltip: '',
            explanation_2: 'questions_feedback.explanation_2',
            explanation_2_tooltip: '',
        },
        punctuation: {
            ':': 'punctuation.:',
            ':_tooltip': '',
        },
        status: {
            draft: 'status.draft',
            draft_tooltip: '',
            submitted: 'status.submitted',
            submitted_tooltip: '',
            completed: 'status.completed',
            completed_tooltip: '',
            valued: 'status.valued',
            valued_tooltip: '',
            'awaiting-onsite': 'status.awaiting-onsite',
            'awaiting-onsite_tooltip': '',
            cancelled: 'status.cancelled',
            cancelled_tooltip: '',
            canceled: 'status.canceled',
            canceled_tooltip: '',
            pending_confirmation: 'status.pending_confirmation',
            pending_confirmation_tooltip: '',
            failed: 'status.failed',
            failed_tooltip: '',
            confirmed: 'status.confirmed',
            confirmed_tooltip: '',
        },
        renovation_info: {
            title: 'renovation_info.title',
            title_tooltip: '',
            add_document: 'renovation_info.add_document',
            add_document_tooltip: '',
            unlink_document: 'renovation_info.unlink_document',
            unlink_document_tooltip: '',
            link_document: 'renovation_info.link_document',
            link_document_tooltip: '',
            items: 'renovation_info.items',
            items_tooltip: '',
            linked_items: 'renovation_info.linked_items',
            linked_items_tooltip: '',
        },
        renovation_item: {
            title: 'renovation_item.title',
            title_tooltip: '',
            amount: 'renovation_item.amount',
            amount_tooltip: '',
            category: 'renovation_item.category',
            category_tooltip: '',
            subcategory: 'renovation_item.subcategory',
            subcategory_tooltip: '',
            modal_title: 'renovation_item.modal_title',
            modal_title_tooltip: '',
        },
        renovation_category: {
            energy: 'renovation_category.energy',
            energy_tooltip: '',
            structural: 'renovation_category.structural',
            structural_tooltip: '',
            aesthetic: 'renovation_category.aesthetic',
            aesthetic_tooltip: '',
            other: 'renovation_category.other',
            other_tooltip: '',
        },
        renovation_subcategory: {
            insulation: 'renovation_subcategory.insulation',
            insulation_tooltip: '',
            solar_panel: 'renovation_subcategory.solar_panel',
            solar_panel_tooltip: '',
            heating: 'renovation_subcategory.heating',
            heating_tooltip: '',
            other: 'renovation_subcategory.other',
            other_tooltip: '',
            wall_extension: 'renovation_subcategory.wall_extension',
            wall_extension_tooltip: '',
            demolition: 'renovation_subcategory.demolition',
            demolition_tooltip: '',
            kitchen: 'renovation_subcategory.kitchen',
            kitchen_tooltip: '',
            bathroom: 'renovation_subcategory.bathroom',
            bathroom_tooltip: '',
        },
        steps: {
            customer_ref: 'steps.customer_ref',
            customer_ref_tooltip: '',
            building_type: 'steps.building_type',
            building_type_tooltip: 'steps.building_type_tooltip',
            address: 'steps.address',
            address_tooltip: '',
            address_confirmation: 'steps.address_confirmation',
            address_confirmation_tooltip: 'steps.address_confirmation_tooltip',
            building_selection: 'steps.building_selection',
            building_selection_tooltip: '',
            house_info: 'steps.house_info',
            house_info_tooltip: '',
            building_dimensions: 'steps.building_dimensions',
            building_dimensions_tooltip: '',
            epc: 'steps.epc',
            epc_tooltip: '',
            construction_year: 'steps.construction_year',
            construction_year_tooltip: 'steps.construction_year_tooltip',
            living_area: 'steps.living_area',
            living_area_tooltip: 'steps.living_area_tooltip',
            energy_performance: 'steps.energy_performance',
            energy_performance_tooltip: '',
            insulation: 'steps.insulation',
            insulation_tooltip: '',
            wall_insulation: 'steps.wall_insulation',
            wall_insulation_tooltip: '',
            roof_insulation: 'steps.roof_insulation',
            roof_insulation_tooltip: '',
            floor_insulation: 'steps.floor_insulation',
            floor_insulation_tooltip: '',
            window_glazing: 'steps.window_glazing',
            window_glazing_tooltip: '',
            attic: 'steps.attic',
            attic_tooltip: '',
            basement: 'steps.basement',
            basement_tooltip: '',
            energy_consumption: 'steps.energy_consumption',
            energy_consumption_tooltip: '',
            heating: 'steps.heating',
            heating_tooltip: '',
            electricity_consumption: 'steps.electricity_consumption',
            electricity_consumption_tooltip: '',
            gas_consumption: 'steps.gas_consumption',
            gas_consumption_tooltip: '',
            oil_consumption: 'steps.oil_consumption',
            oil_consumption_tooltip: '',
            coal_consumption: 'steps.coal_consumption',
            coal_consumption_tooltip: '',
            wood_consumption: 'steps.wood_consumption',
            wood_consumption_tooltip: '',
            pellets_consumption: 'steps.pellets_consumption',
            pellets_consumption_tooltip: '',
            district_heating_consumption: 'steps.district_heating_consumption',
            district_heating_consumption_tooltip: '',
            solar_panels: 'steps.solar_panels',
            solar_panels_tooltip: '',
            ventilation: 'steps.ventilation',
            ventilation_tooltip: '',
            consumers: 'steps.consumers',
            consumers_tooltip: '',
            big_consumers: 'steps.big_consumers',
            big_consumers_tooltip: '',
            electric_vehicles: 'steps.electric_vehicles',
            electric_vehicles_tooltip: '',
            processing: 'steps.processing',
            processing_tooltip: '',
            finish: 'steps.finish',
            finish_tooltip: '',
        },
        property_type: {
            apartments: 'property_type.apartments',
            apartments_tooltip: '',
            coming_soon: 'property_type.coming_soon',
            coming_soon_tooltip: '',
            select_type: 'property_type.select_type',
            select_type_tooltip: '',
            title: 'property_type.title',
            title_tooltip: '',
        },
        out_of_bounds_page: {
            title: 'out_of_bounds_page.title',
            title_tooltip: '',
            '3d_model_not_found_subtitle':
                'out_of_bounds_page.3d_model_not_found_subtitle',
            '3d_model_not_found_subtitle_tooltip': '',
            '3d_model_not_found': 'out_of_bounds_page.3d_model_not_found',
            '3d_model_not_found_tooltip': '',
            content_tooltip: '',
            button: 'out_of_bounds_page.button',
            button_tooltip: '',
            ing_button: 'out_of_bounds_page.ing_button',
            ing_button_tooltip: '',
        },
        terms_page: {
            welcome: 'terms_page.welcome',
            welcome_tooltip: '',
            epc: 'terms_page.epc',
            epc_tooltip: '',
            disclaimer: 'terms_page.disclaimer',
            disclaimer_tooltip: '',
        },
        features_question: {
            insulated_floors: 'features_question.insulated_floors',
            insulated_floors_tooltip: '',
            insulated_roof: 'features_question.insulated_roof',
            insulated_roof_tooltip: '',
            insulated_walls: 'features_question.insulated_walls',
            insulated_walls_tooltip: '',
            has_attic: 'features_question.has_attic',
            has_attic_tooltip: '',
            insulation_floors_when: 'features_question.insulation_floors_when',
            insulation_floors_when_tooltip: '',
            insulation_roof_when: 'features_question.insulation_roof_when',
            insulation_roof_when_tooltip: '',
            insulation_walls_when: 'features_question.insulation_walls_when',
            insulation_walls_when_tooltip: '',
            has_basement: 'features_question.has_basement',
            has_basement_tooltip: '',
            is_attic_heated: 'features_question.is_attic_heated',
            is_attic_heated_tooltip: '',
            last_floor_renovation: 'features_question.last_floor_renovation',
            last_floor_renovation_tooltip: '',
            last_wall_renovation: 'features_question.last_wall_renovation',
            last_wall_renovation_tooltip: '',
            last_roof_renovation: 'features_question.last_roof_renovation',
            last_roof_renovation_tooltip: '',
            enter_epc_label: 'features_question.enter_epc_label',
            enter_epc_label_tooltip: '',
            enter_epc_score: 'features_question.enter_epc_score',
            enter_epc_score_tooltip: '',
            epc_type: 'features_question.epc_type',
            epc_type_tooltip: '',
            epc_known: 'features_question.epc_known',
            epc_known_tooltip: 'features_question.epc_known_tooltip',
            consumption_known_no: 'features_question.consumption_known_no',
            consumption_known_no_tooltip: '',
            consumption_known_yes: 'features_question.consumption_known_yes',
            consumption_known_yes_tooltip: '',
            epc_known_yes: 'features_question.epc_known_yes',
            epc_known_yes_tooltip: '',
            epc_known_no: 'features_question.epc_known_no',
            epc_known_no_tooltip: '',
            select_heating_fuel: 'features_question.select_heating_fuel',
            select_heating_fuel_tooltip: '',
            ventilation_type: 'features_question.ventilation_type',
            ventilation_type_tooltip: '',
            ventilation_subtype: 'features_question.ventilation_subtype',
            ventilation_subtype_tooltip: '',
            n_residents: 'features_question.n_residents',
            n_residents_tooltip: '',
            protected_consumer: 'features_question.protected_consumer',
            protected_consumer_tooltip: '',
            heating_consumption_approx: 'features_question.heating_consumption_approx',
            heating_consumption_approx_tooltip: '',
            electric_consumption_approx: 'features_question.electric_consumption_approx',
            electric_consumption_approx_tooltip: '',
            installation_year: 'features_question.installation_year',
            installation_year_tooltip: '',
            heater: 'features_question.heater',
            heater_tooltip: '',
            energy_consumption_known: 'features_question.energy_consumption_known',
            energy_consumption_known_tooltip: '',
            consumption_known: 'features_question.consumption_known',
            consumption_known_tooltip: 'features_question.consumption_known_tooltip',
            yearly_electricity_consumption:
                'features_question.yearly_electricity_consumption',
            yearly_electricity_consumption_tooltip:
                'features_question.yearly_electricity_consumption_tooltip',
            yearly_electricity_consumption_subtitle:
                'features_question.yearly_electricity_consumption_subtitle',
            yearly_electricity_consumption_subtitle_tooltip: '',
            yearly_fuel_consumption: 'features_question.yearly_fuel_consumption',
            yearly_fuel_consumption_tooltip:
                'features_question.yearly_fuel_consumption_tooltip',
            yearly_heating_consumption: 'features_question.yearly_heating_consumption',
            yearly_heating_consumption_tooltip: '',
            f_construction_year: 'features_question.f_construction_year',
            f_construction_year_tooltip: '',
            f_living_area: 'features_question.f_living_area',
            f_living_area_tooltip: 'features_question.f_living_area_tooltip',
            approx_living_area: 'features_question.approx_living_area',
            approx_living_area_tooltip: '',
            solar_panels: 'features_question.solar_panels',
            solar_panels_tooltip: '',
            insulated_windows: 'features_question.insulated_windows',
            insulated_windows_tooltip: 'features_question.insulated_windows_tooltip',
            insulated_single_renovated: 'features_question.insulated_single_renovated',
            insulated_single_renovated_tooltip: '',
            insulated_plural_renovated: 'features_question.insulated_plural_renovated',
            insulated_plural_renovated_tooltip: '',
            consumption_title: 'features_question.consumption_title',
            consumption_title_tooltip: '',
            consumption_yearly_consumption:
                'features_question.consumption_yearly_consumption',
            consumption_yearly_consumption_tooltip: '',
            gas_consumption_known: 'features_question.gas_consumption_known',
            gas_consumption_known_tooltip: '',
            oil_consumption_known: 'features_question.oil_consumption_known',
            oil_consumption_known_tooltip: '',
            wood_consumption_known: 'features_question.wood_consumption_known',
            wood_consumption_known_tooltip: '',
            coal_consumption_known: 'features_question.coal_consumption_known',
            coal_consumption_known_tooltip: '',
            pellets_consumption_known: 'features_question.pellets_consumption_known',
            pellets_consumption_known_tooltip: '',
            district_heating_consumption_known:
                'features_question.district_heating_consumption_known',
            district_heating_consumption_known_tooltip: '',
            electricity_consumption_known:
                'features_question.electricity_consumption_known',
            electricity_consumption_known_tooltip: '',
            gas_consumption_approx: 'features_question.gas_consumption_approx',
            gas_consumption_approx_tooltip: '',
            oil_consumption_approx: 'features_question.oil_consumption_approx',
            oil_consumption_approx_tooltip: '',
            wood_consumption_approx: 'features_question.wood_consumption_approx',
            wood_consumption_approx_tooltip: '',
            coal_consumption_approx: 'features_question.coal_consumption_approx',
            coal_consumption_approx_tooltip: '',
            pellets_consumption_approx: 'features_question.pellets_consumption_approx',
            pellets_consumption_approx_tooltip: '',
            district_heating_consumption_approx:
                'features_question.district_heating_consumption_approx',
            district_heating_consumption_approx_tooltip: '',
            electricity_consumption_approx:
                'features_question.electricity_consumption_approx',
            electricity_consumption_approx_tooltip: '',
            enter_value: 'features_question.enter_value',
            enter_value_tooltip: '',
        },
        map_page: {
            '3d_model': 'map_page.3d_model',
            '3d_model_tooltip': '',
        },
        address_page: {
            title: 'address_page.title',
            title_tooltip: 'address_page.title_tooltip',
            subtitle: 'address_page.subtitle',
            subtitle_tooltip: '',
            control_address: 'address_page.control_address',
            control_address_tooltip: '',
        },
        validation: {
            range: 'validation.range',
            range_tooltip: '',
            field_required: 'validation.field_required',
            field_required_tooltip: '',
            only_numbers: 'validation.only_numbers',
            only_numbers_tooltip: '',
            min_4_characters: 'validation.min_4_characters',
            min_4_characters_tooltip: '',
            wrong_epc: 'validation.wrong_epc',
            wrong_epc_tooltip: '',
            valid_years: 'validation.valid_years',
            valid_years_tooltip: '',
            value_too_small: 'validation.value_too_small',
            value_too_small_tooltip: '',
            value_too_large: 'validation.value_too_large',
            value_too_large_tooltip: '',
        },
        f_epc: {
            label: 'f_epc.label',
            label_tooltip: '',
        },
        features_page: {
            title: 'features_page.title',
            title_tooltip: '',
        },
        consumption_page: {
            title: 'consumption_page.title',
            title_tooltip: '',
            info: 'consumption_page.info',
            info_tooltip: '',
            big_consumer: 'consumption_page.big_consumer',
            big_consumer_tooltip: '',
        },
        login_page: {
            login: 'login_page.login',
            login_tooltip: '',
        },
        wall_insulation_page: {
            info: 'wall_insulation_page.info',
            info_tooltip: '',
        },
        roof_insulation_page: {
            info: 'roof_insulation_page.info',
            info_tooltip: '',
        },
        building_dimensions_page: {
            is_flat: 'building_dimensions_page.is_flat',
            is_flat_tooltip: '',
            title: 'building_dimensions_page.title',
            title_tooltip: '',
            subtitle: 'building_dimensions_page.subtitle',
            subtitle_tooltip: '',
            floors_title: 'building_dimensions_page.floors_title',
            floors_title_tooltip: '',
            floors_info: 'building_dimensions_page.floors_info',
            floors_info_tooltip: '',
            roof_title: 'building_dimensions_page.roof_title',
            roof_title_tooltip: '',
            tooltip_roof_type: 'building_dimensions_page.tooltip_roof_type',
            tooltip_roof_type_tooltip: '',
            roof_pitched: 'building_dimensions_page.roof_pitched',
            roof_pitched_tooltip: '',
            roof_flat: 'building_dimensions_page.roof_flat',
            roof_flat_tooltip: '',
            roof_mixed: 'building_dimensions_page.roof_mixed',
            roof_mixed_tooltip: '',
            facades_title: 'building_dimensions_page.facades_title',
            facades_title_tooltip: '',
            tooltip_common_facades: 'building_dimensions_page.tooltip_common_facades',
            tooltip_common_facades_tooltip: '',
            facades_type_0: 'building_dimensions_page.facades_type_0',
            facades_type_0_tooltip: '',
            facades_type_1: 'building_dimensions_page.facades_type_1',
            facades_type_1_tooltip: '',
            facades_type_2: 'building_dimensions_page.facades_type_2',
            facades_type_2_tooltip: '',
        },
        welcome_page: {
            title: 'welcome_page.title',
            title_tooltip: '',
            text_welcome: 'welcome_page.text_welcome',
            text_welcome_tooltip: '',
            text_intro: 'welcome_page.text_intro',
            text_intro_tooltip: '',
            text_description: 'welcome_page.text_description',
            text_description_tooltip: '',
            'info-bubble': 'welcome_page.info-bubble',
            'info-bubble_tooltip': '',
            button_start: 'welcome_page.button_start',
            button_start_tooltip: '',
            terms: 'welcome_page.terms',
            terms_tooltip: '',
            curious: 'welcome_page.curious',
            curious_tooltip: '',
        },
        error_page: {
            title: 'error_page.title',
            title_tooltip: '',
            intro: 'error_page.intro',
            intro_tooltip: '',
            button: 'error_page.button',
            button_tooltip: '',
        },
        insulation: {
            title: 'insulation.title',
            title_tooltip: '',
        },
        consumption: {
            gas_consumption_title: 'consumption.gas_consumption_title',
            gas_consumption_title_tooltip: '',
            oil_consumption_title: 'consumption.oil_consumption_title',
            oil_consumption_title_tooltip: '',
            wood_consumption_title: 'consumption.wood_consumption_title',
            wood_consumption_title_tooltip: '',
            coal_consumption_title: 'consumption.coal_consumption_title',
            coal_consumption_title_tooltip: '',
            pellets_consumption_title: 'consumption.pellets_consumption_title',
            pellets_consumption_title_tooltip: '',
            district_heating_consumption_title:
                'consumption.district_heating_consumption_title',
            district_heating_consumption_title_tooltip: '',
            electricity_consumption_title: 'consumption.electricity_consumption_title',
            electricity_consumption_title_tooltip: '',
        },
        consumers_page: {
            info: 'consumers_page.info',
            info_tooltip: '',
            title: 'consumers_page.title',
            title_tooltip: '',
        },
        ventilation_page: {
            ventilation_title: 'ventilation_page.ventilation_title',
            ventilation_title_tooltip: '',
        },
        energy_quizz: {
            solar: {
                qa: {
                    q: 'energy_quizz.solar.qa.q',
                    q_tooltip: '',
                    a1: 'energy_quizz.solar.qa.a1',
                    a1_tooltip: '',
                    a2: 'energy_quizz.solar.qa.a2',
                    a2_tooltip: '',
                    a3: 'energy_quizz.solar.qa.a3',
                    a3_tooltip: '',
                },
                qb: {
                    q: 'energy_quizz.solar.qb.q',
                    q_tooltip: '',
                    a1: 'energy_quizz.solar.qb.a1',
                    a1_tooltip: '',
                    a2: 'energy_quizz.solar.qb.a2',
                    a2_tooltip: '',
                    a3: 'energy_quizz.solar.qb.a3',
                    a3_tooltip: '',
                },
            },
            q1: {
                q: 'energy_quizz.q1.q',
                q_tooltip: '',
                a1: 'energy_quizz.q1.a1',
                a1_tooltip: '',
                f1: 'energy_quizz.q1.f1',
                f1_tooltip: '',
                a2: 'energy_quizz.q1.a2',
                a2_tooltip: '',
                f2: 'energy_quizz.q1.f2',
                f2_tooltip: '',
                a3: 'energy_quizz.q1.a3',
                a3_tooltip: '',
                f3: 'energy_quizz.q1.f3',
                f3_tooltip: '',
            },
            q2: {
                q: 'energy_quizz.q2.q',
                q_tooltip: '',
                a1: 'energy_quizz.q2.a1',
                a1_tooltip: '',
                f1: 'energy_quizz.q2.f1',
                f1_tooltip: '',
                a2: 'energy_quizz.q2.a2',
                a2_tooltip: '',
                f2: 'energy_quizz.q2.f2',
                f2_tooltip: '',
                a3: 'energy_quizz.q2.a3',
                a3_tooltip: '',
                f3: 'energy_quizz.q2.f3',
                f3_tooltip: '',
                a4: 'energy_quizz.q2.a4',
                a4_tooltip: '',
                f4: 'energy_quizz.q2.f4',
                f4_tooltip: '',
            },
            q3: {
                q: 'energy_quizz.q3.q',
                q_tooltip: '',
                a1: 'energy_quizz.q3.a1',
                a1_tooltip: '',
                f1: 'energy_quizz.q3.f1',
                f1_tooltip: '',
                a2: 'energy_quizz.q3.a2',
                a2_tooltip: '',
                f2: 'energy_quizz.q3.f2',
                f2_tooltip: '',
                a3: 'energy_quizz.q3.a3',
                a3_tooltip: '',
                f3: 'energy_quizz.q3.f3',
                f3_tooltip: '',
            },
            q4: {
                q: 'energy_quizz.q4.q',
                q_tooltip: '',
                a1: 'energy_quizz.q4.a1',
                a1_tooltip: '',
                f1: 'energy_quizz.q4.f1',
                f1_tooltip: '',
                a2: 'energy_quizz.q4.a2',
                a2_tooltip: '',
                f2: 'energy_quizz.q4.f2',
                f2_tooltip: '',
                a3: 'energy_quizz.q4.a3',
                a3_tooltip: '',
                f3: 'energy_quizz.q4.f3',
                f3_tooltip: '',
            },
            q5: {
                q: 'energy_quizz.q5.q',
                q_tooltip: '',
                a1: 'energy_quizz.q5.a1',
                a1_tooltip: '',
                f1: 'energy_quizz.q5.f1',
                f1_tooltip: '',
                a2: 'energy_quizz.q5.a2',
                a2_tooltip: '',
                f2: 'energy_quizz.q5.f2',
                f2_tooltip: '',
                a3: 'energy_quizz.q5.a3',
                a3_tooltip: '',
                f3: 'energy_quizz.q5.f3',
                f3_tooltip: '',
            },
            q6: {
                q: 'energy_quizz.q6.q',
                q_tooltip: '',
                a1: 'energy_quizz.q6.a1',
                a1_tooltip: '',
                f1: 'energy_quizz.q6.f1',
                f1_tooltip: '',
                a2: 'energy_quizz.q6.a2',
                a2_tooltip: '',
                f2: 'energy_quizz.q6.f2',
                f2_tooltip: '',
                a3: 'energy_quizz.q6.a3',
                a3_tooltip: '',
                f3: 'energy_quizz.q6.f3',
                f3_tooltip: '',
            },
            discovery_phase: 'energy_quizz.discovery_phase',
            discovery_phase_tooltip: '',
            discovery_description: 'energy_quizz.discovery_description',
            discovery_description_tooltip: '',
            learning_phase: 'energy_quizz.learning_phase',
            learning_phase_tooltip: '',
            learning_description: 'energy_quizz.learning_description',
            learning_description_tooltip: '',
            expert_phase: 'energy_quizz.expert_phase',
            expert_phase_tooltip: '',
            expert_description: 'energy_quizz.expert_description',
            expert_description_tooltip: '',
        },
        ers_report: {
            language: 'ers_report.language',
            language_tooltip: '',
            header_title: 'ers_report.header_title',
            header_title_tooltip: '',
            header_subtitle: 'ers_report.header_subtitle',
            header_subtitle_tooltip: '',
            header_subtitle_pdf: 'ers_report.header_subtitle_pdf',
            header_subtitle_pdf_tooltip: '',
            epc_graph_title: 'ers_report.epc_graph_title',
            epc_graph_title_tooltip: '',
            epc_graph_subtitle: 'ers_report.epc_graph_subtitle',
            epc_graph_subtitle_tooltip: '',
            consumption_title: 'ers_report.consumption_title',
            consumption_title_tooltip: '',
            gas_title: 'ers_report.gas_title',
            gas_title_tooltip: '',
            electric_title: 'ers_report.electric_title',
            electric_title_tooltip: '',
            low_title: 'ers_report.low_title',
            low_title_tooltip: '',
            high_title: 'ers_report.high_title',
            high_title_tooltip: '',
            average_title: 'ers_report.average_title',
            average_title_tooltip: '',
            you_title: 'ers_report.you_title',
            you_title_tooltip: '',
            current_epc: 'ers_report.current_epc',
            current_epc_tooltip: '',
            future_epc: 'ers_report.future_epc',
            future_epc_tooltip: '',
            summary_input_title: 'ers_report.summary_input_title',
            summary_input_title_tooltip: '',
            summary_title: 'ers_report.summary_title',
            summary_title_tooltip: '',
            summary_note: 'ers_report.summary_note',
            summary_note_tooltip: '',
            price_title: 'ers_report.price_title',
            price_title_tooltip: '',
            subsidy_title: 'ers_report.subsidy_title',
            subsidy_title_tooltip: '',
            after_subsidy_title: 'ers_report.after_subsidy_title',
            after_subsidy_title_tooltip: '',
            total_title: 'ers_report.total_title',
            total_title_tooltip: '',
            calculate_button_text: 'ers_report.calculate_button_text',
            calculate_button_text_tooltip: '',
            download_report: 'ers_report.download_report',
            download_report_tooltip: '',
            renovation_title: 'ers_report.renovation_title',
            renovation_title_tooltip: '',
            renovation_subtitle: 'ers_report.renovation_subtitle',
            renovation_subtitle_tooltip: '',
            renovation_price: 'ers_report.renovation_price',
            renovation_price_tooltip: '',
            renovation_subsidy: 'ers_report.renovation_subsidy',
            renovation_subsidy_tooltip: '',
            renovation_area: 'ers_report.renovation_area',
            renovation_area_tooltip: '',
            renovation_insulation_type: 'ers_report.renovation_insulation_type',
            renovation_insulation_type_tooltip: '',
            renovation_yearly: 'ers_report.renovation_yearly',
            renovation_yearly_tooltip: '',
            renovation_windowsDouble: 'ers_report.renovation_windowsDouble',
            renovation_windowsDouble_tooltip: '',
            renovation_wallExt: 'ers_report.renovation_wallExt',
            renovation_wallExt_tooltip: '',
            renovation_wallCav: 'ers_report.renovation_wallCav',
            renovation_wallCav_tooltip: '',
            renovation_roofIn: 'ers_report.renovation_roofIn',
            renovation_roofIn_tooltip: '',
            renovation_roofExt: 'ers_report.renovation_roofExt',
            renovation_roofExt_tooltip: '',
            renovation_roofIn_attic_floor: 'ers_report.renovation_roofIn_attic_floor',
            renovation_roofIn_attic_floor_tooltip: '',
            renovation_condGas: 'ers_report.renovation_condGas',
            renovation_condGas_tooltip: '',
            renovation_heatPump: 'ers_report.renovation_heatPump',
            renovation_heatPump_tooltip: '',
            renovation_ventC: 'ers_report.renovation_ventC',
            renovation_ventC_tooltip: '',
            renovation_solar: 'ers_report.renovation_solar',
            renovation_solar_tooltip: '',
            compliance_pack_title: 'ers_report.compliance_pack_title',
            compliance_pack_title_tooltip: '',
            compliance_pack_desc: 'ers_report.compliance_pack_desc',
            compliance_pack_desc_tooltip: '',
            budget_pack_title: 'ers_report.budget_pack_title',
            budget_pack_title_tooltip: '',
            budget_pack_desc: 'ers_report.budget_pack_desc',
            budget_pack_desc_tooltip: '',
            lowest_pack_title: 'ers_report.lowest_pack_title',
            lowest_pack_title_tooltip: '',
            lowest_pack_desc: 'ers_report.lowest_pack_desc',
            lowest_pack_desc_tooltip: '',
            custom_pack_title: 'ers_report.custom_pack_title',
            custom_pack_title_tooltip: '',
            custom_pack_desc: 'ers_report.custom_pack_desc',
            custom_pack_desc_tooltip: '',
            add_remove_renovations: 'ers_report.add_remove_renovations',
            add_remove_renovations_tooltip: '',
            submit_button_budget: 'ers_report.submit_button_budget',
            submit_button_budget_tooltip: '',
            already_compilance: 'ers_report.already_compilance',
            already_compilance_tooltip: '',
            no_renovation_found: 'ers_report.no_renovation_found',
            no_renovation_found_tooltip: '',
            renovation_subtitle_compliance_pdf:
                'ers_report.renovation_subtitle_compliance_pdf',
            renovation_subtitle_compliance_pdf_tooltip: '',
            renovation_subtitle_budget_pdf: 'ers_report.renovation_subtitle_budget_pdf',
            renovation_subtitle_budget_pdf_tooltip: '',
            renovation_subtitle_custom_pdf: 'ers_report.renovation_subtitle_custom_pdf',
            renovation_subtitle_custom_pdf_tooltip: '',
            disclaimer: {
                title: 'ers_report.disclaimer.title',
                title_tooltip: '',
                body1: 'ers_report.disclaimer.body1',
                body1_tooltip: '',
                body2: 'ers_report.disclaimer.body2',
                body2_tooltip: '',
                body3: 'ers_report.disclaimer.body3',
                body3_tooltip: '',
                body4: 'ers_report.disclaimer.body4',
                body4_tooltip: '',
                body5: 'ers_report.disclaimer.body5',
                body5_tooltip: '',
                body6: 'ers_report.disclaimer.body6',
                body6_tooltip: '',
                body7: 'ers_report.disclaimer.body7',
                body7_tooltip: '',
            },
            disclaimer_body: 'ers_report.disclaimer_body',
            disclaimer_body_tooltip: '',
            disclaimer_body_pdf: 'ers_report.disclaimer_body_pdf',
            disclaimer_body_pdf_tooltip: '',
            property_page: {
                title: 'ers_report.property_page.title',
                title_tooltip: '',
                subtitle: 'ers_report.property_page.subtitle',
                subtitle_tooltip: '',
                info_bubble: 'ers_report.property_page.info_bubble',
                info_bubble_tooltip: '',
                section_title: 'ers_report.property_page.section_title',
                section_title_tooltip: '',
                epc_title: 'ers_report.property_page.epc_title',
                epc_title_tooltip: '',
                epc_text: 'ers_report.property_page.epc_text',
                epc_text_tooltip: '',
                carbon_title: 'ers_report.property_page.carbon_title',
                carbon_title_tooltip: '',
                carbon_text: 'ers_report.property_page.carbon_text',
                carbon_text_tooltip: '',
                bill_title: 'ers_report.property_page.bill_title',
                bill_title_tooltip: '',
                bill_text: 'ers_report.property_page.bill_text',
                bill_text_tooltip: '',
            },
            renovation: {
                title: {
                    gtk: 'ers_report.renovation.title.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.title.works',
                    works_tooltip: '',
                    subsidies: 'ers_report.renovation.title.subsidies',
                    subsidies_tooltip: '',
                },
                roofIn: {
                    gtk: 'ers_report.renovation.roofIn.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.roofIn.works',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies: 'ers_report.renovation.roofIn.BE-WAL.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies: 'ers_report.renovation.roofIn.BE-BRU.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies: 'ers_report.renovation.roofIn.BE-VLG.subsidies',
                        subsidies_tooltip: '',
                    },
                },
                roofExt: {
                    gtk: 'ers_report.renovation.roofExt.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.roofExt.works',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies: 'ers_report.renovation.roofExt.BE-WAL.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies: 'ers_report.renovation.roofExt.BE-BRU.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies: 'ers_report.renovation.roofExt.BE-VLG.subsidies',
                        subsidies_tooltip: '',
                    },
                },
                atticFloor: {
                    gtk: 'ers_report.renovation.atticFloor.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.atticFloor.works',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies: 'ers_report.renovation.atticFloor.BE-WAL.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies: 'ers_report.renovation.atticFloor.BE-BRU.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies: 'ers_report.renovation.atticFloor.BE-VLG.subsidies',
                        subsidies_tooltip: '',
                    },
                },
                wallExt: {
                    gtk: 'ers_report.renovation.wallExt.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.wallExt.works',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies: 'ers_report.renovation.wallExt.BE-WAL.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies: 'ers_report.renovation.wallExt.BE-BRU.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies: 'ers_report.renovation.wallExt.BE-VLG.subsidies',
                        subsidies_tooltip: '',
                    },
                },
                wallIn: {
                    gtk: 'ers_report.renovation.wallIn.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.wallIn.works',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies: 'ers_report.renovation.wallIn.BE-WAL.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies: 'ers_report.renovation.wallIn.BE-BRU.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies: 'ers_report.renovation.wallIn.BE-VLG.subsidies',
                        subsidies_tooltip: '',
                    },
                },
                wallCav: {
                    gtk: 'ers_report.renovation.wallCav.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.wallCav.works',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies: 'ers_report.renovation.wallCav.BE-WAL.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies: 'ers_report.renovation.wallCav.BE-BRU.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies: 'ers_report.renovation.wallCav.BE-VLG.subsidies',
                        subsidies_tooltip: '',
                    },
                },
                windowsDouble: {
                    gtk: 'ers_report.renovation.windowsDouble.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.windowsDouble.works',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies: 'ers_report.renovation.windowsDouble.BE-WAL.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies: 'ers_report.renovation.windowsDouble.BE-BRU.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies: 'ers_report.renovation.windowsDouble.BE-VLG.subsidies',
                        subsidies_tooltip: '',
                    },
                },
                condGas: {
                    gtk: 'ers_report.renovation.condGas.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.condGas.works',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies: 'ers_report.renovation.condGas.BE-WAL.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies: 'ers_report.renovation.condGas.BE-VLG.subsidies',
                        subsidies_tooltip: '',
                    },
                },
                heatPump: {
                    gtk: 'ers_report.renovation.heatPump.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.heatPump.works',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies: 'ers_report.renovation.heatPump.BE-WAL.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies: 'ers_report.renovation.heatPump.BE-BRU.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies: 'ers_report.renovation.heatPump.BE-VLG.subsidies',
                        subsidies_tooltip: '',
                    },
                },
                unitPv: {
                    gtk: 'ers_report.renovation.unitPv.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.unitPv.works',
                    works_tooltip: '',
                    'BE-WAL': {
                        subsidies: 'ers_report.renovation.unitPv.BE-WAL.subsidies',
                        subsidies_tooltip: '',
                    },
                    'BE-BRU': {
                        subsidies_tooltip: '',
                    },
                    'BE-VLG': {
                        subsidies: 'ers_report.renovation.unitPv.BE-VLG.subsidies',
                        subsidies_tooltip: '',
                    },
                },
                works: {
                    lead_in: 'ers_report.renovation.works.lead_in',
                    lead_in_tooltip: '',
                },
                ceiling: {
                    gtk: 'ers_report.renovation.ceiling.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.ceiling.works',
                    works_tooltip: '',
                },
                mixed: {
                    gtk: 'ers_report.renovation.mixed.gtk',
                    gtk_tooltip: '',
                    works: 'ers_report.renovation.mixed.works',
                    works_tooltip: '',
                },
                subsidies: {
                    lead_in: 'ers_report.renovation.subsidies.lead_in',
                    lead_in_tooltip: '',
                },
            },
            title1: 'ers_report.title1',
            title1_tooltip: '',
            title2: 'ers_report.title2',
            title2_tooltip: '',
            title3: 'ers_report.title3',
            title3_tooltip: '',
            title4: 'ers_report.title4',
            title4_tooltip: '',
            per_year: 'ers_report.per_year',
            per_year_tooltip: '',
            per_month: 'ers_report.per_month',
            per_month_tooltip: '',
        },
        processing_page: {
            title_started: 'processing_page.title_started',
            title_started_tooltip: '',
            title_finished: 'processing_page.title_finished',
            title_finished_tooltip: '',
            title_failed: 'processing_page.title_failed',
            title_failed_tooltip: '',
            title_pending_long: 'processing_page.title_pending_long',
            title_pending_long_tooltip: '',
            title_pending_medium: 'processing_page.title_pending_medium',
            title_pending_medium_tooltip: '',
            title_pending_short: 'processing_page.title_pending_short',
            title_pending_short_tooltip: '',
            subtitle: 'processing_page.subtitle',
            subtitle_tooltip: '',
            ing_button: 'processing_page.ing_button',
            ing_button_tooltip: '',
            check_results: 'processing_page.check_results',
            check_results_tooltip: '',
            results_ready: 'processing_page.results_ready',
            results_ready_tooltip: '',
            something_went_wrong: 'processing_page.something_went_wrong',
            something_went_wrong_tooltip: '',
        },
        customer_ref_page: {
            title: 'customer_ref_page.title',
            title_tooltip: '',
            tooltip: 'customer_ref_page.tooltip',
            tooltip_tooltip: '',
        },
        valuer_tool: {
            global: {
                'en-BE': 'valuer_tool.global.en-BE',
                'fr-BE': 'valuer_tool.global.fr-BE',
                'nl-BE': 'valuer_tool.global.nl-BE',
                photos: 'valuer_tool.global.photos',
                plans: 'valuer_tool.global.plans',
                val_submitted: 'valuer_tool.global.val_submitted',
                val_saved: 'valuer_tool.global.val_saved',
            },
            sidebar: {
                summary: {
                    title: 'valuer_tool.sidebar.summary.title',
                    lang: 'valuer_tool.sidebar.summary.lang',
                    epc_score: 'valuer_tool.sidebar.summary.epc_score',
                },
                save_val: {
                    label: 'valuer_tool.sidebar.save_val.label',
                    sub: 'valuer_tool.sidebar.save_val.sub',
                },
                submit_val: 'valuer_tool.sidebar.submit_val',
            },
            borrower: {
                language: 'valuer_tool.borrower.language',
                appointment: {
                    warning_modal: 'valuer_tool.borrower.appointment.warning_modal',
                },
                'billing-address-button': 'valuer_tool.borrower.billing-address-button',
                'billing-address-text': 'valuer_tool.borrower.billing-address-text',
                overview: 'valuer_tool.borrower.overview',
                access_property_warning: 'valuer_tool.borrower.access_property_warning',
                valuer_appointments: {
                    edit: 'valuer_tool.borrower.valuer_appointments.edit',
                    'title-no-appointments':
                        'valuer_tool.borrower.valuer_appointments.title-no-appointments',
                    title: 'valuer_tool.borrower.valuer_appointments.title',
                },
                valuer_info: {
                    title: 'valuer_tool.borrower.valuer_info.title',
                    description: 'valuer_tool.borrower.valuer_info.description',
                    'profile_card-title':
                        'valuer_tool.borrower.valuer_info.profile_card-title',
                    'accreditation_card-number':
                        'valuer_tool.borrower.valuer_info.accreditation_card-number',
                },
                borrower_trans_val: {
                    placeholder: 'valuer_tool.borrower.borrower_trans_val.placeholder',
                },
                borrower_email: {
                    placeholder: 'valuer_tool.borrower.borrower_email.placeholder',
                },
                set_borrower_language: 'valuer_tool.borrower.set_borrower_language',
                calendar: {
                    message_title: 'valuer_tool.borrower.calendar.message_title',
                    message_content: 'valuer_tool.borrower.calendar.message_content',
                    button: 'valuer_tool.borrower.calendar.button',
                    title: 'valuer_tool.borrower.calendar.title',
                },
                'booking-complete': {
                    title: 'valuer_tool.borrower.booking-complete.title',
                    description: 'valuer_tool.borrower.booking-complete.description',
                },
                receipt: {
                    button: 'valuer_tool.borrower.receipt.button',
                },
                report: {
                    button: 'valuer_tool.borrower.report.button',
                },
                'payment-error': 'valuer_tool.borrower.payment-error',
                submitter: {
                    email_question: 'valuer_tool.borrower.submitter.email_question',
                    email_text: 'valuer_tool.borrower.submitter.email_text',
                    transaction_question:
                        'valuer_tool.borrower.submitter.transaction_question',
                    transaction_text: 'valuer_tool.borrower.submitter.transaction_text',
                    success_title: 'valuer_tool.borrower.submitter.success_title',
                    success_description:
                        'valuer_tool.borrower.submitter.success_description',
                    dashboard_button: 'valuer_tool.borrower.submitter.dashboard_button',
                },
                'appointment-overview': {
                    title: 'valuer_tool.borrower.appointment-overview.title',
                    'please-share':
                        'valuer_tool.borrower.appointment-overview.please-share',
                    'will-be-present_question':
                        'valuer_tool.borrower.appointment-overview.will-be-present_question',
                    access_representative:
                        'valuer_tool.borrower.appointment-overview.access_representative',
                    'access_representative-label':
                        'valuer_tool.borrower.appointment-overview.access_representative-label',
                    access_description:
                        'valuer_tool.borrower.appointment-overview.access_description',
                    'access_description-placeholder':
                        'valuer_tool.borrower.appointment-overview.access_description-placeholder',
                },
                'borrower-details': {
                    title: 'valuer_tool.borrower.borrower-details.title',
                },
                'confirm-address_unhappy-title':
                    'valuer_tool.borrower.confirm-address_unhappy-title',
                'confirm-address_unhappy-description':
                    'valuer_tool.borrower.confirm-address_unhappy-description',
                'confirm-address_question':
                    'valuer_tool.borrower.confirm-address_question',
                step: {
                    appointment: 'valuer_tool.borrower.step.appointment',
                    'contact-details': 'valuer_tool.borrower.step.contact-details',
                    confirmation: 'valuer_tool.borrower.step.confirmation',
                    payment: 'valuer_tool.borrower.step.payment',
                },
                'payment-overview': {
                    title: 'valuer_tool.borrower.payment-overview.title',
                    'agree-with-terms':
                        'valuer_tool.borrower.payment-overview.agree-with-terms',
                    'confirm-someone-present':
                        'valuer_tool.borrower.payment-overview.confirm-someone-present',
                    cancel_title: 'valuer_tool.borrower.payment-overview.cancel_title',
                    cancel_description:
                        'valuer_tool.borrower.payment-overview.cancel_description',
                },
                payment: {
                    billing: 'valuer_tool.borrower.payment.billing',
                    pay: 'valuer_tool.borrower.payment.pay',
                    method: 'valuer_tool.borrower.payment.method',
                },
                role: {
                    notary: 'valuer_tool.borrower.role.notary',
                    broker: 'valuer_tool.borrower.role.broker',
                    renter: 'valuer_tool.borrower.role.renter',
                    other: 'valuer_tool.borrower.role.other',
                    place_holder: 'valuer_tool.borrower.role.place_holder',
                },
                'appointment-making': {
                    title: 'valuer_tool.borrower.appointment-making.title',
                },
            },
            valuer: {
                info: 'valuer_tool.valuer.info',
                accreditations: 'valuer_tool.valuer.accreditations',
                availability: 'valuer_tool.valuer.availability',
                appointments: 'valuer_tool.valuer.appointments',
            },
            reference_listing: {
                assessed: 'valuer_tool.reference_listing.assessed',
                reference: 'valuer_tool.reference_listing.reference',
                listing_date: 'valuer_tool.reference_listing.listing_date',
                touching_sides: 'valuer_tool.reference_listing.touching_sides',
                distance: 'valuer_tool.reference_listing.distance',
                price: 'valuer_tool.reference_listing.price',
                price_sqm: 'valuer_tool.reference_listing.price_sqm',
                streetnumber: 'valuer_tool.reference_listing.streetnumber',
                use_as_reference: 'valuer_tool.reference_listing.use_as_reference',
                add_to_remarks: 'valuer_tool.reference_listing.add_to_remarks',
                corrected_price: 'valuer_tool.reference_listing.corrected_price',
                corrected_price_sqm: 'valuer_tool.reference_listing.corrected_price_sqm',
                google_maps: 'valuer_tool.reference_listing.google_maps',
            },
            general: {
                title: 'valuer_tool.general.title',
                basic_infos: {
                    title: 'valuer_tool.general.basic_infos.title',
                    building_found: 'valuer_tool.general.basic_infos.building_found',
                },
                state: {
                    title: 'valuer_tool.general.state.title',
                    epc_label: 'valuer_tool.general.state.epc_label',
                },
                size: {
                    title: 'valuer_tool.general.size.title',
                },
                value: {
                    title: 'valuer_tool.general.value.title',
                    analytics: {
                        title: 'valuer_tool.general.value.analytics.title',
                        assessed: 'valuer_tool.general.value.analytics.assessed',
                        median: 'valuer_tool.general.value.analytics.median',
                        average: 'valuer_tool.general.value.analytics.average',
                        deviance: 'valuer_tool.general.value.analytics.deviance',
                    },
                },
                reference_map: {
                    title: 'valuer_tool.general.reference_map.title',
                },
                reference: {
                    title: 'valuer_tool.general.reference.title',
                    map: {
                        open: 'valuer_tool.general.reference.map.open',
                    },
                },
            },
            exterior: {
                title: 'valuer_tool.exterior.title',
                parcel: 'valuer_tool.exterior.parcel',
                annexes: 'valuer_tool.exterior.annexes',
                roof_information: 'valuer_tool.exterior.roof_information',
                solar_panel: {
                    question: 'valuer_tool.exterior.solar_panel.question',
                },
                garage: {
                    name: 'valuer_tool.exterior.garage.name',
                    question: 'valuer_tool.exterior.garage.question',
                    area: 'valuer_tool.exterior.garage.area',
                    add: 'valuer_tool.exterior.garage.add',
                },
                parking: {
                    name: 'valuer_tool.exterior.parking.name',
                    question: 'valuer_tool.exterior.parking.question',
                    area: 'valuer_tool.exterior.parking.area',
                    add: 'valuer_tool.exterior.parking.add',
                },
                barn: {
                    question: 'valuer_tool.exterior.barn.question',
                },
                stables: {
                    question: 'valuer_tool.exterior.stables.question',
                },
                pool_house: {
                    question: 'valuer_tool.exterior.pool_house.question',
                },
                swimming_pool: {
                    question: 'valuer_tool.exterior.swimming_pool.question',
                },
                garden: {
                    question: 'valuer_tool.exterior.garden.question',
                },
                f_balcony_present: {
                    question: 'valuer_tool.exterior.f_balcony_present.question',
                },
                f_cellar_attic_present: {
                    question: 'valuer_tool.exterior.f_cellar_attic_present.question',
                },
            },
            interior: {
                title: 'valuer_tool.interior.title',
                floors: {
                    floor_mobile_title: 'valuer_tool.interior.floors.floor_mobile_title',
                    title: 'valuer_tool.interior.floors.title',
                    redirected: 'valuer_tool.interior.floors.redirected',
                    add_floors: 'valuer_tool.interior.floors.add_floors',
                    add_apt_floors: 'valuer_tool.interior.floors.add_apt_floors',
                    floor: 'valuer_tool.interior.floors.floor',
                    edit_floors: 'valuer_tool.interior.floors.edit_floors',
                    go_to_floor: 'valuer_tool.interior.floors.go_to_floor',
                    delete_floor: {
                        title: 'valuer_tool.interior.floors.delete_floor.title',
                        select_transfer:
                            'valuer_tool.interior.floors.delete_floor.select_transfer',
                        no_transfer:
                            'valuer_tool.interior.floors.delete_floor.no_transfer',
                    },
                },
                tabs: {
                    interior: 'valuer_tool.interior.tabs.interior',
                    floors: 'valuer_tool.interior.tabs.floors',
                },
                empty_floors: {
                    title: 'valuer_tool.interior.empty_floors.title',
                    content: 'valuer_tool.interior.empty_floors.content',
                },
                rooms: {
                    title: 'valuer_tool.interior.rooms.title',
                    generate: 'valuer_tool.interior.rooms.generate',
                    add_room: 'valuer_tool.interior.rooms.add_room',
                    edit_room: 'valuer_tool.interior.rooms.edit_room',
                    add_and_new_room: 'valuer_tool.interior.rooms.add_and_new_room',
                },
                empty_rooms: {
                    title: 'valuer_tool.interior.empty_rooms.title',
                    content: 'valuer_tool.interior.empty_rooms.content',
                },
            },
            commons: {
                title: 'valuer_tool.commons.title',
                certificates: 'valuer_tool.commons.certificates',
                apartment: {
                    title: 'valuer_tool.commons.apartment.title',
                },
                costs: {
                    title: 'valuer_tool.commons.costs.title',
                    amount: 'valuer_tool.commons.costs.amount',
                },
                upload: {
                    button_subtitle: 'valuer_tool.commons.upload.button_subtitle',
                    button_title: 'valuer_tool.commons.upload.button_title',
                    title: 'valuer_tool.commons.upload.title',
                    max: 'valuer_tool.commons.upload.max',
                },
            },
            surroundings: {
                title: 'valuer_tool.surroundings.title',
                mobility: 'valuer_tool.surroundings.mobility',
            },
            valuation: {
                title: 'valuer_tool.valuation.title',
                value_pre_reno: 'valuer_tool.valuation.value_pre_reno',
                scheduled_renov: {
                    title: 'valuer_tool.valuation.scheduled_renov.title',
                    comment: 'valuer_tool.valuation.scheduled_renov.comment',
                    budget: 'valuer_tool.valuation.scheduled_renov.budget',
                },
                value_post_reno: 'valuer_tool.valuation.value_post_reno',
                estimated_price: 'valuer_tool.valuation.estimated_price',
                reno_adjustment: 'valuer_tool.valuation.reno_adjustment',
                comments: 'valuer_tool.valuation.comments',
            },
            internal_remarks: {
                title: 'valuer_tool.internal_remarks.title',
                description: 'valuer_tool.internal_remarks.description',
            },
            building_violations: {
                placeholder: 'valuer_tool.building_violations.placeholder',
                question: 'valuer_tool.building_violations.question',
                tooltip: 'valuer_tool.building_violations.tooltip',
            },
            valuer_summary: {
                'skip-notification': 'valuer_tool.valuer_summary.skip-notification',
                'appointment_cancel-btn':
                    'valuer_tool.valuer_summary.appointment_cancel-btn',
                'appointment_confirm-btn':
                    'valuer_tool.valuer_summary.appointment_confirm-btn',
                'payment_post-full': 'valuer_tool.valuer_summary.payment_post-full',
                appointment_title: 'valuer_tool.valuer_summary.appointment_title',
                'appointment_not-yet': 'valuer_tool.valuer_summary.appointment_not-yet',
                status: 'valuer_tool.valuer_summary.status',
                'payment_not-needed': 'valuer_tool.valuer_summary.payment_not-needed',
                payment_pending: 'valuer_tool.valuer_summary.payment_pending',
                payment_succeeded: 'valuer_tool.valuer_summary.payment_succeeded',
                payment_cancelled: 'valuer_tool.valuer_summary.payment_cancelled',
                payment_refunded: 'valuer_tool.valuer_summary.payment_refunded',
                payment_started: 'valuer_tool.valuer_summary.payment_started',
                payment_null: 'valuer_tool.valuer_summary.payment_null',
                'appointment_confirm-cancel':
                    'valuer_tool.valuer_summary.appointment_confirm-cancel',
                appointment_cancelled: 'valuer_tool.valuer_summary.appointment_cancelled',
                appointment_cancelled_by_valuer:
                    'valuer_tool.valuer_summary.appointment_cancelled_by_valuer',
                appointment_confirmed: 'valuer_tool.valuer_summary.appointment_confirmed',
                appointment_pending_confirmation:
                    'valuer_tool.valuer_summary.appointment_pending_confirmation',
                appointment_new: 'valuer_tool.valuer_summary.appointment_new',
            },
            valuer_settings: {
                availability_warning: 'valuer_tool.valuer_settings.availability_warning',
                availability_title: 'valuer_tool.valuer_settings.availability_title',
                'availability_add-button':
                    'valuer_tool.valuer_settings.availability_add-button',
                availability_districts:
                    'valuer_tool.valuer_settings.availability_districts',
                availability_delete_ays:
                    'valuer_tool.valuer_settings.availability_delete_ays',
            },
        },
        monolith: {
            global: {
                delete: 'monolith.global.delete',
                i_understand: 'monolith.global.i_understand',
                not_available: 'monolith.global.not_available',
                language: 'monolith.global.language',
                logout: 'monolith.global.logout',
                login: 'monolith.global.login',
                copy: {
                    success: 'monolith.global.copy.success',
                    error: 'monolith.global.copy.error',
                },
                vat: 'monolith.global.vat',
                subtotal: 'monolith.global.subtotal',
                total: 'monolith.global.total',
                or: 'monolith.global.or',
                description: 'monolith.global.description',
                show_more: 'monolith.global.show_more',
                show_less: 'monolith.global.show_less',
                documents: 'monolith.global.documents',
                update: 'monolith.global.update',
                full_name: 'monolith.global.full_name',
                first_name: 'monolith.global.first_name',
                last_name: 'monolith.global.last_name',
                phone: 'monolith.global.phone',
                email: 'monolith.global.email',
            },
            apps: {
                welcome: 'monolith.apps.welcome',
                valuation: {
                    name: 'monolith.apps.valuation.name',
                    description: 'monolith.apps.valuation.description',
                },
                ers: {
                    name: 'monolith.apps.ers.name',
                    description: 'monolith.apps.ers.description',
                },
                dashboard: 'monolith.apps.dashboard',
            },
            shared: {
                apartment: 'monolith.shared.apartment',
                back: 'monolith.shared.back',
                customer_ref_conflict: 'monolith.shared.customer_ref_conflict',
                leave_modal: {
                    cancel: 'monolith.shared.leave_modal.cancel',
                    confirm: 'monolith.shared.leave_modal.confirm',
                },
                next: 'monolith.shared.next',
                previous: 'monolith.shared.previous',
                report: 'monolith.shared.report',
                saved: 'monolith.shared.saved',
                streetnumber: 'monolith.shared.streetnumber',
                touching_sides: 'monolith.shared.touching_sides',
                wrong_value: 'monolith.shared.wrong_value',
                message: 'monolith.shared.message',
                full_address: 'monolith.shared.full_address',
                send: 'monolith.shared.send',
                confirm_before_quit: {
                    title: 'monolith.shared.confirm_before_quit.title',
                    content: 'monolith.shared.confirm_before_quit.content',
                    confirm: 'monolith.shared.confirm_before_quit.confirm',
                    cancel: 'monolith.shared.confirm_before_quit.cancel',
                    save: 'monolith.shared.confirm_before_quit.save',
                },
                customer_ref: 'monolith.shared.customer_ref',
                address: 'monolith.shared.address',
                customer: 'monolith.shared.customer',
                request_ref: 'monolith.shared.request_ref',
                status_col: 'monolith.shared.status_col',
                created_at: 'monolith.shared.created_at',
                last_modified: 'monolith.shared.last_modified',
                actions: 'monolith.shared.actions',
                owner: 'monolith.shared.owner',
                valuer: 'monolith.shared.valuer',
                short_lang: 'monolith.shared.short_lang',
                help_me: 'monolith.shared.help_me',
                faq: 'monolith.shared.faq',
                per_page: 'monolith.shared.per_page',
                search: 'monolith.shared.search',
                email_address: 'monolith.shared.email_address',
                username: 'monolith.shared.username',
                password: 'monolith.shared.password',
                roles: 'monolith.shared.roles',
                cancel: 'monolith.shared.cancel',
                type: 'monolith.shared.type',
                na: 'monolith.shared.na',
            },
            building_type: {
                apartment_comment: 'monolith.building_type.apartment_comment',
                construction_plot: 'monolith.building_type.construction_plot',
                house: 'monolith.building_type.house',
                house_comment: 'monolith.building_type.house_comment',
                new_apartment: 'monolith.building_type.new_apartment',
                new_house: 'monolith.building_type.new_house',
            },
            map: {
                'cannot-find-any-main-parcel': 'monolith.map.cannot-find-any-main-parcel',
                'cannot-find-confirm-main-building':
                    'monolith.map.cannot-find-confirm-main-building',
                'cannot-find-confirm-main-parcel':
                    'monolith.map.cannot-find-confirm-main-parcel',
                'cannot-find-select-extra-parcels':
                    'monolith.map.cannot-find-select-extra-parcels',
                'cannot-find-select-main-building':
                    'monolith.map.cannot-find-select-main-building',
                'cannot-find-select-main-parcel':
                    'monolith.map.cannot-find-select-main-parcel',
                'cannot-find-select-parcels': 'monolith.map.cannot-find-select-parcels',
                'cannot-find-select-secondary-buildings':
                    'monolith.map.cannot-find-select-secondary-buildings',
                'explanation-confirm-main-parcel':
                    'monolith.map.explanation-confirm-main-parcel',
                'explanation-select-extra-parcels':
                    'monolith.map.explanation-select-extra-parcels',
                'explanation-select-main-building':
                    'monolith.map.explanation-select-main-building',
                'explanation-select-main-parcel':
                    'monolith.map.explanation-select-main-parcel',
                'explanation-select-secondary-buildings':
                    'monolith.map.explanation-select-secondary-buildings',
                'explanation-view-building-parcels':
                    'monolith.map.explanation-view-building-parcels',
                parcel_tooltip: 'monolith.map.parcel_tooltip',
            },
            login: {
                email: 'monolith.login.email',
                login: 'monolith.login.login',
                msg: {
                    'email-not-authorized': 'monolith.login.msg.email-not-authorized',
                    'email-sent': 'monolith.login.msg.email-sent',
                    'email-sent_message': 'monolith.login.msg.email-sent_message',
                    'email-sent_title': 'monolith.login.msg.email-sent_title',
                    'invalid-token': 'monolith.login.msg.invalid-token',
                    logout: 'monolith.login.msg.logout',
                    'invalid-email-address': 'monolith.login.msg.invalid-email-address',
                    'server-error': 'monolith.login.msg.server-error',
                    'session-expired': 'monolith.login.msg.session-expired',
                    'wrong-environment': 'monolith.login.msg.wrong-environment',
                },
                title: 'monolith.login.title',
                welcome: 'monolith.login.welcome',
            },
            dashboard: {
                hideFullList: 'monolith.dashboard.hideFullList',
                showFullList: 'monolith.dashboard.showFullList',
                specialist: 'monolith.dashboard.specialist',
                total: 'monolith.dashboard.total',
                unassigned: 'monolith.dashboard.unassigned',
                valuers_workload: 'monolith.dashboard.valuers_workload',
                my_requests: 'monolith.dashboard.my_requests',
                last_month: 'monolith.dashboard.last_month',
                last_year: 'monolith.dashboard.last_year',
                all_requests: 'monolith.dashboard.all_requests',
                search_request: 'monolith.dashboard.search_request',
                review_tooltip: 'monolith.dashboard.review_tooltip',
                badges: {
                    resubmitted: 'monolith.dashboard.badges.resubmitted',
                    needs_on_site: 'monolith.dashboard.badges.needs_on_site',
                    needs_borrower_email:
                        'monolith.dashboard.badges.needs_borrower_email',
                    needs_appointment_confirmation:
                        'monolith.dashboard.badges.needs_appointment_confirmation',
                    needs_borrower_action:
                        'monolith.dashboard.badges.needs_borrower_action',
                    appointment_confirmed:
                        'monolith.dashboard.badges.appointment_confirmed',
                },
                valuer_change_modal: {
                    content: 'monolith.dashboard.valuer_change_modal.content',
                    actions: {
                        confirm: 'monolith.dashboard.valuer_change_modal.actions.confirm',
                    },
                },
                sub_modal: {
                    content: 'monolith.dashboard.sub_modal.content',
                },
                title_tooltip: 'monolith.dashboard.title_tooltip',
                create_report: 'monolith.dashboard.create_report',
                download_report: 'monolith.dashboard.download_report',
                refresh_report: 'monolith.dashboard.refresh_report',
                report_loading: 'monolith.dashboard.report_loading',
            },
            sidesteps: {
                house: 'monolith.sidesteps.house',
            },
            validation: {
                file_too_big: 'monolith.validation.file_too_big',
                incoherent_feature: 'monolith.validation.incoherent_feature',
                renovation_cost_minValue: 'monolith.validation.renovation_cost_minValue',
                required: 'monolith.validation.required',
                wrong_epc: 'monolith.validation.wrong_epc',
                floors_not_consecutive: 'monolith.validation.floors_not_consecutive',
                renovation_cost_zero_invalid:
                    'monolith.validation.renovation_cost_zero_invalid',
            },
            app: {
                session_expiry_warning: {
                    cta: 'monolith.app.session_expiry_warning.cta',
                    text: 'monolith.app.session_expiry_warning.text',
                },
            },
            sso_login: {
                welcome: 'monolith.sso_login.welcome',
            },
            'multiple-address-modal': {
                title: 'monolith.multiple-address-modal.title',
                content: 'monolith.multiple-address-modal.content',
            },
            chat: {
                beginning: 'monolith.chat.beginning',
                bank_agent: 'monolith.chat.bank_agent',
                vs: 'monolith.chat.vs',
            },
            'action-buttons': {
                info: 'monolith.action-buttons.info',
                edit: 'monolith.action-buttons.edit',
                cancel: 'monolith.action-buttons.cancel',
                unvalue: 'monolith.action-buttons.unvalue',
                appointment: 'monolith.action-buttons.appointment',
                'confirm-appointment': 'monolith.action-buttons.confirm-appointment',
                view_request: 'monolith.action-buttons.view_request',
                edit_request: 'monolith.action-buttons.edit_request',
                dvm: 'monolith.action-buttons.dvm',
                ovm: 'monolith.action-buttons.ovm',
                automatic_valuation: 'monolith.action-buttons.automatic_valuation',
                web_report: 'monolith.action-buttons.web_report',
                pdf_report: 'monolith.action-buttons.pdf_report',
                generate_pdf_report: 'monolith.action-buttons.generate_pdf_report',
                regenerate_pdf_report: 'monolith.action-buttons.regenerate_pdf_report',
                downloading: 'monolith.action-buttons.downloading',
                take_ownership: 'monolith.action-buttons.take_ownership',
            },
            faq: {
                title: 'monolith.faq.title',
                question_1: 'monolith.faq.question_1',
                answer_1: 'monolith.faq.answer_1',
                question_2: 'monolith.faq.question_2',
                answer_2: 'monolith.faq.answer_2',
                question_3: 'monolith.faq.question_3',
                answer_3: 'monolith.faq.answer_3',
                question_4: 'monolith.faq.question_4',
                answer_4: 'monolith.faq.answer_4',
                question_5: 'monolith.faq.question_5',
                answer_5: 'monolith.faq.answer_5',
                question_6: 'monolith.faq.question_6',
                answer_6: 'monolith.faq.answer_6',
                question_7: 'monolith.faq.question_7',
                answer_7: 'monolith.faq.answer_7',
                question_8: 'monolith.faq.question_8',
                answer_8: 'monolith.faq.answer_8',
                question_9: 'monolith.faq.question_9',
                answer_9: 'monolith.faq.answer_9',
                question_10: 'monolith.faq.question_10',
                answer_10: 'monolith.faq.answer_10',
                question_11: 'monolith.faq.question_11',
                answer_11: 'monolith.faq.answer_11',
                question_12: 'monolith.faq.question_12',
                answer_12: 'monolith.faq.answer_12',
                question_13: 'monolith.faq.question_13',
                answer_13: 'monolith.faq.answer_13',
            },
        },
        dashboard: {
            reference_listing: {
                view_button: 'dashboard.reference_listing.view_button',
                report_button: 'dashboard.reference_listing.report_button',
                edit_button: 'dashboard.reference_listing.edit_button',
            },
            new_request: {
                title: 'dashboard.new_request.title',
            },
            type_toggles: {
                ers: 'dashboard.type_toggles.ers',
                dvm: 'dashboard.type_toggles.dvm',
            },
        },
        energy: {
            shared: {
                tooltip_more_info: 'energy.shared.tooltip_more_info',
                insulation_year: 'energy.shared.insulation_year',
            },
            building_dimensions: {
                floors: {
                    infobubble: 'energy.building_dimensions.floors.infobubble',
                    question: 'energy.building_dimensions.floors.question',
                    label: 'energy.building_dimensions.floors.label',
                },
                title: 'energy.building_dimensions.title',
                roof: {
                    question: 'energy.building_dimensions.roof.question',
                    tooltip: 'energy.building_dimensions.roof.tooltip',
                },
                roof_type_pitched: 'energy.building_dimensions.roof_type_pitched',
                roof_type_flat: 'energy.building_dimensions.roof_type_flat',
                roof_type_mixed: 'energy.building_dimensions.roof_type_mixed',
                wall_insulation: {
                    question: 'energy.building_dimensions.wall_insulation.question',
                    tooltip: 'energy.building_dimensions.wall_insulation.tooltip',
                },
                facade_type_row: 'energy.building_dimensions.facade_type_row',
                facade_type_row_end: 'energy.building_dimensions.facade_type_row_end',
                facade_type_isolated: 'energy.building_dimensions.facade_type_isolated',
            },
            address: {
                map: {
                    no_model: {
                        title: 'energy.address.map.no_model.title',
                        subtitle: 'energy.address.map.no_model.subtitle',
                        change_address: 'energy.address.map.no_model.change_address',
                        start: 'energy.address.map.no_model.start',
                    },
                    select_building: 'energy.address.map.select_building',
                    cant_find: 'energy.address.map.cant_find',
                    confirm_2d: 'energy.address.map.confirm_2d',
                    confirm_3d: 'energy.address.map.confirm_3d',
                    title: 'energy.address.map.title',
                    placeholder: 'energy.address.map.placeholder',
                },
                is_loading: 'energy.address.is_loading',
                title: 'energy.address.title',
                title_tooltip: 'energy.address.title_tooltip',
                subtitle: 'energy.address.subtitle',
            },
            building_type: {
                title: 'energy.building_type.title',
                unavailable_option: 'energy.building_type.unavailable_option',
                title_tooltip: 'energy.building_type.title_tooltip',
                option: {
                    house: {
                        name: 'energy.building_type.option.house.name',
                        description: 'energy.building_type.option.house.description',
                    },
                    apartment: {
                        name: 'energy.building_type.option.apartment.name',
                        description: 'energy.building_type.option.apartment.description',
                    },
                    apartment_building: {
                        name: 'energy.building_type.option.apartment_building.name',
                        description:
                            'energy.building_type.option.apartment_building.description',
                    },
                },
            },
            attic: {
                question: 'energy.attic.question',
                question_heated: 'energy.attic.question_heated',
                tooltip: 'energy.attic.tooltip',
            },
            basement: {
                question: 'energy.basement.question',
                tooltip: 'energy.basement.tooltip',
            },
            living_area: {
                question: 'energy.living_area.question',
                lvl_3: {
                    tooltip: 'energy.living_area.lvl_3.tooltip',
                },
                bubble_info: 'energy.living_area.bubble_info',
                lvl_2: {
                    tooltip: 'energy.living_area.lvl_2.tooltip',
                },
            },
            valid_epc: {
                question: 'energy.valid_epc.question',
                answer_yes: 'energy.valid_epc.answer_yes',
                answer_no: 'energy.valid_epc.answer_no',
                tooltip: 'energy.valid_epc.tooltip',
            },
            epc_score: {
                'warning_tooltip-main': 'energy.epc_score.warning_tooltip-main',
                'warning_tooltip-description':
                    'energy.epc_score.warning_tooltip-description',
                question: 'energy.epc_score.question',
                tooltip: 'energy.epc_score.tooltip',
                subtitle: 'energy.epc_score.subtitle',
                answer_kwh: 'energy.epc_score.answer_kwh',
                answer_label: 'energy.epc_score.answer_label',
                subtitle_2: 'energy.epc_score.subtitle_2',
            },
            construction_year: {
                question: 'energy.construction_year.question',
                tooltip: 'energy.construction_year.tooltip',
                question_specify: 'energy.construction_year.question_specify',
                label_input: 'energy.construction_year.label_input',
            },
            roof_insulation: {
                question: 'energy.roof_insulation.question',
                tooltip_popup: 'energy.roof_insulation.tooltip_popup',
                info_bubble: 'energy.roof_insulation.info_bubble',
                question_2: 'energy.roof_insulation.question_2',
                label_input: 'energy.roof_insulation.label_input',
            },
            result: {
                footnote: 'energy.result.footnote',
                EPC_label: 'energy.result.EPC_label',
                budget_label: 'energy.result.budget_label',
                edit_questionnaire: 'energy.result.edit_questionnaire',
                scenario_saved_message: 'energy.result.scenario_saved_message',
                no_renovation: 'energy.result.no_renovation',
                header: {
                    title: 'energy.result.header.title',
                    subtitle: 'energy.result.header.subtitle',
                },
                epc_score: {
                    title: 'energy.result.epc_score.title',
                    subtitle: 'energy.result.epc_score.subtitle',
                },
                consumption: {
                    title: 'energy.result.consumption.title',
                    elec: 'energy.result.consumption.elec',
                    low: 'energy.result.consumption.low',
                    high: 'energy.result.consumption.high',
                    med: 'energy.result.consumption.med',
                    you: 'energy.result.consumption.you',
                },
                package: {
                    title: 'energy.result.package.title',
                    subtitle: 'energy.result.package.subtitle',
                    current: 'energy.result.package.current',
                    budget: 'energy.result.package.budget',
                    custom: 'energy.result.package.custom',
                    target: 'energy.result.package.target',
                    best: 'energy.result.package.best',
                },
                renovation: {
                    wall: 'energy.result.renovation.wall',
                    roof: 'energy.result.renovation.roof',
                    window: 'energy.result.renovation.window',
                    poorly_insulated: 'energy.result.renovation.poorly_insulated',
                    mixed: 'energy.result.renovation.mixed',
                    mixed_tooltip_popup: 'energy.result.renovation.mixed_tooltip_popup',
                    ceiling_tooltip_popup:
                        'energy.result.renovation.ceiling_tooltip_popup',
                    ceiling: 'energy.result.renovation.ceiling',
                    roofIn: 'energy.result.renovation.roofIn',
                    roofIn_tooltip_popup: 'energy.result.renovation.roofIn_tooltip_popup',
                    atticFloor: 'energy.result.renovation.atticFloor',
                    atticFloor_tooltip_popup:
                        'energy.result.renovation.atticFloor_tooltip_popup',
                    roofExt: 'energy.result.renovation.roofExt',
                    roofExt_tooltip_popup:
                        'energy.result.renovation.roofExt_tooltip_popup',
                    windowsDouble: 'energy.result.renovation.windowsDouble',
                    windowsDouble_tooltip_popup:
                        'energy.result.renovation.windowsDouble_tooltip_popup',
                    condGas: 'energy.result.renovation.condGas',
                    condGas_tooltip_popup:
                        'energy.result.renovation.condGas_tooltip_popup',
                    heatPump: 'energy.result.renovation.heatPump',
                    heatPump_tooltip_popup:
                        'energy.result.renovation.heatPump_tooltip_popup',
                    wallCav: 'energy.result.renovation.wallCav',
                    wallCav_tooltip_popup:
                        'energy.result.renovation.wallCav_tooltip_popup',
                    unitPv: 'energy.result.renovation.unitPv',
                    unitPv_tooltip_popup: 'energy.result.renovation.unitPv_tooltip_popup',
                    wallExt: 'energy.result.renovation.wallExt',
                    wallExt_tooltip_popup:
                        'energy.result.renovation.wallExt_tooltip_popup',
                },
                warning: {
                    solar_panel: 'energy.result.warning.solar_panel',
                    window: 'energy.result.warning.window',
                    heating: 'energy.result.warning.heating',
                },
                summary: {
                    title: 'energy.result.summary.title',
                    subtitle: 'energy.result.summary.subtitle',
                    item: 'energy.result.summary.item',
                    price_incl_vat: 'energy.result.summary.price_incl_vat',
                    price_excl_vat: 'energy.result.summary.price_excl_vat',
                },
                property_value: 'energy.result.property_value',
                savings: {
                    title: 'energy.result.savings.title',
                    epc: 'energy.result.savings.epc',
                    carbon: 'energy.result.savings.carbon',
                    bills: 'energy.result.savings.bills',
                },
                button: {
                    add_remove: 'energy.result.button.add_remove',
                    download: 'energy.result.button.download',
                    share: 'energy.result.button.share',
                    edit_input: 'energy.result.button.edit_input',
                },
                one_renovation_available: 'energy.result.one_renovation_available',
                price: 'energy.result.price',
            },
            summary: {
                epc: 'energy.summary.epc',
                answers_needs_to_be_fixed: 'energy.summary.answers_needs_to_be_fixed',
                energy_consumption_known: 'energy.summary.energy_consumption_known',
                heated: 'energy.summary.heated',
                not_heated: 'energy.summary.not_heated',
                insulation_year: 'energy.summary.insulation_year',
                residents: 'energy.summary.residents',
                heating_consumption: 'energy.summary.heating_consumption',
                electricity_consumption: 'energy.summary.electricity_consumption',
                high: 'energy.summary.high',
                medium: 'energy.summary.medium',
                low: 'energy.summary.low',
                big_consumer: 'energy.summary.big_consumer',
                fuel_error: 'energy.summary.fuel_error',
                construction_year_error: 'energy.summary.construction_year_error',
                title: 'energy.summary.title',
                subtitle: 'energy.summary.subtitle',
            },
            package: {
                epc: {
                    title: 'energy.package.epc.title',
                    description: 'energy.package.epc.description',
                },
                budget: {
                    title: 'energy.package.budget.title',
                    description: 'energy.package.budget.description',
                },
                custom: {
                    title: 'energy.package.custom.title',
                    description: 'energy.package.custom.description',
                },
            },
            wall_insulation: {
                question: 'energy.wall_insulation.question',
                tooltip_popup: 'energy.wall_insulation.tooltip_popup',
                bubble_info: 'energy.wall_insulation.bubble_info',
                question_2: 'energy.wall_insulation.question_2',
            },
            floor_insulation: {
                question: 'energy.floor_insulation.question',
                tooltip_popup: 'energy.floor_insulation.tooltip_popup',
                question_2: 'energy.floor_insulation.question_2',
            },
            window: {
                warning_tooltip: 'energy.window.warning_tooltip',
                question: 'energy.window.question',
                tooltip_popup: 'energy.window.tooltip_popup',
            },
            heating: {
                question: 'energy.heating.question',
                tooltip: 'energy.heating.tooltip',
            },
            end_section: {
                got_it: 'energy.end_section.got_it',
                text: 'energy.end_section.text',
                go_to_consumption: 'energy.end_section.go_to_consumption',
            },
            energy_consumption: {
                question: 'energy.energy_consumption.question',
                bubble_info: 'energy.energy_consumption.bubble_info',
                yes_text: 'energy.energy_consumption.yes_text',
                no_text: 'energy.energy_consumption.no_text',
            },
            consumers: {
                title: 'energy.consumers.title',
                question_1a: 'energy.consumers.question_1a',
                tooltip_1: 'energy.consumers.tooltip_1',
                question_2a: 'energy.consumers.question_2a',
                tooltip_2: 'energy.consumers.tooltip_2',
                bubble_info: 'energy.consumers.bubble_info',
                question_1b: 'energy.consumers.question_1b',
                tooltip_popup_1: 'energy.consumers.tooltip_popup_1',
                question_2b: 'energy.consumers.question_2b',
                tooltip_popup_2: 'energy.consumers.tooltip_popup_2',
            },
            big_consumers: {
                question: 'energy.big_consumers.question',
                tooltip: 'energy.big_consumers.tooltip',
            },
        },
        admin_panel: {
            user_mgmt: {
                new_accreditation: 'admin_panel.user_mgmt.new_accreditation',
                add_accreditation: 'admin_panel.user_mgmt.add_accreditation',
                accreditation_number: 'admin_panel.user_mgmt.accreditation_number',
                accreditation_institution:
                    'admin_panel.user_mgmt.accreditation_institution',
            },
        },
        dvm: {
            shared: {
                actions: {
                    generating_report: 'dvm.shared.actions.generating_report',
                    incoherent_features: 'dvm.shared.actions.incoherent_features',
                    onsite: 'dvm.shared.actions.onsite',
                    resubmit: 'dvm.shared.actions.resubmit',
                    save: 'dvm.shared.actions.save',
                    submit: 'dvm.shared.actions.submit',
                },
                add_to_remarks: 'dvm.shared.add_to_remarks',
                anchors: {
                    avm: 'dvm.shared.anchors.avm',
                    description: 'dvm.shared.anchors.description',
                    dvm: 'dvm.shared.anchors.dvm',
                    flood_map: 'dvm.shared.anchors.flood_map',
                },
                duplicates: 'dvm.shared.duplicates',
                duplicates_modal: {
                    close: 'dvm.shared.duplicates_modal.close',
                    copy_ref: 'dvm.shared.duplicates_modal.copy_ref',
                    open_dvm: 'dvm.shared.duplicates_modal.open_dvm',
                    reason: 'dvm.shared.duplicates_modal.reason',
                    reasons: {
                        'close point': 'dvm.shared.duplicates_modal.reasons.close point',
                        'same address':
                            'dvm.shared.duplicates_modal.reasons.same address',
                        'same customer_ref':
                            'dvm.shared.duplicates_modal.reasons.same customer_ref',
                        'same place': 'dvm.shared.duplicates_modal.reasons.same place',
                    },
                    title: 'dvm.shared.duplicates_modal.title',
                },
                error_modal: {
                    actions: {
                        incoherent_patch:
                            'dvm.shared.error_modal.actions.incoherent_patch',
                        incoherent_put: 'dvm.shared.error_modal.actions.incoherent_put',
                        onsite_patch: 'dvm.shared.error_modal.actions.onsite_patch',
                        onsite_put: 'dvm.shared.error_modal.actions.onsite_put',
                        report_post: 'dvm.shared.error_modal.actions.report_post',
                        resubmit_patch: 'dvm.shared.error_modal.actions.resubmit_patch',
                        resubmit_put: 'dvm.shared.error_modal.actions.resubmit_put',
                        submitVal_patch: 'dvm.shared.error_modal.actions.submitVal_patch',
                        submitVal_put: 'dvm.shared.error_modal.actions.submitVal_put',
                    },
                    back_to_dashboard: 'dvm.shared.error_modal.back_to_dashboard',
                    cancel: 'dvm.shared.error_modal.cancel',
                    content: 'dvm.shared.error_modal.content',
                    title: 'dvm.shared.error_modal.title',
                },
                incoherent_features_modal: {
                    back_to_dashboard:
                        'dvm.shared.incoherent_features_modal.back_to_dashboard',
                    confirmation_message:
                        'dvm.shared.incoherent_features_modal.confirmation_message',
                    submit: 'dvm.shared.incoherent_features_modal.submit',
                    title: 'dvm.shared.incoherent_features_modal.title',
                },
                onsite_modal: {
                    back_to_dashboard: 'dvm.shared.onsite_modal.back_to_dashboard',
                    confirmation_message: 'dvm.shared.onsite_modal.confirmation_message',
                    reasons: {
                        onsite_commercial_building:
                            'dvm.shared.onsite_modal.reasons.onsite_commercial_building',
                        onsite_exceptional_property:
                            'dvm.shared.onsite_modal.reasons.onsite_exceptional_property',
                        onsite_extensive_renovation:
                            'dvm.shared.onsite_modal.reasons.onsite_extensive_renovation',
                        onsite_few_comparison:
                            'dvm.shared.onsite_modal.reasons.onsite_few_comparison',
                        onsite_flood_zone:
                            'dvm.shared.onsite_modal.reasons.onsite_flood_zone',
                        onsite_incoherent_features:
                            'dvm.shared.onsite_modal.reasons.onsite_incoherent_features',
                        onsite_others: 'dvm.shared.onsite_modal.reasons.onsite_others',
                        onsite_streetview:
                            'dvm.shared.onsite_modal.reasons.onsite_streetview',
                        onsite_volume_missing:
                            'dvm.shared.onsite_modal.reasons.onsite_volume_missing',
                    },
                    submit: 'dvm.shared.onsite_modal.submit',
                    title: 'dvm.shared.onsite_modal.title',
                },
                price: 'dvm.shared.price',
                price_per_sqm: 'dvm.shared.price_per_sqm',
                price_sqm: 'dvm.shared.price_sqm',
                address: 'dvm.shared.address',
                transaction_value: 'dvm.shared.transaction_value',
            },
            request: {
                add_document: 'dvm.request.add_document',
            },
            dashboard: {
                all: 'dvm.dashboard.all',
            },
            avm: {
                analysis: 'dvm.avm.analysis',
            },
            description: {
                annexes: {
                    title: 'dvm.description.annexes.title',
                },
                apartment_features: {
                    title: 'dvm.description.apartment_features.title',
                },
                basic_info: {
                    building_found: 'dvm.description.basic_info.building_found',
                    building_type: {
                        label: 'dvm.description.basic_info.building_type.label',
                        options: {
                            apartment:
                                'dvm.description.basic_info.building_type.options.apartment',
                            construction_plot:
                                'dvm.description.basic_info.building_type.options.construction_plot',
                            house:
                                'dvm.description.basic_info.building_type.options.house',
                            new_apartment:
                                'dvm.description.basic_info.building_type.options.new_apartment',
                            new_house:
                                'dvm.description.basic_info.building_type.options.new_house',
                        },
                    },
                    level: 'dvm.description.basic_info.level',
                    renovations: {
                        label: 'dvm.description.basic_info.renovations.label',
                        warning: 'dvm.description.basic_info.renovations.warning',
                    },
                    title: 'dvm.description.basic_info.title',
                    touching_sides: 'dvm.description.basic_info.touching_sides',
                },
                other: {
                    f_dist_building_flood: 'dvm.description.other.f_dist_building_flood',
                    f_dist_parcel_flood: 'dvm.description.other.f_dist_parcel_flood',
                    f_matched_entities: 'dvm.description.other.f_matched_entities',
                    title: 'dvm.description.other.title',
                },
                size: {
                    title: 'dvm.description.size.title',
                },
                state: {
                    f_epc_label: 'dvm.description.state.f_epc_label',
                    title: 'dvm.description.state.title',
                },
            },
            desktop: {
                apply_influence: 'dvm.desktop.apply_influence',
                dvm_adjustment: 'dvm.desktop.dvm_adjustment',
                environment: {
                    'above-avg': 'dvm.desktop.environment.above-avg',
                    avg: 'dvm.desktop.environment.avg',
                    'below-avg': 'dvm.desktop.environment.below-avg',
                    title: 'dvm.desktop.environment.title',
                },
                market_correction: 'dvm.desktop.market_correction',
                overridden_influence: 'dvm.desktop.overridden_influence',
                total_influence: 'dvm.desktop.total_influence',
                update_remarks: 'dvm.desktop.update_remarks',
            },
            feedback: {
                or_not: 'dvm.feedback.or_not',
            },
            validation: {
                parcel_cost_minValue: 'dvm.validation.parcel_cost_minValue',
            },
            modal: {
                success_modal: {
                    actions: {
                        back_to_dashboard:
                            'dvm.modal.success_modal.actions.back_to_dashboard',
                        show_report: 'dvm.modal.success_modal.actions.show_report',
                        stay_on_page: 'dvm.modal.success_modal.actions.stay_on_page',
                    },
                    content: 'dvm.modal.success_modal.content',
                    title: 'dvm.modal.success_modal.title',
                },
            },
        },
        argenta: {
            valuation: {
                enter: {
                    alt_customer_ref_title:
                        'argenta.valuation.enter.alt_customer_ref_title',
                },
                start: {
                    welcome_text_2: 'argenta.valuation.start.welcome_text_2',
                    welcome_text_3: 'argenta.valuation.start.welcome_text_3',
                },
            },
        },
        avm: {
            step1: {
                errors: {
                    default: 'avm.step1.errors.default',
                    too_few_reference_listings:
                        'avm.step1.errors.too_few_reference_listings',
                },
            },
            shared: {
                extreme_value: 'avm.shared.extreme_value',
            },
            form: {
                step4: {
                    details: {
                        close: 'avm.form.step4.details.close',
                        link: 'avm.form.step4.details.link',
                        text: 'avm.form.step4.details.text',
                        title: 'avm.form.step4.details.title',
                    },
                    plot_title: {
                        f_construction_year:
                            'avm.form.step4.plot_title.f_construction_year',
                        f_epc: 'avm.form.step4.plot_title.f_epc',
                        f_living_area: 'avm.form.step4.plot_title.f_living_area',
                        f_parcel_area: 'avm.form.step4.plot_title.f_parcel_area',
                    },
                    subtitle: 'avm.form.step4.subtitle',
                },
                step5: {
                    card1: {
                        li_1: 'avm.form.step5.card1.li_1',
                        li_2: 'avm.form.step5.card1.li_2',
                        title: 'avm.form.step5.card1.title',
                    },
                    card2: {
                        li_1: 'avm.form.step5.card2.li_1',
                        li_2: 'avm.form.step5.card2.li_2',
                        li_3: 'avm.form.step5.card2.li_3',
                        title: 'avm.form.step5.card2.title',
                    },
                    send: 'avm.form.step5.send',
                    subtitle: 'avm.form.step5.subtitle',
                    text1: 'avm.form.step5.text1',
                    text2: 'avm.form.step5.text2',
                    title: 'avm.form.step5.title',
                },
            },
        },
        ing: {
            valuation: {
                enter: {
                    customer_ref_title: 'ing.valuation.enter.customer_ref_title',
                    forbidden_substring: 'ing.valuation.enter.forbidden_substring',
                },
                request: {
                    tab_title: 'ing.valuation.request.tab_title',
                },
                start: {
                    welcome_text_2: 'ing.valuation.start.welcome_text_2',
                    welcome_text_3: 'ing.valuation.start.welcome_text_3',
                },
            },
            monolith: {
                shared: {
                    customer_ref: 'ing.monolith.shared.customer_ref',
                },
            },
        },
        keytrade: {
            valuation: {
                start: {
                    welcome_text_2: 'keytrade.valuation.start.welcome_text_2',
                    welcome_text_3: 'keytrade.valuation.start.welcome_text_3',
                },
            },
        },
        ovm_dispatch: {
            settings: {
                title: 'ovm_dispatch.settings.title',
                subtitle: 'ovm_dispatch.settings.subtitle',
                nuts: {
                    placeholder: 'ovm_dispatch.settings.nuts.placeholder',
                    caption: 'ovm_dispatch.settings.nuts.caption',
                },
                valuer: {
                    placeholder: 'ovm_dispatch.settings.valuer.placeholder',
                    error: 'ovm_dispatch.settings.valuer.error',
                },
            },
            request: {
                confim: 'ovm_dispatch.request.confim',
                notification: {
                    end_time: 'ovm_dispatch.request.notification.end_time',
                },
                appointment: {
                    title: 'ovm_dispatch.request.appointment.title',
                    subtitle: 'ovm_dispatch.request.appointment.subtitle',
                    button: 'ovm_dispatch.request.appointment.button',
                    previous: 'ovm_dispatch.request.appointment.previous',
                },
            },
        },
        ovm: {
            settings: {
                unsaved_warning: 'ovm.settings.unsaved_warning',
            },
        },
    },
}
